webpackJsonp([0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	// we don't need to use a variable
	// or the from keyword when importing a css/styl file
	// thanks the the styles loader it gets added as a
	// <style> tag in the head by default but can be changed
	
	// import 'normalize.css';
	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	__webpack_require__(31);
	
	var _jquery = __webpack_require__(80);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(83);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	// import angularUIBootstrap from 'angular-ui-bootstrap';
	
	var _appComponentJs = __webpack_require__(153);
	
	var _componentsComponentsJs = __webpack_require__(155);
	
	var _modelsModelsJs = __webpack_require__(507);
	
	// import { messaging } from './messaging.js';
	
	var _configJs = __webpack_require__(548);
	
	if ('serviceWorker' in navigator) {
	    navigator.serviceWorker.getRegistrations().then(function (registrations) {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	            for (var _iterator = registrations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var registration = _step.value;
	
	                if (registration.scope.includes('firebase-cloud-messaging-push-scope') === false) {
	                    registration.unregister();
	                }
	            }
	        } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion && _iterator['return']) {
	                    _iterator['return']();
	                }
	            } finally {
	                if (_didIteratorError) {
	                    throw _iteratorError;
	                }
	            }
	        }
	    });
	    navigator.serviceWorker.register('./firebase-messaging-sw.js', { scope: 'firebase-cloud-messaging-push-scope' }).then(function (reg) {
	        (0, _jquery2['default'])('body').bind('update-sw', function () {
	            reg.update();
	            console.log('Successfully updated service worker', reg);
	        });
	    })['catch'](function (err) {
	        console.warn('Error whilst registering service worker', err);
	    });
	}
	
	//Loads the correct sidebar on window load,
	//collapses the sidebar on window resize.
	// Sets the min-height of #page-wrapper to window size
	(0, _jquery2['default'])(document).ready(function () {
	    // Move right sidebar top after scroll
	    (0, _jquery2['default'])(window).scroll(function () {
	        if ((0, _jquery2['default'])(window).scrollTop() > 0 && !(0, _jquery2['default'])('body').hasClass('fixed-nav')) {
	            (0, _jquery2['default'])('#right-sidebar').addClass('sidebar-top');
	        } else {
	            (0, _jquery2['default'])('#right-sidebar').removeClass('sidebar-top');
	        }
	    });
	
	    // setTimeout(function(){
	    //     fix_height();
	    // });
	});
	
	// // Minimalize menu when screen is less than 768px
	// $(function() {
	//     $(window).bind('load resize', function() {
	//         if ($(document).width() < 769) {
	//             $('body').addClass('body-small');
	//         } else {
	//             $('body').removeClass('body-small');
	//         }
	//     });
	// });
	
	(0, _jquery2['default'])(document).ready(function () {
	    // Set minimal height of #wrapper to fit the window
	    setTimeout(function () {
	        fixWrapperHeight();
	    }, 300);
	
	    // Add special class to minimalize page elements when screen is less than 768px
	    setBodySmall();
	});
	
	(0, _jquery2['default'])(window).bind('resize click', function () {
	    // Add special class to minimalize page elements when screen is less than 768px
	    setBodySmall();
	
	    // Waint until metsiMenu, collapse and other effect finish and set wrapper height
	    setTimeout(function () {
	        fixWrapperHeight();
	    }, 300);
	});
	
	function fixWrapperHeight() {
	    // Get and set current height
	    var headerH = 62;
	    var navigationH = (0, _jquery2['default'])('#navigation').height();
	    var contentH = (0, _jquery2['default'])('.content').height();
	
	    // Set new height when contnet height is less then navigation
	    if (contentH < navigationH) {
	        (0, _jquery2['default'])('#wrapper').css('min-height', navigationH + 'px');
	    }
	
	    // Set new height when contnet height is less then navigation and navigation is less then window
	    if (contentH < navigationH && navigationH < (0, _jquery2['default'])(window).height()) {
	        (0, _jquery2['default'])('#wrapper').css('min-height', (0, _jquery2['default'])(window).height() - headerH + 'px');
	    }
	
	    // Set new height when contnet is higher then navigation but less then window
	    if (contentH > navigationH && contentH < (0, _jquery2['default'])(window).height()) {
	        (0, _jquery2['default'])('#wrapper').css('min-height', (0, _jquery2['default'])(window).height() - headerH + 'px');
	    }
	}
	
	function setBodySmall() {
	    if ((0, _jquery2['default'])(document).width() < 769) {
	        (0, _jquery2['default'])('body').addClass('page-small');
	    } else {
	        (0, _jquery2['default'])('body').removeClass('page-small');
	        (0, _jquery2['default'])('body').removeClass('show-sidebar');
	    }
	}
	
	// console.log(angularUIBootstrap);
	
	var app = _angular2['default'].module('app', [_angularUiRouter2['default'], _modelsModelsJs.models.name, _componentsComponentsJs.components.name, 'messaging']);
	
	app.config(_configJs.config);
	app.run(_configJs.run);
	app.component('app', _appComponentJs.AppComponent);

/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(32);
	
	__webpack_require__(41);
	
	__webpack_require__(49);
	
	__webpack_require__(51);
	
	__webpack_require__(53);
	
	__webpack_require__(55);
	
	__webpack_require__(61);
	
	__webpack_require__(63);
	
	__webpack_require__(70);
	
	__webpack_require__(72);
	
	__webpack_require__(77);

/***/ },
/* 32 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */
32,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */
32,
/* 50 */,
/* 51 */
32,
/* 52 */,
/* 53 */
32,
/* 54 */,
/* 55 */
32,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */
32,
/* 62 */,
/* 63 */
32,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */
32,
/* 71 */,
/* 72 */
32,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */
32,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _appHtml = __webpack_require__(154);
	
	var _appHtml2 = _interopRequireDefault(_appHtml);
	
	function ComponentController() {
	    'ngInject';
	}
	
	var AppComponent = {
	    restrict: 'E',
	    templateUrl: _appHtml2['default'],
	    controller: ComponentController,
	    replace: true
	    // controllerAs: 'vm'
	};
	
	exports.AppComponent = AppComponent;

/***/ },
/* 154 */
/***/ function(module, exports) {

	var path = 'app/app.html';
	var html = "<ui-view></ui-view>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _authAuthJs = __webpack_require__(156);
	
	var _commonCommonJs = __webpack_require__(167);
	
	var _dashboardDashboardJs = __webpack_require__(423);
	
	var _ordinacijaOrdinacijaJs = __webpack_require__(437);
	
	var _cjenikCjenikJs = __webpack_require__(456);
	
	var _radniNalogRadniNalogJs = __webpack_require__(463);
	
	var _stavkaNalogaStavkaNalogaJs = __webpack_require__(466);
	
	var _fazaNalogaFazaNalogaJs = __webpack_require__(504);
	
	var components = _angular2['default'].module('components', [_authAuthJs.auth.name, _commonCommonJs.common.name, _dashboardDashboardJs.dashboard.name, _ordinacijaOrdinacijaJs.ordinacija.name, _cjenikCjenikJs.cjenik.name, _radniNalogRadniNalogJs.radniNalog.name, _stavkaNalogaStavkaNalogaJs.stavkaNaloga.name, _fazaNalogaFazaNalogaJs.fazaNaloga.name]);
	
	exports.components = components;

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularCookies = __webpack_require__(157);
	
	var _angularCookies2 = _interopRequireDefault(_angularCookies);
	
	var _angularLocalStorage = __webpack_require__(159);
	
	var _angularLocalStorage2 = _interopRequireDefault(_angularLocalStorage);
	
	var _authComponentJs = __webpack_require__(161);
	
	var _authServiceJs = __webpack_require__(164);
	
	var auth = _angular2['default'].module('auth', [_angularCookies2['default'], _angularLocalStorage2['default']]);
	
	auth.service('djangoAuth', _authServiceJs.djangoAuth);
	auth.component('auth', _authComponentJs.AuthComponent);
	
	exports.auth = auth;

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(158);
	module.exports = 'ngCookies';


/***/ },
/* 158 */
/***/ function(module, exports) {

	/**
	 * @license AngularJS v1.5.5
	 * (c) 2010-2016 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	/**
	 * @ngdoc module
	 * @name ngCookies
	 * @description
	 *
	 * # ngCookies
	 *
	 * The `ngCookies` module provides a convenient wrapper for reading and writing browser cookies.
	 *
	 *
	 * <div doc-module-components="ngCookies"></div>
	 *
	 * See {@link ngCookies.$cookies `$cookies`} for usage.
	 */
	
	
	angular.module('ngCookies', ['ng']).
	  /**
	   * @ngdoc provider
	   * @name $cookiesProvider
	   * @description
	   * Use `$cookiesProvider` to change the default behavior of the {@link ngCookies.$cookies $cookies} service.
	   * */
	   provider('$cookies', [function $CookiesProvider() {
	    /**
	     * @ngdoc property
	     * @name $cookiesProvider#defaults
	     * @description
	     *
	     * Object containing default options to pass when setting cookies.
	     *
	     * The object may have following properties:
	     *
	     * - **path** - `{string}` - The cookie will be available only for this path and its
	     *   sub-paths. By default, this is the URL that appears in your `<base>` tag.
	     * - **domain** - `{string}` - The cookie will be available only for this domain and
	     *   its sub-domains. For security reasons the user agent will not accept the cookie
	     *   if the current domain is not a sub-domain of this domain or equal to it.
	     * - **expires** - `{string|Date}` - String of the form "Wdy, DD Mon YYYY HH:MM:SS GMT"
	     *   or a Date object indicating the exact date/time this cookie will expire.
	     * - **secure** - `{boolean}` - If `true`, then the cookie will only be available through a
	     *   secured connection.
	     *
	     * Note: By default, the address that appears in your `<base>` tag will be used as the path.
	     * This is important so that cookies will be visible for all routes when html5mode is enabled.
	     *
	     **/
	    var defaults = this.defaults = {};
	
	    function calcOptions(options) {
	      return options ? angular.extend({}, defaults, options) : defaults;
	    }
	
	    /**
	     * @ngdoc service
	     * @name $cookies
	     *
	     * @description
	     * Provides read/write access to browser's cookies.
	     *
	     * <div class="alert alert-info">
	     * Up until Angular 1.3, `$cookies` exposed properties that represented the
	     * current browser cookie values. In version 1.4, this behavior has changed, and
	     * `$cookies` now provides a standard api of getters, setters etc.
	     * </div>
	     *
	     * Requires the {@link ngCookies `ngCookies`} module to be installed.
	     *
	     * @example
	     *
	     * ```js
	     * angular.module('cookiesExample', ['ngCookies'])
	     *   .controller('ExampleController', ['$cookies', function($cookies) {
	     *     // Retrieving a cookie
	     *     var favoriteCookie = $cookies.get('myFavorite');
	     *     // Setting a cookie
	     *     $cookies.put('myFavorite', 'oatmeal');
	     *   }]);
	     * ```
	     */
	    this.$get = ['$$cookieReader', '$$cookieWriter', function($$cookieReader, $$cookieWriter) {
	      return {
	        /**
	         * @ngdoc method
	         * @name $cookies#get
	         *
	         * @description
	         * Returns the value of given cookie key
	         *
	         * @param {string} key Id to use for lookup.
	         * @returns {string} Raw cookie value.
	         */
	        get: function(key) {
	          return $$cookieReader()[key];
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#getObject
	         *
	         * @description
	         * Returns the deserialized value of given cookie key
	         *
	         * @param {string} key Id to use for lookup.
	         * @returns {Object} Deserialized cookie value.
	         */
	        getObject: function(key) {
	          var value = this.get(key);
	          return value ? angular.fromJson(value) : value;
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#getAll
	         *
	         * @description
	         * Returns a key value object with all the cookies
	         *
	         * @returns {Object} All cookies
	         */
	        getAll: function() {
	          return $$cookieReader();
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#put
	         *
	         * @description
	         * Sets a value for given cookie key
	         *
	         * @param {string} key Id for the `value`.
	         * @param {string} value Raw value to be stored.
	         * @param {Object=} options Options object.
	         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
	         */
	        put: function(key, value, options) {
	          $$cookieWriter(key, value, calcOptions(options));
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#putObject
	         *
	         * @description
	         * Serializes and sets a value for given cookie key
	         *
	         * @param {string} key Id for the `value`.
	         * @param {Object} value Value to be stored.
	         * @param {Object=} options Options object.
	         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
	         */
	        putObject: function(key, value, options) {
	          this.put(key, angular.toJson(value), options);
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#remove
	         *
	         * @description
	         * Remove given cookie
	         *
	         * @param {string} key Id of the key-value pair to delete.
	         * @param {Object=} options Options object.
	         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
	         */
	        remove: function(key, options) {
	          $$cookieWriter(key, undefined, calcOptions(options));
	        }
	      };
	    }];
	  }]);
	
	angular.module('ngCookies').
	/**
	 * @ngdoc service
	 * @name $cookieStore
	 * @deprecated
	 * @requires $cookies
	 *
	 * @description
	 * Provides a key-value (string-object) storage, that is backed by session cookies.
	 * Objects put or retrieved from this storage are automatically serialized or
	 * deserialized by angular's toJson/fromJson.
	 *
	 * Requires the {@link ngCookies `ngCookies`} module to be installed.
	 *
	 * <div class="alert alert-danger">
	 * **Note:** The $cookieStore service is **deprecated**.
	 * Please use the {@link ngCookies.$cookies `$cookies`} service instead.
	 * </div>
	 *
	 * @example
	 *
	 * ```js
	 * angular.module('cookieStoreExample', ['ngCookies'])
	 *   .controller('ExampleController', ['$cookieStore', function($cookieStore) {
	 *     // Put cookie
	 *     $cookieStore.put('myFavorite','oatmeal');
	 *     // Get cookie
	 *     var favoriteCookie = $cookieStore.get('myFavorite');
	 *     // Removing a cookie
	 *     $cookieStore.remove('myFavorite');
	 *   }]);
	 * ```
	 */
	 factory('$cookieStore', ['$cookies', function($cookies) {
	
	    return {
	      /**
	       * @ngdoc method
	       * @name $cookieStore#get
	       *
	       * @description
	       * Returns the value of given cookie key
	       *
	       * @param {string} key Id to use for lookup.
	       * @returns {Object} Deserialized cookie value, undefined if the cookie does not exist.
	       */
	      get: function(key) {
	        return $cookies.getObject(key);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $cookieStore#put
	       *
	       * @description
	       * Sets a value for given cookie key
	       *
	       * @param {string} key Id for the `value`.
	       * @param {Object} value Value to be stored.
	       */
	      put: function(key, value) {
	        $cookies.putObject(key, value);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $cookieStore#remove
	       *
	       * @description
	       * Remove given cookie
	       *
	       * @param {string} key Id of the key-value pair to delete.
	       */
	      remove: function(key) {
	        $cookies.remove(key);
	      }
	    };
	
	  }]);
	
	/**
	 * @name $$cookieWriter
	 * @requires $document
	 *
	 * @description
	 * This is a private service for writing cookies
	 *
	 * @param {string} name Cookie name
	 * @param {string=} value Cookie value (if undefined, cookie will be deleted)
	 * @param {Object=} options Object with options that need to be stored for the cookie.
	 */
	function $$CookieWriter($document, $log, $browser) {
	  var cookiePath = $browser.baseHref();
	  var rawDocument = $document[0];
	
	  function buildCookieString(name, value, options) {
	    var path, expires;
	    options = options || {};
	    expires = options.expires;
	    path = angular.isDefined(options.path) ? options.path : cookiePath;
	    if (angular.isUndefined(value)) {
	      expires = 'Thu, 01 Jan 1970 00:00:00 GMT';
	      value = '';
	    }
	    if (angular.isString(expires)) {
	      expires = new Date(expires);
	    }
	
	    var str = encodeURIComponent(name) + '=' + encodeURIComponent(value);
	    str += path ? ';path=' + path : '';
	    str += options.domain ? ';domain=' + options.domain : '';
	    str += expires ? ';expires=' + expires.toUTCString() : '';
	    str += options.secure ? ';secure' : '';
	
	    // per http://www.ietf.org/rfc/rfc2109.txt browser must allow at minimum:
	    // - 300 cookies
	    // - 20 cookies per unique domain
	    // - 4096 bytes per cookie
	    var cookieLength = str.length + 1;
	    if (cookieLength > 4096) {
	      $log.warn("Cookie '" + name +
	        "' possibly not set or overflowed because it was too large (" +
	        cookieLength + " > 4096 bytes)!");
	    }
	
	    return str;
	  }
	
	  return function(name, value, options) {
	    rawDocument.cookie = buildCookieString(name, value, options);
	  };
	}
	
	$$CookieWriter.$inject = ['$document', '$log', '$browser'];
	
	angular.module('ngCookies').provider('$$cookieWriter', function $$CookieWriterProvider() {
	  this.$get = $$CookieWriter;
	});
	
	
	})(window, window.angular);


/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(160);
	module.exports = 'LocalStorageModule';


/***/ },
/* 160 */
/***/ function(module, exports) {

	var isDefined = angular.isDefined,
	  isUndefined = angular.isUndefined,
	  isNumber = angular.isNumber,
	  isObject = angular.isObject,
	  isArray = angular.isArray,
	  extend = angular.extend,
	  toJson = angular.toJson;
	
	angular
	  .module('LocalStorageModule', [])
	  .provider('localStorageService', function() {
	    // You should set a prefix to avoid overwriting any local storage variables from the rest of your app
	    // e.g. localStorageServiceProvider.setPrefix('yourAppName');
	    // With provider you can use config as this:
	    // myApp.config(function (localStorageServiceProvider) {
	    //    localStorageServiceProvider.prefix = 'yourAppName';
	    // });
	    this.prefix = 'ls';
	
	    // You could change web storage type localstorage or sessionStorage
	    this.storageType = 'localStorage';
	
	    // Cookie options (usually in case of fallback)
	    // expiry = Number of days before cookies expire // 0 = Does not expire
	    // path = The web path the cookie represents
	    this.cookie = {
	      expiry: 30,
	      path: '/'
	    };
	
	    // Send signals for each of the following actions?
	    this.notify = {
	      setItem: true,
	      removeItem: false
	    };
	
	    // Setter for the prefix
	    this.setPrefix = function(prefix) {
	      this.prefix = prefix;
	      return this;
	    };
	
	    // Setter for the storageType
	    this.setStorageType = function(storageType) {
	      this.storageType = storageType;
	      return this;
	    };
	
	    // Setter for cookie config
	    this.setStorageCookie = function(exp, path) {
	      this.cookie.expiry = exp;
	      this.cookie.path = path;
	      return this;
	    };
	
	    // Setter for cookie domain
	    this.setStorageCookieDomain = function(domain) {
	      this.cookie.domain = domain;
	      return this;
	    };
	
	    // Setter for notification config
	    // itemSet & itemRemove should be booleans
	    this.setNotify = function(itemSet, itemRemove) {
	      this.notify = {
	        setItem: itemSet,
	        removeItem: itemRemove
	      };
	      return this;
	    };
	
	    this.$get = ['$rootScope', '$window', '$document', '$parse', function($rootScope, $window, $document, $parse) {
	      var self = this;
	      var prefix = self.prefix;
	      var cookie = self.cookie;
	      var notify = self.notify;
	      var storageType = self.storageType;
	      var webStorage;
	
	      // When Angular's $document is not available
	      if (!$document) {
	        $document = document;
	      } else if ($document[0]) {
	        $document = $document[0];
	      }
	
	      // If there is a prefix set in the config lets use that with an appended period for readability
	      if (prefix.substr(-1) !== '.') {
	        prefix = !!prefix ? prefix + '.' : '';
	      }
	      var deriveQualifiedKey = function(key) {
	        return prefix + key;
	      };
	      // Checks the browser to see if local storage is supported
	      var browserSupportsLocalStorage = (function () {
	        try {
	          var supported = (storageType in $window && $window[storageType] !== null);
	
	          // When Safari (OS X or iOS) is in private browsing mode, it appears as though localStorage
	          // is available, but trying to call .setItem throws an exception.
	          //
	          // "QUOTA_EXCEEDED_ERR: DOM Exception 22: An attempt was made to add something to storage
	          // that exceeded the quota."
	          var key = deriveQualifiedKey('__' + Math.round(Math.random() * 1e7));
	          if (supported) {
	            webStorage = $window[storageType];
	            webStorage.setItem(key, '');
	            webStorage.removeItem(key);
	          }
	
	          return supported;
	        } catch (e) {
	          storageType = 'cookie';
	          $rootScope.$broadcast('LocalStorageModule.notification.error', e.message);
	          return false;
	        }
	      }());
	
	      // Directly adds a value to local storage
	      // If local storage is not available in the browser use cookies
	      // Example use: localStorageService.add('library','angular');
	      var addToLocalStorage = function (key, value) {
	        // Let's convert undefined values to null to get the value consistent
	        if (isUndefined(value)) {
	          value = null;
	        } else {
	          value = toJson(value);
	        }
	
	        // If this browser does not support local storage use cookies
	        if (!browserSupportsLocalStorage || self.storageType === 'cookie') {
	          if (!browserSupportsLocalStorage) {
	            $rootScope.$broadcast('LocalStorageModule.notification.warning', 'LOCAL_STORAGE_NOT_SUPPORTED');
	          }
	
	          if (notify.setItem) {
	            $rootScope.$broadcast('LocalStorageModule.notification.setitem', {key: key, newvalue: value, storageType: 'cookie'});
	          }
	          return addToCookies(key, value);
	        }
	
	        try {
	          if (webStorage) {
	            webStorage.setItem(deriveQualifiedKey(key), value);
	          }
	          if (notify.setItem) {
	            $rootScope.$broadcast('LocalStorageModule.notification.setitem', {key: key, newvalue: value, storageType: self.storageType});
	          }
	        } catch (e) {
	          $rootScope.$broadcast('LocalStorageModule.notification.error', e.message);
	          return addToCookies(key, value);
	        }
	        return true;
	      };
	
	      // Directly get a value from local storage
	      // Example use: localStorageService.get('library'); // returns 'angular'
	      var getFromLocalStorage = function (key) {
	
	        if (!browserSupportsLocalStorage || self.storageType === 'cookie') {
	          if (!browserSupportsLocalStorage) {
	            $rootScope.$broadcast('LocalStorageModule.notification.warning', 'LOCAL_STORAGE_NOT_SUPPORTED');
	          }
	
	          return getFromCookies(key);
	        }
	
	        var item = webStorage ? webStorage.getItem(deriveQualifiedKey(key)) : null;
	        // angular.toJson will convert null to 'null', so a proper conversion is needed
	        // FIXME not a perfect solution, since a valid 'null' string can't be stored
	        if (!item || item === 'null') {
	          return null;
	        }
	
	        try {
	          return JSON.parse(item);
	        } catch (e) {
	          return item;
	        }
	      };
	
	      // Remove an item from local storage
	      // Example use: localStorageService.remove('library'); // removes the key/value pair of library='angular'
	      var removeFromLocalStorage = function () {
	        var i, key;
	        for (i=0; i<arguments.length; i++) {
	          key = arguments[i];
	          if (!browserSupportsLocalStorage || self.storageType === 'cookie') {
	            if (!browserSupportsLocalStorage) {
	              $rootScope.$broadcast('LocalStorageModule.notification.warning', 'LOCAL_STORAGE_NOT_SUPPORTED');
	            }
	
	            if (notify.removeItem) {
	              $rootScope.$broadcast('LocalStorageModule.notification.removeitem', {key: key, storageType: 'cookie'});
	            }
	            removeFromCookies(key);
	          }
	          else {
	            try {
	              webStorage.removeItem(deriveQualifiedKey(key));
	              if (notify.removeItem) {
	                $rootScope.$broadcast('LocalStorageModule.notification.removeitem', {
	                  key: key,
	                  storageType: self.storageType
	                });
	              }
	            } catch (e) {
	              $rootScope.$broadcast('LocalStorageModule.notification.error', e.message);
	              removeFromCookies(key);
	            }
	          }
	        }
	      };
	
	      // Return array of keys for local storage
	      // Example use: var keys = localStorageService.keys()
	      var getKeysForLocalStorage = function () {
	
	        if (!browserSupportsLocalStorage) {
	          $rootScope.$broadcast('LocalStorageModule.notification.warning', 'LOCAL_STORAGE_NOT_SUPPORTED');
	          return [];
	        }
	
	        var prefixLength = prefix.length;
	        var keys = [];
	        for (var key in webStorage) {
	          // Only return keys that are for this app
	          if (key.substr(0, prefixLength) === prefix) {
	            try {
	              keys.push(key.substr(prefixLength));
	            } catch (e) {
	              $rootScope.$broadcast('LocalStorageModule.notification.error', e.Description);
	              return [];
	            }
	          }
	        }
	        return keys;
	      };
	
	      // Remove all data for this app from local storage
	      // Also optionally takes a regular expression string and removes the matching key-value pairs
	      // Example use: localStorageService.clearAll();
	      // Should be used mostly for development purposes
	      var clearAllFromLocalStorage = function (regularExpression) {
	
	        // Setting both regular expressions independently
	        // Empty strings result in catchall RegExp
	        var prefixRegex = !!prefix ? new RegExp('^' + prefix) : new RegExp();
	        var testRegex = !!regularExpression ? new RegExp(regularExpression) : new RegExp();
	
	        if (!browserSupportsLocalStorage || self.storageType === 'cookie') {
	          if (!browserSupportsLocalStorage) {
	            $rootScope.$broadcast('LocalStorageModule.notification.warning', 'LOCAL_STORAGE_NOT_SUPPORTED');
	          }
	          return clearAllFromCookies();
	        }
	
	        var prefixLength = prefix.length;
	
	        for (var key in webStorage) {
	          // Only remove items that are for this app and match the regular expression
	          if (prefixRegex.test(key) && testRegex.test(key.substr(prefixLength))) {
	            try {
	              removeFromLocalStorage(key.substr(prefixLength));
	            } catch (e) {
	              $rootScope.$broadcast('LocalStorageModule.notification.error', e.message);
	              return clearAllFromCookies();
	            }
	          }
	        }
	        return true;
	      };
	
	      // Checks the browser to see if cookies are supported
	      var browserSupportsCookies = (function() {
	        try {
	          return $window.navigator.cookieEnabled ||
	          ("cookie" in $document && ($document.cookie.length > 0 ||
	            ($document.cookie = "test").indexOf.call($document.cookie, "test") > -1));
	          } catch (e) {
	            $rootScope.$broadcast('LocalStorageModule.notification.error', e.message);
	            return false;
	          }
	        }());
	
	        // Directly adds a value to cookies
	        // Typically used as a fallback is local storage is not available in the browser
	        // Example use: localStorageService.cookie.add('library','angular');
	        var addToCookies = function (key, value, daysToExpiry) {
	
	          if (isUndefined(value)) {
	            return false;
	          } else if(isArray(value) || isObject(value)) {
	            value = toJson(value);
	          }
	
	          if (!browserSupportsCookies) {
	            $rootScope.$broadcast('LocalStorageModule.notification.error', 'COOKIES_NOT_SUPPORTED');
	            return false;
	          }
	
	          try {
	            var expiry = '',
	            expiryDate = new Date(),
	            cookieDomain = '';
	
	            if (value === null) {
	              // Mark that the cookie has expired one day ago
	              expiryDate.setTime(expiryDate.getTime() + (-1 * 24 * 60 * 60 * 1000));
	              expiry = "; expires=" + expiryDate.toGMTString();
	              value = '';
	            } else if (isNumber(daysToExpiry) && daysToExpiry !== 0) {
	              expiryDate.setTime(expiryDate.getTime() + (daysToExpiry * 24 * 60 * 60 * 1000));
	              expiry = "; expires=" + expiryDate.toGMTString();
	            } else if (cookie.expiry !== 0) {
	              expiryDate.setTime(expiryDate.getTime() + (cookie.expiry * 24 * 60 * 60 * 1000));
	              expiry = "; expires=" + expiryDate.toGMTString();
	            }
	            if (!!key) {
	              var cookiePath = "; path=" + cookie.path;
	              if(cookie.domain){
	                cookieDomain = "; domain=" + cookie.domain;
	              }
	              $document.cookie = deriveQualifiedKey(key) + "=" + encodeURIComponent(value) + expiry + cookiePath + cookieDomain;
	            }
	          } catch (e) {
	            $rootScope.$broadcast('LocalStorageModule.notification.error', e.message);
	            return false;
	          }
	          return true;
	        };
	
	        // Directly get a value from a cookie
	        // Example use: localStorageService.cookie.get('library'); // returns 'angular'
	        var getFromCookies = function (key) {
	          if (!browserSupportsCookies) {
	            $rootScope.$broadcast('LocalStorageModule.notification.error', 'COOKIES_NOT_SUPPORTED');
	            return false;
	          }
	
	          var cookies = $document.cookie && $document.cookie.split(';') || [];
	          for(var i=0; i < cookies.length; i++) {
	            var thisCookie = cookies[i];
	            while (thisCookie.charAt(0) === ' ') {
	              thisCookie = thisCookie.substring(1,thisCookie.length);
	            }
	            if (thisCookie.indexOf(deriveQualifiedKey(key) + '=') === 0) {
	              var storedValues = decodeURIComponent(thisCookie.substring(prefix.length + key.length + 1, thisCookie.length));
	              try {
	                return JSON.parse(storedValues);
	              } catch(e) {
	                return storedValues;
	              }
	            }
	          }
	          return null;
	        };
	
	        var removeFromCookies = function (key) {
	          addToCookies(key,null);
	        };
	
	        var clearAllFromCookies = function () {
	          var thisCookie = null, thisKey = null;
	          var prefixLength = prefix.length;
	          var cookies = $document.cookie.split(';');
	          for(var i = 0; i < cookies.length; i++) {
	            thisCookie = cookies[i];
	
	            while (thisCookie.charAt(0) === ' ') {
	              thisCookie = thisCookie.substring(1, thisCookie.length);
	            }
	
	            var key = thisCookie.substring(prefixLength, thisCookie.indexOf('='));
	            removeFromCookies(key);
	          }
	        };
	
	        var getStorageType = function() {
	          return storageType;
	        };
	
	        // Add a listener on scope variable to save its changes to local storage
	        // Return a function which when called cancels binding
	        var bindToScope = function(scope, key, def, lsKey) {
	          lsKey = lsKey || key;
	          var value = getFromLocalStorage(lsKey);
	
	          if (value === null && isDefined(def)) {
	            value = def;
	          } else if (isObject(value) && isObject(def)) {
	            value = extend(value, def);
	          }
	
	          $parse(key).assign(scope, value);
	
	          return scope.$watch(key, function(newVal) {
	            addToLocalStorage(lsKey, newVal);
	          }, isObject(scope[key]));
	        };
	
	        // Return localStorageService.length
	        // ignore keys that not owned
	        var lengthOfLocalStorage = function() {
	          var count = 0;
	          var storage = $window[storageType];
	          for(var i = 0; i < storage.length; i++) {
	            if(storage.key(i).indexOf(prefix) === 0 ) {
	              count++;
	            }
	          }
	          return count;
	        };
	
	        return {
	          isSupported: browserSupportsLocalStorage,
	          getStorageType: getStorageType,
	          set: addToLocalStorage,
	          add: addToLocalStorage, //DEPRECATED
	          get: getFromLocalStorage,
	          keys: getKeysForLocalStorage,
	          remove: removeFromLocalStorage,
	          clearAll: clearAllFromLocalStorage,
	          bind: bindToScope,
	          deriveKey: deriveQualifiedKey,
	          length: lengthOfLocalStorage,
	          cookie: {
	            isSupported: browserSupportsCookies,
	            set: addToCookies,
	            add: addToCookies, //DEPRECATED
	            get: getFromCookies,
	            remove: removeFromCookies,
	            clearAll: clearAllFromCookies
	          }
	        };
	      }];
	  });


/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _authHtml = __webpack_require__(162);
	
	var _authHtml2 = _interopRequireDefault(_authHtml);
	
	var _authControllerJs = __webpack_require__(163);
	
	var AuthComponent = {
	    restrict: 'E',
	    templateUrl: _authHtml2['default'],
	    controller: _authControllerJs.AuthController,
	    controllerAs: 'vm'
	};
	
	exports.AuthComponent = AuthComponent;

/***/ },
/* 162 */
/***/ function(module, exports) {

	var path = 'app/components/auth/auth.html';
	var html = "<div class=\"color-line\"></div><div class=\"login-container\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"text-center m-b-md\"><img src=\"images/logo.png\"><hr><h1><b>Dental<span class=\"text-warning\">LAB</span></b></h1><h2>Prijava za rad</h2></div><div class=\"hpanel\"><div class=\"panel-body\"><form id=\"loginForm\" ng-submit=\"vm.login()\"><div class=\"form-group\"><label class=\"control-label\" for=\"username\">Korisnik</label> <input type=\"text\" ng-model=\"vm.username\" class=\"form-control\" placeholder=\"korisnik\" required> <span class=\"help-block small\">Vaše korisničko ime</span></div><div class=\"form-group\"><label class=\"control-label\" for=\"password\">Zaporka</label> <input type=\"password\" ng-model=\"vm.password\" class=\"form-control\" placeholder=\"*********\" required> <span class=\"help-block small\">Vaša sigurnosna zaporka</span></div><button type=\"submit\" class=\"btn btn-warning btn-block\">Prijavi me</button><div ng-if=\"!vm.logging\" class=\"margin-top10\"><div class=\"alert alert-danger\" ng-if=\"vm.errors.status === 400\"><strong>Neuspjela prijava!</strong> Nije moguće prijaviti se s navedenim vjerodajnicama.</div><div class=\"alert alert-danger\" ng-if=\"vm.errors.status === 502\">Povezivanje nije uspjelo. Molimo vas pokušajte ponovno.</div><div class=\"alert alert-danger\" ng-if=\"vm.errors.status === -1\">Server timeout. Molimo vas pokušajte ponovno.</div></div></form></div></div></div></div><div class=\"row\"><div class=\"col-md-12 text-center\"><strong>DentalLAB</strong> - web application<br>&copy; 2017 InVita d.o.o.</div></div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 163 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var AuthController = (function () {
	    function AuthController($state, djangoAuth, $scope) {
	        _classCallCheck(this, AuthController);
	
	        this.username = '';
	        this.password = '';
	        this.$state = $state;
	        this.$scope = $scope;
	        this.djangoAuth = djangoAuth;
	        this.djangoAuth.logout();
	    }
	
	    _createClass(AuthController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            this.$scope.$watchCollection('[vm.username, vm.password]', function (newVal, oldVal) {
	                _this.logging = false;
	                _this.errors = false;
	            });
	        }
	    }, {
	        key: 'login',
	        value: function login() {
	            var _this2 = this;
	
	            this.logging = true;
	            this.errors = false;
	            this.djangoAuth.login(this.username, this.password).then(function (data) {
	                _this2.logging = false;
	                _this2.$state.go('dashboard');
	            }, function (error) {
	                _this2.logging = false;
	                _this2.errors = error;
	            });
	        }
	    }]);
	
	    return AuthController;
	})();
	
	AuthController.$inject = ['$state', 'djangoAuth', '$scope'];
	
	exports.AuthController = AuthController;

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _lodash = __webpack_require__(165);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var djangoAuth = function djangoAuth($q, $http, localStorageService, $rootScope, $timeout) {
	    // AngularJS will instantiate a singleton by calling "new" on this function
	    var service = {
	        /* START CUSTOMIZATION HERE */
	        // Change this to point to your Django REST Auth API
	        // e.g. /api/rest-auth  (DO NOT INCLUDE ENDING SLASH)
	        API_URL: '',
	        // Set use_session to true to use Django sessions to store security token.
	        // Set use_session to false to store the security token locally and transmit it as a custom header.
	        use_session: true,
	        /* END OF CUSTOMIZATION */
	        authenticated: null,
	        authPromise: null,
	        request: function request(args) {
	            // Let's retrieve the token from the cookie, if available
	            if (localStorageService.get('token')) {
	                $http.defaults.headers.common.Authorization = 'Token ' + localStorageService.get('token');
	            }
	            // Continue
	            params = args.params || {};
	            args = args || {};
	            var deferred = $q.defer(),
	                url = this.API_URL + args.url,
	                method = args.method || 'GET',
	                params = params,
	                data = args.data || {};
	            // Fire the request, as configured.
	
	            // let canceler = $q.defer();
	
	            $http({
	                url: url,
	                withCredentials: this.use_session,
	                method: method.toUpperCase(),
	                // headers: {'X-CSRFToken': $cookies['csrftoken']},
	                params: params,
	                data: data
	                // timeout: canceler.promise
	            }).then(function (response) {
	                deferred.resolve(response.data, response.status);
	            }, function (response) {
	                var status = response.status;
	                var headers = response.headers;
	                var config = response.config;
	
	                console.log('error syncing with: ' + url);
	
	                var data = {};
	                data.status = status;
	
	                if (status == 502) {
	                    data['details'] = ['Could not connect. Please try again.'];
	                } else if (status == -1) {
	                    data['details'] = ['Server timed out. Please try again.'];
	                } else {
	                    data['details'] = response.data['details'] || response.data['non_field_errors'];
	                }
	
	                deferred.reject(data);
	            });
	
	            // $timeout(() => {
	            //     canceler.resolve();
	            // }, 2000);
	
	            return deferred.promise;
	        },
	        register: function register(username, password1, password2, email, more) {
	            var data = {
	                username: username,
	                password1: password1,
	                password2: password2,
	                email: email
	            };
	            data = angular.extend(data, more);
	            return this.request({
	                method: 'POST',
	                url: '/registration/',
	                data: data
	            });
	        },
	        login: function login(username, password) {
	            var djangoAuth = this;
	            console.debug('Login executed!');
	            delete $http.defaults.headers.common.Authorization;
	            localStorageService.remove('token');
	            return this.request({
	                method: 'POST',
	                url: '/login/',
	                data: {
	                    username: username,
	                    password: password
	                }
	            }).then(function (data) {
	                if (!djangoAuth.use_session) {
	                    $http.defaults.headers.common.Authorization = 'Token ' + data.key;
	                    localStorageService.set('token', data.key);
	                }
	                djangoAuth.authenticated = true;
	                $rootScope.$broadcast('djangoAuth.logged_in', data);
	            });
	        },
	        logout: function logout() {
	            var djangoAuth = this;
	            return this.request({
	                method: 'POST',
	                url: '/logout/'
	            }).then(function (data) {
	                delete $http.defaults.headers.common.Authorization;
	                localStorageService.remove('token');
	                djangoAuth.authenticated = false;
	                $rootScope.$broadcast('djangoAuth.logged_out');
	            });
	        },
	        changePassword: function changePassword(password1, password2) {
	            return this.request({
	                method: 'POST',
	                url: '/password/change/',
	                data: {
	                    new_password1: password1,
	                    new_password2: password2
	                }
	            });
	        },
	        resetPassword: function resetPassword(email) {
	            return this.request({
	                method: 'POST',
	                url: '/password/reset/',
	                data: {
	                    email: email
	                }
	            });
	        },
	        profile: function profile() {
	            return this.request({
	                method: 'GET',
	                url: '/user/'
	            });
	        },
	        updateProfile: function updateProfile(data) {
	            return this.request({
	                method: 'PATCH',
	                url: '/user/',
	                data: data
	            });
	        },
	        verify: function verify(key) {
	            return this.request({
	                method: 'POST',
	                url: '/registration/verify-email/',
	                data: { key: key }
	            });
	        },
	        confirmReset: function confirmReset(uid, token, password1, password2) {
	            return this.request({
	                method: 'POST',
	                url: '/password/reset/confirm/',
	                data: {
	                    uid: uid,
	                    token: token,
	                    new_password1: password1,
	                    new_password2: password2
	                }
	            });
	        },
	        authenticationStatus: function authenticationStatus(restrict, force) {
	            // Set restrict to true to reject the promise if not logged in
	            // Set to false or omit to resolve when status is known
	            // Set force to true to ignore stored value and query API
	            restrict = restrict || false;
	            force = force || false;
	            if (this.authPromise == null || force) {
	                this.authPromise = this.request({
	                    method: 'GET',
	                    url: '/user/'
	                });
	            }
	            var da = this;
	            var getAuthStatus = $q.defer();
	            if (this.authenticated != null && !force) {
	                // We have a stored value which means we can pass it back right away.
	                if (this.authenticated == false && restrict) {
	                    getAuthStatus.reject('User is not logged in.');
	                } else {
	                    getAuthStatus.resolve();
	                }
	            } else {
	                // There isn't a stored value, or we're forcing a request back to
	                // the API to get the authentication status.
	                this.authPromise.then(function () {
	                    da.authenticated = true;
	                    getAuthStatus.resolve();
	                }, function () {
	                    da.authenticated = false;
	                    if (restrict) {
	                        getAuthStatus.reject('User is not logged in.');
	                    } else {
	                        getAuthStatus.resolve();
	                    }
	                });
	            }
	            return getAuthStatus.promise;
	        },
	        initialize: function initialize(url, sessions) {
	            this.API_URL = url;
	            this.use_session = sessions;
	            return this.authenticationStatus();
	        }
	    };
	    return service;
	};
	
	djangoAuth.$inject = ['$q', '$http', 'localStorageService', '$rootScope', '$timeout'];
	
	exports.djangoAuth = djangoAuth;

/***/ },
/* 165 */,
/* 166 */,
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _navbarNavbarJs = __webpack_require__(168);
	
	var _navbarTopNavbarTopJs = __webpack_require__(190);
	
	var _footerFooterJs = __webpack_require__(194);
	
	var _headerHeaderJs = __webpack_require__(197);
	
	var _homerHomerJs = __webpack_require__(200);
	
	var _formsFormsJs = __webpack_require__(201);
	
	var _utilsUtilsJs = __webpack_require__(325);
	
	var _configurationConfigurationJs = __webpack_require__(327);
	
	var _breadcrumbBreadcrumbJs = __webpack_require__(366);
	
	var _pageHeaderPageHeaderJs = __webpack_require__(368);
	
	var _crudCrudJs = __webpack_require__(371);
	
	var _ngDraggableNgDraggableJs = __webpack_require__(416);
	
	var _loggerLoggerServiceJs = __webpack_require__(417);
	
	var _loggerLoggerServiceJs2 = _interopRequireDefault(_loggerLoggerServiceJs);
	
	var _loadingLoadingJs = __webpack_require__(420);
	
	var common = _angular2['default'].module('common', [_homerHomerJs.homer.name, _navbarNavbarJs.navbar.name, _navbarTopNavbarTopJs.navbarTop.name, _footerFooterJs.footer.name, _headerHeaderJs.header.name, _formsFormsJs.forms.name, _configurationConfigurationJs.configurationModule.name, _utilsUtilsJs.utils.name, _breadcrumbBreadcrumbJs.breadcrumb.name, _pageHeaderPageHeaderJs.pageHeader.name, _crudCrudJs.crud.name, _ngDraggableNgDraggableJs.ngDraggable.name, _loggerLoggerServiceJs2['default'].name, _loadingLoadingJs.loading.name]);
	
	exports.common = common;

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiBootstrapSrcTooltip = __webpack_require__(169);
	
	var _angularUiBootstrapSrcTooltip2 = _interopRequireDefault(_angularUiBootstrapSrcTooltip);
	
	var _navbarComponentJs = __webpack_require__(183);
	
	var _profilePictureComponentJs = __webpack_require__(186);
	
	var _navigationDirectiveJs = __webpack_require__(188);
	
	var navbar = _angular2['default'].module('navbar', [_angularUiBootstrapSrcTooltip2['default']]);
	
	navbar.component('navbar', _navbarComponentJs.NavbarComponent);
	navbar.component('profilePicture', _profilePictureComponentJs.ProfilePictureComponent);
	navbar.directive('sideNavigation', _navigationDirectiveJs.SideNavigation);
	
	exports.navbar = navbar;

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(170);
	__webpack_require__(172);
	module.exports = __webpack_require__(174);


/***/ },
/* 170 */
32,
/* 171 */,
/* 172 */
32,
/* 173 */,
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(175);
	__webpack_require__(177);
	__webpack_require__(179);
	__webpack_require__(180);
	__webpack_require__(181);
	__webpack_require__(182);
	
	var MODULE_NAME = 'ui.bootstrap.module.tooltip';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.tooltip', 'uib/template/tooltip/tooltip-popup.html', 'uib/template/tooltip/tooltip-html-popup.html', 'uib/template/tooltip/tooltip-template-popup.html']);
	
	module.exports = MODULE_NAME;


/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(176);
	
	var MODULE_NAME = 'ui.bootstrap.module.position';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.position']);
	
	module.exports = MODULE_NAME;


/***/ },
/* 176 */
/***/ function(module, exports) {

	angular.module('ui.bootstrap.position', [])
	
	/**
	 * A set of utility methods for working with the DOM.
	 * It is meant to be used where we need to absolute-position elements in
	 * relation to another element (this is the case for tooltips, popovers,
	 * typeahead suggestions etc.).
	 */
	  .factory('$uibPosition', ['$document', '$window', function($document, $window) {
	    /**
	     * Used by scrollbarWidth() function to cache scrollbar's width.
	     * Do not access this variable directly, use scrollbarWidth() instead.
	     */
	    var SCROLLBAR_WIDTH;
	    /**
	     * scrollbar on body and html element in IE and Edge overlay
	     * content and should be considered 0 width.
	     */
	    var BODY_SCROLLBAR_WIDTH;
	    var OVERFLOW_REGEX = {
	      normal: /(auto|scroll)/,
	      hidden: /(auto|scroll|hidden)/
	    };
	    var PLACEMENT_REGEX = {
	      auto: /\s?auto?\s?/i,
	      primary: /^(top|bottom|left|right)$/,
	      secondary: /^(top|bottom|left|right|center)$/,
	      vertical: /^(top|bottom)$/
	    };
	    var BODY_REGEX = /(HTML|BODY)/;
	
	    return {
	
	      /**
	       * Provides a raw DOM element from a jQuery/jQLite element.
	       *
	       * @param {element} elem - The element to convert.
	       *
	       * @returns {element} A HTML element.
	       */
	      getRawNode: function(elem) {
	        return elem.nodeName ? elem : elem[0] || elem;
	      },
	
	      /**
	       * Provides a parsed number for a style property.  Strips
	       * units and casts invalid numbers to 0.
	       *
	       * @param {string} value - The style value to parse.
	       *
	       * @returns {number} A valid number.
	       */
	      parseStyle: function(value) {
	        value = parseFloat(value);
	        return isFinite(value) ? value : 0;
	      },
	
	      /**
	       * Provides the closest positioned ancestor.
	       *
	       * @param {element} element - The element to get the offest parent for.
	       *
	       * @returns {element} The closest positioned ancestor.
	       */
	      offsetParent: function(elem) {
	        elem = this.getRawNode(elem);
	
	        var offsetParent = elem.offsetParent || $document[0].documentElement;
	
	        function isStaticPositioned(el) {
	          return ($window.getComputedStyle(el).position || 'static') === 'static';
	        }
	
	        while (offsetParent && offsetParent !== $document[0].documentElement && isStaticPositioned(offsetParent)) {
	          offsetParent = offsetParent.offsetParent;
	        }
	
	        return offsetParent || $document[0].documentElement;
	      },
	
	      /**
	       * Provides the scrollbar width, concept from TWBS measureScrollbar()
	       * function in https://github.com/twbs/bootstrap/blob/master/js/modal.js
	       * In IE and Edge, scollbar on body and html element overlay and should
	       * return a width of 0.
	       *
	       * @returns {number} The width of the browser scollbar.
	       */
	      scrollbarWidth: function(isBody) {
	        if (isBody) {
	          if (angular.isUndefined(BODY_SCROLLBAR_WIDTH)) {
	            var bodyElem = $document.find('body');
	            bodyElem.addClass('uib-position-body-scrollbar-measure');
	            BODY_SCROLLBAR_WIDTH = $window.innerWidth - bodyElem[0].clientWidth;
	            BODY_SCROLLBAR_WIDTH = isFinite(BODY_SCROLLBAR_WIDTH) ? BODY_SCROLLBAR_WIDTH : 0;
	            bodyElem.removeClass('uib-position-body-scrollbar-measure');
	          }
	          return BODY_SCROLLBAR_WIDTH;
	        }
	
	        if (angular.isUndefined(SCROLLBAR_WIDTH)) {
	          var scrollElem = angular.element('<div class="uib-position-scrollbar-measure"></div>');
	          $document.find('body').append(scrollElem);
	          SCROLLBAR_WIDTH = scrollElem[0].offsetWidth - scrollElem[0].clientWidth;
	          SCROLLBAR_WIDTH = isFinite(SCROLLBAR_WIDTH) ? SCROLLBAR_WIDTH : 0;
	          scrollElem.remove();
	        }
	
	        return SCROLLBAR_WIDTH;
	      },
	
	      /**
	       * Provides the padding required on an element to replace the scrollbar.
	       *
	       * @returns {object} An object with the following properties:
	       *   <ul>
	       *     <li>**scrollbarWidth**: the width of the scrollbar</li>
	       *     <li>**widthOverflow**: whether the the width is overflowing</li>
	       *     <li>**right**: the amount of right padding on the element needed to replace the scrollbar</li>
	       *     <li>**rightOriginal**: the amount of right padding currently on the element</li>
	       *     <li>**heightOverflow**: whether the the height is overflowing</li>
	       *     <li>**bottom**: the amount of bottom padding on the element needed to replace the scrollbar</li>
	       *     <li>**bottomOriginal**: the amount of bottom padding currently on the element</li>
	       *   </ul>
	       */
	      scrollbarPadding: function(elem) {
	        elem = this.getRawNode(elem);
	
	        var elemStyle = $window.getComputedStyle(elem);
	        var paddingRight = this.parseStyle(elemStyle.paddingRight);
	        var paddingBottom = this.parseStyle(elemStyle.paddingBottom);
	        var scrollParent = this.scrollParent(elem, false, true);
	        var scrollbarWidth = this.scrollbarWidth(BODY_REGEX.test(scrollParent.tagName));
	
	        return {
	          scrollbarWidth: scrollbarWidth,
	          widthOverflow: scrollParent.scrollWidth > scrollParent.clientWidth,
	          right: paddingRight + scrollbarWidth,
	          originalRight: paddingRight,
	          heightOverflow: scrollParent.scrollHeight > scrollParent.clientHeight,
	          bottom: paddingBottom + scrollbarWidth,
	          originalBottom: paddingBottom
	         };
	      },
	
	      /**
	       * Checks to see if the element is scrollable.
	       *
	       * @param {element} elem - The element to check.
	       * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
	       *   default is false.
	       *
	       * @returns {boolean} Whether the element is scrollable.
	       */
	      isScrollable: function(elem, includeHidden) {
	        elem = this.getRawNode(elem);
	
	        var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
	        var elemStyle = $window.getComputedStyle(elem);
	        return overflowRegex.test(elemStyle.overflow + elemStyle.overflowY + elemStyle.overflowX);
	      },
	
	      /**
	       * Provides the closest scrollable ancestor.
	       * A port of the jQuery UI scrollParent method:
	       * https://github.com/jquery/jquery-ui/blob/master/ui/scroll-parent.js
	       *
	       * @param {element} elem - The element to find the scroll parent of.
	       * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
	       *   default is false.
	       * @param {boolean=} [includeSelf=false] - Should the element being passed be
	       * included in the scrollable llokup.
	       *
	       * @returns {element} A HTML element.
	       */
	      scrollParent: function(elem, includeHidden, includeSelf) {
	        elem = this.getRawNode(elem);
	
	        var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
	        var documentEl = $document[0].documentElement;
	        var elemStyle = $window.getComputedStyle(elem);
	        if (includeSelf && overflowRegex.test(elemStyle.overflow + elemStyle.overflowY + elemStyle.overflowX)) {
	          return elem;
	        }
	        var excludeStatic = elemStyle.position === 'absolute';
	        var scrollParent = elem.parentElement || documentEl;
	
	        if (scrollParent === documentEl || elemStyle.position === 'fixed') {
	          return documentEl;
	        }
	
	        while (scrollParent.parentElement && scrollParent !== documentEl) {
	          var spStyle = $window.getComputedStyle(scrollParent);
	          if (excludeStatic && spStyle.position !== 'static') {
	            excludeStatic = false;
	          }
	
	          if (!excludeStatic && overflowRegex.test(spStyle.overflow + spStyle.overflowY + spStyle.overflowX)) {
	            break;
	          }
	          scrollParent = scrollParent.parentElement;
	        }
	
	        return scrollParent;
	      },
	
	      /**
	       * Provides read-only equivalent of jQuery's position function:
	       * http://api.jquery.com/position/ - distance to closest positioned
	       * ancestor.  Does not account for margins by default like jQuery position.
	       *
	       * @param {element} elem - The element to caclulate the position on.
	       * @param {boolean=} [includeMargins=false] - Should margins be accounted
	       * for, default is false.
	       *
	       * @returns {object} An object with the following properties:
	       *   <ul>
	       *     <li>**width**: the width of the element</li>
	       *     <li>**height**: the height of the element</li>
	       *     <li>**top**: distance to top edge of offset parent</li>
	       *     <li>**left**: distance to left edge of offset parent</li>
	       *   </ul>
	       */
	      position: function(elem, includeMagins) {
	        elem = this.getRawNode(elem);
	
	        var elemOffset = this.offset(elem);
	        if (includeMagins) {
	          var elemStyle = $window.getComputedStyle(elem);
	          elemOffset.top -= this.parseStyle(elemStyle.marginTop);
	          elemOffset.left -= this.parseStyle(elemStyle.marginLeft);
	        }
	        var parent = this.offsetParent(elem);
	        var parentOffset = {top: 0, left: 0};
	
	        if (parent !== $document[0].documentElement) {
	          parentOffset = this.offset(parent);
	          parentOffset.top += parent.clientTop - parent.scrollTop;
	          parentOffset.left += parent.clientLeft - parent.scrollLeft;
	        }
	
	        return {
	          width: Math.round(angular.isNumber(elemOffset.width) ? elemOffset.width : elem.offsetWidth),
	          height: Math.round(angular.isNumber(elemOffset.height) ? elemOffset.height : elem.offsetHeight),
	          top: Math.round(elemOffset.top - parentOffset.top),
	          left: Math.round(elemOffset.left - parentOffset.left)
	        };
	      },
	
	      /**
	       * Provides read-only equivalent of jQuery's offset function:
	       * http://api.jquery.com/offset/ - distance to viewport.  Does
	       * not account for borders, margins, or padding on the body
	       * element.
	       *
	       * @param {element} elem - The element to calculate the offset on.
	       *
	       * @returns {object} An object with the following properties:
	       *   <ul>
	       *     <li>**width**: the width of the element</li>
	       *     <li>**height**: the height of the element</li>
	       *     <li>**top**: distance to top edge of viewport</li>
	       *     <li>**right**: distance to bottom edge of viewport</li>
	       *   </ul>
	       */
	      offset: function(elem) {
	        elem = this.getRawNode(elem);
	
	        var elemBCR = elem.getBoundingClientRect();
	        return {
	          width: Math.round(angular.isNumber(elemBCR.width) ? elemBCR.width : elem.offsetWidth),
	          height: Math.round(angular.isNumber(elemBCR.height) ? elemBCR.height : elem.offsetHeight),
	          top: Math.round(elemBCR.top + ($window.pageYOffset || $document[0].documentElement.scrollTop)),
	          left: Math.round(elemBCR.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft))
	        };
	      },
	
	      /**
	       * Provides offset distance to the closest scrollable ancestor
	       * or viewport.  Accounts for border and scrollbar width.
	       *
	       * Right and bottom dimensions represent the distance to the
	       * respective edge of the viewport element.  If the element
	       * edge extends beyond the viewport, a negative value will be
	       * reported.
	       *
	       * @param {element} elem - The element to get the viewport offset for.
	       * @param {boolean=} [useDocument=false] - Should the viewport be the document element instead
	       * of the first scrollable element, default is false.
	       * @param {boolean=} [includePadding=true] - Should the padding on the offset parent element
	       * be accounted for, default is true.
	       *
	       * @returns {object} An object with the following properties:
	       *   <ul>
	       *     <li>**top**: distance to the top content edge of viewport element</li>
	       *     <li>**bottom**: distance to the bottom content edge of viewport element</li>
	       *     <li>**left**: distance to the left content edge of viewport element</li>
	       *     <li>**right**: distance to the right content edge of viewport element</li>
	       *   </ul>
	       */
	      viewportOffset: function(elem, useDocument, includePadding) {
	        elem = this.getRawNode(elem);
	        includePadding = includePadding !== false ? true : false;
	
	        var elemBCR = elem.getBoundingClientRect();
	        var offsetBCR = {top: 0, left: 0, bottom: 0, right: 0};
	
	        var offsetParent = useDocument ? $document[0].documentElement : this.scrollParent(elem);
	        var offsetParentBCR = offsetParent.getBoundingClientRect();
	
	        offsetBCR.top = offsetParentBCR.top + offsetParent.clientTop;
	        offsetBCR.left = offsetParentBCR.left + offsetParent.clientLeft;
	        if (offsetParent === $document[0].documentElement) {
	          offsetBCR.top += $window.pageYOffset;
	          offsetBCR.left += $window.pageXOffset;
	        }
	        offsetBCR.bottom = offsetBCR.top + offsetParent.clientHeight;
	        offsetBCR.right = offsetBCR.left + offsetParent.clientWidth;
	
	        if (includePadding) {
	          var offsetParentStyle = $window.getComputedStyle(offsetParent);
	          offsetBCR.top += this.parseStyle(offsetParentStyle.paddingTop);
	          offsetBCR.bottom -= this.parseStyle(offsetParentStyle.paddingBottom);
	          offsetBCR.left += this.parseStyle(offsetParentStyle.paddingLeft);
	          offsetBCR.right -= this.parseStyle(offsetParentStyle.paddingRight);
	        }
	
	        return {
	          top: Math.round(elemBCR.top - offsetBCR.top),
	          bottom: Math.round(offsetBCR.bottom - elemBCR.bottom),
	          left: Math.round(elemBCR.left - offsetBCR.left),
	          right: Math.round(offsetBCR.right - elemBCR.right)
	        };
	      },
	
	      /**
	       * Provides an array of placement values parsed from a placement string.
	       * Along with the 'auto' indicator, supported placement strings are:
	       *   <ul>
	       *     <li>top: element on top, horizontally centered on host element.</li>
	       *     <li>top-left: element on top, left edge aligned with host element left edge.</li>
	       *     <li>top-right: element on top, lerightft edge aligned with host element right edge.</li>
	       *     <li>bottom: element on bottom, horizontally centered on host element.</li>
	       *     <li>bottom-left: element on bottom, left edge aligned with host element left edge.</li>
	       *     <li>bottom-right: element on bottom, right edge aligned with host element right edge.</li>
	       *     <li>left: element on left, vertically centered on host element.</li>
	       *     <li>left-top: element on left, top edge aligned with host element top edge.</li>
	       *     <li>left-bottom: element on left, bottom edge aligned with host element bottom edge.</li>
	       *     <li>right: element on right, vertically centered on host element.</li>
	       *     <li>right-top: element on right, top edge aligned with host element top edge.</li>
	       *     <li>right-bottom: element on right, bottom edge aligned with host element bottom edge.</li>
	       *   </ul>
	       * A placement string with an 'auto' indicator is expected to be
	       * space separated from the placement, i.e: 'auto bottom-left'  If
	       * the primary and secondary placement values do not match 'top,
	       * bottom, left, right' then 'top' will be the primary placement and
	       * 'center' will be the secondary placement.  If 'auto' is passed, true
	       * will be returned as the 3rd value of the array.
	       *
	       * @param {string} placement - The placement string to parse.
	       *
	       * @returns {array} An array with the following values
	       * <ul>
	       *   <li>**[0]**: The primary placement.</li>
	       *   <li>**[1]**: The secondary placement.</li>
	       *   <li>**[2]**: If auto is passed: true, else undefined.</li>
	       * </ul>
	       */
	      parsePlacement: function(placement) {
	        var autoPlace = PLACEMENT_REGEX.auto.test(placement);
	        if (autoPlace) {
	          placement = placement.replace(PLACEMENT_REGEX.auto, '');
	        }
	
	        placement = placement.split('-');
	
	        placement[0] = placement[0] || 'top';
	        if (!PLACEMENT_REGEX.primary.test(placement[0])) {
	          placement[0] = 'top';
	        }
	
	        placement[1] = placement[1] || 'center';
	        if (!PLACEMENT_REGEX.secondary.test(placement[1])) {
	          placement[1] = 'center';
	        }
	
	        if (autoPlace) {
	          placement[2] = true;
	        } else {
	          placement[2] = false;
	        }
	
	        return placement;
	      },
	
	      /**
	       * Provides coordinates for an element to be positioned relative to
	       * another element.  Passing 'auto' as part of the placement parameter
	       * will enable smart placement - where the element fits. i.e:
	       * 'auto left-top' will check to see if there is enough space to the left
	       * of the hostElem to fit the targetElem, if not place right (same for secondary
	       * top placement).  Available space is calculated using the viewportOffset
	       * function.
	       *
	       * @param {element} hostElem - The element to position against.
	       * @param {element} targetElem - The element to position.
	       * @param {string=} [placement=top] - The placement for the targetElem,
	       *   default is 'top'. 'center' is assumed as secondary placement for
	       *   'top', 'left', 'right', and 'bottom' placements.  Available placements are:
	       *   <ul>
	       *     <li>top</li>
	       *     <li>top-right</li>
	       *     <li>top-left</li>
	       *     <li>bottom</li>
	       *     <li>bottom-left</li>
	       *     <li>bottom-right</li>
	       *     <li>left</li>
	       *     <li>left-top</li>
	       *     <li>left-bottom</li>
	       *     <li>right</li>
	       *     <li>right-top</li>
	       *     <li>right-bottom</li>
	       *   </ul>
	       * @param {boolean=} [appendToBody=false] - Should the top and left values returned
	       *   be calculated from the body element, default is false.
	       *
	       * @returns {object} An object with the following properties:
	       *   <ul>
	       *     <li>**top**: Value for targetElem top.</li>
	       *     <li>**left**: Value for targetElem left.</li>
	       *     <li>**placement**: The resolved placement.</li>
	       *   </ul>
	       */
	      positionElements: function(hostElem, targetElem, placement, appendToBody) {
	        hostElem = this.getRawNode(hostElem);
	        targetElem = this.getRawNode(targetElem);
	
	        // need to read from prop to support tests.
	        var targetWidth = angular.isDefined(targetElem.offsetWidth) ? targetElem.offsetWidth : targetElem.prop('offsetWidth');
	        var targetHeight = angular.isDefined(targetElem.offsetHeight) ? targetElem.offsetHeight : targetElem.prop('offsetHeight');
	
	        placement = this.parsePlacement(placement);
	
	        var hostElemPos = appendToBody ? this.offset(hostElem) : this.position(hostElem);
	        var targetElemPos = {top: 0, left: 0, placement: ''};
	
	        if (placement[2]) {
	          var viewportOffset = this.viewportOffset(hostElem, appendToBody);
	
	          var targetElemStyle = $window.getComputedStyle(targetElem);
	          var adjustedSize = {
	            width: targetWidth + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginLeft) + this.parseStyle(targetElemStyle.marginRight))),
	            height: targetHeight + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginTop) + this.parseStyle(targetElemStyle.marginBottom)))
	          };
	
	          placement[0] = placement[0] === 'top' && adjustedSize.height > viewportOffset.top && adjustedSize.height <= viewportOffset.bottom ? 'bottom' :
	                         placement[0] === 'bottom' && adjustedSize.height > viewportOffset.bottom && adjustedSize.height <= viewportOffset.top ? 'top' :
	                         placement[0] === 'left' && adjustedSize.width > viewportOffset.left && adjustedSize.width <= viewportOffset.right ? 'right' :
	                         placement[0] === 'right' && adjustedSize.width > viewportOffset.right && adjustedSize.width <= viewportOffset.left ? 'left' :
	                         placement[0];
	
	          placement[1] = placement[1] === 'top' && adjustedSize.height - hostElemPos.height > viewportOffset.bottom && adjustedSize.height - hostElemPos.height <= viewportOffset.top ? 'bottom' :
	                         placement[1] === 'bottom' && adjustedSize.height - hostElemPos.height > viewportOffset.top && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom ? 'top' :
	                         placement[1] === 'left' && adjustedSize.width - hostElemPos.width > viewportOffset.right && adjustedSize.width - hostElemPos.width <= viewportOffset.left ? 'right' :
	                         placement[1] === 'right' && adjustedSize.width - hostElemPos.width > viewportOffset.left && adjustedSize.width - hostElemPos.width <= viewportOffset.right ? 'left' :
	                         placement[1];
	
	          if (placement[1] === 'center') {
	            if (PLACEMENT_REGEX.vertical.test(placement[0])) {
	              var xOverflow = hostElemPos.width / 2 - targetWidth / 2;
	              if (viewportOffset.left + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.right) {
	                placement[1] = 'left';
	              } else if (viewportOffset.right + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.left) {
	                placement[1] = 'right';
	              }
	            } else {
	              var yOverflow = hostElemPos.height / 2 - adjustedSize.height / 2;
	              if (viewportOffset.top + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom) {
	                placement[1] = 'top';
	              } else if (viewportOffset.bottom + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.top) {
	                placement[1] = 'bottom';
	              }
	            }
	          }
	        }
	
	        switch (placement[0]) {
	          case 'top':
	            targetElemPos.top = hostElemPos.top - targetHeight;
	            break;
	          case 'bottom':
	            targetElemPos.top = hostElemPos.top + hostElemPos.height;
	            break;
	          case 'left':
	            targetElemPos.left = hostElemPos.left - targetWidth;
	            break;
	          case 'right':
	            targetElemPos.left = hostElemPos.left + hostElemPos.width;
	            break;
	        }
	
	        switch (placement[1]) {
	          case 'top':
	            targetElemPos.top = hostElemPos.top;
	            break;
	          case 'bottom':
	            targetElemPos.top = hostElemPos.top + hostElemPos.height - targetHeight;
	            break;
	          case 'left':
	            targetElemPos.left = hostElemPos.left;
	            break;
	          case 'right':
	            targetElemPos.left = hostElemPos.left + hostElemPos.width - targetWidth;
	            break;
	          case 'center':
	            if (PLACEMENT_REGEX.vertical.test(placement[0])) {
	              targetElemPos.left = hostElemPos.left + hostElemPos.width / 2 - targetWidth / 2;
	            } else {
	              targetElemPos.top = hostElemPos.top + hostElemPos.height / 2 - targetHeight / 2;
	            }
	            break;
	        }
	
	        targetElemPos.top = Math.round(targetElemPos.top);
	        targetElemPos.left = Math.round(targetElemPos.left);
	        targetElemPos.placement = placement[1] === 'center' ? placement[0] : placement[0] + '-' + placement[1];
	
	        return targetElemPos;
	      },
	
	      /**
	       * Provides a way to adjust the top positioning after first
	       * render to correctly align element to top after content
	       * rendering causes resized element height
	       *
	       * @param {array} placementClasses - The array of strings of classes
	       * element should have.
	       * @param {object} containerPosition - The object with container
	       * position information
	       * @param {number} initialHeight - The initial height for the elem.
	       * @param {number} currentHeight - The current height for the elem.
	       */
	      adjustTop: function(placementClasses, containerPosition, initialHeight, currentHeight) {
	        if (placementClasses.indexOf('top') !== -1 && initialHeight !== currentHeight) {
	          return {
	            top: containerPosition.top - currentHeight + 'px'
	          };
	        }
	      },
	
	      /**
	       * Provides a way for positioning tooltip & dropdown
	       * arrows when using placement options beyond the standard
	       * left, right, top, or bottom.
	       *
	       * @param {element} elem - The tooltip/dropdown element.
	       * @param {string} placement - The placement for the elem.
	       */
	      positionArrow: function(elem, placement) {
	        elem = this.getRawNode(elem);
	
	        var innerElem = elem.querySelector('.tooltip-inner, .popover-inner');
	        if (!innerElem) {
	          return;
	        }
	
	        var isTooltip = angular.element(innerElem).hasClass('tooltip-inner');
	
	        var arrowElem = isTooltip ? elem.querySelector('.tooltip-arrow') : elem.querySelector('.arrow');
	        if (!arrowElem) {
	          return;
	        }
	
	        var arrowCss = {
	          top: '',
	          bottom: '',
	          left: '',
	          right: ''
	        };
	
	        placement = this.parsePlacement(placement);
	        if (placement[1] === 'center') {
	          // no adjustment necessary - just reset styles
	          angular.element(arrowElem).css(arrowCss);
	          return;
	        }
	
	        var borderProp = 'border-' + placement[0] + '-width';
	        var borderWidth = $window.getComputedStyle(arrowElem)[borderProp];
	
	        var borderRadiusProp = 'border-';
	        if (PLACEMENT_REGEX.vertical.test(placement[0])) {
	          borderRadiusProp += placement[0] + '-' + placement[1];
	        } else {
	          borderRadiusProp += placement[1] + '-' + placement[0];
	        }
	        borderRadiusProp += '-radius';
	        var borderRadius = $window.getComputedStyle(isTooltip ? innerElem : elem)[borderRadiusProp];
	
	        switch (placement[0]) {
	          case 'top':
	            arrowCss.bottom = isTooltip ? '0' : '-' + borderWidth;
	            break;
	          case 'bottom':
	            arrowCss.top = isTooltip ? '0' : '-' + borderWidth;
	            break;
	          case 'left':
	            arrowCss.right = isTooltip ? '0' : '-' + borderWidth;
	            break;
	          case 'right':
	            arrowCss.left = isTooltip ? '0' : '-' + borderWidth;
	            break;
	        }
	
	        arrowCss[placement[1]] = borderRadius;
	
	        angular.element(arrowElem).css(arrowCss);
	      }
	    };
	  }]);


/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(178);
	
	var MODULE_NAME = 'ui.bootstrap.module.stackedMap';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.stackedMap']);
	
	module.exports = MODULE_NAME;


/***/ },
/* 178 */
/***/ function(module, exports) {

	angular.module('ui.bootstrap.stackedMap', [])
	/**
	 * A helper, internal data structure that acts as a map but also allows getting / removing
	 * elements in the LIFO order
	 */
	  .factory('$$stackedMap', function() {
	    return {
	      createNew: function() {
	        var stack = [];
	
	        return {
	          add: function(key, value) {
	            stack.push({
	              key: key,
	              value: value
	            });
	          },
	          get: function(key) {
	            for (var i = 0; i < stack.length; i++) {
	              if (key === stack[i].key) {
	                return stack[i];
	              }
	            }
	          },
	          keys: function() {
	            var keys = [];
	            for (var i = 0; i < stack.length; i++) {
	              keys.push(stack[i].key);
	            }
	            return keys;
	          },
	          top: function() {
	            return stack[stack.length - 1];
	          },
	          remove: function(key) {
	            var idx = -1;
	            for (var i = 0; i < stack.length; i++) {
	              if (key === stack[i].key) {
	                idx = i;
	                break;
	              }
	            }
	            return stack.splice(idx, 1)[0];
	          },
	          removeTop: function() {
	            return stack.pop();
	          },
	          length: function() {
	            return stack.length;
	          }
	        };
	      }
	    };
	  });

/***/ },
/* 179 */
/***/ function(module, exports) {

	angular.module("uib/template/tooltip/tooltip-popup.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("uib/template/tooltip/tooltip-popup.html",
	    "<div class=\"tooltip-arrow\"></div>\n" +
	    "<div class=\"tooltip-inner\" ng-bind=\"content\"></div>\n" +
	    "");
	}]);


/***/ },
/* 180 */
/***/ function(module, exports) {

	angular.module("uib/template/tooltip/tooltip-html-popup.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("uib/template/tooltip/tooltip-html-popup.html",
	    "<div class=\"tooltip-arrow\"></div>\n" +
	    "<div class=\"tooltip-inner\" ng-bind-html=\"contentExp()\"></div>\n" +
	    "");
	}]);


/***/ },
/* 181 */
/***/ function(module, exports) {

	angular.module("uib/template/tooltip/tooltip-template-popup.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("uib/template/tooltip/tooltip-template-popup.html",
	    "<div class=\"tooltip-arrow\"></div>\n" +
	    "<div class=\"tooltip-inner\"\n" +
	    "  uib-tooltip-template-transclude=\"contentExp()\"\n" +
	    "  tooltip-template-transclude-scope=\"originScope()\"></div>\n" +
	    "");
	}]);


/***/ },
/* 182 */
/***/ function(module, exports) {

	/**
	 * The following features are still outstanding: animation as a
	 * function, placement as a function, inside, support for more triggers than
	 * just mouse enter/leave, html tooltips, and selector delegation.
	 */
	angular.module('ui.bootstrap.tooltip', ['ui.bootstrap.position', 'ui.bootstrap.stackedMap'])
	
	/**
	 * The $tooltip service creates tooltip- and popover-like directives as well as
	 * houses global options for them.
	 */
	.provider('$uibTooltip', function() {
	  // The default options tooltip and popover.
	  var defaultOptions = {
	    placement: 'top',
	    placementClassPrefix: '',
	    animation: true,
	    popupDelay: 0,
	    popupCloseDelay: 0,
	    useContentExp: false
	  };
	
	  // Default hide triggers for each show trigger
	  var triggerMap = {
	    'mouseenter': 'mouseleave',
	    'click': 'click',
	    'outsideClick': 'outsideClick',
	    'focus': 'blur',
	    'none': ''
	  };
	
	  // The options specified to the provider globally.
	  var globalOptions = {};
	
	  /**
	   * `options({})` allows global configuration of all tooltips in the
	   * application.
	   *
	   *   var app = angular.module( 'App', ['ui.bootstrap.tooltip'], function( $tooltipProvider ) {
	   *     // place tooltips left instead of top by default
	   *     $tooltipProvider.options( { placement: 'left' } );
	   *   });
	   */
		this.options = function(value) {
			angular.extend(globalOptions, value);
		};
	
	  /**
	   * This allows you to extend the set of trigger mappings available. E.g.:
	   *
	   *   $tooltipProvider.setTriggers( { 'openTrigger': 'closeTrigger' } );
	   */
	  this.setTriggers = function setTriggers(triggers) {
	    angular.extend(triggerMap, triggers);
	  };
	
	  /**
	   * This is a helper function for translating camel-case to snake_case.
	   */
	  function snake_case(name) {
	    var regexp = /[A-Z]/g;
	    var separator = '-';
	    return name.replace(regexp, function(letter, pos) {
	      return (pos ? separator : '') + letter.toLowerCase();
	    });
	  }
	
	  /**
	   * Returns the actual instance of the $tooltip service.
	   * TODO support multiple triggers
	   */
	  this.$get = ['$window', '$compile', '$timeout', '$document', '$uibPosition', '$interpolate', '$rootScope', '$parse', '$$stackedMap', function($window, $compile, $timeout, $document, $position, $interpolate, $rootScope, $parse, $$stackedMap) {
	    var openedTooltips = $$stackedMap.createNew();
	    $document.on('keyup', keypressListener);
	
	    $rootScope.$on('$destroy', function() {
	      $document.off('keyup', keypressListener);
	    });
	
	    function keypressListener(e) {
	      if (e.which === 27) {
	        var last = openedTooltips.top();
	        if (last) {
	          last.value.close();
	          last = null;
	        }
	      }
	    }
	
	    return function $tooltip(ttType, prefix, defaultTriggerShow, options) {
	      options = angular.extend({}, defaultOptions, globalOptions, options);
	
	      /**
	       * Returns an object of show and hide triggers.
	       *
	       * If a trigger is supplied,
	       * it is used to show the tooltip; otherwise, it will use the `trigger`
	       * option passed to the `$tooltipProvider.options` method; else it will
	       * default to the trigger supplied to this directive factory.
	       *
	       * The hide trigger is based on the show trigger. If the `trigger` option
	       * was passed to the `$tooltipProvider.options` method, it will use the
	       * mapped trigger from `triggerMap` or the passed trigger if the map is
	       * undefined; otherwise, it uses the `triggerMap` value of the show
	       * trigger; else it will just use the show trigger.
	       */
	      function getTriggers(trigger) {
	        var show = (trigger || options.trigger || defaultTriggerShow).split(' ');
	        var hide = show.map(function(trigger) {
	          return triggerMap[trigger] || trigger;
	        });
	        return {
	          show: show,
	          hide: hide
	        };
	      }
	
	      var directiveName = snake_case(ttType);
	
	      var startSym = $interpolate.startSymbol();
	      var endSym = $interpolate.endSymbol();
	      var template =
	        '<div '+ directiveName + '-popup ' +
	          'uib-title="' + startSym + 'title' + endSym + '" ' +
	          (options.useContentExp ?
	            'content-exp="contentExp()" ' :
	            'content="' + startSym + 'content' + endSym + '" ') +
	          'origin-scope="origScope" ' +
	          'class="uib-position-measure ' + prefix + '" ' +
	          'tooltip-animation-class="fade"' +
	          'uib-tooltip-classes ' +
	          'ng-class="{ in: isOpen }" ' +
	          '>' +
	        '</div>';
	
	      return {
	        compile: function(tElem, tAttrs) {
	          var tooltipLinker = $compile(template);
	
	          return function link(scope, element, attrs, tooltipCtrl) {
	            var tooltip;
	            var tooltipLinkedScope;
	            var transitionTimeout;
	            var showTimeout;
	            var hideTimeout;
	            var positionTimeout;
	            var adjustmentTimeout;
	            var appendToBody = angular.isDefined(options.appendToBody) ? options.appendToBody : false;
	            var triggers = getTriggers(undefined);
	            var hasEnableExp = angular.isDefined(attrs[prefix + 'Enable']);
	            var ttScope = scope.$new(true);
	            var repositionScheduled = false;
	            var isOpenParse = angular.isDefined(attrs[prefix + 'IsOpen']) ? $parse(attrs[prefix + 'IsOpen']) : false;
	            var contentParse = options.useContentExp ? $parse(attrs[ttType]) : false;
	            var observers = [];
	            var lastPlacement;
	
	            var positionTooltip = function() {
	              // check if tooltip exists and is not empty
	              if (!tooltip || !tooltip.html()) { return; }
	
	              if (!positionTimeout) {
	                positionTimeout = $timeout(function() {
	                  var ttPosition = $position.positionElements(element, tooltip, ttScope.placement, appendToBody);
	                  var initialHeight = angular.isDefined(tooltip.offsetHeight) ? tooltip.offsetHeight : tooltip.prop('offsetHeight');
	                  var elementPos = appendToBody ? $position.offset(element) : $position.position(element);
	                  tooltip.css({ top: ttPosition.top + 'px', left: ttPosition.left + 'px' });
	                  var placementClasses = ttPosition.placement.split('-');
	
	                  if (!tooltip.hasClass(placementClasses[0])) {
	                    tooltip.removeClass(lastPlacement.split('-')[0]);
	                    tooltip.addClass(placementClasses[0]);
	                  }
	
	                  if (!tooltip.hasClass(options.placementClassPrefix + ttPosition.placement)) {
	                    tooltip.removeClass(options.placementClassPrefix + lastPlacement);
	                    tooltip.addClass(options.placementClassPrefix + ttPosition.placement);
	                  }
	
	                  adjustmentTimeout = $timeout(function() {
	                    var currentHeight = angular.isDefined(tooltip.offsetHeight) ? tooltip.offsetHeight : tooltip.prop('offsetHeight');
	                    var adjustment = $position.adjustTop(placementClasses, elementPos, initialHeight, currentHeight);
	                    if (adjustment) {
	                      tooltip.css(adjustment);
	                    }
	                    adjustmentTimeout = null;
	                  }, 0, false);
	
	                  // first time through tt element will have the
	                  // uib-position-measure class or if the placement
	                  // has changed we need to position the arrow.
	                  if (tooltip.hasClass('uib-position-measure')) {
	                    $position.positionArrow(tooltip, ttPosition.placement);
	                    tooltip.removeClass('uib-position-measure');
	                  } else if (lastPlacement !== ttPosition.placement) {
	                    $position.positionArrow(tooltip, ttPosition.placement);
	                  }
	                  lastPlacement = ttPosition.placement;
	
	                  positionTimeout = null;
	                }, 0, false);
	              }
	            };
	
	            // Set up the correct scope to allow transclusion later
	            ttScope.origScope = scope;
	
	            // By default, the tooltip is not open.
	            // TODO add ability to start tooltip opened
	            ttScope.isOpen = false;
	
	            function toggleTooltipBind() {
	              if (!ttScope.isOpen) {
	                showTooltipBind();
	              } else {
	                hideTooltipBind();
	              }
	            }
	
	            // Show the tooltip with delay if specified, otherwise show it immediately
	            function showTooltipBind() {
	              if (hasEnableExp && !scope.$eval(attrs[prefix + 'Enable'])) {
	                return;
	              }
	
	              cancelHide();
	              prepareTooltip();
	
	              if (ttScope.popupDelay) {
	                // Do nothing if the tooltip was already scheduled to pop-up.
	                // This happens if show is triggered multiple times before any hide is triggered.
	                if (!showTimeout) {
	                  showTimeout = $timeout(show, ttScope.popupDelay, false);
	                }
	              } else {
	                show();
	              }
	            }
	
	            function hideTooltipBind() {
	              cancelShow();
	
	              if (ttScope.popupCloseDelay) {
	                if (!hideTimeout) {
	                  hideTimeout = $timeout(hide, ttScope.popupCloseDelay, false);
	                }
	              } else {
	                hide();
	              }
	            }
	
	            // Show the tooltip popup element.
	            function show() {
	              cancelShow();
	              cancelHide();
	
	              // Don't show empty tooltips.
	              if (!ttScope.content) {
	                return angular.noop;
	              }
	
	              createTooltip();
	
	              // And show the tooltip.
	              ttScope.$evalAsync(function() {
	                ttScope.isOpen = true;
	                assignIsOpen(true);
	                positionTooltip();
	              });
	            }
	
	            function cancelShow() {
	              if (showTimeout) {
	                $timeout.cancel(showTimeout);
	                showTimeout = null;
	              }
	
	              if (positionTimeout) {
	                $timeout.cancel(positionTimeout);
	                positionTimeout = null;
	              }
	            }
	
	            // Hide the tooltip popup element.
	            function hide() {
	              if (!ttScope) {
	                return;
	              }
	
	              // First things first: we don't show it anymore.
	              ttScope.$evalAsync(function() {
	                if (ttScope) {
	                  ttScope.isOpen = false;
	                  assignIsOpen(false);
	                  // And now we remove it from the DOM. However, if we have animation, we
	                  // need to wait for it to expire beforehand.
	                  // FIXME: this is a placeholder for a port of the transitions library.
	                  // The fade transition in TWBS is 150ms.
	                  if (ttScope.animation) {
	                    if (!transitionTimeout) {
	                      transitionTimeout = $timeout(removeTooltip, 150, false);
	                    }
	                  } else {
	                    removeTooltip();
	                  }
	                }
	              });
	            }
	
	            function cancelHide() {
	              if (hideTimeout) {
	                $timeout.cancel(hideTimeout);
	                hideTimeout = null;
	              }
	
	              if (transitionTimeout) {
	                $timeout.cancel(transitionTimeout);
	                transitionTimeout = null;
	              }
	            }
	
	            function createTooltip() {
	              // There can only be one tooltip element per directive shown at once.
	              if (tooltip) {
	                return;
	              }
	
	              tooltipLinkedScope = ttScope.$new();
	              tooltip = tooltipLinker(tooltipLinkedScope, function(tooltip) {
	                if (appendToBody) {
	                  $document.find('body').append(tooltip);
	                } else {
	                  element.after(tooltip);
	                }
	              });
	
	              openedTooltips.add(ttScope, {
	                close: hide
	              });
	
	              prepObservers();
	            }
	
	            function removeTooltip() {
	              cancelShow();
	              cancelHide();
	              unregisterObservers();
	
	              if (tooltip) {
	                tooltip.remove();
	                
	                tooltip = null;
	                if (adjustmentTimeout) {
	                  $timeout.cancel(adjustmentTimeout);
	                }
	              }
	
	              openedTooltips.remove(ttScope);
	              
	              if (tooltipLinkedScope) {
	                tooltipLinkedScope.$destroy();
	                tooltipLinkedScope = null;
	              }
	            }
	
	            /**
	             * Set the initial scope values. Once
	             * the tooltip is created, the observers
	             * will be added to keep things in sync.
	             */
	            function prepareTooltip() {
	              ttScope.title = attrs[prefix + 'Title'];
	              if (contentParse) {
	                ttScope.content = contentParse(scope);
	              } else {
	                ttScope.content = attrs[ttType];
	              }
	
	              ttScope.popupClass = attrs[prefix + 'Class'];
	              ttScope.placement = angular.isDefined(attrs[prefix + 'Placement']) ? attrs[prefix + 'Placement'] : options.placement;
	              var placement = $position.parsePlacement(ttScope.placement);
	              lastPlacement = placement[1] ? placement[0] + '-' + placement[1] : placement[0];
	
	              var delay = parseInt(attrs[prefix + 'PopupDelay'], 10);
	              var closeDelay = parseInt(attrs[prefix + 'PopupCloseDelay'], 10);
	              ttScope.popupDelay = !isNaN(delay) ? delay : options.popupDelay;
	              ttScope.popupCloseDelay = !isNaN(closeDelay) ? closeDelay : options.popupCloseDelay;
	            }
	
	            function assignIsOpen(isOpen) {
	              if (isOpenParse && angular.isFunction(isOpenParse.assign)) {
	                isOpenParse.assign(scope, isOpen);
	              }
	            }
	
	            ttScope.contentExp = function() {
	              return ttScope.content;
	            };
	
	            /**
	             * Observe the relevant attributes.
	             */
	            attrs.$observe('disabled', function(val) {
	              if (val) {
	                cancelShow();
	              }
	
	              if (val && ttScope.isOpen) {
	                hide();
	              }
	            });
	
	            if (isOpenParse) {
	              scope.$watch(isOpenParse, function(val) {
	                if (ttScope && !val === ttScope.isOpen) {
	                  toggleTooltipBind();
	                }
	              });
	            }
	
	            function prepObservers() {
	              observers.length = 0;
	
	              if (contentParse) {
	                observers.push(
	                  scope.$watch(contentParse, function(val) {
	                    ttScope.content = val;
	                    if (!val && ttScope.isOpen) {
	                      hide();
	                    }
	                  })
	                );
	
	                observers.push(
	                  tooltipLinkedScope.$watch(function() {
	                    if (!repositionScheduled) {
	                      repositionScheduled = true;
	                      tooltipLinkedScope.$$postDigest(function() {
	                        repositionScheduled = false;
	                        if (ttScope && ttScope.isOpen) {
	                          positionTooltip();
	                        }
	                      });
	                    }
	                  })
	                );
	              } else {
	                observers.push(
	                  attrs.$observe(ttType, function(val) {
	                    ttScope.content = val;
	                    if (!val && ttScope.isOpen) {
	                      hide();
	                    } else {
	                      positionTooltip();
	                    }
	                  })
	                );
	              }
	
	              observers.push(
	                attrs.$observe(prefix + 'Title', function(val) {
	                  ttScope.title = val;
	                  if (ttScope.isOpen) {
	                    positionTooltip();
	                  }
	                })
	              );
	
	              observers.push(
	                attrs.$observe(prefix + 'Placement', function(val) {
	                  ttScope.placement = val ? val : options.placement;
	                  if (ttScope.isOpen) {
	                    positionTooltip();
	                  }
	                })
	              );
	            }
	
	            function unregisterObservers() {
	              if (observers.length) {
	                angular.forEach(observers, function(observer) {
	                  observer();
	                });
	                observers.length = 0;
	              }
	            }
	
	            // hide tooltips/popovers for outsideClick trigger
	            function bodyHideTooltipBind(e) {
	              if (!ttScope || !ttScope.isOpen || !tooltip) {
	                return;
	              }
	              // make sure the tooltip/popover link or tool tooltip/popover itself were not clicked
	              if (!element[0].contains(e.target) && !tooltip[0].contains(e.target)) {
	                hideTooltipBind();
	              }
	            }
	
	            // KeyboardEvent handler to hide the tooltip on Escape key press
	            function hideOnEscapeKey(e) {
	              if (e.which === 27) {
	                hideTooltipBind();
	              }
	            }
	
	            var unregisterTriggers = function() {
	              triggers.show.forEach(function(trigger) {
	                if (trigger === 'outsideClick') {
	                  element.off('click', toggleTooltipBind);
	                } else {
	                  element.off(trigger, showTooltipBind);
	                  element.off(trigger, toggleTooltipBind);
	                }
	                element.off('keypress', hideOnEscapeKey);
	              });
	              triggers.hide.forEach(function(trigger) {
	                if (trigger === 'outsideClick') {
	                  $document.off('click', bodyHideTooltipBind);
	                } else {
	                  element.off(trigger, hideTooltipBind);
	                }
	              });
	            };
	
	            function prepTriggers() {
	              var showTriggers = [], hideTriggers = [];
	              var val = scope.$eval(attrs[prefix + 'Trigger']);
	              unregisterTriggers();
	
	              if (angular.isObject(val)) {
	                Object.keys(val).forEach(function(key) {
	                  showTriggers.push(key);
	                  hideTriggers.push(val[key]);
	                });
	                triggers = {
	                  show: showTriggers,
	                  hide: hideTriggers
	                };
	              } else {
	                triggers = getTriggers(val);
	              }
	
	              if (triggers.show !== 'none') {
	                triggers.show.forEach(function(trigger, idx) {
	                  if (trigger === 'outsideClick') {
	                    element.on('click', toggleTooltipBind);
	                    $document.on('click', bodyHideTooltipBind);
	                  } else if (trigger === triggers.hide[idx]) {
	                    element.on(trigger, toggleTooltipBind);
	                  } else if (trigger) {
	                    element.on(trigger, showTooltipBind);
	                    element.on(triggers.hide[idx], hideTooltipBind);
	                  }
	                  element.on('keypress', hideOnEscapeKey);
	                });
	              }
	            }
	
	            prepTriggers();
	
	            var animation = scope.$eval(attrs[prefix + 'Animation']);
	            ttScope.animation = angular.isDefined(animation) ? !!animation : options.animation;
	
	            var appendToBodyVal;
	            var appendKey = prefix + 'AppendToBody';
	            if (appendKey in attrs && attrs[appendKey] === undefined) {
	              appendToBodyVal = true;
	            } else {
	              appendToBodyVal = scope.$eval(attrs[appendKey]);
	            }
	
	            appendToBody = angular.isDefined(appendToBodyVal) ? appendToBodyVal : appendToBody;
	
	            // Make sure tooltip is destroyed and removed.
	            scope.$on('$destroy', function onDestroyTooltip() {
	              unregisterTriggers();
	              removeTooltip();
	              ttScope = null;
	            });
	          };
	        }
	      };
	    };
	  }];
	})
	
	// This is mostly ngInclude code but with a custom scope
	.directive('uibTooltipTemplateTransclude', [
	         '$animate', '$sce', '$compile', '$templateRequest',
	function ($animate, $sce, $compile, $templateRequest) {
	  return {
	    link: function(scope, elem, attrs) {
	      var origScope = scope.$eval(attrs.tooltipTemplateTranscludeScope);
	
	      var changeCounter = 0,
	        currentScope,
	        previousElement,
	        currentElement;
	
	      var cleanupLastIncludeContent = function() {
	        if (previousElement) {
	          previousElement.remove();
	          previousElement = null;
	        }
	
	        if (currentScope) {
	          currentScope.$destroy();
	          currentScope = null;
	        }
	
	        if (currentElement) {
	          $animate.leave(currentElement).then(function() {
	            previousElement = null;
	          });
	          previousElement = currentElement;
	          currentElement = null;
	        }
	      };
	
	      scope.$watch($sce.parseAsResourceUrl(attrs.uibTooltipTemplateTransclude), function(src) {
	        var thisChangeId = ++changeCounter;
	
	        if (src) {
	          //set the 2nd param to true to ignore the template request error so that the inner
	          //contents and scope can be cleaned up.
	          $templateRequest(src, true).then(function(response) {
	            if (thisChangeId !== changeCounter) { return; }
	            var newScope = origScope.$new();
	            var template = response;
	
	            var clone = $compile(template)(newScope, function(clone) {
	              cleanupLastIncludeContent();
	              $animate.enter(clone, elem);
	            });
	
	            currentScope = newScope;
	            currentElement = clone;
	
	            currentScope.$emit('$includeContentLoaded', src);
	          }, function() {
	            if (thisChangeId === changeCounter) {
	              cleanupLastIncludeContent();
	              scope.$emit('$includeContentError', src);
	            }
	          });
	          scope.$emit('$includeContentRequested', src);
	        } else {
	          cleanupLastIncludeContent();
	        }
	      });
	
	      scope.$on('$destroy', cleanupLastIncludeContent);
	    }
	  };
	}])
	
	/**
	 * Note that it's intentional that these classes are *not* applied through $animate.
	 * They must not be animated as they're expected to be present on the tooltip on
	 * initialization.
	 */
	.directive('uibTooltipClasses', ['$uibPosition', function($uibPosition) {
	  return {
	    restrict: 'A',
	    link: function(scope, element, attrs) {
	      // need to set the primary position so the
	      // arrow has space during position measure.
	      // tooltip.positionTooltip()
	      if (scope.placement) {
	        // // There are no top-left etc... classes
	        // // in TWBS, so we need the primary position.
	        var position = $uibPosition.parsePlacement(scope.placement);
	        element.addClass(position[0]);
	      }
	
	      if (scope.popupClass) {
	        element.addClass(scope.popupClass);
	      }
	
	      if (scope.animation) {
	        element.addClass(attrs.tooltipAnimationClass);
	      }
	    }
	  };
	}])
	
	.directive('uibTooltipPopup', function() {
	  return {
	    restrict: 'A',
	    scope: { content: '@' },
	    templateUrl: 'uib/template/tooltip/tooltip-popup.html'
	  };
	})
	
	.directive('uibTooltip', [ '$uibTooltip', function($uibTooltip) {
	  return $uibTooltip('uibTooltip', 'tooltip', 'mouseenter');
	}])
	
	.directive('uibTooltipTemplatePopup', function() {
	  return {
	    restrict: 'A',
	    scope: { contentExp: '&', originScope: '&' },
	    templateUrl: 'uib/template/tooltip/tooltip-template-popup.html'
	  };
	})
	
	.directive('uibTooltipTemplate', ['$uibTooltip', function($uibTooltip) {
	  return $uibTooltip('uibTooltipTemplate', 'tooltip', 'mouseenter', {
	    useContentExp: true
	  });
	}])
	
	.directive('uibTooltipHtmlPopup', function() {
	  return {
	    restrict: 'A',
	    scope: { contentExp: '&' },
	    templateUrl: 'uib/template/tooltip/tooltip-html-popup.html'
	  };
	})
	
	.directive('uibTooltipHtml', ['$uibTooltip', function($uibTooltip) {
	  return $uibTooltip('uibTooltipHtml', 'tooltip', 'mouseenter', {
	    useContentExp: true
	  });
	}]);


/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _navbarControllerJs = __webpack_require__(184);
	
	var _navbarHtml = __webpack_require__(185);
	
	var _navbarHtml2 = _interopRequireDefault(_navbarHtml);
	
	var NavbarComponent = {
	    restrict: 'E',
	    templateUrl: _navbarHtml2['default'],
	    controller: _navbarControllerJs.NavbarController,
	    controllerAs: 'vm',
	    replace: true
	};
	
	exports.NavbarComponent = NavbarComponent;

/***/ },
/* 184 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var NavbarController = function NavbarController($rootScope, $location, AppConfiguration) {
	    _classCallCheck(this, NavbarController);
	
	    var conf = AppConfiguration();
	    this.$rootScope = $rootScope;
	    this.menu = conf.menu().children();
	    this.appTitle = conf.title();
	    this.path = '#' + $location.path();
	};
	
	NavbarController.$inject = ['$rootScope', '$location', 'AppConfiguration'];
	
	exports.NavbarController = NavbarController;

/***/ },
/* 185 */
/***/ function(module, exports) {

	var path = 'app/components/common/navbar/navbar.html';
	var html = "<div id=\"navigation\"><profile-picture></profile-picture><div class=\"p-xs\"><a ui-sref=\"radniNalog.create\" uib-tooltip=\"Novi nalog\" class=\"btn btn-lg btn-info btn-circle\" style=\"padding: 15px\" type=\"button\" tooltip-placement=\"bottom\"><i class=\"fa fa-plus\"></i></a> <a href=\"api/radni_nalozi/radniNalozi/0/ispis\" target=\"_blank\" uib-tooltip=\"Ispis praznog naloga\" class=\"btn btn-lg btn-primary btn-circle\" style=\"padding: 15px\" type=\"button\" data-toggle=\"tooltip\" tooltip-placement=\"bottom\"><i class=\"fa fa-file\"></i></a></div><ul side-navigation class=\"nav metismenu\" id=\"side-menu\"><li ng-repeat=\"(key, menu) in ::vm.menu\" ng-class=\"{active: menu.isChildActive(vm.path)}\"><a ng-if=\"::menu.hasChild()\"><span compile=\"::menu.icon()\"></span> <span class=\"nav-label\">{{ menu.title()}}</span><span class=\"fa arrow\"></span></a> <a ng-if=\"::!menu.hasChild()\" href=\"{{menu.link()}}\"><span compile=\"::menu.icon()\"></span> <span class=\"nav-label\">{{ menu.title()}}</span></a><ul ng-if=\"::menu.hasChild()\" class=\"nav nav-second-level collapse\" ng-class=\"{in: menu.isChildActive(vm.path)}\"><li ng-repeat=\"menu in ::menu.children()\" ng-class=\"{active: menu.isActive(vm.path)}\"><a href=\"{{menu.link()}}\">{{menu.title()}}</a></li></ul></li></ul></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _jquery = __webpack_require__(80);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _profilePictureHtml = __webpack_require__(187);
	
	var _profilePictureHtml2 = _interopRequireDefault(_profilePictureHtml);
	
	var ProfilePictureController = (function () {
	    function ProfilePictureController($rootScope, messaging) {
	        _classCallCheck(this, ProfilePictureController);
	
	        this.messaging = function () {
	            return messaging;
	        };
	        this.user = $rootScope.user;
	    }
	
	    _createClass(ProfilePictureController, [{
	        key: 'activateNotification',
	        value: function activateNotification() {
	            var messaging = this.messaging();
	            messaging.requestPermission();
	        }
	    }, {
	        key: 'updateServiceWorker',
	        value: function updateServiceWorker() {
	            var e = _jquery2['default'].Event('update-sw');
	            (0, _jquery2['default'])('body').trigger(e);
	        }
	    }]);
	
	    return ProfilePictureController;
	})();
	
	ProfilePictureController.$inject = ['$rootScope', 'messaging'];
	
	var ProfilePictureComponent = {
	    restrict: 'E',
	    templateUrl: _profilePictureHtml2['default'],
	    controller: ProfilePictureController,
	    controllerAs: 'vm'
	};
	
	exports.ProfilePictureComponent = ProfilePictureComponent;

/***/ },
/* 187 */
/***/ function(module, exports) {

	var path = 'app/components/common/navbar/profilePicture.html';
	var html = "<div class=\"profile-picture\"><a href=\"index.html\"><i class=\"fa fa-user-md fa-4x\"></i></a><div class=\"stats-label text-color\"><span class=\"font-extra-bold font-uppercase\">DentalLAB</span><div class=\"dropdown\"><a class=\"dropdown-toggle\" href=\"#\" data-toggle=\"dropdown\"><small class=\"text-muted\">{{vm.user.username}} <b class=\"caret\"></b></small></a><ul class=\"dropdown-menu animated fadeInRight m-t-xs\"><li><a ui-sref=\"login\">Odjava</a></li><li><a ng-click=\"vm.activateNotification()\">Notificiraj me na ovoj lokaciji</a></li><li><a ng-click=\"vm.updateServiceWorker()\">Update SW</a></li></ul></div></div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _jquery = __webpack_require__(80);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(189);
	
	function SideNavigation($timeout) {
	    return {
	        restrict: 'A',
	        link: function link(scope, element) {
	            // Call the metsiMenu plugin and plug it to sidebar navigation
	            $timeout(function () {
	                (0, _jquery2['default'])(element).metisMenu();
	            });
	        }
	    };
	};
	
	SideNavigation.$inject = ['$timeout'];
	
	exports.SideNavigation = SideNavigation;

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	 * metismenu - v2.4.3
	 * A jQuery menu plugin
	 * https://github.com/onokumus/metisMenu#readme
	 *
	 * Made by Osman Nuri Okumuş <onokumus@gmail.com> (https://github.com/onokumus)
	 * Under MIT License
	 */
	
	(function(root, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(80)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    module.exports = factory(require('jquery'));
	  } else {
	    root.sortable = factory(root.jQuery);
	  }
	}(this, function($) {
	  'use strict';
	
	  function transitionEnd() {
	    var el = document.createElement('mm');
	
	    var transEndEventNames = {
	      WebkitTransition: 'webkitTransitionEnd',
	      MozTransition: 'transitionend',
	      OTransition: 'oTransitionEnd otransitionend',
	      transition: 'transitionend'
	    };
	
	    for (var name in transEndEventNames) {
	      if (el.style[name] !== undefined) {
	        return {
	          end: transEndEventNames[name]
	        };
	      }
	    }
	    return false;
	  }
	
	  $.fn.emulateTransitionEnd = function(duration) {
	    var called = false;
	    var $el = this;
	    $(this).one('mmTransitionEnd', function() {
	      called = true;
	    });
	    var callback = function() {
	      if (!called) {
	        $($el).trigger($transition.end);
	      }
	    };
	    setTimeout(callback, duration);
	    return this;
	  };
	
	  var $transition = transitionEnd();
	  if (!!$transition) {
	    $.event.special.mmTransitionEnd = {
	      bindType: $transition.end,
	      delegateType: $transition.end,
	      handle: function(e) {
	        if ($(e.target).is(this)) {
	          return e.
	          handleObj.
	          handler.
	          apply(this, arguments);
	        }
	      }
	    };
	  }
	
	  var MetisMenu = function(element, options) {
	    this.$element = $(element);
	    this.options = $.extend({}, MetisMenu.DEFAULTS, options);
	    this.transitioning = null;
	
	    this.init();
	  };
	
	  MetisMenu.TRANSITION_DURATION = 350;
	
	  MetisMenu.DEFAULTS = {
	    toggle: true,
	    doubleTapToGo: false,
	    preventDefault: true,
	    activeClass: 'active',
	    collapseClass: 'collapse',
	    collapseInClass: 'in',
	    collapsingClass: 'collapsing',
	    onTransitionStart: false,
	    onTransitionEnd: false
	  };
	
	  MetisMenu.prototype.init = function() {
	    var $this = this;
	    var activeClass = this.options.activeClass;
	    var collapseClass = this.options.collapseClass;
	    var collapseInClass = this.options.collapseInClass;
	
	    this
	      .$element
	      .find('li.' + activeClass)
	      .has('ul')
	      .children('ul')
	      .attr('aria-expanded', true)
	      .addClass(collapseClass + ' ' + collapseInClass);
	
	    this
	      .$element
	      .find('li')
	      .not('.' + activeClass)
	      .has('ul')
	      .children('ul')
	      .attr('aria-expanded', false)
	      .addClass(collapseClass);
	
	    //add the 'doubleTapToGo' class to active items if needed
	    if (this.options.doubleTapToGo) {
	      this
	        .$element
	        .find('li.' + activeClass)
	        .has('ul')
	        .children('a')
	        .addClass('doubleTapToGo');
	    }
	
	    this
	      .$element
	      .find('li')
	      .has('ul')
	      .children('a')
	      .on('click.metisMenu', function(e) {
	        var self = $(this);
	        var $parent = self.parent('li');
	        var $list = $parent.children('ul');
	        if($this.options.preventDefault){
	          e.preventDefault();
	        }
	        if(self.attr('aria-disabled') === 'true'){
	            return;
	        }
	        if ($parent.hasClass(activeClass) && !$this.options.doubleTapToGo) {
	          $this.hide($list);
	          self.attr('aria-expanded',false);
	        } else {
	          $this.show($list);
	          self.attr('aria-expanded',true);
	        }
	
	        if($this.options.onTransitionStart) {
	          $this.options.onTransitionStart(e);
	        }
	
	        //Do we need to enable the double tap
	        if ($this.options.doubleTapToGo) {
	          //if we hit a second time on the link and the href is valid, navigate to that url
	          if ($this.doubleTapToGo(self) && self.attr('href') !== '#' && self.attr('href') !== '') {
	            e.stopPropagation();
	            document.location = self.attr('href');
	            return;
	          }
	        }
	      });
	  };
	
	  MetisMenu.prototype.doubleTapToGo = function(elem) {
	    var $this = this.$element;
	    //if the class 'doubleTapToGo' exists, remove it and return
	    if (elem.hasClass('doubleTapToGo')) {
	      elem.removeClass('doubleTapToGo');
	      return true;
	    }
	    //does not exists, add a new class and return false
	    if (elem.parent().children('ul').length) {
	      //first remove all other class
	      $this
	        .find('.doubleTapToGo')
	        .removeClass('doubleTapToGo');
	      //add the class on the current element
	      elem.addClass('doubleTapToGo');
	      return false;
	    }
	  };
	
	  MetisMenu.prototype.show = function(el) {
	    var activeClass = this.options.activeClass;
	    var collapseClass = this.options.collapseClass;
	    var collapseInClass = this.options.collapseInClass;
	    var collapsingClass = this.options.collapsingClass;
	    var $this = $(el);
	    var $parent = $this.parent('li');
	    if (this.transitioning || $this.hasClass(collapseInClass)) {
	      return;
	    }
	
	    $parent.addClass(activeClass);
	
	    if (this.options.toggle) {
	      this.hide($parent.siblings().children('ul.' + collapseInClass).attr('aria-expanded', false));
	    }
	
	    $this
	      .removeClass(collapseClass)
	      .addClass(collapsingClass)
	      .height(0);
	
	    this.transitioning = 1;
	    var complete = function() {
	      if(this.transitioning && this.options.onTransitionEnd) {
	        this.options.onTransitionEnd();
	      }
	      $this
	        .removeClass(collapsingClass)
	        .addClass(collapseClass + ' ' + collapseInClass)
	        .height('')
	        .attr('aria-expanded', true);
	      this.transitioning = 0;
	    };
	    if (!$transition) {
	      return complete.call(this);
	    }
	    $this
	      .one('mmTransitionEnd', $.proxy(complete, this))
	      .emulateTransitionEnd(MetisMenu.TRANSITION_DURATION)
	      .height($this[0].scrollHeight);
	  };
	
	  MetisMenu.prototype.hide = function(el) {
	    var activeClass = this.options.activeClass;
	    var collapseClass = this.options.collapseClass;
	    var collapseInClass = this.options.collapseInClass;
	    var collapsingClass = this.options.collapsingClass;
	    var $this = $(el);
	
	    if (this.transitioning || !$this.hasClass(collapseInClass)) {
	      return;
	    }
	
	    $this.parent('li').removeClass(activeClass);
	    $this.height($this.height())[0].offsetHeight;
	
	    $this
	      .addClass(collapsingClass)
	      .removeClass(collapseClass)
	      .removeClass(collapseInClass);
	
	    this.transitioning = 1;
	
	    var complete = function() {
	      if(this.transitioning && this.options.onTransitionEnd) {
	        this.options.onTransitionEnd();
	      }
	      this.transitioning = 0;
	      $this
	        .removeClass(collapsingClass)
	        .addClass(collapseClass)
	        .attr('aria-expanded', false);
	    };
	
	    if (!$transition) {
	      return complete.call(this);
	    }
	    $this
	      .height(0)
	      .one('mmTransitionEnd', $.proxy(complete, this))
	      .emulateTransitionEnd(MetisMenu.TRANSITION_DURATION);
	  };
	
	  function Plugin(option) {
	    return this.each(function() {
	      var $this = $(this);
	      var data = $this.data('mm');
	      var options = $.extend({},
	        MetisMenu.DEFAULTS,
	        $this.data(),
	        typeof option === 'object' && option
	      );
	
	      if (!data) {
	        $this.data('mm', (data = new MetisMenu(this, options)));
	      }
	      if (typeof option === 'string') {
	        data[option]();
	      }
	    });
	  }
	
	  var old = $.fn.metisMenu;
	
	  $.fn.metisMenu = Plugin;
	  $.fn.metisMenu.Constructor = MetisMenu;
	
	  $.fn.metisMenu.noConflict = function() {
	    $.fn.metisMenu = old;
	    return this;
	  };
	}));


/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _navbarTopComponentJs = __webpack_require__(191);
	
	var navbarTop = _angular2['default'].module('navbartop', []);
	
	navbarTop.component('navbarTop', _navbarTopComponentJs.NavbarTopComponent);
	
	exports.navbarTop = navbarTop;

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _navbarTopHtml = __webpack_require__(192);
	
	var _navbarTopHtml2 = _interopRequireDefault(_navbarTopHtml);
	
	var _navbarTopControllerJs = __webpack_require__(193);
	
	var NavbarTopComponent = {
	    restrict: 'E',
	    templateUrl: _navbarTopHtml2['default'],
	    controller: _navbarTopControllerJs.NavbarTopController,
	    controllerAs: 'vm',
	    bindings: {
	        searchCaption: '<',
	        onFilter: '&'
	    }
	};
	
	exports.NavbarTopComponent = NavbarTopComponent;

/***/ },
/* 192 */
/***/ function(module, exports) {

	var path = 'app/components/common/navbarTop/navbarTop.html';
	var html = "<nav class=\"navbar navbar-static-top\" role=\"navigation\" style=\"margin-bottom: 0\"><div class=\"navbar-header\"><a class=\"navbar-minimalize minimalize-styl-2 btn btn-primary\" href=\"#\"><i class=\"fa fa-bars\"></i></a><form role=\"search\" class=\"navbar-form-custom\" ng-submit=\"vm.submit()\"><div class=\"form-group\"><input ng-model=\"vm.searchValue\" type=\"text\" placeholder=\"{{vm.searchCaption}}\" class=\"form-control\" name=\"top-search\" id=\"top-search\"></div></form></div><ul class=\"nav navbar-top-links navbar-right\"><li><a ui-sref=\"login\"><i class=\"fa fa-sign-out\"></i> Odjava</a></li></ul></nav>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 193 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var NavbarTopController = (function () {
	    function NavbarTopController() {
	        _classCallCheck(this, NavbarTopController);
	
	        this.searchCaption = this.searchCaption || 'Pretraži';
	        this.onFilter = this.onFilter || angular.noop;
	        this.hideFilter = this.onFilter === angular.noop;
	        this.searchValue = '';
	    }
	
	    _createClass(NavbarTopController, [{
	        key: 'submit',
	        value: function submit() {
	            this.onFilter({ value: this.searchValue });
	        }
	    }]);
	
	    return NavbarTopController;
	})();
	
	exports.NavbarTopController = NavbarTopController;

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _footerComponentJs = __webpack_require__(195);
	
	var footer = _angular2['default'].module('footer', []);
	
	footer.component('footer', _footerComponentJs.FooterComponent);
	
	exports.footer = footer;

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _footerHtml = __webpack_require__(196);
	
	var _footerHtml2 = _interopRequireDefault(_footerHtml);
	
	var FooterComponent = {
	    restrict: 'E',
	    templateUrl: _footerHtml2['default']
	};
	
	exports.FooterComponent = FooterComponent;

/***/ },
/* 196 */
/***/ function(module, exports) {

	var path = 'app/components/common/footer/footer.html';
	var html = "<div class=\"footer\"><div><strong>Copyright</strong> <a href=\"http://www.invita.hr\" target=\"_blank\">InVita d.o.o.</a> &copy; 2017.</div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _headerComponentJs = __webpack_require__(198);
	
	var header = _angular2['default'].module('header', []);
	
	header.component('header', _headerComponentJs.HeaderComponent);
	
	exports.header = header;

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _lodash = __webpack_require__(165);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _headerHtml = __webpack_require__(199);
	
	var _headerHtml2 = _interopRequireDefault(_headerHtml);
	
	var HeaderController = (function () {
	    function HeaderController(messaging, $state) {
	        _classCallCheck(this, HeaderController);
	
	        this.messaging = function () {
	            return messaging;
	        };
	        this.$state = function () {
	            return $state;
	        };
	    }
	
	    _createClass(HeaderController, [{
	        key: "$onInit",
	        value: function $onInit() {
	            this.comments = [];
	            this.disableSearch = !_lodash2["default"].isString(this.searchPlaceholder);
	            this.refreshState();
	        }
	    }, {
	        key: "refreshState",
	        value: function refreshState() {
	            var _this = this;
	
	            var messaging = this.messaging();
	            messaging.getComments().then(function (response) {
	                _this.comments = [].concat(_toConsumableArray(response));
	            });
	        }
	    }, {
	        key: "showComment",
	        value: function showComment(comment) {
	            var messaging = this.messaging();
	            var $state = this.$state();
	            messaging.updateComment(comment).then(function () {
	                $state.go("radniNalog.details", {
	                    id: comment.radni_nalog
	                });
	            });
	        }
	    }, {
	        key: "submit",
	        value: function submit() {
	            this.onSearch({ value: this.term });
	        }
	    }]);
	
	    return HeaderController;
	})();
	
	HeaderController.$inject = ["messaging", "$state"];
	
	var HeaderComponent = {
	    restrict: "E",
	    templateUrl: _headerHtml2["default"],
	    controller: HeaderController,
	    controllerAs: "vm",
	    bindings: {
	        onSearch: "&",
	        searchPlaceholder: "@",
	        term: "<"
	    }
	};
	
	exports.HeaderComponent = HeaderComponent;

/***/ },
/* 199 */
/***/ function(module, exports) {

	var path = 'app/components/common/header/header.html';
	var html = "<div class=\"color-line\"></div><div id=\"logo\" class=\"light-version\"><span><i class=\"fa fa-user\"></i> Aktivni korisnik</span></div><nav role=\"navigation\"><minimaliza-menu></minimaliza-menu><div class=\"small-logo\"><span class=\"text-primary\">DENTAL LAB</span></div><form role=\"search\" class=\"navbar-form-custom\" ng-submit=\"vm.submit()\"><div class=\"form-group\"><input type=\"text\" ng-model=\"vm.term\" placeholder=\"{{vm.searchPlaceholder}}\" class=\"form-control\" name=\"search\" ng-disabled=\"vm.disableSearch\"></div></form><div class=\"mobile-menu\"><button type=\"button\" class=\"navbar-toggle mobile-menu-toggle\" data-toggle=\"collapse\" data-target=\"#mobile-collapse\"><i class=\"fa fa-chevron-down\"></i></button><div class=\"collapse mobile-navbar\" id=\"mobile-collapse\"><ul class=\"nav navbar-nav\"><li><a href=\"#\">Login</a></li></ul></div></div><div class=\"navbar-right\"><ul class=\"nav navbar-nav no-borders\"><li class=\"dropdown\"><a class=\"dropdown-toggle label-menu-corner\" data-toggle=\"dropdown\"><i class=\"pe-7s-note2\"></i> <span class=\"label label-success\">{{vm.comments.length}}</span></a><ul class=\"dropdown-menu hdropdown notification animated flipInX\"><li ng-repeat=\"item in vm.comments\"><a ng-click=\"vm.showComment(item)\">Nalog: &nbsp; <span class=\"label label-success\">{{item.sifra_naloga}}</span> - {{item.sender}} - {{item.poruka}}</a></li><li class=\"summary\"><h5 ng-if=\"vm.comments.length > 0\">{{vm.comments.length}} nove poruke</h5><h5 ng-if=\"vm.comments.length === 0\">Nemate novih poruka</h5></li></ul></li><li class=\"dropdown\"><a ui-sref=\"login\"><i class=\"pe-7s-upload pe-rotate-90\"></i></a></li></ul></div></nav>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	// import jQuery from 'jQuery';
	
	/**
	 * HOMER - Responsive Admin Theme
	 * Copyright 2015 Webapplayers.com
	 *
	 */
	
	/**
	 * pageTitle - Directive for set Page title - mata title
	 */
	function pageTitle($rootScope, $timeout) {
	    return {
	        link: function link(scope, element) {
	            var listener = function listener(event, toState, toParams, fromState, fromParams) {
	                // Default title
	                var title = 'HOMER | AngularJS Responsive WebApp';
	                // Create your own title pattern
	                if (toState.data && toState.data.pageTitle) title = 'HOMER | ' + toState.data.pageTitle;
	                $timeout(function () {
	                    element.text(title);
	                });
	            };
	            $rootScope.$on('$stateChangeStart', listener);
	        }
	    };
	}
	pageTitle.$inject = ['$rootScope', '$timeout'];
	
	// /**
	//  * sideNavigation - Directive for run metsiMenu on sidebar navigation
	//  */
	// function sideNavigation($timeout) {
	//     return {
	//         restrict: 'A',
	//         link: function(scope, element) {
	//             // Call the metsiMenu plugin and plug it to sidebar navigation
	//             element.metisMenu();
	
	//             // Colapse menu in mobile mode after click on element
	//             var menuElement = $('#side-menu a:not([href$="\\#"])');
	//             menuElement.click(function(){
	
	//                 if ($(window).width() < 769) {
	//                     $("body").toggleClass("show-sidebar");
	//                 }
	//             });
	
	//         }
	//     };
	// };
	
	/**
	 * minimalizaSidebar - Directive for minimalize sidebar
	 */
	function minimalizaMenu($rootScope) {
	    return {
	        restrict: 'EA',
	        template: '<div class="header-link hide-menu" ng-click="minimalize()"><i class="fa fa-bars"></i></div>',
	        controller: ['$scope', function ($scope) {
	            $scope.minimalize = function () {
	                if ($(window).width() < 769) {
	                    $('body').toggleClass('show-sidebar');
	                } else {
	                    $('body').toggleClass('hide-sidebar');
	                }
	            };
	        }]
	    };
	}
	minimalizaMenu.$inject = ['$rootScope'];
	
	/**
	 * sparkline - Directive for Sparkline chart
	 */
	function sparkline() {
	    return {
	        restrict: 'A',
	        scope: {
	            sparkData: '=',
	            sparkOptions: '='
	        },
	        link: function link(scope, element, attrs) {
	            scope.$watch(scope.sparkData, function () {
	                render();
	            });
	            scope.$watch(scope.sparkOptions, function () {
	                render();
	            });
	            var render = function render() {
	                $(element).sparkline(scope.sparkData, scope.sparkOptions);
	            };
	        }
	    };
	}
	
	/**
	 * icheck - Directive for custom checkbox icheck
	 */
	function icheck($timeout) {
	    return {
	        restrict: 'A',
	        require: 'ngModel',
	        link: function link($scope, element, $attrs, ngModel) {
	            return $timeout(function () {
	                var value;
	                value = $attrs['value'];
	
	                $scope.$watch($attrs['ngModel'], function (newValue) {
	                    $(element).iCheck('update');
	                });
	
	                return $(element).iCheck({
	                    checkboxClass: 'icheckbox_square-green',
	                    radioClass: 'iradio_square-green'
	                }).on('ifChanged', function (event) {
	                    if ($(element).attr('type') === 'checkbox' && $attrs['ngModel']) {
	                        $scope.$apply(function () {
	                            return ngModel.$setViewValue(event.target.checked);
	                        });
	                    }
	                    if ($(element).attr('type') === 'radio' && $attrs['ngModel']) {
	                        return $scope.$apply(function () {
	                            return ngModel.$setViewValue(value);
	                        });
	                    }
	                });
	            });
	        }
	    };
	}
	icheck.$inject = ['$timeout'];
	
	/**
	 * panelTools - Directive for panel tools elements in right corner of panel
	 */
	function panelTools($timeout) {
	    return {
	        restrict: 'A',
	        scope: true,
	        templateUrl: 'views/common/panel_tools.html',
	        controller: ['$scope', '$element', function ($scope, $element) {
	            // Function for collapse ibox
	            $scope.showhide = function () {
	                var hpanel = $element.closest('div.hpanel');
	                var icon = $element.find('i:first');
	                var body = hpanel.find('div.panel-body');
	                var footer = hpanel.find('div.panel-footer');
	                body.slideToggle(300);
	                footer.slideToggle(200);
	                // Toggle icon from up to down
	                icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
	                hpanel.toggleClass('').toggleClass('panel-collapse');
	                $timeout(function () {
	                    hpanel.resize();
	                    hpanel.find('[id^=map-]').resize();
	                }, 50);
	            },
	            // Function for close ibox
	            $scope.closebox = function () {
	                var hpanel = $element.closest('div.hpanel');
	                hpanel.remove();
	            };
	        }]
	    };
	}
	panelTools.$inject = ['$timeout'];
	
	/**
	 * panelToolsFullscreen - Directive for panel tools elements in right corner of panel with fullscreen option
	 */
	function panelToolsFullscreen($timeout) {
	    return {
	        restrict: 'A',
	        scope: true,
	        templateUrl: 'views/common/panel_tools_fullscreen.html',
	        controller: ['$scope', '$element', function ($scope, $element) {
	            // Function for collapse ibox
	            $scope.showhide = function () {
	                var hpanel = $element.closest('div.hpanel');
	                var icon = $element.find('i:first');
	                var body = hpanel.find('div.panel-body');
	                var footer = hpanel.find('div.panel-footer');
	                body.slideToggle(300);
	                footer.slideToggle(200);
	                // Toggle icon from up to down
	                icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
	                hpanel.toggleClass('').toggleClass('panel-collapse');
	                $timeout(function () {
	                    hpanel.resize();
	                    hpanel.find('[id^=map-]').resize();
	                }, 50);
	            };
	
	            // Function for close ibox
	            $scope.closebox = function () {
	                var hpanel = $element.closest('div.hpanel');
	                hpanel.remove();
	                if ($('body').hasClass('fullscreen-panel-mode')) {
	                    $('body').removeClass('fullscreen-panel-mode');
	                }
	            };
	
	            // Function for fullscreen
	            $scope.fullscreen = function () {
	                var hpanel = $element.closest('div.hpanel');
	                var icon = $element.find('i:first');
	                $('body').toggleClass('fullscreen-panel-mode');
	                icon.toggleClass('fa-expand').toggleClass('fa-compress');
	                hpanel.toggleClass('fullscreen');
	                setTimeout(function () {
	                    $(window).trigger('resize');
	                }, 100);
	            };
	        }]
	    };
	}
	panelToolsFullscreen.$inject = ['$timeout'];
	
	/**
	 * smallHeader - Directive for page title panel
	 */
	function smallHeader() {
	    return {
	        restrict: 'A',
	        scope: true,
	        controller: ['$scope', '$element', function ($scope, $element) {
	            $scope.small = function () {
	                var icon = $element.find('i:first');
	                var breadcrumb = $element.find('#hbreadcrumb');
	                $element.toggleClass('small-header');
	                breadcrumb.toggleClass('m-t-lg');
	                icon.toggleClass('fa-arrow-up').toggleClass('fa-arrow-down');
	            };
	        }]
	    };
	}
	
	function animatePanel($timeout, $state) {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            //Set defaul values for start animation and delay
	            var panel;
	            var startAnimation = 0;
	            var delay = 0.06; // secunds
	            var start = Math.abs(delay) + startAnimation;
	
	            // Store current state where directive was start
	            var currentState = $state.current.name;
	
	            // Set default values for attrs
	            if (!attrs.effect) {
	                attrs.effect = 'zoomIn';
	            }
	            if (attrs.delay) {
	                delay = attrs.delay / 10;
	            } else {
	                delay = 0.06;
	            }
	            if (!attrs.child) {
	                attrs.child = '.row > div';
	            } else {
	                attrs.child = '.' + attrs.child;
	            }
	            // Get all element and set opactiy to 0
	            element.addClass('opacity-0');
	
	            // Wrap to $timeout to execute after ng-repeat
	            $timeout(function () {
	                // Get all elements and add effect class
	                panel = element.find(attrs.child);
	                panel.addClass('opacity-0').addClass('stagger').addClass('animated-panel').addClass(attrs.effect);
	
	                // show main element
	                element.removeClass('opacity-0');
	
	                var panelsCount = panel.length + 10;
	                var animateTime = panelsCount * delay * 10000 / 10;
	
	                // Add delay for each child elements
	                panel.each(function (i, elm) {
	                    start += delay;
	                    var rounded = Math.round(start * 10) / 10;
	                    $(elm).css('animation-delay', rounded + 's');
	                    // Remove opacity 0 after finish
	                    $(elm).removeClass('opacity-0');
	                });
	
	                // Clear animation after finish
	                $timeout(function () {
	                    // $('.stagger').css('animation', '');
	                    // $('.stagger').removeClass(attrs.effect).removeClass('animated-panel').removeClass('stagger');
	                    panel.css('animation', '');
	                    panel.removeClass(attrs.effect).removeClass('animated-panel').removeClass('stagger');
	                    panel.resize();
	                }, animateTime);
	            });
	        }
	    };
	}
	animatePanel.$inject = ['$timeout', '$state'];
	
	function landingScrollspy() {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            element.scrollspy({
	                target: '.navbar-fixed-top',
	                offset: 80
	            });
	        }
	    };
	}
	
	/**
	 * clockPicker - Directive for clock picker plugin
	 */
	function clockPicker() {
	    return {
	        restrict: 'A',
	        link: function link(scope, element) {
	            element.clockpicker();
	        }
	    };
	}
	
	function dateTimePicker() {
	    return {
	        require: '?ngModel',
	        restrict: 'AE',
	        scope: {
	            pick12HourFormat: '@',
	            language: '@',
	            useCurrent: '@',
	            location: '@'
	        },
	        link: function link(scope, elem, attrs) {
	            elem.datetimepicker({
	                pick12HourFormat: scope.pick12HourFormat,
	                language: scope.language,
	                useCurrent: scope.useCurrent
	            });
	
	            //Local event change
	            elem.on('blur', function () {
	                // For test
	                //console.info('this', this);
	                //console.info('scope', scope);
	                //console.info('attrs', attrs);
	                /*// returns moments.js format object
	                 scope.dateTime = new Date(elem.data("DateTimePicker").getDate().format());
	                 // Global change propagation
	                 $rootScope.$broadcast("emit:dateTimePicker", {
	                 location: scope.location,
	                 action: 'changed',
	                 dateTime: scope.dateTime,
	                 example: scope.useCurrent
	                 });
	                 scope.$apply();*/
	            });
	        }
	    };
	}
	
	var homer = angular.module('homer', []);
	
	homer.directive('pageTitle', pageTitle)
	// .directive('sideNavigation', sideNavigation)
	.directive('minimalizaMenu', minimalizaMenu).directive('sparkline', sparkline).directive('icheck', icheck).directive('panelTools', panelTools).directive('panelToolsFullscreen', panelToolsFullscreen).directive('smallHeader', smallHeader).directive('animatePanel', animatePanel).directive('landingScrollspy', landingScrollspy).directive('clockPicker', clockPicker).directive('dateTimePicker', dateTimePicker);
	
	exports.homer = homer;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(80)))

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	__webpack_require__(202);
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularFormly = __webpack_require__(204);
	
	var _angularFormly2 = _interopRequireDefault(_angularFormly);
	
	// import formlyBootstrap from './formly-bootstrap';
	
	var _angularFormlyTemplatesBootstrap = __webpack_require__(206);
	
	var _angularFormlyTemplatesBootstrap2 = _interopRequireDefault(_angularFormlyTemplatesBootstrap);
	
	var _angularSanitize = __webpack_require__(207);
	
	var _angularSanitize2 = _interopRequireDefault(_angularSanitize);
	
	var _angularMessages = __webpack_require__(209);
	
	var _angularMessages2 = _interopRequireDefault(_angularMessages);
	
	var _uiSelect = __webpack_require__(211);
	
	var _uiSelect2 = _interopRequireDefault(_uiSelect);
	
	var _angularUiMask = __webpack_require__(213);
	
	var _angularUiMask2 = _interopRequireDefault(_angularUiMask);
	
	var _datemaskJs = __webpack_require__(215);
	
	// templates
	
	var _templatesFieldsetHtml = __webpack_require__(315);
	
	var _templatesFieldsetHtml2 = _interopRequireDefault(_templatesFieldsetHtml);
	
	var _templatesRowHtml = __webpack_require__(316);
	
	var _templatesRowHtml2 = _interopRequireDefault(_templatesRowHtml);
	
	var _templatesDivHtml = __webpack_require__(317);
	
	var _templatesDivHtml2 = _interopRequireDefault(_templatesDivHtml);
	
	var _templatesHorizontalLabelHtml = __webpack_require__(318);
	
	var _templatesHorizontalLabelHtml2 = _interopRequireDefault(_templatesHorizontalLabelHtml);
	
	var _templatesHorizontalCheckboxHtml = __webpack_require__(319);
	
	var _templatesHorizontalCheckboxHtml2 = _interopRequireDefault(_templatesHorizontalCheckboxHtml);
	
	var _templatesValidationHtml = __webpack_require__(320);
	
	var _templatesValidationHtml2 = _interopRequireDefault(_templatesValidationHtml);
	
	var _templatesErrorMessagesHtml = __webpack_require__(321);
	
	var _templatesErrorMessagesHtml2 = _interopRequireDefault(_templatesErrorMessagesHtml);
	
	var _templatesUiSelectHtml = __webpack_require__(322);
	
	var _templatesUiSelectHtml2 = _interopRequireDefault(_templatesUiSelectHtml);
	
	var _templatesUiSelectAsyncHtml = __webpack_require__(323);
	
	var _templatesUiSelectAsyncHtml2 = _interopRequireDefault(_templatesUiSelectAsyncHtml);
	
	var _templatesFeedHtml = __webpack_require__(324);
	
	var _templatesFeedHtml2 = _interopRequireDefault(_templatesFeedHtml);
	
	var forms = _angular2['default'].module('forms', [_angularSanitize2['default'], _angularMessages2['default'], _angularFormly2['default'], _angularFormlyTemplatesBootstrap2['default'], _angularUiMask2['default'], _uiSelect2['default']]);
	
	function setWrappers(formlyConfig) {
	    // formlyConfig.setWrapper({
	    //     name: 'validation',
	    //     templateUrl: 'app/blocks/formly/templates/validation.html'
	    // });
	
	    formlyConfig.setWrapper({
	        name: 'row',
	        templateUrl: _templatesRowHtml2['default']
	    });
	
	    formlyConfig.setWrapper({
	        name: 'div',
	        templateUrl: _templatesDivHtml2['default']
	    });
	
	    formlyConfig.setWrapper({
	        name: 'fieldset',
	        templateUrl: _templatesFieldsetHtml2['default']
	    });
	
	    formlyConfig.setWrapper({
	        name: 'horizontalBootstrapLabel',
	        templateUrl: _templatesHorizontalLabelHtml2['default']
	    });
	
	    formlyConfig.setWrapper({
	        name: 'horizontalBootstrapCheckbox',
	        templateUrl: _templatesHorizontalCheckboxHtml2['default']
	    });
	}
	
	configFunc.$inject = ['formlyConfigProvider'];
	function configFunc(formlyConfigProvider) {
	    formlyConfigProvider.setWrapper({
	        name: 'validation',
	        types: ['input', 'hInput', 'maskedInput', 'textarea', 'select', 'typeahead', 'datepicker', 'hDatepicker', 'hSelect', 'hTextarea', 'huiSelect', 'uiSelect', 'uiSelectAsync', 'huiSelectAsync'],
	        templateUrl: _templatesValidationHtml2['default']
	    });
	}
	
	runFunc.$inject = ['formlyConfig'];
	function runFunc(formlyConfig) {
	    formlyConfig.extras.errorExistsAndShouldBeVisibleExpression = '!fc.$pristine || form.$submitted';
	
	    setWrappers(formlyConfig);
	
	    formlyConfig.setType({
	        name: 'hInput',
	        'extends': 'input',
	        wrapper: ['horizontalBootstrapLabel', 'bootstrapHasError']
	    });
	
	    formlyConfig.setType({
	        name: 'hCheckbox',
	        'extends': 'checkbox',
	        wrapper: ['horizontalBootstrapCheckbox', 'bootstrapHasError']
	    });
	
	    formlyConfig.setType({
	        name: 'hRadio',
	        'extends': 'radio',
	        wrapper: ['horizontalBootstrapLabel', 'bootstrapHasError']
	    });
	
	    formlyConfig.setType({
	        name: 'hSelect',
	        'extends': 'select',
	        wrapper: ['horizontalBootstrapLabel', 'bootstrapHasError']
	    });
	
	    formlyConfig.setType({
	        name: 'hTextarea',
	        'extends': 'textarea',
	        wrapper: ['horizontalBootstrapLabel', 'bootstrapHasError']
	    });
	
	    formlyConfig.setType({
	        name: 'typeahead',
	        'extends': 'input',
	        defaultOptions: {
	            ngModelAttrs: {
	                uibTypeahead: {
	                    attribute: 'typeahead'
	                },
	                typeaheadOnSelect: {
	                    attribute: 'typeahead-on-select'
	                },
	                typeaheadWaitMs: {
	                    attribute: 'typeahead-wait-ms'
	                },
	                typeaheadEditable: {
	                    attribute: 'typeahead-editable'
	                }
	            },
	
	            ngModelElAttrs: {
	                autocomplete: 'off'
	            }
	        }
	    });
	
	    formlyConfig.setType({
	        name: 'hTypeahead',
	        'extends': 'typeahead',
	        wrapper: ['horizontalBootstrapLabel', 'bootstrapHasError']
	    });
	
	    formlyConfig.setType({
	        name: 'maskedInput',
	        'extends': 'input',
	        defaultOptions: {
	            ngModelAttrs: {
	                mask: {
	                    attribute: 'ui-mask'
	                },
	                maskPlaceholder: {
	                    attribute: 'ui-mask-placeholder'
	                }
	            },
	            templateOptions: {
	                maskPlaceholder: ''
	            }
	        }
	    });
	
	    formlyConfig.setType({
	        name: 'datepicker',
	        'extends': 'maskedInput',
	        defaultOptions: {
	            templateOptions: {
	                maskPlaceholder: 'DD.MM.GGGG',
	                mask: '99.99.9999'
	            },
	            ngModelElAttrs: {
	                datemask: ''
	            }
	        }
	    });
	
	    formlyConfig.setType({
	        name: 'timepicker',
	        'extends': 'maskedInput',
	        defaultOptions: {
	            templateOptions: {
	                maskPlaceholder: 'HH:MM',
	                mask: '99:99'
	            },
	            ngModelElAttrs: {
	                'model-view-value': 'true'
	            }
	        }
	    });
	
	    formlyConfig.setType({
	        name: 'datetimepicker',
	        'extends': 'maskedInput',
	        defaultOptions: {
	            templateOptions: {
	                maskPlaceholder: 'DD.MM.GGGG hh:mm',
	                mask: '99.99.9999 99:99'
	            },
	            ngModelElAttrs: {
	                datemask: '',
	                format: 'datetime'
	            }
	        }
	    });
	
	    formlyConfig.setType({
	        name: 'hTimepicker',
	        'extends': 'timepicker',
	        wrapper: ['horizontalBootstrapLabel', 'bootstrapHasError']
	    });
	
	    formlyConfig.setType({
	        name: 'hDatepicker',
	        'extends': 'datepicker',
	        wrapper: ['horizontalBootstrapLabel', 'bootstrapHasError']
	    });
	
	    formlyConfig.setType({
	        name: 'hDatetimepicker',
	        'extends': 'datetimepicker',
	        wrapper: ['horizontalBootstrapLabel', 'bootstrapHasError']
	    });
	
	    formlyConfig.setType({
	        name: 'uiSelect',
	        'extends': 'select',
	        templateUrl: _templatesUiSelectHtml2['default']
	    });
	
	    formlyConfig.setType({
	        name: 'huiSelect',
	        'extends': 'uiSelect',
	        wrapper: ['horizontalBootstrapLabel', 'bootstrapHasError']
	    });
	
	    formlyConfig.setType({
	        name: 'uiSelectAsync',
	        'extends': 'select',
	        templateUrl: _templatesUiSelectAsyncHtml2['default'],
	        defaultOptions: {
	            templateOptions: {
	                optionsAttr: 'bs-options',
	                ngOptions: 'option[to.valueProp] as option in to.options',
	                options: [],
	                refreshDelay: 700
	            }
	        }
	    });
	
	    formlyConfig.setType({
	        name: 'huiSelectAsync',
	        'extends': 'uiSelectAsync',
	        wrapper: ['horizontalBootstrapLabel', 'bootstrapHasError']
	    });
	}
	
	forms.config(configFunc);
	forms.run(runFunc);
	
	forms.directive('datemask', _datemaskJs.datemask);
	
	exports.forms = forms;

/***/ },
/* 202 */
32,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	//! angular-formly-templates-bootstrap version 6.3.0 built with ♥ by Astrism <astrisms@gmail.com>, Kent C. Dodds <kent@doddsfamily.us> (ó ì_í)=óò=(ì_í ò)
	
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(81), __webpack_require__(204), __webpack_require__(205));
		else if(typeof define === 'function' && define.amd)
			define(["angular", "angular-formly", "api-check"], factory);
		else if(typeof exports === 'object')
			exports["ngFormlyTemplatesBootstrap"] = factory(require("angular"), require("angular-formly"), require("api-check"));
		else
			root["ngFormlyTemplatesBootstrap"] = factory(root["angular"], root["ngFormly"], root["apiCheck"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_5__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		module.exports = __webpack_require__(1);
	
	/***/ },
	/* 1 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
		var ngModuleName = 'formlyBootstrap';
		var angular = __webpack_require__(2);
		var ngModule = angular.module(ngModuleName, [__webpack_require__(4)]);
		ngModule.constant('formlyBootstrapApiCheck', __webpack_require__(5)({
		  output: {
		    prefix: 'angular-formly-bootstrap'
		  }
		}));
		ngModule.constant('formlyBootstrapVersion', ("6.3.0"));
	
		__webpack_require__(6)(ngModule);
		__webpack_require__(9)(ngModule);
		__webpack_require__(19)(ngModule);
	
		exports['default'] = ngModuleName;
		module.exports = exports['default'];
	
	/***/ },
	/* 2 */
	/***/ function(module, exports, __webpack_require__) {
	
		// some versions of angular don't export the angular module properly,
		// so we get it from window in this case.
		'use strict';
	
		var angular = __webpack_require__(3);
		if (!angular.version) {
		  angular = window.angular;
		}
		module.exports = angular;
	
	/***/ },
	/* 3 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_3__;
	
	/***/ },
	/* 4 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_4__;
	
	/***/ },
	/* 5 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_5__;
	
	/***/ },
	/* 6 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		exports['default'] = function (ngModule) {
		  ngModule.config(addWrappers);
	
		  function addWrappers(formlyConfigProvider) {
		    formlyConfigProvider.setWrapper([{
		      name: 'bootstrapLabel',
		      template: __webpack_require__(7),
		      apiCheck: function apiCheck(check) {
		        return {
		          templateOptions: {
		            label: check.string.optional,
		            required: check.bool.optional,
		            labelSrOnly: check.bool.optional
		          }
		        };
		      }
		    }, { name: 'bootstrapHasError', template: __webpack_require__(8) }]);
		  }
		  addWrappers.$inject = ["formlyConfigProvider"];
		};
	
		module.exports = exports['default'];
	
	/***/ },
	/* 7 */
	/***/ function(module, exports) {
	
		module.exports = "<div>\n  <label for=\"{{id}}\" class=\"control-label {{to.labelSrOnly ? 'sr-only' : ''}}\" ng-if=\"to.label\">\n    {{to.label}}\n    {{to.required ? '*' : ''}}\n  </label>\n  <formly-transclude></formly-transclude>\n</div>\n"
	
	/***/ },
	/* 8 */
	/***/ function(module, exports) {
	
		module.exports = "<div class=\"form-group\" ng-class=\"{'has-error': showError}\">\n  <formly-transclude></formly-transclude>\n</div>\n"
	
	/***/ },
	/* 9 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		exports['default'] = function (ngModule) {
		  __webpack_require__(10)(ngModule);
		  __webpack_require__(12)(ngModule);
		  __webpack_require__(14)(ngModule);
		  __webpack_require__(15)(ngModule);
		  __webpack_require__(17)(ngModule);
		  __webpack_require__(18)(ngModule);
		};
	
		module.exports = exports['default'];
	
	/***/ },
	/* 10 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		exports['default'] = function (ngModule) {
		  ngModule.config(addCheckboxType);
	
		  function addCheckboxType(formlyConfigProvider) {
		    formlyConfigProvider.setType({
		      name: 'checkbox',
		      template: __webpack_require__(11),
		      wrapper: ['bootstrapHasError'],
		      apiCheck: function apiCheck(check) {
		        return {
		          templateOptions: {
		            label: check.string
		          }
		        };
		      }
		    });
		  }
		  addCheckboxType.$inject = ["formlyConfigProvider"];
		};
	
		module.exports = exports['default'];
	
	/***/ },
	/* 11 */
	/***/ function(module, exports) {
	
		module.exports = "<div class=\"checkbox\">\n\t<label>\n\t\t<input type=\"checkbox\"\n           class=\"formly-field-checkbox\"\n\t\t       ng-model=\"model[options.key]\">\n\t\t{{to.label}}\n\t\t{{to.required ? '*' : ''}}\n\t</label>\n</div>\n"
	
	/***/ },
	/* 12 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		exports['default'] = function (ngModule) {
		  ngModule.config(addCheckboxType);
	
		  function addCheckboxType(formlyConfigProvider) {
		    formlyConfigProvider.setType({
		      name: 'multiCheckbox',
		      template: __webpack_require__(13),
		      wrapper: ['bootstrapLabel', 'bootstrapHasError'],
		      apiCheck: function apiCheck(check) {
		        return {
		          templateOptions: {
		            options: check.arrayOf(check.object),
		            labelProp: check.string.optional,
		            valueProp: check.string.optional
		          }
		        };
		      },
		      defaultOptions: {
		        noFormControl: false,
		        ngModelAttrs: {
		          required: {
		            attribute: '',
		            bound: ''
		          }
		        }
		      },
		      controller: /* @ngInject */["$scope", function controller($scope) {
		        var to = $scope.to;
		        var opts = $scope.options;
		        $scope.multiCheckbox = {
		          checked: [],
		          change: setModel
		        };
	
		        // initialize the checkboxes check property
		        $scope.$watch('model', function modelWatcher(newModelValue) {
		          var modelValue, valueProp;
	
		          if (Object.keys(newModelValue).length) {
		            modelValue = newModelValue[opts.key];
	
		            $scope.$watch('to.options', function optionsWatcher(newOptionsValues) {
		              if (newOptionsValues && Array.isArray(newOptionsValues) && Array.isArray(modelValue)) {
		                valueProp = to.valueProp || 'value';
		                for (var index = 0; index < newOptionsValues.length; index++) {
		                  $scope.multiCheckbox.checked[index] = modelValue.indexOf(newOptionsValues[index][valueProp]) !== -1;
		                }
		              }
		            });
		          }
		        }, true);
	
		        function checkValidity(expressionValue) {
		          var valid;
	
		          if ($scope.to.required) {
		            valid = angular.isArray($scope.model[opts.key]) && $scope.model[opts.key].length > 0 && expressionValue;
	
		            $scope.fc.$setValidity('required', valid);
		          }
		        }
	
		        function setModel() {
		          $scope.model[opts.key] = [];
		          angular.forEach($scope.multiCheckbox.checked, function (checkbox, index) {
		            if (checkbox) {
		              $scope.model[opts.key].push(to.options[index][to.valueProp || 'value']);
		            }
		          });
	
		          // Must make sure we mark as touched because only the last checkbox due to a bug in angular.
		          $scope.fc.$setTouched();
		          checkValidity(true);
		        }
	
		        if (opts.expressionProperties && opts.expressionProperties['templateOptions.required']) {
		          $scope.$watch(function () {
		            return $scope.to.required;
		          }, function (newValue) {
		            checkValidity(newValue);
		          });
		        }
	
		        if ($scope.to.required) {
		          var unwatchFormControl = $scope.$watch('fc', function (newValue) {
		            if (!newValue) {
		              return;
		            }
		            checkValidity(true);
		            unwatchFormControl();
		          });
		        }
		      }]
		    });
		  }
		  addCheckboxType.$inject = ["formlyConfigProvider"];
		};
	
		module.exports = exports['default'];
	
	/***/ },
	/* 13 */
	/***/ function(module, exports) {
	
		module.exports = "<div class=\"radio-group\">\n  <div ng-repeat=\"(key, option) in to.options\" class=\"checkbox\">\n    <label>\n      <input type=\"checkbox\"\n             id=\"{{id + '_'+ $index}}\"\n             ng-model=\"multiCheckbox.checked[$index]\"\n             ng-change=\"multiCheckbox.change()\">\n      {{option[to.labelProp || 'name']}}\n    </label>\n  </div>\n</div>\n"
	
	/***/ },
	/* 14 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		exports['default'] = function (ngModule) {
		  ngModule.config(addInputType);
	
		  function addInputType(formlyConfigProvider) {
		    formlyConfigProvider.setType({
		      name: 'input',
		      template: '<input class="form-control" ng-model="model[options.key]">',
		      wrapper: ['bootstrapLabel', 'bootstrapHasError']
		    });
		  }
		  addInputType.$inject = ["formlyConfigProvider"];
		};
	
		module.exports = exports['default'];
	
	/***/ },
	/* 15 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		exports['default'] = function (ngModule) {
		  ngModule.config(addRadioType);
	
		  function addRadioType(formlyConfigProvider) {
		    formlyConfigProvider.setType({
		      name: 'radio',
		      template: __webpack_require__(16),
		      wrapper: ['bootstrapLabel', 'bootstrapHasError'],
		      defaultOptions: {
		        noFormControl: false
		      },
		      apiCheck: function apiCheck(check) {
		        return {
		          templateOptions: {
		            options: check.arrayOf(check.object),
		            labelProp: check.string.optional,
		            valueProp: check.string.optional
		          }
		        };
		      }
		    });
		  }
		  addRadioType.$inject = ["formlyConfigProvider"];
		};
	
		module.exports = exports['default'];
	
	/***/ },
	/* 16 */
	/***/ function(module, exports) {
	
		module.exports = "<div class=\"radio-group\">\n  <div ng-repeat=\"(key, option) in to.options\" class=\"radio\">\n    <label>\n      <input type=\"radio\"\n             id=\"{{id + '_'+ $index}}\"\n             tabindex=\"0\"\n             ng-value=\"option[to.valueProp || 'value']\"\n             ng-model=\"model[options.key]\">\n      {{option[to.labelProp || 'name']}}\n    </label>\n  </div>\n</div>\n"
	
	/***/ },
	/* 17 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
		exports['default'] = function (ngModule) {
		  ngModule.config(addSelectType);
	
		  var template = '<select class="form-control" ng-model="model[options.key]"></select>';
	
		  function addSelectType(formlyConfigProvider) {
		    formlyConfigProvider.setType({
		      name: 'select',
		      template: template,
		      wrapper: ['bootstrapLabel', 'bootstrapHasError'],
		      defaultOptions: function defaultOptions(options) {
		        /* jshint maxlen:195 */
		        var ngOptions = options.templateOptions.ngOptions || 'option[to.valueProp || \'value\'] as option[to.labelProp || \'name\'] group by option[to.groupProp || \'group\'] for option in to.options';
		        return {
		          ngModelAttrs: _defineProperty({}, ngOptions, {
		            value: options.templateOptions.optionsAttr || 'ng-options'
		          })
		        };
		      },
		      apiCheck: function apiCheck(check) {
		        return {
		          templateOptions: {
		            options: check.arrayOf(check.object),
		            optionsAttr: check.string.optional,
		            labelProp: check.string.optional,
		            valueProp: check.string.optional,
		            groupProp: check.string.optional
		          }
		        };
		      }
		    });
		  }
		  addSelectType.$inject = ["formlyConfigProvider"];
		};
	
		module.exports = exports['default'];
	
	/***/ },
	/* 18 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		exports['default'] = function (ngModule) {
		  ngModule.config(addTextareaType);
	
		  function addTextareaType(formlyConfigProvider) {
		    formlyConfigProvider.setType({
		      name: 'textarea',
		      template: '<textarea class="form-control" ng-model="model[options.key]"></textarea>',
		      wrapper: ['bootstrapLabel', 'bootstrapHasError'],
		      defaultOptions: {
		        ngModelAttrs: {
		          rows: { attribute: 'rows' },
		          cols: { attribute: 'cols' }
		        }
		      },
		      apiCheck: function apiCheck(check) {
		        return {
		          templateOptions: {
		            rows: check.number.optional,
		            cols: check.number.optional
		          }
		        };
		      }
		    });
		  }
		  addTextareaType.$inject = ["formlyConfigProvider"];
		};
	
		module.exports = exports['default'];
	
	/***/ },
	/* 19 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _addons = __webpack_require__(20);
	
		var _addons2 = _interopRequireDefault(_addons);
	
		var _description = __webpack_require__(22);
	
		var _description2 = _interopRequireDefault(_description);
	
		exports['default'] = function (ngModule) {
		  (0, _addons2['default'])(ngModule);
		  (0, _description2['default'])(ngModule);
		};
	
		module.exports = exports['default'];
	
	/***/ },
	/* 20 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		exports['default'] = function (ngModule) {
		  ngModule.run(addAddonsManipulator);
	
		  function addAddonsManipulator(formlyConfig, formlyBootstrapApiCheck) {
		    var addonTemplate = __webpack_require__(21);
		    var addonChecker = formlyBootstrapApiCheck.shape({
		      'class': formlyBootstrapApiCheck.string.optional,
		      text: formlyBootstrapApiCheck.string.optional,
		      onClick: formlyBootstrapApiCheck.func.optional
		    }).strict.optional;
		    var api = formlyBootstrapApiCheck.shape({
		      templateOptions: formlyBootstrapApiCheck.shape({
		        addonLeft: addonChecker,
		        addonRight: addonChecker
		      })
		    });
		    formlyConfig.templateManipulators.preWrapper.push(function (template, options) {
		      if (!options.templateOptions.addonLeft && !options.templateOptions.addonRight) {
		        return template;
		      }
		      formlyBootstrapApiCheck.warn([api], [options]);
		      return addonTemplate.replace('<formly-transclude></formly-transclude>', template);
		    });
		  }
		  addAddonsManipulator.$inject = ["formlyConfig", "formlyBootstrapApiCheck"];
		};
	
		module.exports = exports['default'];
	
	/***/ },
	/* 21 */
	/***/ function(module, exports) {
	
		module.exports = "<div ng-class=\"{'input-group': to.addonLeft || to.addonRight}\">\n    <div class=\"input-group-addon\"\n         ng-if=\"to.addonLeft\"\n         ng-style=\"{cursor: to.addonLeft.onClick ? 'pointer' : 'inherit'}\"\n         ng-click=\"to.addonLeft.onClick(options, this, $event)\">\n        <i class=\"{{to.addonLeft.class}}\" ng-if=\"to.addonLeft.class\"></i>\n        <span ng-if=\"to.addonLeft.text\">{{to.addonLeft.text}}</span>\n    </div>\n    <formly-transclude></formly-transclude>\n    <div class=\"input-group-addon\"\n         ng-if=\"to.addonRight\"\n         ng-style=\"{cursor: to.addonRight.onClick ? 'pointer' : 'inherit'}\"\n         ng-click=\"to.addonRight.onClick(options, this, $event)\">\n        <i class=\"{{to.addonRight.class}}\" ng-if=\"to.addonRight.class\"></i>\n        <span ng-if=\"to.addonRight.text\">{{to.addonRight.text}}</span>\n    </div>\n</div>\n"
	
	/***/ },
	/* 22 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		exports['default'] = function (ngModule) {
		  ngModule.run(addDescriptionManipulator);
	
		  function addDescriptionManipulator(formlyConfig) {
		    formlyConfig.templateManipulators.preWrapper.push(function ariaDescribedBy(template, options, scope) {
		      if (angular.isDefined(options.templateOptions.description)) {
		        var el = document.createElement('div');
		        el.appendChild(angular.element(template)[0]);
		        el.appendChild(angular.element('<p id="' + scope.id + '_description"' + 'class="help-block"' + 'ng-if="to.description">' + '{{to.description}}' + '</p>')[0]);
		        var modelEls = angular.element(el.querySelectorAll('[ng-model]'));
		        if (modelEls) {
		          modelEls.attr('aria-describedby', scope.id + '_description');
		        }
		        return el.innerHTML;
		      } else {
		        return template;
		      }
		    });
		  }
		  addDescriptionManipulator.$inject = ["formlyConfig"];
		};
	
		module.exports = exports['default'];
	
	/***/ }
	/******/ ])
	});
	;

/***/ },
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	//https://github.com/angular/angular.js/pull/10732
	
	var angular = __webpack_require__(81);
	var mask = __webpack_require__(214);
	
	module.exports = 'ui.mask';


/***/ },
/* 214 */
/***/ function(module, exports) {

	/*!
	 * angular-ui-mask
	 * https://github.com/angular-ui/ui-mask
	 * Version: 1.8.5 - 2016-06-10T18:02:57.970Z
	 * License: MIT
	 */
	
	
	(function () { 
	'use strict';
	/*
	 Attaches input mask onto input element
	 */
	angular.module('ui.mask', [])
	        .value('uiMaskConfig', {
	            maskDefinitions: {
	                '9': /\d/,
	                'A': /[a-zA-Z]/,
	                '*': /[a-zA-Z0-9]/
	            },
	            clearOnBlur: true,
	            clearOnBlurPlaceholder: false,
	            escChar: '\\',
	            eventsToHandle: ['input', 'keyup', 'click', 'focus'],
	            addDefaultPlaceholder: true,
	            allowInvalidValue: false
	        })
	        .provider('uiMask.Config', function() {
	            var options = {};
	
	            this.maskDefinitions = function(maskDefinitions) {
	                return options.maskDefinitions = maskDefinitions;
	            };
	            this.clearOnBlur = function(clearOnBlur) {
	                return options.clearOnBlur = clearOnBlur;
	            };
	            this.clearOnBlurPlaceholder = function(clearOnBlurPlaceholder) {
	                return options.clearOnBlurPlaceholder = clearOnBlurPlaceholder;
	            };
	            this.eventsToHandle = function(eventsToHandle) {
	                return options.eventsToHandle = eventsToHandle;
	            };
	            this.addDefaultPlaceholder = function(addDefaultPlaceholder) {
	                return options.addDefaultPlaceholder = addDefaultPlaceholder;
	            };
	            this.allowInvalidValue = function(allowInvalidValue) {
	                return options.allowInvalidValue = allowInvalidValue;
	            };
	            this.$get = ['uiMaskConfig', function(uiMaskConfig) {
	                var tempOptions = uiMaskConfig;
	                for(var prop in options) {
	                    if (angular.isObject(options[prop]) && !angular.isArray(options[prop])) {
	                        angular.extend(tempOptions[prop], options[prop]);
	                    } else {
	                        tempOptions[prop] = options[prop];
	                    }
	                }
	
	                return tempOptions;
	            }];
	        })
	        .directive('uiMask', ['uiMask.Config', function(maskConfig) {
	                function isFocused (elem) {
	                  return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
	                }
	
	                return {
	                    priority: 100,
	                    require: 'ngModel',
	                    restrict: 'A',
	                    compile: function uiMaskCompilingFunction() {
	                        var options = angular.copy(maskConfig);
	
	                        return function uiMaskLinkingFunction(scope, iElement, iAttrs, controller) {
	                            var maskProcessed = false, eventsBound = false,
	                                    maskCaretMap, maskPatterns, maskPlaceholder, maskComponents,
	                                    // Minimum required length of the value to be considered valid
	                                    minRequiredLength,
	                                    value, valueMasked, isValid,
	                                    // Vars for initializing/uninitializing
	                                    originalPlaceholder = iAttrs.placeholder,
	                                    originalMaxlength = iAttrs.maxlength,
	                                    // Vars used exclusively in eventHandler()
	                                    oldValue, oldValueUnmasked, oldCaretPosition, oldSelectionLength,
	                                    // Used for communicating if a backspace operation should be allowed between
	                                    // keydownHandler and eventHandler
	                                    preventBackspace;
	
	                            var originalIsEmpty = controller.$isEmpty;
	                            controller.$isEmpty = function(value) {
	                                if (maskProcessed) {
	                                    return originalIsEmpty(unmaskValue(value || ''));
	                                } else {
	                                    return originalIsEmpty(value);
	                                }
	                            };
	
	                            function initialize(maskAttr) {
	                                if (!angular.isDefined(maskAttr)) {
	                                    return uninitialize();
	                                }
	                                processRawMask(maskAttr);
	                                if (!maskProcessed) {
	                                    return uninitialize();
	                                }
	                                initializeElement();
	                                bindEventListeners();
	                                return true;
	                            }
	
	                            function initPlaceholder(placeholderAttr) {
	                                if ( ! placeholderAttr) {
	                                    return;
	                                }
	
	                                maskPlaceholder = placeholderAttr;
	
	                                // If the mask is processed, then we need to update the value
	                                // but don't set the value if there is nothing entered into the element
	                                // and there is a placeholder attribute on the element because that
	                                // will only set the value as the blank maskPlaceholder
	                                // and override the placeholder on the element
	                                if (maskProcessed && !(iElement.val().length === 0 && angular.isDefined(iAttrs.placeholder))) {
	                                    iElement.val(maskValue(unmaskValue(iElement.val())));
	                                }
	                            }
	
	                            function initPlaceholderChar() {
	                                return initialize(iAttrs.uiMask);
	                            }
	
	                            var modelViewValue = false;
	                            iAttrs.$observe('modelViewValue', function(val) {
	                                if (val === 'true') {
	                                    modelViewValue = true;
	                                }
	                            });
	
	                            iAttrs.$observe('allowInvalidValue', function(val) {
	                                linkOptions.allowInvalidValue = val === ''
	                                    ? true
	                                    : !!val;
	                                formatter(controller.$modelValue);
	                            });
	
	                            function formatter(fromModelValue) {
	                                if (!maskProcessed) {
	                                    return fromModelValue;
	                                }
	                                value = unmaskValue(fromModelValue || '');
	                                isValid = validateValue(value);
	                                controller.$setValidity('mask', isValid);
	
	                                if (!value.length) return undefined;
	                                if (isValid || linkOptions.allowInvalidValue) {
	                                    return maskValue(value);
	                                } else {
	                                    return undefined;
	                                }
	                            }
	
	                            function parser(fromViewValue) {
	                                if (!maskProcessed) {
	                                    return fromViewValue;
	                                }
	                                value = unmaskValue(fromViewValue || '');
	                                isValid = validateValue(value);
	                                // We have to set viewValue manually as the reformatting of the input
	                                // value performed by eventHandler() doesn't happen until after
	                                // this parser is called, which causes what the user sees in the input
	                                // to be out-of-sync with what the controller's $viewValue is set to.
	                                controller.$viewValue = value.length ? maskValue(value) : '';
	                                controller.$setValidity('mask', isValid);
	
	                                if (isValid || linkOptions.allowInvalidValue) {
	                                    return modelViewValue ? controller.$viewValue : value;
	                                }
	                            }
	
	                            var linkOptions = {};
	
	                            if (iAttrs.uiOptions) {
	                                linkOptions = scope.$eval('[' + iAttrs.uiOptions + ']');
	                                if (angular.isObject(linkOptions[0])) {
	                                    // we can't use angular.copy nor angular.extend, they lack the power to do a deep merge
	                                    linkOptions = (function(original, current) {
	                                        for (var i in original) {
	                                            if (Object.prototype.hasOwnProperty.call(original, i)) {
	                                                if (current[i] === undefined) {
	                                                    current[i] = angular.copy(original[i]);
	                                                } else {
	                                                    if (angular.isObject(current[i]) && !angular.isArray(current[i])) {
	                                                        current[i] = angular.extend({}, original[i], current[i]);
	                                                    }
	                                                }
	                                            }
	                                        }
	                                        return current;
	                                    })(options, linkOptions[0]);
	                                } else {
	                                    linkOptions = options;  //gotta be a better way to do this..
	                                }
	                            } else {
	                                linkOptions = options;
	                            }
	
	                            iAttrs.$observe('uiMask', initialize);
	                            if (angular.isDefined(iAttrs.uiMaskPlaceholder)) {
	                                iAttrs.$observe('uiMaskPlaceholder', initPlaceholder);
	                            }
	                            else {
	                                iAttrs.$observe('placeholder', initPlaceholder);
	                            }
	                            if (angular.isDefined(iAttrs.uiMaskPlaceholderChar)) {
	                                iAttrs.$observe('uiMaskPlaceholderChar', initPlaceholderChar);
	                            }
	
	                            controller.$formatters.unshift(formatter);
	                            controller.$parsers.unshift(parser);
	
	                            function uninitialize() {
	                                maskProcessed = false;
	                                unbindEventListeners();
	
	                                if (angular.isDefined(originalPlaceholder)) {
	                                    iElement.attr('placeholder', originalPlaceholder);
	                                } else {
	                                    iElement.removeAttr('placeholder');
	                                }
	
	                                if (angular.isDefined(originalMaxlength)) {
	                                    iElement.attr('maxlength', originalMaxlength);
	                                } else {
	                                    iElement.removeAttr('maxlength');
	                                }
	
	                                iElement.val(controller.$modelValue);
	                                controller.$viewValue = controller.$modelValue;
	                                return false;
	                            }
	
	                            function initializeElement() {
	                                value = oldValueUnmasked = unmaskValue(controller.$modelValue || '');
	                                valueMasked = oldValue = maskValue(value);
	                                isValid = validateValue(value);
	                                if (iAttrs.maxlength) { // Double maxlength to allow pasting new val at end of mask
	                                    iElement.attr('maxlength', maskCaretMap[maskCaretMap.length - 1] * 2);
	                                }
	                                if ( ! originalPlaceholder && linkOptions.addDefaultPlaceholder) {
	                                    iElement.attr('placeholder', maskPlaceholder);
	                                }
	                                var viewValue = controller.$modelValue;
	                                var idx = controller.$formatters.length;
	                                while(idx--) {
	                                    viewValue = controller.$formatters[idx](viewValue);
	                                }
	                                controller.$viewValue = viewValue || '';
	                                controller.$render();
	                                // Not using $setViewValue so we don't clobber the model value and dirty the form
	                                // without any kind of user interaction.
	                            }
	
	                            function bindEventListeners() {
	                                if (eventsBound) {
	                                    return;
	                                }
	                                iElement.bind('blur', blurHandler);
	                                iElement.bind('mousedown mouseup', mouseDownUpHandler);
	                                iElement.bind('keydown', keydownHandler);
	                                iElement.bind(linkOptions.eventsToHandle.join(' '), eventHandler);
	                                eventsBound = true;
	                            }
	
	                            function unbindEventListeners() {
	                                if (!eventsBound) {
	                                    return;
	                                }
	                                iElement.unbind('blur', blurHandler);
	                                iElement.unbind('mousedown', mouseDownUpHandler);
	                                iElement.unbind('mouseup', mouseDownUpHandler);
	                                iElement.unbind('keydown', keydownHandler);
	                                iElement.unbind('input', eventHandler);
	                                iElement.unbind('keyup', eventHandler);
	                                iElement.unbind('click', eventHandler);
	                                iElement.unbind('focus', eventHandler);
	                                eventsBound = false;
	                            }
	
	                            function validateValue(value) {
	                                // Zero-length value validity is ngRequired's determination
	                                return value.length ? value.length >= minRequiredLength : true;
	                            }
	
	                            function unmaskValue(value) {
	                                var valueUnmasked = '',
	                                    input = iElement[0],
	                                    maskPatternsCopy = maskPatterns.slice(),
	                                    selectionStart = oldCaretPosition,
	                                    selectionEnd = selectionStart + getSelectionLength(input),
	                                    valueOffset, valueDelta, tempValue = '';
	                                // Preprocess by stripping mask components from value
	                                value = value.toString();
	                                valueOffset = 0;
	                                valueDelta = value.length - maskPlaceholder.length;
	                                angular.forEach(maskComponents, function(component) {
	                                    var position = component.position;
	                                    //Only try and replace the component if the component position is not within the selected range
	                                    //If component was in selected range then it was removed with the user input so no need to try and remove that component
	                                    if (!(position >= selectionStart && position < selectionEnd)) {
	                                        if (position >= selectionStart) {
	                                            position += valueDelta;
	                                        }
	                                        if (value.substring(position, position + component.value.length) === component.value) {
	                                            tempValue += value.slice(valueOffset, position);// + value.slice(position + component.value.length);
	                                            valueOffset = position + component.value.length;
	                                        }
	                                    }
	                                });
	                                value = tempValue + value.slice(valueOffset);
	                                angular.forEach(value.split(''), function(chr) {
	                                    if (maskPatternsCopy.length && maskPatternsCopy[0].test(chr)) {
	                                        valueUnmasked += chr;
	                                        maskPatternsCopy.shift();
	                                    }
	                                });
	
	                                return valueUnmasked;
	                            }
	
	                            function maskValue(unmaskedValue) {
	                                var valueMasked = '',
	                                        maskCaretMapCopy = maskCaretMap.slice();
	
	                                angular.forEach(maskPlaceholder.split(''), function(chr, i) {
	                                    if (unmaskedValue.length && i === maskCaretMapCopy[0]) {
	                                        valueMasked += unmaskedValue.charAt(0) || '_';
	                                        unmaskedValue = unmaskedValue.substr(1);
	                                        maskCaretMapCopy.shift();
	                                    }
	                                    else {
	                                        valueMasked += chr;
	                                    }
	                                });
	                                return valueMasked;
	                            }
	
	                            function getPlaceholderChar(i) {
	                                var placeholder = angular.isDefined(iAttrs.uiMaskPlaceholder) ? iAttrs.uiMaskPlaceholder : iAttrs.placeholder,
	                                    defaultPlaceholderChar;
	
	                                if (angular.isDefined(placeholder) && placeholder[i]) {
	                                    return placeholder[i];
	                                } else {
	                                    defaultPlaceholderChar = angular.isDefined(iAttrs.uiMaskPlaceholderChar) && iAttrs.uiMaskPlaceholderChar ? iAttrs.uiMaskPlaceholderChar : '_';
	                                    return (defaultPlaceholderChar.toLowerCase() === 'space') ? ' ' : defaultPlaceholderChar[0];
	                                }
	                            }
	
	                            // Generate array of mask components that will be stripped from a masked value
	                            // before processing to prevent mask components from being added to the unmasked value.
	                            // E.g., a mask pattern of '+7 9999' won't have the 7 bleed into the unmasked value.
	                            function getMaskComponents() {
	                                var maskPlaceholderChars = maskPlaceholder.split(''),
	                                        maskPlaceholderCopy, components;
	
	                                //maskCaretMap can have bad values if the input has the ui-mask attribute implemented as an obversable property, e.g. the demo page
	                                if (maskCaretMap && !isNaN(maskCaretMap[0])) {
	                                    //Instead of trying to manipulate the RegEx based on the placeholder characters
	                                    //we can simply replace the placeholder characters based on the already built
	                                    //maskCaretMap to underscores and leave the original working RegEx to get the proper
	                                    //mask components
	                                    angular.forEach(maskCaretMap, function(value) {
	                                        maskPlaceholderChars[value] = '_';
	                                    });
	                                }
	                                maskPlaceholderCopy = maskPlaceholderChars.join('');
	                                components = maskPlaceholderCopy.replace(/[_]+/g, '_').split('_');
	                                components = components.filter(function(s) {
	                                    return s !== '';
	                                });
	
	                                // need a string search offset in cases where the mask contains multiple identical components
	                                // E.g., a mask of 99.99.99-999.99
	                                var offset = 0;
	                                return components.map(function(c) {
	                                    var componentPosition = maskPlaceholderCopy.indexOf(c, offset);
	                                    offset = componentPosition + 1;
	                                    return {
	                                        value: c,
	                                        position: componentPosition
	                                    };
	                                });
	                            }
	
	                            function processRawMask(mask) {
	                                var characterCount = 0;
	
	                                maskCaretMap = [];
	                                maskPatterns = [];
	                                maskPlaceholder = '';
	
	                                if (angular.isString(mask)) {
	                                    minRequiredLength = 0;
	
	                                    var isOptional = false,
	                                            numberOfOptionalCharacters = 0,
	                                            splitMask = mask.split('');
	
	                                    var inEscape = false;
	                                    angular.forEach(splitMask, function(chr, i) {
	                                        if (inEscape) {
	                                            inEscape = false;
	                                            maskPlaceholder += chr;
	                                            characterCount++;
	                                        }
	                                        else if (linkOptions.escChar === chr) {
	                                            inEscape = true;
	                                        }
	                                        else if (linkOptions.maskDefinitions[chr]) {
	                                            maskCaretMap.push(characterCount);
	
	                                            maskPlaceholder += getPlaceholderChar(i - numberOfOptionalCharacters);
	                                            maskPatterns.push(linkOptions.maskDefinitions[chr]);
	
	                                            characterCount++;
	                                            if (!isOptional) {
	                                                minRequiredLength++;
	                                            }
	
	                                            isOptional = false;
	                                        }
	                                        else if (chr === '?') {
	                                            isOptional = true;
	                                            numberOfOptionalCharacters++;
	                                        }
	                                        else {
	                                            maskPlaceholder += chr;
	                                            characterCount++;
	                                        }
	                                    });
	                                }
	                                // Caret position immediately following last position is valid.
	                                maskCaretMap.push(maskCaretMap.slice().pop() + 1);
	
	                                maskComponents = getMaskComponents();
	                                maskProcessed = maskCaretMap.length > 1 ? true : false;
	                            }
	
	                            var prevValue = iElement.val();
	                            function blurHandler() {
	                                if (linkOptions.clearOnBlur || ((linkOptions.clearOnBlurPlaceholder) && (value.length === 0) && iAttrs.placeholder)) {
	                                    oldCaretPosition = 0;
	                                    oldSelectionLength = 0;
	                                    if (!isValid || value.length === 0) {
	                                        valueMasked = '';
	                                        iElement.val('');
	                                        scope.$apply(function() {
	                                            //only $setViewValue when not $pristine to avoid changing $pristine state.
	                                            if (!controller.$pristine) {
	                                                controller.$setViewValue('');
	                                            }
	                                        });
	                                    }
	                                }
	                                //Check for different value and trigger change.
	                                //Check for different value and trigger change.
	                                if (value !== prevValue) {
	                                    // #157 Fix the bug from the trigger when backspacing exactly on the first letter (emptying the field)
	                                    // and then blurring out.
	                                    // Angular uses html element and calls setViewValue(element.value.trim()), setting it to the trimmed mask
	                                    // when it should be empty
	                                    var currentVal = iElement.val();
	                                    var isTemporarilyEmpty = value === '' && currentVal && angular.isDefined(iAttrs.uiMaskPlaceholderChar) && iAttrs.uiMaskPlaceholderChar === 'space'; 
	                                    if(isTemporarilyEmpty) {
	                                        iElement.val('');
	                                    }
	                                    triggerChangeEvent(iElement[0]);
	                                    if(isTemporarilyEmpty) {
	                                        iElement.val(currentVal);
	                                    }
	                                }
	                                prevValue = value;
	                            }
	
	                            function triggerChangeEvent(element) {
	                                var change;
	                                if (angular.isFunction(window.Event) && !element.fireEvent) {
	                                    // modern browsers and Edge
	                                    change = new Event('change', {
	                                        view: window,
	                                        bubbles: true,
	                                        cancelable: false
	                                    });
	                                    element.dispatchEvent(change);
	                                } else if ('createEvent' in document) {
	                                    // older browsers
	                                    change = document.createEvent('HTMLEvents');
	                                    change.initEvent('change', false, true);
	                                    element.dispatchEvent(change);
	                                }
	                                else if (element.fireEvent) {
	                                    // IE <= 11
	                                    element.fireEvent('onchange');
	                                }
	                            }
	
	                            function mouseDownUpHandler(e) {
	                                if (e.type === 'mousedown') {
	                                    iElement.bind('mouseout', mouseoutHandler);
	                                } else {
	                                    iElement.unbind('mouseout', mouseoutHandler);
	                                }
	                            }
	
	                            iElement.bind('mousedown mouseup', mouseDownUpHandler);
	
	                            function mouseoutHandler() {
	                                /*jshint validthis: true */
	                                oldSelectionLength = getSelectionLength(this);
	                                iElement.unbind('mouseout', mouseoutHandler);
	                            }
	
	                            function keydownHandler(e) {
	                                /*jshint validthis: true */
	                                var isKeyBackspace = e.which === 8,
	                                    caretPos = getCaretPosition(this) - 1 || 0; //value in keydown is pre change so bump caret position back to simulate post change
	
	                                if (isKeyBackspace) {
	                                    while(caretPos >= 0) {
	                                        if (isValidCaretPosition(caretPos)) {
	                                            //re-adjust the caret position.
	                                            //Increment to account for the initial decrement to simulate post change caret position
	                                            setCaretPosition(this, caretPos + 1);
	                                            break;
	                                        }
	                                        caretPos--;
	                                    }
	                                    preventBackspace = caretPos === -1;
	                                }
	                            }
	
	                            function eventHandler(e) {
	                                /*jshint validthis: true */
	                                e = e || {};
	                                // Allows more efficient minification
	                                var eventWhich = e.which,
	                                        eventType = e.type;
	
	                                // Prevent shift and ctrl from mucking with old values
	                                if (eventWhich === 16 || eventWhich === 91) {
	                                    return;
	                                }
	
	                                var val = iElement.val(),
	                                        valOld = oldValue,
	                                        valMasked,
	                                        valAltered = false,
	                                        valUnmasked = unmaskValue(val),
	                                        valUnmaskedOld = oldValueUnmasked,
	                                        caretPos = getCaretPosition(this) || 0,
	                                        caretPosOld = oldCaretPosition || 0,
	                                        caretPosDelta = caretPos - caretPosOld,
	                                        caretPosMin = maskCaretMap[0],
	                                        caretPosMax = maskCaretMap[valUnmasked.length] || maskCaretMap.slice().shift(),
	                                        selectionLenOld = oldSelectionLength || 0,
	                                        isSelected = getSelectionLength(this) > 0,
	                                        wasSelected = selectionLenOld > 0,
	                                        // Case: Typing a character to overwrite a selection
	                                        isAddition = (val.length > valOld.length) || (selectionLenOld && val.length > valOld.length - selectionLenOld),
	                                        // Case: Delete and backspace behave identically on a selection
	                                        isDeletion = (val.length < valOld.length) || (selectionLenOld && val.length === valOld.length - selectionLenOld),
	                                        isSelection = (eventWhich >= 37 && eventWhich <= 40) && e.shiftKey, // Arrow key codes
	
	                                        isKeyLeftArrow = eventWhich === 37,
	                                        // Necessary due to "input" event not providing a key code
	                                        isKeyBackspace = eventWhich === 8 || (eventType !== 'keyup' && isDeletion && (caretPosDelta === -1)),
	                                        isKeyDelete = eventWhich === 46 || (eventType !== 'keyup' && isDeletion && (caretPosDelta === 0) && !wasSelected),
	                                        // Handles cases where caret is moved and placed in front of invalid maskCaretMap position. Logic below
	                                        // ensures that, on click or leftward caret placement, caret is moved leftward until directly right of
	                                        // non-mask character. Also applied to click since users are (arguably) more likely to backspace
	                                        // a character when clicking within a filled input.
	                                        caretBumpBack = (isKeyLeftArrow || isKeyBackspace || eventType === 'click') && caretPos > caretPosMin;
	
	                                oldSelectionLength = getSelectionLength(this);
	
	                                // These events don't require any action
	                                if (isSelection || (isSelected && (eventType === 'click' || eventType === 'keyup' || eventType === 'focus'))) {
	                                    return;
	                                }
	
	                                if (isKeyBackspace && preventBackspace) {
	                                    iElement.val(maskPlaceholder);
	                                    // This shouldn't be needed but for some reason after aggressive backspacing the controller $viewValue is incorrect.
	                                    // This keeps the $viewValue updated and correct.
	                                    scope.$apply(function () {
	                                        controller.$setViewValue(''); // $setViewValue should be run in angular context, otherwise the changes will be invisible to angular and user code.
	                                    });
	                                    setCaretPosition(this, caretPosOld);
	                                    return;
	                                }
	
	                                // Value Handling
	                                // ==============
	
	                                // User attempted to delete but raw value was unaffected--correct this grievous offense
	                                if ((eventType === 'input') && isDeletion && !wasSelected && valUnmasked === valUnmaskedOld) {
	                                    while (isKeyBackspace && caretPos > caretPosMin && !isValidCaretPosition(caretPos)) {
	                                        caretPos--;
	                                    }
	                                    while (isKeyDelete && caretPos < caretPosMax && maskCaretMap.indexOf(caretPos) === -1) {
	                                        caretPos++;
	                                    }
	                                    var charIndex = maskCaretMap.indexOf(caretPos);
	                                    // Strip out non-mask character that user would have deleted if mask hadn't been in the way.
	                                    valUnmasked = valUnmasked.substring(0, charIndex) + valUnmasked.substring(charIndex + 1);
	
	                                    // If value has not changed, don't want to call $setViewValue, may be caused by IE raising input event due to placeholder
	                                    if (valUnmasked !== valUnmaskedOld)
	                                        valAltered = true;
	                                }
	
	                                // Update values
	                                valMasked = maskValue(valUnmasked);
	
	                                oldValue = valMasked;
	                                oldValueUnmasked = valUnmasked;
	
	                                //additional check to fix the problem where the viewValue is out of sync with the value of the element.
	                                //better fix for commit 2a83b5fb8312e71d220a497545f999fc82503bd9 (I think)
	                                if (!valAltered && val.length > valMasked.length)
	                                    valAltered = true;
	
	                                iElement.val(valMasked);
	
	                                //we need this check.  What could happen if you don't have it is that you'll set the model value without the user
	                                //actually doing anything.  Meaning, things like pristine and touched will be set.
	                                if (valAltered) {
	                                    scope.$apply(function () {
	                                        controller.$setViewValue(valMasked); // $setViewValue should be run in angular context, otherwise the changes will be invisible to angular and user code.
	                                    });
	                                }
	
	                                // Caret Repositioning
	                                // ===================
	
	                                // Ensure that typing always places caret ahead of typed character in cases where the first char of
	                                // the input is a mask char and the caret is placed at the 0 position.
	                                if (isAddition && (caretPos <= caretPosMin)) {
	                                    caretPos = caretPosMin + 1;
	                                }
	
	                                if (caretBumpBack) {
	                                    caretPos--;
	                                }
	
	                                // Make sure caret is within min and max position limits
	                                caretPos = caretPos > caretPosMax ? caretPosMax : caretPos < caretPosMin ? caretPosMin : caretPos;
	
	                                // Scoot the caret back or forth until it's in a non-mask position and within min/max position limits
	                                while (!isValidCaretPosition(caretPos) && caretPos > caretPosMin && caretPos < caretPosMax) {
	                                    caretPos += caretBumpBack ? -1 : 1;
	                                }
	
	                                if ((caretBumpBack && caretPos < caretPosMax) || (isAddition && !isValidCaretPosition(caretPosOld))) {
	                                    caretPos++;
	                                }
	                                oldCaretPosition = caretPos;
	                                setCaretPosition(this, caretPos);
	                            }
	
	                            function isValidCaretPosition(pos) {
	                                return maskCaretMap.indexOf(pos) > -1;
	                            }
	
	                            function getCaretPosition(input) {
	                                if (!input)
	                                    return 0;
	                                if (input.selectionStart !== undefined) {
	                                    return input.selectionStart;
	                                } else if (document.selection) {
	                                    if (isFocused(iElement[0])) {
	                                        // Curse you IE
	                                        input.focus();
	                                        var selection = document.selection.createRange();
	                                        selection.moveStart('character', input.value ? -input.value.length : 0);
	                                        return selection.text.length;
	                                    }
	                                }
	                                return 0;
	                            }
	
	                            function setCaretPosition(input, pos) {
	                                if (!input)
	                                    return 0;
	                                if (input.offsetWidth === 0 || input.offsetHeight === 0) {
	                                    return; // Input's hidden
	                                }
	                                if (input.setSelectionRange) {
	                                    if (isFocused(iElement[0])) {
	                                        input.focus();
	                                        input.setSelectionRange(pos, pos);
	                                    }
	                                }
	                                else if (input.createTextRange) {
	                                    // Curse you IE
	                                    var range = input.createTextRange();
	                                    range.collapse(true);
	                                    range.moveEnd('character', pos);
	                                    range.moveStart('character', pos);
	                                    range.select();
	                                }
	                            }
	
	                            function getSelectionLength(input) {
	                                if (!input)
	                                    return 0;
	                                if (input.selectionStart !== undefined) {
	                                    return (input.selectionEnd - input.selectionStart);
	                                }
	                                if (document.selection) {
	                                    return (document.selection.createRange().text.length);
	                                }
	                                return 0;
	                            }
	
	                            // https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/Array/indexOf
	                            if (!Array.prototype.indexOf) {
	                                Array.prototype.indexOf = function(searchElement /*, fromIndex */) {
	                                    if (this === null) {
	                                        throw new TypeError();
	                                    }
	                                    var t = Object(this);
	                                    var len = t.length >>> 0;
	                                    if (len === 0) {
	                                        return -1;
	                                    }
	                                    var n = 0;
	                                    if (arguments.length > 1) {
	                                        n = Number(arguments[1]);
	                                        if (n !== n) { // shortcut for verifying if it's NaN
	                                            n = 0;
	                                        } else if (n !== 0 && n !== Infinity && n !== -Infinity) {
	                                            n = (n > 0 || -1) * Math.floor(Math.abs(n));
	                                        }
	                                    }
	                                    if (n >= len) {
	                                        return -1;
	                                    }
	                                    var k = n >= 0 ? n : Math.max(len - Math.abs(n), 0);
	                                    for (; k < len; k++) {
	                                        if (k in t && t[k] === searchElement) {
	                                            return k;
	                                        }
	                                    }
	                                    return -1;
	                                };
	                            }
	
	                        };
	                    }
	                };
	            }
	        ]);
	
	}());

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _moment = __webpack_require__(216);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var datemask = function datemask() {
	    return {
	        restrict: 'A',
	        require: 'ngModel',
	        priority: 1000,
	        link: function link(scope, iElement, iAttrs, ngModelCtrl) {
	            var format, momentFormat, isoFormat;
	            var type = iAttrs.format || 'date';
	            if (type === 'datetime') {
	                momentFormat = 'DDMMYYYYHHmm';
	                format = 'DD.MM.YYYY HH:mm';
	                isoFormat = 'YYYY-MM-DDTHH:mm:ss';
	            } else {
	                momentFormat = 'DDMMYYYY';
	                format = 'DD.MM.YYYY';
	                isoFormat = 'YYYY-MM-DD';
	            }
	
	            iElement.on('keyup', function (event) {
	                if (event.keyCode === 32 && ngModelCtrl.$viewValue === iAttrs.uiMaskPlaceholder) {
	                    var value = (0, _moment2['default'])().format(momentFormat);
	                    ngModelCtrl.$setViewValue(value);
	                    ngModelCtrl.$render();
	                }
	            });
	
	            function parseViewValue(value) {
	                var d = (0, _moment2['default'])(value, momentFormat, true);
	                if (d.isValid()) {
	                    return d.format(isoFormat);
	                }
	
	                return value;
	            }
	
	            function formatViewValue(value) {
	                var d = (0, _moment2['default'])(value, isoFormat, true);
	                if (d.isValid()) {
	                    return d.format(format);
	                }
	            }
	
	            function validateValue(modelValue, viewValue) {
	                var value = modelValue;
	                if (value === null || angular.isUndefined(value) || value === '') {
	                    return true;
	                }
	
	                var d = (0, _moment2['default'])(value, isoFormat, true);
	                return d.isValid();
	            }
	
	            ngModelCtrl.$parsers.push(parseViewValue);
	            ngModelCtrl.$formatters.push(formatViewValue);
	            ngModelCtrl.$validators.datemask = validateValue;
	        }
	    };
	};
	
	exports.datemask = datemask;

/***/ },
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */
/***/ function(module, exports) {

	var path = 'app/components/common/forms/templates/fieldset.html';
	var html = "<fieldset class=\"{{to.className}}\"><legend><span>{{to.label}}</span></legend><formly-transclude></formly-transclude></fieldset>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 316 */
/***/ function(module, exports) {

	var path = 'app/components/common/forms/templates/row.html';
	var html = "<div class=\"{{to.cssClass || 'row'}}\"><formly-transclude></formly-transclude></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 317 */
/***/ function(module, exports) {

	var path = 'app/components/common/forms/templates/div.html';
	var html = "<div class=\"{{to.className}}\"><formly-transclude></formly-transclude></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 318 */
/***/ function(module, exports) {

	var path = 'app/components/common/forms/templates/horizontalLabel.html';
	var html = "<label ng-if=\"to.label\" for=\"{{::id}}\" class=\"{{::to.labelcss || 'col-md-3'}} control-label\">{{to.label}} {{to.required ? \"*\" : \"\"}}</label><div class=\"{{::to.controllCss || 'col-md-9'}}\"><formly-transclude></formly-transclude></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 319 */
/***/ function(module, exports) {

	var path = 'app/components/common/forms/templates/horizontalCheckbox.html';
	var html = "<div class=\"col-sm-offset-3 col-sm-8\"><formly-transclude></formly-transclude></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 320 */
/***/ function(module, exports) {

	var path = 'app/components/common/forms/templates/validation.html';
	var html = "<formly-transclude></formly-transclude><div ng-messages=\"fc.$error\" ng-if=\"options.validation.errorExistsAndShouldBeVisible\" class=\"field-error-messages\"><div ng-message=\"{{ ::name }}\" ng-repeat=\"(name, message) in ::options.validation.messages\" class=\"message\">{{ message(fc.$viewValue, fc.$modelValue, this)}}</div><div ng-messages-include=\"app/components/common/forms/templates/errorMessages.html\"></div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 321 */
/***/ function(module, exports) {

	var path = 'app/components/common/forms/templates/errorMessages.html';
	var html = "<div ng-message=\"required\" class=\"field-error-messages\">Obavezno polje</div><div ng-message=\"minlength\" class=\"field-error-messages\">Unos je predug</div><div ng-message=\"maxlength\" class=\"field-error-messages\">Unos je prekratak</div><div ng-message=\"email\" class=\"field-error-messages\">Neispravna e-mail adresa</div><div ng-message=\"datemask\" class=\"field-error-messages\">Neispravan datum</div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 322 */
/***/ function(module, exports) {

	var path = 'app/components/common/forms/templates/ui-select.html';
	var html = "<div class=\"input-group\"><ui-select ng-model=\"model[options.key]\" theme=\"bootstrap\" ng-required=\"{{to.required}}\" ng-disabled=\"{{to.disabled}}\" reset-search-input=\"false\" on-select=\"ctrl.onRemove($item, $model)\"><ui-select-match placeholder=\"{{to.placeholder}}\">{{$select.selected[to.labelProp || 'name']}}</ui-select-match><ui-select-choices group-by=\"to.groupBy\" repeat=\"option[to.valueProp || 'value'] as option in to.options | filter: $select.search track by option.id\"><div ng-bind-html=\"option[to.labelProp || 'name'] | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"input-group-addon\" ng-style=\"{cursor: 'pointer'}\" ng-click=\"model[options.key]=null\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 323 */
/***/ function(module, exports) {

	var path = 'app/components/common/forms/templates/ui-select-async.html';
	var html = "<div class=\"input-group\"><ui-select on-select=\"onSelect($item, $model)\" ng-model=\"model[options.key]\" theme=\"bootstrap\" ng-required=\"{{to.required}}\" ng-disabled=\"{{to.disabled}}\" on-remove=\"onRemove($item, $model)\"><ui-select-match placeholder=\"{{to.placeholder}}\">{{$select.selected[to.labelProp || 'name']}}</ui-select-match><ui-select-choices repeat=\"option[to.valueProp || 'value'] as option in to.options\" refresh=\"to.refresh($select.search, options)\" refresh-delay=\"{{to.refreshDelay}}\"><div ng-bind-html=\"option[to.labelProp || 'name'] | highlight: $select.search\"></div></ui-select-choices></ui-select><div ng-if=\"true\" class=\"input-group-addon\" ng-style=\"{cursor: 'pointer'}\" ng-click=\"model[options.key]=null\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></div><div class=\"input-group-addon\" ng-if=\"to.addon\" ng-style=\"{cursor: to.addonRight.onClick ? 'pointer' : 'inherit'}\" ng-click=\"to.addon.onClick(options, this, $event)\"><i class=\"{{to.addon.class}}\" ng-if=\"to.addon.class\"></i> <span ng-if=\"to.addon.text\">{{to.addon.text}}</span></div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 324 */
/***/ function(module, exports) {

	var path = 'app/components/common/forms/templates/feed.html';
	var html = "<div style=\"overflow-y: scroll; height: 500px\" ng-hide=\"!model[options.key]\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Postojeći unosi</h5><div class=\"ibox-tools\"><span class=\"label label-warning-light pull-right\">{{model[options.key].length}} pregleda</span></div></div><div class=\"ibox-content\"><div><div class=\"feed-activity-list\"><div class=\"feed-element\" ng-repeat=\"item in model[options.key]\"><div class=\"media-body\"><strong>Datum posjete</strong><small class=\"text-muted\">&nbsp{{item.datum | date:'dd.MM.yyyy'}}</small><br><small class=\"text-muted\">{{item.dijagnoza_text}}</small><div class=\"well\">{{item.napomena}}</div></div></div></div></div></div></div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _compileJs = __webpack_require__(326);
	
	var _compileJs2 = _interopRequireDefault(_compileJs);
	
	var utils = _angular2['default'].module('utils', []);
	
	utils.directive('compile', _compileJs2['default']);
	
	exports.utils = utils;

/***/ },
/* 326 */
/***/ function(module, exports) {

	// @see https://docs.angularjs.org/api/ng/service/$compile
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = Compile;
	
	function Compile($injector) {
	    var $compile = $injector.get('$compile');
	
	    return {
	        transclude: true,
	        link: function link(scope, element, attrs, controller, transcludeFn) {
	            var unbindWatcher = scope.$watch(function (scope) {
	                // watch the 'compile' expression for changes
	                return scope.$eval(attrs.compile);
	            }, function (value) {
	                if (false === value || undefined === value) {
	                    // use the default tag content
	                    transcludeFn(scope, function (clone) {
	                        element.append(clone);
	                    });
	                    return;
	                }
	                // when the 'compile' expression changes assign it into the current DOM
	                element.html(value);
	
	                // compile the new DOM and link it to the current scope.
	                $compile(element.contents())(scope);
	
	                if (attrs.compileOnce == 'true') {
	                    unbindWatcher();
	                }
	            });
	        }
	    };
	}
	
	Compile.$inject = ['$injector'];
	module.exports = exports['default'];

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _FactoryJs = __webpack_require__(328);
	
	var _FactoryJs2 = _interopRequireDefault(_FactoryJs);
	
	var AppConfiguration = (function () {
	    function AppConfiguration() {
	        _classCallCheck(this, AppConfiguration);
	
	        this._config = null;
	        this.factory = new _FactoryJs2['default']();
	    }
	
	    // class AppConfigurationUIRouter extends AppConfiguration {
	
	    //     $get($state) {
	
	    //     }
	    // }
	
	    _createClass(AppConfiguration, [{
	        key: 'configure',
	        value: function configure(config) {
	            this._config = config;
	        }
	    }, {
	        key: '$get',
	        value: function $get() {
	            var _this = this;
	
	            var appConf = function appConf() {
	                return _this._config;
	            };
	
	            appConf.application = this.application.bind(this);
	            appConf.menu = this.menu.bind(this);
	            appConf.entity = this.entity.bind(this);
	            appConf.configure = this.configure.bind(this);
	            appConf.field = this.field.bind(this);
	            // appConf.setFactory = this.setFactory.bind(this);
	
	            return appConf;
	        }
	    }, {
	        key: 'application',
	        value: function application(name) {
	            return this.factory.application(name);
	        }
	    }, {
	        key: 'menu',
	        value: function menu(entity) {
	            return this.factory.menu(entity);
	        }
	    }, {
	        key: 'entity',
	        value: function entity(name) {
	            return this.factory.entity(name);
	        }
	    }, {
	        key: 'field',
	        value: function field(name, type) {
	            return this.factory.field(name, type);
	        }
	    }, {
	        key: 'setfactroy',
	        value: function setfactroy(factory) {
	            this.factory = factory;
	        }
	    }]);
	
	    return AppConfiguration;
	})();
	
	var configurationModule = _angular2['default'].module('ConfigurationModule', []);
	
	configurationModule.provider('AppConfiguration', AppConfiguration);
	
	exports.configurationModule = configurationModule;

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _ApplicationJs = __webpack_require__(329);
	
	var _ApplicationJs2 = _interopRequireDefault(_ApplicationJs);
	
	var _EntityEntity = __webpack_require__(331);
	
	var _EntityEntity2 = _interopRequireDefault(_EntityEntity);
	
	// import DataStore from "./DataStore/DataStore";
	// import PromisesResolver from "./Utils/PromisesResolver";
	
	// import ReadQueries from "./Queries/ReadQueries";
	// import WriteQueries from "./Queries/WriteQueries";
	
	var _FieldField = __webpack_require__(333);
	
	var _FieldField2 = _interopRequireDefault(_FieldField);
	
	var _FieldBooleanField = __webpack_require__(348);
	
	var _FieldBooleanField2 = _interopRequireDefault(_FieldBooleanField);
	
	var _FieldChoiceField = __webpack_require__(349);
	
	var _FieldChoiceField2 = _interopRequireDefault(_FieldChoiceField);
	
	var _FieldChoicesField = __webpack_require__(350);
	
	var _FieldChoicesField2 = _interopRequireDefault(_FieldChoicesField);
	
	var _FieldDateField = __webpack_require__(351);
	
	var _FieldDateField2 = _interopRequireDefault(_FieldDateField);
	
	var _FieldDateTimeField = __webpack_require__(352);
	
	var _FieldDateTimeField2 = _interopRequireDefault(_FieldDateTimeField);
	
	var _FieldEmailField = __webpack_require__(353);
	
	var _FieldEmailField2 = _interopRequireDefault(_FieldEmailField);
	
	var _FieldEmbeddedListField = __webpack_require__(354);
	
	var _FieldEmbeddedListField2 = _interopRequireDefault(_FieldEmbeddedListField);
	
	var _FieldFloatFieldJs = __webpack_require__(355);
	
	var _FieldFloatFieldJs2 = _interopRequireDefault(_FieldFloatFieldJs);
	
	var _FieldFileField = __webpack_require__(357);
	
	var _FieldFileField2 = _interopRequireDefault(_FieldFileField);
	
	var _FieldJsonField = __webpack_require__(358);
	
	var _FieldJsonField2 = _interopRequireDefault(_FieldJsonField);
	
	var _FieldNumberField = __webpack_require__(356);
	
	var _FieldNumberField2 = _interopRequireDefault(_FieldNumberField);
	
	var _FieldPasswordField = __webpack_require__(359);
	
	var _FieldPasswordField2 = _interopRequireDefault(_FieldPasswordField);
	
	var _FieldReferenceField = __webpack_require__(360);
	
	var _FieldReferenceField2 = _interopRequireDefault(_FieldReferenceField);
	
	var _FieldReferencedListField = __webpack_require__(361);
	
	var _FieldReferencedListField2 = _interopRequireDefault(_FieldReferencedListField);
	
	var _FieldReferenceManyField = __webpack_require__(362);
	
	var _FieldReferenceManyField2 = _interopRequireDefault(_FieldReferenceManyField);
	
	var _FieldTemplateField = __webpack_require__(363);
	
	var _FieldTemplateField2 = _interopRequireDefault(_FieldTemplateField);
	
	var _FieldTextField = __webpack_require__(364);
	
	var _FieldTextField2 = _interopRequireDefault(_FieldTextField);
	
	var _FieldWysiwygField = __webpack_require__(365);
	
	var _FieldWysiwygField2 = _interopRequireDefault(_FieldWysiwygField);
	
	var _MenuMenuJs = __webpack_require__(330);
	
	var _MenuMenuJs2 = _interopRequireDefault(_MenuMenuJs);
	
	// import Collection from './Collection';
	// import Dashboard from './Dashboard';
	// import Entry from './Entry';
	
	var Factory = (function () {
	    function Factory() {
	        _classCallCheck(this, Factory);
	
	        this._fieldTypes = [];
	        this._init();
	    }
	
	    _createClass(Factory, [{
	        key: "application",
	        value: function application(name, debug) {
	            return new _ApplicationJs2["default"](name, debug);
	        }
	    }, {
	        key: "entity",
	        value: function entity(name) {
	            return new _EntityEntity2["default"](name);
	        }
	    }, {
	        key: "field",
	        value: function field(name, type) {
	            type = type || 'string';
	
	            if (!(type in this._fieldTypes)) {
	                throw new Error("Unknown field type \"" + type + "\".");
	            }
	
	            return new this._fieldTypes[type](name);
	        }
	    }, {
	        key: "registerFieldType",
	        value: function registerFieldType(name, constructor) {
	            this._fieldTypes[name] = constructor;
	        }
	    }, {
	        key: "getFieldConstructor",
	        value: function getFieldConstructor(name) {
	            return this._fieldTypes[name];
	        }
	    }, {
	        key: "menu",
	        value: function menu(entity) {
	            var menu = new _MenuMenuJs2["default"]();
	            if (entity) {
	                menu.populateFromEntity(entity);
	            }
	            return menu;
	        }
	    }, {
	        key: "dashboard",
	        value: function dashboard() {
	            return new Dashboard();
	        }
	    }, {
	        key: "collection",
	        value: function collection(entity) {
	            var collection = new Collection();
	            if (entity) {
	                collection.setEntity(entity);
	            }
	            return collection;
	        }
	    }, {
	        key: "getEntryConstructor",
	        value: function getEntryConstructor() {
	            return Entry;
	        }
	    }, {
	        key: "getDataStore",
	        value: function getDataStore() {
	            return new DataStore();
	        }
	    }, {
	        key: "getReadQueries",
	        value: function getReadQueries(RestWrapper, PromisesResolver, Application) {
	            return new ReadQueries(RestWrapper, PromisesResolver, Application);
	        }
	    }, {
	        key: "getWriteQueries",
	        value: function getWriteQueries(RestWrapper, PromisesResolver, Application) {
	            return new WriteQueries(RestWrapper, PromisesResolver, Application);
	        }
	    }, {
	        key: "getPromisesResolver",
	        value: function getPromisesResolver() {
	            return PromisesResolver;
	        }
	    }, {
	        key: "_init",
	        value: function _init() {
	            this.registerFieldType('boolean', _FieldBooleanField2["default"]);
	            this.registerFieldType('choice', _FieldChoiceField2["default"]);
	            this.registerFieldType('choices', _FieldChoicesField2["default"]);
	            this.registerFieldType('date', _FieldDateField2["default"]);
	            this.registerFieldType('datetime', _FieldDateTimeField2["default"]);
	            this.registerFieldType('email', _FieldEmailField2["default"]);
	            this.registerFieldType('embedded_list', _FieldEmbeddedListField2["default"]);
	            this.registerFieldType('float', _FieldFloatFieldJs2["default"]);
	            this.registerFieldType('string', _FieldField2["default"]);
	            this.registerFieldType('file', _FieldFileField2["default"]);
	            this.registerFieldType('json', _FieldJsonField2["default"]);
	            this.registerFieldType('number', _FieldNumberField2["default"]);
	            this.registerFieldType('password', _FieldPasswordField2["default"]);
	            this.registerFieldType('reference', _FieldReferenceField2["default"]);
	            this.registerFieldType('reference_many', _FieldReferenceManyField2["default"]);
	            this.registerFieldType('referenced_list', _FieldReferencedListField2["default"]);
	            this.registerFieldType('template', _FieldTemplateField2["default"]);
	            this.registerFieldType('text', _FieldTextField2["default"]);
	            this.registerFieldType('wysiwyg', _FieldWysiwygField2["default"]);
	        }
	    }]);
	
	    return Factory;
	})();
	
	exports["default"] = Factory;
	module.exports = exports["default"];

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _MenuMenuJs = __webpack_require__(330);
	
	var _MenuMenuJs2 = _interopRequireDefault(_MenuMenuJs);
	
	var Application = (function () {
	    function Application() {
	        var title = arguments.length <= 0 || arguments[0] === undefined ? '' : arguments[0];
	        var debug = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
	        _classCallCheck(this, Application);
	
	        this._baseApiUrl = '';
	        this._customTemplate = function (viewName) {};
	        this._title = title;
	        this._menu = null;
	        this._dashboard = null;
	        this._layout = false;
	        this._header = false;
	        this._entities = [];
	        this._errorMessage = this.defaultErrorMessage;
	        this._debug = debug;
	    }
	
	    // defaultErrorMessage(response) {
	    //     let body = response.data;
	
	    //     if (typeof body === 'object') {
	    //         body = JSON.stringify(body);
	    //     }
	
	    //     return 'Oops, an error occured : (code: ' + response.status + ') ' + body;
	    // }
	
	    _createClass(Application, [{
	        key: 'title',
	
	        // getViewsOfType(type) {
	        //     return orderElement.order(
	        //         this.entities.map(entity => entity.views[type])
	        //                      .filter(view => view.enabled)
	        //     );
	        // }
	
	        // getRouteFor(entity, viewUrl, viewType, identifierValue, identifierName) {
	        //     let baseApiUrl = entity.baseApiUrl() || this.baseApiUrl(),
	        //         url = viewUrl || entity.getUrl(viewType, identifierValue, identifierName);
	
	        //     // If the view or the entity don't define the url, retrieve it from the baseURL of the entity or the app
	        //     if (!url) {
	        //         url = baseApiUrl + encodeURIComponent(entity.name());
	        //         if (identifierValue != null) {
	        //             url += '/' + encodeURIComponent(identifierValue);
	        //         }
	        //     } else if (!/^(?:[a-z]+:)?\/\//.test(url)) {
	        //         // Add baseUrl for relative URL
	        //         url = baseApiUrl + url;
	        //     }
	
	        //     return url;
	        // }
	
	        // debug(debug) {
	        //     if (!arguments.length) return this._debug;
	        //     this._debug = debug;
	        //     return this;
	        // }
	
	        // layout(layout) {
	        //     if (!arguments.length) return this._layout;
	        //     this._layout = layout;
	        //     return this;
	        // }
	
	        // header(header) {
	        //     if (!arguments.length) return this._header;
	        //     this._header = header;
	        //     return this;
	        // }
	
	        value: function title(_title) {
	            if (!arguments.length) return this._title;
	            this._title = _title;
	            return this;
	        }
	
	        /**
	         * Getter/Setter for the main application menu
	         *
	         * If the getter is called first, it will return a menu based on entities.
	         *
	         *     application.addEntity(new Entity('posts'));
	         *     application.addEntity(new Entity('comments'));
	         *     application.menu(); // Menu { children: [ Menu { title: "Posts" }, Menu { title: "Comments" } ]}
	         *
	         * If the setter is called first, all subsequent calls to the getter will return the set menu.
	         *
	         *     application.addEntity(new Entity('posts'));
	         *     application.addEntity(new Entity('comments'));
	         *     application.menu(new Menu().addChild(new Menu().title('Foo')));
	         *     application.menu(); // Menu { children: [ Menu { title: "Foo" } ]}
	         *
	         * @see Menu
	         */
	    }, {
	        key: 'menu',
	        value: function menu(_menu) {
	            if (!arguments.length) {
	                if (!this._menu) {
	                    this._menu = this.buildMenuFromEntities();
	                }
	                return this._menu;
	            }
	
	            this._menu = _menu;
	            return this;
	        }
	    }, {
	        key: 'buildMenuFromEntities',
	        value: function buildMenuFromEntities() {
	            return new _MenuMenuJs2['default']().children(this.entities.filter(function (entity) {
	                return entity.menuView().enabled;
	            }).sort(function (e1, e2) {
	                return e1.menuView().order() - e2.menuView().order();
	            }).map(function (entity) {
	                return new _MenuMenuJs2['default']().populateFromEntity(entity);
	            }));
	        }
	
	        // dashboard(dashboard) {
	        //     if (!arguments.length) {
	        //             if (!this._dashboard) {
	        //                 this._dashboard = this.buildDashboardFromEntities();
	        //             }
	        //             return this._dashboard
	        //     }
	        //     this._dashboard = dashboard;
	        //     return this;
	        // }
	
	        // buildDashboardFromEntities() {
	        //     let dashboard = new Dashboard()
	        //     this.entities
	        //         .filter(entity => entity.dashboardView().enabled)
	        //         .map(entity => {
	        //             dashboard.addCollection(entity.dashboardView()); // yep, a collection is a ListView, and so is a DashboardView - forgive this duck typing for BC sake
	        //         });
	        //     if (!dashboard.hasCollections()) {
	        //         // still no collection from dashboardViews, let's use listViews instead
	        //         this.entities
	        //             .filter(entity => entity.listView().enabled)
	        //             .map((entity, index) => {
	        //                 let collection = new Collection();
	        //                 let listView = entity.listView();
	        //                 collection.setEntity(entity);
	        //                 collection.perPage(listView.perPage())
	        //                 collection.sortField(listView.sortField())
	        //                 collection.sortDir(listView.sortDir())
	        //                 collection.order(index);
	        //                 // use only the first 3 cols
	        //                 collection.fields(listView.fields().filter((el, index) => index < 3));
	        //                 dashboard.addCollection(collection);
	        //             });
	        //     }
	        //     return dashboard;
	        // }
	
	        // customTemplate(customTemplate) {
	        //     if (!arguments.length) return this._customTemplate;
	        //     this._customTemplate = customTemplate;
	        //     return this;
	        // }
	
	    }, {
	        key: 'baseApiUrl',
	        value: function baseApiUrl(url) {
	            if (!arguments.length) return this._baseApiUrl;
	            this._baseApiUrl = url;
	            return this;
	        }
	    }, {
	        key: 'addEntity',
	        value: function addEntity(entity) {
	            if (!entity) {
	                throw new Error("No entity given");
	            }
	
	            this._entities.push(entity);
	
	            return this;
	        }
	    }, {
	        key: 'getEntity',
	        value: function getEntity(entityName) {
	            var foundEntity = this._entities.filter(function (e) {
	                return e.name() === entityName;
	            })[0];
	            if (!foundEntity) {
	                throw new Error('Unable to find entity "' + entityName + '"');
	            }
	
	            return foundEntity;
	        }
	    }, {
	        key: 'hasEntity',
	        value: function hasEntity(fieldName) {
	            return !!this._entities.filter(function (f) {
	                return f.name() === fieldName;
	            }).length;
	        }
	    }, {
	        key: 'getViewByEntityAndType',
	        value: function getViewByEntityAndType(entityName, type) {
	            return this._entities.filter(function (e) {
	                return e.name() === entityName;
	            })[0].views[type];
	        }
	    }, {
	        key: 'getErrorMessage',
	        value: function getErrorMessage(response) {
	            if (typeof this._errorMessage === 'function') {
	                return this._errorMessage(response);
	            }
	
	            return this._errorMessage;
	        }
	    }, {
	        key: 'errorMessage',
	        value: function errorMessage(_errorMessage) {
	            if (!arguments.length) return this._errorMessage;
	            this._errorMessage = _errorMessage;
	            return this;
	        }
	    }, {
	        key: 'getErrorMessageFor',
	        value: function getErrorMessageFor(view, response) {
	            return view.getErrorMessage(response) || view.getEntity().getErrorMessage(response) || this.getErrorMessage(response);
	        }
	    }, {
	        key: 'getEntityNames',
	        value: function getEntityNames() {
	            return this.entities.map(function (f) {
	                return f.name();
	            });
	        }
	    }, {
	        key: 'entities',
	        get: function get() {
	            return this._entities;
	        }
	    }]);
	
	    return Application;
	})();
	
	exports['default'] = Application;
	module.exports = exports['default'];

/***/ },
/* 330 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function alwaysFalse() {
	    return false;
	}
	
	var uuid = 0;
	var _autoClose = true;
	
	var Menu = (function () {
	    function Menu() {
	        _classCallCheck(this, Menu);
	
	        this._link = null;
	        this._activeFunc = alwaysFalse;
	        this._title = null;
	        this._icon = false;
	        this._children = [];
	        this._template = false;
	        this._autoClose = true;
	        this.uuid = uuid++;
	    }
	
	    _createClass(Menu, [{
	        key: 'title',
	        value: function title() {
	            if (arguments.length) {
	                this._title = arguments[0];
	                return this;
	            }
	            return this._title;
	        }
	    }, {
	        key: 'isLink',
	        value: function isLink() {
	            return !!this._link;
	        }
	    }, {
	        key: 'link',
	        value: function link() {
	            var _this = this;
	
	            if (arguments.length) {
	                this._link = arguments[0];
	                if (this._activeFunc == alwaysFalse) {
	                    this._activeFunc = function (url) {
	                        return url.indexOf(_this._link) === 0;
	                    };
	                }
	                return this;
	            }
	            return this._link;
	        }
	    }, {
	        key: 'autoClose',
	        value: function autoClose() {
	            if (arguments.length) {
	                _autoClose = arguments[0];
	                return this;
	            }
	            return _autoClose;
	        }
	    }, {
	        key: 'active',
	        value: function active(activeFunc) {
	            if (arguments.length) {
	                this._activeFunc = arguments[0];
	                return this;
	            }
	            return this._activeFunc;
	        }
	    }, {
	        key: 'isActive',
	        value: function isActive(url) {
	            return this._activeFunc(url);
	            // return true;
	        }
	    }, {
	        key: 'isChildActive',
	        value: function isChildActive(url) {
	            return this.isActive(url) || this.children().filter(function (menu) {
	                return menu.isChildActive(url);
	            }).length > 0;
	        }
	    }, {
	        key: 'addChild',
	        value: function addChild(child) {
	            if (!(child instanceof Menu)) {
	                throw new Error('Only Menu instances are accepted as children of a Menu');
	            }
	            this._children.push(child);
	            return this;
	        }
	    }, {
	        key: 'hasChild',
	        value: function hasChild() {
	            return this._children.length > 0;
	        }
	    }, {
	        key: 'getChildByTitle',
	        value: function getChildByTitle(title) {
	            return this.children().filter(function (child) {
	                return child.title() == title;
	            }).pop();
	        }
	    }, {
	        key: 'children',
	        value: function children() {
	            if (arguments.length) {
	                this._children = arguments[0];
	                return this;
	            }
	            return this._children;
	        }
	    }, {
	        key: 'icon',
	        value: function icon() {
	            if (arguments.length) {
	                this._icon = arguments[0];
	                return this;
	            }
	            return this._icon;
	        }
	    }, {
	        key: 'template',
	        value: function template() {
	            if (arguments.length) {
	                this._template = arguments[0];
	                return this;
	            }
	            return this._template;
	        }
	
	        // populateFromEntity(entity) {
	        //     if (!(entity instanceof Entity)) {
	        //         throw new Error('populateFromEntity() only accepts an Entity parameter');
	        //     }
	        //     this.title(entity.label());
	        //     this.active(path => path.indexOf(`/${entity.name()}/`) === 0 );
	        //     this.link(`/${entity.name()}/list`);
	        //     // deprecated
	        //     this.icon(entity.menuView().icon());
	        //     return this;
	        // }
	    }]);
	
	    return Menu;
	})();
	
	exports['default'] = Menu;
	module.exports = exports['default'];

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _UtilsStringUtils = __webpack_require__(332);
	
	var _UtilsStringUtils2 = _interopRequireDefault(_UtilsStringUtils);
	
	var _FieldField = __webpack_require__(333);
	
	var _FieldField2 = _interopRequireDefault(_FieldField);
	
	var _ViewDashboardView = __webpack_require__(334);
	
	var _ViewDashboardView2 = _interopRequireDefault(_ViewDashboardView);
	
	var _ViewMenuView = __webpack_require__(341);
	
	var _ViewMenuView2 = _interopRequireDefault(_ViewMenuView);
	
	var _ViewListView = __webpack_require__(335);
	
	var _ViewListView2 = _interopRequireDefault(_ViewListView);
	
	var _ViewCreateView = __webpack_require__(342);
	
	var _ViewCreateView2 = _interopRequireDefault(_ViewCreateView);
	
	var _ViewEditView = __webpack_require__(343);
	
	var _ViewEditView2 = _interopRequireDefault(_ViewEditView);
	
	var _ViewDeleteView = __webpack_require__(344);
	
	var _ViewDeleteView2 = _interopRequireDefault(_ViewDeleteView);
	
	var _ViewShowView = __webpack_require__(345);
	
	var _ViewShowView2 = _interopRequireDefault(_ViewShowView);
	
	var _ViewBatchDeleteView = __webpack_require__(346);
	
	var _ViewBatchDeleteView2 = _interopRequireDefault(_ViewBatchDeleteView);
	
	var _ViewExportView = __webpack_require__(347);
	
	var _ViewExportView2 = _interopRequireDefault(_ViewExportView);
	
	var index = 0;
	
	var Entity = (function () {
	    function Entity(name) {
	        _classCallCheck(this, Entity);
	
	        this._name = name;
	        this._uniqueId = this._name + '_' + index++;
	        this._baseApiUrl = null;
	        this._label = null;
	        this._identifierField = new _FieldField2["default"]("id");
	        this._isReadOnly = false;
	        this._errorMessage = null;
	        this._order = 0;
	        this._url = null;
	        this._createMethod = null; // manually set the HTTP-method for create operation, defaults to post
	        this._updateMethod = null; // manually set the HTTP-method for update operation, defaults to put
	        this._retrieveMethod = null; // manually set the HTTP-method for the get operation, defaults to get
	        this._deleteMethod = null; // manually set the HTTP-method for the delete operation, defaults to delete
	
	        this._initViews();
	    }
	
	    _createClass(Entity, [{
	        key: "label",
	        value: function label() {
	            if (arguments.length) {
	                this._label = arguments[0];
	                return this;
	            }
	
	            if (this._label === null) {
	                return _UtilsStringUtils2["default"].camelCase(this._name);
	            }
	
	            return this._label;
	        }
	    }, {
	        key: "name",
	        value: function name() {
	            if (arguments.length) {
	                this._name = arguments[0];
	                return this;
	            }
	
	            return this._name;
	        }
	    }, {
	        key: "menuView",
	        value: function menuView() {
	            return this._views["MenuView"];
	        }
	    }, {
	        key: "dashboardView",
	        value: function dashboardView() {
	            return this._views["DashboardView"];
	        }
	    }, {
	        key: "listView",
	        value: function listView() {
	            return this._views["ListView"];
	        }
	    }, {
	        key: "creationView",
	        value: function creationView() {
	            return this._views["CreateView"];
	        }
	    }, {
	        key: "editionView",
	        value: function editionView() {
	            return this._views["EditView"];
	        }
	    }, {
	        key: "deletionView",
	        value: function deletionView() {
	            return this._views["DeleteView"];
	        }
	    }, {
	        key: "batchDeleteView",
	        value: function batchDeleteView() {
	            return this._views["BatchDeleteView"];
	        }
	    }, {
	        key: "exportView",
	        value: function exportView() {
	            return this._views["ExportView"];
	        }
	    }, {
	        key: "showView",
	        value: function showView() {
	            return this._views["ShowView"];
	        }
	    }, {
	        key: "baseApiUrl",
	        value: function baseApiUrl(_baseApiUrl) {
	            if (!arguments.length) return this._baseApiUrl;
	            this._baseApiUrl = _baseApiUrl;
	            return this;
	        }
	    }, {
	        key: "_initViews",
	        value: function _initViews() {
	            this._views = {
	                "DashboardView": new _ViewDashboardView2["default"]().setEntity(this),
	                "MenuView": new _ViewMenuView2["default"]().setEntity(this),
	                "ListView": new _ViewListView2["default"]().setEntity(this),
	                "CreateView": new _ViewCreateView2["default"]().setEntity(this),
	                "EditView": new _ViewEditView2["default"]().setEntity(this),
	                "DeleteView": new _ViewDeleteView2["default"]().setEntity(this),
	                "BatchDeleteView": new _ViewBatchDeleteView2["default"]().setEntity(this),
	                "ExportView": new _ViewExportView2["default"]().setEntity(this),
	                "ShowView": new _ViewShowView2["default"]().setEntity(this)
	            };
	        }
	    }, {
	        key: "identifier",
	        value: function identifier(value) {
	            if (!arguments.length) return this._identifierField;
	            if (!(value instanceof _FieldField2["default"])) {
	                throw new Error('Entity ' + this.name() + ': identifier must be an instance of Field.');
	            }
	            this._identifierField = value;
	            return this;
	        }
	    }, {
	        key: "readOnly",
	        value: function readOnly() {
	            this._isReadOnly = true;
	
	            this._views["CreateView"].disable();
	            this._views["EditView"].disable();
	            this._views["DeleteView"].disable();
	            this._views["BatchDeleteView"].disable();
	
	            return this;
	        }
	    }, {
	        key: "getErrorMessage",
	        value: function getErrorMessage(response) {
	            if (typeof this._errorMessage === 'function') {
	                return this._errorMessage(response);
	            }
	
	            return this._errorMessage;
	        }
	    }, {
	        key: "errorMessage",
	        value: function errorMessage(_errorMessage) {
	            if (!arguments.length) return this._errorMessage;
	            this._errorMessage = _errorMessage;
	            return this;
	        }
	    }, {
	        key: "order",
	        value: function order(_order) {
	            if (!arguments.length) return this._order;
	            this._order = _order;
	            return this;
	        }
	    }, {
	        key: "url",
	        value: function url(_url) {
	            if (!arguments.length) return this._url;
	            this._url = _url;
	            return this;
	        }
	    }, {
	        key: "getUrl",
	        value: function getUrl(viewType, identifierValue, identifierName) {
	            if (typeof this._url === 'function') {
	                return this._url(this.name(), viewType, identifierValue, identifierName);
	            }
	
	            return this._url;
	        }
	    }, {
	        key: "createMethod",
	        value: function createMethod(_createMethod) {
	            if (!arguments.length) return this._createMethod;
	            this._createMethod = _createMethod;
	            return this;
	        }
	    }, {
	        key: "updateMethod",
	        value: function updateMethod(_updateMethod) {
	            if (!arguments.length) return this._updateMethod;
	            this._updateMethod = _updateMethod;
	            return this;
	        }
	    }, {
	        key: "retrieveMethod",
	        value: function retrieveMethod(_retrieveMethod) {
	            if (!arguments.length) return this._retrieveMethod;
	            this._retrieveMethod = _retrieveMethod;
	            return this;
	        }
	    }, {
	        key: "deleteMethod",
	        value: function deleteMethod(_deleteMethod) {
	            if (!arguments.length) return this._deleteMethod;
	            this._deleteMethod = _deleteMethod;
	            return this;
	        }
	    }, {
	        key: "uniqueId",
	        get: function get() {
	            return this._uniqueId;
	        }
	    }, {
	        key: "views",
	        get: function get() {
	            return this._views;
	        }
	    }, {
	        key: "isReadOnly",
	        get: function get() {
	            return this._isReadOnly;
	        }
	    }]);
	
	    return Entity;
	})();
	
	exports["default"] = Entity;
	module.exports = exports["default"];

/***/ },
/* 332 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = {
	    /**
	     * @see http://stackoverflow.com/questions/10425287/convert-string-to-camelcase-with-regular-expression
	     * @see http://phpjs.org/functions/ucfirst/
	     */
	    camelCase: function camelCase(text) {
	        if (!text) {
	            return text;
	        }
	
	        var f = text.charAt(0).toUpperCase();
	        text = f + text.substr(1);
	
	        return text.replace(/[-_.\s](.)/g, function (match, group1) {
	            return ' ' + group1.toUpperCase();
	        });
	    }
	};
	module.exports = exports['default'];

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _UtilsStringUtils = __webpack_require__(332);
	
	var _UtilsStringUtils2 = _interopRequireDefault(_UtilsStringUtils);
	
	var Field = (function () {
	    function Field(name) {
	        _classCallCheck(this, Field);
	
	        this._name = name || Math.random().toString(36).substring(7);
	        this._detailLink = name === 'id';
	        this._type = "string";
	        this._order = null;
	        this._label = null;
	        this._maps = [];
	        this._transforms = [];
	        this._attributes = {};
	        this._cssClasses = null;
	        this._validation = { required: false, minlength: 0, maxlength: 99999 };
	        this._defaultValue = null;
	        this._editable = true;
	        this._sortable = true;
	        this._detailLinkRoute = 'edit';
	        this._pinned = false;
	        this._flattenable = true;
	        this.dashboard = true;
	        this.list = true;
	        this._template = function () {
	            return '';
	        };
	        this._templateIncludesLabel = false;
	        this._hidden = false;
	    }
	
	    _createClass(Field, [{
	        key: "label",
	        value: function label() {
	            if (arguments.length) {
	                this._label = arguments[0];
	                return this;
	            }
	
	            if (this._label === null) {
	                return _UtilsStringUtils2["default"].camelCase(this._name);
	            }
	
	            return this._label;
	        }
	    }, {
	        key: "type",
	        value: function type() {
	            return this._type;
	        }
	    }, {
	        key: "hidden",
	        value: function hidden(value) {
	            this._hidden = value;
	            return this;
	        }
	    }, {
	        key: "name",
	        value: function name() {
	            if (arguments.length) {
	                this._name = arguments[0];
	                return this;
	            }
	
	            return this._name;
	        }
	    }, {
	        key: "order",
	        value: function order() {
	            if (arguments.length) {
	                if (arguments[1] !== true) {
	                    console.warn('Setting order with Field.order is deprecated, order directly in fields array');
	                }
	                this._order = arguments[0];
	                return this;
	            }
	
	            return this._order;
	        }
	    }, {
	        key: "isDetailLink",
	        value: function isDetailLink(detailLink) {
	            if (arguments.length) {
	                this._detailLink = arguments[0];
	                return this;
	            }
	
	            if (this._detailLink === null) {
	                return this._name === 'id';
	            }
	
	            return this._detailLink;
	        }
	    }, {
	        key: "map",
	
	        /**
	         * Add a function to be applied to the response object to turn it into an entry
	         */
	        value: function map(fn) {
	            if (!fn) return this._maps;
	            if (typeof fn !== "function") {
	                var type = typeof fn;
	                throw new Error("Map argument should be a function, " + type + " given.");
	            }
	
	            this._maps.push(fn);
	
	            return this;
	        }
	    }, {
	        key: "hasMaps",
	        value: function hasMaps() {
	            return !!this._maps.length;
	        }
	    }, {
	        key: "getMappedValue",
	        value: function getMappedValue(value, entry) {
	            for (var i in this._maps) {
	                value = this._maps[i](value, entry);
	            }
	
	            return value;
	        }
	
	        /**
	         * Add a function to be applied to the entry to turn it into a response object
	         */
	    }, {
	        key: "transform",
	        value: function transform(fn) {
	            if (!fn) return this._transforms;
	            if (typeof fn !== "function") {
	                var type = typeof fn;
	                throw new Error("transform argument should be a function, " + type + " given.");
	            }
	
	            this._transforms.push(fn);
	
	            return this;
	        }
	    }, {
	        key: "hasTranforms",
	        value: function hasTranforms() {
	            return !!this._transforms.length;
	        }
	    }, {
	        key: "getTransformedValue",
	        value: function getTransformedValue(value, entry) {
	            for (var i in this._transforms) {
	                value = this._transforms[i](value, entry);
	            }
	
	            return value;
	        }
	    }, {
	        key: "attributes",
	        value: function attributes(_attributes) {
	            if (!arguments.length) {
	                return this._attributes;
	            }
	
	            this._attributes = _attributes;
	
	            return this;
	        }
	    }, {
	        key: "cssClasses",
	        value: function cssClasses(classes) {
	            if (!arguments.length) return this._cssClasses;
	            this._cssClasses = classes;
	            return this;
	        }
	    }, {
	        key: "getCssClasses",
	        value: function getCssClasses(entry) {
	            if (!this._cssClasses) {
	                return '';
	            }
	
	            if (this._cssClasses.constructor === Array) {
	                return this._cssClasses.join(' ');
	            }
	
	            if (typeof this._cssClasses === 'function') {
	                return this._cssClasses(entry);
	            }
	
	            return this._cssClasses;
	        }
	    }, {
	        key: "validation",
	        value: function validation(_validation) {
	            if (!arguments.length) {
	                return this._validation;
	            }
	
	            for (var property in _validation) {
	                if (!_validation.hasOwnProperty(property)) continue;
	                if (_validation[property] === null) {
	                    delete this._validation[property];
	                } else {
	                    this._validation[property] = _validation[property];
	                }
	            }
	
	            return this;
	        }
	    }, {
	        key: "defaultValue",
	        value: function defaultValue(_defaultValue) {
	            if (!arguments.length) return this._defaultValue;
	            this._defaultValue = _defaultValue;
	            return this;
	        }
	    }, {
	        key: "editable",
	        value: function editable(_editable) {
	            if (!arguments.length) return this._editable;
	            this._editable = _editable;
	            return this;
	        }
	    }, {
	        key: "sortable",
	        value: function sortable(_sortable) {
	            if (!arguments.length) return this._sortable;
	            this._sortable = _sortable;
	            return this;
	        }
	    }, {
	        key: "detailLinkRoute",
	        value: function detailLinkRoute(route) {
	            if (!arguments.length) return this._detailLinkRoute;
	            this._detailLinkRoute = route;
	            return this;
	        }
	    }, {
	        key: "pinned",
	        value: function pinned(_pinned) {
	            if (!arguments.length) return this._pinned;
	            this._pinned = _pinned;
	            return this;
	        }
	    }, {
	        key: "flattenable",
	        value: function flattenable() {
	            return this._flattenable;
	        }
	    }, {
	        key: "getTemplateValue",
	        value: function getTemplateValue(data) {
	            if (typeof this._template === 'function') {
	                return this._template(data);
	            }
	
	            return this._template;
	        }
	    }, {
	        key: "getTemplateValueWithLabel",
	        value: function getTemplateValueWithLabel(data) {
	            return this._templateIncludesLabel ? this.getTemplateValue(data) : false;
	        }
	    }, {
	        key: "templateIncludesLabel",
	        value: function templateIncludesLabel(_templateIncludesLabel) {
	            if (!arguments.length) return this._templateIncludesLabel;
	            this._templateIncludesLabel = _templateIncludesLabel;
	            return this;
	        }
	    }, {
	        key: "template",
	        value: function template(_template) {
	            var templateIncludesLabel = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	            if (!arguments.length) return this._template;
	            this._template = _template;
	            this._templateIncludesLabel = templateIncludesLabel;
	            return this;
	        }
	    }, {
	        key: "detailLink",
	        set: function set(isDetailLink) {
	            return this._detailLink = isDetailLink;
	        }
	    }]);
	
	    return Field;
	})();
	
	exports["default"] = Field;
	module.exports = exports["default"];

/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ListView2 = __webpack_require__(335);
	
	var _ListView3 = _interopRequireDefault(_ListView2);
	
	var DashboardView = (function (_ListView) {
	    _inherits(DashboardView, _ListView);
	
	    function DashboardView() {
	        _classCallCheck(this, DashboardView);
	
	        _get(Object.getPrototypeOf(DashboardView.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(DashboardView, [{
	        key: 'setEntity',
	        value: function setEntity(entity) {
	            this.entity = entity;
	            if (!this._name) {
	                this._name = entity.name();
	            }
	            return this;
	        }
	    }]);
	
	    return DashboardView;
	})(_ListView3['default']);
	
	exports['default'] = DashboardView;
	module.exports = exports['default'];

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _View2 = __webpack_require__(336);
	
	var _View3 = _interopRequireDefault(_View2);
	
	var _UtilsOrderElement = __webpack_require__(340);
	
	var _UtilsOrderElement2 = _interopRequireDefault(_UtilsOrderElement);
	
	var ListView = (function (_View) {
	    _inherits(ListView, _View);
	
	    function ListView(name) {
	        _classCallCheck(this, ListView);
	
	        _get(Object.getPrototypeOf(ListView.prototype), 'constructor', this).call(this, name);
	
	        this._type = 'ListView';
	        this._perPage = 30;
	        this._infinitePagination = false;
	        this._listActions = [];
	        this._batchActions = ['delete'];
	        this._filters = [];
	        this._permanentFilters = {};
	        this._exportFields = null;
	        this._exportOptions = {};
	        this._entryCssClasses = null;
	
	        this._sortField = 'id';
	        this._sortDir = 'DESC';
	    }
	
	    _createClass(ListView, [{
	        key: 'perPage',
	        value: function perPage() {
	            if (!arguments.length) {
	                return this._perPage;
	            }
	            this._perPage = arguments[0];
	            return this;
	        }
	
	        /** @deprecated Use perPage instead */
	    }, {
	        key: 'limit',
	        value: function limit() {
	            if (!arguments.length) {
	                return this.perPage();
	            }
	            return this.perPage(arguments[0]);
	        }
	    }, {
	        key: 'sortField',
	        value: function sortField() {
	            if (arguments.length) {
	                this._sortField = arguments[0];
	                return this;
	            }
	
	            return this._sortField;
	        }
	    }, {
	        key: 'sortDir',
	        value: function sortDir() {
	            if (arguments.length) {
	                this._sortDir = arguments[0];
	                return this;
	            }
	
	            return this._sortDir;
	        }
	    }, {
	        key: 'getSortFieldName',
	        value: function getSortFieldName() {
	            return this.name() + '.' + this._sortField;
	        }
	    }, {
	        key: 'infinitePagination',
	        value: function infinitePagination() {
	            if (arguments.length) {
	                this._infinitePagination = arguments[0];
	                return this;
	            }
	
	            return this._infinitePagination;
	        }
	    }, {
	        key: 'actions',
	        value: function actions(_actions) {
	            if (!arguments.length) {
	                return this._actions;
	            }
	
	            this._actions = _actions;
	
	            return this;
	        }
	    }, {
	        key: 'exportFields',
	        value: function exportFields(_exportFields) {
	            if (!arguments.length) {
	                return this._exportFields;
	            }
	
	            this._exportFields = _exportFields;
	
	            return this;
	        }
	    }, {
	        key: 'exportOptions',
	        value: function exportOptions(_exportOptions) {
	            if (!arguments.length) {
	                return this._exportOptions;
	            }
	
	            this._exportOptions = _exportOptions;
	
	            return this;
	        }
	    }, {
	        key: 'batchActions',
	        value: function batchActions(actions) {
	            if (!arguments.length) {
	                return this._batchActions;
	            }
	
	            this._batchActions = actions;
	
	            return this;
	        }
	
	        /**
	         * Define permanent filters to be added to the REST API calls
	         *
	         *     posts.listView().permanentFilters({
	         *        published: true
	         *     });
	         *     // related API call will be /posts?published=true
	         *
	         * @param {Object} filters list of filters to apply to the call
	         */
	    }, {
	        key: 'permanentFilters',
	        value: function permanentFilters(filters) {
	            if (!arguments.length) {
	                return this._permanentFilters;
	            }
	
	            this._permanentFilters = filters;
	
	            return this;
	        }
	
	        /**
	         * Define filters the user can add to the datagrid
	         *
	         *     posts.listView().filters([
	         *       nga.field('title'),
	         *       nga.field('age', 'number')
	         *     ]);
	         *
	         * @param {Field[]} filters list of filters to add to the GUI
	         */
	    }, {
	        key: 'filters',
	        value: function filters(_filters) {
	            if (!arguments.length) {
	                return this._filters;
	            }
	
	            this._filters = _UtilsOrderElement2['default'].order(_filters);
	
	            return this;
	        }
	    }, {
	        key: 'getFilterReferences',
	        value: function getFilterReferences(withRemoteComplete) {
	            var result = {};
	            var lists = this._filters.filter(function (f) {
	                return f.type() === 'reference';
	            });
	
	            var filterFunction = null;
	            if (withRemoteComplete === true) {
	                filterFunction = function (f) {
	                    return f.remoteComplete();
	                };
	            } else if (withRemoteComplete === false) {
	                filterFunction = function (f) {
	                    return !f.remoteComplete();
	                };
	            }
	
	            if (filterFunction !== null) {
	                lists = lists.filter(filterFunction);
	            }
	
	            for (var i = 0, c = lists.length; i < c; i++) {
	                var list = lists[i];
	                result[list.name()] = list;
	            }
	
	            return result;
	        }
	    }, {
	        key: 'listActions',
	        value: function listActions(actions) {
	            if (!arguments.length) {
	                return this._listActions;
	            }
	
	            this._listActions = actions;
	
	            return this;
	        }
	    }, {
	        key: 'entryCssClasses',
	        value: function entryCssClasses(classes) {
	            if (!arguments.length) {
	                return this._entryCssClasses;
	            }
	
	            this._entryCssClasses = classes;
	
	            return this;
	        }
	    }, {
	        key: 'getEntryCssClasses',
	        value: function getEntryCssClasses(entry) {
	            if (!this._entryCssClasses) {
	                return '';
	            }
	
	            if (this._entryCssClasses.constructor === Array) {
	                return this._entryCssClasses.join(' ');
	            }
	
	            if (typeof this._entryCssClasses === 'function') {
	                return this._entryCssClasses(entry);
	            }
	
	            return this._entryCssClasses;
	        }
	    }]);
	
	    return ListView;
	})(_View3['default']);
	
	exports['default'] = ListView;
	module.exports = exports['default'];

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _Entry = __webpack_require__(337);
	
	var _Entry2 = _interopRequireDefault(_Entry);
	
	var _UtilsReferenceExtractor = __webpack_require__(339);
	
	var _UtilsReferenceExtractor2 = _interopRequireDefault(_UtilsReferenceExtractor);
	
	var _UtilsObjectProperties = __webpack_require__(338);
	
	var View = (function () {
	    function View(name) {
	        _classCallCheck(this, View);
	
	        this.entity = null;
	        this._actions = null;
	        this._title = false;
	        this._description = '';
	        this._template = null;
	
	        this._enabled = false;
	        this._fields = [];
	        this._type = null;
	        this._name = name;
	        this._order = 0;
	        this._errorMessage = null;
	        this._url = null;
	        this._prepare = null;
	        this._icon = false;
	    }
	
	    _createClass(View, [{
	        key: 'icon',
	        value: function icon(_icon) {
	            if (!arguments.length) return this._icon;
	            this._icon = _icon;
	            return this;
	        }
	    }, {
	        key: 'title',
	        value: function title(_title) {
	            if (!arguments.length) return this._title;
	            this._title = _title;
	            return this;
	        }
	    }, {
	        key: 'getTitle',
	        value: function getTitle(params) {
	            if (typeof this._title === 'function') {
	                return this._title(params);
	            }
	
	            return this._title;
	        }
	    }, {
	        key: 'description',
	        value: function description() {
	            if (arguments.length) {
	                this._description = arguments[0];
	                return this;
	            }
	
	            return this._description;
	        }
	    }, {
	        key: 'name',
	        value: function name(_name) {
	            if (!arguments.length) {
	                return this._name || this.entity.name() + '_' + this._type;
	            }
	
	            this._name = _name;
	            return this;
	        }
	    }, {
	        key: 'disable',
	        value: function disable() {
	            this._enabled = false;
	
	            return this;
	        }
	    }, {
	        key: 'enable',
	        value: function enable() {
	            this._enabled = true;
	
	            return this;
	        }
	
	        /**
	         * @deprecated Use getter "enabled" instead
	         */
	    }, {
	        key: 'isEnabled',
	        value: function isEnabled() {
	            return this.enabled;
	        }
	
	        /**
	         * @deprecated Use getter "entity" instead
	         */
	    }, {
	        key: 'getEntity',
	        value: function getEntity() {
	            return this.entity;
	        }
	
	        /**
	         * @deprecated Specify entity at view creation or use "entity" setter instead
	         */
	    }, {
	        key: 'setEntity',
	        value: function setEntity(entity) {
	            this.entity = entity;
	            if (!this._name) {
	                this._name = entity.name() + '_' + this._type;
	            }
	
	            return this;
	        }
	
	        /*
	         * Supports various syntax
	         * fields([ Field1, Field2 ])
	         * fields(Field1, Field2)
	         * fields([Field1, {Field2, Field3}])
	         * fields(Field1, {Field2, Field3})
	         * fields({Field2, Field3})
	         */
	    }, {
	        key: 'fields',
	        value: function fields() {
	            if (!arguments.length) return this._fields;
	
	            [].slice.call(arguments).map(function (argument) {
	                var _this = this;
	
	                View.flatten(argument).map(function (arg) {
	                    return _this.addField(arg);
	                });
	            }, this);
	
	            return this;
	        }
	    }, {
	        key: 'hasFields',
	        value: function hasFields() {
	            return this.fields.length > 0;
	        }
	    }, {
	        key: 'removeFields',
	        value: function removeFields() {
	            this._fields = [];
	            return this;
	        }
	    }, {
	        key: 'getFields',
	        value: function getFields() {
	            return this._fields;
	        }
	    }, {
	        key: 'getField',
	        value: function getField(fieldName) {
	            return this._fields.filter(function (f) {
	                return f.name() === fieldName;
	            })[0];
	        }
	    }, {
	        key: 'getFieldsOfType',
	        value: function getFieldsOfType(type) {
	            return this._fields.filter(function (f) {
	                return f.type() === type;
	            });
	        }
	    }, {
	        key: 'addField',
	        value: function addField(field) {
	            if (field.order() === null) {
	                field.order(this._fields.length, true);
	            }
	            this._fields.push(field);
	            this._fields = this._fields.sort(function (a, b) {
	                return a.order() - b.order();
	            });
	
	            return this;
	        }
	    }, {
	        key: 'order',
	        value: function order(_order) {
	            if (!arguments.length) return this._order;
	            this._order = _order;
	            return this;
	        }
	    }, {
	        key: 'getReferences',
	        value: function getReferences(withRemoteComplete) {
	            return _UtilsReferenceExtractor2['default'].getReferences(this._fields, withRemoteComplete);
	        }
	    }, {
	        key: 'getNonOptimizedReferences',
	        value: function getNonOptimizedReferences(withRemoteComplete) {
	            return _UtilsReferenceExtractor2['default'].getNonOptimizedReferences(this._fields, withRemoteComplete);
	        }
	    }, {
	        key: 'getOptimizedReferences',
	        value: function getOptimizedReferences(withRemoteComplete) {
	            return _UtilsReferenceExtractor2['default'].getOptimizedReferences(this._fields, withRemoteComplete);
	        }
	    }, {
	        key: 'getReferencedLists',
	        value: function getReferencedLists() {
	            return _UtilsReferenceExtractor2['default'].getReferencedLists(this._fields);
	        }
	    }, {
	        key: 'template',
	        value: function template(_template) {
	            if (!arguments.length) {
	                return this._template;
	            }
	
	            this._template = _template;
	
	            return this;
	        }
	    }, {
	        key: 'identifier',
	        value: function identifier() {
	            return this.entity.identifier();
	        }
	    }, {
	        key: 'actions',
	        value: function actions(_actions) {
	            if (!arguments.length) return this._actions;
	            this._actions = _actions;
	            return this;
	        }
	    }, {
	        key: 'getErrorMessage',
	        value: function getErrorMessage(response) {
	            if (typeof this._errorMessage === 'function') {
	                return this._errorMessage(response);
	            }
	
	            return this._errorMessage;
	        }
	    }, {
	        key: 'errorMessage',
	        value: function errorMessage(_errorMessage) {
	            if (!arguments.length) return this._errorMessage;
	            this._errorMessage = _errorMessage;
	            return this;
	        }
	    }, {
	        key: 'url',
	        value: function url(_url) {
	            if (!arguments.length) return this._url;
	            this._url = _url;
	            return this;
	        }
	    }, {
	        key: 'getUrl',
	        value: function getUrl(identifierValue) {
	            if (typeof this._url === 'function') {
	                return this._url(identifierValue);
	            }
	
	            return this._url;
	        }
	    }, {
	        key: 'validate',
	        value: function validate(entry) {
	            this._fields.map(function (field) {
	                var validation = field.validation();
	
	                if (typeof validation.validator === 'function') {
	                    validation.validator(entry.values[field.name()], entry.values);
	                }
	            });
	        }
	
	        /**
	         * Map a JS object from the REST API Response to an Entry
	         */
	    }, {
	        key: 'mapEntry',
	        value: function mapEntry(restEntry) {
	            return _Entry2['default'].createFromRest(restEntry, this._fields, this.entity.name(), this.entity.identifier().name());
	        }
	    }, {
	        key: 'mapEntries',
	        value: function mapEntries(restEntries) {
	            return _Entry2['default'].createArrayFromRest(restEntries, this._fields, this.entity.name(), this.entity.identifier().name());
	        }
	
	        /**
	         * Transform an Entry to a JS object for the REST API Request
	         */
	    }, {
	        key: 'transformEntry',
	        value: function transformEntry(entry) {
	            return entry.transformToRest(this._fields);
	        }
	
	        /**
	         * Add a function to be executed before the view renders
	         *
	         * This is the ideal place to prefetch related entities and manipulate
	         * the dataStore.
	         *
	         * The syntax depends on the framework calling the function.
	         *
	         * With ng-admin, the function can be an angular injectable, listing
	         * required dependencies in an array. Among other, the function can receive
	         * the following services:
	         *  - query: the query object (an object representation of the main request
	         *    query string)
	         *  - datastore: where the Entries are stored. The dataStore is accessible
	         *    during rendering
	         *  - view: the current View object
	         *  - entry: the current Entry instance (except in listView)
	         *  - Entry: the Entry constructor (required to transform an object from
	         *    the REST response to an Entry)
	         *  - window: the window object. If you need to fetch anything other than an
	         *    entry and pass it to the view layer, it's the only way.
	         *
	         * The function can be asynchronous, in which case it should return
	         * a Promise.
	         *
	         * @example
	         *
	         *     post.listView().prepare(['datastore', 'view', 'Entry', function(datastore, view, Entry) {
	         *       const posts = datastore.getEntries(view.getEntity().uniqueId);
	         *       const authorIds = posts.map(post => post.values.authorId).join(',');
	         *       return fetch('http://myapi.com/authors?id[]=' + authorIds)
	         *          .then(response => response.json())
	         *          .then(authors => Entry.createArrayFromRest(
	         *              authors,
	         *              [new Field('first_name'), new Field('last_name')],
	         *              'author'
	         *          ))
	         *          .then(authorEntries => datastore.setEntries('authors', authorEntries));
	         *     }]);
	         */
	    }, {
	        key: 'prepare',
	        value: function prepare(_prepare) {
	            if (!arguments.length) return this._prepare;
	            this._prepare = _prepare;
	            return this;
	        }
	    }, {
	        key: 'doPrepare',
	        value: function doPrepare() {
	            return this._prepare.apply(this, arguments);
	        }
	    }, {
	        key: 'enabled',
	        get: function get() {
	            return this._enabled || !!this._fields.length;
	        }
	    }, {
	        key: 'type',
	        get: function get() {
	            return this._type;
	        }
	    }], [{
	        key: 'flatten',
	        value: function flatten(arg) {
	            if (arg.constructor.name === 'Object') {
	                console.warn('Passing literal of Field to fields method is deprecated use array instead');
	                var result = [];
	                for (var fieldName in arg) {
	                    result = result.concat(View.flatten(arg[fieldName]));
	                }
	                return result;
	            }
	            if (Array.isArray(arg)) {
	                return arg.reduce(function (previous, current) {
	                    return previous.concat(View.flatten(current));
	                }, []);
	            }
	            // arg is a scalar
	            return [arg];
	        }
	    }]);
	
	    return View;
	})();
	
	exports['default'] = View;
	module.exports = exports['default'];

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _UtilsObjectProperties = __webpack_require__(338);
	
	var Entry = (function () {
	    function Entry(entityName, values, identifierValue) {
	        _classCallCheck(this, Entry);
	
	        this._entityName = entityName;
	        this.values = values || {};
	        this._identifierValue = identifierValue;
	        this.listValues = {};
	    }
	
	    _createClass(Entry, [{
	        key: 'transformToRest',
	
	        /**
	         * Transform an Entry to a JS object for the REST API Request
	         *
	         * @return {Object}
	         */
	        value: function transformToRest(fields) {
	
	            var restEntry = (0, _UtilsObjectProperties.clone)(this.values);
	            fields.forEach(function (field) {
	                var fieldName = field.name();
	                if (fieldName in restEntry) {
	                    restEntry[fieldName] = field.getTransformedValue(restEntry[fieldName], restEntry);
	                }
	            });
	
	            return (0, _UtilsObjectProperties.cloneAndNest)(restEntry);
	        }
	    }, {
	        key: 'entityName',
	        get: function get() {
	            return this._entityName;
	        }
	    }, {
	        key: 'identifierValue',
	        get: function get() {
	            return this._identifierValue;
	        }
	    }], [{
	        key: 'createForFields',
	        value: function createForFields(fields, entityName) {
	            var entry = new Entry(entityName);
	            fields.forEach(function (field) {
	                entry.values[field.name()] = field.defaultValue();
	            });
	            return entry;
	        }
	
	        /**
	         * Map a JS object from the REST API Response to an Entry
	         *
	         * @return {Entry}
	         */
	    }, {
	        key: 'createFromRest',
	        value: function createFromRest(restEntry) {
	            var fields = arguments.length <= 1 || arguments[1] === undefined ? [] : arguments[1];
	            var entityName = arguments.length <= 2 || arguments[2] === undefined ? '' : arguments[2];
	            var identifierName = arguments.length <= 3 || arguments[3] === undefined ? 'id' : arguments[3];
	
	            if (!restEntry || Object.keys(restEntry).length == 0) {
	                return Entry.createForFields(fields, entityName);
	            }
	            var excludedFields = fields.filter(function (f) {
	                return !f.flattenable();
	            }).map(function (f) {
	                return f.name();
	            });
	
	            var values = (0, _UtilsObjectProperties.cloneAndFlatten)(restEntry, excludedFields);
	
	            fields.forEach(function (field) {
	                var fieldName = field.name();
	                values[fieldName] = field.getMappedValue(values[fieldName], values);
	            });
	
	            return new Entry(entityName, values, values[identifierName]);
	        }
	
	        /**
	         * Map an array of JS objects from the REST API Response to an array of Entries
	         *
	         * @return {Array[Entry]}
	         */
	    }, {
	        key: 'createArrayFromRest',
	        value: function createArrayFromRest(restEntries, fields, entityName, identifierName) {
	            return restEntries.map(function (e) {
	                return Entry.createFromRest(e, fields, entityName, identifierName);
	            });
	        }
	    }]);
	
	    return Entry;
	})();
	
	exports['default'] = Entry;
	module.exports = exports['default'];

/***/ },
/* 338 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports.clone = clone;
	exports.cloneAndFlatten = cloneAndFlatten;
	exports.cloneAndNest = cloneAndNest;
	function isObject(value) {
	    if (value === null) return false;
	    if (typeof value !== 'object') return false;
	    if (Array.isArray(value)) return false;
	    if (Object.prototype.toString.call(value) === '[object Date]') return false;
	    return true;
	}
	
	function clone(object) {
	    return Object.keys(object).reduce(function (values, name) {
	        if (object.hasOwnProperty(name)) {
	            values[name] = object[name];
	        }
	        return values;
	    }, {});
	}
	
	/*
	 * Flatten nested object into a single level object with 'foo.bar' property names
	 *
	 * The parameter object is left unchanged. All values in the returned object are scalar.
	 *
	 *     cloneAndFlatten({ a: 1, b: { c: 2 }, d: { e: 3, f: { g: 4, h: 5 } }, i: { j: 6 } }, ['i'])
	 *     // { a: 1, 'b.c': 2, 'd.e': 3, 'd.f.g': 4, 'd.f.h': 5, i: { j: 6 } } }
	 *
	 * @param {Object} object
	 * @param {String[]} excludedProperties
	 * @return {Object}
	 */
	
	function cloneAndFlatten(object) {
	    var excludedProperties = arguments.length <= 1 || arguments[1] === undefined ? [] : arguments[1];
	
	    if (typeof object !== 'object') {
	        throw new Error('Expecting an object parameter');
	    }
	    return Object.keys(object).reduce(function (values, name) {
	        if (!object.hasOwnProperty(name)) return values;
	        if (isObject(object[name])) {
	            if (excludedProperties.indexOf(name) === -1) {
	                (function () {
	                    var flatObject = cloneAndFlatten(object[name]);
	                    Object.keys(flatObject).forEach(function (flatObjectKey) {
	                        if (!flatObject.hasOwnProperty(flatObjectKey)) return;
	                        values[name + '.' + flatObjectKey] = flatObject[flatObjectKey];
	                    });
	                })();
	            } else {
	                values[name] = clone(object[name]);
	            }
	        } else {
	            values[name] = object[name];
	        }
	        return values;
	    }, {});
	}
	
	;
	
	/*
	 * Clone flattened object into a nested object
	 *
	 * The parameter object is left unchanged.
	 *
	 *     cloneAndNest({ a: 1, 'b.c': 2, 'd.e': 3, 'd.f.g': 4, 'd.f.h': 5 } )
	 *     // { a: 1, b: { c: 2 }, d: { e: 3, f: { g: 4, h: 5 } } }
	 *
	 * @param {Object} object
	 * @return {Object}
	 */
	
	function cloneAndNest(object) {
	    if (typeof object !== 'object') {
	        throw new Error('Expecting an object parameter');
	    }
	    return Object.keys(object).reduce(function (values, name) {
	        if (!object.hasOwnProperty(name)) return values;
	        name.split('.').reduce(function (previous, current, index, list) {
	            if (previous != null) {
	                if (typeof previous[current] === 'undefined') previous[current] = {};
	                if (index < list.length - 1) {
	                    return previous[current];
	                };
	                previous[current] = object[name];
	            }
	        }, values);
	        return values;
	    }, {});
	}

/***/ },
/* 339 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = {
	
	    getReferencedLists: function getReferencedLists(fields) {
	        return this.indexByName(fields.filter(function (f) {
	            return f.type() === 'referenced_list';
	        }));
	    },
	    getReferences: function getReferences(fields, withRemoteComplete) {
	        var optimized = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	        var references = fields.filter(function (f) {
	            return f.type() === 'reference' || f.type() === 'reference_many';
	        });
	        if (withRemoteComplete === true) {
	            references = references.filter(function (r) {
	                return r.remoteComplete();
	            });
	        } else if (withRemoteComplete === false) {
	            references = references.filter(function (r) {
	                return !r.remoteComplete();
	            });
	        }
	        if (optimized !== null) {
	            references = references.filter(function (r) {
	                return r.hasSingleApiCall() === optimized;
	            });
	        }
	        return this.indexByName(references);
	    },
	    getNonOptimizedReferences: function getNonOptimizedReferences(fields, withRemoteComplete) {
	        return this.getReferences(fields, withRemoteComplete, false);
	    },
	    getOptimizedReferences: function getOptimizedReferences(fields, withRemoteComplete) {
	        return this.getReferences(fields, withRemoteComplete, true);
	    },
	    indexByName: function indexByName(references) {
	        return references.reduce(function (referencesByName, reference) {
	            referencesByName[reference.name()] = reference;
	            return referencesByName;
	        }, {});
	    }
	};
	module.exports = exports['default'];

/***/ },
/* 340 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports["default"] = {
	    order: function order(input) {
	        var results = [],
	            objectKey;
	
	        for (objectKey in input) {
	            results.push(input[objectKey]);
	        }
	
	        return results.sort(function (e1, e2) {
	            return e1.order() - e2.order();
	        });
	    }
	};
	module.exports = exports["default"];

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _View2 = __webpack_require__(336);
	
	var _View3 = _interopRequireDefault(_View2);
	
	var MenuView = (function (_View) {
	    _inherits(MenuView, _View);
	
	    function MenuView(name) {
	        _classCallCheck(this, MenuView);
	
	        _get(Object.getPrototypeOf(MenuView.prototype), 'constructor', this).call(this, name);
	        this._type = 'MenuView';
	        this._icon = null;
	    }
	
	    _createClass(MenuView, [{
	        key: 'icon',
	        value: function icon() {
	            if (arguments.length) {
	                console.warn('entity.menuView() is deprecated. Please use the Menu class instead');
	                this._icon = arguments[0];
	                return this;
	            }
	
	            if (this._icon === null) {
	                return '<span class="glyphicon glyphicon-list"></span>';
	            }
	
	            return this._icon;
	        }
	    }, {
	        key: 'enabled',
	        get: function get() {
	            return this._enabled || this.entity.views['ListView'].enabled;
	        }
	    }]);
	
	    return MenuView;
	})(_View3['default']);
	
	exports['default'] = MenuView;
	module.exports = exports['default'];

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _View2 = __webpack_require__(336);
	
	var _View3 = _interopRequireDefault(_View2);
	
	var CreateView = (function (_View) {
	    _inherits(CreateView, _View);
	
	    function CreateView(name) {
	        _classCallCheck(this, CreateView);
	
	        _get(Object.getPrototypeOf(CreateView.prototype), 'constructor', this).call(this, name);
	        this._type = 'CreateView';
	        this._submitCreationSuccess = null;
	        this._submitCreationError = null;
	    }
	
	    /**
	     * Add a function to be executed after the creation succeeds.
	     *
	     * This is the ideal place to use the response to update the entry, or
	     * redirect to another view.
	     *
	     * If the function returns false, the default execution workflow is stopped.
	     * This means that the function must provide a custom workflow.
	     *
	     * If the function throws an exception, the onSubmitError callback will
	     * execute.
	     *
	     * The syntax depends on the framework calling the function.
	     *
	     * With ng-admin, the function can be an angular injectable, listing
	     * required dependencies in an array. Among other, the function can receive
	     * the following services:
	     *  - $event: the form submission event
	     *  - entry: the current Entry instance
	     *  - entity: the current entity
	     *  - form: the form object (for form validation and errors)
	     *  - progression: the controller for the loading indicator
	     *  - notification: the controller for top notifications
	     *
	     * The function can be asynchronous, in which case it should return
	     * a Promise.
	     *
	     * @example
	     *
	     *     post.creationView().onSubmitSuccess(['progression', 'notification', '$state', 'entry', 'entity', function(progression, notification, $state, entry, entity) {
	     *         // stop the progress bar
	     *         progression.done();
	     *         // add a notification
	     *         notification.log(`Element #${entry._identifierValue} successfully created.`, { addnCls: 'humane-flatty-success' });
	     *         // redirect to the list view
	     *         $state.go($state.get('list'), { entity: entity.name() });
	     *         // cancel the default action (redirect to the edition view)
	     *         return false;
	     *      }])
	     *
	     */
	
	    _createClass(CreateView, [{
	        key: 'onSubmitSuccess',
	        value: function onSubmitSuccess(_onSubmitSuccess) {
	            if (!arguments.length) return this._onSubmitSuccess;
	            this._onSubmitSuccess = _onSubmitSuccess;
	            return this;
	        }
	
	        /**
	         * Add a function to be executed after the creation request receives a
	         * failed http response from the server.
	         *
	         * This is the ideal place to use the response to update the entry, display
	         * server-side validation error, or redirect to another view.
	         *
	         * If the function returns false, the default execution workflow is stopped.
	         * This means that the function must provide a custom workflow.
	         *
	         * The syntax depends on the framework calling the function.
	         *
	         * With ng-admin, the function can be an angular injectable, listing
	         * required dependencies in an array. Among other, the function can receive
	         * the following services:
	         *  - $event: the form submission event
	         *  - error: the response from the server
	         *  - errorMessage: the error message based on the response
	         *  - entry: the current Entry instance
	         *  - entity: the current entity
	         *  - form: the form object (for form validation and errors)
	         *  - progression: the controller for the loading indicator
	         *  - notification: the controller for top notifications
	         *
	         * The function can be asynchronous, in which case it should return
	         * a Promise.
	         *
	         * @example
	         *
	         *     post.creationView().onSubmitError(['error', 'form', 'progression', 'notification', function(error, form, progression, notification) {
	         *         // mark fields based on errors from the response
	         *         error.violations.forEach(violation => {
	         *             if (form[violation.propertyPath]) {
	         *                 form[violation.propertyPath].$valid = false;
	         *             }
	         *         });
	         *         // stop the progress bar
	         *         progression.done();
	         *         // add a notification
	         *         notification.log(`Some values are invalid, see details in the form`, { addnCls: 'humane-flatty-error' });
	         *         // cancel the default action (default error messages)
	         *         return false;
	         *     }]);
	         */
	    }, {
	        key: 'onSubmitError',
	        value: function onSubmitError(_onSubmitError) {
	            if (!arguments.length) return this._onSubmitError;
	            this._onSubmitError = _onSubmitError;
	            return this;
	        }
	    }, {
	        key: 'addField',
	        value: function addField(field) {
	            this._fields.push(field);
	            return this;
	        }
	    }, {
	        key: 'fields',
	        value: function fields() {
	            if (!arguments.length) return this._fields;
	
	            [].slice.call(arguments).map(function (argument) {
	                var _this = this;
	
	                argument.map(function (arg) {
	                    return _this.addField(arg);
	                });
	            }, this);
	
	            return this;
	        }
	    }]);
	
	    return CreateView;
	})(_View3['default']);
	
	exports['default'] = CreateView;
	module.exports = exports['default'];

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _View2 = __webpack_require__(336);
	
	var _View3 = _interopRequireDefault(_View2);
	
	var EditView = (function (_View) {
	    _inherits(EditView, _View);
	
	    function EditView(name) {
	        _classCallCheck(this, EditView);
	
	        _get(Object.getPrototypeOf(EditView.prototype), 'constructor', this).call(this, name);
	        this._type = 'EditView';
	        this._submitCreationSuccess = null;
	        this._submitCreationError = null;
	    }
	
	    /**
	     * Add a function to be executed after the update succeeds.
	     *
	     * This is the ideal place to use the response to update the entry, or
	     * redirect to another view.
	     *
	     * If the function returns false, the default execution workflow is stopped.
	     * This means that the function must provide a custom workflow.
	     *
	     * If the function throws an exception, the onSubmitError callback will
	     * execute.
	     *
	     * The syntax depends on the framework calling the function.
	     *
	     * With ng-admin, the function can be an angular injectable, listing
	     * required dependencies in an array. Among other, the function can receive
	     * the following services:
	     *  - $event: the form submission event
	     *  - entry: the current Entry instance
	     *  - entity: the current entity
	     *  - form: the form object (for form validation and errors)
	     *  - progression: the controller for the loading indicator
	     *  - notification: the controller for top notifications
	     *
	     * The function can be asynchronous, in which case it should return
	     * a Promise.
	     *
	     * @example
	     *
	     *     post.editionView().onSubmitSuccess(['progression', 'notification', '$state', 'entry', 'entity', function(progression, notification, $state, entry, entity) {
	     *         // stop the progress bar
	     *         progression.done();
	     *         // add a notification
	     *         notification.log(`Element #${entry._identifierValue} successfully edited.`, { addnCls: 'humane-flatty-success' });
	     *         // redirect to the list view
	     *         $state.go($state.get('list'), { entity: entity.name() });
	     *         // cancel the default action (redirect to the edition view)
	     *         return false;
	     *      }])
	     */
	
	    _createClass(EditView, [{
	        key: 'onSubmitSuccess',
	        value: function onSubmitSuccess(_onSubmitSuccess) {
	            if (!arguments.length) return this._onSubmitSuccess;
	            this._onSubmitSuccess = _onSubmitSuccess;
	            return this;
	        }
	
	        /**
	         * Add a function to be executed after the update request receives a failed
	         * http response from the server.
	         *
	         * This is the ideal place to use the response to update the entry, display
	         * server-side validation error, or redirect to another view.
	         *
	         * If the function returns false, the default execution workflow is stopped.
	         * This means that the function must provide a custom workflow.
	         *
	         * The syntax depends on the framework calling the function.
	         *
	         * With ng-admin, the function can be an angular injectable, listing
	         * required dependencies in an array. Among other, the function can receive
	         * the following services:
	         *  - $event: the form submission event
	         *  - error: the response from the server
	         *  - errorMessage: the error message based on the response
	         *  - entry: the current Entry instance
	         *  - entity: the current entity
	         *  - form: the form object (for form validation and errors)
	         *  - progression: the controller for the loading indicator
	         *  - notification: the controller for top notifications
	         *
	         * The function can be asynchronous, in which case it should return
	         * a Promise.
	         *
	         * @example
	         *
	         *     post.editionView().onSubmitError(['error', 'form', 'progression', 'notification', function(error, form, progression, notification) {
	         *         // mark fields based on errors from the response
	         *         error.violations.forEach(violation => {
	         *             if (form[violation.propertyPath]) {
	         *                 form[violation.propertyPath].$valid = false;
	         *             }
	         *         });
	         *         // stop the progress bar
	         *         progression.done();
	         *         // add a notification
	         *         notification.log(`Some values are invalid, see details in the form`, { addnCls: 'humane-flatty-error' });
	         *         // cancel the default action (default error messages)
	         *         return false;
	         *     }]);
	         */
	    }, {
	        key: 'onSubmitError',
	        value: function onSubmitError(_onSubmitError) {
	            if (!arguments.length) return this._onSubmitError;
	            this._onSubmitError = _onSubmitError;
	            return this;
	        }
	    }, {
	        key: 'addField',
	        value: function addField(field) {
	            this._fields.push(field);
	            return this;
	        }
	    }, {
	        key: 'fields',
	        value: function fields() {
	            if (!arguments.length) return this._fields;
	
	            [].slice.call(arguments).map(function (argument) {
	                var _this = this;
	
	                argument.map(function (arg) {
	                    return _this.addField(arg);
	                });
	            }, this);
	
	            return this;
	        }
	    }]);
	
	    return EditView;
	})(_View3['default']);
	
	exports['default'] = EditView;
	module.exports = exports['default'];

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _View2 = __webpack_require__(336);
	
	var _View3 = _interopRequireDefault(_View2);
	
	var DeleteView = (function (_View) {
	    _inherits(DeleteView, _View);
	
	    function DeleteView(name) {
	        _classCallCheck(this, DeleteView);
	
	        _get(Object.getPrototypeOf(DeleteView.prototype), 'constructor', this).call(this, name);
	        this._type = 'DeleteView';
	        this._enabled = true;
	    }
	
	    return DeleteView;
	})(_View3['default']);
	
	exports['default'] = DeleteView;
	module.exports = exports['default'];

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _View2 = __webpack_require__(336);
	
	var _View3 = _interopRequireDefault(_View2);
	
	var ShowView = (function (_View) {
	    _inherits(ShowView, _View);
	
	    function ShowView(name) {
	        _classCallCheck(this, ShowView);
	
	        _get(Object.getPrototypeOf(ShowView.prototype), 'constructor', this).call(this, name);
	        this._type = 'ShowView';
	    }
	
	    return ShowView;
	})(_View3['default']);
	
	exports['default'] = ShowView;
	module.exports = exports['default'];

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _View2 = __webpack_require__(336);
	
	var _View3 = _interopRequireDefault(_View2);
	
	var BatchDeleteView = (function (_View) {
	    _inherits(BatchDeleteView, _View);
	
	    function BatchDeleteView(name) {
	        _classCallCheck(this, BatchDeleteView);
	
	        _get(Object.getPrototypeOf(BatchDeleteView.prototype), 'constructor', this).call(this, name);
	
	        this._type = 'BatchDeleteView';
	        this._enabled = true;
	    }
	
	    return BatchDeleteView;
	})(_View3['default']);
	
	exports['default'] = BatchDeleteView;
	module.exports = exports['default'];

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ListView2 = __webpack_require__(335);
	
	var _ListView3 = _interopRequireDefault(_ListView2);
	
	var ExportView = (function (_ListView) {
	    _inherits(ExportView, _ListView);
	
	    function ExportView(name) {
	        _classCallCheck(this, ExportView);
	
	        _get(Object.getPrototypeOf(ExportView.prototype), 'constructor', this).call(this, name);
	        this._fields = [];
	        this._type = 'ExportView';
	    }
	
	    return ExportView;
	})(_ListView3['default']);
	
	exports['default'] = ExportView;
	module.exports = exports['default'];

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ChoiceField2 = __webpack_require__(349);
	
	var _ChoiceField3 = _interopRequireDefault(_ChoiceField2);
	
	var BooleanField = (function (_ChoiceField) {
	    _inherits(BooleanField, _ChoiceField);
	
	    function BooleanField(name) {
	        _classCallCheck(this, BooleanField);
	
	        _get(Object.getPrototypeOf(BooleanField.prototype), "constructor", this).call(this, name);
	        this._type = "boolean";
	        this._choices = [{ value: null, label: 'undefined' }, { value: true, label: 'true' }, { value: false, label: 'false' }];
	        this._filterChoices = [{ value: true, label: 'true' }, { value: false, label: 'false' }];
	    }
	
	    _createClass(BooleanField, [{
	        key: "filterChoices",
	        value: function filterChoices(_filterChoices) {
	            if (!arguments.length) return this._filterChoices;
	            this._filterChoices = _filterChoices;
	
	            return this;
	        }
	    }]);
	
	    return BooleanField;
	})(_ChoiceField3["default"]);
	
	exports["default"] = BooleanField;
	module.exports = exports["default"];

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _Field2 = __webpack_require__(333);
	
	var _Field3 = _interopRequireDefault(_Field2);
	
	var ChoiceField = (function (_Field) {
	    _inherits(ChoiceField, _Field);
	
	    function ChoiceField(name) {
	        _classCallCheck(this, ChoiceField);
	
	        _get(Object.getPrototypeOf(ChoiceField.prototype), "constructor", this).call(this, name);
	        this._type = "choice";
	        this._choices = [];
	    }
	
	    _createClass(ChoiceField, [{
	        key: "choices",
	        value: function choices(_choices) {
	            if (!arguments.length) return this._choices;
	            this._choices = _choices;
	
	            return this;
	        }
	    }, {
	        key: "getLabelForChoice",
	        value: function getLabelForChoice(value, entry) {
	            var choices = typeof this._choices === 'function' ? this._choices(entry) : this._choices;
	            var choice = choices.filter(function (c) {
	                return c.value == value;
	            }).pop();
	            return choice ? choice.label : null;
	        }
	    }]);
	
	    return ChoiceField;
	})(_Field3["default"]);
	
	exports["default"] = ChoiceField;
	module.exports = exports["default"];

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ChoiceField2 = __webpack_require__(349);
	
	var _ChoiceField3 = _interopRequireDefault(_ChoiceField2);
	
	var ChoicesField = (function (_ChoiceField) {
	    _inherits(ChoicesField, _ChoiceField);
	
	    function ChoicesField(name) {
	        _classCallCheck(this, ChoicesField);
	
	        _get(Object.getPrototypeOf(ChoicesField.prototype), "constructor", this).call(this, name);
	        this._type = "choices";
	    }
	
	    return ChoicesField;
	})(_ChoiceField3["default"]);
	
	exports["default"] = ChoicesField;
	module.exports = exports["default"];

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _Field2 = __webpack_require__(333);
	
	var _Field3 = _interopRequireDefault(_Field2);
	
	var DateField = (function (_Field) {
	    _inherits(DateField, _Field);
	
	    function DateField(name) {
	        _classCallCheck(this, DateField);
	
	        _get(Object.getPrototypeOf(DateField.prototype), "constructor", this).call(this, name);
	
	        this._format = null;
	        this._parse = function (date) {
	            if (date instanceof Date) {
	                // the datepicker returns a JS Date object, with hours, minutes and timezone
	                // in order to convert it back to date, we must remove the timezone, then
	                // remove hours and minutes
	                date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
	
	                var dateString = date.toJSON();
	                return dateString ? dateString.substr(0, 10) : null;
	            }
	            return date;
	        };
	        this._type = "date";
	    }
	
	    _createClass(DateField, [{
	        key: "format",
	        value: function format(value) {
	            if (!arguments.length) return this._format;
	            this._format = value;
	            return this;
	        }
	    }, {
	        key: "parse",
	        value: function parse(value) {
	            if (!arguments.length) return this._parse;
	            this._parse = value;
	            return this;
	        }
	    }]);
	
	    return DateField;
	})(_Field3["default"]);
	
	exports["default"] = DateField;
	module.exports = exports["default"];

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _DateField2 = __webpack_require__(351);
	
	var _DateField3 = _interopRequireDefault(_DateField2);
	
	var DateTimeField = (function (_DateField) {
	    _inherits(DateTimeField, _DateField);
	
	    function DateTimeField(name) {
	        _classCallCheck(this, DateTimeField);
	
	        _get(Object.getPrototypeOf(DateTimeField.prototype), "constructor", this).call(this, name);
	
	        this._format = null;
	        this._parse = function (date) {
	            return date;
	        };
	
	        this._type = 'datetime';
	    }
	
	    return DateTimeField;
	})(_DateField3["default"]);
	
	exports["default"] = DateTimeField;
	module.exports = exports["default"];

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _Field2 = __webpack_require__(333);
	
	var _Field3 = _interopRequireDefault(_Field2);
	
	var EmailField = (function (_Field) {
	    _inherits(EmailField, _Field);
	
	    function EmailField(name) {
	        _classCallCheck(this, EmailField);
	
	        _get(Object.getPrototypeOf(EmailField.prototype), "constructor", this).call(this, name);
	        this._type = "email";
	    }
	
	    return EmailField;
	})(_Field3["default"]);
	
	exports["default"] = EmailField;
	module.exports = exports["default"];

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _Field2 = __webpack_require__(333);
	
	var _Field3 = _interopRequireDefault(_Field2);
	
	var _EntityEntity = __webpack_require__(331);
	
	var _EntityEntity2 = _interopRequireDefault(_EntityEntity);
	
	/**
	 * Map an embedded list in the entry
	 *
	 * @example
	 *
	 *     {
	 *        id: 123,
	 *        title: "hello, world",
	 *        comments: [
	 *          { date: "2015-09-30", author: "John Doe", body: "Lorem Ipsum" },
	 *          { date: "2015-10-02", author: "Jane Doe", body: "Sic dolor amet" }
	 *        ]
	 *     }
	 *
	 *     let commentsField = new EmbeddedListField('comments')
	 *        .targetFields([
	 *          new DateField('date'),
	 *          new StringField('author'),
	 *          new StringField('body')
	 *        ])
	 */
	
	var EmbeddedListField = (function (_Field) {
	    _inherits(EmbeddedListField, _Field);
	
	    function EmbeddedListField(name) {
	        _classCallCheck(this, EmbeddedListField);
	
	        _get(Object.getPrototypeOf(EmbeddedListField.prototype), "constructor", this).call(this, name);
	        this._type = 'embedded_list';
	        this._flattenable = false;
	        this._targetEntity = new _EntityEntity2["default"](); // link to an empty entity by default
	        this._targetFields = [];
	        this._sortField = null;
	        this._sortDir = null;
	        this._permanentFilters = null;
	        this._listActions = [];
	    }
	
	    /**
	     * Optionally set the target Entity
	     *
	     * Useful if the embedded entries can be edited in standalone
	     */
	
	    _createClass(EmbeddedListField, [{
	        key: "targetEntity",
	        value: function targetEntity(entity) {
	            if (!arguments.length) {
	                return this._targetEntity;
	            }
	            this._targetEntity = entity;
	
	            return this;
	        }
	
	        /**
	         * List the fields to map in the embedded entries
	         *
	         * @example
	         *
	         *     embeddedListField.targetFields([
	         *       new DateField('date'),
	         *       new StringField('author'),
	         *       new StringField('body')
	         *     ])
	         */
	    }, {
	        key: "targetFields",
	        value: function targetFields(value) {
	            if (!arguments.length) return this._targetFields;
	            this._targetFields = value;
	
	            return this;
	        }
	
	        /**
	         * Name of the field used for sorting.
	         *
	         * @param string
	         */
	    }, {
	        key: "sortField",
	        value: function sortField() {
	            if (arguments.length) {
	                this._sortField = arguments[0];
	                return this;
	            }
	
	            return this._sortField ? this._sortField : this.targetEntity().identifier().name();
	        }
	
	        /**
	         * Direction used for sorting.
	         *
	         * @param String either 'ASC' or 'DESC'
	         */
	    }, {
	        key: "sortDir",
	        value: function sortDir() {
	            if (arguments.length) {
	                this._sortDir = arguments[0];
	                return this;
	            }
	
	            return this._sortDir;
	        }
	    }, {
	        key: "listActions",
	        value: function listActions(actions) {
	            if (!arguments.length) {
	                return this._listActions;
	            }
	
	            this._listActions = actions;
	
	            return this;
	        }
	
	        /**
	         * Define permanent filters to be added to the REST API calls
	         *
	         *     nga.field('post_id', 'reference').permanentFilters({
	         *        published: true
	         *     });
	         *     // related API call will be /posts/:id?published=true
	         *
	         * @param {Object} filters list of filters to apply to the call
	         */
	    }, {
	        key: "permanentFilters",
	        value: function permanentFilters(filters) {
	            if (!arguments.length) {
	                return this._permanentFilters;
	            }
	
	            this._permanentFilters = filters;
	
	            return this;
	        }
	    }]);
	
	    return EmbeddedListField;
	})(_Field3["default"]);
	
	exports["default"] = EmbeddedListField;
	module.exports = exports["default"];

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _NumberField2 = __webpack_require__(356);
	
	var _NumberField3 = _interopRequireDefault(_NumberField2);
	
	var FloatField = (function (_NumberField) {
	    _inherits(FloatField, _NumberField);
	
	    function FloatField(name) {
	        _classCallCheck(this, FloatField);
	
	        _get(Object.getPrototypeOf(FloatField.prototype), 'constructor', this).call(this, name);
	        this._type = 'float';
	        this._format = '0.000';
	    }
	
	    return FloatField;
	})(_NumberField3['default']);
	
	exports['default'] = FloatField;
	module.exports = exports['default'];

/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _Field2 = __webpack_require__(333);
	
	var _Field3 = _interopRequireDefault(_Field2);
	
	var NumberField = (function (_Field) {
	    _inherits(NumberField, _Field);
	
	    function NumberField(name) {
	        _classCallCheck(this, NumberField);
	
	        _get(Object.getPrototypeOf(NumberField.prototype), "constructor", this).call(this, name);
	        this._type = "number";
	        this._format = undefined;
	    }
	
	    /**
	     * Specify format pattern for number to string conversion. 
	     *
	     * Based on NumeralJs, which uses a syntax similar to Excel.
	     *
	     * {@link} http://numeraljs.com/
	     * {@link} https://github.com/baumandm/angular-numeraljs
	     * {@example}
	     *
	     *     nga.field('height', 'number').format('$0,0.00');
	     */
	
	    _createClass(NumberField, [{
	        key: "format",
	        value: function format(value) {
	            if (!arguments.length) return this._format;
	            this._format = value;
	            return this;
	        }
	    }, {
	        key: "fractionSize",
	        value: function fractionSize(decimals) {
	            console.warn('NumberField.fractionSize() is deprecated, use NumberField.format() instead');
	            this.format('0.' + '0'.repeat(decimals));
	            return this;
	        }
	    }]);
	
	    return NumberField;
	})(_Field3["default"]);
	
	exports["default"] = NumberField;
	module.exports = exports["default"];

/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _Field2 = __webpack_require__(333);
	
	var _Field3 = _interopRequireDefault(_Field2);
	
	var FileField = (function (_Field) {
	    _inherits(FileField, _Field);
	
	    function FileField(name) {
	        _classCallCheck(this, FileField);
	
	        _get(Object.getPrototypeOf(FileField.prototype), "constructor", this).call(this, name);
	        this._type = "file";
	        this._uploadInformation = {
	            url: '/upload',
	            accept: '*'
	        };
	    }
	
	    _createClass(FileField, [{
	        key: "uploadInformation",
	        value: function uploadInformation(information) {
	            if (!arguments.length) return this._uploadInformation;
	            this._uploadInformation = information;
	            return this;
	        }
	    }]);
	
	    return FileField;
	})(_Field3["default"]);
	
	exports["default"] = FileField;
	module.exports = exports["default"];

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _Field2 = __webpack_require__(333);
	
	var _Field3 = _interopRequireDefault(_Field2);
	
	var JsonField = (function (_Field) {
	    _inherits(JsonField, _Field);
	
	    function JsonField(name) {
	        _classCallCheck(this, JsonField);
	
	        _get(Object.getPrototypeOf(JsonField.prototype), "constructor", this).call(this, name);
	        this._type = "json";
	        this._flattenable = false;
	    }
	
	    return JsonField;
	})(_Field3["default"]);
	
	exports["default"] = JsonField;
	module.exports = exports["default"];

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _Field2 = __webpack_require__(333);
	
	var _Field3 = _interopRequireDefault(_Field2);
	
	var PasswordField = (function (_Field) {
	    _inherits(PasswordField, _Field);
	
	    function PasswordField(name) {
	        _classCallCheck(this, PasswordField);
	
	        _get(Object.getPrototypeOf(PasswordField.prototype), "constructor", this).call(this, name);
	        this._type = "password";
	    }
	
	    return PasswordField;
	})(_Field3["default"]);
	
	exports["default"] = PasswordField;
	module.exports = exports["default"];

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _Field2 = __webpack_require__(333);
	
	var _Field3 = _interopRequireDefault(_Field2);
	
	var ReferenceField = (function (_Field) {
	    _inherits(ReferenceField, _Field);
	
	    function ReferenceField(name) {
	        _classCallCheck(this, ReferenceField);
	
	        _get(Object.getPrototypeOf(ReferenceField.prototype), 'constructor', this).call(this, name);
	        this._type = 'reference';
	        this._targetEntity = null;
	        this._targetField = null;
	        this._perPage = 30;
	        this._permanentFilters = null;
	        this._sortField = null;
	        this._sortDir = null;
	        this._singleApiCall = false;
	        this._detailLink = true;
	        this._remoteComplete = false;
	        this._remoteCompleteOptions = {
	            refreshDelay: 500
	        };
	    }
	
	    _createClass(ReferenceField, [{
	        key: 'perPage',
	        value: function perPage(_perPage) {
	            if (!arguments.length) return this._perPage;
	            this._perPage = _perPage;
	            return this;
	        }
	    }, {
	        key: 'datagridName',
	        value: function datagridName() {
	            return this._targetEntity.name() + '_ListView';
	        }
	    }, {
	        key: 'targetEntity',
	        value: function targetEntity(entity) {
	            if (!arguments.length) {
	                return this._targetEntity;
	            }
	            this._targetEntity = entity;
	
	            return this;
	        }
	    }, {
	        key: 'targetField',
	        value: function targetField(field) {
	            if (!arguments.length) return this._targetField;
	            this._targetField = field;
	
	            return this;
	        }
	
	        /**
	         * Define permanent filters to be added to the REST API calls
	         *
	         *     nga.field('post_id', 'reference').permanentFilters({
	         *        published: true
	         *     });
	         *     // related API call will be /posts/:id?published=true
	         *
	         * @param {Object} filters list of filters to apply to the call
	         */
	    }, {
	        key: 'permanentFilters',
	        value: function permanentFilters(filters) {
	            if (!arguments.length) {
	                return this._permanentFilters;
	            }
	
	            this._permanentFilters = filters;
	
	            return this;
	        }
	
	        /**
	         * @deprecated use permanentFilters() instead
	         */
	    }, {
	        key: 'filters',
	        value: function filters(_filters) {
	            console.warn('ReferenceField.filters() is deprecated, please use ReferenceField.permanentFilters() instead');
	            return this.permanentFilters(_filters);
	        }
	    }, {
	        key: 'sortField',
	        value: function sortField() {
	            if (arguments.length) {
	                this._sortField = arguments[0];
	                return this;
	            }
	
	            return this._sortField;
	        }
	    }, {
	        key: 'sortDir',
	        value: function sortDir() {
	            if (arguments.length) {
	                this._sortDir = arguments[0];
	                return this;
	            }
	
	            return this._sortDir;
	        }
	    }, {
	        key: 'singleApiCall',
	        value: function singleApiCall(_singleApiCall) {
	            if (!arguments.length) return this._singleApiCall;
	            this._singleApiCall = _singleApiCall;
	            return this;
	        }
	    }, {
	        key: 'hasSingleApiCall',
	        value: function hasSingleApiCall() {
	            return typeof this._singleApiCall === 'function';
	        }
	    }, {
	        key: 'getSingleApiCall',
	        value: function getSingleApiCall(identifiers) {
	            return this.hasSingleApiCall() ? this._singleApiCall(identifiers) : this._singleApiCall;
	        }
	    }, {
	        key: 'getIdentifierValues',
	        value: function getIdentifierValues(rawValues) {
	            var results = {};
	            var identifierName = this._name;
	            for (var i = 0, l = rawValues.length; i < l; i++) {
	                var identifier = rawValues[i][identifierName];
	                if (identifier == null) {
	                    continue;
	                }
	
	                if (identifier instanceof Array) {
	                    for (var j in identifier) {
	                        results[identifier[j]] = true;
	                    }
	                    continue;
	                }
	
	                results[identifier] = true;
	            }
	
	            return Object.keys(results);
	        }
	    }, {
	        key: 'getSortFieldName',
	        value: function getSortFieldName() {
	            if (!this.sortField()) {
	                return null;
	            }
	
	            return this._targetEntity.name() + '_ListView.' + this.sortField();
	        }
	
	        /**
	         * Enable autocompletion using REST API for choices.
	         *
	         * Available options are:
	         *
	         * * `refreshDelay`: minimal delay between two API calls in milliseconds. By default: 500.
	         * * `searchQuery`: a function returning the parameters to add to the query string basd on the input string.
	         *
	         *       new ReferenceField('authors')
	         *           .targetEntity(author)
	         *           .targetField(new Field('name'))
	         *           .remoteComplete(true, {
	         *               refreshDelay: 300,
	         *               // populate choices from the response of GET /tags?q=XXX
	         *               searchQuery: function(search) { return { q: search }; }
	         *           })
	         *           .perPage(10) // limit the number of results to 10
	         *
	         * @param {Boolean} remoteComplete true to enable remote complete. False by default
	         * @param {Object} options Remote completion options (optional)
	         */
	    }, {
	        key: 'remoteComplete',
	        value: function remoteComplete(_remoteComplete, options) {
	            if (!arguments.length) return this._remoteComplete;
	            this._remoteComplete = _remoteComplete;
	            if (options) {
	                this.remoteCompleteOptions(options);
	            }
	            return this;
	        }
	    }, {
	        key: 'remoteCompleteOptions',
	        value: function remoteCompleteOptions(options) {
	            if (!arguments.length) return this._remoteCompleteOptions;
	            this._remoteCompleteOptions = options;
	            return this;
	        }
	    }]);
	
	    return ReferenceField;
	})(_Field3['default']);
	
	exports['default'] = ReferenceField;
	module.exports = exports['default'];

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ReferenceField2 = __webpack_require__(360);
	
	var _ReferenceField3 = _interopRequireDefault(_ReferenceField2);
	
	var _UtilsReferenceExtractor = __webpack_require__(339);
	
	var _UtilsReferenceExtractor2 = _interopRequireDefault(_UtilsReferenceExtractor);
	
	var ReferencedListField = (function (_ReferenceField) {
	    _inherits(ReferencedListField, _ReferenceField);
	
	    function ReferencedListField(name) {
	        _classCallCheck(this, ReferencedListField);
	
	        _get(Object.getPrototypeOf(ReferencedListField.prototype), 'constructor', this).call(this, name);
	        this._type = 'referenced_list';
	        this._targetReferenceField = null;
	        this._targetFields = [];
	        this._detailLink = false;
	        this._listActions = [];
	        this._entryCssClasses = null;
	    }
	
	    _createClass(ReferencedListField, [{
	        key: 'targetReferenceField',
	        value: function targetReferenceField(value) {
	            if (!arguments.length) return this._targetReferenceField;
	            this._targetReferenceField = value;
	            return this;
	        }
	    }, {
	        key: 'targetFields',
	        value: function targetFields(value) {
	            if (!arguments.length) return this._targetFields;
	            this._targetFields = value;
	
	            return this;
	        }
	    }, {
	        key: 'getGridColumns',
	        value: function getGridColumns() {
	            var columns = [];
	            for (var i = 0, l = this._targetFields.length; i < l; i++) {
	                var field = this._targetFields[i];
	                columns.push({
	                    field: field,
	                    label: field.label()
	                });
	            }
	
	            return columns;
	        }
	    }, {
	        key: 'getSortFieldName',
	        value: function getSortFieldName() {
	            if (!this.sortField()) {
	                return null;
	            }
	
	            return this._targetEntity.name() + '_ListView.' + this.sortField();
	        }
	    }, {
	        key: 'listActions',
	        value: function listActions(actions) {
	            if (!arguments.length) {
	                return this._listActions;
	            }
	
	            this._listActions = actions;
	
	            return this;
	        }
	    }, {
	        key: 'entryCssClasses',
	        value: function entryCssClasses(classes) {
	            if (!arguments.length) {
	                return this._entryCssClasses;
	            }
	
	            this._entryCssClasses = classes;
	
	            return this;
	        }
	    }, {
	        key: 'getReferences',
	        value: function getReferences(withRemoteComplete) {
	            return _UtilsReferenceExtractor2['default'].getReferences(this._targetFields, withRemoteComplete);
	        }
	    }, {
	        key: 'getNonOptimizedReferences',
	        value: function getNonOptimizedReferences(withRemoteComplete) {
	            return _UtilsReferenceExtractor2['default'].getNonOptimizedReferences(this._targetFields, withRemoteComplete);
	        }
	    }, {
	        key: 'getOptimizedReferences',
	        value: function getOptimizedReferences(withRemoteComplete) {
	            return _UtilsReferenceExtractor2['default'].getOptimizedReferences(this._targetFields, withRemoteComplete);
	        }
	    }]);
	
	    return ReferencedListField;
	})(_ReferenceField3['default']);
	
	exports['default'] = ReferencedListField;
	module.exports = exports['default'];

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ReferenceField2 = __webpack_require__(360);
	
	var _ReferenceField3 = _interopRequireDefault(_ReferenceField2);
	
	var ReferenceManyField = (function (_ReferenceField) {
	    _inherits(ReferenceManyField, _ReferenceField);
	
	    function ReferenceManyField(name) {
	        _classCallCheck(this, ReferenceManyField);
	
	        _get(Object.getPrototypeOf(ReferenceManyField.prototype), "constructor", this).call(this, name);
	        this._type = 'reference_many';
	    }
	
	    return ReferenceManyField;
	})(_ReferenceField3["default"]);
	
	exports["default"] = ReferenceManyField;
	module.exports = exports["default"];

/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _Field2 = __webpack_require__(333);
	
	var _Field3 = _interopRequireDefault(_Field2);
	
	var TemplateField = (function (_Field) {
	    _inherits(TemplateField, _Field);
	
	    function TemplateField(name) {
	        _classCallCheck(this, TemplateField);
	
	        _get(Object.getPrototypeOf(TemplateField.prototype), "constructor", this).call(this, name);
	        this._type = "template";
	        this._flattenable = false;
	    }
	
	    return TemplateField;
	})(_Field3["default"]);
	
	exports["default"] = TemplateField;
	module.exports = exports["default"];

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _Field2 = __webpack_require__(333);
	
	var _Field3 = _interopRequireDefault(_Field2);
	
	var TextField = (function (_Field) {
	    _inherits(TextField, _Field);
	
	    function TextField(name) {
	        _classCallCheck(this, TextField);
	
	        _get(Object.getPrototypeOf(TextField.prototype), "constructor", this).call(this, name);
	        this._type = "text";
	    }
	
	    return TextField;
	})(_Field3["default"]);
	
	exports["default"] = TextField;
	module.exports = exports["default"];

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _Field2 = __webpack_require__(333);
	
	var _Field3 = _interopRequireDefault(_Field2);
	
	var WysiwygField = (function (_Field) {
	    _inherits(WysiwygField, _Field);
	
	    function WysiwygField(name) {
	        _classCallCheck(this, WysiwygField);
	
	        _get(Object.getPrototypeOf(WysiwygField.prototype), "constructor", this).call(this, name);
	        this._type = "wysiwyg";
	        this._stripTags = false;
	        this._sanitize = true;
	    }
	
	    _createClass(WysiwygField, [{
	        key: "stripTags",
	        value: function stripTags(value) {
	            if (!arguments.length) return this._stripTags;
	            this._stripTags = value;
	            return this;
	        }
	    }, {
	        key: "sanitize",
	        value: function sanitize(value) {
	            if (!arguments.length) return this._sanitize;
	            this._sanitize = value;
	            return this;
	        }
	    }]);
	
	    return WysiwygField;
	})(_Field3["default"]);
	
	exports["default"] = WysiwygField;
	module.exports = exports["default"];

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(83);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _breadcrumbHtml = __webpack_require__(367);
	
	var _breadcrumbHtml2 = _interopRequireDefault(_breadcrumbHtml);
	
	var BreadcrumbController = (function () {
	    function BreadcrumbController($state, $stateParams) {
	        _classCallCheck(this, BreadcrumbController);
	
	        this.$state = function () {
	            return $state;
	        };
	        this.$stateParams = function () {
	            return $stateParams;
	        };
	    }
	
	    _createClass(BreadcrumbController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.$state = this.$state();
	            this.stateParams = this.$stateParams();
	            this.states = this.$state.$current.path.filter(function (s) {
	                return !s.abstract;
	            });
	        }
	    }]);
	
	    return BreadcrumbController;
	})();
	
	BreadcrumbController.$inject = ['$state', '$stateParams'];
	
	var BreadcrumbComponent = {
	    restrict: 'E',
	    templateUrl: _breadcrumbHtml2['default'],
	    controller: BreadcrumbController,
	    controllerAs: 'vm'
	};
	
	var breadcrumb = _angular2['default'].module('breadcrumb', [_angularUiRouter2['default']]);
	breadcrumb.component('breadcrumb', BreadcrumbComponent);
	
	exports.breadcrumb = breadcrumb;

/***/ },
/* 367 */
/***/ function(module, exports) {

	var path = 'app/components/common/breadcrumb/breadcrumb.html';
	var html = "<div id=\"hbreadcrumb\" class=\"m-t-lg\"><ol class=\"hbreadcrumb breadcrumb\"><li ng-repeat=\"state in vm.states\" ng-switch=\"$last\" ng-class=\"{active: $last}\"><a ng-switch-when=\"false\" href=\"#{{state.url.format(vm.stateParams)}}\">{{state.data.pageTitle}}</a> <span ng-switch-when=\"true\">{{state.data.pageTitle}}</span></li></ol></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(83);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _pageHeaderComponentJs = __webpack_require__(369);
	
	var pageHeader = _angular2['default'].module('pageHeader', []);
	pageHeader.component('pageHeader', _pageHeaderComponentJs.PageHeaderComponent);
	
	exports.pageHeader = pageHeader;

/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _pageHeaderHtml = __webpack_require__(370);
	
	var _pageHeaderHtml2 = _interopRequireDefault(_pageHeaderHtml);
	
	var PageHeaderController = function PageHeaderController($state) {
	    _classCallCheck(this, PageHeaderController);
	
	    this.$state = $state;
	    this.icon = this.icon || false;
	};
	
	PageHeaderController.$inject = ['$state'];
	
	var PageHeaderComponent = {
	    restrict: 'E',
	    templateUrl: _pageHeaderHtml2['default'],
	    controller: PageHeaderController,
	    controllerAs: 'vm',
	    bindings: {
	        icon: '<',
	        pageTitle: '<',
	        pageDesc: '<'
	    }
	};
	
	exports.PageHeaderComponent = PageHeaderComponent;

/***/ },
/* 370 */
/***/ function(module, exports) {

	var path = 'app/components/common/pageHeader/pageHeader.html';
	var html = "<div small-header class=\"normalheader transition\"><div class=\"hpanel\"><div class=\"panel-body\"><a ng-click=\"small()\"><div class=\"clip-header\"><i class=\"fa fa-arrow-up\"></i></div></a><div class=\"pull-right\" compile=\"vm.icon\" compileOnce=\"true\"><breadcrumb></breadcrumb></div><h2 class=\"font-light m-b-xs\" compile=\"vm.pageTitle\" compileOnce=\"true\"></h2><small ng-bind-html=\"vm.pageDesc\"></small></div></div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(83);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _configurationConfigurationJs = __webpack_require__(327);
	
	var _listDataGridComponentJs = __webpack_require__(372);
	
	var _listListViewComponentJs = __webpack_require__(374);
	
	var _formModalFormComponentJs = __webpack_require__(387);
	
	var _fieldViewFieldViewConfigurationJs = __webpack_require__(389);
	
	var _fieldViewFieldViewConfigurationJs2 = _interopRequireDefault(_fieldViewFieldViewConfigurationJs);
	
	var crud = _angular2['default'].module('crud', [_angularUiRouter2['default'], _configurationConfigurationJs.configurationModule.name]);
	
	crud.component('inDataGrid', _listDataGridComponentJs.DataGridComponent);
	crud.component('listView', _listListViewComponentJs.ListViewComponent);
	crud.component('modalForm', _formModalFormComponentJs.ModalFormComponent);
	
	crud.provider('FieldViewConfiguration', _fieldViewFieldViewConfigurationJs2['default']);
	
	crud.directive('inListActions', __webpack_require__(409));
	
	crud.directive('column', __webpack_require__(411));
	crud.directive('inStringColumn', __webpack_require__(412));
	crud.directive('inDateColumn', __webpack_require__(413));
	crud.directive('inTemplateColumn', __webpack_require__(414));
	crud.directive('inReferenceColumn', __webpack_require__(415));
	
	exports.crud = crud;

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _dataGridHtml = __webpack_require__(373);
	
	var _dataGridHtml2 = _interopRequireDefault(_dataGridHtml);
	
	var DataGridController = (function () {
	    function DataGridController() {
	        _classCallCheck(this, DataGridController);
	
	        this.shouldDisplayActions = this.actions && this.actions.length > 0;
	        // this.datastore = this.datastore();
	    }
	
	    _createClass(DataGridController, [{
	        key: 'btnClicked',
	        value: function btnClicked(btnId, params) {
	            this.onBtnClick({ btnId: btnId, params: params });
	        }
	    }, {
	        key: 'edit',
	        value: function edit(item) {
	            this.onEdit({ item: item });
	        }
	    }, {
	        key: 'delete',
	        value: function _delete(item) {
	            this.onDelete({ item: item });
	        }
	    }]);
	
	    return DataGridController;
	})();
	
	DataGridController.$inject = ['$q'];
	
	var DataGridComponent = {
	    restrict: 'E',
	    templateUrl: _dataGridHtml2['default'],
	    bindings: {
	        fields: '<',
	        entries: '<',
	        entity: '<',
	        datastore: '&',
	        actions: '<',
	        onBtnClick: '&',
	        onEdit: '&',
	        onDelete: '&',
	        tblClass: '@'
	    },
	    controller: DataGridController,
	    controllerAs: 'vm'
	};
	
	exports.DataGridComponent = DataGridComponent;

/***/ },
/* 373 */
/***/ function(module, exports) {

	var path = 'app/components/common/crud/list/dataGrid.html';
	var html = "<table class=\"table table-striped table-hover\" ng-class=\"vm.tblClass\"><thead><tr><th ng-repeat=\"field in vm.fields | filter: {_hidden:false} track by $index\" ng-class=\"field.getCssClasses()\" class=\"ng-admin-column-{{ ::field.name() }} ng-admin-type-{{ ::field.type() }}\"><span ng-bind-html=\"field.label()\"></span></th><th ng-if=\"vm.shouldDisplayActions\" class=\"ng-admin-column-actions col-lg-2 text-center\">Akcije</th></tr></thead><tbody><tr ng-repeat=\"entry in vm.entries\"><td ng-repeat=\"field in vm.fields | filter: {_hidden:false}\" ng-class=\"field.getCssClasses(entry)\" class=\"ng-admin-column-{{ ::field.name() }} ng-admin-type-{{ ::field.type() }}\"><column field=\"::field\" entry=\"::entry\" entity=\"::vm.entity\" datastore=\"::vm.datastore()\"></column></td><td ng-if=\"vm.shouldDisplayActions\" class=\"ng-admin-column-actions text-center\"><in-list-actions entry=\"::entry\" entity=\"::vm.entity\" buttons=\"vm.actions\" on-btn-click=\"vm.btnClicked(btnId, params)\" on-edit=\"vm.edit(item)\" on-delete=\"vm.delete(item)\"></in-list-actions></td></tr></tbody></table>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _sweetalert = __webpack_require__(375);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	var _listViewHtml = __webpack_require__(384);
	
	var _listViewHtml2 = _interopRequireDefault(_listViewHtml);
	
	var _listControllerJs = __webpack_require__(385);
	
	var _listControllerJs2 = _interopRequireDefault(_listControllerJs);
	
	var ListViewController = (function (_ListController) {
	    _inherits(ListViewController, _ListController);
	
	    function ListViewController($uibModal, DS, $q, logger) {
	        _classCallCheck(this, ListViewController);
	
	        _get(Object.getPrototypeOf(ListViewController.prototype), 'constructor', this).call(this);
	        this.$uibModal = $uibModal;
	        this.$q = $q;
	        this.logger = logger;
	        this.view = this.view || false;
	        this.Model = this.store || false;
	        this.datastore = function () {
	            return DS;
	        };
	
	        this.icon = this.view.icon();
	        this.pageTitle = this.view.title();
	        this.pageDesc = this.view.description();
	
	        this.getState();
	    }
	
	    _createClass(ListViewController, [{
	        key: 'getState',
	        value: function getState() {
	            var _this = this;
	
	            this.resolveReferences().then(function () {
	                _this.getItems();
	            });
	        }
	    }, {
	        key: 'resolveReferences',
	        value: function resolveReferences() {
	            var models = [];
	            var datastore = this.datastore();
	
	            _.forOwn(this.view.getReferences(), function (value, key) {
	                models.push(datastore.definitions[value.targetEntity().name()]);
	            });
	
	            return this.$q.all(models.map(function (m) {
	                return m.findAll();
	            }));
	        }
	    }, {
	        key: 'getQueryset',
	        value: function getQueryset(params) {
	            return this.Model.findAll(params, { bypassCache: true });
	        }
	    }, {
	        key: 'edit',
	        value: function edit(item) {
	            var _this2 = this;
	
	            var model = item;
	            var entity = this.view.entity;
	            var _view = entity.editionView();
	            var modal = this.$uibModal.open({
	                component: 'modalForm',
	                size: 'lg',
	                resolve: {
	                    item: function item() {
	                        return model;
	                    },
	                    view: function view() {
	                        return _view;
	                    }
	                }
	            });
	
	            modal.result.then(function (model) {
	                _this2.Model.update(model.id, model).then(function () {
	                    return _this2.getState();
	                })['catch'](function (error) {
	                    _this2.logger.error('Upsss', error.data);
	                });
	            });
	        }
	    }, {
	        key: 'canInsert',
	        value: function canInsert() {
	            var fields = this.view.entity.editionView().fields();
	            return fields.length > 0;
	        }
	    }, {
	        key: 'insert',
	        value: function insert() {
	            var _this3 = this;
	
	            var model = {};
	            var entity = this.view.entity;
	            var _view2 = entity.editionView();
	            var modal = this.$uibModal.open({
	                component: 'modalForm',
	                size: 'lg',
	                resolve: {
	                    item: function item() {
	                        return model;
	                    },
	                    view: function view() {
	                        return _view2;
	                    }
	                }
	            });
	
	            modal.result.then(function (model) {
	                _this3.Model.create(model).then(function () {
	                    _this3.Model.ejectAll();
	                    _this3.getState();
	                })['catch'](function (error) {
	                    _this3.logger.error('Upsss', error.data);
	                });
	            });
	        }
	    }, {
	        key: 'delete',
	        value: function _delete(item) {
	            var _this4 = this;
	
	            var previousWindowKeyDown = window.onkeydown;
	            (0, _sweetalert2['default'])({
	                title: 'Brisanje retka entiteta ' + this.view.title(),
	                text: 'Za potvrdu brisanja upišite \'da\'',
	                type: 'input',
	                showCancelButton: true,
	                closeOnConfirm: false
	            }, function (inputValue) {
	                window.onkeydown = previousWindowKeyDown;
	                if (inputValue === false) return false;
	                if (inputValue === 'da') {
	                    _this4.Model.destroy(item.id).then(function (data) {
	                        _this4.getState();
	                        (0, _sweetalert2['default'])('Redak obrisan', '', 'success');
	                    }, function (error) {
	                        (0, _sweetalert2['default'])('Greška', 'Došlo je do greške prilikom brisanja', 'error');
	                    });
	                    return true;
	                }
	                _sweetalert2['default'].showInputError('Nedozvoljena vrijednost');
	                return false;
	            });
	        }
	    }, {
	        key: 'btnClicked',
	        value: function btnClicked(btnId, params) {}
	    }]);
	
	    return ListViewController;
	})(_listControllerJs2['default']);
	
	ListViewController.$inject = ['$uibModal', 'DS', '$q', 'logger'];
	
	var ListViewComponent = {
	    restrict: 'E',
	    templateUrl: _listViewHtml2['default'],
	    controller: ListViewController,
	    controllerAs: 'vm',
	    bindings: {
	        view: '<',
	        store: '<'
	    }
	};
	
	exports.ListViewComponent = ListViewComponent;

/***/ },
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */
/***/ function(module, exports) {

	var path = 'app/components/common/crud/list/listView.html';
	var html = "<header id=\"header\" on-search=\"vm.onFilter(value)\" search-placeholder=\"Pretraži...\"></header><navbar id=\"menu\"></navbar><div id=\"wrapper\"><page-header icon=\"vm.icon\" page-title=\"vm.pageTitle\" page-desc=\"vm.pageDesc\"></page-header><div class=\"content\" animate-panel><div class=\"row\"><div class=\"col-sm-6\"><div class=\"dataTables_paginate paging_simple_numbers\" id=\"example2_paginate\"><ul uib-pagination total-items=\"vm.pager.totalItems\" items-per-page=\"vm.pager.limit\" max-size=\"5\" ng-change=\"vm.pageChanged()\" ng-model=\"vm.pager.currentPage\" num-pages=\"smallnumPages\" previous-text=\"Prethodni\" next-text=\"Slijedeći\"></ul></div></div><div class=\"col-sm-6\"><div class=\"dataTables_info pull-right\" id=\"example2_info\" role=\"status\" aria-live=\"polite\">Prikazuje se {{vm.pager.start}} od {{vm.pager.end}} od ukupno {{vm.pager.totalItems}} zapisa</div></div></div><div class=\"row\"><div class=\"col-lg-12\"><a ng-click=\"vm.insert()\" type=\"button\" class=\"btn btn-success\" ng-if=\"vm.canInsert()\"><i class=\"fa fa-plus-square\"></i> Novi zapis</a></div></div><div animate-panel child=\"hpanel\"><div class=\"hpanel\"><div class=\"panel-heading\"><div class=\"panel-tools\"><a class=\"showhide\"><i class=\"fa fa-chevron-up\"></i></a> <a class=\"closebox\" hidden><i class=\"fa fa-times\"></i></a></div><br></div><div class=\"panel-body\"><div class=\"table-responsive\"><in-data-grid fields=\"vm.view.fields()\" entries=\"vm.items\" entity=\"vm.view.entity\" actions=\"vm.view.listActions()\" datastore=\"vm.datastore()\" on-btn-click=\"vm.btnClicked(btnId, params)\" on-edit=\"vm.edit(item)\" on-delete=\"vm.delete(item)\"></in-data-grid></div></div><div class=\"panel-footer\"><br></div></div></div></div><footer class=\"footer\"></footer></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _lodash = __webpack_require__(165);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _modelsMetaJs = __webpack_require__(386);
	
	var ListController = (function () {
	    function ListController(Model) {
	        _classCallCheck(this, ListController);
	
	        this.Model = Model;
	        this.items = [];
	        this.pager = {
	            currentPage: 1,
	            limit: 15,
	            totalItems: 0,
	            search: "",
	            start: 0,
	            end: 0
	        };
	    }
	
	    _createClass(ListController, [{
	        key: 'getState',
	        value: function getState() {}
	    }, {
	        key: 'getQueryset',
	        value: function getQueryset(params) {
	            return this.Model.findAll(params);
	        }
	    }, {
	        key: 'getItems',
	        value: function getItems() {
	            var _this = this;
	
	            var params = {
	                limit: this.pager.limit,
	                offset: 0,
	                search: this.pager.search
	            };
	
	            if (params.search === '') {
	                delete params.search;
	            }
	
	            params.offset = (this.pager.currentPage - 1) * params.limit;
	
	            return this.getQueryset(params).then(function (response) {
	                _this.items = response;
	
	                _this.pager.start = parseInt(params.offset * (_this.pager.currentPage - 1)) + 1;
	                _this.pager.end = parseInt(params.offset * (_this.pager.currentPage - 1)) + response.length;
	
	                if (_modelsMetaJs.meta[_this.Model.name] !== undefined) {
	                    _this.pager.totalItems = _modelsMetaJs.meta[_this.Model.name].count;
	                    // this.pager.start = response.meta.start;
	                    // this.pager.end = response.meta.end;
	                }
	
	                return _this.items;
	            });
	        }
	    }, {
	        key: 'onFilter',
	        value: function onFilter(value) {
	            this.pager.search = value;
	            this.getState();
	        }
	    }, {
	        key: 'pageChanged',
	        value: function pageChanged() {
	            this.getState();
	        }
	    }]);
	
	    return ListController;
	})();
	
	exports['default'] = ListController;
	module.exports = exports['default'];

/***/ },
/* 386 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var meta = {};
	
	exports.meta = meta;

/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _modalFormHtml = __webpack_require__(388);
	
	var _modalFormHtml2 = _interopRequireDefault(_modalFormHtml);
	
	var ModalFormController = (function () {
	    function ModalFormController() {
	        _classCallCheck(this, ModalFormController);
	    }
	
	    _createClass(ModalFormController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.item = this.resolve.item;
	            this.view = this.resolve.view;
	            this.formClass = this.resolve.formClass || 'horizontal';
	            this.clone = _angular2['default'].copy(this.item);
	        }
	    }, {
	        key: 'submit',
	        value: function submit(item) {
	            this.form.$setSubmitted(true);
	            if (this.form.$invalid) {
	                return;
	            }
	            this.close({ $value: item });
	        }
	    }, {
	        key: 'cancel',
	        value: function cancel() {
	            this.dismiss({ $value: 'cancel' });
	        }
	    }]);
	
	    return ModalFormController;
	})();
	
	var ModalFormComponent = {
	    restrict: 'E',
	    templateUrl: _modalFormHtml2['default'],
	    controller: ModalFormController,
	    controllerAs: 'vm',
	    bindings: {
	        resolve: '<',
	        close: '&',
	        dismiss: '&'
	    }
	};
	
	exports.ModalFormComponent = ModalFormComponent;

/***/ },
/* 388 */
/***/ function(module, exports) {

	var path = 'app/components/common/crud/form/modalForm.html';
	var html = "<div class=\"modal-content\"><div class=\"color-line\"></div><div class=\"modal-header\"><h5 class=\"modal-title\">{{vm.view.title()}}</h5></div><div class=\"modal-body\"><div class=\"hpanel stats\"><div class=\"panel-body list\"><form name=\"vm.form\" ng-submit=\"vm.submit(vm.clone)\" ng-class=\"{'form-horizontal': vm.formClass === 'horizontal'}\"><formly-form model=\"vm.clone\" fields=\"vm.view.fields()\" form=\"vm.form\" options=\"vm.options\"></formly-form></form></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.cancel()\">Odustani</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"vm.submit(vm.clone)\">Potvrdi</button></div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var FieldViewConfiguration = (function () {
	    function FieldViewConfiguration() {
	        _classCallCheck(this, FieldViewConfiguration);
	
	        this.fieldViews = {};
	        this._init();
	    }
	
	    _createClass(FieldViewConfiguration, [{
	        key: 'registerFieldView',
	        value: function registerFieldView(type, FieldView) {
	            this.fieldViews[type] = FieldView;
	        }
	    }, {
	        key: '$get',
	        value: function $get() {
	            return this.fieldViews;
	        }
	    }, {
	        key: '_init',
	        value: function _init() {
	            this.registerFieldView('boolean', __webpack_require__(390));
	            this.registerFieldView('choice', __webpack_require__(391));
	            this.registerFieldView('choices', __webpack_require__(392));
	            this.registerFieldView('date', __webpack_require__(393));
	            this.registerFieldView('datetime', __webpack_require__(394));
	            this.registerFieldView('email', __webpack_require__(395));
	            this.registerFieldView('embedded_list', __webpack_require__(396));
	            this.registerFieldView('file', __webpack_require__(397));
	            this.registerFieldView('float', __webpack_require__(398));
	            this.registerFieldView('json', __webpack_require__(399));
	            this.registerFieldView('number', __webpack_require__(400));
	            this.registerFieldView('password', __webpack_require__(401));
	            this.registerFieldView('referenced_list', __webpack_require__(402));
	            this.registerFieldView('reference', __webpack_require__(403));
	            this.registerFieldView('reference_many', __webpack_require__(404));
	            this.registerFieldView('string', __webpack_require__(405));
	            this.registerFieldView('template', __webpack_require__(406));
	            this.registerFieldView('text', __webpack_require__(407));
	            this.registerFieldView('wysiwyg', __webpack_require__(408));
	        }
	    }]);
	
	    return FieldViewConfiguration;
	})();
	
	exports['default'] = FieldViewConfiguration;
	
	FieldViewConfiguration.$inject = [];
	module.exports = exports['default'];

/***/ },
/* 390 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-boolean-column value="::value"></ma-boolean-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-choice-field field="::field" value="value" choices="::field.filterChoices()"></ma-choice-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<div class="row">\n        <ma-choice-field class="col-sm-4 col-md-3" ng-if="!field.validation().required" field="::field" value="$parent.value"></ma-choice-field>\n        <ma-checkbox-field class="col-sm-4 col-md-3" ng-if="!!field.validation().required" field="::field" value="$parent.value"></ma-checkbox-field>\n    </div>';
	    }
	};
	module.exports = exports['default'];

/***/ },
/* 391 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-string-column value="::field.getLabelForChoice(value, entry)"></ma-string-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-choice-field field="::field" value="value"></ma-choice-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-choice-field field="::field" entry="entry" value="value"></ma-choice-field>';
	    }
	};
	module.exports = exports['default'];

/***/ },
/* 392 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-choices-column values="::value"></ma-choices-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-choices-field field="::field" value="value"></ma-choices-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-choices-field field="::field" entry="::entry" value="value"></ma-choices-field>';
	    }
	};
	module.exports = exports['default'];

/***/ },
/* 393 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = {
	    getReadWidget: function getReadWidget() {
	        return '<in-date-column field="::field" value="::value()"></in-date-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-date-field field="::field" value="value"></ma-date-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<div class="date_widget"><ma-date-field field="::field" value="value"></ma-date-field></div>';
	    }
	};
	module.exports = exports['default'];

/***/ },
/* 394 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = {
	    getReadWidget: function getReadWidget() {
	        return '<in-date-column field="::field" value="::value()"></in-date-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-date-field field="::field" value="value"></ma-date-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<div class="datetime_widget"><ma-date-field field="::field" value="value"></ma-date-field></div>';
	    }
	};
	module.exports = exports['default'];

/***/ },
/* 395 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-string-column value="::value"></ma-string-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-input-field field="::field" value="value"></ma-input-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-input-field type="email" field="::field" value="value"></ma-input-field>';
	    }
	};
	module.exports = exports['default'];

/***/ },
/* 396 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-embedded-list-column field="::field" value="::value" datastore="::datastore"></ma-embedded-list-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return 'error: cannot display referenced_list field as linkable';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return 'error: cannot display referenced_list field as filter';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-embedded-list-field field="::field" value="value" datastore="::datastore"></ma-embedded-list-field>';
	    }
	};
	module.exports = exports['default'];

/***/ },
/* 397 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = {
	    getReadWidget: function getReadWidget() {
	        return 'error: cannot display file field as readable';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return 'error: cannot display file field as linkable';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return 'error: cannot display file field as filter';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-file-field field="::field" value="value"></ma-file-field>';
	    }
	};
	module.exports = exports['default'];

/***/ },
/* 398 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-number-column field="::field" value="::value"></ma-number-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-input-field type="number" step="any" field="::field" value="value"></ma-input-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-input-field type="number" step="any" field="::field" value="value"></ma-input-field>';
	    }
	};
	module.exports = exports['default'];

/***/ },
/* 399 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-json-column value="::value"></ma-json-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return 'error: cannot display a json field as linkable';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-input-field field="::field" value="value"></ma-input-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-json-field field="::field" value="value"></ma-json-field>';
	    }
	};
	module.exports = exports['default'];

/***/ },
/* 400 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-number-column field="::field" value="::value"></ma-number-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-input-field type="number" field="::field" value="value"></ma-input-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-input-field type="number" field="::field" value="value"></ma-input-field>';
	    }
	};
	module.exports = exports['default'];

/***/ },
/* 401 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = {
	    getReadWidget: function getReadWidget() {
	        return 'error: cannot display password field as readable';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return 'error: cannot display password field as linkable';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return 'error: cannot display password field as filter';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-input-field type="password" field="::field" value="value"></ma-input-field>';
	    }
	};
	module.exports = exports['default'];

/***/ },
/* 402 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-referenced-list-column field="::field" datastore="::datastore"></ma-referenced-list-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return 'error: cannot display referenced_list field as linkable';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return 'error: cannot display referenced_list field as filter';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-referenced-list-column field="::field" datastore="::datastore"></ma-referenced-list-column>';
	    }
	};
	module.exports = exports['default'];

/***/ },
/* 403 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = {
	    getReadWidget: function getReadWidget() {
	        return '<in-reference-column field="::field" value="value()" datastore="::datastore"></in-reference-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<ma-reference-link-column entry="::entry" field="::field" value="::value" datastore="::datastore"></ma-reference-link-column>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-reference-field field="::field" value="value" datastore="::datastore"></ma-reference-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-reference-field field="::field" value="value" datastore="::datastore"></ma-reference-field>';
	    }
	};
	module.exports = exports['default'];

/***/ },
/* 404 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-choices-column values="::entry.listValues[field.name()]"></ma-choices-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<ma-reference-many-link-column ids="::value" values="::entry.listValues[field.name()]" field="::field"></ma-reference-many-link-column>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-reference-many-field field="::field" value="value" datastore="::datastore"></ma-reference-many-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-reference-many-field field="::field" value="value" datastore="::datastore"></ma-reference-many-field>';
	    }
	};
	module.exports = exports['default'];

/***/ },
/* 405 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = {
	    getReadWidget: function getReadWidget() {
	        return '<in-string-column value="::value()"></in-string-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-input-field field="::field" value="value"></ma-input-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-input-field field="::field" value="value"></ma-input-field>';
	    }
	};
	module.exports = exports['default'];

/***/ },
/* 406 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = {
	    getReadWidget: function getReadWidget() {
	        return '<in-template-column entry="::entry" field="::field" entity="::entity"></in-template-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-template-field field="::field" value="value" values="values" filters="filters"></ma-template-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-template-field field="::field" value="value" entry="entry" entity="::entity"></ma-template-field>';
	    }
	};
	module.exports = exports['default'];

/***/ },
/* 407 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-string-column value="::value"></ma-string-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-input-field field="::field" value="value"></ma-input-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-text-field field="::field" value="value"></ma-text-field>';
	    }
	};
	module.exports = exports['default'];

/***/ },
/* 408 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-wysiwyg-column field="::field" value="::value"></ma-wysiwyg-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-input-field field="::field" value="value"></ma-input-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ma-wysiwyg-field field="::field" value="value"></ma-wysiwyg-field>';
	    }
	};
	module.exports = exports['default'];

/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = inListActions;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _listActionsHtml = __webpack_require__(410);
	
	var _listActionsHtml2 = _interopRequireDefault(_listActionsHtml);
	
	function inListActions() {
	    return {
	        restrict: 'E',
	        transclude: true,
	        scope: {
	            'buttons': '<',
	            'entry': '<',
	            'entity': '<',
	            'onBtnClick': '&',
	            'onEdit': '&',
	            'onDelete': '&'
	        },
	        controller: ['$scope', function ($scope) {
	
	            $scope.actionClick = function (btnId) {
	                var params = {
	                    entity: $scope.entity,
	                    entry: $scope.entry
	                };
	                $scope.onBtnClick({ btnId: btnId, params: params });
	            };
	
	            $scope.edit = function () {
	                $scope.onEdit({ item: $scope.entry });
	            };
	
	            $scope['delete'] = function () {
	                $scope.onDelete({ item: $scope.entry });
	            };
	        }],
	        link: function link($scope) {
	            $scope.customTemplate = false;
	            if (typeof $scope.buttons === 'string') {
	                $scope.customTemplate = $scope.buttons;
	                $scope.buttons = null;
	            }
	        },
	        templateUrl: _listActionsHtml2['default']
	    };
	}
	
	inListActions.$inject = [];
	module.exports = exports['default'];

/***/ },
/* 410 */
/***/ function(module, exports) {

	var path = 'app/components/common/crud/list/listActions.html';
	var html = "<span compile=\"customTemplate\"><span ng-repeat=\"button in ::buttons\" ng-switch=\"button\"><ma-show-button ng-switch-when=\"show\" entry=\"::entry\" entity=\"::entity\" size=\"xs\"></ma-show-button><a ng-click=\"edit()\" ng-switch-when=\"edit\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-edit\"></i></a> <a ng-click=\"delete()\" ng-switch-when=\"delete\" class=\"btn btn-danger btn-xs\"><i class=\"fa fa-close\"></i></a><span ng-switch-default><span compile=\"button\"></span></span></span></span>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 411 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = column;
	
	function column($compile, FieldViewConfiguration) {
	
	    function linkFn(scope, element) {
	        // debugger;
	
	        if (typeof scope.field === 'undefined') return;
	
	        scope.value = function () {
	            if (typeof scope.entry === 'undefined') {
	                return '';
	            }
	            return scope.entry[scope.field.name()];
	        };
	
	        var type = scope.field.type();
	        element.append(FieldViewConfiguration[type].getReadWidget());
	        $compile(element.contents())(scope);
	    }
	
	    return {
	        restrict: 'E',
	        scope: {
	            field: '<',
	            entry: '<',
	            entity: '<',
	            datastore: '&'
	        },
	        link: linkFn
	    };
	}
	
	column.$inject = ['$compile', 'FieldViewConfiguration'];
	module.exports = exports['default'];

/***/ },
/* 412 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = inStringColumn;
	
	function inStringColumn() {
	    return {
	        restrict: 'E',
	        scope: {
	            value: '&'
	        },
	        template: '<span>{{ value() }}</span>'
	    };
	}
	
	inStringColumn.$inject = [];
	module.exports = exports['default'];

/***/ },
/* 413 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = inDateColumn;
	
	function inDateColumn() {
	    return {
	        restrict: 'E',
	        scope: {
	            value: '&',
	            field: '<'
	        },
	        link: function link(scope) {
	            var field = scope.field;
	            scope.format = field.format();
	            if (!scope.format) {
	                scope.format = field.type() === 'date' ? 'dd.MM.yyyy' : 'dd.MM.yyyy HH:mm:ss';
	            }
	        },
	        template: '<span>{{ value() | date:format }}</span>'
	    };
	}
	
	inDateColumn.$inject = [];
	module.exports = exports['default'];

/***/ },
/* 414 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = inTemplateColumn;
	
	function inTemplateColumn() {
	    return {
	        restrict: 'E',
	        scope: {
	            field: '<',
	            entry: '<',
	            entity: '<'
	        },
	        link: function link(scope) {
	            // scope.field = scope.field();
	            // scope.entry = scope.entry();
	            // scope.entity = scope.entity();
	        },
	        template: '<span compile="field.getTemplateValue(entry)"></span>'
	    };
	}
	
	inTemplateColumn.$inject = [];
	module.exports = exports['default'];

/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = inReferenceColumn;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _lodash = __webpack_require__(165);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function inReferenceColumn() {
	    return {
	        restrict: 'E',
	        scope: {
	            field: '&',
	            value: '&',
	            datastore: '<'
	        },
	        link: {
	            pre: function pre(scope) {
	                // const value = scope.value();
	                scope.field = scope.field();
	                scope.targetEntity = scope.field.targetEntity();
	                scope.targetField = scope.field.targetField();
	                var referencedEntries = scope.datastore().definitions[scope.targetEntity.name()].getAll();
	                // scope.referencedEntry = _.find(referencedEntries, (e) => e.id === value);
	
	                scope.$watch(scope.value, function (newVal, oldVal) {
	                    scope.referencedEntry = _lodash2['default'].find(referencedEntries, function (e) {
	                        return e.id === newVal;
	                    });
	                });
	            }
	        },
	        template: '<column field="::targetField" entry="referencedEntry" entity="::targetEntity" datastore="::datastore()"></column>'
	    };
	}
	
	inReferenceColumn.$inject = [];
	module.exports = exports['default'];

/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	/*
	 *
	 * https://github.com/fatlinesofcode/ngDraggable
	 */
	var ngDraggable = _angular2['default'].module("ngDraggable", []).service('ngDraggable', [function () {
	
	    var scope = this;
	    scope.inputEvent = function (event) {
	        if (_angular2['default'].isDefined(event.touches)) {
	            return event.touches[0];
	        } else if (_angular2['default'].isDefined(event.originalEvent.touches)) {
	            return event.originalEvent.touches[0];
	        }
	        return event;
	    };
	}]).directive('ngDrag', ['$rootScope', '$parse', '$document', '$window', 'ngDraggable', function ($rootScope, $parse, $document, $window, ngDraggable) {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            scope.value = attrs.ngDrag;
	            var offset,
	                _centerAnchor = false,
	                _mx,
	                _my,
	                _tx,
	                _ty,
	                _mrx,
	                _mry;
	            var _hasTouch = 'ontouchstart' in window || window.DocumentTouch && document instanceof DocumentTouch;
	            var _pressEvents = 'touchstart mousedown';
	            var _moveEvents = 'touchmove mousemove';
	            var _releaseEvents = 'touchend mouseup';
	            var _dragHandle;
	
	            // to identify the element in order to prevent getting superflous events when a single element has both drag and drop directives on it.
	            var _myid = scope.$id;
	            var _data = null;
	
	            var _dragOffset = null;
	
	            var _dragEnabled = false;
	
	            var _pressTimer = null;
	
	            var onDragSuccessCallback = $parse(attrs.ngDragSuccess) || null;
	            var allowTransform = _angular2['default'].isDefined(attrs.allowTransform) ? scope.$eval(attrs.allowTransform) : true;
	            // var allowTransform = true;
	
	            // debugger;
	
	            // Adjust scroll offset if drag element is in a position fixed div and we scroll while dragging
	            var scrollOffset = _angular2['default'].isDefined(attrs.scrollOffset) ? scope.$eval(attrs.scrollOffset) : false;
	            // scrollOffset = scrollOffset && !allowTransform;
	            scrollOffset = true;
	
	            var getDragData = $parse(attrs.ngDragData);
	
	            // deregistration function for mouse move events in $rootScope triggered by jqLite trigger handler
	            var _deregisterRootMoveListener = _angular2['default'].noop;
	
	            var initialize = function initialize() {
	                element.attr('draggable', 'false'); // prevent native drag
	                // check to see if drag handle(s) was specified
	                // if querySelectorAll is available, we use this instead of find
	                // as JQLite find is limited to tagnames
	                if (element[0].querySelectorAll) {
	                    var dragHandles = _angular2['default'].element(element[0].querySelectorAll('[ng-drag-handle]'));
	                } else {
	                    var dragHandles = element.find('[ng-drag-handle]');
	                }
	                if (dragHandles.length) {
	                    _dragHandle = dragHandles;
	                }
	                toggleListeners(true);
	            };
	
	            var toggleListeners = function toggleListeners(enable) {
	                if (!enable) return;
	                // add listeners.
	
	                scope.$on('$destroy', onDestroy);
	                scope.$watch(attrs.ngDrag, onEnableChange);
	                scope.$watch(attrs.ngCenterAnchor, onCenterAnchor);
	                // wire up touch events
	                if (_dragHandle) {
	                    // handle(s) specified, use those to initiate drag
	                    _dragHandle.on(_pressEvents, onpress);
	                } else {
	                    // no handle(s) specified, use the element as the handle
	                    element.on(_pressEvents, onpress);
	                }
	                if (!_hasTouch && element[0].nodeName.toLowerCase() == "img") {
	                    element.on('mousedown', function () {
	                        return false;
	                    }); // prevent native drag for images
	                }
	            };
	            var onDestroy = function onDestroy(enable) {
	                toggleListeners(false);
	            };
	            var onEnableChange = function onEnableChange(newVal, oldVal) {
	                _dragEnabled = newVal;
	            };
	            var onCenterAnchor = function onCenterAnchor(newVal, oldVal) {
	                if (_angular2['default'].isDefined(newVal)) _centerAnchor = newVal || 'true';
	            };
	
	            var isClickableElement = function isClickableElement(evt) {
	                return _angular2['default'].isDefined(_angular2['default'].element(evt.target).attr("ng-cancel-drag"));
	            };
	            /*
	             * When the element is clicked start the drag behaviour
	             * On touch devices as a small delay so as not to prevent native window scrolling
	             */
	            var onpress = function onpress(evt) {
	                if (!_dragEnabled) return;
	
	                if (isClickableElement(evt)) {
	                    return;
	                }
	
	                if (evt.type == "mousedown" && evt.button != 0) {
	                    // Do not start dragging on right-click
	                    return;
	                }
	
	                if (_hasTouch) {
	                    cancelPress();
	                    _pressTimer = setTimeout(function () {
	                        cancelPress();
	                        onlongpress(evt);
	                    }, 100);
	                    $document.on(_moveEvents, cancelPress);
	                    $document.on(_releaseEvents, cancelPress);
	                } else {
	                    onlongpress(evt);
	                }
	            };
	
	            var cancelPress = function cancelPress() {
	                clearTimeout(_pressTimer);
	                $document.off(_moveEvents, cancelPress);
	                $document.off(_releaseEvents, cancelPress);
	            };
	
	            var onlongpress = function onlongpress(evt) {
	                if (!_dragEnabled) return;
	                evt.preventDefault();
	
	                offset = element[0].getBoundingClientRect();
	                if (allowTransform) _dragOffset = offset;else {
	                    _dragOffset = { left: document.body.scrollLeft, top: document.body.scrollTop };
	                }
	
	                element.centerX = element[0].offsetWidth / 2;
	                element.centerY = element[0].offsetHeight / 2;
	
	                _mx = ngDraggable.inputEvent(evt).pageX; //ngDraggable.getEventProp(evt, 'pageX');
	                _my = ngDraggable.inputEvent(evt).pageY; //ngDraggable.getEventProp(evt, 'pageY');
	                _mrx = _mx - offset.left;
	                _mry = _my - offset.top;
	                if (_centerAnchor) {
	                    _tx = _mx - element.centerX - $window.pageXOffset;
	                    _ty = _my - element.centerY - $window.pageYOffset;
	                } else {
	                    _tx = _mx - _mrx - $window.pageXOffset;
	                    _ty = _my - _mry - $window.pageYOffset;
	                }
	
	                $document.on(_moveEvents, onmove);
	                $document.on(_releaseEvents, onrelease);
	                // This event is used to receive manually triggered mouse move events
	                // jqLite unfortunately only supports triggerHandler(...)
	                // See http://api.jquery.com/triggerHandler/
	                // _deregisterRootMoveListener = $rootScope.$on('draggable:_triggerHandlerMove', onmove);
	                _deregisterRootMoveListener = $rootScope.$on('draggable:_triggerHandlerMove', function (event, origEvent) {
	                    onmove(origEvent);
	                });
	            };
	
	            var onmove = function onmove(evt) {
	                if (!_dragEnabled) return;
	                evt.preventDefault();
	
	                if (!element.hasClass('dragging')) {
	                    _data = getDragData(scope);
	                    element.addClass('dragging');
	                    $rootScope.$broadcast('draggable:start', { x: _mx, y: _my, tx: _tx, ty: _ty, event: evt, element: element, data: _data });
	                }
	
	                _mx = ngDraggable.inputEvent(evt).pageX; //ngDraggable.getEventProp(evt, 'pageX');
	                _my = ngDraggable.inputEvent(evt).pageY; //ngDraggable.getEventProp(evt, 'pageY');
	
	                if (_centerAnchor) {
	                    _tx = _mx - element.centerX - _dragOffset.left;
	                    _ty = _my - element.centerY - _dragOffset.top;
	                } else {
	                    _tx = _mx - _mrx - _dragOffset.left;
	                    _ty = _my - _mry - _dragOffset.top;
	                }
	
	                // Adjust offset based on scroll
	                if (scrollOffset) {
	                    if (_dragOffset.top === 0) {
	                        _ty = _ty - document.body.scrollTop;
	                    } else if (_dragOffset.top > 0) {
	                        _ty = _ty - document.body.scrollTop + 2 * _dragOffset.top;
	                    }
	                }
	
	                moveElement(_tx, _ty);
	
	                $rootScope.$broadcast('draggable:move', { x: _mx, y: _my, tx: _tx, ty: _ty, event: evt, element: element, data: _data, uid: _myid });
	            };
	
	            var onrelease = function onrelease(evt) {
	                if (!_dragEnabled) return;
	                evt.preventDefault();
	                $rootScope.$broadcast('draggable:end', { x: _mx, y: _my, tx: _tx, ty: _ty, event: evt, element: element, data: _data, callback: onDragComplete, uid: _myid });
	                element.removeClass('dragging');
	                element.parent().find('.drag-enter').removeClass('drag-enter');
	                reset();
	                $document.off(_moveEvents, onmove);
	                $document.off(_releaseEvents, onrelease);
	                _deregisterRootMoveListener();
	            };
	
	            var onDragComplete = function onDragComplete(evt) {
	                if (!onDragSuccessCallback) return;
	
	                scope.$apply(function () {
	                    onDragSuccessCallback(scope, { $data: _data, $event: evt });
	                });
	            };
	
	            var reset = function reset() {
	                if (allowTransform) element.css({ transform: '', 'z-index': '', '-webkit-transform': '', '-ms-transform': '' });else element.css({ 'position': '', top: '', left: '' });
	            };
	
	            var moveElement = function moveElement(x, y) {
	                if (allowTransform) {
	                    element.css({
	                        transform: 'matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, ' + x + ', ' + y + ', 0, 1)',
	                        'z-index': 99999,
	                        '-webkit-transform': 'matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, ' + x + ', ' + y + ', 0, 1)',
	                        '-ms-transform': 'matrix(1, 0, 0, 1, ' + x + ', ' + y + ')'
	                    });
	                } else {
	                    element.css({ 'left': x + 'px', 'top': y + 'px', 'position': 'fixed' });
	                }
	            };
	            initialize();
	        }
	    };
	}]).directive('ngDrop', ['$parse', '$timeout', '$window', '$document', 'ngDraggable', function ($parse, $timeout, $window, $document, ngDraggable) {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            scope.value = attrs.ngDrop;
	            scope.isTouching = false;
	
	            var _lastDropTouch = null;
	
	            var _myid = scope.$id;
	
	            var _dropEnabled = false;
	
	            var onDropCallback = $parse(attrs.ngDropSuccess); // || function(){};
	
	            var onDragStartCallback = $parse(attrs.ngDragStart);
	            var onDragStopCallback = $parse(attrs.ngDragStop);
	            var onDragMoveCallback = $parse(attrs.ngDragMove);
	
	            var initialize = function initialize() {
	                toggleListeners(true);
	            };
	
	            var toggleListeners = function toggleListeners(enable) {
	                // remove listeners
	
	                if (!enable) return;
	                // add listeners.
	                scope.$watch(attrs.ngDrop, onEnableChange);
	                scope.$on('$destroy', onDestroy);
	                scope.$on('draggable:start', onDragStart);
	                scope.$on('draggable:move', onDragMove);
	                scope.$on('draggable:end', onDragEnd);
	            };
	
	            var onDestroy = function onDestroy(enable) {
	                toggleListeners(false);
	            };
	            var onEnableChange = function onEnableChange(newVal, oldVal) {
	                _dropEnabled = newVal;
	            };
	            var onDragStart = function onDragStart(evt, obj) {
	                if (!_dropEnabled) return;
	                isTouching(obj.x, obj.y, obj.element);
	
	                if (attrs.ngDragStart) {
	                    $timeout(function () {
	                        onDragStartCallback(scope, { $data: obj.data, $event: obj });
	                    });
	                }
	            };
	            var onDragMove = function onDragMove(evt, obj) {
	                if (!_dropEnabled) return;
	                isTouching(obj.x, obj.y, obj.element);
	
	                if (attrs.ngDragMove) {
	                    $timeout(function () {
	                        onDragMoveCallback(scope, { $data: obj.data, $event: obj });
	                    });
	                }
	            };
	
	            var onDragEnd = function onDragEnd(evt, obj) {
	
	                // don't listen to drop events if this is the element being dragged
	                // only update the styles and return
	                if (!_dropEnabled || _myid === obj.uid) {
	                    updateDragStyles(false, obj.element);
	                    return;
	                }
	                if (isTouching(obj.x, obj.y, obj.element)) {
	                    // call the ngDraggable ngDragSuccess element callback
	                    if (obj.callback) {
	                        obj.callback(obj);
	                    }
	
	                    if (attrs.ngDropSuccess) {
	                        $timeout(function () {
	                            onDropCallback(scope, { $data: obj.data, $event: obj, $target: scope.$eval(scope.value) });
	                        });
	                    }
	                }
	
	                if (attrs.ngDragStop) {
	                    $timeout(function () {
	                        onDragStopCallback(scope, { $data: obj.data, $event: obj });
	                    });
	                }
	
	                updateDragStyles(false, obj.element);
	            };
	
	            var isTouching = function isTouching(mouseX, mouseY, dragElement) {
	                var touching = hitTest(mouseX, mouseY);
	                scope.isTouching = touching;
	                if (touching) {
	                    _lastDropTouch = element;
	                }
	                updateDragStyles(touching, dragElement);
	                return touching;
	            };
	
	            var updateDragStyles = function updateDragStyles(touching, dragElement) {
	                if (touching) {
	                    element.addClass('drag-enter');
	                    dragElement.addClass('drag-over');
	                } else if (_lastDropTouch == element) {
	                    _lastDropTouch = null;
	                    element.removeClass('drag-enter');
	                    dragElement.removeClass('drag-over');
	                }
	            };
	
	            var hitTest = function hitTest(x, y) {
	                var bounds = element[0].getBoundingClientRect(); // ngDraggable.getPrivOffset(element);
	                x -= $document[0].body.scrollLeft + $document[0].documentElement.scrollLeft;
	                y -= $document[0].body.scrollTop + $document[0].documentElement.scrollTop;
	                return x >= bounds.left && x <= bounds.right && y <= bounds.bottom && y >= bounds.top;
	            };
	
	            initialize();
	        }
	    };
	}]).directive('ngDragClone', ['$parse', '$timeout', 'ngDraggable', function ($parse, $timeout, ngDraggable) {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            var img,
	                _allowClone = true;
	            var _dragOffset = null;
	            scope.clonedData = {};
	            var initialize = function initialize() {
	
	                img = element.find('img');
	                element.attr('draggable', 'false');
	                img.attr('draggable', 'false');
	                reset();
	                toggleListeners(true);
	            };
	
	            var toggleListeners = function toggleListeners(enable) {
	                // remove listeners
	
	                if (!enable) return;
	                // add listeners.
	                scope.$on('draggable:start', onDragStart);
	                scope.$on('draggable:move', onDragMove);
	                scope.$on('draggable:end', onDragEnd);
	                preventContextMenu();
	            };
	            var preventContextMenu = function preventContextMenu() {
	                //  element.off('mousedown touchstart touchmove touchend touchcancel', absorbEvent_);
	                img.off('mousedown touchstart touchmove touchend touchcancel', absorbEvent_);
	                //  element.on('mousedown touchstart touchmove touchend touchcancel', absorbEvent_);
	                img.on('mousedown touchstart touchmove touchend touchcancel', absorbEvent_);
	            };
	            var onDragStart = function onDragStart(evt, obj, elm) {
	                _allowClone = true;
	                if (_angular2['default'].isDefined(obj.data.allowClone)) {
	                    _allowClone = obj.data.allowClone;
	                }
	                if (_allowClone) {
	                    scope.$apply(function () {
	                        scope.clonedData = obj.data;
	                    });
	                    element.css('width', obj.element[0].offsetWidth);
	                    element.css('height', obj.element[0].offsetHeight);
	
	                    moveElement(obj.tx, obj.ty);
	                }
	
	                _dragOffset = element[0].getBoundingClientRect(); //ngDraggable.getPrivOffset(element);
	            };
	            var onDragMove = function onDragMove(evt, obj) {
	                if (_allowClone) {
	
	                    _tx = obj.tx + _dragOffset.left;
	                    _ty = obj.ty + _dragOffset.top;
	
	                    moveElement(_tx, _ty);
	                }
	            };
	            var onDragEnd = function onDragEnd(evt, obj) {
	                //moveElement(obj.tx,obj.ty);
	                if (_allowClone) {
	                    reset();
	                }
	            };
	
	            var reset = function reset() {
	                element.css({ left: 0, top: 0, position: 'fixed', 'z-index': -1, visibility: 'hidden' });
	            };
	            var moveElement = function moveElement(x, y) {
	                element.css({
	                    transform: 'matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, ' + x + ', ' + y + ', 0, 1)', 'z-index': 99999, 'visibility': 'visible',
	                    '-webkit-transform': 'matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, ' + x + ', ' + y + ', 0, 1)',
	                    '-ms-transform': 'matrix(1, 0, 0, 1, ' + x + ', ' + y + ')'
	                    //,margin: '0'  don't monkey with the margin,
	                });
	            };
	
	            var absorbEvent_ = function absorbEvent_(event) {
	                var e = event; //.originalEvent;
	                e.preventDefault && e.preventDefault();
	                e.stopPropagation && e.stopPropagation();
	                e.cancelBubble = true;
	                e.returnValue = false;
	                return false;
	            };
	
	            initialize();
	        }
	    };
	}]).directive('ngPreventDrag', ['$parse', '$timeout', function ($parse, $timeout) {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            var initialize = function initialize() {
	
	                element.attr('draggable', 'false');
	                toggleListeners(true);
	            };
	
	            var toggleListeners = function toggleListeners(enable) {
	                // remove listeners
	
	                if (!enable) return;
	                // add listeners.
	                element.on('mousedown touchstart touchmove touchend touchcancel', absorbEvent_);
	            };
	
	            var absorbEvent_ = function absorbEvent_(event) {
	                var e = event.originalEvent;
	                e.preventDefault && e.preventDefault();
	                e.stopPropagation && e.stopPropagation();
	                e.cancelBubble = true;
	                e.returnValue = false;
	                return false;
	            };
	
	            initialize();
	        }
	    };
	}]).directive('ngCancelDrag', [function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            element.find('*').attr('ng-cancel-drag', 'ng-cancel-drag');
	        }
	    };
	}]).directive('ngDragScroll', ['$window', '$interval', '$timeout', '$document', '$rootScope', function ($window, $interval, $timeout, $document, $rootScope) {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            var intervalPromise = null;
	            var lastMouseEvent = null;
	
	            var config = {
	                verticalScroll: attrs.verticalScroll || true,
	                horizontalScroll: attrs.horizontalScroll || true,
	                activationDistance: attrs.activationDistance || 75,
	                scrollDistance: attrs.scrollDistance || 15
	            };
	
	            var reqAnimFrame = (function () {
	                return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function ( /* function FrameRequestCallback */callback, /* DOMElement Element */element) {
	                    window.setTimeout(callback, 1000 / 60);
	                };
	            })();
	
	            var animationIsOn = false;
	            var createInterval = function createInterval() {
	                animationIsOn = true;
	
	                function nextFrame(callback) {
	                    var args = Array.prototype.slice.call(arguments);
	                    if (animationIsOn) {
	                        reqAnimFrame(function () {
	                            $rootScope.$apply(function () {
	                                callback.apply(null, args);
	                                nextFrame(callback);
	                            });
	                        });
	                    }
	                }
	
	                nextFrame(function () {
	                    if (!lastMouseEvent) return;
	
	                    var viewportWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
	                    var viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
	
	                    var scrollX = 0;
	                    var scrollY = 0;
	
	                    if (config.horizontalScroll) {
	                        // If horizontal scrolling is active.
	                        if (lastMouseEvent.clientX < config.activationDistance) {
	                            // If the mouse is on the left of the viewport within the activation distance.
	                            scrollX = -config.scrollDistance;
	                        } else if (lastMouseEvent.clientX > viewportWidth - config.activationDistance) {
	                            // If the mouse is on the right of the viewport within the activation distance.
	                            scrollX = config.scrollDistance;
	                        }
	                    }
	
	                    if (config.verticalScroll) {
	                        // If vertical scrolling is active.
	                        if (lastMouseEvent.clientY < config.activationDistance) {
	                            // If the mouse is on the top of the viewport within the activation distance.
	                            scrollY = -config.scrollDistance;
	                        } else if (lastMouseEvent.clientY > viewportHeight - config.activationDistance) {
	                            // If the mouse is on the bottom of the viewport within the activation distance.
	                            scrollY = config.scrollDistance;
	                        }
	                    }
	
	                    if (scrollX !== 0 || scrollY !== 0) {
	                        // Record the current scroll position.
	                        var currentScrollLeft = $window.pageXOffset || $document[0].documentElement.scrollLeft;
	                        var currentScrollTop = $window.pageYOffset || $document[0].documentElement.scrollTop;
	
	                        // Remove the transformation from the element, scroll the window by the scroll distance
	                        // record how far we scrolled, then reapply the element transformation.
	                        var elementTransform = element.css('transform');
	                        element.css('transform', 'initial');
	
	                        $window.scrollBy(scrollX, scrollY);
	
	                        var horizontalScrollAmount = ($window.pageXOffset || $document[0].documentElement.scrollLeft) - currentScrollLeft;
	                        var verticalScrollAmount = ($window.pageYOffset || $document[0].documentElement.scrollTop) - currentScrollTop;
	
	                        element.css('transform', elementTransform);
	
	                        lastMouseEvent.pageX += horizontalScrollAmount;
	                        lastMouseEvent.pageY += verticalScrollAmount;
	
	                        $rootScope.$emit('draggable:_triggerHandlerMove', lastMouseEvent);
	                    }
	                });
	            };
	
	            var clearInterval = function clearInterval() {
	                animationIsOn = false;
	            };
	
	            scope.$on('draggable:start', function (event, obj) {
	                // Ignore this event if it's not for this element.
	                if (obj.element[0] !== element[0]) return;
	
	                if (!animationIsOn) createInterval();
	            });
	
	            scope.$on('draggable:end', function (event, obj) {
	                // Ignore this event if it's not for this element.
	                if (obj.element[0] !== element[0]) return;
	
	                if (animationIsOn) clearInterval();
	            });
	
	            scope.$on('draggable:move', function (event, obj) {
	                // Ignore this event if it's not for this element.
	                if (obj.element[0] !== element[0]) return;
	
	                lastMouseEvent = obj.event;
	            });
	        }
	    };
	}]);
	
	exports.ngDraggable = ngDraggable;

/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _loggerJs = __webpack_require__(418);
	
	var _module = _angular2['default'].module('logger', []);
	
	_module.service('logger', ['$filter', function ($filter) {
	    return {
	        error: function error(title, data) {
	            _loggerJs.logger.error(title, $filter('json')(data));
	        }
	    };
	}]);
	
	exports['default'] = _module;
	module.exports = exports['default'];

/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _swalSwalJs = __webpack_require__(419);
	
	var _swalSwalJs2 = _interopRequireDefault(_swalSwalJs);
	
	var _lodash = __webpack_require__(165);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function error(title, data) {
	    var html = '<pre style="text-align: left">' + data + '</pre>';
	    (0, _swalSwalJs2['default'])({
	        title: title,
	        text: html,
	        html: true,
	        type: 'error'
	    });
	}
	
	function info(message, data, title) {
	    toastr.info(message, title);
	    // $log.info('Info: ' + title, data);
	}
	
	function success(message, data, title) {
	    toastr.success(message, title);
	    // $log.info('Success: ' + title, data);
	}
	
	function warning(message, data, title) {
	    toastr.warning(message, title);
	    // $log.warn('Warning: ' + title, data);
	}
	
	var logger = {
	
	    error: error,
	    info: info,
	    success: success,
	    warning: warning
	};
	
	exports.logger = logger;

/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _sweetalert = __webpack_require__(375);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	exports['default'] = function () {
	    var previousWindowKeyDown = window.onkeydown;
	    _sweetalert2['default'].apply(this, Array.prototype.slice.call(arguments, 0));
	    window.onkeydown = previousWindowKeyDown;
	};
	
	module.exports = exports['default'];

/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _loadingComponentJs = __webpack_require__(421);
	
	var loading = _angular2['default'].module('loading', []);
	
	loading.component('loading', _loadingComponentJs.LoadingComponent);
	
	exports.loading = loading;

/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _loadingHtml = __webpack_require__(422);
	
	var _loadingHtml2 = _interopRequireDefault(_loadingHtml);
	
	var LoadingController = function LoadingController() {
	    _classCallCheck(this, LoadingController);
	};
	
	LoadingController.$inject = [];
	
	var LoadingComponent = {
	    restrict: 'E',
	    templateUrl: _loadingHtml2['default'],
	    controller: LoadingController,
	    controllerAs: 'vm',
	    bindings: {
	        isLoading: '<',
	        message: '@'
	    }
	};
	
	exports.LoadingComponent = LoadingComponent;
	exports.LoadingController = LoadingController;

/***/ },
/* 422 */
/***/ function(module, exports) {

	var path = 'app/components/common/loading/loading.html';
	var html = "<div class=\"row\" ng-if=\"vm.isLoading\"><div class=\"col-lg-12 text-center\"><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div><div class=\"col-lg-12 text-center\"><span>{{vm.message}}</span></div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiBootstrapSrcModal = __webpack_require__(424);
	
	var _angularUiBootstrapSrcModal2 = _interopRequireDefault(_angularUiBootstrapSrcModal);
	
	var _dashboardComponentJs = __webpack_require__(430);
	
	var _animateFazeDirectiveJs = __webpack_require__(436);
	
	var _animateFazeDirectiveJs2 = _interopRequireDefault(_animateFazeDirectiveJs);
	
	var dashboard = _angular2['default'].module('dashboard', [_angularUiBootstrapSrcModal2['default']]);
	
	dashboard.component('dashboard', _dashboardComponentJs.DashboardComponent);
	dashboard.directive('animateFaze', _animateFazeDirectiveJs2['default']);
	
	exports.dashboard = dashboard;

/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(170);
	module.exports = __webpack_require__(425);


/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(426);
	__webpack_require__(175);
	__webpack_require__(177);
	__webpack_require__(428);
	__webpack_require__(429);
	
	var MODULE_NAME = 'ui.bootstrap.module.modal';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.modal', 'uib/template/modal/window.html']);
	
	module.exports = MODULE_NAME;


/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(427);


/***/ },
/* 427 */
/***/ function(module, exports) {

	angular.module('ui.bootstrap.multiMap', [])
	/**
	 * A helper, internal data structure that stores all references attached to key
	 */
	  .factory('$$multiMap', function() {
	    return {
	      createNew: function() {
	        var map = {};
	
	        return {
	          entries: function() {
	            return Object.keys(map).map(function(key) {
	              return {
	                key: key,
	                value: map[key]
	              };
	            });
	          },
	          get: function(key) {
	            return map[key];
	          },
	          hasKey: function(key) {
	            return !!map[key];
	          },
	          keys: function() {
	            return Object.keys(map);
	          },
	          put: function(key, value) {
	            if (!map[key]) {
	              map[key] = [];
	            }
	
	            map[key].push(value);
	          },
	          remove: function(key, value) {
	            var values = map[key];
	
	            if (!values) {
	              return;
	            }
	
	            var idx = values.indexOf(value);
	
	            if (idx !== -1) {
	              values.splice(idx, 1);
	            }
	
	            if (!values.length) {
	              delete map[key];
	            }
	          }
	        };
	      }
	    };
	  });


/***/ },
/* 428 */
/***/ function(module, exports) {

	angular.module("uib/template/modal/window.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("uib/template/modal/window.html",
	    "<div class=\"modal-dialog {{size ? 'modal-' + size : ''}}\"><div class=\"modal-content\" uib-modal-transclude></div></div>\n" +
	    "");
	}]);


/***/ },
/* 429 */
/***/ function(module, exports) {

	angular.module('ui.bootstrap.modal', ['ui.bootstrap.multiMap', 'ui.bootstrap.stackedMap', 'ui.bootstrap.position'])
	/**
	 * Pluggable resolve mechanism for the modal resolve resolution
	 * Supports UI Router's $resolve service
	 */
	  .provider('$uibResolve', function() {
	    var resolve = this;
	    this.resolver = null;
	
	    this.setResolver = function(resolver) {
	      this.resolver = resolver;
	    };
	
	    this.$get = ['$injector', '$q', function($injector, $q) {
	      var resolver = resolve.resolver ? $injector.get(resolve.resolver) : null;
	      return {
	        resolve: function(invocables, locals, parent, self) {
	          if (resolver) {
	            return resolver.resolve(invocables, locals, parent, self);
	          }
	
	          var promises = [];
	
	          angular.forEach(invocables, function(value) {
	            if (angular.isFunction(value) || angular.isArray(value)) {
	              promises.push($q.resolve($injector.invoke(value)));
	            } else if (angular.isString(value)) {
	              promises.push($q.resolve($injector.get(value)));
	            } else {
	              promises.push($q.resolve(value));
	            }
	          });
	
	          return $q.all(promises).then(function(resolves) {
	            var resolveObj = {};
	            var resolveIter = 0;
	            angular.forEach(invocables, function(value, key) {
	              resolveObj[key] = resolves[resolveIter++];
	            });
	
	            return resolveObj;
	          });
	        }
	      };
	    }];
	  })
	
	/**
	 * A helper directive for the $modal service. It creates a backdrop element.
	 */
	  .directive('uibModalBackdrop', ['$animate', '$injector', '$uibModalStack',
	  function($animate, $injector, $modalStack) {
	    return {
	      restrict: 'A',
	      compile: function(tElement, tAttrs) {
	        tElement.addClass(tAttrs.backdropClass);
	        return linkFn;
	      }
	    };
	
	    function linkFn(scope, element, attrs) {
	      if (attrs.modalInClass) {
	        $animate.addClass(element, attrs.modalInClass);
	
	        scope.$on($modalStack.NOW_CLOSING_EVENT, function(e, setIsAsync) {
	          var done = setIsAsync();
	          if (scope.modalOptions.animation) {
	            $animate.removeClass(element, attrs.modalInClass).then(done);
	          } else {
	            done();
	          }
	        });
	      }
	    }
	  }])
	
	  .directive('uibModalWindow', ['$uibModalStack', '$q', '$animateCss', '$document',
	  function($modalStack, $q, $animateCss, $document) {
	    return {
	      scope: {
	        index: '@'
	      },
	      restrict: 'A',
	      transclude: true,
	      templateUrl: function(tElement, tAttrs) {
	        return tAttrs.templateUrl || 'uib/template/modal/window.html';
	      },
	      link: function(scope, element, attrs) {
	        element.addClass(attrs.windowTopClass || '');
	        scope.size = attrs.size;
	
	        scope.close = function(evt) {
	          var modal = $modalStack.getTop();
	          if (modal && modal.value.backdrop &&
	            modal.value.backdrop !== 'static' &&
	            evt.target === evt.currentTarget) {
	            evt.preventDefault();
	            evt.stopPropagation();
	            $modalStack.dismiss(modal.key, 'backdrop click');
	          }
	        };
	
	        // moved from template to fix issue #2280
	        element.on('click', scope.close);
	
	        // This property is only added to the scope for the purpose of detecting when this directive is rendered.
	        // We can detect that by using this property in the template associated with this directive and then use
	        // {@link Attribute#$observe} on it. For more details please see {@link TableColumnResize}.
	        scope.$isRendered = true;
	
	        // Deferred object that will be resolved when this modal is rendered.
	        var modalRenderDeferObj = $q.defer();
	        // Resolve render promise post-digest
	        scope.$$postDigest(function() {
	          modalRenderDeferObj.resolve();
	        });
	
	        modalRenderDeferObj.promise.then(function() {
	          var animationPromise = null;
	
	          if (attrs.modalInClass) {
	            animationPromise = $animateCss(element, {
	              addClass: attrs.modalInClass
	            }).start();
	
	            scope.$on($modalStack.NOW_CLOSING_EVENT, function(e, setIsAsync) {
	              var done = setIsAsync();
	              $animateCss(element, {
	                removeClass: attrs.modalInClass
	              }).start().then(done);
	            });
	          }
	
	
	          $q.when(animationPromise).then(function() {
	            // Notify {@link $modalStack} that modal is rendered.
	            var modal = $modalStack.getTop();
	            if (modal) {
	              $modalStack.modalRendered(modal.key);
	            }
	
	            /**
	             * If something within the freshly-opened modal already has focus (perhaps via a
	             * directive that causes focus) then there's no need to try to focus anything.
	             */
	            if (!($document[0].activeElement && element[0].contains($document[0].activeElement))) {
	              var inputWithAutofocus = element[0].querySelector('[autofocus]');
	              /**
	               * Auto-focusing of a freshly-opened modal element causes any child elements
	               * with the autofocus attribute to lose focus. This is an issue on touch
	               * based devices which will show and then hide the onscreen keyboard.
	               * Attempts to refocus the autofocus element via JavaScript will not reopen
	               * the onscreen keyboard. Fixed by updated the focusing logic to only autofocus
	               * the modal element if the modal does not contain an autofocus element.
	               */
	              if (inputWithAutofocus) {
	                inputWithAutofocus.focus();
	              } else {
	                element[0].focus();
	              }
	            }
	          });
	        });
	      }
	    };
	  }])
	
	  .directive('uibModalAnimationClass', function() {
	    return {
	      compile: function(tElement, tAttrs) {
	        if (tAttrs.modalAnimation) {
	          tElement.addClass(tAttrs.uibModalAnimationClass);
	        }
	      }
	    };
	  })
	
	  .directive('uibModalTransclude', ['$animate', function($animate) {
	    return {
	      link: function(scope, element, attrs, controller, transclude) {
	        transclude(scope.$parent, function(clone) {
	          element.empty();
	          $animate.enter(clone, element);
	        });
	      }
	    };
	  }])
	
	  .factory('$uibModalStack', ['$animate', '$animateCss', '$document',
	    '$compile', '$rootScope', '$q', '$$multiMap', '$$stackedMap', '$uibPosition',
	    function($animate, $animateCss, $document, $compile, $rootScope, $q, $$multiMap, $$stackedMap, $uibPosition) {
	      var OPENED_MODAL_CLASS = 'modal-open';
	
	      var backdropDomEl, backdropScope;
	      var openedWindows = $$stackedMap.createNew();
	      var openedClasses = $$multiMap.createNew();
	      var $modalStack = {
	        NOW_CLOSING_EVENT: 'modal.stack.now-closing'
	      };
	      var topModalIndex = 0;
	      var previousTopOpenedModal = null;
	      var ARIA_HIDDEN_ATTRIBUTE_NAME = 'data-bootstrap-modal-aria-hidden-count';
	
	      //Modal focus behavior
	      var tabbableSelector = 'a[href], area[href], input:not([disabled]):not([tabindex=\'-1\']), ' +
	        'button:not([disabled]):not([tabindex=\'-1\']),select:not([disabled]):not([tabindex=\'-1\']), textarea:not([disabled]):not([tabindex=\'-1\']), ' +
	        'iframe, object, embed, *[tabindex]:not([tabindex=\'-1\']), *[contenteditable=true]';
	      var scrollbarPadding;
	      var SNAKE_CASE_REGEXP = /[A-Z]/g;
	
	      // TODO: extract into common dependency with tooltip
	      function snake_case(name) {
	        var separator = '-';
	        return name.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
	          return (pos ? separator : '') + letter.toLowerCase();
	        });
	      }
	
	      function isVisible(element) {
	        return !!(element.offsetWidth ||
	          element.offsetHeight ||
	          element.getClientRects().length);
	      }
	
	      function backdropIndex() {
	        var topBackdropIndex = -1;
	        var opened = openedWindows.keys();
	        for (var i = 0; i < opened.length; i++) {
	          if (openedWindows.get(opened[i]).value.backdrop) {
	            topBackdropIndex = i;
	          }
	        }
	
	        // If any backdrop exist, ensure that it's index is always
	        // right below the top modal
	        if (topBackdropIndex > -1 && topBackdropIndex < topModalIndex) {
	          topBackdropIndex = topModalIndex;
	        }
	        return topBackdropIndex;
	      }
	
	      $rootScope.$watch(backdropIndex, function(newBackdropIndex) {
	        if (backdropScope) {
	          backdropScope.index = newBackdropIndex;
	        }
	      });
	
	      function removeModalWindow(modalInstance, elementToReceiveFocus) {
	        var modalWindow = openedWindows.get(modalInstance).value;
	        var appendToElement = modalWindow.appendTo;
	
	        //clean up the stack
	        openedWindows.remove(modalInstance);
	        previousTopOpenedModal = openedWindows.top();
	        if (previousTopOpenedModal) {
	          topModalIndex = parseInt(previousTopOpenedModal.value.modalDomEl.attr('index'), 10);
	        }
	
	        removeAfterAnimate(modalWindow.modalDomEl, modalWindow.modalScope, function() {
	          var modalBodyClass = modalWindow.openedClass || OPENED_MODAL_CLASS;
	          openedClasses.remove(modalBodyClass, modalInstance);
	          var areAnyOpen = openedClasses.hasKey(modalBodyClass);
	          appendToElement.toggleClass(modalBodyClass, areAnyOpen);
	          if (!areAnyOpen && scrollbarPadding && scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
	            if (scrollbarPadding.originalRight) {
	              appendToElement.css({paddingRight: scrollbarPadding.originalRight + 'px'});
	            } else {
	              appendToElement.css({paddingRight: ''});
	            }
	            scrollbarPadding = null;
	          }
	          toggleTopWindowClass(true);
	        }, modalWindow.closedDeferred);
	        checkRemoveBackdrop();
	
	        //move focus to specified element if available, or else to body
	        if (elementToReceiveFocus && elementToReceiveFocus.focus) {
	          elementToReceiveFocus.focus();
	        } else if (appendToElement.focus) {
	          appendToElement.focus();
	        }
	      }
	
	      // Add or remove "windowTopClass" from the top window in the stack
	      function toggleTopWindowClass(toggleSwitch) {
	        var modalWindow;
	
	        if (openedWindows.length() > 0) {
	          modalWindow = openedWindows.top().value;
	          modalWindow.modalDomEl.toggleClass(modalWindow.windowTopClass || '', toggleSwitch);
	        }
	      }
	
	      function checkRemoveBackdrop() {
	        //remove backdrop if no longer needed
	        if (backdropDomEl && backdropIndex() === -1) {
	          var backdropScopeRef = backdropScope;
	          removeAfterAnimate(backdropDomEl, backdropScope, function() {
	            backdropScopeRef = null;
	          });
	          backdropDomEl = undefined;
	          backdropScope = undefined;
	        }
	      }
	
	      function removeAfterAnimate(domEl, scope, done, closedDeferred) {
	        var asyncDeferred;
	        var asyncPromise = null;
	        var setIsAsync = function() {
	          if (!asyncDeferred) {
	            asyncDeferred = $q.defer();
	            asyncPromise = asyncDeferred.promise;
	          }
	
	          return function asyncDone() {
	            asyncDeferred.resolve();
	          };
	        };
	        scope.$broadcast($modalStack.NOW_CLOSING_EVENT, setIsAsync);
	
	        // Note that it's intentional that asyncPromise might be null.
	        // That's when setIsAsync has not been called during the
	        // NOW_CLOSING_EVENT broadcast.
	        return $q.when(asyncPromise).then(afterAnimating);
	
	        function afterAnimating() {
	          if (afterAnimating.done) {
	            return;
	          }
	          afterAnimating.done = true;
	
	          $animate.leave(domEl).then(function() {
	            if (done) {
	              done();
	            }
	
	            domEl.remove();
	            if (closedDeferred) {
	              closedDeferred.resolve();
	            }
	          });
	
	          scope.$destroy();
	        }
	      }
	
	      $document.on('keydown', keydownListener);
	
	      $rootScope.$on('$destroy', function() {
	        $document.off('keydown', keydownListener);
	      });
	
	      function keydownListener(evt) {
	        if (evt.isDefaultPrevented()) {
	          return evt;
	        }
	
	        var modal = openedWindows.top();
	        if (modal) {
	          switch (evt.which) {
	            case 27: {
	              if (modal.value.keyboard) {
	                evt.preventDefault();
	                $rootScope.$apply(function() {
	                  $modalStack.dismiss(modal.key, 'escape key press');
	                });
	              }
	              break;
	            }
	            case 9: {
	              var list = $modalStack.loadFocusElementList(modal);
	              var focusChanged = false;
	              if (evt.shiftKey) {
	                if ($modalStack.isFocusInFirstItem(evt, list) || $modalStack.isModalFocused(evt, modal)) {
	                  focusChanged = $modalStack.focusLastFocusableElement(list);
	                }
	              } else {
	                if ($modalStack.isFocusInLastItem(evt, list)) {
	                  focusChanged = $modalStack.focusFirstFocusableElement(list);
	                }
	              }
	
	              if (focusChanged) {
	                evt.preventDefault();
	                evt.stopPropagation();
	              }
	
	              break;
	            }
	          }
	        }
	      }
	
	      $modalStack.open = function(modalInstance, modal) {
	        var modalOpener = $document[0].activeElement,
	          modalBodyClass = modal.openedClass || OPENED_MODAL_CLASS;
	
	        toggleTopWindowClass(false);
	
	        // Store the current top first, to determine what index we ought to use
	        // for the current top modal
	        previousTopOpenedModal = openedWindows.top();
	
	        openedWindows.add(modalInstance, {
	          deferred: modal.deferred,
	          renderDeferred: modal.renderDeferred,
	          closedDeferred: modal.closedDeferred,
	          modalScope: modal.scope,
	          backdrop: modal.backdrop,
	          keyboard: modal.keyboard,
	          openedClass: modal.openedClass,
	          windowTopClass: modal.windowTopClass,
	          animation: modal.animation,
	          appendTo: modal.appendTo
	        });
	
	        openedClasses.put(modalBodyClass, modalInstance);
	
	        var appendToElement = modal.appendTo,
	            currBackdropIndex = backdropIndex();
	
	        if (currBackdropIndex >= 0 && !backdropDomEl) {
	          backdropScope = $rootScope.$new(true);
	          backdropScope.modalOptions = modal;
	          backdropScope.index = currBackdropIndex;
	          backdropDomEl = angular.element('<div uib-modal-backdrop="modal-backdrop"></div>');
	          backdropDomEl.attr({
	            'class': 'modal-backdrop',
	            'ng-style': '{\'z-index\': 1040 + (index && 1 || 0) + index*10}',
	            'uib-modal-animation-class': 'fade',
	            'modal-in-class': 'in'
	          });
	          if (modal.backdropClass) {
	            backdropDomEl.addClass(modal.backdropClass);
	          }
	
	          if (modal.animation) {
	            backdropDomEl.attr('modal-animation', 'true');
	          }
	          $compile(backdropDomEl)(backdropScope);
	          $animate.enter(backdropDomEl, appendToElement);
	          if ($uibPosition.isScrollable(appendToElement)) {
	            scrollbarPadding = $uibPosition.scrollbarPadding(appendToElement);
	            if (scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
	              appendToElement.css({paddingRight: scrollbarPadding.right + 'px'});
	            }
	          }
	        }
	
	        var content;
	        if (modal.component) {
	          content = document.createElement(snake_case(modal.component.name));
	          content = angular.element(content);
	          content.attr({
	            resolve: '$resolve',
	            'modal-instance': '$uibModalInstance',
	            close: '$close($value)',
	            dismiss: '$dismiss($value)'
	          });
	        } else {
	          content = modal.content;
	        }
	
	        // Set the top modal index based on the index of the previous top modal
	        topModalIndex = previousTopOpenedModal ? parseInt(previousTopOpenedModal.value.modalDomEl.attr('index'), 10) + 1 : 0;
	        var angularDomEl = angular.element('<div uib-modal-window="modal-window"></div>');
	        angularDomEl.attr({
	          'class': 'modal',
	          'template-url': modal.windowTemplateUrl,
	          'window-top-class': modal.windowTopClass,
	          'role': 'dialog',
	          'aria-labelledby': modal.ariaLabelledBy,
	          'aria-describedby': modal.ariaDescribedBy,
	          'size': modal.size,
	          'index': topModalIndex,
	          'animate': 'animate',
	          'ng-style': '{\'z-index\': 1050 + $$topModalIndex*10, display: \'block\'}',
	          'tabindex': -1,
	          'uib-modal-animation-class': 'fade',
	          'modal-in-class': 'in'
	        }).append(content);
	        if (modal.windowClass) {
	          angularDomEl.addClass(modal.windowClass);
	        }
	
	        if (modal.animation) {
	          angularDomEl.attr('modal-animation', 'true');
	        }
	
	        appendToElement.addClass(modalBodyClass);
	        if (modal.scope) {
	          // we need to explicitly add the modal index to the modal scope
	          // because it is needed by ngStyle to compute the zIndex property.
	          modal.scope.$$topModalIndex = topModalIndex;
	        }
	        $animate.enter($compile(angularDomEl)(modal.scope), appendToElement);
	
	        openedWindows.top().value.modalDomEl = angularDomEl;
	        openedWindows.top().value.modalOpener = modalOpener;
	
	        applyAriaHidden(angularDomEl);
	
	        function applyAriaHidden(el) {
	          if (!el || el[0].tagName === 'BODY') {
	            return;
	          }
	
	          getSiblings(el).forEach(function(sibling) {
	            var elemIsAlreadyHidden = sibling.getAttribute('aria-hidden') === 'true',
	              ariaHiddenCount = parseInt(sibling.getAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME), 10);
	
	            if (!ariaHiddenCount) {
	              ariaHiddenCount = elemIsAlreadyHidden ? 1 : 0;
	            }
	
	            sibling.setAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME, ariaHiddenCount + 1);
	            sibling.setAttribute('aria-hidden', 'true');
	          });
	
	          return applyAriaHidden(el.parent());
	
	          function getSiblings(el) {
	            var children = el.parent() ? el.parent().children() : [];
	
	            return Array.prototype.filter.call(children, function(child) {
	              return child !== el[0];
	            });
	          }
	        }
	      };
	
	      function broadcastClosing(modalWindow, resultOrReason, closing) {
	        return !modalWindow.value.modalScope.$broadcast('modal.closing', resultOrReason, closing).defaultPrevented;
	      }
	
	      function unhideBackgroundElements() {
	        Array.prototype.forEach.call(
	          document.querySelectorAll('[' + ARIA_HIDDEN_ATTRIBUTE_NAME + ']'),
	          function(hiddenEl) {
	            var ariaHiddenCount = parseInt(hiddenEl.getAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME), 10),
	              newHiddenCount = ariaHiddenCount - 1;
	            hiddenEl.setAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME, newHiddenCount);
	
	            if (!newHiddenCount) {
	              hiddenEl.removeAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME);
	              hiddenEl.removeAttribute('aria-hidden');
	            }
	          }
	        );
	      }
	
	      $modalStack.close = function(modalInstance, result) {
	        var modalWindow = openedWindows.get(modalInstance);
	        unhideBackgroundElements();
	        if (modalWindow && broadcastClosing(modalWindow, result, true)) {
	          modalWindow.value.modalScope.$$uibDestructionScheduled = true;
	          modalWindow.value.deferred.resolve(result);
	          removeModalWindow(modalInstance, modalWindow.value.modalOpener);
	          return true;
	        }
	
	        return !modalWindow;
	      };
	
	      $modalStack.dismiss = function(modalInstance, reason) {
	        var modalWindow = openedWindows.get(modalInstance);
	        unhideBackgroundElements();
	        if (modalWindow && broadcastClosing(modalWindow, reason, false)) {
	          modalWindow.value.modalScope.$$uibDestructionScheduled = true;
	          modalWindow.value.deferred.reject(reason);
	          removeModalWindow(modalInstance, modalWindow.value.modalOpener);
	          return true;
	        }
	        return !modalWindow;
	      };
	
	      $modalStack.dismissAll = function(reason) {
	        var topModal = this.getTop();
	        while (topModal && this.dismiss(topModal.key, reason)) {
	          topModal = this.getTop();
	        }
	      };
	
	      $modalStack.getTop = function() {
	        return openedWindows.top();
	      };
	
	      $modalStack.modalRendered = function(modalInstance) {
	        var modalWindow = openedWindows.get(modalInstance);
	        if (modalWindow) {
	          modalWindow.value.renderDeferred.resolve();
	        }
	      };
	
	      $modalStack.focusFirstFocusableElement = function(list) {
	        if (list.length > 0) {
	          list[0].focus();
	          return true;
	        }
	        return false;
	      };
	
	      $modalStack.focusLastFocusableElement = function(list) {
	        if (list.length > 0) {
	          list[list.length - 1].focus();
	          return true;
	        }
	        return false;
	      };
	
	      $modalStack.isModalFocused = function(evt, modalWindow) {
	        if (evt && modalWindow) {
	          var modalDomEl = modalWindow.value.modalDomEl;
	          if (modalDomEl && modalDomEl.length) {
	            return (evt.target || evt.srcElement) === modalDomEl[0];
	          }
	        }
	        return false;
	      };
	
	      $modalStack.isFocusInFirstItem = function(evt, list) {
	        if (list.length > 0) {
	          return (evt.target || evt.srcElement) === list[0];
	        }
	        return false;
	      };
	
	      $modalStack.isFocusInLastItem = function(evt, list) {
	        if (list.length > 0) {
	          return (evt.target || evt.srcElement) === list[list.length - 1];
	        }
	        return false;
	      };
	
	      $modalStack.loadFocusElementList = function(modalWindow) {
	        if (modalWindow) {
	          var modalDomE1 = modalWindow.value.modalDomEl;
	          if (modalDomE1 && modalDomE1.length) {
	            var elements = modalDomE1[0].querySelectorAll(tabbableSelector);
	            return elements ?
	              Array.prototype.filter.call(elements, function(element) {
	                return isVisible(element);
	              }) : elements;
	          }
	        }
	      };
	
	      return $modalStack;
	    }])
	
	  .provider('$uibModal', function() {
	    var $modalProvider = {
	      options: {
	        animation: true,
	        backdrop: true, //can also be false or 'static'
	        keyboard: true
	      },
	      $get: ['$rootScope', '$q', '$document', '$templateRequest', '$controller', '$uibResolve', '$uibModalStack',
	        function ($rootScope, $q, $document, $templateRequest, $controller, $uibResolve, $modalStack) {
	          var $modal = {};
	
	          function getTemplatePromise(options) {
	            return options.template ? $q.when(options.template) :
	              $templateRequest(angular.isFunction(options.templateUrl) ?
	                options.templateUrl() : options.templateUrl);
	          }
	
	          var promiseChain = null;
	          $modal.getPromiseChain = function() {
	            return promiseChain;
	          };
	
	          $modal.open = function(modalOptions) {
	            var modalResultDeferred = $q.defer();
	            var modalOpenedDeferred = $q.defer();
	            var modalClosedDeferred = $q.defer();
	            var modalRenderDeferred = $q.defer();
	
	            //prepare an instance of a modal to be injected into controllers and returned to a caller
	            var modalInstance = {
	              result: modalResultDeferred.promise,
	              opened: modalOpenedDeferred.promise,
	              closed: modalClosedDeferred.promise,
	              rendered: modalRenderDeferred.promise,
	              close: function (result) {
	                return $modalStack.close(modalInstance, result);
	              },
	              dismiss: function (reason) {
	                return $modalStack.dismiss(modalInstance, reason);
	              }
	            };
	
	            //merge and clean up options
	            modalOptions = angular.extend({}, $modalProvider.options, modalOptions);
	            modalOptions.resolve = modalOptions.resolve || {};
	            modalOptions.appendTo = modalOptions.appendTo || $document.find('body').eq(0);
	
	            if (!modalOptions.appendTo.length) {
	              throw new Error('appendTo element not found. Make sure that the element passed is in DOM.');
	            }
	
	            //verify options
	            if (!modalOptions.component && !modalOptions.template && !modalOptions.templateUrl) {
	              throw new Error('One of component or template or templateUrl options is required.');
	            }
	
	            var templateAndResolvePromise;
	            if (modalOptions.component) {
	              templateAndResolvePromise = $q.when($uibResolve.resolve(modalOptions.resolve, {}, null, null));
	            } else {
	              templateAndResolvePromise =
	                $q.all([getTemplatePromise(modalOptions), $uibResolve.resolve(modalOptions.resolve, {}, null, null)]);
	            }
	
	            function resolveWithTemplate() {
	              return templateAndResolvePromise;
	            }
	
	            // Wait for the resolution of the existing promise chain.
	            // Then switch to our own combined promise dependency (regardless of how the previous modal fared).
	            // Then add to $modalStack and resolve opened.
	            // Finally clean up the chain variable if no subsequent modal has overwritten it.
	            var samePromise;
	            samePromise = promiseChain = $q.all([promiseChain])
	              .then(resolveWithTemplate, resolveWithTemplate)
	              .then(function resolveSuccess(tplAndVars) {
	                var providedScope = modalOptions.scope || $rootScope;
	
	                var modalScope = providedScope.$new();
	                modalScope.$close = modalInstance.close;
	                modalScope.$dismiss = modalInstance.dismiss;
	
	                modalScope.$on('$destroy', function() {
	                  if (!modalScope.$$uibDestructionScheduled) {
	                    modalScope.$dismiss('$uibUnscheduledDestruction');
	                  }
	                });
	
	                var modal = {
	                  scope: modalScope,
	                  deferred: modalResultDeferred,
	                  renderDeferred: modalRenderDeferred,
	                  closedDeferred: modalClosedDeferred,
	                  animation: modalOptions.animation,
	                  backdrop: modalOptions.backdrop,
	                  keyboard: modalOptions.keyboard,
	                  backdropClass: modalOptions.backdropClass,
	                  windowTopClass: modalOptions.windowTopClass,
	                  windowClass: modalOptions.windowClass,
	                  windowTemplateUrl: modalOptions.windowTemplateUrl,
	                  ariaLabelledBy: modalOptions.ariaLabelledBy,
	                  ariaDescribedBy: modalOptions.ariaDescribedBy,
	                  size: modalOptions.size,
	                  openedClass: modalOptions.openedClass,
	                  appendTo: modalOptions.appendTo
	                };
	
	                var component = {};
	                var ctrlInstance, ctrlInstantiate, ctrlLocals = {};
	
	                if (modalOptions.component) {
	                  constructLocals(component, false, true, false);
	                  component.name = modalOptions.component;
	                  modal.component = component;
	                } else if (modalOptions.controller) {
	                  constructLocals(ctrlLocals, true, false, true);
	
	                  // the third param will make the controller instantiate later,private api
	                  // @see https://github.com/angular/angular.js/blob/master/src/ng/controller.js#L126
	                  ctrlInstantiate = $controller(modalOptions.controller, ctrlLocals, true, modalOptions.controllerAs);
	                  if (modalOptions.controllerAs && modalOptions.bindToController) {
	                    ctrlInstance = ctrlInstantiate.instance;
	                    ctrlInstance.$close = modalScope.$close;
	                    ctrlInstance.$dismiss = modalScope.$dismiss;
	                    angular.extend(ctrlInstance, {
	                      $resolve: ctrlLocals.$scope.$resolve
	                    }, providedScope);
	                  }
	
	                  ctrlInstance = ctrlInstantiate();
	
	                  if (angular.isFunction(ctrlInstance.$onInit)) {
	                    ctrlInstance.$onInit();
	                  }
	                }
	
	                if (!modalOptions.component) {
	                  modal.content = tplAndVars[0];
	                }
	
	                $modalStack.open(modalInstance, modal);
	                modalOpenedDeferred.resolve(true);
	
	                function constructLocals(obj, template, instanceOnScope, injectable) {
	                  obj.$scope = modalScope;
	                  obj.$scope.$resolve = {};
	                  if (instanceOnScope) {
	                    obj.$scope.$uibModalInstance = modalInstance;
	                  } else {
	                    obj.$uibModalInstance = modalInstance;
	                  }
	
	                  var resolves = template ? tplAndVars[1] : tplAndVars;
	                  angular.forEach(resolves, function(value, key) {
	                    if (injectable) {
	                      obj[key] = value;
	                    }
	
	                    obj.$scope.$resolve[key] = value;
	                  });
	                }
	            }, function resolveError(reason) {
	              modalOpenedDeferred.reject(reason);
	              modalResultDeferred.reject(reason);
	            })['finally'](function() {
	              if (promiseChain === samePromise) {
	                promiseChain = null;
	              }
	            });
	
	            return modalInstance;
	          };
	
	          return $modal;
	        }
	      ]
	    };
	
	    return $modalProvider;
	  });


/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _dashboardHtml = __webpack_require__(431);
	
	var _dashboardHtml2 = _interopRequireDefault(_dashboardHtml);
	
	var _dashboardControllerJs = __webpack_require__(432);
	
	exports.DashboardController = _dashboardControllerJs.DashboardController;
	
	var DashboardComponent = {
	    restrict: 'E',
	    templateUrl: _dashboardHtml2['default'],
	    controller: _dashboardControllerJs.DashboardController,
	    controllerAs: 'vm'
	};
	
	exports.DashboardComponent = DashboardComponent;

/***/ },
/* 431 */
/***/ function(module, exports) {

	var path = 'app/components/dashboard/dashboard.html';
	var html = "<header id=\"header\"></header><navbar id=\"menu\"></navbar><div id=\"wrapper\"><div class=\"content\" animate-panel effect=\"zoomIn\"><div class=\"row\" animate-faze=\"vm.mode\"><div class=\"col-lg-6\"><div class=\"hpanel\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-lg-12\"><h4 class=\"text-success\"><i class=\"fa fa-star\"></i> Novi radni nalozi</h4></div></div><table id=\"no-more-tables\" class=\"table table-striped table-hover\"><thead><tr><th>Datum naloga <i class=\"fa fa-sort-down\"></i></th><th class=\"text-center\">Broj naloga</th><th>Pacijent</th><th>Ordinacija</th></tr></thead><tbody><tr ng-repeat=\"item in vm.otvoreniNalozi\"><td data-title=\"Datum naloga\">{{item.datum_naloga | date: 'dd.MM.yyyy'}}</td><td data-title=\"Broj naloga\" class=\"text-center\"><rn-link rn=\"item\"></rn-link></td><td data-title=\"Pacijent\"><strong>{{item.pacijent}}</strong></td><td data-title=\"Ordinacija\"><strong>{{item.ordinacija_naziv}}</strong></td></tr></tbody></table></div></div></div><div class=\"col-lg-6\" id=\"faze-for-day\"><div class=\"hpanel\"><div class=\"panel-body list\"><div class=\"row\"><div class=\"col-lg-8\"><h4><i class=\"fa fa-clock-o\"></i> Probe za dan: <strong class=\"text-success\">{{vm.day|date:\"dd.MM.yyyy\" }}</strong> <a ng-if=\"vm.days.length === 1\" ng-href=\"api/radni_nalozi/fazeNaloga/ispis?datum={{vm.day|date:'yyyy-MM-dd'}}\" target=\"_blank\" class=\"btn btn-xs btn-success\"><i class=\"fa fa-print\"></i> Ispis</a> <a ng-if=\"vm.days.length > 1\" ng-href=\"api/radni_nalozi/fazeNaloga/ispis_tjedan?datum_od={{vm.datum_od}}&datum_do={{vm.datum_do}}\" target=\"_blank\" class=\"btn btn-xs btn-success\"><i class=\"fa fa-print\"></i> Ispis</a></h4></div><div class=\"col-lg-4 text-right\"><a ng-click=\"vm.getForToday()\" class=\"btn btn-xs btn-default\" ng-class=\"{'btn-danger': vm.mode === 'danas'}\">Danas</a> <a ng-click=\"vm.getForNextDay()\" class=\"btn btn-xs btn-default\" ng-class=\"{'btn-danger': vm.mode === 'sutra'}\">Sutra</a> <a ng-click=\"vm.getForWeek()\" class=\"btn btn-xs btn-default\" ng-class=\"{'btn-danger': vm.mode === 'tjedan'}\">Sljedećih 7 dana</a></div></div><faze-for-day days=\"vm.days\" on-click=\"vm.getForDay(day)\"></faze-for-day></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"hpanel\"><div class=\"panel-body list\"><div class=\"row\"><div class=\"col-lg-12\"><h4><i class=\"fa fa-file\"></i> Radni nalozi - u obradi</h4><hr></div></div><div class=\"table-responsive project-list\"><table id=\"no-more-tables\" class=\"table table-striped table-hover\"><thead><tr><th class=\"col-lg-2\">Datum naloga</th><th class=\"col-lg-2 text-center\">Broj naloga</th><th>Pacijent</th><th>Ordinacija</th><th>Akcije</th></tr></thead><tbody><tr ng-repeat=\"item in vm.entries\"><td data-title=\"Datum naloga\">{{item.datum_naloga | date: 'dd.MM.yyyy'}}</td><td data-title=\"Broj naloga\" class=\"text-center\"><rn-link rn=\"item\"></rn-link></td><td data-title=\"Pacijent\">{{item.pacijent}},<br><small><i class=\"fa fa-clock-o\"></i> Status: <strong>{{item.status}}</strong></small></td><td data-title=\"Ordinacija\"><strong>{{item.ordinacija_naziv}}</strong></td><td data-title=\"Akcije\"><a ng-click=\"vm.edit(item)\" title=\"Detalji\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-edit\"></i></a></td></tr></tbody></table></div></div><div class=\"panel-footer\"><a ui-sref=\"radniNalog\" class=\"btn btn-xs btn-success\">Pregled svih radnih naloga</a></div></div></div></div></div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _moment = __webpack_require__(216);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _commonModalControllerJs = __webpack_require__(433);
	
	var _commonFormsLayoutJs = __webpack_require__(434);
	
	var _radniNalogStatusiJs = __webpack_require__(435);
	
	var DashboardController = (function () {
	    function DashboardController($state, AppConfiguration, DS) {
	        _classCallCheck(this, DashboardController);
	
	        var app = AppConfiguration();
	        this.entityRN = app.getEntity('dashboard');
	        this.fields = this.entityRN.listView().fields();
	        this.datastore = function () {
	            return DS;
	        };
	
	        this.listActions = this.entityRN.listView().listActions();
	        this.$state = $state;
	        this.params = {
	            limit: 10,
	            offset: 0,
	            status: _radniNalogStatusiJs.UOBRADI
	        };
	    }
	
	    _createClass(DashboardController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.otvoreniNalozi = [];
	            this.refreshState(this.params);
	            this.getForToday();
	            this.mode = 'danas';
	        }
	    }, {
	        key: 'refreshState',
	        value: function refreshState(params) {
	            var _this = this;
	
	            var DS = this.datastore();
	            DS.findAll('RadniNalog', { limit: 20, offset: 0, status: _radniNalogStatusiJs.OTVOREN }, { bypassCache: true }).then(function (response) {
	                _this.otvoreniNalozi = response;
	            });
	
	            DS.findAll('Ordinacija').then(function (response) {
	                return DS.findAll('RadniNalog', params, { bypassCache: true });
	            }).then(function (response) {
	                _this.entries = response;
	            });
	        }
	    }, {
	        key: 'edit',
	        value: function edit(item) {
	            this.$state.go('radniNalog.details', { id: item.id });
	        }
	    }, {
	        key: 'onFilter',
	        value: function onFilter(item) {
	            this.params.search = item;
	            this.refreshState(this.params);
	        }
	    }, {
	        key: 'getForToday',
	        value: function getForToday() {
	            this.mode = 'danas';
	            this.days = [(0, _moment2['default'])().format('YYYY-MM-DD')];
	            this.day = this.days[0];
	        }
	    }, {
	        key: 'getForNextDay',
	        value: function getForNextDay() {
	            this.mode = 'sutra';
	            this.days = [(0, _moment2['default'])().add(1, 'days').format('YYYY-MM-DD')];
	            this.day = this.days[0];
	        }
	    }, {
	        key: 'getForDay',
	        value: function getForDay(day) {
	            this.mode = 'custom';
	            this.days = [day];
	            this.day = this.days[0];
	        }
	    }, {
	        key: 'getForWeek',
	        value: function getForWeek() {
	            this.mode = 'tjedan';
	            this.days = [(0, _moment2['default'])().format('YYYY-MM-DD'), (0, _moment2['default'])().add(1, 'days').format('YYYY-MM-DD'), (0, _moment2['default'])().add(2, 'days').format('YYYY-MM-DD'), (0, _moment2['default'])().add(3, 'days').format('YYYY-MM-DD'), (0, _moment2['default'])().add(4, 'days').format('YYYY-MM-DD'), (0, _moment2['default'])().add(5, 'days').format('YYYY-MM-DD')];
	            this.day = null;
	            this.datum_od = this.days[0];
	            this.datum_do = this.days[5];
	            // let element = $('#faze-for-day');
	            // element.siblings()
	            //             // .addClass('opacity-0')
	            //             // .addClass('stagger')
	            //             .addClass('animated-panel')
	            //             .addClass('zoomOut')
	            //             .addClass('hide');
	            // element.removeClass('col-lg-6');
	            // element.addClass('col-lg-12');
	            // debugger;
	        }
	    }]);
	
	    return DashboardController;
	})();
	
	DashboardController.$inject = ['$state', 'AppConfiguration', 'DS'];
	
	exports.DashboardController = DashboardController;

/***/ },
/* 433 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var ModalController = (function () {
	    function ModalController($uibModalInstance, model) {
	        _classCallCheck(this, ModalController);
	
	        this.uibModalInstance = $uibModalInstance;
	        this.model = model;
	    }
	
	    _createClass(ModalController, [{
	        key: 'submit',
	        value: function submit(model) {
	            this.uibModalInstance.close(model);
	        }
	    }, {
	        key: 'cancel',
	        value: function cancel() {
	            this.uibModalInstance.dismiss();
	        }
	    }]);
	
	    return ModalController;
	})();
	
	ModalController.$inject = ['$uibModalInstance', 'model'];
	
	exports.ModalController = ModalController;

/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _lodash = __webpack_require__(165);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function Div(cssClass, fields) {
	    var fieldsArray = _lodash2['default'].castArray(fields);
	    return {
	        wrapper: 'div',
	        templateOptions: {
	            className: cssClass
	        },
	        fieldGroup: fieldsArray || []
	    };
	}
	
	function Fieldset(legend, fields) {
	    var fieldsArray = _lodash2['default'].castArray(fields);
	    return {
	        wrapper: 'fieldset',
	        templateOptions: {
	            label: legend
	        },
	        fieldGroup: fieldsArray || []
	    };
	}
	
	function Row(columns) {
	    return Div('row', columns);
	}
	
	var Column2 = _lodash2['default'].partial(Div, 'col-lg-2');
	var Column3 = _lodash2['default'].partial(Div, 'col-lg-3');
	var Column4 = _lodash2['default'].partial(Div, 'col-lg-4');
	var Column5 = _lodash2['default'].partial(Div, 'col-lg-5');
	var Column6 = _lodash2['default'].partial(Div, 'col-lg-6');
	var Column7 = _lodash2['default'].partial(Div, 'col-lg-7');
	var Column8 = _lodash2['default'].partial(Div, 'col-lg-8');
	var Column9 = _lodash2['default'].partial(Div, 'col-lg-9');
	var Column10 = _lodash2['default'].partial(Div, 'col-lg-10');
	var Column11 = _lodash2['default'].partial(Div, 'col-lg-11');
	var Column12 = _lodash2['default'].partial(Div, 'col-lg-12');
	
	exports.Div = Div;
	exports.Row = Row;
	exports.Fieldset = Fieldset;
	exports.Column2 = Column2;
	exports.Column3 = Column3;
	exports.Column4 = Column4;
	exports.Column5 = Column5;
	exports.Column6 = Column6;
	exports.Column7 = Column7;
	exports.Column8 = Column8;
	exports.Column9 = Column9;
	exports.Column10 = Column10;
	exports.Column11 = Column11;
	exports.Column12 = Column12;

/***/ },
/* 435 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var OTVOREN = 'Otvoren';
	exports.OTVOREN = OTVOREN;
	var UOBRADI = 'U obradi';
	exports.UOBRADI = UOBRADI;
	var ZAKLJUCAN = 'Zaključan';
	exports.ZAKLJUCAN = ZAKLJUCAN;
	var STORNIRAN = 'Storniran';
	exports.STORNIRAN = STORNIRAN;

/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = animateFaze;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _jquery = __webpack_require__(80);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _lodash = __webpack_require__(165);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function animateFaze($timeout) {
	    return {
	        restrict: 'A',
	        link: function link(scope, iElement, iAttrs) {
	            var element = (0, _jquery2['default'])('#faze-for-day');
	            var row = (0, _jquery2['default'])('.content');
	            var cssClasses = [];
	
	            row.children().each(function (i, c) {
	                cssClasses.push((0, _jquery2['default'])(c).attr('class'));
	            });
	
	            function restoreCssClasses() {
	                row.children().each(function (i, c) {
	                    (0, _jquery2['default'])(c).attr('class', cssClasses[i]);
	                });
	            }
	
	            function zoomOut() {
	                row.children().addClass('animated-panel').removeClass('zoomIn').addClass('zoomOut');
	            }
	
	            function zoomIn() {
	                row.children().addClass('animated-panel').removeClass('zoomOut').addClass('zoomIn');
	            }
	
	            scope.$watch('vm.days.length', function (newVal, oldVal) {
	                if (oldVal !== newVal) {
	                    if (newVal > 1) {
	                        zoomOut();
	                        $timeout(function () {
	                            element.siblings().addClass('hide');
	                            element.attr('class', 'col-lg-12');
	                            zoomIn();
	                        }, 400);
	                    } else {
	                        restoreCssClasses();
	                        zoomOut();
	                        $timeout(function () {
	                            restoreCssClasses();
	                            element.siblings().removeClass('hide');
	                            element.attr('class', 'col-lg-6');
	                            zoomIn();
	                        }, 400);
	                    }
	                    $timeout(function () {
	                        restoreCssClasses();
	                    }, 1000);
	                }
	            });
	        }
	    };
	}
	
	animateFaze.$inject = ['$timeout'];
	module.exports = exports['default'];

/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiBootstrapSrcPagination = __webpack_require__(438);
	
	var _angularUiBootstrapSrcPagination2 = _interopRequireDefault(_angularUiBootstrapSrcPagination);
	
	var _angularUiBootstrapSrcModal = __webpack_require__(424);
	
	var _angularUiBootstrapSrcModal2 = _interopRequireDefault(_angularUiBootstrapSrcModal);
	
	var _commonCrudCrudJs = __webpack_require__(371);
	
	var _ordinacijaListComponentJs = __webpack_require__(445);
	
	var _cardOrdinacijaComponentJs = __webpack_require__(447);
	
	var _ordinacijaDetailsComponentJs = __webpack_require__(449);
	
	var _ordinacijaCreateComponentJs = __webpack_require__(451);
	
	var _ordinacijaEditComponentJs = __webpack_require__(453);
	
	var _ordinacijaFormComponentJs = __webpack_require__(454);
	
	var ordinacija = _angular2['default'].module('ordinacija', [_angularUiBootstrapSrcPagination2['default'], _angularUiBootstrapSrcModal2['default'], _commonCrudCrudJs.crud.name]);
	
	ordinacija.component('ordinacijaList', _ordinacijaListComponentJs.OrdinacijaListComponent);
	ordinacija.component('cardOrdinacija', _cardOrdinacijaComponentJs.CardOrdinacijaComponent);
	ordinacija.component('ordinacijaDetails', _ordinacijaDetailsComponentJs.OrdinacijaDetailsComponent);
	ordinacija.component('ordinacijaCreate', _ordinacijaCreateComponentJs.OrdinacijaCreateComponent);
	ordinacija.component('ordinacijaEdit', _ordinacijaEditComponentJs.OrdinacijaEditComponent);
	ordinacija.component('ordinacijaForm', _ordinacijaFormComponentJs.OrdinacijaFormComponent);
	
	exports.ordinacija = ordinacija;

/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(439);
	__webpack_require__(441);
	__webpack_require__(443);
	__webpack_require__(444);
	
	var MODULE_NAME = 'ui.bootstrap.module.pagination';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.pagination', 'uib/template/pagination/pagination.html']);
	
	module.exports = MODULE_NAME;


/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(440);
	
	var MODULE_NAME = 'ui.bootstrap.module.paging';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.paging']);
	
	module.exports = MODULE_NAME;


/***/ },
/* 440 */
/***/ function(module, exports) {

	angular.module('ui.bootstrap.paging', [])
	/**
	 * Helper internal service for generating common controller code between the
	 * pager and pagination components
	 */
	.factory('uibPaging', ['$parse', function($parse) {
	  return {
	    create: function(ctrl, $scope, $attrs) {
	      ctrl.setNumPages = $attrs.numPages ? $parse($attrs.numPages).assign : angular.noop;
	      ctrl.ngModelCtrl = { $setViewValue: angular.noop }; // nullModelCtrl
	      ctrl._watchers = [];
	
	      ctrl.init = function(ngModelCtrl, config) {
	        ctrl.ngModelCtrl = ngModelCtrl;
	        ctrl.config = config;
	
	        ngModelCtrl.$render = function() {
	          ctrl.render();
	        };
	
	        if ($attrs.itemsPerPage) {
	          ctrl._watchers.push($scope.$parent.$watch($attrs.itemsPerPage, function(value) {
	            ctrl.itemsPerPage = parseInt(value, 10);
	            $scope.totalPages = ctrl.calculateTotalPages();
	            ctrl.updatePage();
	          }));
	        } else {
	          ctrl.itemsPerPage = config.itemsPerPage;
	        }
	
	        $scope.$watch('totalItems', function(newTotal, oldTotal) {
	          if (angular.isDefined(newTotal) || newTotal !== oldTotal) {
	            $scope.totalPages = ctrl.calculateTotalPages();
	            ctrl.updatePage();
	          }
	        });
	      };
	
	      ctrl.calculateTotalPages = function() {
	        var totalPages = ctrl.itemsPerPage < 1 ? 1 : Math.ceil($scope.totalItems / ctrl.itemsPerPage);
	        return Math.max(totalPages || 0, 1);
	      };
	
	      ctrl.render = function() {
	        $scope.page = parseInt(ctrl.ngModelCtrl.$viewValue, 10) || 1;
	      };
	
	      $scope.selectPage = function(page, evt) {
	        if (evt) {
	          evt.preventDefault();
	        }
	
	        var clickAllowed = !$scope.ngDisabled || !evt;
	        if (clickAllowed && $scope.page !== page && page > 0 && page <= $scope.totalPages) {
	          if (evt && evt.target) {
	            evt.target.blur();
	          }
	          ctrl.ngModelCtrl.$setViewValue(page);
	          ctrl.ngModelCtrl.$render();
	        }
	      };
	
	      $scope.getText = function(key) {
	        return $scope[key + 'Text'] || ctrl.config[key + 'Text'];
	      };
	
	      $scope.noPrevious = function() {
	        return $scope.page === 1;
	      };
	
	      $scope.noNext = function() {
	        return $scope.page === $scope.totalPages;
	      };
	
	      ctrl.updatePage = function() {
	        ctrl.setNumPages($scope.$parent, $scope.totalPages); // Readonly variable
	
	        if ($scope.page > $scope.totalPages) {
	          $scope.selectPage($scope.totalPages);
	        } else {
	          ctrl.ngModelCtrl.$render();
	        }
	      };
	
	      $scope.$on('$destroy', function() {
	        while (ctrl._watchers.length) {
	          ctrl._watchers.shift()();
	        }
	      });
	    }
	  };
	}]);


/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(442);
	
	var MODULE_NAME = 'ui.bootstrap.module.tabindex';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.tabindex']);
	
	module.exports = MODULE_NAME;


/***/ },
/* 442 */
/***/ function(module, exports) {

	angular.module('ui.bootstrap.tabindex', [])
	
	.directive('uibTabindexToggle', function() {
	  return {
	    restrict: 'A',
	    link: function(scope, elem, attrs) {
	      attrs.$observe('disabled', function(disabled) {
	        attrs.$set('tabindex', disabled ? -1 : null);
	      });
	    }
	  };
	});


/***/ },
/* 443 */
/***/ function(module, exports) {

	angular.module("uib/template/pagination/pagination.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("uib/template/pagination/pagination.html",
	    "<li role=\"menuitem\" ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"pagination-first\"><a href ng-click=\"selectPage(1, $event)\" ng-disabled=\"noPrevious()||ngDisabled\" uib-tabindex-toggle>{{::getText('first')}}</a></li>\n" +
	    "<li role=\"menuitem\" ng-if=\"::directionLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"pagination-prev\"><a href ng-click=\"selectPage(page - 1, $event)\" ng-disabled=\"noPrevious()||ngDisabled\" uib-tabindex-toggle>{{::getText('previous')}}</a></li>\n" +
	    "<li role=\"menuitem\" ng-repeat=\"page in pages track by $index\" ng-class=\"{active: page.active,disabled: ngDisabled&&!page.active}\" class=\"pagination-page\"><a href ng-click=\"selectPage(page.number, $event)\" ng-disabled=\"ngDisabled&&!page.active\" uib-tabindex-toggle>{{page.text}}</a></li>\n" +
	    "<li role=\"menuitem\" ng-if=\"::directionLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"pagination-next\"><a href ng-click=\"selectPage(page + 1, $event)\" ng-disabled=\"noNext()||ngDisabled\" uib-tabindex-toggle>{{::getText('next')}}</a></li>\n" +
	    "<li role=\"menuitem\" ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"pagination-last\"><a href ng-click=\"selectPage(totalPages, $event)\" ng-disabled=\"noNext()||ngDisabled\" uib-tabindex-toggle>{{::getText('last')}}</a></li>\n" +
	    "");
	}]);


/***/ },
/* 444 */
/***/ function(module, exports) {

	angular.module('ui.bootstrap.pagination', ['ui.bootstrap.paging', 'ui.bootstrap.tabindex'])
	.controller('UibPaginationController', ['$scope', '$attrs', '$parse', 'uibPaging', 'uibPaginationConfig', function($scope, $attrs, $parse, uibPaging, uibPaginationConfig) {
	  var ctrl = this;
	  // Setup configuration parameters
	  var maxSize = angular.isDefined($attrs.maxSize) ? $scope.$parent.$eval($attrs.maxSize) : uibPaginationConfig.maxSize,
	    rotate = angular.isDefined($attrs.rotate) ? $scope.$parent.$eval($attrs.rotate) : uibPaginationConfig.rotate,
	    forceEllipses = angular.isDefined($attrs.forceEllipses) ? $scope.$parent.$eval($attrs.forceEllipses) : uibPaginationConfig.forceEllipses,
	    boundaryLinkNumbers = angular.isDefined($attrs.boundaryLinkNumbers) ? $scope.$parent.$eval($attrs.boundaryLinkNumbers) : uibPaginationConfig.boundaryLinkNumbers,
	    pageLabel = angular.isDefined($attrs.pageLabel) ? function(idx) { return $scope.$parent.$eval($attrs.pageLabel, {$page: idx}); } : angular.identity;
	  $scope.boundaryLinks = angular.isDefined($attrs.boundaryLinks) ? $scope.$parent.$eval($attrs.boundaryLinks) : uibPaginationConfig.boundaryLinks;
	  $scope.directionLinks = angular.isDefined($attrs.directionLinks) ? $scope.$parent.$eval($attrs.directionLinks) : uibPaginationConfig.directionLinks;
	  $attrs.$set('role', 'menu');
	
	  uibPaging.create(this, $scope, $attrs);
	
	  if ($attrs.maxSize) {
	    ctrl._watchers.push($scope.$parent.$watch($parse($attrs.maxSize), function(value) {
	      maxSize = parseInt(value, 10);
	      ctrl.render();
	    }));
	  }
	
	  // Create page object used in template
	  function makePage(number, text, isActive) {
	    return {
	      number: number,
	      text: text,
	      active: isActive
	    };
	  }
	
	  function getPages(currentPage, totalPages) {
	    var pages = [];
	
	    // Default page limits
	    var startPage = 1, endPage = totalPages;
	    var isMaxSized = angular.isDefined(maxSize) && maxSize < totalPages;
	
	    // recompute if maxSize
	    if (isMaxSized) {
	      if (rotate) {
	        // Current page is displayed in the middle of the visible ones
	        startPage = Math.max(currentPage - Math.floor(maxSize / 2), 1);
	        endPage = startPage + maxSize - 1;
	
	        // Adjust if limit is exceeded
	        if (endPage > totalPages) {
	          endPage = totalPages;
	          startPage = endPage - maxSize + 1;
	        }
	      } else {
	        // Visible pages are paginated with maxSize
	        startPage = (Math.ceil(currentPage / maxSize) - 1) * maxSize + 1;
	
	        // Adjust last page if limit is exceeded
	        endPage = Math.min(startPage + maxSize - 1, totalPages);
	      }
	    }
	
	    // Add page number links
	    for (var number = startPage; number <= endPage; number++) {
	      var page = makePage(number, pageLabel(number), number === currentPage);
	      pages.push(page);
	    }
	
	    // Add links to move between page sets
	    if (isMaxSized && maxSize > 0 && (!rotate || forceEllipses || boundaryLinkNumbers)) {
	      if (startPage > 1) {
	        if (!boundaryLinkNumbers || startPage > 3) { //need ellipsis for all options unless range is too close to beginning
	        var previousPageSet = makePage(startPage - 1, '...', false);
	        pages.unshift(previousPageSet);
	      }
	        if (boundaryLinkNumbers) {
	          if (startPage === 3) { //need to replace ellipsis when the buttons would be sequential
	            var secondPageLink = makePage(2, '2', false);
	            pages.unshift(secondPageLink);
	          }
	          //add the first page
	          var firstPageLink = makePage(1, '1', false);
	          pages.unshift(firstPageLink);
	        }
	      }
	
	      if (endPage < totalPages) {
	        if (!boundaryLinkNumbers || endPage < totalPages - 2) { //need ellipsis for all options unless range is too close to end
	        var nextPageSet = makePage(endPage + 1, '...', false);
	        pages.push(nextPageSet);
	      }
	        if (boundaryLinkNumbers) {
	          if (endPage === totalPages - 2) { //need to replace ellipsis when the buttons would be sequential
	            var secondToLastPageLink = makePage(totalPages - 1, totalPages - 1, false);
	            pages.push(secondToLastPageLink);
	          }
	          //add the last page
	          var lastPageLink = makePage(totalPages, totalPages, false);
	          pages.push(lastPageLink);
	        }
	      }
	    }
	    return pages;
	  }
	
	  var originalRender = this.render;
	  this.render = function() {
	    originalRender();
	    if ($scope.page > 0 && $scope.page <= $scope.totalPages) {
	      $scope.pages = getPages($scope.page, $scope.totalPages);
	    }
	  };
	}])
	
	.constant('uibPaginationConfig', {
	  itemsPerPage: 10,
	  boundaryLinks: false,
	  boundaryLinkNumbers: false,
	  directionLinks: true,
	  firstText: 'First',
	  previousText: 'Previous',
	  nextText: 'Next',
	  lastText: 'Last',
	  rotate: true,
	  forceEllipses: false
	})
	
	.directive('uibPagination', ['$parse', 'uibPaginationConfig', function($parse, uibPaginationConfig) {
	  return {
	    scope: {
	      totalItems: '=',
	      firstText: '@',
	      previousText: '@',
	      nextText: '@',
	      lastText: '@',
	      ngDisabled:'='
	    },
	    require: ['uibPagination', '?ngModel'],
	    restrict: 'A',
	    controller: 'UibPaginationController',
	    controllerAs: 'pagination',
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/pagination/pagination.html';
	    },
	    link: function(scope, element, attrs, ctrls) {
	      element.addClass('pagination');
	      var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      if (!ngModelCtrl) {
	         return; // do nothing if no ng-model
	      }
	
	      paginationCtrl.init(ngModelCtrl, uibPaginationConfig);
	    }
	  };
	}]);


/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ordinacijaListHtml = __webpack_require__(446);
	
	var _ordinacijaListHtml2 = _interopRequireDefault(_ordinacijaListHtml);
	
	var _commonListControllerJs = __webpack_require__(385);
	
	var _commonListControllerJs2 = _interopRequireDefault(_commonListControllerJs);
	
	var OrdinacijaListController = (function (_ListController) {
	    _inherits(OrdinacijaListController, _ListController);
	
	    function OrdinacijaListController(ModelFactory, $state) {
	        _classCallCheck(this, OrdinacijaListController);
	
	        _get(Object.getPrototypeOf(OrdinacijaListController.prototype), 'constructor', this).call(this, ModelFactory);
	        this.getState();
	        this.icon = $state.current.data.icon || false;
	        this.pageTitle = $state.current.data.pageTitle || false;
	        this.pageDesc = $state.current.data.pageDesc || false;
	
	        this.getState();
	    }
	
	    _createClass(OrdinacijaListController, [{
	        key: 'getState',
	        value: function getState() {
	            this.getItems();
	        }
	    }, {
	        key: 'getQueryset',
	        value: function getQueryset(params) {
	            return this.Model.findAll(params, { bypassCache: true });
	        }
	    }]);
	
	    return OrdinacijaListController;
	})(_commonListControllerJs2['default']);
	
	OrdinacijaListController.$inject = ['Ordinacija', '$state'];
	
	var OrdinacijaListComponent = {
	    restrict: 'E',
	    templateUrl: _ordinacijaListHtml2['default'],
	    controller: OrdinacijaListController,
	    controllerAs: 'vm'
	};
	
	exports.OrdinacijaListComponent = OrdinacijaListComponent;
	exports.OrdinacijaListController = OrdinacijaListController;

/***/ },
/* 446 */
/***/ function(module, exports) {

	var path = 'app/components/ordinacija/ordinacijaList.html';
	var html = "<header id=\"header\" on-search=\"vm.onFilter(value)\" search-placeholder=\"Naziv ili oib\"></header><navbar id=\"menu\"></navbar><div id=\"wrapper\"><page-header icon=\"vm.icon\" page-title=\"vm.pageTitle\" page-desc=\"vm.pageDesc\"></page-header><div class=\"content\" animate-panel><div class=\"row\"><div class=\"col-sm-6\"><div class=\"dataTables_paginate paging_simple_numbers\"><ul uib-pagination total-items=\"vm.pager.totalItems\" items-per-page=\"vm.pager.limit\" max-size=\"5\" ng-change=\"vm.pageChanged()\" ng-model=\"vm.pager.currentPage\" num-pages=\"smallnumPages\" previous-text=\"Prethodni\" next-text=\"Slijedeći\"></ul><uib-pagination total-items=\"vm.pager.totalItems\" items-per-page=\"vm.pager.limit\" max-size=\"5\" ng-change=\"vm.pageChanged()\" ng-model=\"vm.pager.currentPage\" num-pages=\"smallnumPages\" previous-text=\"Prethodni\" next-text=\"Slijedeći\"></uib-pagination></div></div><div class=\"col-sm-6\"><div class=\"dataTables_info pull-right\" id=\"example2_info\" role=\"status\" aria-live=\"polite\">Prikazuje se {{vm.pager.start}} od {{vm.pager.end}} od ukupno {{vm.pager.totalItems}} zapisa</div></div></div><div class=\"row\"><div class=\"col-lg-12\"><a ui-sref=\"ordinacija.create\" type=\"button\" class=\"btn btn-success\"><i class=\"fa fa-plus-square\"></i> Novi zapis</a></div></div><hr><div ng-if=\"vm.items.length > 0\" animate-panel><card-ordinacija class=\"card\" items=\"vm.items\"></card-ordinacija></div></div><footer class=\"footer\"></footer></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _lodash = __webpack_require__(165);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _cardOrdinacijaHtml = __webpack_require__(448);
	
	var _cardOrdinacijaHtml2 = _interopRequireDefault(_cardOrdinacijaHtml);
	
	var CardOrdinacijaController = (function () {
	    function CardOrdinacijaController($scope) {
	        _classCallCheck(this, CardOrdinacijaController);
	
	        this.items = this.items || [];
	        this.rows = [];
	        $scope.$watch('vm.items', this.itemsChanged());
	    }
	
	    _createClass(CardOrdinacijaController, [{
	        key: 'itemsChanged',
	        value: function itemsChanged() {
	            var _this = this;
	
	            return function (newValue, oldValue) {
	                var items = _lodash2['default'].map(newValue, _lodash2['default'].clone);
	                _this.rows = [];
	                for (var i = 0, j = items.length; i < j; i = i + 4) {
	                    _this.rows.push(items.splice(0, 4));
	                }
	            };
	        }
	    }, {
	        key: 'edit',
	        value: function edit(item) {
	            this.onEdit({ item: item });
	        }
	    }]);
	
	    return CardOrdinacijaController;
	})();
	
	CardOrdinacijaController.$inject = ['$scope'];
	
	var CardOrdinacijaComponent = {
	    restrict: 'E',
	    templateUrl: _cardOrdinacijaHtml2['default'],
	    controller: CardOrdinacijaController,
	    controllerAs: 'vm',
	    bindings: {
	        items: '<',
	        onEdit: '&'
	    }
	};
	
	exports.CardOrdinacijaComponent = CardOrdinacijaComponent;

/***/ },
/* 448 */
/***/ function(module, exports) {

	var path = 'app/components/ordinacija/cardOrdinacija.html';
	var html = "<div class=\"row\" ng-repeat=\"row in vm.rows\"><div class=\"col-lg-3\" ng-repeat=\"item in row\"><div class=\"hpanel hviolet contact-panel\"><div class=\"panel-body\"><div class=\"btn-group pull-right\"><button data-toggle=\"dropdown\" class=\"btn btn-success btn-xs dropdown-toggle\" aria-expanded=\"false\">Akcije <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li><a ui-sref=\"ordinacija.details({id: item.id})\">Detalji</a></li></ul></div><i class=\"fa fa-user fa-3x\"></i><h3><a ui-sref=\"ordinacija.details({id: item.id})\">{{item.naziv}}</a></h3><div class=\"text-muted font-bold m-b-xs\">{{item.adresa}}, {{item.postanski_broj}} {{item.mjesto}}</div><p>Korisničko ime: <strong>{{item.korisnicko_ime}}</strong></p><p>E-mail: <strong><a>{{item.email}}</a></strong></p></div><div class=\"panel-footer contact-footer\"><div class=\"row\"><div class=\"col-md-6 border-right\"><div class=\"contact-stat\"><span>OIB:</span> <strong>{{item.oib}}</strong></div></div><div class=\"col-md-6 border-right\"><div class=\"contact-stat\"><span>Telefon:</span> <strong>{{item.telefon}}</strong></div></div></div></div></div></div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _ordinacijaDetailsHtml = __webpack_require__(450);
	
	var _ordinacijaDetailsHtml2 = _interopRequireDefault(_ordinacijaDetailsHtml);
	
	var OrdinacijaDetailsController = (function () {
	    function OrdinacijaDetailsController(DS, AppConfiguration, $q, $uibModal, logger) {
	        _classCallCheck(this, OrdinacijaDetailsController);
	
	        this.$q = $q;
	        this.$uibModal = $uibModal;
	        this.logger = logger;
	        this.icon = false;
	        this.pageTitle = 'Ordinacija dentalne medicine:' || false;
	        this.pageDesc = 'Podaci o ordinaciji dentalne medicine';
	        this.datastore = function () {
	            return DS;
	        };
	        this.naloziListView = AppConfiguration().getViewByEntityAndType('RadniNalog', 'OrdinacijaViews');
	        this.korisniciListView = AppConfiguration().getViewByEntityAndType('KorisnikOrdinacija', 'ListView');
	        this.korisniciCreateView = AppConfiguration().getViewByEntityAndType('KorisnikOrdinacija', 'CreateView');
	    }
	
	    _createClass(OrdinacijaDetailsController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.shouldDisplayActions = true;
	            this.pageTitle = 'Ordinacija dentalne medicine: ' + this.item.naziv;
	            this.refreshState();
	        }
	    }, {
	        key: 'refreshState',
	        value: function refreshState() {
	            this.getNaloge();
	            this.getKorisnike();
	        }
	    }, {
	        key: 'getNaloge',
	        value: function getNaloge() {
	            var _this = this;
	
	            var DS = this.datastore();
	            this.resolveReferences().then(function () {
	                return DS.findAll('RadniNalog', { ordinacija: _this.item.id, aktivne: 1 }, { bypassCache: true });
	            }).then(function (response) {
	                _this.nalozi = response;
	            });
	        }
	    }, {
	        key: 'getKorisnike',
	        value: function getKorisnike() {
	            var _this2 = this;
	
	            var DS = this.datastore();
	            DS.findAll('KorisnikOrdinacija', { ordinacija: this.item.id }, { bypassCache: true }).then(function (response) {
	                _this2.korisnici = response.map(function (item) {
	                    return {
	                        id: item.id,
	                        user_id: item.user.id,
	                        first_name: item.user.first_name,
	                        last_name: item.user.last_name,
	                        email: item.user.email,
	                        username: item.user.username
	                    };
	                });
	            });
	        }
	    }, {
	        key: 'insertKorisnika',
	        value: function insertKorisnika() {
	            var _this3 = this;
	
	            var DS = this.datastore();
	            var _view = this.korisniciCreateView;
	            var modal = this.$uibModal.open({
	                component: 'modalForm',
	                size: 'lg',
	                resolve: {
	                    item: function item() {
	                        return {};
	                    },
	                    view: function view() {
	                        return _view;
	                    },
	                    formClass: function formClass() {
	                        return 'horizontal';
	                    }
	                }
	            });
	
	            modal.result.then(function (user) {
	                DS.create('KorisnikOrdinacija', { ordinacija: _this3.item.id, user: user }, { cacheResponse: true }).then(function (response) {
	                    _this3.refreshState();
	                })['catch'](function (error) {
	                    _this3.logger.error('Oops...', error.data);
	                });
	            });
	        }
	    }, {
	        key: 'deleteKorisnika',
	        value: function deleteKorisnika(item) {
	            var _this4 = this;
	
	            var DS = this.datastore();
	            var previousWindowKeyDown = window.onkeydown;
	            swal({
	                title: 'Brisanje korisnika',
	                text: 'Za potvrdu brisanja upišite \'da\'',
	                type: 'input',
	                showCancelButton: true,
	                closeOnConfirm: false
	            }, function (inputValue) {
	                window.onkeydown = previousWindowKeyDown;
	                if (inputValue === false) return false;
	                if (inputValue === 'da') {
	                    DS.destroy('KorisnikOrdinacija', item.id).then(function (data) {
	                        _this4.refreshState();
	                        swal('Redak obrisan', '', 'success');
	                    }, function (error) {
	                        swal('Greška', 'Došlo je do greške prilikom brisanja', 'error');
	                    });
	                    return true;
	                }
	                swal.showInputError('Nedozvoljena vrijednost');
	                return false;
	            });
	        }
	    }, {
	        key: 'resolveReferences',
	        value: function resolveReferences() {
	            var models = [];
	            var datastore = this.datastore();
	
	            _.forOwn(this.naloziListView.getReferences(), function (value, key) {
	                models.push(datastore.definitions[value.targetEntity().name()]);
	            });
	
	            return this.$q.all(models.map(function (m) {
	                return m.findAll();
	            }));
	        }
	    }]);
	
	    return OrdinacijaDetailsController;
	})();
	
	OrdinacijaDetailsController.$inject = ['DS', 'AppConfiguration', '$q', '$uibModal', 'logger'];
	
	var OrdinacijaDetailsComponent = {
	    restrict: 'E',
	    templateUrl: _ordinacijaDetailsHtml2['default'],
	    controller: OrdinacijaDetailsController,
	    controllerAs: 'vm',
	    bindings: {
	        item: '<'
	    }
	};
	
	exports.OrdinacijaDetailsComponent = OrdinacijaDetailsComponent;

/***/ },
/* 450 */
/***/ function(module, exports) {

	var path = 'app/components/ordinacija/ordinacijaDetails.html';
	var html = "<header id=\"header\"></header><navbar id=\"menu\"></navbar><div id=\"wrapper\"><page-header icon=\"vm.icon\" page-title=\"vm.pageTitle\" page-desc=\"vm.pageDesc\"></page-header><div class=\"content\"><div animate-panel><div class=\"row\"><div class=\"col-lg-12\"><a ui-sref=\"radniNalog.create\" class=\"btn btn-info\" type=\"button\"><i class=\"fa fa-plus-square\"></i> Novi nalog</a> <a ui-sref=\"ordinacija.details.edit({id: vm.item.id})\" class=\"btn btn-default\" type=\"button\"><i class=\"fa fa-edit\"></i> Izmjeni</a></div></div><div class=\"row\"><div class=\"col-lg-6\"><div class=\"hpanel stats\"><div class=\"panel-heading\"></div><div class=\"panel-body list\"><div class=\"pull-right\"><i class=\"fa fa-building-o fa-3x\"></i></div><div class=\"panel-title\">ORDINACIJA DENTALNE MEDICINE</div><small class=\"fo\">Osnovni podaci</small><hr><table id=\"user\" class=\"table table-bordered table-striped\" style=\"clear: both\"><tbody><tr><td width=\"35%\">Naziv</td><td width=\"65%\"><b>{{vm.item.naziv}}</b></td></tr><tr><td width=\"35%\">OIB</td><td width=\"65%\"><b>{{vm.item.oib}}</b></td></tr><tr><td width=\"35%\">Radno vrijeme</td><td width=\"65%\"><b>{{vm.item.radno_vrijeme}}</b></td></tr><tr><td width=\"35%\">Napomena</td><td width=\"65%\"><b>{{vm.item.napomena}}</b></td></tr></tbody></table><small class=\"fo\">Adresa, kontakt</small><hr><table id=\"user\" class=\"table table-bordered table-striped\" style=\"clear: both\"><tbody><tr><td width=\"35%\">Adresa</td><td width=\"65%\"><b>{{vm.item.adresa}}</b></td></tr><tr><td width=\"35%\">Naziv mjesta</td><td width=\"65%\"><b>{{vm.item.postanski_broj}} {{vm.item.mjesto}}</b></td></tr><tr><td width=\"35%\">E-mail</td><td width=\"65%\"><b>{{vm.item.email}}</b></td></tr><tr><td width=\"35%\">Telefon</td><td width=\"65%\"><b>{{vm.item.telefon}}</b></td></tr></tbody></table><small class=\"fo\">Korisnički računi</small><div class=\"pull-right\"><button type=\"button\" class=\"btn btn-xs btn-success\" ng-click=\"vm.insertKorisnika()\"><i class=\"fa fa-plus-square\"></i> Novi korisnik</button></div><hr><table class=\"table table-striped table-hover\"><thead><tr><th class=\"col-md-2\">Ime</th><th class=\"col-md-2\">Prezime</th><th>Email</th><th>Username</th><th ng-if=\"vm.shouldDisplayActions\">Akcije</th></tr></thead><tbody><tr ng-repeat=\"item in vm.korisnici\"><td>{{item.first_name}}</td><td>{{item.last_name}}</td><td>{{item.email}}</td><td>{{item.username}}</td><td ng-if=\"vm.shouldDisplayActions\"><a ng-click=\"vm.deleteKorisnika(item)\" class=\"btn btn-danger btn-xs\"><i class=\"fa fa-close\"></i></a></td></tr></tbody></table></div></div></div><div class=\"col-lg-6\"><div class=\"hpanel\"><div class=\"panel-heading\"></div><div class=\"panel-body list\"><div class=\"row\"><div class=\"col-lg-12\"><h4><i class=\"fa fa-file\"></i> Radni nalozi - aktivni</h4><hr></div></div><div class=\"table-responsive project-list\"><table class=\"table table-striped table-hover\"><thead><tr><th class=\"col-lg-2\">Datum naloga</th><th>Pacijent</th><th class=\"col-lg-2 text-center\">Broj naloga</th></tr></thead><tbody><tr ng-repeat=\"item in vm.nalozi\"><td>{{item.datum_naloga | date: 'dd.MM.yyyy'}}</td><td>{{item.pacijent}},<br><small><i class=\"fa fa-clock-o\"></i> Status: <strong>{{item.status}}</strong></small></td><td class=\"text-center\"><rn-link rn=\"item\"></rn-link></td></tr></tbody></table></div></div><div class=\"panel-footer\"><a ui-sref=\"radniNalog\" class=\"btn btn-xs btn-success\">Pregled svih radnih naloga</a></div></div></div></div></div></div><footer class=\"footer\"></footer></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _ordinacijaCreateEditHtml = __webpack_require__(452);
	
	var _ordinacijaCreateEditHtml2 = _interopRequireDefault(_ordinacijaCreateEditHtml);
	
	var _sweetalert = __webpack_require__(375);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	var OrdinacijaCreateController = (function () {
	    function OrdinacijaCreateController(DS, AppConfiguration, $state, logger) {
	        _classCallCheck(this, OrdinacijaCreateController);
	
	        this.$state = $state;
	        this.logger = logger;
	        this.Model = DS.definitions['Ordinacija'];
	        this.view = AppConfiguration().getViewByEntityAndType('Ordinacija', 'CreateView');
	    }
	
	    _createClass(OrdinacijaCreateController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.pageTitle = 'Unos nove ordinacije dentalne medicine';
	            this.pageDesc = 'Podaci o ordinaciji dentalne medicine';
	            this.fields = this.view.fields();
	        }
	    }, {
	        key: 'submit',
	        value: function submit(item) {
	            var _this = this;
	
	            var previousWindowKeyDown = window.onkeydown;
	            this.Model.create(item).then(function (response) {
	                (0, _sweetalert2['default'])({
	                    title: 'Zahvaljujemo',
	                    text: 'Podaci su uspiješno pohranjeni',
	                    type: 'success',
	                    closeOnConfirme: true
	                }, function () {
	                    window.onkeydown = previousWindowKeyDown;
	                    _this.Model.ejectAll();
	                    _this.$state.go('ordinacija.details', { id: response.id });
	                });
	            })['catch'](function (error) {
	                _this.logger.error('Upsss', error.data);
	            });
	        }
	    }]);
	
	    return OrdinacijaCreateController;
	})();
	
	OrdinacijaCreateController.$inject = ['DS', 'AppConfiguration', '$state', 'logger'];
	
	var OrdinacijaCreateComponent = {
	    restrict: 'E',
	    templateUrl: _ordinacijaCreateEditHtml2['default'],
	    controller: OrdinacijaCreateController,
	    controllerAs: 'vm',
	    bindings: {
	        item: '<'
	    }
	};
	
	exports.OrdinacijaCreateComponent = OrdinacijaCreateComponent;
	exports.OrdinacijaCreateController = OrdinacijaCreateController;

/***/ },
/* 452 */
/***/ function(module, exports) {

	var path = 'app/components/ordinacija/ordinacijaCreateEdit.html';
	var html = "<header id=\"header\"></header><navbar id=\"menu\"></navbar><div id=\"wrapper\"><page-header icon=\"vm.icon\" page-title=\"vm.pageTitle\" page-desc=\"vm.pageDesc\"></page-header><div class=\"content\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"hpanel\"><div class=\"panel-heading\"></div><div class=\"panel-body\"><ordinacija-form fields=\"vm.fields\" on-submit=\"vm.submit(item)\" item=\"vm.item\"></ordinacija-form></div></div></div></div></div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _ordinacijaCreateEditHtml = __webpack_require__(452);
	
	var _ordinacijaCreateEditHtml2 = _interopRequireDefault(_ordinacijaCreateEditHtml);
	
	var _sweetalert = __webpack_require__(375);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	var OrdinacijaEditController = (function () {
	    function OrdinacijaEditController(DS, AppConfiguration, $state, logger) {
	        _classCallCheck(this, OrdinacijaEditController);
	
	        this.$state = $state;
	        this.logger = logger;
	        this.Model = DS.definitions['Ordinacija'];
	        this.view = AppConfiguration().getViewByEntityAndType('Ordinacija', 'CreateView');
	    }
	
	    _createClass(OrdinacijaEditController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.pageTitle = 'Izmjena ordinacije dentalne medicine ' + this.item.naziv;
	            this.pageDesc = 'Podaci o ordinaciji dentalne medicine';
	            this.fields = this.view.fields();
	        }
	    }, {
	        key: 'submit',
	        value: function submit(item) {
	            var _this = this;
	
	            var previousWindowKeyDown = window.onkeydown;
	            this.Model.update(item.id, item).then(function (response) {
	                (0, _sweetalert2['default'])({
	                    title: 'Zahvaljujemo',
	                    text: 'Podaci su uspješno ažurirani',
	                    type: 'success',
	                    closeOnConfirme: true
	                }, function () {
	                    window.onkeydown = previousWindowKeyDown;
	                    _this.$state.go('ordinacija.details', { id: response.id });
	                });
	            })['catch'](function (error) {
	                _this.logger.error('Upsss', error.data);
	            });
	        }
	    }]);
	
	    return OrdinacijaEditController;
	})();
	
	OrdinacijaEditController.$inject = ['DS', 'AppConfiguration', '$state', 'logger'];
	
	var OrdinacijaEditComponent = {
	    restrict: 'E',
	    templateUrl: _ordinacijaCreateEditHtml2['default'],
	    controller: OrdinacijaEditController,
	    controllerAs: 'vm',
	    bindings: {
	        item: '<'
	    }
	};
	
	exports.OrdinacijaEditComponent = OrdinacijaEditComponent;
	exports.OrdinacijaEditController = OrdinacijaEditController;

/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _ordinacijaFormHtml = __webpack_require__(455);
	
	var _ordinacijaFormHtml2 = _interopRequireDefault(_ordinacijaFormHtml);
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var OrdinacijaFormController = (function () {
	    function OrdinacijaFormController() {
	        _classCallCheck(this, OrdinacijaFormController);
	
	        this.step = 1;
	    }
	
	    _createClass(OrdinacijaFormController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.step1Fields = this.fields[0];
	            this.step2Fields = this.fields[1];
	            this.model = _angular2['default'].copy(this.item);
	        }
	    }, {
	        key: 'show',
	        value: function show(step) {
	            this.step = step;
	        }
	    }, {
	        key: 'next',
	        value: function next() {
	            if (this.step < 2) {
	                this.step++;
	            }
	        }
	    }, {
	        key: 'prev',
	        value: function prev() {
	            if (this.step > 1) {
	                this.step--;
	            }
	        }
	    }, {
	        key: 'submit',
	        value: function submit(item) {
	            this.form.$setSubmitted(true);
	            if (this.form.$invalid) {
	                return;
	            }
	            this.onSubmit({ item: item });
	        }
	    }]);
	
	    return OrdinacijaFormController;
	})();
	
	OrdinacijaFormController.$inject = [];
	
	var OrdinacijaFormComponent = {
	    restrict: 'E',
	    templateUrl: _ordinacijaFormHtml2['default'],
	    controller: OrdinacijaFormController,
	    controllerAs: 'vm',
	    bindings: {
	        fields: '<',
	        item: '<',
	        onSubmit: '&'
	    }
	};
	
	exports.OrdinacijaFormComponent = OrdinacijaFormComponent;
	exports.OrdinacijaFormController = OrdinacijaFormController;

/***/ },
/* 455 */
/***/ function(module, exports) {

	var path = 'app/components/ordinacija/ordinacijaForm.html';
	var html = "<form name=\"vm.form\" novalidate ng-submit=\"vm.submit(vm.model)\"><div class=\"text-center m-b-md\" id=\"wizardControl\"><a class=\"btn\" ng-class=\"{ 'btn-primary': vm.step == 1, 'btn-default': vm.step != 1}\" ng-click=\"vm.show(1)\">1 - Osnovni podaci</a> <a class=\"btn\" ng-class=\"{ 'btn-primary': vm.step == 2, 'btn-default': vm.step != 2}\" ng-click=\"vm.show(2)\">2 - Kontakt, korisnički račun</a></div><div class=\"tab-content\"><div id=\"step1\" class=\"p-m\" ng-show=\"vm.step == 1\"><div class=\"row\"><div class=\"col-lg-3 text-center\"><i class=\"fa fa-building-o fa-3x text-muted\"></i><p class=\"small m-t-md\">Osnovni podaci o <strong>ordinaciji dentalne medicine</strong></p></div><div class=\"col-lg-9\"><formly-form model=\"vm.model\" fields=\"vm.step1Fields\" form=\"vm.form\" options=\"vm.options\"></formly-form></div></div><hr><div class=\"text-right m-t-xs\"><a class=\"btn btn-default\" ng-click=\"vm.prev()\">Prethodni</a> <a class=\"btn btn-default\" ng-click=\"vm.next()\">Sljedeći</a></div></div><div id=\"step2\" class=\"p-m\" ng-show=\"vm.step == 2\"><div class=\"row\"><div class=\"col-lg-3 text-center\"><i class=\"pe-7s-map-marker fa-5x text-muted\"></i><p class=\"small m-t-md\"><strong>Kontakt podaci</strong> ordinacije.<br>Podaci o <strong>korisničkom računu</strong> za rad u aplikaciji</p></div><div class=\"col-lg-9\"><formly-form model=\"vm.model\" fields=\"vm.step2Fields\" form=\"vm.form\" options=\"vm.options\"></formly-form></div></div><hr><div class=\"text-right m-t-xs\"><a class=\"btn btn-default\" ng-click=\"vm.prev()\">Prethodni</a> <a class=\"btn btn-default\" ng-click=\"vm.next()\">Sljedeći</a> <a class=\"btn btn-success\" ng-click=\"vm.submit(vm.model)\">Potvrdi</a></div></div></div></form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiBootstrapSrcPagination = __webpack_require__(438);
	
	var _angularUiBootstrapSrcPagination2 = _interopRequireDefault(_angularUiBootstrapSrcPagination);
	
	var _angularUiBootstrapSrcModal = __webpack_require__(424);
	
	var _angularUiBootstrapSrcModal2 = _interopRequireDefault(_angularUiBootstrapSrcModal);
	
	var _commonCrudCrudJs = __webpack_require__(371);
	
	var _cjenikComponentJs = __webpack_require__(457);
	
	var _cardCjenikComponentJs = __webpack_require__(459);
	
	var _stavkaCjenikaComponentJs = __webpack_require__(461);
	
	var cjenik = _angular2['default'].module('cjenik', [_angularUiBootstrapSrcPagination2['default'], _angularUiBootstrapSrcModal2['default'], _commonCrudCrudJs.crud.name]);
	
	cjenik.component('cjenik', _cjenikComponentJs.CjenikComponent);
	cjenik.component('cardCjenik', _cardCjenikComponentJs.CardCjenikComponent);
	cjenik.component('stavkaCjenika', _stavkaCjenikaComponentJs.StavkaCjenikaComponent);
	
	exports.cjenik = cjenik;

/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _cjenikHtml = __webpack_require__(458);
	
	var _cjenikHtml2 = _interopRequireDefault(_cjenikHtml);
	
	var _commonListControllerJs = __webpack_require__(385);
	
	var _commonListControllerJs2 = _interopRequireDefault(_commonListControllerJs);
	
	var CjenikController = (function (_ListController) {
	    _inherits(CjenikController, _ListController);
	
	    function CjenikController(DS, $q, $uibModal, AppConfiguration, logger) {
	        _classCallCheck(this, CjenikController);
	
	        _get(Object.getPrototypeOf(CjenikController.prototype), 'constructor', this).call(this, DS.definitions.Cjenik);
	        this.DS = DS;
	        this.$q = $q;
	        this.logger = logger;
	        this.view = AppConfiguration().getViewByEntityAndType('Cjenik', 'ListView');
	        this.formView = AppConfiguration().getViewByEntityAndType('Cjenik', 'EditView');
	        this.$uibModal = $uibModal;
	
	        this.icon = this.view.icon();
	        this.pageTitle = this.view.title();
	        this.pageDesc = this.view.description();
	
	        this.getState();
	    }
	
	    _createClass(CjenikController, [{
	        key: 'getState',
	        value: function getState() {
	            var _this = this;
	
	            this.DS.findAll('Valuta').then(function (response) {
	                _this.valute = response;
	            })['finally'](function () {
	                _this.getItems();
	            });
	        }
	    }, {
	        key: 'getQueryset',
	        value: function getQueryset(params) {
	            return this.Model.findAll(params, { bypassCache: true });
	        }
	    }, {
	        key: 'edit',
	        value: function edit(item) {
	            var _this2 = this;
	
	            var modal = this.showForm(item);
	            modal.result.then(function (model) {
	                _this2.Model.update(model.id, model).then(function () {
	                    return _this2.getState();
	                })['catch'](function (error) {
	                    _this2.logger.error('Upsss', error.data);
	                });
	            });
	        }
	    }, {
	        key: 'insert',
	        value: function insert() {
	            var _this3 = this;
	
	            var modal = this.showForm({});
	            modal.result.then(function (model) {
	                _this3.Model.create(model).then(function () {
	                    return _this3.getState();
	                })['catch'](function (error) {
	                    _this3.logger.error('Upsss', error.data);
	                });
	            });
	        }
	    }, {
	        key: 'showForm',
	        value: function showForm(_item) {
	            var _view = this.formView;
	            var modal = this.$uibModal.open({
	                component: 'modalForm',
	                size: 'lg',
	                resolve: {
	                    item: function item() {
	                        return _item;
	                    },
	                    view: function view() {
	                        return _view;
	                    }
	                }
	            });
	            return modal;
	        }
	    }]);
	
	    return CjenikController;
	})(_commonListControllerJs2['default']);
	
	CjenikController.$inject = ['DS', '$q', '$uibModal', 'AppConfiguration', 'logger'];
	
	var CjenikComponent = {
	    restrict: 'E',
	    templateUrl: _cjenikHtml2['default'],
	    controller: CjenikController,
	    controllerAs: 'vm'
	};
	
	exports.CjenikComponent = CjenikComponent;

/***/ },
/* 458 */
/***/ function(module, exports) {

	var path = 'app/components/cjenik/cjenik.html';
	var html = "<header id=\"header\"></header><navbar id=\"menu\"></navbar><div id=\"wrapper\"><page-header icon=\"vm.icon\" page-title=\"vm.pageTitle\" page-desc=\"vm.pageDesc\"></page-header><div class=\"content\" animate-panel><div class=\"row\"><div class=\"col-sm-6\"><div class=\"dataTables_paginate paging_simple_numbers\"><ul uib-pagination total-items=\"vm.pager.totalItems\" items-per-page=\"vm.pager.limit\" max-size=\"5\" ng-change=\"vm.pageChanged()\" ng-model=\"vm.pager.currentPage\" num-pages=\"smallnumPages\" previous-text=\"Prethodni\" next-text=\"Slijedeći\"></ul><uib-pagination total-items=\"vm.pager.totalItems\" items-per-page=\"vm.pager.limit\" max-size=\"5\" ng-change=\"vm.pageChanged()\" ng-model=\"vm.pager.currentPage\" num-pages=\"smallnumPages\" previous-text=\"Prethodni\" next-text=\"Slijedeći\"></uib-pagination></div></div><div class=\"col-sm-6\"><div class=\"dataTables_info pull-right\" role=\"status\" aria-live=\"polite\">Prikazuje se {{vm.pager.start}} od {{vm.pager.end}} od ukupno {{vm.pager.totalItems}} zapisa</div></div></div><div class=\"row\"><div class=\"col-lg-12\"><a ng-click=\"vm.insert()\" type=\"button\" class=\"btn btn-success\"><i class=\"fa fa-plus-square\"></i> Novi zapis</a></div></div><hr><div ng-if=\"vm.items.length > 0\" animate-panel><card-cjenik class=\"card\" items=\"vm.items\" valute=\"vm.valute\" on-edit=\"vm.edit(item)\"></card-cjenik></div></div><footer class=\"footer\"></footer></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _lodash = __webpack_require__(165);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _cardCjenikHtml = __webpack_require__(460);
	
	var _cardCjenikHtml2 = _interopRequireDefault(_cardCjenikHtml);
	
	var CardCjenikController = (function () {
	    function CardCjenikController(DS, $scope) {
	        _classCallCheck(this, CardCjenikController);
	
	        this.store = DS;
	        this.valute = _lodash2['default'].castArray(this.valute);
	        this.items = this.items || [];
	        this.rows = [];
	        $scope.$watch('vm.items', this.itemsChanged());
	    }
	
	    _createClass(CardCjenikController, [{
	        key: 'itemsChanged',
	        value: function itemsChanged() {
	            var _this = this;
	
	            return function (newValue, oldValue) {
	                var items = _lodash2['default'].map(newValue, _lodash2['default'].clone);
	                _this.rows = [];
	                for (var i = 0, j = items.length; i < j; i = i + 4) {
	                    _this.rows.push(items.splice(0, 4));
	                }
	            };
	        }
	    }, {
	        key: 'getValutu',
	        value: function getValutu(item) {
	            return _lodash2['default'].find(this.valute, function (i) {
	                return i.id === item.valuta;
	            });
	        }
	    }, {
	        key: 'edit',
	        value: function edit(item) {
	            this.onEdit({ item: item });
	        }
	    }]);
	
	    return CardCjenikController;
	})();
	
	var CardCjenikComponent = {
	    restrict: 'E',
	    templateUrl: _cardCjenikHtml2['default'],
	    controller: CardCjenikController,
	    controllerAs: 'vm',
	    bindings: {
	        items: '<',
	        valute: '<',
	        onEdit: '&'
	    }
	};
	
	CardCjenikController.$inject = ['DS', '$scope'];
	exports.CardCjenikComponent = CardCjenikComponent;

/***/ },
/* 460 */
/***/ function(module, exports) {

	var path = 'app/components/cjenik/cardCjenik.html';
	var html = "<div class=\"row\" ng-repeat=\"row in vm.rows\"><div class=\"col-lg-3\" ng-repeat=\"item in row\"><div class=\"hpanel hgreen contact-panel\"><div class=\"panel-body\"><div class=\"btn-group pull-right\"><button data-toggle=\"dropdown\" class=\"btn btn-success btn-xs dropdown-toggle\" aria-expanded=\"false\">Akcije <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li><a ng-click=\"vm.edit(item)\"><i class=\"fa fa-edit\"></i> Ažuriranje zaglavlja</a></li><li class=\"divider\"></li><li><a ui-sref=\"cjenik.details({id: item.id})\"><i class=\"fa fa-list-alt\"></i> Ažuriranje cijena</a></li><li><a><i class=\"fa fa-print\"></i> Ispis cjenika</a></li></ul></div><a ui-sref=\"cjenik.details({id: item.id})\"><i class=\"fa fa-list-alt fa-3x\"></i></a><h3><a ui-sref=\"cjenik.details({id: item.id})\">{{item.naziv}}</a></h3></div><div class=\"panel-footer contact-footer\"><div class=\"row\"><div class=\"col-md-12 border-right\"><div class=\"contact-stat\"><span>Valuta:</span> <strong>{{vm.getValutu(item).valuta | uppercase}}</strong></div></div></div></div></div></div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _sweetalert = __webpack_require__(375);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	var _stavkaCjenikaHtml = __webpack_require__(462);
	
	var _stavkaCjenikaHtml2 = _interopRequireDefault(_stavkaCjenikaHtml);
	
	var _commonListControllerJs = __webpack_require__(385);
	
	var _commonListControllerJs2 = _interopRequireDefault(_commonListControllerJs);
	
	var StavkaCjenikaController = (function (_ListController) {
	    _inherits(StavkaCjenikaController, _ListController);
	
	    function StavkaCjenikaController(DS, AppConfiguration, $q, $uibModal, logger) {
	        _classCallCheck(this, StavkaCjenikaController);
	
	        _get(Object.getPrototypeOf(StavkaCjenikaController.prototype), 'constructor', this).call(this);
	        this.DS = DS;
	        this.$q = $q;
	        this.logger = logger;
	        this.$uibModal = $uibModal;
	        this.Model = DS.definitions['StavkaCjenika'] || false;
	        this.view = AppConfiguration().getViewByEntityAndType('StavkaCjenika', 'ListView');
	
	        this.icon = this.view.icon();
	        this.pageTitle = this.view.getTitle({ naziv: this.cjenik.naziv });
	        this.pageDesc = this.view.description();
	
	        this.getState();
	    }
	
	    _createClass(StavkaCjenikaController, [{
	        key: 'getState',
	        value: function getState() {
	            var _this = this;
	
	            this.resolveReferences().then(function () {
	                _this.getItems();
	            });
	        }
	    }, {
	        key: 'resolveReferences',
	        value: function resolveReferences() {
	            var models = [];
	            var datastore = this.datastore();
	
	            _.forOwn(this.view.getReferences(), function (value, key) {
	                models.push(datastore.definitions[value.targetEntity().name()]);
	            });
	
	            return this.$q.all(models.map(function (m) {
	                return m.findAll();
	            }));
	        }
	    }, {
	        key: 'getQueryset',
	        value: function getQueryset(params) {
	            var cloneParams = _extends({}, params);
	            cloneParams.cjenik = this.cjenik.id;
	            return this.Model.findAll(cloneParams, { bypassCache: true });
	        }
	    }, {
	        key: 'datastore',
	        value: function datastore() {
	            return this.DS;
	        }
	    }, {
	        key: 'insert',
	        value: function insert() {
	            var _this2 = this;
	
	            var model = {
	                cjenik: this.cjenik.id
	            };
	            var entity = this.view.entity;
	            var _view = entity.creationView();
	            var modal = this.$uibModal.open({
	                component: 'modalForm',
	                size: 'lg',
	                resolve: {
	                    item: function item() {
	                        return model;
	                    },
	                    view: function view() {
	                        return _view;
	                    }
	                }
	            });
	
	            modal.result.then(function (model) {
	                _this2.Model.create(model).then(function () {
	                    _this2.Model.ejectAll();
	                    _this2.getState();
	                })['catch'](function (error) {
	                    _this2.logger.error('Oupss...', error.data);
	                });
	            });
	        }
	    }, {
	        key: 'edit',
	        value: function edit(item) {
	            var _this3 = this;
	
	            var model = item;
	            var entity = this.view.entity;
	            var _view2 = entity.creationView();
	            var modal = this.$uibModal.open({
	                component: 'modalForm',
	                size: 'lg',
	                resolve: {
	                    item: function item() {
	                        return model;
	                    },
	                    view: function view() {
	                        return _view2;
	                    }
	                }
	            });
	
	            modal.result.then(function (model) {
	                _this3.Model.update(model.id, model).then(function () {
	                    return _this3.getState();
	                })['catch'](function (error) {
	                    _this3.logger.error('Oupss...', error.data);
	                });
	            });
	        }
	    }, {
	        key: 'delete',
	        value: function _delete(item) {
	            var _this4 = this;
	
	            var previousWindowKeyDown = window.onkeydown;
	            (0, _sweetalert2['default'])({
	                title: 'Brisanje retka stavke cjenika ',
	                text: 'Za potvrdu brisanja upišite \'da\'',
	                type: 'input',
	                showCancelButton: true,
	                closeOnConfirm: false
	            }, function (inputValue) {
	                window.onkeydown = previousWindowKeyDown;
	                if (inputValue === false) return false;
	                if (inputValue === 'da') {
	                    _this4.Model.destroy(item.id).then(function (data) {
	                        _this4.getState();
	                        (0, _sweetalert2['default'])('Redak obrisan', '', 'success');
	                    }, function (error) {
	                        (0, _sweetalert2['default'])('Greška', 'Došlo je do greške prilikom brisanja', 'error');
	                    });
	                    return true;
	                }
	                _sweetalert2['default'].showInputError('Nedozvoljena vrijednost');
	                return false;
	            });
	        }
	    }]);
	
	    return StavkaCjenikaController;
	})(_commonListControllerJs2['default']);
	
	StavkaCjenikaController.$inject = ['DS', 'AppConfiguration', '$q', '$uibModal', 'logger'];
	
	var StavkaCjenikaComponent = {
	    restrict: 'E',
	    templateUrl: _stavkaCjenikaHtml2['default'],
	    controller: StavkaCjenikaController,
	    controllerAs: 'vm',
	    bindings: {
	        cjenik: '<'
	    }
	};
	
	exports.StavkaCjenikaComponent = StavkaCjenikaComponent;

/***/ },
/* 462 */
/***/ function(module, exports) {

	var path = 'app/components/cjenik/stavkaCjenika.html';
	var html = "<header id=\"header\" on-search=\"vm.onFilter(value)\" search-placeholder=\"Naziv protetskog rada / usluge\"></header><navbar id=\"menu\"></navbar><div id=\"wrapper\"><page-header icon=\"vm.icon\" page-title=\"vm.pageTitle\" page-desc=\"vm.pageDesc\"></page-header><div class=\"content\" animate-panel><div class=\"row\"><div class=\"col-sm-6\"><div class=\"dataTables_paginate paging_simple_numbers\" id=\"example2_paginate\"><ul uib-pagination total-items=\"vm.pager.totalItems\" items-per-page=\"vm.pager.limit\" max-size=\"5\" ng-change=\"vm.pageChanged()\" ng-model=\"vm.pager.currentPage\" num-pages=\"smallnumPages\" previous-text=\"Prethodni\" next-text=\"Slijedeći\"></ul></div></div><div class=\"col-sm-6\"><div class=\"dataTables_info pull-right\" id=\"example2_info\" role=\"status\" aria-live=\"polite\">Prikazuje se {{vm.pager.start}} od {{vm.pager.end}} od ukupno {{vm.pager.totalItems}} zapisa</div></div></div><div class=\"row\"><div class=\"col-lg-12\"><a ng-click=\"vm.insert()\" type=\"button\" class=\"btn btn-success\"><i class=\"fa fa-plus-square\"></i> Novi zapis</a></div></div><div animate-panel child=\"hpanel\"><div class=\"hpanel\"><div class=\"panel-heading\"><div class=\"panel-tools\"><a class=\"showhide\"><i class=\"fa fa-chevron-up\"></i></a> <a class=\"closebox\" hidden><i class=\"fa fa-times\"></i></a></div><br></div><div class=\"panel-body\"><div class=\"table-responsive\"><in-data-grid fields=\"vm.view.fields()\" entries=\"vm.items\" entity=\"vm.view.entity\" datastore=\"vm.datastore()\" actions=\"vm.view.listActions()\" on-btn-click=\"vm.btnClicked(btnId, params)\" on-edit=\"vm.edit(item)\" on-delete=\"vm.delete(item)\"></in-data-grid></div></div><div class=\"panel-footer\"><br></div></div></div></div><footer class=\"footer\"></footer></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	__webpack_require__(464);
	
	var _angularUiBootstrapSrcPagination = __webpack_require__(438);
	
	var _angularUiBootstrapSrcPagination2 = _interopRequireDefault(_angularUiBootstrapSrcPagination);
	
	var _angularUiBootstrapSrcModal = __webpack_require__(424);
	
	var _angularUiBootstrapSrcModal2 = _interopRequireDefault(_angularUiBootstrapSrcModal);
	
	var _angularUiBootstrapSrcTooltip = __webpack_require__(169);
	
	var _angularUiBootstrapSrcTooltip2 = _interopRequireDefault(_angularUiBootstrapSrcTooltip);
	
	var _commonCrudCrudJs = __webpack_require__(371);
	
	var _stavkaNalogaStavkaNalogaJs = __webpack_require__(466);
	
	var _radniNalogListComponentJs = __webpack_require__(481);
	
	var _radniNalogDetailsComponentJs = __webpack_require__(483);
	
	var _planRadaComponentJs = __webpack_require__(486);
	
	var _shemaComponentJs = __webpack_require__(488);
	
	var _radniNalogCreateComponentJs = __webpack_require__(490);
	
	var _radniNalogEditComponentJs = __webpack_require__(492);
	
	var _radniNalogWizardFormComponentJs = __webpack_require__(494);
	
	var _evidencijaNalogaComponentJs = __webpack_require__(496);
	
	var _komentariComponentJs = __webpack_require__(498);
	
	var _rnLinkComponentJs = __webpack_require__(501);
	
	var _radniNalogServiceJs = __webpack_require__(503);
	
	var _radniNalogServiceJs2 = _interopRequireDefault(_radniNalogServiceJs);
	
	var radniNalog = _angular2["default"].module("radniNalog", [_angularUiBootstrapSrcPagination2["default"], _angularUiBootstrapSrcModal2["default"], _angularUiBootstrapSrcTooltip2["default"], "ngFileUpload", _commonCrudCrudJs.crud.name, _stavkaNalogaStavkaNalogaJs.stavkaNaloga.name]);
	
	radniNalog.component("radniNalogList", _radniNalogListComponentJs.RadniNalogListComponent);
	radniNalog.component("radniNalogDetails", _radniNalogDetailsComponentJs.RadniNalogDetailsComponent);
	radniNalog.component("planRada", _planRadaComponentJs.PlanRadaComponent);
	radniNalog.component("shema", _shemaComponentJs.ShemaComponent);
	radniNalog.component("radniNalogCreate", _radniNalogCreateComponentJs.RadniNalogCreateComponent);
	radniNalog.component("radniNalogEdit", _radniNalogEditComponentJs.RadniNalogEditComponent);
	radniNalog.component("radniNalogWizardForm", _radniNalogWizardFormComponentJs.RadniNalogWizardFormComponent);
	radniNalog.component("evidencijaNaloga", _evidencijaNalogaComponentJs.EvidencijaNalogaComponent);
	radniNalog.component("komentari", _komentariComponentJs.KomentariComponent);
	radniNalog.component("rnLink", _rnLinkComponentJs.RnLinkComponent);
	
	radniNalog.service("RadniNalogService", _radniNalogServiceJs2["default"]);
	
	exports.radniNalog = radniNalog;

/***/ },
/* 464 */,
/* 465 */,
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _stavkaNalogaFormComponentJs = __webpack_require__(467);
	
	var _odabirPozicijaFormComponentJs = __webpack_require__(470);
	
	var _pozicijeComponentJs = __webpack_require__(472);
	
	var _kvadrantComponentJs = __webpack_require__(474);
	
	var _protetskiPozicijeDirectiveJs = __webpack_require__(476);
	
	var _vrstaRadaComponentJs = __webpack_require__(477);
	
	var _materijalComponentJs = __webpack_require__(479);
	
	var stavkaNaloga = _angular2['default'].module('stavkaNaloga', []);
	
	stavkaNaloga.component('stavkaNalogaForm', _stavkaNalogaFormComponentJs.StavkaNalogaFormComponent);
	stavkaNaloga.component('odabirPozicijaForm', _odabirPozicijaFormComponentJs.OdabirPozicijaFormComponent);
	stavkaNaloga.component('pozicije', _pozicijeComponentJs.PozicijeComponent);
	stavkaNaloga.component('kvadrant', _kvadrantComponentJs.KvadrantComponent);
	stavkaNaloga.component('vrstaRada', _vrstaRadaComponentJs.VrstaRadaComponent);
	stavkaNaloga.component('materijal', _materijalComponentJs.MaterijalComponent);
	
	stavkaNaloga.directive('protetskiPozicije', _protetskiPozicijeDirectiveJs.protetskiPozicije);
	
	exports.stavkaNaloga = stavkaNaloga;

/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _lodash = __webpack_require__(165);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _stavkaNalogaFormHtml = __webpack_require__(468);
	
	var _stavkaNalogaFormHtml2 = _interopRequireDefault(_stavkaNalogaFormHtml);
	
	var _kvadrantJs = __webpack_require__(469);
	
	var StavkaNalogaFormController = (function () {
	    function StavkaNalogaFormController(AppConfiguration, DS, $timeout, logger, $q) {
	        _classCallCheck(this, StavkaNalogaFormController);
	
	        this.item = this.resolve.item;
	        this.logger = logger;
	        this.view = AppConfiguration().getViewByEntityAndType('StavkaNaloga', 'CreateView');
	        this.datastore = function () {
	            return DS;
	        };
	        this.$timeout = function () {
	            return $timeout;
	        };
	        this.$q = function () {
	            return $q;
	        };
	    }
	
	    _createClass(StavkaNalogaFormController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            var DS = this.datastore();
	            var $q = this.$q();
	            this.vrste_radova = [];
	            this._materijali = []; // cache materijala za kasnije filtriranje
	            this.stavke_cjenika = [];
	            this.clone = angular.copy(this.item);
	            DS.findAll('StavkaCjenika').then(function (stavke) {
	                _this.stavke_cjenika = stavke;
	
	                DS.findAll('ProtetskiRad').then(function (response) {
	                    _this.protetski_rad = response.filter(function (i) {
	                        return _lodash2['default'].find(_this.stavke_cjenika, { protetski_rad: i.id });
	                    });
	                }).then(function () {
	                    $q.when(DS.findAll('VrstaRada')).then(function (vrsta) {
	                        _this.vrste_radova = vrsta.filter(function (i) {
	                            return _lodash2['default'].find(_this.protetski_rad, { vrsta_rada: i.id });
	                        });
	                    });
	                });
	                DS.findAll('Materijal').then(function (response) {
	                    _this._materijali = response;
	                });
	            });
	        }
	    }, {
	        key: 'submit',
	        value: function submit(model) {
	            this.form.$setSubmitted(true);
	            if (this.form.$invalid) {
	                return;
	            }
	            this.close({ $value: model });
	        }
	    }, {
	        key: 'setVrstuRada',
	        value: function setVrstuRada(item) {
	            var _this2 = this;
	
	            if (item === undefined) {
	                this.clone.vrsta_rada = undefined;
	                this.materijali = [];
	                return;
	            }
	
	            var $timeout = this.$timeout();
	            var radovi = _lodash2['default'].filter(this.protetski_rad, { vrsta_rada: item.id });
	
	            this.clone.vrsta_rada = null;
	            this.clone.protetski_rad = null;
	            this.clone.cjenik = null;
	            var materijali = [];
	
	            _lodash2['default'].forEach(radovi, function (rad) {
	                if (rad.materijal) {
	                    materijali.push(rad.materijal);
	                }
	            });
	
	            if (materijali.length === 0) {
	                this.setProtetskiRadByVrstaRada(item.id);
	            }
	
	            $timeout(function () {
	                _this2.clone.vrsta_rada = item.id;
	                _this2.materijali = _lodash2['default'].uniq(materijali).map(function (m) {
	                    return _lodash2['default'].cloneDeep(_lodash2['default'].find(_this2._materijali, { id: m }));
	                });
	            });
	        }
	    }, {
	        key: 'setMaterijal',
	        value: function setMaterijal(item) {
	            // const $timeout = this.$timeout();
	            // this.setProtetskiRadByVrstaRadaAndMaterijal(this.clone.vrsta_rada, item.id);
	            if (item && _lodash2['default'].isFinite(parseInt(item.id))) {
	                this.clone.materijal = item.id;
	            } else {
	                this.clone.materijal = undefined;
	            }
	            // $timeout(() => {
	            // });
	        }
	    }, {
	        key: 'setProtetskiRadByVrstaRada',
	        value: function setProtetskiRadByVrstaRada(vrsta_rada) {
	            // const protetski_rad = _.find(this.protetski_rad, {vrsta_rada: vrsta_rada});
	            // if (_.isUndefined(protetski_rad)) {
	            //     this.logger.error('Oupss...', 'Traženi protetski rad nije pronađen');
	            //     return;
	            // }
	            // this.clone.protetski_rad = protetski_rad.id;
	            // this.setCjenik(this.clone.protetski_rad);
	        }
	    }, {
	        key: 'setProtetskiRadByVrstaRadaAndMaterijal',
	        value: function setProtetskiRadByVrstaRadaAndMaterijal(vrsta_rada, materijal) {
	            // const protetski_rad = _.find(this.protetski_rad, {vrsta_rada: vrsta_rada, materijal: materijal});
	            // if (_.isUndefined(protetski_rad)) {
	            //     this.logger.error('Oupss...', 'Traženi protetski rad nije pronađen');
	            //     return;
	            // }
	            // this.clone.protetski_rad = protetski_rad.id;
	            // this.setCjenik(this.clone.protetski_rad);
	        }
	    }, {
	        key: 'setCjenik',
	        value: function setCjenik(protetski_rad) {
	            var stavke = _lodash2['default'].filter(this.stavke_cjenika, { protetski_rad: protetski_rad });
	            debugger;
	            if (stavke.length === 1) {
	                this.clone.cjenik = stavke[0].cjenik;
	            }
	        }
	    }, {
	        key: 'cancel',
	        value: function cancel() {
	            this.dismiss({ $value: 'cancel' });
	        }
	    }]);
	
	    return StavkaNalogaFormController;
	})();
	
	StavkaNalogaFormController.$inject = ['AppConfiguration', 'DS', '$timeout', 'logger', '$q'];
	
	var StavkaNalogaFormComponent = {
	    restrict: 'E',
	    templateUrl: _stavkaNalogaFormHtml2['default'],
	    controller: StavkaNalogaFormController,
	    controllerAs: 'vm',
	    bindings: {
	        resolve: '<',
	        close: '&',
	        dismiss: '&'
	    }
	};
	
	exports.StavkaNalogaFormComponent = StavkaNalogaFormComponent;
	exports.StavkaNalogaFormController = StavkaNalogaFormController;

/***/ },
/* 468 */
/***/ function(module, exports) {

	var path = 'app/components/stavkaNaloga/stavkaNalogaForm.html';
	var html = "<div class=\"modal-content\"><div class=\"color-line\"></div><div class=\"modal-header padding15\"><h1 ng-if=\"vm.clone.pozicija\" class=\"modal-title\">Odabrana pozicija za rad: <a id=\"18\" class=\"btn btn-lg btn-warning pozicije\">{{vm.clone.pozicija}}</a></h1></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-lg-12\" ng-if=\"vm.vrste_radova.length > 0\" animate-panel><vrsta-rada items=\"vm.vrste_radova\" on-click=\"vm.setVrstuRada(item)\"></vrsta-rada></div><div class=\"col-lg-3 col-sm-12\" ng-if=\"vm.materijali.length > 0\" animate-panel><materijal items=\"vm.materijali\" on-click=\"vm.setMaterijal(item)\"></materijal></div><div class=\"col-lg-9 col-sm-12\" animate-panel><div class=\"row\"><div class=\"col-lg-12\"><form name=\"vm.form\" ng-submit=\"vm.submit(vm.clone)\" class=\"form-horizontal\"><formly-form model=\"vm.clone\" fields=\"vm.view.fields()\" form=\"vm.form\" options=\"vm.options\"></formly-form></form></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.cancel()\">Odustani</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"vm.submit(vm.clone)\">Potvrdi</button></div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 469 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var kvadrant_I = [{ broj: 18, selected: false, veza: false }, { broj: 1817, selected: false, veza: true }, { broj: 17, selected: false, veza: false }, { broj: 1716, selected: false, veza: true }, { broj: 16, selected: false, veza: false }, { broj: 1615, selected: false, veza: true }, { broj: 15, selected: false, veza: false }, { broj: 1514, selected: false, veza: true }, { broj: 14, selected: false, veza: false }, { broj: 1413, selected: false, veza: true }, { broj: 13, selected: false, veza: false }, { broj: 1312, selected: false, veza: true }, { broj: 12, selected: false, veza: false }, { broj: 1211, selected: false, veza: true }, { broj: 11, selected: false, veza: false }, { broj: 1121, selected: false, veza: true }];
	
	var kvadrant_II = [{ broj: 21, selected: false, veza: false }, { broj: 2122, selected: false, veza: true }, { broj: 22, selected: false, veza: false }, { broj: 2223, selected: false, veza: true }, { broj: 23, selected: false, veza: false }, { broj: 2324, selected: false, veza: true }, { broj: 24, selected: false, veza: false }, { broj: 2425, selected: false, veza: true }, { broj: 25, selected: false, veza: false }, { broj: 2526, selected: false, veza: true }, { broj: 26, selected: false, veza: false }, { broj: 2627, selected: false, veza: true }, { broj: 27, selected: false, veza: false }, { broj: 2728, selected: false, veza: true }, { broj: 28, selected: false, veza: false }];
	
	var kvadrant_III = [{ broj: 31, selected: false, veza: false }, { broj: 3132, selected: false, veza: true }, { broj: 32, selected: false, veza: false }, { broj: 3233, selected: false, veza: true }, { broj: 33, selected: false, veza: false }, { broj: 3334, selected: false, veza: true }, { broj: 34, selected: false, veza: false }, { broj: 3435, selected: false, veza: true }, { broj: 35, selected: false, veza: false }, { broj: 3536, selected: false, veza: true }, { broj: 36, selected: false, veza: false }, { broj: 3637, selected: false, veza: true }, { broj: 37, selected: false, veza: false }, { broj: 3738, selected: false, veza: true }, { broj: 38, selected: false, veza: false }];
	
	var kvadrant_IV = [{ broj: 48, selected: false, veza: false }, { broj: 4847, selected: false, veza: true }, { broj: 47, selected: false, veza: false }, { broj: 4746, selected: false, veza: true }, { broj: 46, selected: false, veza: false }, { broj: 4645, selected: false, veza: true }, { broj: 45, selected: false, veza: false }, { broj: 4544, selected: false, veza: true }, { broj: 44, selected: false, veza: false }, { broj: 4443, selected: false, veza: true }, { broj: 43, selected: false, veza: false }, { broj: 4342, selected: false, veza: true }, { broj: 42, selected: false, veza: false }, { broj: 4241, selected: false, veza: true }, { broj: 41, selected: false, veza: false }, { broj: 4131, selected: false, veza: true }];
	
	exports.kvadrant_I = kvadrant_I;
	exports.kvadrant_II = kvadrant_II;
	exports.kvadrant_III = kvadrant_III;
	exports.kvadrant_IV = kvadrant_IV;

/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _lodash = __webpack_require__(165);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _odabirPozicijaFormHtml = __webpack_require__(471);
	
	var _odabirPozicijaFormHtml2 = _interopRequireDefault(_odabirPozicijaFormHtml);
	
	var _kvadrantJs = __webpack_require__(469);
	
	var OdabirPozicijaFormController = (function () {
	    function OdabirPozicijaFormController() {
	        _classCallCheck(this, OdabirPozicijaFormController);
	
	        this.item = this.resolve.item;
	        this.kvadranti = [];
	    }
	
	    _createClass(OdabirPozicijaFormController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            this.clone = angular.copy(this.item);
	
	            this.kvadranti = [_lodash2['default'].cloneDeep(_kvadrantJs.kvadrant_I), _lodash2['default'].cloneDeep(_kvadrantJs.kvadrant_II), _lodash2['default'].cloneDeep(_kvadrantJs.kvadrant_III), _lodash2['default'].cloneDeep(_kvadrantJs.kvadrant_IV)];
	
	            this.kvadranti.map(function (kvadrant) {
	                kvadrant.map(function (pozicija) {
	                    var item = _lodash2['default'].find(_this.clone.pozicije, { broj: pozicija.broj });
	                    pozicija.selected = _lodash2['default'].isUndefined(item) ? false : true;
	                });
	            });
	
	            if (_lodash2['default'].isArray(this.clone.pozicije) === false) {
	                this.clone.pozicije = [];
	            }
	        }
	    }, {
	        key: 'submit',
	        value: function submit() {
	            var pozicije = [];
	            this.kvadranti.map(function (kvadrant) {
	                kvadrant.map(function (pozicija) {
	                    if (pozicija.selected) {
	                        pozicije.push({ broj: pozicija.broj, selected: pozicija.selected });
	                    }
	                });
	            });
	            this.close({ $value: pozicije });
	        }
	    }, {
	        key: 'pozicijaClicked',
	        value: function pozicijaClicked(pozicija) {
	
	            this.kvadranti.map(function (kvadrant) {
	                kvadrant.map(function (item) {
	                    if (item.broj === pozicija.broj) {
	                        pozicija.selected = !pozicija.selected;
	                    }
	                });
	            });
	            this.submit();
	        }
	    }, {
	        key: 'cancel',
	        value: function cancel() {
	            this.dismiss({ $value: 'cancel' });
	        }
	    }]);
	
	    return OdabirPozicijaFormController;
	})();
	
	OdabirPozicijaFormController.$inject = [];
	
	var OdabirPozicijaFormComponent = {
	    restrict: 'E',
	    templateUrl: _odabirPozicijaFormHtml2['default'],
	    controller: OdabirPozicijaFormController,
	    controllerAs: 'vm',
	    bindings: {
	        resolve: '<',
	        close: '&',
	        dismiss: '&'
	    }
	};
	
	exports.OdabirPozicijaFormComponent = OdabirPozicijaFormComponent;
	exports.OdabirPozicijaFormController = OdabirPozicijaFormController;

/***/ },
/* 471 */
/***/ function(module, exports) {

	var path = 'app/components/stavkaNaloga/odabirPozicijaForm.html';
	var html = "<div class=\"modal-content\"><div class=\"color-line\"></div><div class=\"modal-header\"><h5 class=\"modal-title\">Odaberite pozicije</h5></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-lg-6\"><div class=\"hpanel text-left\"><div class=\"panel-heading hbuilt\"><a href=\"#\" class=\"btn btn-xs btn-primary pozicije\">1. kvadrant</a></div><div class=\"panel-body\"><div class=\"table-responsive\"><pozicije items=\"vm.kvadranti[0]\" on-click=\"vm.pozicijaClicked(pozicija)\"></pozicije></div></div></div></div><div class=\"col-lg-6\"><div class=\"hpanel text-left\"><div class=\"panel-heading hbuilt\"><a href=\"#\" class=\"btn btn-xs btn-primary pozicije\">2. kvadrant</a></div><div class=\"panel-body\"><div class=\"table-responsive\"><pozicije items=\"vm.kvadranti[1]\" on-click=\"vm.pozicijaClicked(pozicija)\"></pozicije></div></div></div></div><div class=\"col-lg-6\"><div class=\"hpanel text-left\"><div class=\"panel-heading hbuilt\"><a href=\"#\" class=\"btn btn-xs btn-primary pozicije\">4. kvadrant</a></div><div class=\"panel-body\"><div class=\"table-responsive\"><pozicije items=\"vm.kvadranti[3]\" on-click=\"vm.pozicijaClicked(pozicija)\"></pozicije></div></div></div></div><div class=\"col-lg-6\"><div class=\"hpanel text-left\"><div class=\"panel-heading hbuilt\"><a href=\"#\" class=\"btn btn-xs btn-primary pozicije\">3. kvadrant</a></div><div class=\"panel-body\"><div class=\"table-responsive\"><pozicije items=\"vm.kvadranti[2]\" on-click=\"vm.pozicijaClicked(pozicija)\"></pozicije></div></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.cancel()\">Odustani</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"vm.submit()\">Potvrdi</button></div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _lodash = __webpack_require__(165);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _pozicijeHtml = __webpack_require__(473);
	
	var _pozicijeHtml2 = _interopRequireDefault(_pozicijeHtml);
	
	var PozicijeController = (function () {
	    function PozicijeController() {
	        _classCallCheck(this, PozicijeController);
	    }
	
	    _createClass(PozicijeController, [{
	        key: '$onInit',
	
	        // this.items = [];
	        value: function $onInit() {}
	    }, {
	        key: 'pozicijaClicked',
	        value: function pozicijaClicked(pozicija) {
	            this.onClick({ pozicija: pozicija });
	        }
	    }]);
	
	    return PozicijeController;
	})();
	
	PozicijeController.$inject = [];
	
	var PozicijeComponent = {
	    restrict: 'E',
	    templateUrl: _pozicijeHtml2['default'],
	    controller: PozicijeController,
	    controllerAs: 'vm',
	    bindings: {
	        items: '<',
	        onClick: '&'
	    }
	};
	
	exports.PozicijeComponent = PozicijeComponent;
	exports.PozicijeController = PozicijeController;

/***/ },
/* 473 */
/***/ function(module, exports) {

	var path = 'app/components/stavkaNaloga/pozicije.html';
	var html = "<table cellpadding=\"1\" cellspacing=\"1\" class=\"table table-condensed no_border\"><tbody><tr><th class=\"text-center\" ng-repeat=\"pozicija in vm.items\"><a ng-click=\"vm.pozicijaClicked(pozicija)\" ng-class=\"{'btn-warning': pozicija.selected}\" class=\"btn btn-xs btn-default pozicije\">{{pozicija.broj}}</a></th></tr></tbody></table>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _lodash = __webpack_require__(165);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _kvadrantHtml = __webpack_require__(475);
	
	var _kvadrantHtml2 = _interopRequireDefault(_kvadrantHtml);
	
	var _kvadrantJs = __webpack_require__(469);
	
	var KvadrantController = (function () {
	    function KvadrantController($scope) {
	        _classCallCheck(this, KvadrantController);
	
	        this.kvadranti = [_lodash2['default'].cloneDeep(_kvadrantJs.kvadrant_I).concat(_lodash2['default'].cloneDeep(_kvadrantJs.kvadrant_II)), _lodash2['default'].cloneDeep(_kvadrantJs.kvadrant_IV).concat(_lodash2['default'].cloneDeep(_kvadrantJs.kvadrant_III))];
	
	        this.$scope = $scope;
	        this.kvadrant = this.kvadrant || 1;
	        // debugger;
	        this.stavke = this.stavke || [];
	        this.pozicije = [];
	        this.dragStarted = false;
	    }
	
	    _createClass(KvadrantController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.pozicije = this.kvadranti[this.kvadrant - 1];
	            this.$scope.$watch('vm.stavke', this.refreshPozicije(), true);
	        }
	    }, {
	        key: 'onClick',
	        value: function onClick(pozicija) {
	            if (!this.dragStarted) {
	                this.pozicijaClicked({ pozicija: pozicija });
	            }
	        }
	    }, {
	        key: 'refreshStavke',
	        value: function refreshStavke() {
	            var that = this;
	            return function (newValue, oldValue) {
	                that.pozicije.map(function (i) {
	                    return i.selected = false;
	                });
	                that.stavke.map(function (stavka) {
	                    that.pozicije.map(function (item) {
	                        var pozicija = _lodash2['default'].find(stavka.pozicije, { broj: item.broj });
	                        if (_lodash2['default'].isUndefined(pozicija) === false) {
	                            item.selected = pozicija.selected;
	                        }
	                    });
	                });
	            };
	        }
	    }, {
	        key: 'onDropComplete',
	        value: function onDropComplete(toPozicija, fromPozicija, $event) {
	            this.dragStarted = false;
	            $event.event.stopPropagation();
	            this.onDrop({ from: fromPozicija, to: toPozicija });
	        }
	    }, {
	        key: 'onDragStarted',
	        value: function onDragStarted($event) {
	            this.dragStarted = true;
	        }
	    }, {
	        key: 'refreshPozicije',
	        value: function refreshPozicije() {
	            var _this = this;
	
	            var that = this;
	            return function (newValue, oldValue) {
	                that.pozicije.map(function (pozicija) {
	                    var stavka = _lodash2['default'].find(_this.stavke, { broj: pozicija.broj });
	                    pozicija.selected = _lodash2['default'].isObject(stavka);
	                });
	            };
	        }
	    }]);
	
	    return KvadrantController;
	})();
	
	KvadrantController.$inject = ['$scope'];
	
	var KvadrantComponent = {
	    restrict: 'E',
	    templateUrl: _kvadrantHtml2['default'],
	    controller: KvadrantController,
	    controllerAs: 'vm',
	    bindings: {
	        stavke: '<',
	        kvadrant: '<',
	        pozicijaClicked: '&',
	        onDrop: '&'
	    }
	};
	
	exports.KvadrantComponent = KvadrantComponent;
	exports.KvadrantController = KvadrantController;

/***/ },
/* 475 */
/***/ function(module, exports) {

	var path = 'app/components/stavkaNaloga/kvadrant.html';
	var html = "<div class=\"table-responsive\"><table cellpadding=\"1\" cellspacing=\"1\" border=\"0\" class=\"table table-condensed table-kvadrant\" ng-if=\"vm.kvadrant===1\"><thead><tr><th class=\"text-center\" ng-repeat=\"pozicija in vm.pozicije\"><a ng-if=\"!pozicija.veza\" ng-click=\"vm.onClick(pozicija)\" class=\"btn btn-xs btn-default pozicije\" ng-class=\"{'btn-warning': pozicija.selected}\">{{pozicija.broj}}</a></th></tr></thead><tbody><tr><td ng-repeat=\"pozicija in vm.pozicije\" ng-drop=\"true\" ng-drop-success=\"vm.onDropComplete(pozicija, $data,$event)\" ng-drag-start=\"vm.onDragStarted($event)\"><div ng-if=\"!pozicija.veza\" style=\"z-index: 2\" ng-drag=\"true\" ng-drag-data=\"pozicija\" data-allow-transform=\"false\"><a ng-click=\"vm.onClick(pozicija)\"><img ng-src=\"images/zubi/{{pozicija.broj}}.jpg\" ng-class=\"{'pozicija_selected_kvadrant_1': pozicija.selected}\" class=\"img-responsive center-block zubi_gornji\"></a></div></td></tr><tr><td ng-repeat=\"pozicija in vm.pozicije\"><a ng-if=\"pozicija.veza\" ng-click=\"vm.onClick(pozicija)\" class=\"veza\" ng-class=\"{'active': pozicija.selected}\"></a></td></tr></tbody></table><table cellpadding=\"1\" cellspacing=\"1\" border=\"0\" class=\"table table-condensed table-kvadrant\" ng-if=\"vm.kvadrant===2\"><thead><tr><th ng-repeat=\"pozicija in vm.pozicije\"><a ng-if=\"pozicija.veza\" ng-click=\"vm.onClick(pozicija)\" class=\"veza\" ng-class=\"{'active': pozicija.selected}\"></a></th></tr></thead><tbody><tr><td ng-repeat=\"pozicija in vm.pozicije\" ng-drop=\"true\" ng-drop-success=\"vm.onDropComplete(pozicija, $data,$event)\" ng-drag-start=\"vm.onDragStarted($event)\"><div ng-if=\"!pozicija.veza\" ng-drag=\"true\" ng-drag-data=\"pozicija\" data-allow-transform=\"false\"><a ng-click=\"vm.onClick(pozicija)\"><img ng-src=\"images/zubi/{{pozicija.broj}}.jpg\" ng-class=\"{'pozicija_selected_kvadrant_2': pozicija.selected}\" class=\"img-responsive center-block zubi_donji\"></a></div></td></tr><tr><td class=\"text-center\" ng-repeat=\"pozicija in vm.pozicije\"><a ng-if=\"!pozicija.veza\" ng-click=\"vm.onClick(pozicija)\" class=\"btn btn-xs btn-default pozicije\" ng-class=\"{'btn-warning': pozicija.selected}\">{{pozicija.broj}}</a></td></tr></tbody></table></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _lodash = __webpack_require__(165);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function protetskiPozicije() {
	    return {
	        restrict: 'E',
	        controller: ['DS', '$scope', function (DS, $scope) {
	            $scope.protetski_rad_naziv = function () {
	                var protetski_rad = DS.get('ProtetskiRad', $scope.entry.protetski_rad);
	                if (_lodash2['default'].isObject(protetski_rad)) {
	                    return protetski_rad.naziv;
	                }
	                return protetski_rad;
	            };
	        }],
	        template: '\n            <div><strong>{{protetski_rad_naziv()}}</strong></div>\n            <small>\n                <span ng-repeat="pozicija in entry.pozicije track by $index" ng-show="pozicija">[{{pozicija}}] </span>\n            </small>\n        '
	    };
	}
	
	exports.protetskiPozicije = protetskiPozicije;

/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _lodash = __webpack_require__(165);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _vrstaRadaHtml = __webpack_require__(478);
	
	var _vrstaRadaHtml2 = _interopRequireDefault(_vrstaRadaHtml);
	
	var VrstaRadaController = (function () {
	    function VrstaRadaController(DS) {
	        _classCallCheck(this, VrstaRadaController);
	
	        this.datastore = function () {
	            return DS;
	        };
	    }
	
	    _createClass(VrstaRadaController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.selectedItem = undefined;
	        }
	    }, {
	        key: '$onChanges',
	        value: function $onChanges(changes) {
	            if (changes.items.currentValue.length > 0) {
	                this.grupe = [];
	                this.refreshState();
	            }
	        }
	    }, {
	        key: 'click',
	        value: function click(item) {
	            if (this.selectedItem === item) {
	                this.selectedItem = undefined;
	                this.onClick({ item: undefined });
	            } else {
	                this.selectedItem = item;
	                this.onClick({ item: item });
	            }
	        }
	    }, {
	        key: 'itemSelected',
	        value: function itemSelected(item) {
	            // return (!_.isUndefined(this.selectedItem) && this.selectedItem.id === item.id);
	            return this.selectedItem === item;
	        }
	    }, {
	        key: 'refreshState',
	        value: function refreshState() {
	            var _this = this;
	
	            var DS = this.datastore();
	            DS.findAll('GrupaRada').then(function (response) {
	                var grupe = response.map(function (grupa) {
	                    var clone = _lodash2['default'].cloneDeep(grupa);
	                    var items = _lodash2['default'].filter(_this.items, { grupa: grupa.id });
	                    clone.items = [];
	                    for (var i = 0, j = items.length; i < j; i = i + 3) {
	                        clone.items.push(items.splice(0, 3));
	                    }
	                    return clone;
	                });
	
	                _this.grupe = _lodash2['default'].filter(grupe, function (i) {
	                    return i.items.length > 0;
	                });
	            });
	        }
	    }]);
	
	    return VrstaRadaController;
	})();
	
	VrstaRadaController.$inject = ['DS'];
	
	var VrstaRadaComponent = {
	    restrict: 'E',
	    templateUrl: _vrstaRadaHtml2['default'],
	    controller: VrstaRadaController,
	    controllerAs: 'vm',
	    bindings: {
	        items: '<',
	        onClick: '&'
	    }
	};
	
	exports.VrstaRadaComponent = VrstaRadaComponent;
	exports.VrstaRadaController = VrstaRadaController;

/***/ },
/* 478 */
/***/ function(module, exports) {

	var path = 'app/components/stavkaNaloga/vrstaRada.html';
	var html = "<h2>Vrsta rada</h2><hr><div id=\"vrste-rada\" class=\"panel-body float-e-margins\"><div class=\"row\"><div class=\"col-lg-2\" ng-repeat=\"grupa in vm.grupe\"><h4 class=\"m-t-sm m-b-sm\">{{grupa.naziv}}</h4><div ng-repeat=\"row in grupa.items\"><span class=\"vrsta\" ng-repeat=\"item in row\"><a ng-click=\"vm.click(item)\" class=\"btn btn-primary\" ng-class=\"{'btn-warning': vm.itemSelected(item)}\" type=\"button\">{{item.naziv}}</a></span></div></div></div></div><hr>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _lodash = __webpack_require__(165);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _materijalHtml = __webpack_require__(480);
	
	var _materijalHtml2 = _interopRequireDefault(_materijalHtml);
	
	var MaterijalController = (function () {
	    function MaterijalController() {
	        _classCallCheck(this, MaterijalController);
	    }
	
	    _createClass(MaterijalController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.selectedItem = undefined;
	        }
	    }, {
	        key: 'click',
	        value: function click(item) {
	            if (this.selectedItem === item) {
	                this.selectedItem = undefined;
	                this.onClick({ item: undefined });
	            } else {
	                this.selectedItem = item;
	                this.onClick({ item: item });
	            }
	        }
	    }, {
	        key: 'itemSelected',
	        value: function itemSelected(item) {
	            return this.selectedItem === item;
	        }
	    }]);
	
	    return MaterijalController;
	})();
	
	MaterijalController.$inject = [];
	
	var MaterijalComponent = {
	    restrict: 'E',
	    templateUrl: _materijalHtml2['default'],
	    controller: MaterijalController,
	    controllerAs: 'vm',
	    bindings: {
	        items: '<',
	        onClick: '&'
	    }
	};
	
	exports.MaterijalComponent = MaterijalComponent;
	exports.MaterijalController = MaterijalController;

/***/ },
/* 480 */
/***/ function(module, exports) {

	var path = 'app/components/stavkaNaloga/materijal.html';
	var html = "<h2>Materijal</h2><hr><div class=\"row\"><div class=\"col-lg-12\"><button ng-repeat=\"item in vm.items track by $index\" ng-click=\"vm.click(item)\" class=\"btn btn-primary margin-right10 margin-bottom20\" ng-class=\"{'btn-warning': vm.itemSelected(item)}\" type=\"button\"><i class=\"fa fa-recycle\"></i><br>{{item.naziv}}</button></div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _radniNalogListHtml = __webpack_require__(482);
	
	var _radniNalogListHtml2 = _interopRequireDefault(_radniNalogListHtml);
	
	var _commonListControllerJs = __webpack_require__(385);
	
	var _commonListControllerJs2 = _interopRequireDefault(_commonListControllerJs);
	
	var RadniNalogListController = (function () {
	    function RadniNalogListController(DS, AppConfiguration, $q, $state, RadniNalogService) {
	        _classCallCheck(this, RadniNalogListController);
	
	        this.DS = function () {
	            return DS;
	        };
	        this.$q = $q;
	        this.$state = $state;
	        this.view = AppConfiguration().getViewByEntityAndType("RadniNalog", "ListView");
	
	        this.icon = this.view.icon();
	        this.pageTitle = this.view.title();
	        this.pageDesc = this.view.description();
	
	        this.RadniNalogService = function () {
	            return RadniNalogService;
	        };
	        this.pager = RadniNalogService.getPager();
	        this.filter = RadniNalogService.getFilter();
	    }
	
	    _createClass(RadniNalogListController, [{
	        key: "$onInit",
	        value: function $onInit() {
	            this.refreshState();
	        }
	    }, {
	        key: "refreshState",
	        value: function refreshState() {
	            var _this = this;
	
	            var RadniNalogService = this.RadniNalogService();
	            RadniNalogService.fetchRadneNaloge().then(function (response) {
	                _this.items = response;
	                _this.pager = RadniNalogService.getPager();
	            });
	        }
	    }, {
	        key: "pageChanged",
	        value: function pageChanged() {
	            var RadniNalogService = this.RadniNalogService();
	            var pager = RadniNalogService.getPager();
	            RadniNalogService.setPager({ currentPage: this.pager.currentPage });
	            this.refreshState();
	        }
	    }, {
	        key: "onFilter",
	        value: function onFilter(value) {
	            var filter = { search: value };
	            var RadniNalogService = this.RadniNalogService();
	            RadniNalogService.setFilter(_extends({}, filter));
	            RadniNalogService.setPager({ currentPage: 1 });
	            this.refreshState();
	        }
	    }, {
	        key: "edit",
	        value: function edit(item) {
	            this.$state.go("radniNalog.details", { id: item.id });
	        }
	    }]);
	
	    return RadniNalogListController;
	})();
	
	RadniNalogListController.$inject = ["DS", "AppConfiguration", "$q", "$state", "RadniNalogService"];
	
	var RadniNalogListComponent = {
	    restrict: "E",
	    templateUrl: _radniNalogListHtml2["default"],
	    controller: RadniNalogListController,
	    controllerAs: "vm"
	};
	
	exports.RadniNalogListComponent = RadniNalogListComponent;
	exports.RadniNalogListController = RadniNalogListController;

/***/ },
/* 482 */
/***/ function(module, exports) {

	var path = 'app/components/radniNalog/radniNalogList.html';
	var html = "<header id=\"header\" on-search=\"vm.onFilter(value)\" search-placeholder=\"Broj RN, pacijent ili ordinacija\" term=\"vm.filter.search\"></header><navbar id=\"menu\"></navbar><div id=\"wrapper\"><page-header icon=\"vm.icon\" page-title=\"vm.pageTitle\" page-desc=\"vm.pageDesc\"></page-header><div class=\"content\" animate-panel><div class=\"row\"><div class=\"col-sm-6\"><div class=\"dataTables_paginate paging_simple_numbers\"><ul uib-pagination total-items=\"vm.pager.totalItems\" items-per-page=\"vm.pager.limit\" max-size=\"5\" ng-change=\"vm.pageChanged()\" ng-model=\"vm.pager.currentPage\" num-pages=\"smallnumPages\" previous-text=\"Prethodni\" next-text=\"Slijedeći\"></ul></div></div><div class=\"col-sm-6\"><div class=\"dataTables_info pull-right\" id=\"example2_info\" role=\"status\" aria-live=\"polite\">Prikazuje se {{vm.pager.start}} od {{vm.pager.end}} od ukupno {{vm.pager.totalItems}} zapisa</div></div></div><div class=\"row\"><div class=\"col-lg-6\"><a ui-sref=\"radniNalog.create\" type=\"button\" class=\"btn btn-success\"><i class=\"fa fa-plus-square\"></i> Novi zapis</a></div><div class=\"col-lg-6\"><div class=\"pull-right\"><a ui-sref=\"crud.list({entity: 'Komentar'})\" type=\"button\" class=\"btn btn-primary\"><i class=\"fa fa-comments\"></i> Pregled svih komentara</a></div></div></div><hr><div animate-panel><div class=\"hpanel\"><div class=\"panel-heading\"><div class=\"panel-tools\"><a class=\"showhide\"><i class=\"fa fa-chevron-up\"></i></a> <a class=\"closebox\" hidden><i class=\"fa fa-times\"></i></a></div><br></div><div class=\"panel-body\"><div class=\"table-responsive project-list\"><table id=\"no-more-tables\" class=\"table table-striped table-hover\"><thead><tr><th class=\"col-lg-2\">Datum naloga</th><th class=\"col-lg-2 text-center\">Broj naloga</th><th>Pacijent</th><th>Ordinacija</th><th>Akcije</th></tr></thead><tbody><tr ng-repeat=\"item in vm.items\"><td data-title=\"Datum naloga\">{{item.datum_naloga | date: 'dd.MM.yyyy'}}</td><td data-title=\"Broj naloga\" class=\"text-center\"><rn-link rn=\"item\"></rn-link></td><td data-title=\"Pacijent\">{{item.pacijent}},<br><small><i class=\"fa fa-clock-o\"></i> Status: <strong>{{item.status}}</strong></small></td><td data-title=\"Ordinacija\"><strong>{{item.ordinacija_naziv}}</strong></td><td data-title=\"Akcije\"><a ng-click=\"vm.edit(item)\" title=\"Detalji\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-edit\"></i></a></td></tr></tbody></table></div></div><div class=\"panel-footer\"><br></div></div></div></div><footer class=\"footer\"></footer></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _radniNalogDetailsHtml = __webpack_require__(484);
	
	var _radniNalogDetailsHtml2 = _interopRequireDefault(_radniNalogDetailsHtml);
	
	var _sweetalert = __webpack_require__(375);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	var _lightbox2 = __webpack_require__(485);
	
	var _lightbox22 = _interopRequireDefault(_lightbox2);
	
	var _statusiJs = __webpack_require__(435);
	
	var RadniNalogDetailsController = (function () {
	    function RadniNalogDetailsController(DS, AppConfiguration, $uibModal, $q, $timeout, Upload, $cookies, logger, $http) {
	        _classCallCheck(this, RadniNalogDetailsController);
	
	        this.icon = false;
	        this.$uibModal = $uibModal;
	        this.$q = $q;
	        this.$timeout = $timeout;
	        this.logger = logger;
	        this.pageTitle = 'Radni nalog:' || false;
	        this.pageDesc = 'Podaci o radnom nalogu';
	        this.datastore = function () {
	            return DS;
	        };
	        this.fazeListView = AppConfiguration().getViewByEntityAndType('FazaNaloga', 'ListView');
	        this.fazeEditView = AppConfiguration().getViewByEntityAndType('FazaNaloga', 'EditView');
	        this.stavkeListView = AppConfiguration().getViewByEntityAndType('StavkaNaloga', 'ListView');
	        this.upload = function () {
	            return Upload;
	        };
	        this.$cookies = function () {
	            return $cookies;
	        };
	        this.$http = function () {
	            return $http;
	        };
	    }
	
	    _createClass(RadniNalogDetailsController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.uploading = false;
	            this.otvoren = _statusiJs.OTVOREN;
	            this.uobradi = _statusiJs.UOBRADI;
	            this.zakljucan = _statusiJs.ZAKLJUCAN;
	            this.storniran = _statusiJs.STORNIRAN;
	            this.progress = 0;
	            this.refreshState();
	            // this.uploader.onBeforeUploadItem = (item) => {
	            //      item.formData.push({radni_nalog: this.item.id});
	            // };
	            // this.uploader.bind('beforeupload', (event, item) => {
	            //     item.formData.push({radni_nalog: this.item.id});
	            // });
	        }
	    }, {
	        key: 'uploadDocument',
	        value: function uploadDocument(file) {
	            var _this = this;
	
	            var $cookies = this.$cookies();
	            var uploader = this.upload();
	            if (file) {
	                this.uploading = true;
	                uploader.upload({
	                    url: '/api/radni_nalozi/dokumentNaloga',
	                    headers: {
	                        'X-CSRFToken': $cookies.get('csrftoken')
	                    },
	                    data: {
	                        dokument: file,
	                        radni_nalog: this.item.id
	                    }
	                }).then(function (response) {
	                    _this.uploading = false;
	                    _this.refreshState();
	                }, function (error) {
	                    _this.uploading = false;
	                    _this.logger.error('Oupss...', error.data);
	                }, function (evt) {
	                    _this.progress = parseInt(100.0 * evt.loaded / evt.total);
	                });
	            }
	        }
	    }, {
	        key: 'deleteImage',
	        value: function deleteImage(item) {
	            var _this2 = this;
	
	            var DS = this.datastore();
	            var previousWindowKeyDown = window.onkeydown;
	            (0, _sweetalert2['default'])({
	                title: 'Brisanje slike',
	                text: 'Za potvrdu brisanja upišite \'da\'',
	                type: 'input',
	                showCancelButton: true,
	                closeOnConfirm: false
	            }, function (inputValue) {
	                window.onkeydown = previousWindowKeyDown;
	                if (inputValue === false) return false;
	                if (inputValue === 'da') {
	                    DS.destroy('DokumentNaloga', item.id).then(function (data) {
	                        _this2.refreshState();
	                        (0, _sweetalert2['default'])('Slika obrisana', '', 'success');
	                        _this2.refreshState();
	                    }, function (error) {
	                        _this2.logger.error('Oops...', error.data);
	                    });
	                    return true;
	                }
	                _sweetalert2['default'].showInputError('Nedozvoljena vrijednost');
	                return false;
	            });
	        }
	    }, {
	        key: 'refreshState',
	        value: function refreshState() {
	            var _this3 = this;
	
	            var DS = this.datastore();
	            DS.find('RadniNalog', this.id, { bypassCache: true }).then(function (radniNalog) {
	                _this3.item = radniNalog;
	                _this3.pageTitle = 'Radni nalog: ' + _this3.item.sifra_naloga;
	                _this3.pageDesc = '<i class="fa fa-check-square-o"></i> Status: ' + _this3.item.status;
	            }).then(function () {
	                _this3.resolveReferences().then(function () {
	                    return _this3.getFaze();
	                }).then(function (response) {
	                    _this3.faze = response;
	                    return _this3.getStavke();
	                }).then(function (response) {
	                    _this3.stavke = response;
	                    _this3.groupStavke();
	                    return _this3.getDokumente();
	                }).then(function (dokumenti) {
	                    _this3.dokumenti = [];
	                    for (var i = 0, j = dokumenti.length; i < j; i = i + 3) {
	                        _this3.dokumenti.push(dokumenti.splice(0, 3));
	                    }
	                });
	            });
	        }
	    }, {
	        key: 'getFaze',
	        value: function getFaze() {
	            var DS = this.datastore();
	            return DS.findAll('FazaNaloga', { radni_nalog: this.item.id }, { bypassCache: true });
	        }
	    }, {
	        key: 'getStavke',
	        value: function getStavke() {
	            var DS = this.datastore();
	            return DS.findAll('StavkaNaloga', { radni_nalog: this.item.id }, { bypassCache: true });
	        }
	    }, {
	        key: 'getDokumente',
	        value: function getDokumente() {
	            var DS = this.datastore();
	            return DS.findAll('DokumentNaloga', { radni_nalog: this.item.id }, { bypassCache: true });
	        }
	    }, {
	        key: 'groupStavke',
	        value: function groupStavke() {
	            // grupiraj stavke naloga po protetskom radu
	            // {
	            //     "protetski_rad": 21,
	            //     "pozicije": [
	            //            12,
	            //            22,
	            //            18
	            //     ],
	            //     cjenik: 1
	            // },
	
	            var DS = this.datastore();
	            var StavkaNaloga = DS.definitions['StavkaNaloga'].createInstance();
	            this.groupedStavke = StavkaNaloga.group(this.stavke);
	        }
	    }, {
	        key: 'doPozicije',
	        value: function doPozicije() {
	            var _this4 = this;
	
	            var modal = this.$uibModal.open({
	                component: 'odabirPozicijaForm',
	                size: 'lg',
	                resolve: {
	                    item: function item() {
	                        return {};
	                    }
	                }
	            });
	
	            modal.result.then(function (pozicije) {
	                _this4.$timeout(function () {
	                    _this4.insertStavku(pozicije);
	                }, 500);
	            });
	        }
	    }, {
	        key: 'insertStavku',
	        value: function insertStavku(pozicije) {
	            var _this5 = this;
	
	            var DS = this.datastore();
	            var model = {
	                radni_nalog: this.item.id
	            };
	
	            if (pozicije.length === 1) {
	                model.pozicija = pozicije[0].broj;
	            }
	            var stavkaForm = this.$uibModal.open({
	                component: 'stavkaNalogaForm',
	                size: 'lg-extra',
	                resolve: {
	                    item: function item() {
	                        return model;
	                    }
	                }
	            });
	
	            stavkaForm.result.then(function (model) {
	                var promises = [];
	
	                if (pozicije.length > 0) {
	                    _.forEach(pozicije, function (pozicija) {
	                        var clone = _.cloneDeep(model);
	                        clone.pozicija = pozicija.broj;
	                        promises.push(DS.create('StavkaNaloga', clone));
	                    });
	                } else {
	                    promises.push(DS.create('StavkaNaloga', model));
	                }
	
	                _this5.$q.all(promises).then(function () {
	                    _this5.refreshState();
	                })['catch'](function (error) {
	                    _this5.logger.error('Oops...', error.data);
	                });
	            });
	        }
	    }, {
	        key: 'editStavku',
	        value: function editStavku(item) {
	            var _this6 = this;
	
	            var DS = this.datastore();
	            var model = item;
	            var modal = this.$uibModal.open({
	                component: 'stavkaNalogaForm',
	                size: 'lg',
	                resolve: {
	                    item: function item() {
	                        return model;
	                    }
	                }
	            });
	
	            modal.result.then(function (model) {
	                DS.update('StavkaNaloga', model.id, model).then(function () {
	                    _this6.refreshState();
	                });
	            });
	        }
	    }, {
	        key: 'resolveReferences',
	        value: function resolveReferences() {
	            var models = [];
	            var datastore = this.datastore();
	
	            _.forOwn(this.fazeListView.getReferences(), function (value, key) {
	                models.push(datastore.definitions[value.targetEntity().name()]);
	            });
	
	            _.forOwn(this.stavkeListView.getReferences(), function (value, key) {
	                models.push(datastore.definitions[value.targetEntity().name()]);
	            });
	
	            return this.$q.all(models.map(function (m) {
	                return m.findAll();
	            }));
	        }
	    }, {
	        key: 'editFazu',
	        value: function editFazu(item) {
	            var _this7 = this;
	
	            var DS = this.datastore();
	            var model = item;
	            var _view = this.fazeEditView;
	            var modal = this.$uibModal.open({
	                component: 'modalForm',
	                size: 'lg',
	                resolve: {
	                    item: function item() {
	                        return model;
	                    },
	                    view: function view() {
	                        return _view;
	                    },
	                    formClass: function formClass() {
	                        return 'standard';
	                    }
	                }
	            });
	
	            modal.result.then(function (model) {
	                DS.update('FazaNaloga', model.id, model).then(function () {
	                    _this7.refreshState();
	                })['catch'](function (error) {
	                    _this7.logger.error('Oupss...', error.data);
	                });
	            });
	        }
	    }, {
	        key: 'deleteFazu',
	        value: function deleteFazu(item) {
	            var _this8 = this;
	
	            var DS = this.datastore();
	            var previousWindowKeyDown = window.onkeydown;
	            (0, _sweetalert2['default'])({
	                title: 'Brisanje probe',
	                text: 'Za potvrdu brisanja upišite \'da\'',
	                type: 'input',
	                showCancelButton: true,
	                closeOnConfirm: false
	            }, function (inputValue) {
	                window.onkeydown = previousWindowKeyDown;
	                if (inputValue === false) return false;
	                if (inputValue === 'da') {
	                    DS.destroy('FazaNaloga', item.id).then(function (data) {
	                        _this8.refreshState();
	                        (0, _sweetalert2['default'])('Proba obrisana', '', 'success');
	                    }, function (error) {
	                        _this8.logger.error('Oops...', error.data);
	                    });
	                    return true;
	                }
	                _sweetalert2['default'].showInputError('Nedozvoljena vrijednost');
	                return false;
	            });
	        }
	    }, {
	        key: 'insertFazu',
	        value: function insertFazu() {
	            var _this9 = this;
	
	            var DS = this.datastore();
	            var model = {
	                radni_nalog: this.item.id
	            };
	            var _view2 = this.fazeEditView;
	            var modal = this.$uibModal.open({
	                component: 'modalForm',
	                size: 'lg',
	                resolve: {
	                    item: function item() {
	                        return model;
	                    },
	                    view: function view() {
	                        return _view2;
	                    },
	                    formClass: function formClass() {
	                        return 'standard';
	                    }
	                }
	            });
	
	            modal.result.then(function (model) {
	                DS.create('FazaNaloga', model).then(function () {
	                    _this9.refreshState();
	                })['catch'](function (error) {
	                    _this9.logger.error('Oupss...', error.data);
	                });
	            });
	        }
	    }, {
	        key: 'setStatus',
	        value: function setStatus(status) {
	            var _this10 = this;
	
	            var $http = this.$http();
	            var previousWindowKeyDown = window.onkeydown;
	            $http.put('/api/radni_nalozi/radniNalozi/' + this.item.id + '/postavi_status', { status: status }).then(function (response) {
	                (0, _sweetalert2['default'])({
	                    title: 'Zahvaljujemo',
	                    text: 'Podaci su uspješno ažurirani',
	                    type: 'success',
	                    closeOnConfirme: true
	                }, function () {
	                    window.onkeydown = previousWindowKeyDown;
	                    _this10.refreshState();
	                });
	            }, function (error) {
	                _this10.logger.error('Oupss...', error.data);
	            });
	        }
	    }]);
	
	    return RadniNalogDetailsController;
	})();
	
	RadniNalogDetailsController.$inject = ['DS', 'AppConfiguration', '$uibModal', '$q', '$timeout', 'Upload', '$cookies', 'logger', '$http'];
	
	var RadniNalogDetailsComponent = {
	    restrict: 'E',
	    templateUrl: _radniNalogDetailsHtml2['default'],
	    controller: RadniNalogDetailsController,
	    controllerAs: 'vm',
	    bindings: {
	        id: '<'
	    }
	};
	
	exports.RadniNalogDetailsComponent = RadniNalogDetailsComponent;
	exports.RadniNalogDetailsController = RadniNalogDetailsController;

/***/ },
/* 484 */
/***/ function(module, exports) {

	var path = 'app/components/radniNalog/radniNalogDetails.html';
	var html = "<header id=\"header\"></header><navbar id=\"menu\"></navbar><div id=\"wrapper\"><page-header icon=\"vm.icon\" page-title=\"vm.pageTitle\" page-desc=\"vm.pageDesc\"></page-header><div class=\"content\" animate-panel effect=\"zoomIn\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"btn-group\"><button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">Akcije&nbsp; <span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-left\"><li><a ui-sref=\"radniNalog.details.edit({id: vm.item.id})\"><i class=\"fa fa-edit\"></i> Izmjeni</a></li><li class=\"divider\"></li><li><a ng-click=\"vm.setStatus(vm.otvoren)\"><i class=\"fa\" ng-class=\"{'fa-square-o': vm.item.status !== vm.otvoren, 'fa-check-square-o': vm.item.status === vm.otvoren}\" aria-hidden=\"true\"></i> Otvoren</a> <a ng-click=\"vm.setStatus(vm.uobradi)\"><i class=\"fa\" ng-class=\"{'fa-square-o': vm.item.status !== vm.uobradi, 'fa-check-square-o': vm.item.status === vm.uobradi}\" aria-hidden=\"true\"></i> U obradi</a> <a ng-click=\"vm.setStatus(vm.zakljucan)\"><i class=\"fa\" ng-class=\"{'fa-square-o': vm.item.status !== vm.zakljucan, 'fa-check-square-o': vm.item.status === vm.zakljucan}\" aria-hidden=\"true\"></i> Zaključan</a> <a ng-click=\"vm.setStatus(vm.storniran)\"><i class=\"fa\" ng-class=\"{'fa-square-o': vm.item.status !== vm.storniran, 'fa-check-square-o': vm.item.status === vm.storniran}\" aria-hidden=\"true\"></i> Storniran</a></li></ul></div><a ng-href=\"api/radni_nalozi/radniNalozi/{{vm.item.id}}/ispis\" target=\"_blank\" class=\"btn btn-primary btn-sm pull-right\"><i class=\"fa fa-print\"></i> Ispis naloga</a></div></div><div class=\"row\"><div class=\"col-lg-6\"><div class=\"hpanel stats\"><div class=\"panel-heading\"></div><div class=\"panel-body list\"><div class=\"pull-right\"><i class=\"fa fa-file-text-o fa-3x\"></i></div><div class=\"panel-title\">RADNI NALOG</div><small class=\"fo\">Osnovni podaci</small><hr><table id=\"user\" class=\"table table-bordered table-striped\" style=\"clear: both\"><tbody><tr><td width=\"35%\">Ordinacija dentalne medicine</td><td width=\"65%\"><a ui-sref=\"ordinacija.details({id: vm.item.ordinacija})\"><b>{{vm.item.ordinacija_naziv}}</b></a></td></tr><tr><td width=\"35%\">Datum naloga</td><td width=\"65%\"><b>{{vm.item.datum_naloga | date:'dd.MM.yyyy'}}</b></td></tr><tr><td width=\"35%\">Boja</td><td width=\"65%\"><b>{{vm.item.boja}} ({{vm.item.oznaka_boje}})</b></td></tr><tr><td width=\"35%\">Oblik</td><td width=\"65%\"><b>{{vm.item.oblik}}</b></td></tr><tr><td width=\"35%\">Napomena</td><td width=\"65%\"><small>{{vm.item.napomena}}</small></td></tr></tbody></table><small class=\"fo\">Podaci o pacijentu</small><hr><table id=\"user\" class=\"table table-bordered table-striped\" style=\"clear: both\"><tbody><tr><td width=\"35%\">Ime i prezime</td><td width=\"65%\"><b>{{vm.item.pacijent}}</b></td></tr><tr><td width=\"35%\">Spol</td><td width=\"65%\"><b>{{vm.item.spol}}</b></td></tr><tr><td width=\"35%\">Godina rođenja</td><td width=\"65%\"><b>{{vm.item.godina_rodjenja}}</b></td></tr></tbody></table><small class=\"fo\">Podaci - pozicije radnog naloga</small><div class=\"pull-right\"><a type=\"button\" class=\"btn btn-xs btn-success\" ui-sref=\"radniNalog.details.planRada({id: vm.item.id})\"><i class=\"fa fa-plus-square\"></i> Plan rada</a></div><hr><div class=\"table-responsive m-t\"><in-data-grid fields=\"vm.stavkeListView.fields()\" entries=\"vm.groupedStavke\" entity=\"vm.stavkeListView.entity\" datastore=\"vm.datastore()\"></in-data-grid></div></div></div><div>&nbsp;<i class=\"fa fa-clock-o\"></i>&nbsp;<small>Kreirano: {{vm.item.created_at | date: 'dd.MM.yyyy HH:mm'}}</small></div><div>&nbsp;<i class=\"fa fa-clock-o\"></i>&nbsp;<small>Datum zadnje promjene: {{vm.item.last_modified | date: 'dd.MM.yyyy HH:mm'}}</small></div></div><div class=\"col-lg-6\"><div class=\"hpanel\"><div class=\"panel-heading\"></div><div class=\"panel-body list\"><div class=\"panel-title\">FAZE RADNOG NALOGA</div><small class=\"fo\">Probe rada</small><div class=\"pull-right\"><button type=\"button\" class=\"btn btn-xs btn-success\" ng-click=\"vm.insertFazu()\"><i class=\"fa fa-plus-square\"></i> Nova faza</button></div><hr><div class=\"table-responsive project-list\"><table id=\"no-more-tables\" class=\"table table-striped table-hover\"><thead><tr><th class=\"col-lg-2\">Datum probe</th><th class=\"col-lg-2\">Termin</th><th>Tehničar</th><th>Napomena</th><th class=\"col-lg-2 text-center\">Akcije</th></tr></thead><tbody><tr ng-repeat=\"item in vm.faze\"><td data-title=\"Datum probe\">{{item.datum_probe | date: 'dd.MM.yyyy'}}</td><td data-title=\"Termin\"><i class=\"fa fa-clock-o\"></i> {{item.termin_probe}}</td><td data-title=\"Tehničar\"><small>{{item.tehnicar_naziv}}&nbsp;</small></td><td data-title=\"Napomena\"><small>{{item.napomena}}&nbsp;</small></td><td data-title=\"Akcije\" class=\"text-center\"><section ng-if=\"item.broj_probe !== -1\"><a ng-click=\"vm.editFazu(item)\" class=\"btn btn-xs btn-success\" type=\"button\"><i class=\"fa fa-edit\"></i></a> <a ng-click=\"vm.deleteFazu(item)\" class=\"btn btn-xs btn-danger\" type=\"button\"><i class=\"fa fa-remove\"></i></a></section></td></tr></tbody></table></div></div></div><div class=\"hpanel\"><div class=\"panel-heading\"></div><div class=\"panel-body list\"><div class=\"row\"><div class=\"col-lg-6 animated-panel zoomIn\" style=\"animation-delay: 0.3s;\"><div class=\"panel-title\">DOKUMENTI</div><small class=\"fo\">Priloženi dokumenti</small></div><div class=\"col-lg-6 text-right animated-panel zoomIn\" style=\"animation-delay: 0.4s;\"><div class=\"input-group\"><label class=\"input-group-btn\"><button class=\"btn btn-primary btn-xs ng-pristine ng-untouched ng-empty ng-invalid ng-invalid-required\" ngf-select=\"vm.uploadDocument(vm.docFile)\" ng-model=\"vm.docFile\" name=\"file\" required ngf-model-invalid=\"errorFile\"><i class=\"fa fa-file\"></i> Upload dokumenta</button></label></div></div></div><hr><div class=\"row lightBoxGallery\"><div class=\"row\" ng-repeat=\"row in vm.dokumenti\"><div class=\"col-sm-4\" ng-repeat=\"item in row\"><a ng-href=\"/api/radni_nalozi/dokumentNaloga/{{item.id}}/download\" data-lightbox=\"roadtrip\"><img class=\"img-responsive\" ng-src=\"/api/radni_nalozi/dokumentNaloga/{{item.id}}/thumbnail\"></a> <button type=\"button\" ng-click=\"vm.deleteImage(item)\" class=\"close\" aria-label=\"Close\" uib-tooltip=\"Ukloni sliku\" tooltip-placement=\"right\"><span aria-hidden=\"true\">×</span></button></div></div><div class=\"col-sm-4\" ng-if=\"vm.uploading\"><loading is-loading=\"vm.uploading\" message=\"Pričekajte dok se dokument upload-a\"></loading><span>{{vm.progress}}%</span></div></div></div></div><div class=\"hpanel\"><div class=\"panel-heading\"></div><div class=\"panel-body list\"><div class=\"row\"><div class=\"col-lg-6\"><div class=\"panel-title\">Komentari</div></div></div><hr><div class=\"row\"><div class=\"col-lg-12\"><komentari id=\"vm.id\"></komentari></div></div></div></div></div></div></div><footer class=\"footer\"></footer></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 485 */,
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _lodash = __webpack_require__(165);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _planRadaHtml = __webpack_require__(487);
	
	var _planRadaHtml2 = _interopRequireDefault(_planRadaHtml);
	
	var PlanRadaController = (function () {
	    function PlanRadaController(DS, AppConfiguration, $q, $uibModal, $state, logger) {
	        _classCallCheck(this, PlanRadaController);
	
	        this.datastore = function () {
	            return DS;
	        };
	        this.$q = function () {
	            return $q;
	        };
	        this.$uibModal = function () {
	            return $uibModal;
	        };
	        this.$state = function () {
	            return $state;
	        };
	        this.logger = function () {
	            return logger;
	        };
	        this.view = AppConfiguration().getViewByEntityAndType('StavkaNaloga', 'ListView');
	        this.pageTitle = 'Plan rada';
	    }
	
	    _createClass(PlanRadaController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            var DS = this.datastore();
	            DS.find('RadniNalog', this.id, { bypassCache: true }).then(function (radniNalog) {
	                _this.item = radniNalog;
	                _this.pageTitle = 'Plan rada: ' + radniNalog.pacijent;
	                _this.refreshState();
	            });
	        }
	    }, {
	        key: 'refreshState',
	        value: function refreshState() {
	            var _this2 = this;
	
	            var DS = this.datastore();
	            var $q = this.$q();
	            this.nalog = this.item;
	            this.stavke = _lodash2['default'].cloneDeep(this.nalog.stavke);
	            this.veze = _lodash2['default'].cloneDeep(this.nalog.veze);
	
	            this.pozicije = [];
	            this.stavke.forEach(function (stavka) {
	                _this2.pozicije.push({ broj: stavka.pozicija, selected: true, veza: false });
	            });
	            this.veze.forEach(function (veza) {
	                _this2.pozicije.push({ broj: veza.pozicija, selected: true, veza: true });
	            });
	
	            $q.all([DS.findAll('ProtetskiRad'), DS.findAll('Cjenik')]).then(function (response) {
	                _this2.groupStavke(_this2.stavke);
	            });
	        }
	    }, {
	        key: 'copyStavke',
	        value: function copyStavke(from, to) {
	            var _this3 = this;
	
	            if (from && from.selected && from.broj !== to.broj && !to.veza && !from.veza) {
	                var stavke = _lodash2['default'].filter(this.stavke, { pozicija: from.broj });
	                var clones = _lodash2['default'].cloneDeep(stavke);
	                _lodash2['default'].forEach(clones, function (clone) {
	                    // debugger;
	                    clone.pozicija = to.broj;
	                    _this3.stavke.push(clone);
	                    _this3.pozicije.push(Object.assign({}, to, { selected: true }));
	                });
	
	                this.groupStavke(this.stavke);
	            }
	        }
	    }, {
	        key: 'groupStavke',
	        value: function groupStavke(stavke) {
	            // grupiraj stavke naloga po protetskom radu
	            // {
	            //     "protetski_rad": 21,
	            //     "pozicije": [
	            //            12,
	            //            22,
	            //            18
	            //     ],
	            //     cjenik: 1
	            // },
	            var DS = this.datastore();
	            var StavkaNaloga = DS.definitions['StavkaNaloga'].createInstance();
	            this.groupedStavke = StavkaNaloga.group(stavke);
	        }
	    }, {
	        key: 'pozicijaClicked',
	        value: function pozicijaClicked(pozicija) {
	            var _this4 = this;
	
	            if (_lodash2['default'].isObject(pozicija) && !pozicija.veza) {
	                this.insertStavkuNaloga(pozicija).then(function () {
	                    _this4.pozicije.push(Object.assign({}, pozicija, { selected: true }));
	                });
	            } else {
	                (function () {
	                    // ako je veza već odbrana makni je iz liste,
	                    // ako nije stavie je u listu odabranih veza
	                    var veza = _lodash2['default'].find(_this4.veze, function (item) {
	                        return item.pozicija === pozicija.broj;
	                    });
	
	                    if (veza) {
	                        _this4.pozicije = _lodash2['default'].filter(_this4.pozicije, function (item) {
	                            return item.broj !== veza.pozicija;
	                        });
	                        _this4.removeVezuNaloga(veza);
	                    } else {
	                        _this4.pozicije.push(Object.assign({}, pozicija, { selected: !pozicija.selected }));
	                        _this4.insertVezuNaloga(pozicija);
	                    }
	                })();
	            }
	        }
	    }, {
	        key: 'insertVezuNaloga',
	        value: function insertVezuNaloga(pozicija) {
	            this.veze.push({ pozicija: pozicija.broj });
	        }
	    }, {
	        key: 'insertStavkuNaloga',
	        value: function insertStavkuNaloga(pozicija) {
	            var _this5 = this;
	
	            var $uibModal = this.$uibModal();
	            var model = {};
	
	            if (_lodash2['default'].isObject(pozicija)) {
	                model.pozicija = pozicija.broj;
	            }
	
	            var modal = $uibModal.open({
	                component: 'stavkaNalogaForm',
	                size: 'lg-extra',
	                // windowClass: 'modal-lg-extra',
	                resolve: {
	                    item: function item() {
	                        return model;
	                    }
	                }
	            });
	
	            return modal.result.then(function (model) {
	                _this5.stavke.push(model);
	                _this5.groupStavke(_this5.stavke);
	            });
	        }
	    }, {
	        key: 'removeStavkuNaloga',
	        value: function removeStavkuNaloga(item) {
	            var _this6 = this;
	
	            _lodash2['default'].remove(this.stavke, function (stavka) {
	                return stavka.protetski_rad === item.protetski_rad && stavka.cjenik === item.cjenik;
	            });
	
	            item.pozicije.forEach(function (pozicija) {
	                var poz = _lodash2['default'].findIndex(_this6.pozicije, function (i) {
	                    return i.broj === pozicija;
	                });
	
	                if (poz !== -1) {
	                    _this6.pozicije.splice(poz, 1);
	                }
	            });
	            this.groupStavke(this.stavke);
	        }
	    }, {
	        key: 'removeVezuNaloga',
	        value: function removeVezuNaloga(item) {
	            _lodash2['default'].remove(this.veze, function (veza) {
	                return veza.pozicija === item.pozicija;
	            });
	        }
	    }, {
	        key: 'submit',
	        value: function submit() {
	            var _this7 = this;
	
	            // this.onSubmit({stavke: this.stavke, veze: this.veze});
	            var DS = this.datastore();
	            var $state = this.$state();
	            var logger = this.logger();
	            DS.update('PlanRada', this.item.id, { stavke: this.stavke, veze: this.veze }).then(function (response) {
	                _this7.item.stavke = response.stavke;
	                _this7.item.veze = response.veze;
	                $state.go('radniNalog.details', { id: _this7.item.id });
	            })['catch'](function (error) {
	                logger.error('Oupss....', error.data);
	            });
	        }
	    }]);
	
	    return PlanRadaController;
	})();
	
	PlanRadaController.$inject = ['DS', 'AppConfiguration', '$q', '$uibModal', '$state', 'logger'];
	
	var PlanRadaComponent = {
	    restrict: 'E',
	    templateUrl: _planRadaHtml2['default'],
	    controller: PlanRadaController,
	    controllerAs: 'vm',
	    bindings: {
	        id: '<'
	    }
	};
	
	exports.PlanRadaComponent = PlanRadaComponent;
	exports.PlanRadaController = PlanRadaController;

/***/ },
/* 487 */
/***/ function(module, exports) {

	var path = 'app/components/radniNalog/planRada.html';
	var html = "<header id=\"header\"></header><navbar id=\"menu\"></navbar><div id=\"wrapper\"><page-header icon=\"vm.icon\" page-title=\"vm.pageTitle\" page-desc=\"vm.pageDesc\"></page-header><div class=\"content\"><div class=\"hpanel\"><div class=\"panel-body\"><div ui-view animate-panel><div class=\"row\"><div class=\"col-lg-12\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"hpanel\"><div class=\"panel-body text-right\"><kvadrant on-drop=\"vm.copyStavke(from, to)\" pozicija-clicked=\"vm.pozicijaClicked(pozicija)\" kvadrant=\"1\" stavke=\"vm.pozicije\"></kvadrant></div></div></div><div class=\"col-lg-12\"><div class=\"hpanel\"><div class=\"panel-body\"><kvadrant on-drop=\"vm.copyStavke(from, to)\" pozicija-clicked=\"vm.pozicijaClicked(pozicija)\" kvadrant=\"2\" stavke=\"vm.pozicije\"></kvadrant></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-8\"><div class=\"hpanel\"><div class=\"panel-heading hbuilt\"><div class=\"pull-right\"><button type=\"button\" class=\"btn btn-xs btn-success\" ng-click=\"vm.insertStavkuNaloga()\"><i class=\"fa fa-plus-square\"></i> Nova stavka</button></div><h4>Naručene pozicije</h4></div><div class=\"panel-body\"><div class=\"table-responsive\"><in-data-grid fields=\"vm.view.fields()\" entries=\"vm.groupedStavke\" entity=\"vm.view.entity\" datastore=\"vm.datastore()\" actions=\"vm.view.listActions()\" on-delete=\"vm.removeStavkuNaloga(item)\"></in-data-grid></div></div></div></div><div class=\"col-lg-4\" ng-if=\"vm.item.napomena\"><div class=\"well well-lg\"><h5 class=\"font-bold\">Napomena</h5><hr><span>{{vm.item.napomena}}</span></div></div></div><div class=\"row\"></div></div><div class=\"text-right m-t-xs\"><a class=\"btn btn-default\" ui-sref=\"radniNalog.details({id: vm.nalog.id})\">Povratak</a> <a class=\"btn btn-success\" ng-click=\"vm.submit()\">Potvrdi</a></div></div></div></div><footer class=\"footer\"></footer></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _lodash = __webpack_require__(165);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _shemaHtml = __webpack_require__(489);
	
	var _shemaHtml2 = _interopRequireDefault(_shemaHtml);
	
	var ShemaController = (function () {
	    function ShemaController() {
	        _classCallCheck(this, ShemaController);
	    }
	
	    _createClass(ShemaController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            this.pozicije = [];
	            this.veze = [];
	            this.nalog.stavke.forEach(function (stavka) {
	                _this.pozicije.push({ broj: stavka.pozicija, selected: true, veza: false });
	            });
	            this.nalog.veze.forEach(function (veza) {
	                var pozicija = veza.pozicija.toString();
	                _this.veze.push({ broj: parseInt(pozicija.slice(0, 2)), selected: true, veza: true });
	                _this.veze.push({ broj: parseInt(pozicija.slice(2, 4)), selected: true, veza: true });
	            });
	        }
	    }, {
	        key: 'pozSelected',
	        value: function pozSelected(poz) {
	            return _lodash2['default'].filter(this.pozicije, function (item) {
	                return item.broj === poz;
	            }).length > 0;
	        }
	    }, {
	        key: 'vezaSelected',
	        value: function vezaSelected(poz) {
	            return _lodash2['default'].filter(this.veze, function (item) {
	                return item.broj === poz;
	            }).length > 0;
	        }
	    }]);
	
	    return ShemaController;
	})();
	
	ShemaController.$inject = [];
	
	var ShemaComponent = {
	    restrict: 'E',
	    templateUrl: _shemaHtml2['default'],
	    controller: ShemaController,
	    controllerAs: 'vm',
	    bindings: {
	        nalog: '<'
	    }
	};
	
	exports.ShemaComponent = ShemaComponent;
	exports.ShemaController = ShemaController;

/***/ },
/* 489 */
/***/ function(module, exports) {

	var path = 'app/components/radniNalog/shema.html';
	var html = "<table><tr><td ng-class=\"{'circle': vm.pozSelected(18), 'selected': vm.vezaSelected(18)}\">8</td><td ng-class=\"{'circle': vm.pozSelected(17), 'selected': vm.vezaSelected(17)}\">7</td><td ng-class=\"{'circle': vm.pozSelected(16), 'selected': vm.vezaSelected(16)}\">6</td><td ng-class=\"{'circle': vm.pozSelected(15), 'selected': vm.vezaSelected(15)}\">5</td><td ng-class=\"{'circle': vm.pozSelected(14), 'selected': vm.vezaSelected(14)}\">4</td><td ng-class=\"{'circle': vm.pozSelected(13), 'selected': vm.vezaSelected(13)}\">3</td><td ng-class=\"{'circle': vm.pozSelected(12), 'selected': vm.vezaSelected(12)}\">2</td><td ng-class=\"{'circle': vm.pozSelected(11), 'selected': vm.vezaSelected(11)}\">1</td><td ng-class=\"{'circle': vm.pozSelected(21), 'selected': vm.vezaSelected(21)}\">1</td><td ng-class=\"{'circle': vm.pozSelected(22), 'selected': vm.vezaSelected(22)}\">2</td><td ng-class=\"{'circle': vm.pozSelected(23), 'selected': vm.vezaSelected(23)}\">3</td><td ng-class=\"{'circle': vm.pozSelected(24), 'selected': vm.vezaSelected(24)}\">4</td><td ng-class=\"{'circle': vm.pozSelected(25), 'selected': vm.vezaSelected(25)}\">5</td><td ng-class=\"{'circle': vm.pozSelected(26), 'selected': vm.vezaSelected(26)}\">6</td><td ng-class=\"{'circle': vm.pozSelected(27), 'selected': vm.vezaSelected(27)}\">7</td><td ng-class=\"{'circle': vm.pozSelected(28), 'selected': vm.vezaSelected(28)}\">8</td></tr><tr><td ng-class=\"{'circle': vm.pozSelected(48), 'selected': vm.vezaSelected(48)}\">8</td><td ng-class=\"{'circle': vm.pozSelected(47), 'selected': vm.vezaSelected(47)}\">7</td><td ng-class=\"{'circle': vm.pozSelected(46), 'selected': vm.vezaSelected(46)}\">6</td><td ng-class=\"{'circle': vm.pozSelected(45), 'selected': vm.vezaSelected(45)}\">5</td><td ng-class=\"{'circle': vm.pozSelected(44), 'selected': vm.vezaSelected(44)}\">4</td><td ng-class=\"{'circle': vm.pozSelected(43), 'selected': vm.vezaSelected(43)}\">3</td><td ng-class=\"{'circle': vm.pozSelected(42), 'selected': vm.vezaSelected(42)}\">2</td><td ng-class=\"{'circle': vm.pozSelected(41), 'selected': vm.vezaSelected(41)}\">1</td><td ng-class=\"{'circle': vm.pozSelected(31), 'selected': vm.vezaSelected(31)}\">1</td><td ng-class=\"{'circle': vm.pozSelected(32), 'selected': vm.vezaSelected(32)}\">2</td><td ng-class=\"{'circle': vm.pozSelected(33), 'selected': vm.vezaSelected(33)}\">3</td><td ng-class=\"{'circle': vm.pozSelected(34), 'selected': vm.vezaSelected(34)}\">4</td><td ng-class=\"{'circle': vm.pozSelected(35), 'selected': vm.vezaSelected(35)}\">5</td><td ng-class=\"{'circle': vm.pozSelected(36), 'selected': vm.vezaSelected(36)}\">6</td><td ng-class=\"{'circle': vm.pozSelected(37), 'selected': vm.vezaSelected(37)}\">7</td><td ng-class=\"{'circle': vm.pozSelected(38), 'selected': vm.vezaSelected(38)}\">8</td></tr></table>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _radniNalogCreateHtml = __webpack_require__(491);
	
	var _radniNalogCreateHtml2 = _interopRequireDefault(_radniNalogCreateHtml);
	
	var _moment = __webpack_require__(216);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var RadniNalogCreateController = (function () {
	    function RadniNalogCreateController(DS, AppConfiguration, $state, logger) {
	        _classCallCheck(this, RadniNalogCreateController);
	
	        this.Model = DS.definitions['RadniNalog'];
	        this.view = AppConfiguration().getViewByEntityAndType('RadniNalog', 'CreateView');
	        this.$state = $state;
	        this.logger = logger;
	    }
	
	    _createClass(RadniNalogCreateController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.item = {
	                datum_naloga: (0, _moment2['default'])().format('YYYY-MM-DD')
	            };
	            this.fields = this.view.fields();
	        }
	    }, {
	        key: 'submit',
	        value: function submit(item) {
	            var _this = this;
	
	            this.Model.create(item).then(function (response) {
	                // uploader.url = '/api/radni_nalozi/dokument'
	                _this.$state.go('radniNalog.details', { id: response.id });
	            })['catch'](function (error) {
	                _this.logger.error('Oupss...', error.data);
	            });
	        }
	    }]);
	
	    return RadniNalogCreateController;
	})();
	
	RadniNalogCreateController.$inject = ['DS', 'AppConfiguration', '$state', 'logger'];
	
	var RadniNalogCreateComponent = {
	    restrict: 'E',
	    templateUrl: _radniNalogCreateHtml2['default'],
	    controller: RadniNalogCreateController,
	    controllerAs: 'vm'
	};
	
	exports.RadniNalogCreateComponent = RadniNalogCreateComponent;
	exports.RadniNalogCreateController = RadniNalogCreateController;

/***/ },
/* 491 */
/***/ function(module, exports) {

	var path = 'app/components/radniNalog/radniNalogCreate.html';
	var html = "<header id=\"header\"></header><navbar id=\"menu\"></navbar><div id=\"wrapper\"><div class=\"content\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"hpanel\"><div class=\"panel-heading\"></div><div class=\"panel-body\"><radni-nalog-wizard-form fields=\"vm.fields\" on-submit=\"vm.submit(item)\" item=\"vm.item\"></radni-nalog-wizard-form></div></div></div></div></div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _radniNalogEditHtml = __webpack_require__(493);
	
	var _radniNalogEditHtml2 = _interopRequireDefault(_radniNalogEditHtml);
	
	var _sweetalert = __webpack_require__(375);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	var RadniNalogEditController = (function () {
	    function RadniNalogEditController(DS, AppConfiguration, $state, logger) {
	        _classCallCheck(this, RadniNalogEditController);
	
	        this.$state = $state;
	        this.logger = logger;
	        this.Model = DS.definitions['RadniNalog'];
	        this.view = AppConfiguration().getViewByEntityAndType('RadniNalog', 'EditView');
	    }
	
	    _createClass(RadniNalogEditController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.pageTitle = 'Izmjena radnog naloga ' + this.item.broj_naloga;
	            this.pageDesc = 'Izmjena općih podataka radnog naloga';
	            this.fields = this.view.fields();
	            this.model = Object.assign({}, this.item, { stavke: [], veze: [], faze: [] });
	        }
	    }, {
	        key: 'submit',
	        value: function submit(item) {
	            var _this = this;
	
	            var previousWindowKeyDown = window.onkeydown;
	            this.Model.update(item.id, item).then(function (response) {
	                (0, _sweetalert2['default'])({
	                    title: 'Zahvaljujemo',
	                    text: 'Podaci su uspješno ažurirani',
	                    type: 'success',
	                    closeOnConfirme: true
	                }, function () {
	                    window.onkeydown = previousWindowKeyDown;
	                    _this.$state.go('radniNalog.details', { id: response.id });
	                });
	            })['catch'](function (error) {
	                _this.logger.error('Upsss', error.data);
	            });
	        }
	    }]);
	
	    return RadniNalogEditController;
	})();
	
	RadniNalogEditController.$inject = ['DS', 'AppConfiguration', '$state', 'logger'];
	
	var RadniNalogEditComponent = {
	    restrict: 'E',
	    templateUrl: _radniNalogEditHtml2['default'],
	    controller: RadniNalogEditController,
	    controllerAs: 'vm',
	    bindings: {
	        item: '<'
	    }
	};
	
	exports.RadniNalogEditComponent = RadniNalogEditComponent;
	exports.RadniNalogEditController = RadniNalogEditController;

/***/ },
/* 493 */
/***/ function(module, exports) {

	var path = 'app/components/radniNalog/radniNalogEdit.html';
	var html = "<header id=\"header\"></header><navbar id=\"menu\"></navbar><div id=\"wrapper\"><div class=\"content\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"hpanel\"><div class=\"panel-heading\"></div><div class=\"panel-body\"><form name=\"vm.form\" novalidate ng-submit=\"vm.submit(vm.model)\"><div class=\"row\"><div class=\"col-lg-3 text-center\"><i class=\"pe-7s-credit fa-5x text-muted\"></i><h4>Radni nalog - izmjena</h4></div><div class=\"col-lg-9\"><formly-form model=\"vm.model\" fields=\"vm.fields\" form=\"vm.form\" options=\"vm.options\"></formly-form></div></div><hr><div class=\"text-right m-t-xs\"><a ui-sref=\"radniNalog.details({id: vm.item.id})\" class=\"btn btn-default\">Odustani</a> <a class=\"btn btn-success\" ng-click=\"vm.submit(vm.model)\">Potvrdi</a></div></form></div></div></div></div></div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _lodash = __webpack_require__(165);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _radniNalogWizardFormHtml = __webpack_require__(495);
	
	var _radniNalogWizardFormHtml2 = _interopRequireDefault(_radniNalogWizardFormHtml);
	
	var RadniNalogWizardFormController = (function () {
	    function RadniNalogWizardFormController($uibModal, DS, AppConfiguration, logger, $state) {
	        var _this = this;
	
	        _classCallCheck(this, RadniNalogWizardFormController);
	
	        this.step = 1;
	        this.$uibModal = $uibModal;
	        this.logger = logger;
	        this.$state = $state;
	        DS.findAll('ProtetskiRad').then(function (response) {
	            _this.protetski_rad = response;
	        });
	        this.datastore = function () {
	            return DS;
	        };
	        this.fazeListView = AppConfiguration().getViewByEntityAndType('FazaNaloga', 'ListView');
	        this.stavkeNalogaListView = AppConfiguration().getViewByEntityAndType('StavkaNaloga', 'ListView');
	        this.fazeEditView = AppConfiguration().getViewByEntityAndType('FazaNaloga', 'EditView');
	        this.stavkeCreateView = AppConfiguration().getViewByEntityAndType('StavkaNaloga', 'CreateView');
	    }
	
	    _createClass(RadniNalogWizardFormController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.osnovniPodaciFields = this.fields[0];
	            this.stavkeNalogaFields = this.fields[1];
	            this.napomenaField = this.fields[2];
	            this.model = angular.copy(this.item);
	            this.model.stavke = [];
	            this.model.faze = [];
	            this.model.veze = [];
	            this.pozicije = [];
	            this.groupedStavke = [];
	        }
	    }, {
	        key: 'show',
	        value: function show(step) {
	            this.step = step;
	        }
	    }, {
	        key: 'next',
	        value: function next() {
	            if (this.step < 4) {
	                this.step++;
	            }
	        }
	    }, {
	        key: 'prev',
	        value: function prev() {
	            if (this.step > 1) {
	                this.step--;
	            }
	        }
	    }, {
	        key: 'cancel',
	        value: function cancel() {
	            var _this2 = this;
	
	            var previousWindowKeyDown = window.onkeydown;
	            swal({
	                title: 'Prekid unosa novog radnog naloga',
	                text: 'Želite odustati od unosa novog radnog naloga?',
	                type: 'warning',
	                showCancelButton: true,
	                closeOnConfirme: true
	            }, function () {
	                window.onkeydown = previousWindowKeyDown;
	                _this2.$state.go('dashboard');
	            });
	        }
	    }, {
	        key: 'resolveNazivProtetskogRada',
	        value: function resolveNazivProtetskogRada(stavka) {
	            var item = _lodash2['default'].find(this.protetski_rad, { id: stavka.protetski_rad });
	            if (_lodash2['default'].isUndefined(item)) {
	                return '';
	            }
	            return item.naziv;
	        }
	    }, {
	        key: 'pozicijaClicked',
	        value: function pozicijaClicked(pozicija) {
	            var _this3 = this;
	
	            if (_lodash2['default'].isObject(pozicija) && !pozicija.veza) {
	                this.insertStavkuNaloga(pozicija).then(function () {
	                    _this3.pozicije.push(Object.assign({}, pozicija, { selected: true }));
	                });
	            } else {
	                (function () {
	                    // ako je veza već odbrana makni je iz liste,
	                    // ako nije stavie je u listu odabranih veza
	                    var veza = _lodash2['default'].find(_this3.model.veze, function (item) {
	                        return item.pozicija === pozicija.broj;
	                    });
	
	                    if (veza) {
	                        _this3.pozicije = _lodash2['default'].filter(_this3.pozicije, function (item) {
	                            return item.broj !== veza.pozicija;
	                        });
	                        _this3.removeVezuNaloga(veza);
	                    } else {
	                        _this3.pozicije.push(Object.assign({}, pozicija, { selected: !pozicija.selected }));
	                        _this3.insertVezuNaloga(pozicija);
	                    }
	                })();
	            }
	        }
	    }, {
	        key: 'insertVezuNaloga',
	        value: function insertVezuNaloga(pozicija) {
	            this.model.veze.push({ pozicija: pozicija.broj });
	        }
	    }, {
	        key: 'insertStavkuNaloga',
	        value: function insertStavkuNaloga(pozicija) {
	            var _this4 = this;
	
	            var model = {};
	
	            if (_lodash2['default'].isObject(pozicija)) {
	                model.pozicija = pozicija.broj;
	            }
	
	            var modal = this.$uibModal.open({
	                component: 'stavkaNalogaForm',
	                size: 'lg-extra',
	                // windowClass: 'modal-lg-extra',
	                resolve: {
	                    item: function item() {
	                        return model;
	                    }
	                }
	            });
	
	            return modal.result.then(function (model) {
	                _this4.model.stavke.push(model);
	                _this4.groupStavke();
	            });
	        }
	    }, {
	        key: 'copyStavke',
	        value: function copyStavke(from, to) {
	            var _this5 = this;
	
	            // debugger;
	            if (from && from.selected && from.broj !== to.broj && !to.veza && !from.veza) {
	                // debugger;
	                var stavke = _lodash2['default'].filter(this.model.stavke, { pozicija: from.broj });
	                var clones = _lodash2['default'].cloneDeep(stavke);
	                _lodash2['default'].forEach(clones, function (clone) {
	                    // debugger;
	                    clone.pozicija = to.broj;
	                    _this5.model.stavke.push(clone);
	                    _this5.pozicije.push(Object.assign({}, to, { selected: true }));
	                });
	
	                this.groupStavke();
	            }
	        }
	    }, {
	        key: 'groupStavke',
	        value: function groupStavke() {
	            // grupiraj stavke naloga po protetskom radu
	            // {
	            //     "protetski_rad": 21,
	            //     "pozicije": [
	            //            12,
	            //            22,
	            //            18
	            //     ],
	            //     cjenik: 1
	            // },
	            var DS = this.datastore();
	            var StavkaNaloga = DS.definitions['StavkaNaloga'].createInstance();
	            this.groupedStavke = StavkaNaloga.group(this.model.stavke);
	        }
	    }, {
	        key: 'insertFazu',
	        value: function insertFazu() {
	            var _this6 = this;
	
	            var DS = this.datastore();
	            var model = {
	                radni_nalog: this.item.id
	            };
	            var _view = this.fazeEditView;
	            var modal = this.$uibModal.open({
	                component: 'modalForm',
	                size: 'lg',
	                resolve: {
	                    item: function item() {
	                        return model;
	                    },
	                    view: function view() {
	                        return _view;
	                    },
	                    formClass: function formClass() {
	                        return 'standard';
	                    }
	                }
	            });
	
	            modal.result.then(function (model) {
	                _this6.model.faze.push(model);
	            });
	        }
	    }, {
	        key: 'deleteFazu',
	        value: function deleteFazu(item) {
	            this.model.faze = this.model.faze.filter(function (f) {
	                return f !== item;
	            });
	        }
	    }, {
	        key: 'submit',
	        value: function submit(item) {
	            this.form.$setSubmitted(true);
	            if (this.form.$invalid) {
	                return;
	            }
	            this.onSubmit({ item: item });
	        }
	    }, {
	        key: 'removeStavkuNaloga',
	        value: function removeStavkuNaloga(item) {
	            var _this7 = this;
	
	            _lodash2['default'].remove(this.model.stavke, function (stavka) {
	                return stavka.protetski_rad === item.protetski_rad && stavka.cjenik === item.cjenik;
	            });
	
	            item.pozicije.forEach(function (pozicija) {
	                var poz = _lodash2['default'].findIndex(_this7.pozicije, function (i) {
	                    return i.broj === pozicija;
	                });
	
	                if (poz !== -1) {
	                    _this7.pozicije.splice(poz, 1);
	                }
	            });
	            this.groupStavke();
	        }
	    }, {
	        key: 'removeVezuNaloga',
	        value: function removeVezuNaloga(item) {
	            _lodash2['default'].remove(this.model.veze, function (veza) {
	                return veza.pozicija === item.pozicija;
	            });
	        }
	    }]);
	
	    return RadniNalogWizardFormController;
	})();
	
	RadniNalogWizardFormController.$inject = ['$uibModal', 'DS', 'AppConfiguration', 'logger', '$state'];
	
	var RadniNalogWizardFormComponent = {
	    restrict: 'E',
	    templateUrl: _radniNalogWizardFormHtml2['default'],
	    controller: RadniNalogWizardFormController,
	    controllerAs: 'vm',
	    bindings: {
	        fields: '<',
	        item: '<',
	        onSubmit: '&'
	    }
	};
	
	exports.RadniNalogWizardFormComponent = RadniNalogWizardFormComponent;
	exports.RadniNalogWizardFormController = RadniNalogWizardFormController;

/***/ },
/* 495 */
/***/ function(module, exports) {

	var path = 'app/components/radniNalog/radniNalogWizardForm.html';
	var html = "<form name=\"vm.form\" novalidate ng-submit=\"vm.submit(vm.model)\"><div class=\"text-center m-b-md\" id=\"wizardControl\"><a class=\"btn\" ng-class=\"{ 'btn-primary': vm.step == 1, 'btn-default': vm.step != 1}\" ng-click=\"vm.show(1)\">1 - Osnovni podaci</a> <a class=\"btn\" ng-class=\"{ 'btn-primary': vm.step == 2, 'btn-default': vm.step != 2}\" ng-click=\"vm.show(2)\">2 - Plan rada</a> <a class=\"btn\" ng-class=\"{ 'btn-primary': vm.step == 3, 'btn-default': vm.step != 3}\" ng-click=\"vm.show(3)\">3 - Naručene probe</a> <a class=\"btn\" ng-class=\"{ 'btn-primary': vm.step == 4, 'btn-default': vm.step != 4}\" ng-click=\"vm.show(4)\">4 - Pregled naloga</a></div><div class=\"tab-content\"><div id=\"step1\" class=\"p-m\" ng-show=\"vm.step == 1\"><div class=\"row\"><div class=\"col-lg-3 text-center\"><i class=\"pe-7s-credit fa-5x text-muted\"></i><h4>Radni nalog - unos</h4></div><div class=\"col-lg-9\"><formly-form model=\"vm.model\" fields=\"vm.osnovniPodaciFields\" form=\"vm.form\" options=\"vm.options\"></formly-form></div></div><hr><div class=\"text-right m-t-xs\"><a class=\"btn btn-default\" ng-click=\"vm.prev()\">Prethodni</a> <a class=\"btn btn-default\" ng-click=\"vm.next()\">Sljedeći</a> <a class=\"btn btn-default\" ng-click=\"vm.cancel()\">Odustani</a></div></div><div id=\"step2\" class=\"p-m\" ng-show=\"vm.step == 2\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"hpanel\"><div class=\"panel-body text-right\"><kvadrant on-drop=\"vm.copyStavke(from, to)\" pozicija-clicked=\"vm.pozicijaClicked(pozicija)\" kvadrant=\"1\" stavke=\"vm.pozicije\"></kvadrant></div><div class=\"panel-footer\" hidden><div class=\"row\"><div class=\"col-lg-12 text-left\"><a href=\"#\" id=\"kvadrant_1\" class=\"btn btn-xs btn-default pozicije\">1. kvadrant</a></div></div></div></div></div><div class=\"col-lg-12\"><div class=\"hpanel\"><div class=\"panel-body\"><kvadrant on-drop=\"vm.copyStavke(from, to)\" pozicija-clicked=\"vm.pozicijaClicked(pozicija)\" kvadrant=\"2\" stavke=\"vm.pozicije\"></kvadrant></div><div class=\"panel-footer\" hidden><div class=\"row\"><div class=\"col-lg-12 text-right\"><a href=\"#\" id=\"kvadrant_2\" class=\"btn btn-xs btn-default pozicije\">2. kvadrant</a></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-8\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"hpanel\"><div class=\"panel-heading hbuilt\"><div class=\"pull-right\"><button type=\"button\" class=\"btn btn-xs btn-success\" ng-click=\"vm.insertStavkuNaloga()\"><i class=\"fa fa-plus-square\"></i> Nova stavka</button></div><h4>Naručene pozicije</h4></div><div class=\"panel-body\"><div class=\"table-responsive\"><in-data-grid fields=\"vm.stavkeNalogaListView.fields()\" entries=\"vm.groupedStavke\" entity=\"vm.stavkeNalogaListView.entity\" datastore=\"vm.datastore()\" actions=\"vm.stavkeNalogaListView.listActions()\" on-delete=\"vm.removeStavkuNaloga(item)\"></in-data-grid></div></div></div></div><div class=\"col-lg-12\"><formly-form model=\"vm.model\" fields=\"vm.napomenaField\" form=\"vm.form\" options=\"vm.options\"></formly-form></div></div></div><div class=\"col-lg-4\"><div class=\"row\"><div class=\"col-lg-12\"><formly-form model=\"vm.model\" fields=\"vm.stavkeNalogaFields\" form=\"vm.form\" options=\"vm.options\"></formly-form></div></div></div></div><hr><div class=\"text-right m-t-xs\"><a class=\"btn btn-default\" ng-click=\"vm.prev()\">Prethodni</a> <a class=\"btn btn-default\" ng-click=\"vm.next()\">Sljedeći</a> <a class=\"btn btn-default\" ng-click=\"vm.cancel()\">Odustani</a></div></div><div id=\"step3\" class=\"p-m\" ng-if=\"vm.step == 3\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"hpanel\"><div class=\"panel-heading hbuilt\"><div class=\"pull-right\"><button type=\"button\" class=\"btn btn-xs btn-success\" ng-click=\"vm.insertFazu()\"><i class=\"fa fa-plus-square\"></i> Nova proba</button></div><h4>Naručene probe</h4></div><div class=\"panel-body\"><div class=\"table-responsive project-list\"><in-data-grid fields=\"vm.fazeListView.fields()\" entries=\"vm.model.faze\" entity=\"vm.fazeListView.entity\" datastore=\"vm.datastore()\" actions=\"vm.fazeListView.listActions()\" on-delete=\"vm.deleteFazu(item)\"></in-data-grid></div></div></div></div></div><hr><div class=\"text-right m-t-xs\"><a class=\"btn btn-default\" ng-click=\"vm.prev()\">Prethodni</a> <a class=\"btn btn-default\" ng-click=\"vm.next()\">Sljedeći</a> <a class=\"btn btn-default\" ng-click=\"vm.cancel()\">Odustani</a></div></div><div id=\"step4\" class=\"p-m\" ng-if=\"vm.step == 4\"><div class=\"row\"><div class=\"col-lg-12\" ng-if=\"vm.form.$valid\"><evidencija-naloga item=\"vm.model\"></evidencija-naloga></div><div class=\"col-lg-12\" ng-if=\"vm.form.$invalid\"><span>Forma sadrži neispravne unose</span></div></div><hr><div class=\"text-right m-t-xs\"><a class=\"btn btn-default\" ng-click=\"vm.prev()\">Prethodni</a> <a class=\"btn btn-default\" ng-click=\"vm.next()\">Sljedeći</a> <a class=\"btn btn-default\" ng-click=\"vm.cancel()\">Odustani</a> <a class=\"btn btn-success\" ng-click=\"vm.submit(vm.model)\">Potvrdi</a></div></div></div></form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _lodash = __webpack_require__(165);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _evidencijaNalogaHtml = __webpack_require__(497);
	
	var _evidencijaNalogaHtml2 = _interopRequireDefault(_evidencijaNalogaHtml);
	
	var EvidencijaNalogaController = (function () {
	    function EvidencijaNalogaController(DS, $q) {
	        _classCallCheck(this, EvidencijaNalogaController);
	
	        this.datastore = function () {
	            return DS;
	        };
	        this.$q = function () {
	            return $q;
	        };
	        this.protetski_rad = [];
	    }
	
	    _createClass(EvidencijaNalogaController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            var DS = this.datastore();
	            var $q = this.$q();
	            this.item = this.item || undefined;
	            if (this.item === undefined) {
	                return;
	            }
	
	            this.ukupniIznos = 0;
	
	            DS.find('Ordinacija', this.item.ordinacija).then(function (response) {
	                _this.ordinacija = response;
	            });
	
	            $q.all([DS.findAll('ProtetskiRad'), DS.findAll('StavkaCjenika')]).then(function (response) {
	                var _response = _slicedToArray(response, 2);
	
	                var protetskiRadovi = _response[0];
	                var stavkeCjenika = _response[1];
	
	                var StavkaNaloga = DS.definitions['StavkaNaloga'].createInstance();
	                _this.stavke = StavkaNaloga.group(_this.item.stavke);
	
	                _this.stavke.map(function (stavka) {
	                    var protetskiRad = _lodash2['default'].find(protetskiRadovi, { id: stavka.protetski_rad });
	                    var stavkaCjenika = _lodash2['default'].find(stavkeCjenika, {
	                        cjenik: stavka.cjenik,
	                        protetski_rad: stavka.protetski_rad
	                    });
	                    stavka.nazivProtetskogRada = protetskiRad.naziv;
	                    stavka.jedinicnaCijena = stavkaCjenika.iznos;
	                    stavka.kolicina = stavka.pozicije.length;
	                    stavka.iznos = stavka.jedinicnaCijena * stavka.kolicina;
	                    _this.ukupniIznos = _this.ukupniIznos + stavka.iznos;
	                });
	                // this.protetski_rad = response;
	                // this.stavke = this.item.stavke;
	            });
	        }
	    }, {
	        key: 'resolveNazivProtetskogRada',
	        value: function resolveNazivProtetskogRada(stavka) {
	            var item = _lodash2['default'].find(this.protetski_rad, { id: stavka.protetski_rad });
	            if (_lodash2['default'].isUndefined(item)) {
	                return '';
	            }
	            return item.naziv;
	        }
	    }]);
	
	    return EvidencijaNalogaController;
	})();
	
	EvidencijaNalogaController.$inject = ['DS', '$q'];
	
	var EvidencijaNalogaComponent = {
	    restrict: 'E',
	    templateUrl: _evidencijaNalogaHtml2['default'],
	    controller: EvidencijaNalogaController,
	    controllerAs: 'vm',
	    bindings: {
	        item: '<'
	    }
	};
	
	exports.EvidencijaNalogaComponent = EvidencijaNalogaComponent;
	exports.EvidencijaNalogaController = EvidencijaNalogaController;

/***/ },
/* 497 */
/***/ function(module, exports) {

	var path = 'app/components/radniNalog/evidencijaNaloga.html';
	var html = "<div class=\"hpanel\"><div class=\"panel-body p-xl\"><div class=\"row m-b-xl\"><div class=\"col-sm-6\"><h3 class=\"text-info\">RN-{br. radnog naloga}</h3><address><strong></strong><br><br><br></address></div><div class=\"col-sm-6 text-right\"><span>Ordinacija dentalne medicine</span><address><strong>{{vm.ordinacija.naziv}}</strong><br>{{vm.ordinacija.adresa}}<br>{{vm.ordinacija.postanski_broj}} {{vm.ordinacija.mjesto}}<br><abbr title=\"Phone\">Tel:</abbr> {{vm.ordinacija.telefon}}</address><p><span><strong>Datum naloga:</strong> {{vm.item.datum_naloga | date: 'dd.MM.yyyy.'}}</span><br></p></div></div><h3>&nbsp;Pacijent:&nbsp;<span class=\"text-info\">{{vm.item.pacijent}}, ({{vm.item.godina_rodjenja}})</span></h3><div class=\"table-responsive m-t\"><table class=\"table table-striped\"><thead><tr><th class=\"col-lg-8\">Protetski rad<br><small>Pozicija</small></th><th class=\"col-lg-2\">Količina</th><th class=\"col-lg-2 text-right\">Iznos (HRK)</th></tr></thead><tbody><tr ng-repeat=\"stavka in vm.stavke\"><td><div><strong>{{stavka.nazivProtetskogRada}}</strong></div><small><span ng-repeat=\"pozicija in stavka.pozicije\" ng-if=\"pozicija\">[{{pozicija}}]</span></small></td><td>{{stavka.kolicina}}</td><td class=\"text-right\">{{stavka.iznos | currency: '' : 2}}</td></tr></tbody></table></div><div class=\"row m-t\"><div class=\"col-md-8\"><table class=\"table text-left\"><tbody><tr><td>Boja: <strong>{{vm.item.boja}} ({{vm.item.oznaka_boje}})</strong>, oblik: <strong>{{vm.item.oblik}}</strong></td></tr></tbody></table></div><div class=\"col-md-4 text-right\"><table class=\"table table-striped text-right\"><tbody><tr><td><h3>Ukupan iznos (HRK):</h3></td><td><h3>{{vm.ukupniIznos | currency: '' : 2 }}</h3></td></tr></tbody></table><small class=\"text-info\">*Izračun je informativnog karaktera.</small></div></div><div class=\"row\"><div class=\"col-md-8\"><div class=\"m-t\"><strong>Napomena:</strong><br><small class=\"text-danger\">{{vm.item.napomena}}</small></div></div></div></div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _moment = __webpack_require__(216);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _komentariHtml = __webpack_require__(499);
	
	var _komentariHtml2 = _interopRequireDefault(_komentariHtml);
	
	var _modelsKomentarJs = __webpack_require__(500);
	
	var KomentariController = (function () {
	    function KomentariController(DS, $q, $state, logger) {
	        _classCallCheck(this, KomentariController);
	
	        this.datastore = function () {
	            return DS;
	        };
	        this.$q = function () {
	            return $q;
	        };
	        this.$state = function () {
	            return $state;
	        };
	        this.logger = function () {
	            return logger;
	        };
	    }
	
	    _createClass(KomentariController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            var DS = this.datastore();
	            this.newComment = '';
	            DS.find('RadniNalog', this.id, { bypassCache: true }).then(function (radniNalog) {
	                _this.item = radniNalog;
	                _this.refreshState();
	            });
	        }
	    }, {
	        key: 'refreshState',
	        value: function refreshState() {
	            var _this2 = this;
	
	            var DS = this.datastore();
	            var Komentar = DS.definitions['Komentar'];
	            var $q = this.$q();
	            this.pageTitle = 'Poruke radnog naloga: ' + this.item.sifra_naloga;
	            this.pageDesc = 'Evidencija zaprimljenih poruka operatera';
	            $q.when(Komentar.findAll({ radni_nalog: this.item.id }, { bypassCache: true })).then(function (response) {
	                _this2.komentari = [].concat(_toConsumableArray(response));
	                response.filter(function (item) {
	                    return item.status === _modelsKomentarJs.NOVI;
	                }).map(function (item) {
	                    Komentar.update(item.id, { status: _modelsKomentarJs.PROCITAN, radni_nalog: item.radni_nalog, poruka: item.poruka });
	                });
	            });
	        }
	    }, {
	        key: 'createComment',
	        value: function createComment(text) {
	            var _this3 = this;
	
	            var DS = this.datastore();
	            var Komentar = DS.definitions['Komentar'];
	            if (text.length > 0) Komentar.create({ radni_nalog: this.item.id, poruka: text }).then(function (komentar) {
	                _this3.komentari = [komentar].concat(_toConsumableArray(_this3.komentari));
	                _this3.newComment = '';
	            });
	        }
	    }, {
	        key: 'getDayOfWeek',
	        value: function getDayOfWeek(day) {
	            return (0, _moment2['default'])(day).format('dddd');
	        }
	    }]);
	
	    return KomentariController;
	})();
	
	KomentariController.$inject = ['DS', '$q', '$state', 'logger'];
	
	var KomentariComponent = {
	    restrict: 'E',
	    templateUrl: _komentariHtml2['default'],
	    controller: KomentariController,
	    controllerAs: 'vm',
	    bindings: {
	        id: '<'
	    }
	};
	
	exports.KomentariComponent = KomentariComponent;
	exports.KomentariController = KomentariController;

/***/ },
/* 499 */
/***/ function(module, exports) {

	var path = 'app/components/radniNalog/komentari.html';
	var html = "<div class=\"hpanel\"><div class=\"panel-heading hbuilt\">Slanje nove poruke</div><div class=\"panel-footer borders\"><div class=\"input-group\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.newComment\" placeholder=\"Upišite sadržaj poruke ovdje...\"> <span class=\"input-group-btn\"><button ng-click=\"vm.createComment(vm.newComment)\" class=\"btn btn-success\" ng-disabled=\"vm.newComment === ''\">Pošalji</button></span></div></div><div class=\"v-timeline vertical-container\"><div class=\"vertical-timeline-block\" ng-repeat=\"item in vm.komentari\" animate-panel effect=\"zoomIn\"><div class=\"row\"><div class=\"vertical-timeline-icon navy-bg\"><i class=\"fa fa-comment\"></i></div><div class=\"vertical-timeline-content\"><div class=\"p-sm\"><span class=\"vertical-date pull-right\"><small style=\"text-transform: capitalize;\">{{vm.getDayOfWeek(item.created_at)}}, {{item.created_at | date: 'dd.MM.yyyy'}}</small><br><small>{{item.created_at | date: 'HH:mm'}}</small></span><h5 class=\"text-primary\">{{item.sender}}</h5><p>{{item.poruka}}</p></div></div></div></div></div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 500 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	var Komentar = function Komentar(DS) {
	    return DS.defineResource({
	        name: 'Komentar',
	        endpoint: '/komentar'
	    });
	};
	
	var NeprocitanKomentar = function NeprocitanKomentar(DS) {
	    return DS.defineResource({
	        name: 'NeprocitanKomentar',
	        endpoint: '/komentar/neprocitani'
	    });
	};
	
	Komentar.$inject = ['DS'];
	NeprocitanKomentar.$inject = ['DS'];
	
	var NOVI = 'Novi';
	var PROCITAN = 'Procitan';
	
	exports.NOVI = NOVI;
	exports.PROCITAN = PROCITAN;
	exports.Komentar = Komentar;
	exports.NeprocitanKomentar = NeprocitanKomentar;

/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _rnLinkHtml = __webpack_require__(502);
	
	var _rnLinkHtml2 = _interopRequireDefault(_rnLinkHtml);
	
	var _statusiJs = __webpack_require__(435);
	
	var status = {};
	status[_statusiJs.OTVOREN] = 'btn-success';
	status[_statusiJs.UOBRADI] = 'btn-info';
	status[_statusiJs.ZAKLJUCAN] = 'btn-danger';
	status[_statusiJs.STORNIRAN] = 'btn-default';
	
	var RnLinkController = (function () {
	    function RnLinkController() {
	        _classCallCheck(this, RnLinkController);
	    }
	
	    _createClass(RnLinkController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.style = status[this.rn.status];
	        }
	    }]);
	
	    return RnLinkController;
	})();
	
	RnLinkController.$inject = [];
	
	var RnLinkComponent = {
	    restrict: 'E',
	    templateUrl: _rnLinkHtml2['default'],
	    controller: RnLinkController,
	    controllerAs: 'vm',
	    bindings: {
	        rn: '<',
	        badge: '<'
	    }
	};
	
	exports.RnLinkComponent = RnLinkComponent;
	exports.RnLinkController = RnLinkController;

/***/ },
/* 502 */
/***/ function(module, exports) {

	var path = 'app/components/radniNalog/rnLink.html';
	var html = "<a ui-sref=\"radniNalog.details({id:vm.rn.id})\" class=\"btn btn-xs\" ng-class=\"vm.style\"><span class=\"label\">{{vm.rn.sifra_naloga}}</span></a>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports["default"] = RadniNalogService;
	
	var _modelsMetaJs = __webpack_require__(386);
	
	function RadniNalogService(DS, $q, $http) {
	    var filter = {};
	    var pager = {
	        currentPage: 1,
	        limit: 20,
	        totalItems: 0
	    };
	
	    function getPager() {
	        return _extends({}, pager);
	    }
	
	    function setPager(newPager) {
	        pager = Object.assign({}, pager, newPager);
	    }
	
	    function getFilter() {
	        return _extends({}, filter);
	    }
	
	    function setFilter(newFilter) {
	        filter = Object.assign({}, filter, newFilter);
	    }
	
	    function getRadniNalog(id) {
	        return DS.find("RadniNalog", id)["catch"](function (error) {
	            return $q.reject(error);
	        });
	    }
	
	    function fetchRadneNaloge() {
	        var currentPager = getPager();
	        var currentFilter = getFilter();
	        var pagerParams = {
	            offset: (currentPager.currentPage - 1) * currentPager.limit,
	            limit: currentPager.limit
	        };
	
	        var params = _extends({}, pagerParams, currentFilter);
	
	        return $q.when(DS.findAll("RadniNalog", params, { bypassCache: true })).then(function (response) {
	            // debugger;
	            var start = parseInt(pagerParams.offset + 1);
	            var end = parseInt(pagerParams.offset + response.length);
	            if (_modelsMetaJs.meta["RadniNalog"] !== undefined) {
	                setPager({
	                    totalItems: _modelsMetaJs.meta["RadniNalog"].count,
	                    start: start,
	                    end: end
	                });
	            }
	
	            return response;
	        })["catch"](function (error) {
	            return $q.reject(error);
	        });
	    }
	
	    function find(id) {
	        return $q.when(DS.find("RadniNalog", id));
	    }
	
	    // function brojStranica(id) {
	    //     return $q.when(DS.getMapper('dokument').brojStranica(id));
	    // }
	
	    function filterRadneNalogeBy(filter) {
	        // setPredmetFilter(filter);
	        // setCurrentPage(1);
	        fetchDokumente();
	    }
	
	    return {
	        getPager: getPager,
	        setPager: setPager,
	        getRadniNalog: getRadniNalog,
	        setFilter: setFilter,
	        getFilter: getFilter,
	        filterRadneNalogeBy: filterRadneNalogeBy,
	        fetchRadneNaloge: fetchRadneNaloge,
	        find: find
	    };
	}
	
	RadniNalogService.$inject = ["DS", "$q", "$http"];
	module.exports = exports["default"];

/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _commonCrudCrudJs = __webpack_require__(371);
	
	var _fazeForDayComponentJs = __webpack_require__(505);
	
	var fazaNaloga = _angular2['default'].module('fazaNaloga', [_commonCrudCrudJs.crud.name]);
	
	fazaNaloga.component('fazeForDay', _fazeForDayComponentJs.FazeForDayComponent);
	
	exports.fazaNaloga = fazaNaloga;

/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _moment = __webpack_require__(216);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(165);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _fazeForDayHtml = __webpack_require__(506);
	
	var _fazeForDayHtml2 = _interopRequireDefault(_fazeForDayHtml);
	
	var _jquery = __webpack_require__(80);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var FazeForDayController = (function () {
	    function FazeForDayController(AppConfiguration, DS, $q) {
	        _classCallCheck(this, FazeForDayController);
	
	        this.fazeView = AppConfiguration().getViewByEntityAndType('FazaNaloga', 'DashboardView');
	        this.datastore = function () {
	            return DS;
	        };
	        this.$q = function () {
	            return $q;
	        };
	    }
	
	    _createClass(FazeForDayController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.mode = 'danas';
	        }
	    }, {
	        key: '$onChanges',
	        value: function $onChanges(changes) {
	            this.days = changes.days.currentValue;
	            this.getState();
	        }
	    }, {
	        key: 'onDayClicked',
	        value: function onDayClicked(day) {
	            this.onClick({ day: day });
	        }
	    }, {
	        key: 'no_reservation',
	        value: function no_reservation(header_day, item) {
	            // console.log(header_day.format('YYYY-MM-DD'), item);
	
	            // if (item && item.datum_probe === header_day.format('YYYY-MM-DD')) {
	            //     return false;
	            // }
	            return true;
	        }
	
	        // getState() {
	        //     this.items = [];
	        //     this.pivot = [];
	        //     _.forEach(this.days, day => {
	        //         let item = {};
	        //         this.getFaze(day).then(response => {
	        //             item.date = day;
	        //             item.datum = moment(day).format();
	        //             item.probe = response;
	        //             response.forEach((r, i) => {
	        //                 if (this.pivot.length <= i) {
	        //                     this.pivot.push([]);
	        //                 }
	        //                 this.pivot[i].push(r);
	        //             });
	        //         });
	
	        //         this.items.push(item);
	        //     });
	        // }
	
	    }, {
	        key: 'getItemForRow',
	        value: function getItemForRow(row, dan) {
	            var probe_za_dan = this.dani.filter(function (f) {
	                return f.datum === dan;
	            });
	            if (probe_za_dan.length === 1) {
	                var probe = probe_za_dan[0].response;
	                if (probe.length > row) {
	                    return probe[row];
	                }
	            }
	            return null;
	        }
	    }, {
	        key: 'getState',
	        value: function getState() {
	            var _this = this;
	
	            var $q = this.$q();
	            this.items = [];
	            this.dani = [];
	            this.max_proba = 0;
	
	            $q.all(this.days.map(function (day) {
	                return _this.getFaze(day);
	            })).then(function (responses) {
	                _lodash2['default'].forEach(responses, function (response, i) {
	                    var dan = {
	                        datum: _this.days[i],
	                        broj_proba: response.length,
	                        response: response
	                    };
	                    _lodash2['default'].forEach(response, function (r) {
	                        _this.items.push(r);
	                    });
	
	                    _this.dani.push(dan);
	                });
	
	                var max_proba = _lodash2['default'].maxBy(_this.dani, 'broj_proba');
	                _this.max_proba = [].concat(_toConsumableArray(Array.from(Array(max_proba.broj_proba).keys())));
	            });
	        }
	    }, {
	        key: 'getFaze',
	        value: function getFaze(day) {
	            var DS = this.datastore();
	            return DS.findAll('FazaNaloga', { aktivne: 1, datum_probe: (0, _moment2['default'])(day).format('YYYY-MM-DD'), ordering: 'termin_probe' }, { bypassCache: true }).then(function (response) {
	                return response;
	            });
	        }
	    }]);
	
	    return FazeForDayController;
	})();
	
	FazeForDayController.$inject = ['AppConfiguration', 'DS', '$q'];
	
	var FazeForDayComponent = {
	    restrict: 'E',
	    templateUrl: _fazeForDayHtml2['default'],
	    controller: FazeForDayController,
	    controllerAs: 'vm',
	    bindings: {
	        days: '<',
	        onClick: '&'
	    }
	};
	
	exports.FazeForDayComponent = FazeForDayComponent;
	exports.FazeForDayController = FazeForDayController;

/***/ },
/* 506 */
/***/ function(module, exports) {

	var path = 'app/components/fazaNaloga/fazeForDay.html';
	var html = "<div class=\"row\"><div class=\"col-lg-12\" ng-if=\"vm.days.length === 1\"><br><div class=\"table-responsive\"><table id=\"no-more-tables\" cellpadding=\"1\" cellspacing=\"1\" class=\"table table-bordered table-striped table-hover\"><thead><tr><th>Ordinacija</th><th>Pacijent</th><th>Broj naloga</th><th>Napomena</th><th class=\"text-center\"><i class=\"fa fa-clock-o\"></i> Termin <i class=\"fa fa-sort-up\"></i></th></tr></thead><tbody><tr ng-repeat=\"item in vm.items\"><td data-title=\"Ordinacija\"><h5 class=\"no-margins font-extra-bold\">{{item.ordinacija_naziv}}</h5></td><td data-title=\"Pacijent\">{{item.pacijent_naziv}}</td><td data-title=\"Broj naloga\" class=\"text-center\"><rn-link rn=\"item.rn\"></rn-link></td><td data-title=\"Napomena\">{{item.napomena}}&nbsp;</td><td data-title=\"Termin\" class=\"text-center\"><h5>{{item.termin_probe}}</h5></td></tr></tbody></table></div></div><table id=\"no-more-tables\" class=\"table table-striped table-bordered\" ng-if=\"vm.days.length > 1\"><thead><tr><th ng-repeat=\"dan in vm.dani\"><h5 class=\"text-primary text-center\">{{dan.datum | date:\"dd.MM.yyyy.\"}}<span class=\"label label-danger pull-right\">{{dan.broj_proba}}</span></h5></th></tr></thead><tbody><tr ng-repeat=\"row in vm.max_proba\"><td data-title=\"Datum naloga\" ng-repeat=\"day in vm.days track by $index\"><img src=\"images/slobodan_termin.png\" class=\"img-responsive center-block\" ng-if=\"!vm.getItemForRow(row, day)\"><div ng-if=\"vm.getItemForRow(row, day)\"><h5 class=\"no-margins font-extra-bold\">{{vm.getItemForRow(row, day).ordinacija_naziv}}</h5><small>{{vm.getItemForRow(row, day).pacijent_naziv}}</small><div class=\"pull-right font-bold\">{{vm.getItemForRow(row, day).termin_probe}}</div><br><rn-link rn=\"vm.getItemForRow(row, day).rn\"></rn-link></div></td></tr></tbody></table><div class=\"col-lg-2\" ng-if=\"vm.items.length > 1\" ng-repeat=\"day in vm.items\"><div class=\"list-item-container\"><div class=\"list-item text-center\"><a ng-click=\"vm.onDayClicked(day.date)\"><h5 class=\"text-success\">{{day.datum | date:\"dd.MM.yyyy\"}}<span class=\"label label-danger pull-right\">{{day.probe.length}}</span></h5></a></div><div class=\"list-item text-center\" ng-if=\"day.probe.length === 0\"><img src=\"images/slobodan_termin.png\"></div><div class=\"list-item\" ng-repeat=\"item in day.probe\"><h5 class=\"no-margins font-extra-bold text-danger\">{{item.ordinacija_naziv}}</h5><a ui-sref=\"radniNalog.details({id:item.radni_nalog})\"><small>{{item.pacijent_naziv}} (<span class=\"label label-success\">{{item.radni_nalog_sifra_naloga}}</span>)</small></a><div class=\"pull-right font-bold\">{{item.termin_probe}}</div></div></div></div></div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(81);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _jsDataAngular = __webpack_require__(508);
	
	var _jsDataAngular2 = _interopRequireDefault(_jsDataAngular);
	
	var _radniNalogJs = __webpack_require__(530);
	
	var _ordinacijaJs = __webpack_require__(531);
	
	var _tehnicarJs = __webpack_require__(532);
	
	var _valutaJs = __webpack_require__(533);
	
	var _poreznaStopaJs = __webpack_require__(534);
	
	var _protetskiRadJs = __webpack_require__(535);
	
	var _cjenikJs = __webpack_require__(536);
	
	var _stavkaCjenikaJs = __webpack_require__(537);
	
	var _bojaJs = __webpack_require__(538);
	
	var _oznakaBojeJs = __webpack_require__(539);
	
	var _fazaNalogaJs = __webpack_require__(540);
	
	var _stavkaNalogaJs = __webpack_require__(541);
	
	var _korisnikOrdinacijaJs = __webpack_require__(542);
	
	var _materijalJs = __webpack_require__(543);
	
	var _grupaRadaJs = __webpack_require__(544);
	
	var _vrstaRadaJs = __webpack_require__(545);
	
	var _dokumentNalogaJs = __webpack_require__(546);
	
	var _tokensJs = __webpack_require__(547);
	
	var _komentarJs = __webpack_require__(500);
	
	var _metaJs = __webpack_require__(386);
	
	var models = _angular2['default'].module('models', [_jsDataAngular2['default']]);
	
	Config.$inject = ['DSProvider', 'DSHttpAdapterProvider', '$httpProvider'];
	function Config(DSProvider, DSHttpAdapterProvider, $httpProvider) {
	    _angular2['default'].extend(DSProvider.defaults, {
	        bypassCache: false,
	        cacheResponse: true,
	        deserialize: function deserialize(resourceName, res) {
	            if (_angular2['default'].isDefined(res.data) && _angular2['default'].isDefined(res.data.results)) {
	                var newResponse = res.data.results;
	                newResponse.meta = {
	                    count: res.data.count,
	                    next: res.data.next,
	                    previous: res.data.previous,
	                    start: res.data.start,
	                    end: res.data.end
	                };
	                _metaJs.meta[resourceName.name] = newResponse.meta;
	                return newResponse;
	            }
	            return res.data;
	        }
	    });
	    _angular2['default'].extend(DSHttpAdapterProvider.defaults, {
	        basePath: '/api/radni_nalozi'
	    });
	
	    $httpProvider.defaults.xsrfCookieName = 'csrftoken';
	    $httpProvider.defaults.xsrfHeaderName = 'X-CSRFToken';
	}
	
	models.run(['DS', 'RadniNalog', 'Ordinacija', 'Tehnicar', 'Valuta', 'PoreznaStopa', 'ProtetskiRad', 'Cjenik', 'StavkaCjenika', 'Boja', 'OznakaBoje', 'FazaNaloga', 'StavkaNaloga', 'KorisnikOrdinacija', 'Materijal', 'GrupaRada', 'VrstaRada', 'DokumentNaloga', 'PlanRada', 'Token', 'Komentar', 'NeprocitanKomentar', function () {
	    // require('./factory.js')(DS);
	}]);
	
	models.config(Config);
	
	models.factory('RadniNalog', _radniNalogJs.RadniNalog);
	models.factory('Ordinacija', _ordinacijaJs.Ordinacija);
	models.factory('Tehnicar', _tehnicarJs.Tehnicar);
	models.factory('Valuta', _valutaJs.Valuta);
	models.factory('PoreznaStopa', _poreznaStopaJs.PoreznaStopa);
	models.factory('ProtetskiRad', _protetskiRadJs.ProtetskiRad);
	models.factory('Cjenik', _cjenikJs.Cjenik);
	models.factory('StavkaCjenika', _stavkaCjenikaJs.StavkaCjenika);
	models.factory('Boja', _bojaJs.Boja);
	models.factory('OznakaBoje', _oznakaBojeJs.OznakaBoje);
	models.factory('FazaNaloga', _fazaNalogaJs.FazaNaloga);
	models.factory('StavkaNaloga', _stavkaNalogaJs.StavkaNaloga);
	models.factory('KorisnikOrdinacija', _korisnikOrdinacijaJs.KorisnikOrdinacija);
	models.factory('Materijal', _materijalJs.Materijal);
	models.factory('GrupaRada', _grupaRadaJs.GrupaRada);
	models.factory('VrstaRada', _vrstaRadaJs.VrstaRada);
	models.factory('DokumentNaloga', _dokumentNalogaJs.DokumentNaloga);
	models.factory('PlanRada', _radniNalogJs.PlanRada);
	models.factory('Token', _tokensJs.Token);
	models.factory('Komentar', _komentarJs.Komentar);
	models.factory('NeprocitanKomentar', _komentarJs.NeprocitanKomentar);
	
	exports.models = models;

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	* js-data-angular
	* @version 3.2.1 - Homepage <https://github.com/js-data/js-data-angular>
	* @copyright (c) 2014-2016 js-data-angular project authors
	* @license MIT <https://github.com/js-data/js-data-angular/blob/master/LICENSE>
	*
	* @overview Angular wrapper for js-data.
	*/
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(509), __webpack_require__(81), (function webpackLoadOptionalExternalModule() { try { return __webpack_require__(510); } catch(e) {} }()));
		else if(typeof define === 'function' && define.amd)
			define(["js-data", "angular"], function webpackLoadOptionalExternalModuleAmd(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_4__) {
				return factory(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_4__, root["axios"]);
			});
		else if(typeof exports === 'object')
			exports["jsDataAngularModuleName"] = factory(require("js-data"), require("angular"), (function webpackLoadOptionalExternalModule() { try { return require("axios"); } catch(e) {} }()));
		else
			root["jsDataAngularModuleName"] = factory(root["JSData"], root["angular"], root["axios"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_3__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	/******/
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		/* jshint loopfunc:true */
		var JSData = __webpack_require__(1);
		var DSHttpAdapter = __webpack_require__(2);
		var angular = __webpack_require__(4);
		
		var DSUtils = JSData.DSUtils;
		var DSErrors = JSData.DSErrors;
		var get = DSUtils.get;
		var isString = DSUtils.isString;
		var isNumber = DSUtils.isNumber;
		var isObject = DSUtils.isObject;
		var set = DSUtils.set;
		var resolveId = DSUtils.resolveId;
		
		
		var adapters = [{
		  project: 'js-data-localstorage',
		  name: 'localstorage',
		  'class': 'DSLocalStorageAdapter'
		}, {
		  project: 'js-data-localforage',
		  name: 'localforage',
		  'class': 'DSLocalForageAdapter'
		}, {
		  project: 'js-data-firebase',
		  name: 'firebase',
		  'class': 'DSFirebaseAdapter'
		}, {
		  project: 'js-data-sql',
		  name: 'sql',
		  'class': 'DSSqlAdapter'
		}];
		
		var functionsToWrap = ['compute', 'digest', 'eject', 'inject'];
		
		function registerAdapter(adapter) {
		  var Adapter = void 0;
		
		  try {
		    Adapter = __webpack_require__(5)(adapter.project);
		  } catch (e) {}
		
		  if (!Adapter) {
		    Adapter = window[adapter.class];
		  }
		
		  if (Adapter) {
		    adapter.loaded = true;
		    angular.module('js-data').provider(adapter.class, function () {
		      var _this = this;
		      _this.defaults = {};
		      _this.$get = [function () {
		        return new Adapter(_this.defaults);
		      }];
		    });
		  }
		}
		
		var DSHttpAdapterProvider = function DSHttpAdapterProvider() {
		  _classCallCheck(this, DSHttpAdapterProvider);
		
		  var defaults = {};
		  this.defaults = defaults;
		
		  this.$get = ['$http', 'DS', function ($http, DS) {
		    defaults.http = defaults.http || $http;
		    var adapter = new DSHttpAdapter(defaults);
		    DS.registerAdapter('http', adapter, { 'default': true });
		    return adapter;
		  }];
		};
		
		var DSProvider = function DSProvider() {
		  _classCallCheck(this, DSProvider);
		
		  var _this = this;
		  var deps = [];
		
		  for (var i = 0; i < adapters.length; i++) {
		    if (adapters[i].loaded) {
		      deps.push(adapters[i].class);
		    }
		  }
		
		  _this.defaults = {};
		
		  JSData.DS.prototype.bindAll = function (resourceName, params, scope, expr, cb) {
		    var _this = this;
		
		    params = params || {};
		
		    if (!_this.definitions[resourceName]) {
		      throw new DSErrors.NER(resourceName);
		    } else if (!isObject(params)) {
		      throw new DSErrors.IA('"params" must be an object!');
		    } else if (!isObject(scope)) {
		      throw new DSErrors.IA('"scope" must be an object!');
		    } else if (!isString(expr)) {
		      throw new DSErrors.IA('"expr" must be a string!');
		    }
		
		    var idAttribute = _this.definitions[resourceName].idAttribute;
		
		    try {
		      return scope.$watch(function () {
		        return _this.lastModified(resourceName);
		      }, function () {
		        var items = _this.filter(resourceName, params);
		        if (items && items.length) {
		          angular.forEach(items, function (item) {
		            _this.compute(resourceName, get(item, idAttribute));
		          });
		        }
		        set(scope, expr, items);
		        if (cb) {
		          cb(null, items);
		        }
		      });
		    } catch (err) {
		      if (cb) {
		        cb(err);
		      } else {
		        throw err;
		      }
		    }
		  };
		
		  JSData.DS.prototype.bindOne = function (resourceName, id, scope, expr, cb) {
		    var _this = this;
		
		    id = resolveId(_this.definitions[resourceName], id);
		    if (!_this.definitions[resourceName]) {
		      throw new DSErrors.NER(resourceName);
		    } else if (!isString(id) && !isNumber(id)) {
		      throw new DSErrors.IA('"id" must be a string or a number!');
		    } else if (!isObject(scope)) {
		      throw new DSErrors.IA('"scope" must be an object!');
		    } else if (!isString(expr)) {
		      throw new DSErrors.IA('"expr" must be a string!');
		    }
		
		    try {
		      return scope.$watch(function () {
		        return _this.lastModified(resourceName, id);
		      }, function () {
		        var item = _this.get(resourceName, id);
		        if (item) {
		          _this.compute(resourceName, id);
		        }
		        set(scope, expr, item);
		        if (cb) {
		          cb(null, item);
		        }
		      });
		    } catch (err) {
		      if (cb) {
		        cb(err);
		      } else {
		        throw err;
		      }
		    }
		  };
		
		  function load() {
		    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
		      args[_key] = arguments[_key];
		    }
		
		    var $rootScope = args[args.length - 2];
		    var $q = args[args.length - 1];
		    var store = new JSData.DS(_this.defaults);
		    var originals = {};
		
		    function QPromise(executor) {
		      var deferred = $q.defer();
		
		      try {
		        executor(angular.bind(deferred, deferred.resolve), angular.bind(deferred, deferred.reject));
		      } catch (err) {
		        deferred.reject(err);
		      }
		
		      return deferred.promise;
		    }
		
		    QPromise.all = $q.all;
		    QPromise.when = $q.when;
		    QPromise.reject = $q.reject;
		
		    DSUtils.Promise = QPromise;
		
		    // Register any adapters that have been loaded
		    if (args.length) {
		      for (var i = 0; i < args.length; i++) {
		        for (var j = 0; j < adapters.length; j++) {
		          if (adapters[j].loaded && !adapters[j].registered) {
		            adapters[j].registered = true;
		            store.registerAdapter(adapters[j].name, args[i]);
		            break;
		          }
		        }
		      }
		    }
		
		    // Wrap certain sync functions with $apply
		
		    var _loop = function _loop() {
		      var name = functionsToWrap[k];
		      originals[name] = store[name];
		      store[name] = function () {
		        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
		          args[_key2] = arguments[_key2];
		        }
		
		        if (!$rootScope.$$phase) {
		          return $rootScope.$apply(function () {
		            return originals[name].apply(store, args);
		          });
		        }
		        return originals[name].apply(store, args);
		      };
		    };
		
		    for (var k = 0; k < functionsToWrap.length; k++) {
		      _loop();
		    }
		
		    // Hook into the digest loop
		    if (typeof Object.observe !== 'function' || typeof Array.observe !== 'function') {
		      $rootScope.$watch(function () {
		        return store.observe.Platform.performMicrotaskCheckpoint();
		      });
		    }
		
		    return store;
		  }
		
		  deps.push('$rootScope');
		  deps.push('$q');
		  deps.push(load);
		
		  _this.$get = deps;
		};
		
		angular.module('js-data', ['ng']).value('DSUtils', DSUtils).value('DSErrors', DSErrors).value('DSVersion', JSData.version).provider('DS', DSProvider).provider('DSHttpAdapter', DSHttpAdapterProvider).run(['DS', 'DSHttpAdapter', function (DS, DSHttpAdapter) {
		  DS.registerAdapter('http', DSHttpAdapter, { 'default': true });
		}]);
		
		for (var i = 0; i < adapters.length; i++) {
		  registerAdapter(adapters[i]);
		}
		
		// return the module name
		module.exports = 'js-data';
		try {
		  module.exports.name = 'js-data';
		} catch (e) {}
	
	/***/ },
	/* 1 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_1__;
	
	/***/ },
	/* 2 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
		
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
		
		function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		var JSData = __webpack_require__(1);
		var axios = null;
		
		try {
		  axios = __webpack_require__(3);
		} catch (e) {}
		
		var DSUtils = JSData.DSUtils;
		var deepMixIn = DSUtils.deepMixIn;
		var removeCircular = DSUtils.removeCircular;
		var copy = DSUtils.copy;
		var makePath = DSUtils.makePath;
		var isString = DSUtils.isString;
		var isNumber = DSUtils.isNumber;
		
		
		function isUndefined(value) {
		  return value === undefined;
		}
		
		var Defaults = function () {
		  function Defaults() {
		    _classCallCheck(this, Defaults);
		  }
		
		  _createClass(Defaults, [{
		    key: 'queryTransform',
		    value: function queryTransform(resourceConfig, params) {
		      return params;
		    }
		  }, {
		    key: 'deserialize',
		    value: function deserialize(resourceConfig, data) {
		      return data ? 'data' in data ? data.data : data : data;
		    }
		  }, {
		    key: 'serialize',
		    value: function serialize(resourceConfig, data) {
		      return data;
		    }
		  }, {
		    key: 'log',
		    value: function log() {}
		  }, {
		    key: 'error',
		    value: function error() {}
		  }]);
		
		  return Defaults;
		}();
		
		var defaultsPrototype = Defaults.prototype;
		
		defaultsPrototype.basePath = '';
		
		defaultsPrototype.forceTrailingSlash = '';
		
		defaultsPrototype.httpConfig = {};
		
		defaultsPrototype.verbsUseBasePath = false;
		
		var DSHttpAdapter = function () {
		  function DSHttpAdapter(options) {
		    _classCallCheck(this, DSHttpAdapter);
		
		    options || (options = {});
		    this.defaults = new Defaults();
		    if (console) {
		      this.defaults.log = function (a, b) {
		        return console[typeof console.info === 'function' ? 'info' : 'log'](a, b);
		      };
		    }
		    if (console) {
		      this.defaults.error = function (a, b) {
		        return console[typeof console.error === 'function' ? 'error' : 'log'](a, b);
		      };
		    }
		    deepMixIn(this.defaults, options);
		    this.http = options.http || axios;
		  }
		
		  _createClass(DSHttpAdapter, [{
		    key: 'getEndpoint',
		    value: function getEndpoint(resourceConfig, id, options) {
		      options || (options = {});
		      options.params = isUndefined(options.params) ? {} : options.params;
		
		      var endpoint = options.hasOwnProperty('endpoint') ? options.endpoint : resourceConfig.endpoint;
		      var parents = resourceConfig.parents || (resourceConfig.parent ? _defineProperty({}, resourceConfig.parent, {
		        key: resourceConfig.parentKey,
		        field: resourceConfig.parentField
		      }) : {});
		
		      DSUtils.forOwn(parents, function (parent, parentName) {
		        var _this2 = this;
		
		        var item = void 0;
		        var parentKey = parent.key;
		        var parentField = parent.field;
		        var parentDef = resourceConfig.getResource(parentName);
		        var parentId = options.params[parentKey];
		
		        if (parentId === false || !parentKey || !parentDef) {
		          if (parentId === false) {
		            delete options.params[parentKey];
		          }
		        } else {
		          delete options.params[parentKey];
		
		          if (DSUtils._sn(id)) {
		            item = resourceConfig.get(id);
		          } else if (DSUtils._o(id)) {
		            item = id;
		          }
		
		          if (item) {
		            parentId = parentId || item[parentKey] || (item[parentField] ? item[parentField][parentDef.idAttribute] : null);
		          }
		
		          if (parentId) {
		            (function () {
		              delete options.endpoint;
		              var _options = {};
		              DSUtils.forOwn(options, function (value, key) {
		                _options[key] = value;
		              });
		              endpoint = DSUtils.makePath(_this2.getEndpoint(parentDef, parentId, DSUtils._(parentDef, _options)), parentId, endpoint);
		            })();
		          }
		        }
		      }, this);
		
		      return endpoint;
		    }
		  }, {
		    key: 'getPath',
		    value: function getPath(method, resourceConfig, id, options) {
		      var _this = this;
		      options || (options = {});
		      if (isString(options.urlPath)) {
		        return makePath.apply(DSUtils, [options.basePath || _this.defaults.basePath || resourceConfig.basePath, options.urlPath]);
		      } else {
		        var args = [options.basePath || _this.defaults.basePath || resourceConfig.basePath, this.getEndpoint(resourceConfig, isString(id) || isNumber(id) || method === 'create' ? id : null, options)];
		        if (method === 'find' || method === 'update' || method === 'destroy') {
		          args.push(id);
		        }
		        return makePath.apply(DSUtils, args);
		      }
		    }
		  }, {
		    key: 'HTTP',
		    value: function HTTP(config) {
		      var _this = this;
		      var start = new Date();
		
		      // blacklist `data` as it can be large and will take a lot of time to copy
		      var payload = config.data;
		      var cache = config.cache;
		      var timeout = config.timeout;
		      config = copy(config, null, null, null, ['data', 'cache', 'timeout']);
		      config = deepMixIn(config, _this.defaults.httpConfig);
		      config.data = payload;
		      config.cache = cache;
		      config.timeout = timeout;
		      if (!('verbsUseBasePath' in config)) {
		        config.verbsUseBasePath = _this.defaults.verbsUseBasePath;
		      }
		      if (!config.urlOverride && config.verbsUseBasePath) {
		        config.url = makePath(config.basePath || _this.defaults.basePath, config.url);
		      }
		      if (_this.defaults.forceTrailingSlash && config.url[config.url.length - 1] !== '/' && !config.urlOverride) {
		        config.url += '/';
		      }
		      if (_typeof(config.data) === 'object') {
		        config.data = removeCircular(config.data);
		      }
		      config.method = config.method.toUpperCase();
		      var suffix = isUndefined(config.suffix) ? _this.defaults.suffix : config.suffix;
		      if (suffix && config.url.substr(config.url.length - suffix.length) !== suffix && !config.urlOverride) {
		        config.url += suffix;
		      }
		
		      // logs the HTTP response
		      function logResponse(data, isRejection) {
		        data = data || {};
		        // examine the data object
		        if (data instanceof Error) {
		          // log the Error object
		          _this.defaults.error('FAILED: ' + (data.message || 'Unknown Error'), data);
		          return DSUtils.Promise.reject(data);
		        } else if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object') {
		          var str = start.toUTCString() + ' - ' + config.method + ' ' + config.url + ' - ' + data.status + ' ' + (new Date().getTime() - start.getTime()) + 'ms';
		
		          if (data.status >= 200 && data.status < 300 && !isRejection) {
		            if (_this.defaults.log) {
		              _this.defaults.log(str, data);
		            }
		            return data;
		          } else {
		            if (_this.defaults.error) {
		              _this.defaults.error('FAILED: ' + str, data);
		            }
		            return DSUtils.Promise.reject(data);
		          }
		        } else {
		          // unknown type for 'data' that is not an Object or Error
		          _this.defaults.error('FAILED', data);
		          return DSUtils.Promise.reject(data);
		        }
		      }
		
		      if (!this.http) {
		        throw new Error('You have not configured this adapter with an http library!');
		      }
		
		      return this.http(config).then(logResponse, function (data) {
		        return logResponse(data, true);
		      });
		    }
		  }, {
		    key: 'GET',
		    value: function GET(url, config) {
		      config = config || {};
		      config.method = config.method || 'get';
		      config.urlOverride = !!config.url;
		      config.url = config.url || url;
		      return this.HTTP(config);
		    }
		  }, {
		    key: 'POST',
		    value: function POST(url, attrs, config) {
		      config = config || {};
		      config.method = config.method || 'post';
		      config.urlOverride = !!config.url;
		      config.url = config.url || url;
		      config.data = config.data || attrs;
		      return this.HTTP(config);
		    }
		  }, {
		    key: 'PUT',
		    value: function PUT(url, attrs, config) {
		      config = config || {};
		      config.method = config.method || 'put';
		      config.urlOverride = !!config.url;
		      config.url = config.url || url;
		      config.data = config.data || attrs;
		      return this.HTTP(config);
		    }
		  }, {
		    key: 'DEL',
		    value: function DEL(url, config) {
		      config = config || {};
		      config.method = config.method || 'delete';
		      config.urlOverride = !!config.url;
		      config.url = config.url || url;
		      return this.HTTP(config);
		    }
		  }, {
		    key: 'find',
		    value: function find(resourceConfig, id, options) {
		      var _this = this;
		      options || (options = {});
		      options.suffix = isUndefined(options.suffix) ? resourceConfig.suffix : options.suffix;
		      options.params = isUndefined(options.params) ? {} : copy(options.params);
		      options.params = _this.defaults.queryTransform(resourceConfig, options.params);
		      return _this.GET(_this.getPath('find', resourceConfig, id, options), options).then(function (data) {
		        var item = (options.deserialize ? options.deserialize : _this.defaults.deserialize)(resourceConfig, data);
		        return !item ? DSUtils.Promise.reject(new Error('Not Found!')) : item;
		      });
		    }
		  }, {
		    key: 'findAll',
		    value: function findAll(resourceConfig, params, options) {
		      var _this = this;
		      options || (options = {});
		      options.suffix = isUndefined(options.suffix) ? resourceConfig.suffix : options.suffix;
		      options.params = isUndefined(options.params) ? {} : copy(options.params);
		      if (params) {
		        params = _this.defaults.queryTransform(resourceConfig, params);
		        deepMixIn(options.params, params);
		      }
		      return _this.GET(_this.getPath('findAll', resourceConfig, params, options), options).then(function (data) {
		        return (options.deserialize ? options.deserialize : _this.defaults.deserialize)(resourceConfig, data);
		      });
		    }
		  }, {
		    key: 'create',
		    value: function create(resourceConfig, attrs, options) {
		      var _this = this;
		      options || (options = {});
		      options.suffix = isUndefined(options.suffix) ? resourceConfig.suffix : options.suffix;
		      options.params = isUndefined(options.params) ? {} : copy(options.params);
		      options.params = _this.defaults.queryTransform(resourceConfig, options.params);
		      return _this.POST(_this.getPath('create', resourceConfig, attrs, options), options.serialize ? options.serialize(resourceConfig, attrs) : _this.defaults.serialize(resourceConfig, attrs), options).then(function (data) {
		        return (options.deserialize ? options.deserialize : _this.defaults.deserialize)(resourceConfig, data);
		      });
		    }
		  }, {
		    key: 'update',
		    value: function update(resourceConfig, id, attrs, options) {
		      var _this = this;
		      options || (options = {});
		      options.suffix = isUndefined(options.suffix) ? resourceConfig.suffix : options.suffix;
		      options.params = isUndefined(options.params) ? {} : copy(options.params);
		      options.params = _this.defaults.queryTransform(resourceConfig, options.params);
		      return _this.PUT(_this.getPath('update', resourceConfig, id, options), options.serialize ? options.serialize(resourceConfig, attrs) : _this.defaults.serialize(resourceConfig, attrs), options).then(function (data) {
		        return (options.deserialize ? options.deserialize : _this.defaults.deserialize)(resourceConfig, data);
		      });
		    }
		  }, {
		    key: 'updateAll',
		    value: function updateAll(resourceConfig, attrs, params, options) {
		      var _this = this;
		      options || (options = {});
		      options.suffix = isUndefined(options.suffix) ? resourceConfig.suffix : options.suffix;
		      options.params = isUndefined(options.params) ? {} : copy(options.params);
		      if (params) {
		        params = _this.defaults.queryTransform(resourceConfig, params);
		        deepMixIn(options.params, params);
		      }
		      return this.PUT(_this.getPath('updateAll', resourceConfig, attrs, options), options.serialize ? options.serialize(resourceConfig, attrs) : _this.defaults.serialize(resourceConfig, attrs), options).then(function (data) {
		        return (options.deserialize ? options.deserialize : _this.defaults.deserialize)(resourceConfig, data);
		      });
		    }
		  }, {
		    key: 'destroy',
		    value: function destroy(resourceConfig, id, options) {
		      var _this = this;
		      options || (options = {});
		      options.suffix = isUndefined(options.suffix) ? resourceConfig.suffix : options.suffix;
		      options.params = isUndefined(options.params) ? {} : copy(options.params);
		      options.params = _this.defaults.queryTransform(resourceConfig, options.params);
		      return _this.DEL(_this.getPath('destroy', resourceConfig, id, options), options).then(function (data) {
		        return (options.deserialize ? options.deserialize : _this.defaults.deserialize)(resourceConfig, data);
		      });
		    }
		  }, {
		    key: 'destroyAll',
		    value: function destroyAll(resourceConfig, params, options) {
		      var _this = this;
		      options || (options = {});
		      options.suffix = isUndefined(options.suffix) ? resourceConfig.suffix : options.suffix;
		      options.params = isUndefined(options.params) ? {} : copy(options.params);
		      if (params) {
		        params = _this.defaults.queryTransform(resourceConfig, params);
		        deepMixIn(options.params, params);
		      }
		      return this.DEL(_this.getPath('destroyAll', resourceConfig, params, options), options).then(function (data) {
		        return (options.deserialize ? options.deserialize : _this.defaults.deserialize)(resourceConfig, data);
		      });
		    }
		  }]);
		
		  return DSHttpAdapter;
		}();
		
		DSHttpAdapter.version = {
		  full: '3.2.1',
		  major: parseInt('3', 10),
		  minor: parseInt('2', 10),
		  patch: parseInt('1', 10),
		  alpha:  true ? 'false' : false,
		  beta:  true ? 'false' : false
		};
		
		module.exports = DSHttpAdapter;
	
	/***/ },
	/* 3 */
	/***/ function(module, exports) {
	
		if(typeof __WEBPACK_EXTERNAL_MODULE_3__ === 'undefined') {var e = new Error("Cannot find module \"axios\""); e.code = 'MODULE_NOT_FOUND'; throw e;}
		module.exports = __WEBPACK_EXTERNAL_MODULE_3__;
	
	/***/ },
	/* 4 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_4__;
	
	/***/ },
	/* 5 */
	/***/ function(module, exports, __webpack_require__) {
	
		var map = {};
		function webpackContext(req) {
			return __webpack_require__(webpackContextResolve(req));
		};
		function webpackContextResolve(req) {
			return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
		};
		webpackContext.keys = function webpackContextKeys() {
			return Object.keys(map);
		};
		webpackContext.resolve = webpackContextResolve;
		module.exports = webpackContext;
		webpackContext.id = 5;
	
	
	/***/ }
	/******/ ])
	});
	;
	//# sourceMappingURL=js-data-angular.js.map

/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * js-data
	 * @version 2.9.0 - Homepage <http://www.js-data.io/>
	 * @author Jason Dobry <jason.dobry@gmail.com>
	 * @copyright (c) 2014-2016 Jason Dobry 
	 * @license MIT <https://github.com/js-data/js-data/blob/master/LICENSE>
	 * 
	 * @overview Robust framework-agnostic data store.
	 */
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define([], factory);
		else if(typeof exports === 'object')
			exports["JSData"] = factory();
		else
			root["JSData"] = factory();
	})(this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	/******/
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		var _index = __webpack_require__(1);
		
		var _index2 = _interopRequireDefault(_index);
		
		var _utils = __webpack_require__(2);
		
		var _utils2 = _interopRequireDefault(_utils);
		
		var _errors = __webpack_require__(3);
		
		var _errors2 = _interopRequireDefault(_errors);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		/**
		 * The library export.
		 *   - window.JSData
		 *   - require('js-data')
		 *   - define(['js-data', function (JSData) { ... }]);
		 *   - import JSData from 'js-data'
		 */
		module.exports = {
		  DS: _index2.default,
		  DSUtils: _utils2.default,
		  DSErrors: _errors2.default,
		  createStore: function createStore(options) {
		    return new _index2.default(options);
		  },
		
		  version: {
		    full: '2.9.0',
		    major: parseInt('2', 10),
		    minor: parseInt('9', 10),
		    patch: parseInt('0', 10),
		    alpha:  true ? 'false' : false,
		    beta:  true ? 'false' : false
		  }
		};
	
	/***/ },
	/* 1 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
		
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* jshint eqeqeq:false */
		
		
		var _utils = __webpack_require__(2);
		
		var _utils2 = _interopRequireDefault(_utils);
		
		var _errors = __webpack_require__(3);
		
		var _errors2 = _interopRequireDefault(_errors);
		
		var _index = __webpack_require__(41);
		
		var _index2 = _interopRequireDefault(_index);
		
		var _index3 = __webpack_require__(47);
		
		var _index4 = _interopRequireDefault(_index3);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		function lifecycleNoopCb(resource, attrs, cb) {
		  cb(null, attrs);
		}
		
		function lifecycleNoop(resource, attrs) {
		  return attrs;
		}
		
		function compare(orderBy, index, a, b) {
		  var def = orderBy[index];
		  var cA = _utils2.default.get(a, def[0]);
		  var cB = _utils2.default.get(b, def[0]);
		  if (_utils2.default._s(cA)) {
		    cA = _utils2.default.upperCase(cA);
		  }
		  if (_utils2.default._s(cB)) {
		    cB = _utils2.default.upperCase(cB);
		  }
		  if (def[1] === 'DESC') {
		    if (cB < cA) {
		      return -1;
		    } else if (cB > cA) {
		      return 1;
		    } else {
		      if (index < orderBy.length - 1) {
		        return compare(orderBy, index + 1, a, b);
		      } else {
		        return 0;
		      }
		    }
		  } else {
		    if (cA < cB) {
		      return -1;
		    } else if (cA > cB) {
		      return 1;
		    } else {
		      if (index < orderBy.length - 1) {
		        return compare(orderBy, index + 1, a, b);
		      } else {
		        return 0;
		      }
		    }
		  }
		}
		
		var Defaults = function () {
		  function Defaults() {
		    _classCallCheck(this, Defaults);
		  }
		
		  _createClass(Defaults, [{
		    key: 'errorFn',
		    value: function errorFn(a, b) {
		      if (this.error && typeof this.error === 'function') {
		        try {
		          if (typeof a === 'string') {
		            throw new Error(a);
		          } else {
		            throw a;
		          }
		        } catch (err) {
		          a = err;
		        }
		        this.error(this.name || null, a || null, b || null);
		      }
		    }
		  }]);
		
		  return Defaults;
		}();
		
		var defaultsPrototype = Defaults.prototype;
		
		defaultsPrototype.actions = {};
		defaultsPrototype.afterCreate = lifecycleNoopCb;
		defaultsPrototype.afterCreateCollection = lifecycleNoop;
		defaultsPrototype.afterCreateInstance = lifecycleNoop;
		defaultsPrototype.afterDestroy = lifecycleNoopCb;
		defaultsPrototype.afterEject = lifecycleNoop;
		defaultsPrototype.afterFind = lifecycleNoopCb;
		defaultsPrototype.afterFindAll = lifecycleNoopCb;
		defaultsPrototype.afterInject = lifecycleNoop;
		defaultsPrototype.afterLoadRelations = lifecycleNoopCb;
		defaultsPrototype.afterReap = lifecycleNoop;
		defaultsPrototype.afterUpdate = lifecycleNoopCb;
		defaultsPrototype.afterValidate = lifecycleNoopCb;
		defaultsPrototype.allowSimpleWhere = true;
		defaultsPrototype.basePath = '';
		defaultsPrototype.beforeCreate = lifecycleNoopCb;
		defaultsPrototype.beforeCreateCollection = lifecycleNoop;
		defaultsPrototype.beforeCreateInstance = lifecycleNoop;
		defaultsPrototype.beforeDestroy = lifecycleNoopCb;
		defaultsPrototype.beforeEject = lifecycleNoop;
		defaultsPrototype.beforeInject = lifecycleNoop;
		defaultsPrototype.beforeReap = lifecycleNoop;
		defaultsPrototype.beforeUpdate = lifecycleNoopCb;
		defaultsPrototype.beforeValidate = lifecycleNoopCb;
		defaultsPrototype.bypassCache = false;
		defaultsPrototype.cacheResponse = !!_utils2.default.w;
		defaultsPrototype.csp = false;
		defaultsPrototype.clearEmptyQueries = true;
		defaultsPrototype.computed = {};
		defaultsPrototype.defaultAdapter = 'http';
		defaultsPrototype.debug = false;
		defaultsPrototype.defaultValues = {};
		defaultsPrototype.eagerEject = false;
		// TODO: Implement eagerInject in DS#create
		defaultsPrototype.eagerInject = false;
		defaultsPrototype.endpoint = '';
		defaultsPrototype.error = console ? function (a, b, c) {
		  return console[typeof console.error === 'function' ? 'error' : 'log'](a, b, c);
		} : false;
		defaultsPrototype.errorHandler = function () {
		  return _utils2.default.Promise.reject(arguments.length <= 0 ? undefined : arguments[0]);
		};
		defaultsPrototype.fallbackAdapters = ['http'];
		defaultsPrototype.findStrictCache = false;
		defaultsPrototype.idAttribute = 'id';
		defaultsPrototype.ignoredChanges = [/\$/];
		defaultsPrototype.instanceEvents = !!_utils2.default.w;
		defaultsPrototype.keepChangeHistory = false;
		defaultsPrototype.linkRelations = !!_utils2.default.w;
		defaultsPrototype.log = console ? function (a, b, c, d, e) {
		  return console[typeof console.info === 'function' ? 'info' : 'log'](a, b, c, d, e);
		} : false;
		
		defaultsPrototype.logFn = function (a, b, c, d) {
		  var _this = this;
		  if (_this.debug && _this.log && typeof _this.log === 'function') {
		    _this.log(_this.name || null, a || null, b || null, c || null, d || null);
		  }
		};
		
		defaultsPrototype.maxAge = false;
		defaultsPrototype.methods = {};
		defaultsPrototype.notify = !!_utils2.default.w;
		defaultsPrototype.omit = [];
		defaultsPrototype.onConflict = 'merge';
		defaultsPrototype.reapAction = _utils2.default.w ? 'inject' : 'none';
		defaultsPrototype.reapInterval = _utils2.default.w ? 30000 : false;
		defaultsPrototype.relationsEnumerable = false;
		defaultsPrototype.resetHistoryOnInject = true;
		defaultsPrototype.returnMeta = false;
		defaultsPrototype.scopes = {};
		defaultsPrototype.strategy = 'single';
		defaultsPrototype.upsert = !!_utils2.default.w;
		defaultsPrototype.useClass = true;
		defaultsPrototype.useFilter = false;
		defaultsPrototype.validate = lifecycleNoopCb;
		defaultsPrototype.watchChanges = !!_utils2.default.w;
		
		var escapeRegExp = /([.*+?^=!:${}()|[\]\/\\])/g;
		var percentRegExp = /%/g;
		var underscoreRegExp = /_/g;
		
		function escape(pattern) {
		  return pattern.replace(escapeRegExp, '\\$1');
		}
		
		function like(pattern, flags) {
		  return new RegExp('^' + escape(pattern).replace(percentRegExp, '.*').replace(underscoreRegExp, '.') + '$', flags);
		}
		
		defaultsPrototype.defaultFilter = function (collection, resourceName, params, options) {
		  var definition = this.definitions[resourceName];
		  var idA = 'id';
		  var resource = undefined;
		  if (definition) {
		    idA = definition.idAttribute;
		    resource = this.store[resourceName];
		  }
		  var filtered = collection;
		  var where = null;
		  var reserved = {
		    skip: '',
		    offset: '',
		    where: '',
		    limit: '',
		    orderBy: '',
		    sort: ''
		  };
		
		  params = params || {};
		  options = options || {};
		
		  if (_utils2.default._o(params.where)) {
		    where = params.where;
		  } else {
		    where = {};
		  }
		
		  if (options.allowSimpleWhere) {
		    _utils2.default.forOwn(params, function (value, key) {
		      if (!(key in reserved) && !(key in where)) {
		        where[key] = {
		          '==': value
		        };
		      }
		    });
		  }
		
		  if (_utils2.default.isEmpty(where)) {
		    where = null;
		  }
		
		  if (where) {
		    filtered = _utils2.default.filter(filtered, function (attrs) {
		      var first = true;
		      var keep = true;
		
		      if (options.excludeTemporary && resource && resource.temporaryItems[attrs[idA]]) {
		        return false;
		      }
		
		      _utils2.default.forOwn(where, function (clause, field) {
		        if (!_utils2.default._o(clause)) {
		          clause = {
		            '==': clause
		          };
		        }
		        _utils2.default.forOwn(clause, function (term, op) {
		          var expr = undefined;
		          var isOr = op[0] === '|';
		          var val = _utils2.default.get(attrs, field);
		          op = isOr ? op.substr(1) : op;
		          if (op === '==') {
		            expr = val == term; // eslint-disable-line
		          } else if (op === '===') {
		              expr = val === term;
		            } else if (op === '!=') {
		              expr = val != term; // eslint-disable-line
		            } else if (op === '!==') {
		                expr = val !== term;
		              } else if (op === '>') {
		                expr = val > term;
		              } else if (op === '>=') {
		                expr = val >= term;
		              } else if (op === '<') {
		                expr = val < term;
		              } else if (op === '<=') {
		                expr = val <= term;
		              } else if (op === 'isectEmpty') {
		                expr = !_utils2.default.intersection(val || [], term || []).length;
		              } else if (op === 'isectNotEmpty') {
		                expr = _utils2.default.intersection(val || [], term || []).length;
		              } else if (op === 'in') {
		                if (_utils2.default._s(term)) {
		                  expr = term.indexOf(val) !== -1;
		                } else {
		                  expr = _utils2.default.contains(term, val);
		                }
		              } else if (op === 'notIn') {
		                if (_utils2.default._s(term)) {
		                  expr = term.indexOf(val) === -1;
		                } else {
		                  expr = !_utils2.default.contains(term, val);
		                }
		              } else if (op.indexOf('like') === 0) {
		                expr = like(term, op.substr(4)).exec(val) !== null;
		              } else if (op.indexOf('notLike') === 0) {
		                expr = like(term, op.substr(7)).exec(val) === null;
		              } else if (op === 'contains') {
		                if (_utils2.default._s(val)) {
		                  expr = val.indexOf(term) !== -1;
		                } else {
		                  expr = _utils2.default.contains(val, term);
		                }
		              } else if (op === 'notContains') {
		                if (_utils2.default._s(val)) {
		                  expr = val.indexOf(term) === -1;
		                } else {
		                  expr = !_utils2.default.contains(val, term);
		                }
		              }
		          if (expr !== undefined) {
		            keep = first ? expr : isOr ? keep || expr : keep && expr;
		          }
		          first = false;
		        });
		      });
		
		      return keep;
		    });
		  } else if (options.excludeTemporary && resource) {
		    filtered = _utils2.default.filter(filtered, function (attrs) {
		      return resource.temporaryItems[attrs[idA]];
		    });
		  }
		
		  var orderBy = null;
		
		  if (_utils2.default._s(params.orderBy)) {
		    orderBy = [[params.orderBy, 'ASC']];
		  } else if (_utils2.default._a(params.orderBy)) {
		    orderBy = params.orderBy;
		  }
		
		  if (!orderBy && _utils2.default._s(params.sort)) {
		    orderBy = [[params.sort, 'ASC']];
		  } else if (!orderBy && _utils2.default._a(params.sort)) {
		    orderBy = params.sort;
		  }
		
		  // Apply 'orderBy'
		  if (orderBy) {
		    (function () {
		      var index = 0;
		      _utils2.default.forEach(orderBy, function (def, i) {
		        if (_utils2.default._s(def)) {
		          orderBy[i] = [def, 'ASC'];
		        } else if (!_utils2.default._a(def)) {
		          throw new _errors2.default.IA('DS.filter("' + resourceName + '"[, params][, options]): ' + _utils2.default.toJson(def) + ': Must be a string or an array!', {
		            params: {
		              'orderBy[i]': {
		                actual: typeof def === 'undefined' ? 'undefined' : _typeof(def),
		                expected: 'string|array'
		              }
		            }
		          });
		        }
		      });
		      filtered = _utils2.default.sort(filtered, function (a, b) {
		        return compare(orderBy, index, a, b);
		      });
		    })();
		  }
		
		  var limit = _utils2.default._n(params.limit) ? params.limit : null;
		  var skip = null;
		
		  if (_utils2.default._n(params.skip)) {
		    skip = params.skip;
		  } else if (_utils2.default._n(params.offset)) {
		    skip = params.offset;
		  }
		
		  // Apply 'limit' and 'skip'
		  if (limit && skip) {
		    filtered = _utils2.default.slice(filtered, skip, Math.min(filtered.length, skip + limit));
		  } else if (_utils2.default._n(limit)) {
		    filtered = _utils2.default.slice(filtered, 0, Math.min(filtered.length, limit));
		  } else if (_utils2.default._n(skip)) {
		    if (skip < filtered.length) {
		      filtered = _utils2.default.slice(filtered, skip);
		    } else {
		      filtered = [];
		    }
		  }
		
		  return filtered === collection ? filtered.slice() : filtered;
		};
		
		var DS = function () {
		  function DS(options) {
		    _classCallCheck(this, DS);
		
		    var _this = this;
		    options = options || {};
		
		    _this.store = {};
		    _this.definitions = {};
		    _this.adapters = {};
		    _this.defaults = new Defaults();
		    _this.observe = _utils2.default.observe;
		    _utils2.default.forOwn(options, function (v, k) {
		      if (k === 'omit') {
		        _this.defaults.omit = v.concat(Defaults.prototype.omit);
		      } else {
		        _this.defaults[k] = v;
		      }
		    });
		    _this.defaults.logFn('new data store created', _this.defaults);
		
		    var P = _utils2.default.Promise;
		
		    if (P && !P.prototype.spread) {
		      P.prototype.spread = function (cb) {
		        return this.then(function (arr) {
		          return cb.apply(this, arr);
		        });
		      };
		    }
		
		    _utils2.default.Events(_this);
		  }
		
		  _createClass(DS, [{
		    key: 'getAdapterName',
		    value: function getAdapterName(options) {
		      var errorIfNotExist = false;
		      options = options || {};
		      this.defaults.logFn('getAdapterName', options);
		      if (_utils2.default._s(options)) {
		        errorIfNotExist = true;
		        options = {
		          adapter: options
		        };
		      }
		      if (this.adapters[options.adapter]) {
		        return options.adapter;
		      } else if (errorIfNotExist) {
		        throw new Error(options.adapter + ' is not a registered adapter!');
		      } else {
		        return options.defaultAdapter;
		      }
		    }
		  }, {
		    key: 'getAdapter',
		    value: function getAdapter(options) {
		      options = options || {};
		      this.defaults.logFn('getAdapter', options);
		      return this.adapters[this.getAdapterName(options)];
		    }
		  }, {
		    key: 'registerAdapter',
		    value: function registerAdapter(name, Adapter, options) {
		      var _this = this;
		      options = options || {};
		      _this.defaults.logFn('registerAdapter', name, Adapter, options);
		      if (_utils2.default.isFunction(Adapter)) {
		        _this.adapters[name] = new Adapter(options);
		      } else {
		        _this.adapters[name] = Adapter;
		      }
		      if (options.default) {
		        _this.defaults.defaultAdapter = name;
		      }
		      _this.defaults.logFn('default adapter is ' + _this.defaults.defaultAdapter);
		    }
		  }, {
		    key: 'is',
		    value: function is(resourceName, instance) {
		      var definition = this.definitions[resourceName];
		      if (!definition) {
		        throw new _errors2.default.NER(resourceName);
		      }
		      return instance instanceof definition[definition.class];
		    }
		  }, {
		    key: 'clear',
		    value: function clear() {
		      var _this2 = this;
		
		      var ejected = {};
		      _utils2.default.forOwn(this.definitions, function (definition) {
		        var name = definition.name;
		        ejected[name] = definition.ejectAll();
		        _this2.store[name].completedQueries = {};
		        _this2.store[name].queryData = {};
		      });
		      return ejected;
		    }
		  }, {
		    key: 'errorFn',
		    value: function errorFn() {
		      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
		        args[_key] = arguments[_key];
		      }
		
		      var options = args[args.length - 1];
		      var defaultHandler = this.defaults.errorHandler;
		      var errorHandler = options ? options.errorHandler : defaultHandler;
		      errorHandler = errorHandler || defaultHandler;
		      return function (err) {
		        return errorHandler.apply(undefined, [err].concat(args));
		      };
		    }
		  }]);
		
		  return DS;
		}();
		
		var dsPrototype = DS.prototype;
		
		dsPrototype.getAdapterName.shorthand = false;
		dsPrototype.getAdapter.shorthand = false;
		dsPrototype.registerAdapter.shorthand = false;
		dsPrototype.errors = _errors2.default;
		dsPrototype.utils = _utils2.default;
		
		function addMethods(target, obj) {
		  _utils2.default.forOwn(obj, function (v, k) {
		    target[k] = v;
		    target[k].before = function (fn) {
		      var orig = target[k];
		      target[k] = function () {
		        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
		          args[_key2] = arguments[_key2];
		        }
		
		        return orig.apply(this, fn.apply(this, args) || args);
		      };
		    };
		  });
		}
		
		addMethods(dsPrototype, _index2.default);
		addMethods(dsPrototype, _index4.default);
		
		exports.default = DS;
	
	/***/ },
	/* 2 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; }; /* jshint eqeqeq:false */
		
		/**
		 * Mix of ES6 and CommonJS module imports because the interop of Babel + Webpack + ES6 modules + CommonJS isn't very good.
		 */
		
		
		var _errors = __webpack_require__(3);
		
		var _errors2 = _interopRequireDefault(_errors);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		var BinaryHeap = __webpack_require__(4);
		var forEach = __webpack_require__(5);
		var slice = __webpack_require__(6);
		var forOwn = __webpack_require__(7);
		var contains = __webpack_require__(10);
		var deepMixIn = __webpack_require__(12);
		var pascalCase = __webpack_require__(14);
		var remove = __webpack_require__(21);
		var pick = __webpack_require__(22);
		var _keys = __webpack_require__(23);
		var sort = __webpack_require__(24);
		var upperCase = __webpack_require__(19);
		var get = __webpack_require__(25);
		var set = __webpack_require__(27);
		var observe = __webpack_require__(29);
		var guid = __webpack_require__(30);
		var w = undefined,
		    P = undefined,
		    File = undefined;
		var objectProto = Object.prototype;
		var toString = objectProto.toString;
		
		/**
		 * Attempt to detect the global Promise constructor.
		 * JSData will still work without one, as long you do something like this:
		 *
		 * var JSData = require('js-data');
		 * JSData.DSUtils.Promise = MyPromiseLib;
		 */
		try {
		  P = Promise;
		} catch (e) {
		  console.error('js-data requires a global Promise constructor!');
		}
		
		try {
		  File = window.File;
		} catch (e) {
		  File = function File() {};
		}
		
		function _isArray(value) {
		  return toString.call(value) === '[object Array]' || false;
		}
		
		var isArray = Array.isArray || _isArray;
		
		function isRegExp(value) {
		  return toString.call(value) === '[object RegExp]' || false;
		}
		
		// adapted from lodash.isString
		function isString(value) {
		  return typeof value === 'string' || value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && toString.call(value) === '[object String]' || false;
		}
		
		function isObject(value) {
		  return toString.call(value) === '[object Object]' || false;
		}
		
		// adapted from lodash.isDate
		function isDate(value) {
		  return value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && toString.call(value) === '[object Date]' || false;
		}
		
		// adapted from lodash.isNumber
		function isNumber(value) {
		  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
		  return type === 'number' || value && type === 'object' && toString.call(value) === '[object Number]' || false;
		}
		
		// adapted from lodash.isFunction
		function isFunction(value) {
		  return typeof value === 'function' || value && toString.call(value) === '[object Function]' || false;
		}
		
		// shorthand argument checking functions, using these shaves 1.18 kb off of the minified build
		function isStringOrNumber(value) {
		  return isString(value) || isNumber(value);
		}
		
		function isStringOrNumberErr(field) {
		  return new _errors2.default.IA('"' + field + '" must be a string or a number!');
		}
		
		function isObjectErr(field) {
		  return new _errors2.default.IA('"' + field + '" must be an object!');
		}
		
		function isArrayErr(field) {
		  return new _errors2.default.IA('"' + field + '" must be an array!');
		}
		
		// adapted from mout.isEmpty
		function isEmpty(val) {
		  if (val == null) {
		    // jshint ignore:line
		    // typeof null == 'object' so we check it first
		    return true;
		  } else if (typeof val === 'string' || isArray(val)) {
		    return !val.length;
		  } else if ((typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object') {
		    var result = true;
		    forOwn(val, function () {
		      result = false;
		      return false; // break loop
		    });
		    return result;
		  } else {
		    return true;
		  }
		}
		
		// Find the intersection between two arrays
		function intersection(array1, array2) {
		  if (!array1 || !array2) {
		    return [];
		  }
		  var result = [];
		  var item = undefined;
		  for (var i = 0, length = array1.length; i < length; i++) {
		    item = array1[i];
		    if (contains(result, item)) {
		      continue;
		    }
		    if (contains(array2, item)) {
		      result.push(item);
		    }
		  }
		  return result;
		}
		
		function filter(array, cb, thisObj) {
		  var results = [];
		  forEach(array, function (value, key, arr) {
		    if (cb(value, key, arr)) {
		      results.push(value);
		    }
		  }, thisObj);
		  return results;
		}
		
		/**
		 * Attempt to detect whether we are in the browser.
		 */
		try {
		  w = window;
		  w = {};
		} catch (e) {
		  w = null;
		}
		
		/**
		 * Event mixin. Usage:
		 *
		 * function handler() { ... }
		 * Events(myObject);
		 * myObject.on('foo', handler);
		 * myObject.emit('foo', 'some', 'data');
		 * myObject.off('foo', handler);
		 */
		function Events(target) {
		  var events = {};
		  target = target || this;
		  Object.defineProperties(target, {
		    on: {
		      value: function value(type, func, ctx) {
		        events[type] = events[type] || [];
		        events[type].push({
		          f: func,
		          c: ctx
		        });
		      }
		    },
		    off: {
		      value: function value(type, func) {
		        var listeners = events[type];
		        if (!listeners) {
		          events = {};
		        } else if (func) {
		          for (var i = 0; i < listeners.length; i++) {
		            if (listeners[i].f === func) {
		              listeners.splice(i, 1);
		              break;
		            }
		          }
		        } else {
		          listeners.splice(0, listeners.length);
		        }
		      }
		    },
		    emit: {
		      value: function value() {
		        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
		          args[_key] = arguments[_key];
		        }
		
		        var listeners = events[args.shift()] || [];
		        if (listeners) {
		          for (var i = 0; i < listeners.length; i++) {
		            listeners[i].f.apply(listeners[i].c, args);
		          }
		        }
		      }
		    }
		  });
		}
		
		/**
		 * Lifecycle hooks that should support promises.
		 */
		var toPromisify = ['beforeValidate', 'validate', 'afterValidate', 'beforeCreate', 'afterCreate', 'beforeUpdate', 'afterUpdate', 'beforeDestroy', 'afterDestroy'];
		
		/**
		 * Return whether "prop" is in the blacklist.
		 */
		var isBlacklisted = observe.isBlacklisted;
		
		// adapted from angular.copy
		function copy(source, destination, stackSource, stackDest, blacklist) {
		  if (!destination) {
		    destination = source;
		    if (source) {
		      if (isArray(source)) {
		        destination = copy(source, [], stackSource, stackDest, blacklist);
		      } else if (isDate(source)) {
		        destination = new Date(source.getTime());
		      } else if (isRegExp(source)) {
		        destination = new RegExp(source.source, source.toString().match(/[^\/]*$/)[0]);
		        destination.lastIndex = source.lastIndex;
		      } else if (isObject(source)) {
		        destination = copy(source, Object.create(Object.getPrototypeOf(source)), stackSource, stackDest, blacklist);
		      }
		    }
		  } else {
		    if (source === destination) {
		      throw new Error('Cannot copy! Source and destination are identical.');
		    }
		
		    stackSource = stackSource || [];
		    stackDest = stackDest || [];
		
		    if (isObject(source)) {
		      var index = stackSource.indexOf(source);
		      if (index !== -1) {
		        return stackDest[index];
		      }
		
		      stackSource.push(source);
		      stackDest.push(destination);
		    }
		
		    var result = undefined;
		    if (isArray(source)) {
		      var i = undefined;
		      destination.length = 0;
		      for (i = 0; i < source.length; i++) {
		        result = copy(source[i], null, stackSource, stackDest, blacklist);
		        if (isObject(source[i])) {
		          stackSource.push(source[i]);
		          stackDest.push(result);
		        }
		        destination.push(result);
		      }
		    } else {
		      if (isArray(destination)) {
		        destination.length = 0;
		      } else {
		        forEach(destination, function (value, key) {
		          delete destination[key];
		        });
		      }
		      for (var key in source) {
		        if (source.hasOwnProperty(key)) {
		          if (isBlacklisted(key, blacklist)) {
		            continue;
		          }
		          result = copy(source[key], null, stackSource, stackDest, blacklist);
		          if (isObject(source[key])) {
		            stackSource.push(source[key]);
		            stackDest.push(result);
		          }
		          destination[key] = result;
		        }
		      }
		    }
		  }
		  return destination;
		}
		
		// adapted from angular.equals
		function equals(o1, o2) {
		  if (o1 === o2) {
		    return true;
		  }
		  if (o1 === null || o2 === null) {
		    return false;
		  }
		  if (o1 !== o1 && o2 !== o2) {
		    // eslint-disable-line
		    return true;
		  } // NaN === NaN
		  var t1 = typeof o1 === 'undefined' ? 'undefined' : _typeof(o1);
		  var t2 = typeof o2 === 'undefined' ? 'undefined' : _typeof(o2);
		  var length, key, keySet;
		  if (t1 == t2) {
		    // eslint-disable-line
		    if (t1 == 'object') {
		      // eslint-disable-line
		      if (isArray(o1)) {
		        if (!isArray(o2)) {
		          return false;
		        }
		        if ((length = o1.length) === o2.length) {
		          // jshint ignore:line
		          for (key = 0; key < length; key++) {
		            if (!equals(o1[key], o2[key])) {
		              return false;
		            }
		          }
		          return true;
		        }
		      } else if (isDate(o1)) {
		        if (!isDate(o2)) {
		          return false;
		        }
		        return equals(o1.getTime(), o2.getTime());
		      } else if (isRegExp(o1) && isRegExp(o2)) {
		        return o1.toString() == o2.toString(); // eslint-disable-line
		      } else {
		          if (isArray(o2)) {
		            return false;
		          }
		          keySet = {};
		          for (key in o1) {
		            if (key.charAt(0) === '$' || isFunction(o1[key])) {
		              continue;
		            }
		            if (!equals(o1[key], o2[key])) {
		              return false;
		            }
		            keySet[key] = true;
		          }
		          for (key in o2) {
		            if (!keySet.hasOwnProperty(key) && key.charAt(0) !== '$' && o2[key] !== undefined && !isFunction(o2[key])) {
		              return false;
		            }
		          }
		          return true;
		        }
		    }
		  }
		  return false;
		}
		
		/**
		 * Given either an instance or the primary key of an instance, return the primary key.
		 */
		function resolveId(definition, idOrInstance) {
		  if (isString(idOrInstance) || isNumber(idOrInstance)) {
		    return idOrInstance;
		  } else if (idOrInstance && definition) {
		    return idOrInstance[definition.idAttribute] || idOrInstance;
		  } else {
		    return idOrInstance;
		  }
		}
		
		/**
		 * Given either an instance or the primary key of an instance, return the instance.
		 */
		function resolveItem(resource, idOrInstance) {
		  if (resource && (isString(idOrInstance) || isNumber(idOrInstance))) {
		    return resource.index[idOrInstance] || idOrInstance;
		  } else {
		    return idOrInstance;
		  }
		}
		
		function isValidString(val) {
		  return val != null && val !== ''; // jshint ignore:line
		}
		
		function join(items, separator) {
		  separator = separator || '';
		  return filter(items, isValidString).join(separator);
		}
		
		function makePath() {
		  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
		    args[_key2] = arguments[_key2];
		  }
		
		  var result = join(args, '/');
		  return result.replace(/([^:\/]|^)\/{2,}/g, '$1/');
		}
		
		exports.default = {
		  Promise: P,
		  /**
		   * Method to wrap an "options" object so that it will inherit from
		   * some parent object, such as a resource definition.
		   */
		  _: function _(parent, options) {
		    var _this = this;
		    parent = parent || {};
		    options = options || {};
		    if (options && options.constructor === parent.constructor) {
		      return options;
		    } else if (!isObject(options)) {
		      throw new _errors2.default.IA('"options" must be an object!');
		    }
		    forEach(toPromisify, function (name) {
		      if (typeof options[name] === 'function' && options[name].toString().indexOf('for (var _len = arg') === -1) {
		        options[name] = _this.promisify(options[name]);
		      }
		    });
		    // Dynamic constructor function
		    var O = function Options(attrs) {
		      var self = this;
		      forOwn(attrs, function (value, key) {
		        self[key] = value;
		      });
		    };
		    // Inherit from some parent object
		    O.prototype = parent;
		    // Give us a way to get the original options back.
		    O.prototype.orig = function () {
		      var orig = {};
		      forOwn(this, function (value, key) {
		        orig[key] = value;
		      });
		      return orig;
		    };
		    return new O(options);
		  },
		
		  _n: isNumber,
		  _s: isString,
		  _sn: isStringOrNumber,
		  _snErr: isStringOrNumberErr,
		  _o: isObject,
		  _oErr: isObjectErr,
		  _a: isArray,
		  _aErr: isArrayErr,
		  applyScope: function applyScope(definition, params, options) {
		    var scope = options.scope;
		    var _params = copy(params);
		    if (scope) {
		      if (isString(scope)) {
		        scope = [scope];
		      }
		    } else {
		      scope = [];
		    }
		    scope.unshift('defaultScope');
		    forEach(scope, function (_scope) {
		      var scopeDef = options.scopes[_scope];
		      if (typeof scopeDef === 'function') {
		        deepMixIn(params, scopeDef(definition));
		      } else if (scopeDef) {
		        deepMixIn(params, scopeDef);
		      }
		    });
		    deepMixIn(params, _params);
		  },
		  compute: function compute(fn, field) {
		    var _this = this;
		    var args = [];
		    if (!isObject(fn)) {
		      forEach(fn.deps, function (dep) {
		        args.push(get(_this, dep));
		      });
		      // compute property
		      set(_this, field, fn[fn.length - 1].apply(_this, args));
		    }
		  },
		
		  contains: contains,
		  copy: copy,
		  deepMixIn: deepMixIn,
		  diffObjectFromOldObject: observe.diffObjectFromOldObject,
		  BinaryHeap: BinaryHeap,
		  equals: equals,
		  Events: Events,
		  filter: filter,
		  fillIn: function fillIn(target, obj) {
		    forOwn(obj, function (v, k) {
		      if (!(k in target)) {
		        target[k] = v;
		      }
		    });
		    return target;
		  },
		
		  forEach: forEach,
		  forOwn: forOwn,
		  fromJson: function fromJson(json) {
		    return isString(json) ? JSON.parse(json) : json;
		  },
		
		  get: get,
		  guid: guid,
		  intersection: intersection,
		  isArray: isArray,
		  isBlacklisted: isBlacklisted,
		  isEmpty: isEmpty,
		  isFunction: isFunction,
		  isObject: isObject,
		  isNumber: isNumber,
		  isString: isString,
		  keys: _keys,
		  makePath: makePath,
		  observe: observe,
		  omit: function omit(obj, bl) {
		    var toRemove = [];
		    forOwn(obj, function (v, k) {
		      if (isBlacklisted(k, bl)) {
		        toRemove.push(k);
		      }
		    });
		    forEach(toRemove, function (k) {
		      delete obj[k];
		    });
		    return obj;
		  },
		
		  pascalCase: pascalCase,
		  pick: pick,
		  // Turn the given node-style callback function into one that can return a promise.
		  promisify: function promisify(fn, target) {
		    var _this = this;
		    if (!fn) {
		      return;
		    } else if (typeof fn !== 'function') {
		      throw new Error('Can only promisify functions!');
		    }
		    return function () {
		      for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
		        args[_key3] = arguments[_key3];
		      }
		
		      return new _this.Promise(function (resolve, reject) {
		        args.push(function (err, result) {
		          if (err) {
		            reject(err);
		          } else {
		            resolve(result);
		          }
		        });
		
		        try {
		          var promise = fn.apply(target || this, args);
		          if (promise && promise.then) {
		            promise.then(resolve, reject);
		          }
		        } catch (err) {
		          reject(err);
		        }
		      });
		    };
		  },
		
		  remove: remove,
		  set: set,
		  slice: slice,
		  sort: sort,
		  toJson: JSON.stringify,
		  updateTimestamp: function updateTimestamp(timestamp) {
		    var newTimestamp = typeof Date.now === 'function' ? Date.now() : new Date().getTime();
		    if (timestamp && newTimestamp <= timestamp) {
		      return timestamp + 1;
		    } else {
		      return newTimestamp;
		    }
		  },
		
		  upperCase: upperCase,
		  // Return a copy of "object" with cycles removed.
		  removeCircular: function removeCircular(object) {
		    return function rmCirc(value, ctx) {
		      var i = undefined;
		      var nu = undefined;
		
		      if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value !== null && !(value instanceof Boolean) && !(value instanceof Date) && !(value instanceof Number) && !(value instanceof RegExp) && !(value instanceof String) && (!File || !(value instanceof File))) {
		        // check if current object points back to itself
		        var cur = ctx.cur;
		        var parent = ctx.ctx;
		        while (parent) {
		          if (parent.cur === cur) {
		            return undefined;
		          }
		          parent = parent.ctx;
		        }
		
		        if (isArray(value)) {
		          nu = [];
		          for (i = 0; i < value.length; i += 1) {
		            nu[i] = rmCirc(value[i], { ctx: ctx, cur: value[i] });
		          }
		        } else {
		          nu = {};
		          forOwn(value, function (v, k) {
		            nu[k] = rmCirc(value[k], { ctx: ctx, cur: value[k] });
		          });
		        }
		        return nu;
		      }
		      return value;
		    }(object, { ctx: null, cur: object });
		  },
		
		  resolveItem: resolveItem,
		  resolveId: resolveId,
		  respond: function respond(response, meta, options) {
		    if (options.returnMeta === 'array') {
		      return [response, meta];
		    } else if (options.returnMeta === 'object') {
		      return { response: response, meta: meta };
		    } else {
		      return response;
		    }
		  },
		
		  w: w,
		  // This is where the magic of relations happens.
		  applyRelationGettersToTarget: function applyRelationGettersToTarget(store, definition, target) {
		    this.forEach(definition.relationList, function (def) {
		      var relationName = def.relation;
		      var localField = def.localField;
		      var localKey = def.localKey;
		      var foreignKey = def.foreignKey;
		      var localKeys = def.localKeys;
		      var foreignKeys = def.foreignKeys;
		      var enumerable = typeof def.enumerable === 'boolean' ? def.enumerable : !!definition.relationsEnumerable;
		      if (typeof def.link === 'boolean' ? def.link : !!definition.linkRelations) {
		        delete target[localField];
		        var prop = {
		          enumerable: enumerable
		        };
		        if (def.type === 'belongsTo') {
		          prop.get = function () {
		            var key = get(this, localKey);
		            var hasKey = !!(key || key === 0);
		            return hasKey ? definition.getResource(relationName).get(key) : undefined;
		          };
		          prop.set = function (parent) {
		            if (parent) {
		              set(this, localKey, get(parent, definition.getResource(relationName).idAttribute));
		            }
		            return get(this, localField);
		          };
		        } else if (def.type === 'hasMany') {
		          prop.get = function () {
		            var params = {};
		            if (foreignKey) {
		              params[foreignKey] = this[definition.idAttribute];
		              return definition.getResource(relationName).defaultFilter.call(store, store.store[relationName].collection, relationName, params, { allowSimpleWhere: true });
		            } else if (localKeys) {
		              var keys = get(this, localKeys) || [];
		              return definition.getResource(relationName).getAll(isArray(keys) ? keys : _keys(keys));
		            } else if (foreignKeys) {
		              set(params, 'where.' + foreignKeys + '.contains', this[definition.idAttribute]);
		              return definition.getResource(relationName).defaultFilter.call(store, store.store[relationName].collection, relationName, params);
		            }
		            return undefined;
		          };
		          prop.set = function (children) {
		            var _this2 = this;
		
		            if (children && children.length) {
		              (function () {
		                var id = get(_this2, definition.idAttribute);
		                if (foreignKey) {
		                  forEach(children, function (child) {
		                    set(child, foreignKey, id);
		                  });
		                } else if (localKeys) {
		                  (function () {
		                    var keys = [];
		                    forEach(children, function (child) {
		                      keys.push(get(child, definition.getResource(relationName).idAttribute));
		                    });
		                    set(_this2, localKeys, keys);
		                  })();
		                } else if (foreignKeys) {
		                  forEach(children, function (child) {
		                    var keys = get(child, foreignKeys);
		                    if (keys) {
		                      if (!contains(keys, id)) {
		                        keys.push(id);
		                      }
		                    } else {
		                      set(child, foreignKeys, [id]);
		                    }
		                  });
		                }
		              })();
		            }
		            return get(this, localField);
		          };
		        } else if (def.type === 'hasOne') {
		          if (localKey) {
		            prop.get = function () {
		              var key = get(this, localKey);
		              var hasKey = !!(key || key === 0);
		              return hasKey ? definition.getResource(relationName).get(key) : undefined;
		            };
		            prop.set = function (sibling) {
		              if (sibling) {
		                set(this, localKey, get(sibling, definition.getResource(relationName).idAttribute));
		              }
		              return get(this, localField);
		            };
		          } else {
		            prop.get = function () {
		              var params = {};
		              params[foreignKey] = this[definition.idAttribute];
		              var items = params[foreignKey] ? definition.getResource(relationName).defaultFilter.call(store, store.store[relationName].collection, relationName, params, { allowSimpleWhere: true }) : [];
		              if (items.length) {
		                return items[0];
		              }
		              return undefined;
		            };
		            prop.set = function (sibling) {
		              if (sibling) {
		                set(sibling, foreignKey, get(this, definition.idAttribute));
		              }
		              return get(this, localField);
		            };
		          }
		        }
		        if (def.get) {
		          (function () {
		            var orig = prop.get;
		            prop.get = function () {
		              var _this3 = this;
		
		              return def.get(definition, def, this, function () {
		                for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
		                  args[_key4] = arguments[_key4];
		                }
		
		                return orig.apply(_this3, args);
		              });
		            };
		          })();
		        }
		        Object.defineProperty(target, localField, prop);
		      }
		    });
		  }
		};
	
	/***/ },
	/* 3 */
	/***/ function(module, exports) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
		
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
		
		/**
		 * Thrown during a method call when an argument passed into the method is invalid.
		 */
		
		var IllegalArgumentError = function (_Error) {
		  _inherits(IllegalArgumentError, _Error);
		
		  function IllegalArgumentError(message) {
		    _classCallCheck(this, IllegalArgumentError);
		
		    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(IllegalArgumentError).call(this));
		
		    if (typeof Error.captureStackTrace === 'function') {
		      Error.captureStackTrace(_this, _this.constructor);
		    }
		    _this.type = _this.constructor.name;
		    _this.message = message;
		    return _this;
		  }
		
		  return IllegalArgumentError;
		}(Error);
		
		/**
		 * Thrown when an invariant is violated or unrecoverable error is encountered during execution.
		 */
		
		
		var RuntimeError = function (_Error2) {
		  _inherits(RuntimeError, _Error2);
		
		  function RuntimeError(message) {
		    _classCallCheck(this, RuntimeError);
		
		    var _this2 = _possibleConstructorReturn(this, Object.getPrototypeOf(RuntimeError).call(this));
		
		    if (typeof Error.captureStackTrace === 'function') {
		      Error.captureStackTrace(_this2, _this2.constructor);
		    }
		    _this2.type = _this2.constructor.name;
		    _this2.message = message;
		    return _this2;
		  }
		
		  return RuntimeError;
		}(Error);
		
		/**
		 * Thrown when attempting to access or work with a non-existent resource.
		 */
		
		
		var NonexistentResourceError = function (_Error3) {
		  _inherits(NonexistentResourceError, _Error3);
		
		  function NonexistentResourceError(resourceName) {
		    _classCallCheck(this, NonexistentResourceError);
		
		    var _this3 = _possibleConstructorReturn(this, Object.getPrototypeOf(NonexistentResourceError).call(this));
		
		    if (typeof Error.captureStackTrace === 'function') {
		      Error.captureStackTrace(_this3, _this3.constructor);
		    }
		    _this3.type = _this3.constructor.name;
		    _this3.message = resourceName + ' is not a registered resource!';
		    return _this3;
		  }
		
		  return NonexistentResourceError;
		}(Error);
		
		exports.default = {
		  IllegalArgumentError: IllegalArgumentError,
		  IA: IllegalArgumentError,
		  RuntimeError: RuntimeError,
		  R: RuntimeError,
		  NonexistentResourceError: NonexistentResourceError,
		  NER: NonexistentResourceError
		};
	
	/***/ },
	/* 4 */
	/***/ function(module, exports, __webpack_require__) {
	
		/*!
		 * yabh
		 * @version 1.1.0 - Homepage <http://jmdobry.github.io/yabh/>
		 * @author Jason Dobry <jason.dobry@gmail.com>
		 * @copyright (c) 2015 Jason Dobry 
		 * @license MIT <https://github.com/jmdobry/yabh/blob/master/LICENSE>
		 * 
		 * @overview Yet another Binary Heap.
		 */
		(function webpackUniversalModuleDefinition(root, factory) {
			if(true)
				module.exports = factory();
			else if(typeof define === 'function' && define.amd)
				define("yabh", factory);
			else if(typeof exports === 'object')
				exports["BinaryHeap"] = factory();
			else
				root["BinaryHeap"] = factory();
		})(this, function() {
		return /******/ (function(modules) { // webpackBootstrap
		/******/ 	// The module cache
		/******/ 	var installedModules = {};
		
		/******/ 	// The require function
		/******/ 	function __webpack_require__(moduleId) {
		
		/******/ 		// Check if module is in cache
		/******/ 		if(installedModules[moduleId])
		/******/ 			return installedModules[moduleId].exports;
		
		/******/ 		// Create a new module (and put it into the cache)
		/******/ 		var module = installedModules[moduleId] = {
		/******/ 			exports: {},
		/******/ 			id: moduleId,
		/******/ 			loaded: false
		/******/ 		};
		
		/******/ 		// Execute the module function
		/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
		
		/******/ 		// Flag the module as loaded
		/******/ 		module.loaded = true;
		
		/******/ 		// Return the exports of the module
		/******/ 		return module.exports;
		/******/ 	}
		
		
		/******/ 	// expose the modules object (__webpack_modules__)
		/******/ 	__webpack_require__.m = modules;
		
		/******/ 	// expose the module cache
		/******/ 	__webpack_require__.c = installedModules;
		
		/******/ 	// __webpack_public_path__
		/******/ 	__webpack_require__.p = "";
		
		/******/ 	// Load entry module and return exports
		/******/ 	return __webpack_require__(0);
		/******/ })
		/************************************************************************/
		/******/ ([
		/* 0 */
		/***/ function(module, exports, __webpack_require__) {
		
			/**
			 * @method bubbleUp
			 * @param {array} heap The heap.
			 * @param {function} weightFunc The weight function.
			 * @param {number} n The index of the element to bubble up.
			 */
			function bubbleUp(heap, weightFunc, n) {
			  var element = heap[n];
			  var weight = weightFunc(element);
			  // When at 0, an element can not go up any further.
			  while (n > 0) {
			    // Compute the parent element's index, and fetch it.
			    var parentN = Math.floor((n + 1) / 2) - 1;
			    var _parent = heap[parentN];
			    // If the parent has a lesser weight, things are in order and we
			    // are done.
			    if (weight >= weightFunc(_parent)) {
			      break;
			    } else {
			      heap[parentN] = element;
			      heap[n] = _parent;
			      n = parentN;
			    }
			  }
			}
		
			/**
			 * @method bubbleDown
			 * @param {array} heap The heap.
			 * @param {function} weightFunc The weight function.
			 * @param {number} n The index of the element to sink down.
			 */
			var bubbleDown = function bubbleDown(heap, weightFunc, n) {
			  var length = heap.length;
			  var node = heap[n];
			  var nodeWeight = weightFunc(node);
		
			  while (true) {
			    var child2N = (n + 1) * 2,
			        child1N = child2N - 1;
			    var swap = null;
			    if (child1N < length) {
			      var child1 = heap[child1N],
			          child1Weight = weightFunc(child1);
			      // If the score is less than our node's, we need to swap.
			      if (child1Weight < nodeWeight) {
			        swap = child1N;
			      }
			    }
			    // Do the same checks for the other child.
			    if (child2N < length) {
			      var child2 = heap[child2N],
			          child2Weight = weightFunc(child2);
			      if (child2Weight < (swap === null ? nodeWeight : weightFunc(heap[child1N]))) {
			        swap = child2N;
			      }
			    }
		
			    if (swap === null) {
			      break;
			    } else {
			      heap[n] = heap[swap];
			      heap[swap] = node;
			      n = swap;
			    }
			  }
			};
		
			function BinaryHeap(weightFunc, compareFunc) {
			  if (!weightFunc) {
			    weightFunc = function (x) {
			      return x;
			    };
			  }
			  if (!compareFunc) {
			    compareFunc = function (x, y) {
			      return x === y;
			    };
			  }
			  if (typeof weightFunc !== 'function') {
			    throw new Error('BinaryHeap([weightFunc][, compareFunc]): "weightFunc" must be a function!');
			  }
			  if (typeof compareFunc !== 'function') {
			    throw new Error('BinaryHeap([weightFunc][, compareFunc]): "compareFunc" must be a function!');
			  }
			  this.weightFunc = weightFunc;
			  this.compareFunc = compareFunc;
			  this.heap = [];
			}
		
			var BHProto = BinaryHeap.prototype;
		
			BHProto.push = function (node) {
			  this.heap.push(node);
			  bubbleUp(this.heap, this.weightFunc, this.heap.length - 1);
			};
		
			BHProto.peek = function () {
			  return this.heap[0];
			};
		
			BHProto.pop = function () {
			  var front = this.heap[0];
			  var end = this.heap.pop();
			  if (this.heap.length > 0) {
			    this.heap[0] = end;
			    bubbleDown(this.heap, this.weightFunc, 0);
			  }
			  return front;
			};
		
			BHProto.remove = function (node) {
			  var length = this.heap.length;
			  for (var i = 0; i < length; i++) {
			    if (this.compareFunc(this.heap[i], node)) {
			      var removed = this.heap[i];
			      var end = this.heap.pop();
			      if (i !== length - 1) {
			        this.heap[i] = end;
			        bubbleUp(this.heap, this.weightFunc, i);
			        bubbleDown(this.heap, this.weightFunc, i);
			      }
			      return removed;
			    }
			  }
			  return null;
			};
		
			BHProto.removeAll = function () {
			  this.heap = [];
			};
		
			BHProto.size = function () {
			  return this.heap.length;
			};
		
			module.exports = BinaryHeap;
		
		/***/ }
		/******/ ])
		});
		;
	
	/***/ },
	/* 5 */
	/***/ function(module, exports) {
	
		
		
		    /**
		     * Array forEach
		     */
		    function forEach(arr, callback, thisObj) {
		        if (arr == null) {
		            return;
		        }
		        var i = -1,
		            len = arr.length;
		        while (++i < len) {
		            // we iterate over sparse items since there is no way to make it
		            // work properly on IE 7-8. see #64
		            if ( callback.call(thisObj, arr[i], i, arr) === false ) {
		                break;
		            }
		        }
		    }
		
		    module.exports = forEach;
		
		
	
	
	/***/ },
	/* 6 */
	/***/ function(module, exports) {
	
		
		
		    /**
		     * Create slice of source array or array-like object
		     */
		    function slice(arr, start, end){
		        var len = arr.length;
		
		        if (start == null) {
		            start = 0;
		        } else if (start < 0) {
		            start = Math.max(len + start, 0);
		        } else {
		            start = Math.min(start, len);
		        }
		
		        if (end == null) {
		            end = len;
		        } else if (end < 0) {
		            end = Math.max(len + end, 0);
		        } else {
		            end = Math.min(end, len);
		        }
		
		        var result = [];
		        while (start < end) {
		            result.push(arr[start++]);
		        }
		
		        return result;
		    }
		
		    module.exports = slice;
		
		
	
	
	/***/ },
	/* 7 */
	/***/ function(module, exports, __webpack_require__) {
	
		var hasOwn = __webpack_require__(8);
		var forIn = __webpack_require__(9);
		
		    /**
		     * Similar to Array/forEach but works over object properties and fixes Don't
		     * Enum bug on IE.
		     * based on: http://whattheheadsaid.com/2010/10/a-safer-object-keys-compatibility-implementation
		     */
		    function forOwn(obj, fn, thisObj){
		        forIn(obj, function(val, key){
		            if (hasOwn(obj, key)) {
		                return fn.call(thisObj, obj[key], key, obj);
		            }
		        });
		    }
		
		    module.exports = forOwn;
		
		
	
	
	/***/ },
	/* 8 */
	/***/ function(module, exports) {
	
		
		
		    /**
		     * Safer Object.hasOwnProperty
		     */
		     function hasOwn(obj, prop){
		         return Object.prototype.hasOwnProperty.call(obj, prop);
		     }
		
		     module.exports = hasOwn;
		
		
	
	
	/***/ },
	/* 9 */
	/***/ function(module, exports, __webpack_require__) {
	
		var hasOwn = __webpack_require__(8);
		
		    var _hasDontEnumBug,
		        _dontEnums;
		
		    function checkDontEnum(){
		        _dontEnums = [
		                'toString',
		                'toLocaleString',
		                'valueOf',
		                'hasOwnProperty',
		                'isPrototypeOf',
		                'propertyIsEnumerable',
		                'constructor'
		            ];
		
		        _hasDontEnumBug = true;
		
		        for (var key in {'toString': null}) {
		            _hasDontEnumBug = false;
		        }
		    }
		
		    /**
		     * Similar to Array/forEach but works over object properties and fixes Don't
		     * Enum bug on IE.
		     * based on: http://whattheheadsaid.com/2010/10/a-safer-object-keys-compatibility-implementation
		     */
		    function forIn(obj, fn, thisObj){
		        var key, i = 0;
		        // no need to check if argument is a real object that way we can use
		        // it for arrays, functions, date, etc.
		
		        //post-pone check till needed
		        if (_hasDontEnumBug == null) checkDontEnum();
		
		        for (key in obj) {
		            if (exec(fn, obj, key, thisObj) === false) {
		                break;
		            }
		        }
		
		
		        if (_hasDontEnumBug) {
		            var ctor = obj.constructor,
		                isProto = !!ctor && obj === ctor.prototype;
		
		            while (key = _dontEnums[i++]) {
		                // For constructor, if it is a prototype object the constructor
		                // is always non-enumerable unless defined otherwise (and
		                // enumerated above).  For non-prototype objects, it will have
		                // to be defined on this object, since it cannot be defined on
		                // any prototype objects.
		                //
		                // For other [[DontEnum]] properties, check if the value is
		                // different than Object prototype value.
		                if (
		                    (key !== 'constructor' ||
		                        (!isProto && hasOwn(obj, key))) &&
		                    obj[key] !== Object.prototype[key]
		                ) {
		                    if (exec(fn, obj, key, thisObj) === false) {
		                        break;
		                    }
		                }
		            }
		        }
		    }
		
		    function exec(fn, obj, key, thisObj){
		        return fn.call(thisObj, obj[key], key, obj);
		    }
		
		    module.exports = forIn;
		
		
	
	
	/***/ },
	/* 10 */
	/***/ function(module, exports, __webpack_require__) {
	
		var indexOf = __webpack_require__(11);
		
		    /**
		     * If array contains values.
		     */
		    function contains(arr, val) {
		        return indexOf(arr, val) !== -1;
		    }
		    module.exports = contains;
		
	
	
	/***/ },
	/* 11 */
	/***/ function(module, exports) {
	
		
		
		    /**
		     * Array.indexOf
		     */
		    function indexOf(arr, item, fromIndex) {
		        fromIndex = fromIndex || 0;
		        if (arr == null) {
		            return -1;
		        }
		
		        var len = arr.length,
		            i = fromIndex < 0 ? len + fromIndex : fromIndex;
		        while (i < len) {
		            // we iterate over sparse items since there is no way to make it
		            // work properly on IE 7-8. see #64
		            if (arr[i] === item) {
		                return i;
		            }
		
		            i++;
		        }
		
		        return -1;
		    }
		
		    module.exports = indexOf;
		
	
	
	/***/ },
	/* 12 */
	/***/ function(module, exports, __webpack_require__) {
	
		var forOwn = __webpack_require__(7);
		var isPlainObject = __webpack_require__(13);
		
		    /**
		     * Mixes objects into the target object, recursively mixing existing child
		     * objects.
		     */
		    function deepMixIn(target, objects) {
		        var i = 0,
		            n = arguments.length,
		            obj;
		
		        while(++i < n){
		            obj = arguments[i];
		            if (obj) {
		                forOwn(obj, copyProp, target);
		            }
		        }
		
		        return target;
		    }
		
		    function copyProp(val, key) {
		        var existing = this[key];
		        if (isPlainObject(val) && isPlainObject(existing)) {
		            deepMixIn(existing, val);
		        } else {
		            this[key] = val;
		        }
		    }
		
		    module.exports = deepMixIn;
		
		
	
	
	/***/ },
	/* 13 */
	/***/ function(module, exports) {
	
		
		
		    /**
		     * Checks if the value is created by the `Object` constructor.
		     */
		    function isPlainObject(value) {
		        return (!!value && typeof value === 'object' &&
		            value.constructor === Object);
		    }
		
		    module.exports = isPlainObject;
		
		
	
	
	/***/ },
	/* 14 */
	/***/ function(module, exports, __webpack_require__) {
	
		var toString = __webpack_require__(15);
		var camelCase = __webpack_require__(16);
		var upperCase = __webpack_require__(19);
		    /**
		     * camelCase + UPPERCASE first char
		     */
		    function pascalCase(str){
		        str = toString(str);
		        return camelCase(str).replace(/^[a-z]/, upperCase);
		    }
		
		    module.exports = pascalCase;
		
	
	
	/***/ },
	/* 15 */
	/***/ function(module, exports) {
	
		
		
		    /**
		     * Typecast a value to a String, using an empty string value for null or
		     * undefined.
		     */
		    function toString(val){
		        return val == null ? '' : val.toString();
		    }
		
		    module.exports = toString;
		
		
	
	
	/***/ },
	/* 16 */
	/***/ function(module, exports, __webpack_require__) {
	
		var toString = __webpack_require__(15);
		var replaceAccents = __webpack_require__(17);
		var removeNonWord = __webpack_require__(18);
		var upperCase = __webpack_require__(19);
		var lowerCase = __webpack_require__(20);
		    /**
		    * Convert string to camelCase text.
		    */
		    function camelCase(str){
		        str = toString(str);
		        str = replaceAccents(str);
		        str = removeNonWord(str)
		            .replace(/[\-_]/g, ' ') //convert all hyphens and underscores to spaces
		            .replace(/\s[a-z]/g, upperCase) //convert first char of each word to UPPERCASE
		            .replace(/\s+/g, '') //remove spaces
		            .replace(/^[A-Z]/g, lowerCase); //convert first char to lowercase
		        return str;
		    }
		    module.exports = camelCase;
		
	
	
	/***/ },
	/* 17 */
	/***/ function(module, exports, __webpack_require__) {
	
		var toString = __webpack_require__(15);
		    /**
		    * Replaces all accented chars with regular ones
		    */
		    function replaceAccents(str){
		        str = toString(str);
		
		        // verifies if the String has accents and replace them
		        if (str.search(/[\xC0-\xFF]/g) > -1) {
		            str = str
		                    .replace(/[\xC0-\xC5]/g, "A")
		                    .replace(/[\xC6]/g, "AE")
		                    .replace(/[\xC7]/g, "C")
		                    .replace(/[\xC8-\xCB]/g, "E")
		                    .replace(/[\xCC-\xCF]/g, "I")
		                    .replace(/[\xD0]/g, "D")
		                    .replace(/[\xD1]/g, "N")
		                    .replace(/[\xD2-\xD6\xD8]/g, "O")
		                    .replace(/[\xD9-\xDC]/g, "U")
		                    .replace(/[\xDD]/g, "Y")
		                    .replace(/[\xDE]/g, "P")
		                    .replace(/[\xE0-\xE5]/g, "a")
		                    .replace(/[\xE6]/g, "ae")
		                    .replace(/[\xE7]/g, "c")
		                    .replace(/[\xE8-\xEB]/g, "e")
		                    .replace(/[\xEC-\xEF]/g, "i")
		                    .replace(/[\xF1]/g, "n")
		                    .replace(/[\xF2-\xF6\xF8]/g, "o")
		                    .replace(/[\xF9-\xFC]/g, "u")
		                    .replace(/[\xFE]/g, "p")
		                    .replace(/[\xFD\xFF]/g, "y");
		        }
		        return str;
		    }
		    module.exports = replaceAccents;
		
	
	
	/***/ },
	/* 18 */
	/***/ function(module, exports, __webpack_require__) {
	
		var toString = __webpack_require__(15);
		    // This pattern is generated by the _build/pattern-removeNonWord.js script
		    var PATTERN = /[^\x20\x2D0-9A-Z\x5Fa-z\xC0-\xD6\xD8-\xF6\xF8-\xFF]/g;
		
		    /**
		     * Remove non-word chars.
		     */
		    function removeNonWord(str){
		        str = toString(str);
		        return str.replace(PATTERN, '');
		    }
		
		    module.exports = removeNonWord;
		
	
	
	/***/ },
	/* 19 */
	/***/ function(module, exports, __webpack_require__) {
	
		var toString = __webpack_require__(15);
		    /**
		     * "Safer" String.toUpperCase()
		     */
		    function upperCase(str){
		        str = toString(str);
		        return str.toUpperCase();
		    }
		    module.exports = upperCase;
		
	
	
	/***/ },
	/* 20 */
	/***/ function(module, exports, __webpack_require__) {
	
		var toString = __webpack_require__(15);
		    /**
		     * "Safer" String.toLowerCase()
		     */
		    function lowerCase(str){
		        str = toString(str);
		        return str.toLowerCase();
		    }
		
		    module.exports = lowerCase;
		
	
	
	/***/ },
	/* 21 */
	/***/ function(module, exports, __webpack_require__) {
	
		var indexOf = __webpack_require__(11);
		
		    /**
		     * Remove a single item from the array.
		     * (it won't remove duplicates, just a single item)
		     */
		    function remove(arr, item){
		        var idx = indexOf(arr, item);
		        if (idx !== -1) arr.splice(idx, 1);
		    }
		
		    module.exports = remove;
		
	
	
	/***/ },
	/* 22 */
	/***/ function(module, exports, __webpack_require__) {
	
		var slice = __webpack_require__(6);
		
		    /**
		     * Return a copy of the object, filtered to only have values for the whitelisted keys.
		     */
		    function pick(obj, var_keys){
		        var keys = typeof arguments[1] !== 'string'? arguments[1] : slice(arguments, 1),
		            out = {},
		            i = 0, key;
		        while (key = keys[i++]) {
		            out[key] = obj[key];
		        }
		        return out;
		    }
		
		    module.exports = pick;
		
		
	
	
	/***/ },
	/* 23 */
	/***/ function(module, exports, __webpack_require__) {
	
		var forOwn = __webpack_require__(7);
		
		    /**
		     * Get object keys
		     */
		     var keys = Object.keys || function (obj) {
		            var keys = [];
		            forOwn(obj, function(val, key){
		                keys.push(key);
		            });
		            return keys;
		        };
		
		    module.exports = keys;
		
		
	
	
	/***/ },
	/* 24 */
	/***/ function(module, exports) {
	
		
		
		    /**
		     * Merge sort (http://en.wikipedia.org/wiki/Merge_sort)
		     */
		    function mergeSort(arr, compareFn) {
		        if (arr == null) {
		            return [];
		        } else if (arr.length < 2) {
		            return arr;
		        }
		
		        if (compareFn == null) {
		            compareFn = defaultCompare;
		        }
		
		        var mid, left, right;
		
		        mid   = ~~(arr.length / 2);
		        left  = mergeSort( arr.slice(0, mid), compareFn );
		        right = mergeSort( arr.slice(mid, arr.length), compareFn );
		
		        return merge(left, right, compareFn);
		    }
		
		    function defaultCompare(a, b) {
		        return a < b ? -1 : (a > b? 1 : 0);
		    }
		
		    function merge(left, right, compareFn) {
		        var result = [];
		
		        while (left.length && right.length) {
		            if (compareFn(left[0], right[0]) <= 0) {
		                // if 0 it should preserve same order (stable)
		                result.push(left.shift());
		            } else {
		                result.push(right.shift());
		            }
		        }
		
		        if (left.length) {
		            result.push.apply(result, left);
		        }
		
		        if (right.length) {
		            result.push.apply(result, right);
		        }
		
		        return result;
		    }
		
		    module.exports = mergeSort;
		
		
	
	
	/***/ },
	/* 25 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isPrimitive = __webpack_require__(26);
		
		    /**
		     * get "nested" object property
		     */
		    function get(obj, prop){
		        var parts = prop.split('.'),
		            last = parts.pop();
		
		        while (prop = parts.shift()) {
		            obj = obj[prop];
		            if (obj == null) return;
		        }
		
		        return obj[last];
		    }
		
		    module.exports = get;
		
		
	
	
	/***/ },
	/* 26 */
	/***/ function(module, exports) {
	
		
		
		    /**
		     * Checks if the object is a primitive
		     */
		    function isPrimitive(value) {
		        // Using switch fallthrough because it's simple to read and is
		        // generally fast: http://jsperf.com/testing-value-is-primitive/5
		        switch (typeof value) {
		            case "string":
		            case "number":
		            case "boolean":
		                return true;
		        }
		
		        return value == null;
		    }
		
		    module.exports = isPrimitive;
		
		
	
	
	/***/ },
	/* 27 */
	/***/ function(module, exports, __webpack_require__) {
	
		var namespace = __webpack_require__(28);
		
		    /**
		     * set "nested" object property
		     */
		    function set(obj, prop, val){
		        var parts = (/^(.+)\.(.+)$/).exec(prop);
		        if (parts){
		            namespace(obj, parts[1])[parts[2]] = val;
		        } else {
		            obj[prop] = val;
		        }
		    }
		
		    module.exports = set;
		
		
	
	
	/***/ },
	/* 28 */
	/***/ function(module, exports, __webpack_require__) {
	
		var forEach = __webpack_require__(5);
		
		    /**
		     * Create nested object if non-existent
		     */
		    function namespace(obj, path){
		        if (!path) return obj;
		        forEach(path.split('.'), function(key){
		            if (!obj[key]) {
		                obj[key] = {};
		            }
		            obj = obj[key];
		        });
		        return obj;
		    }
		
		    module.exports = namespace;
		
		
	
	
	/***/ },
	/* 29 */
	/***/ function(module, exports) {
	
		/*
		 * Copyright (c) 2014 The Polymer Project Authors. All rights reserved.
		 * This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
		 * The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
		 * The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
		 * Code distributed by Google as part of the polymer project is also
		 * subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
		 */
		
		// Modifications
		// Copyright 2014-2015 Jason Dobry
		//
		// Summary of modifications:
		// Fixed use of "delete" keyword for IE8 compatibility
		// Exposed diffObjectFromOldObject on the exported object
		// Added the "equals" argument to diffObjectFromOldObject to be used to check equality
		// Added a way in diffObjectFromOldObject to ignore changes to certain properties
		// Removed all code related to:
		// - ArrayObserver
		// - ArraySplice
		// - PathObserver
		// - CompoundObserver
		// - Path
		// - ObserverTransform
		
		(function(global) {
		  var testingExposeCycleCount = global.testingExposeCycleCount;
		
		  // Detect and do basic sanity checking on Object/Array.observe.
		  function detectObjectObserve() {
		    if (typeof Object.observe !== 'function' ||
		        typeof Array.observe !== 'function') {
		      return false;
		    }
		
		    var records = [];
		
		    function callback(recs) {
		      records = recs;
		    }
		
		    var test = {};
		    var arr = [];
		    Object.observe(test, callback);
		    Array.observe(arr, callback);
		    test.id = 1;
		    test.id = 2;
		    delete test.id;
		    arr.push(1, 2);
		    arr.length = 0;
		
		    Object.deliverChangeRecords(callback);
		    if (records.length !== 5)
		      return false;
		
		    if (records[0].type != 'add' ||
		        records[1].type != 'update' ||
		        records[2].type != 'delete' ||
		        records[3].type != 'splice' ||
		        records[4].type != 'splice') {
		      return false;
		    }
		
		    Object.unobserve(test, callback);
		    Array.unobserve(arr, callback);
		
		    return true;
		  }
		
		  var hasObserve = detectObjectObserve();
		
		  var createObject = ('__proto__' in {}) ?
		    function(obj) { return obj; } :
		    function(obj) {
		      var proto = obj.__proto__;
		      if (!proto)
		        return obj;
		      var newObject = Object.create(proto);
		      Object.getOwnPropertyNames(obj).forEach(function(name) {
		        Object.defineProperty(newObject, name,
		                             Object.getOwnPropertyDescriptor(obj, name));
		      });
		      return newObject;
		    };
		
		  var MAX_DIRTY_CHECK_CYCLES = 1000;
		
		  function dirtyCheck(observer) {
		    var cycles = 0;
		    while (cycles < MAX_DIRTY_CHECK_CYCLES && observer.check_()) {
		      cycles++;
		    }
		    if (testingExposeCycleCount)
		      global.dirtyCheckCycleCount = cycles;
		
		    return cycles > 0;
		  }
		
		  function objectIsEmpty(object) {
		    for (var prop in object)
		      return false;
		    return true;
		  }
		
		  function diffIsEmpty(diff) {
		    return objectIsEmpty(diff.added) &&
		           objectIsEmpty(diff.removed) &&
		           objectIsEmpty(diff.changed);
		  }
		
		  function isBlacklisted(prop, bl) {
		    if (!bl || !bl.length) {
		      return false;
		    }
		    var matches;
		    for (var i = 0; i < bl.length; i++) {
		      if ((Object.prototype.toString.call(bl[i]) === '[object RegExp]' && bl[i].test(prop)) || bl[i] === prop) {
		        return matches = prop;
		      }
		    }
		    return !!matches;
		  }
		
		  function diffObjectFromOldObject(object, oldObject, equals, bl) {
		    var added = {};
		    var removed = {};
		    var changed = {};
		
		    for (var prop in oldObject) {
		      var newValue = object[prop];
		
		      if (isBlacklisted(prop, bl))
		        continue;
		
		      if (newValue !== undefined && (equals ? equals(newValue, oldObject[prop]) : newValue === oldObject[prop]))
		        continue;
		
		      if (!(prop in object)) {
		        removed[prop] = undefined;
		        continue;
		      }
		
		      if (equals ? !equals(newValue, oldObject[prop]) : newValue !== oldObject[prop])
		        changed[prop] = newValue;
		    }
		
		    for (var prop in object) {
		      if (prop in oldObject)
		        continue;
		
		      if (isBlacklisted(prop, bl))
		        continue;
		
		      added[prop] = object[prop];
		    }
		
		    if (Array.isArray(object) && object.length !== oldObject.length)
		      changed.length = object.length;
		
		    return {
		      added: added,
		      removed: removed,
		      changed: changed
		    };
		  }
		
		  var eomTasks = [];
		  function runEOMTasks() {
		    if (!eomTasks.length)
		      return false;
		
		    for (var i = 0; i < eomTasks.length; i++) {
		      eomTasks[i]();
		    }
		    eomTasks.length = 0;
		    return true;
		  }
		
		  var runEOM = hasObserve ? (function(){
		    return function(fn) {
		      return Promise.resolve().then(fn);
		    }
		  })() :
		  (function() {
		    return function(fn) {
		      eomTasks.push(fn);
		    };
		  })();
		
		  var observedObjectCache = [];
		
		  function newObservedObject() {
		    var observer;
		    var object;
		    var discardRecords = false;
		    var first = true;
		
		    function callback(records) {
		      if (observer && observer.state_ === OPENED && !discardRecords)
		        observer.check_(records);
		    }
		
		    return {
		      open: function(obs) {
		        if (observer)
		          throw Error('ObservedObject in use');
		
		        if (!first)
		          Object.deliverChangeRecords(callback);
		
		        observer = obs;
		        first = false;
		      },
		      observe: function(obj, arrayObserve) {
		        object = obj;
		        if (arrayObserve)
		          Array.observe(object, callback);
		        else
		          Object.observe(object, callback);
		      },
		      deliver: function(discard) {
		        discardRecords = discard;
		        Object.deliverChangeRecords(callback);
		        discardRecords = false;
		      },
		      close: function() {
		        observer = undefined;
		        Object.unobserve(object, callback);
		        observedObjectCache.push(this);
		      }
		    };
		  }
		
		  function getObservedObject(observer, object, arrayObserve) {
		    var dir = observedObjectCache.pop() || newObservedObject();
		    dir.open(observer);
		    dir.observe(object, arrayObserve);
		    return dir;
		  }
		
		  var UNOPENED = 0;
		  var OPENED = 1;
		  var CLOSED = 2;
		
		  var nextObserverId = 1;
		
		  function Observer() {
		    this.state_ = UNOPENED;
		    this.callback_ = undefined;
		    this.target_ = undefined; // TODO(rafaelw): Should be WeakRef
		    this.directObserver_ = undefined;
		    this.value_ = undefined;
		    this.id_ = nextObserverId++;
		  }
		
		  Observer.prototype = {
		    open: function(callback, target) {
		      if (this.state_ != UNOPENED)
		        throw Error('Observer has already been opened.');
		
		      addToAll(this);
		      this.callback_ = callback;
		      this.target_ = target;
		      this.connect_();
		      this.state_ = OPENED;
		      return this.value_;
		    },
		
		    close: function() {
		      if (this.state_ != OPENED)
		        return;
		
		      removeFromAll(this);
		      this.disconnect_();
		      this.value_ = undefined;
		      this.callback_ = undefined;
		      this.target_ = undefined;
		      this.state_ = CLOSED;
		    },
		
		    deliver: function() {
		      if (this.state_ != OPENED)
		        return;
		
		      dirtyCheck(this);
		    },
		
		    report_: function(changes) {
		      try {
		        this.callback_.apply(this.target_, changes);
		      } catch (ex) {
		        Observer._errorThrownDuringCallback = true;
		        console.error('Exception caught during observer callback: ' +
		                       (ex.stack || ex));
		      }
		    },
		
		    discardChanges: function() {
		      this.check_(undefined, true);
		      return this.value_;
		    }
		  }
		
		  var collectObservers = !hasObserve;
		  var allObservers;
		  Observer._allObserversCount = 0;
		
		  if (collectObservers) {
		    allObservers = [];
		  }
		
		  function addToAll(observer) {
		    Observer._allObserversCount++;
		    if (!collectObservers)
		      return;
		
		    allObservers.push(observer);
		  }
		
		  function removeFromAll(observer) {
		    Observer._allObserversCount--;
		  }
		
		  var runningMicrotaskCheckpoint = false;
		
		  global.Platform = global.Platform || {};
		
		  global.Platform.performMicrotaskCheckpoint = function() {
		    if (runningMicrotaskCheckpoint)
		      return;
		
		    if (!collectObservers)
		      return;
		
		    runningMicrotaskCheckpoint = true;
		
		    var cycles = 0;
		    var anyChanged, toCheck;
		
		    do {
		      cycles++;
		      toCheck = allObservers;
		      allObservers = [];
		      anyChanged = false;
		
		      for (var i = 0; i < toCheck.length; i++) {
		        var observer = toCheck[i];
		        if (observer.state_ != OPENED)
		          continue;
		
		        if (observer.check_())
		          anyChanged = true;
		
		        allObservers.push(observer);
		      }
		      if (runEOMTasks())
		        anyChanged = true;
		    } while (cycles < MAX_DIRTY_CHECK_CYCLES && anyChanged);
		
		    if (testingExposeCycleCount)
		      global.dirtyCheckCycleCount = cycles;
		
		    runningMicrotaskCheckpoint = false;
		  };
		
		  if (collectObservers) {
		    global.Platform.clearObservers = function() {
		      allObservers = [];
		    };
		  }
		
		  function ObjectObserver(object) {
		    Observer.call(this);
		    this.value_ = object;
		    this.oldObject_ = undefined;
		  }
		
		  ObjectObserver.prototype = createObject({
		    __proto__: Observer.prototype,
		
		    arrayObserve: false,
		
		    connect_: function(callback, target) {
		      if (hasObserve) {
		        this.directObserver_ = getObservedObject(this, this.value_,
		                                                 this.arrayObserve);
		      } else {
		        this.oldObject_ = this.copyObject(this.value_);
		      }
		
		    },
		
		    copyObject: function(object) {
		      var copy = Array.isArray(object) ? [] : {};
		      for (var prop in object) {
		        copy[prop] = object[prop];
		      };
		      if (Array.isArray(object))
		        copy.length = object.length;
		      return copy;
		    },
		
		    check_: function(changeRecords, skipChanges) {
		      var diff;
		      var oldValues;
		      if (hasObserve) {
		        if (!changeRecords)
		          return false;
		
		        oldValues = {};
		        diff = diffObjectFromChangeRecords(this.value_, changeRecords,
		                                           oldValues);
		      } else {
		        oldValues = this.oldObject_;
		        diff = diffObjectFromOldObject(this.value_, this.oldObject_);
		      }
		
		      if (diffIsEmpty(diff))
		        return false;
		
		      if (!hasObserve)
		        this.oldObject_ = this.copyObject(this.value_);
		
		      this.report_([
		        diff.added || {},
		        diff.removed || {},
		        diff.changed || {},
		        function(property) {
		          return oldValues[property];
		        }
		      ]);
		
		      return true;
		    },
		
		    disconnect_: function() {
		      if (hasObserve) {
		        this.directObserver_.close();
		        this.directObserver_ = undefined;
		      } else {
		        this.oldObject_ = undefined;
		      }
		    },
		
		    deliver: function() {
		      if (this.state_ != OPENED)
		        return;
		
		      if (hasObserve)
		        this.directObserver_.deliver(false);
		      else
		        dirtyCheck(this);
		    },
		
		    discardChanges: function() {
		      if (this.directObserver_)
		        this.directObserver_.deliver(true);
		      else
		        this.oldObject_ = this.copyObject(this.value_);
		
		      return this.value_;
		    }
		  });
		
		  var observerSentinel = {};
		
		  var expectedRecordTypes = {
		    add: true,
		    update: true,
		    'delete': true
		  };
		
		  function diffObjectFromChangeRecords(object, changeRecords, oldValues) {
		    var added = {};
		    var removed = {};
		
		    for (var i = 0; i < changeRecords.length; i++) {
		      var record = changeRecords[i];
		      if (!expectedRecordTypes[record.type]) {
		        console.error('Unknown changeRecord type: ' + record.type);
		        console.error(record);
		        continue;
		      }
		
		      if (!(record.name in oldValues))
		        oldValues[record.name] = record.oldValue;
		
		      if (record.type == 'update')
		        continue;
		
		      if (record.type == 'add') {
		        if (record.name in removed)
		          delete removed[record.name];
		        else
		          added[record.name] = true;
		
		        continue;
		      }
		
		      // type = 'delete'
		      if (record.name in added) {
		        delete added[record.name];
		        delete oldValues[record.name];
		      } else {
		        removed[record.name] = true;
		      }
		    }
		
		    for (var prop in added)
		      added[prop] = object[prop];
		
		    for (var prop in removed)
		      removed[prop] = undefined;
		
		    var changed = {};
		    for (var prop in oldValues) {
		      if (prop in added || prop in removed)
		        continue;
		
		      var newValue = object[prop];
		      if (oldValues[prop] !== newValue)
		        changed[prop] = newValue;
		    }
		
		    return {
		      added: added,
		      removed: removed,
		      changed: changed
		    };
		  }
		
		  // Export the observe-js object for **Node.js**, with backwards-compatibility
		  // for the old `require()` API. Also ensure `exports` is not a DOM Element.
		  // If we're in the browser, export as a global object.
		
		  global.Observer = Observer;
		  global.isBlacklisted = isBlacklisted;
		  global.Observer.runEOM_ = runEOM;
		  global.Observer.observerSentinel_ = observerSentinel; // for testing.
		  global.Observer.hasObjectObserve = hasObserve;
		  global.diffObjectFromOldObject = diffObjectFromOldObject;
		  global.ObjectObserver = ObjectObserver;
		
		})(exports);
	
	
	/***/ },
	/* 30 */
	/***/ function(module, exports, __webpack_require__) {
	
		var randHex = __webpack_require__(31);
		var choice = __webpack_require__(32);
		
		  /**
		   * Returns pseudo-random guid (UUID v4)
		   * IMPORTANT: it's not totally "safe" since randHex/choice uses Math.random
		   * by default and sequences can be predicted in some cases. See the
		   * "random/random" documentation for more info about it and how to replace
		   * the default PRNG.
		   */
		  function guid() {
		    return (
		        randHex(8)+'-'+
		        randHex(4)+'-'+
		        // v4 UUID always contain "4" at this position to specify it was
		        // randomly generated
		        '4' + randHex(3) +'-'+
		        // v4 UUID always contain chars [a,b,8,9] at this position
		        choice(8, 9, 'a', 'b') + randHex(3)+'-'+
		        randHex(12)
		    );
		  }
		  module.exports = guid;
		
	
	
	/***/ },
	/* 31 */
	/***/ function(module, exports, __webpack_require__) {
	
		var choice = __webpack_require__(32);
		
		    var _chars = '0123456789abcdef'.split('');
		
		    /**
		     * Returns a random hexadecimal string
		     */
		    function randHex(size){
		        size = size && size > 0? size : 6;
		        var str = '';
		        while (size--) {
		            str += choice(_chars);
		        }
		        return str;
		    }
		
		    module.exports = randHex;
		
		
	
	
	/***/ },
	/* 32 */
	/***/ function(module, exports, __webpack_require__) {
	
		var randInt = __webpack_require__(33);
		var isArray = __webpack_require__(38);
		
		    /**
		     * Returns a random element from the supplied arguments
		     * or from the array (if single argument is an array).
		     */
		    function choice(items) {
		        var target = (arguments.length === 1 && isArray(items))? items : arguments;
		        return target[ randInt(0, target.length - 1) ];
		    }
		
		    module.exports = choice;
		
		
	
	
	/***/ },
	/* 33 */
	/***/ function(module, exports, __webpack_require__) {
	
		var MIN_INT = __webpack_require__(34);
		var MAX_INT = __webpack_require__(35);
		var rand = __webpack_require__(36);
		
		    /**
		     * Gets random integer inside range or snap to min/max values.
		     */
		    function randInt(min, max){
		        min = min == null? MIN_INT : ~~min;
		        max = max == null? MAX_INT : ~~max;
		        // can't be max + 0.5 otherwise it will round up if `rand`
		        // returns `max` causing it to overflow range.
		        // -0.5 and + 0.49 are required to avoid bias caused by rounding
		        return Math.round( rand(min - 0.5, max + 0.499999999999) );
		    }
		
		    module.exports = randInt;
		
	
	
	/***/ },
	/* 34 */
	/***/ function(module, exports) {
	
		/**
		 * @constant Minimum 32-bit signed integer value (-2^31).
		 */
		
		    module.exports = -2147483648;
		
	
	
	/***/ },
	/* 35 */
	/***/ function(module, exports) {
	
		/**
		 * @constant Maximum 32-bit signed integer value. (2^31 - 1)
		 */
		
		    module.exports = 2147483647;
		
	
	
	/***/ },
	/* 36 */
	/***/ function(module, exports, __webpack_require__) {
	
		var random = __webpack_require__(37);
		var MIN_INT = __webpack_require__(34);
		var MAX_INT = __webpack_require__(35);
		
		    /**
		     * Returns random number inside range
		     */
		    function rand(min, max){
		        min = min == null? MIN_INT : min;
		        max = max == null? MAX_INT : max;
		        return min + (max - min) * random();
		    }
		
		    module.exports = rand;
		
	
	
	/***/ },
	/* 37 */
	/***/ function(module, exports) {
	
		
		
		    /**
		     * Just a wrapper to Math.random. No methods inside mout/random should call
		     * Math.random() directly so we can inject the pseudo-random number
		     * generator if needed (ie. in case we need a seeded random or a better
		     * algorithm than the native one)
		     */
		    function random(){
		        return random.get();
		    }
		
		    // we expose the method so it can be swapped if needed
		    random.get = Math.random;
		
		    module.exports = random;
		
		
	
	
	/***/ },
	/* 38 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isKind = __webpack_require__(39);
		    /**
		     */
		    var isArray = Array.isArray || function (val) {
		        return isKind(val, 'Array');
		    };
		    module.exports = isArray;
		
	
	
	/***/ },
	/* 39 */
	/***/ function(module, exports, __webpack_require__) {
	
		var kindOf = __webpack_require__(40);
		    /**
		     * Check if value is from a specific "kind".
		     */
		    function isKind(val, kind){
		        return kindOf(val) === kind;
		    }
		    module.exports = isKind;
		
	
	
	/***/ },
	/* 40 */
	/***/ function(module, exports) {
	
		
		
		    var _rKind = /^\[object (.*)\]$/,
		        _toString = Object.prototype.toString,
		        UNDEF;
		
		    /**
		     * Gets the "kind" of value. (e.g. "String", "Number", etc)
		     */
		    function kindOf(val) {
		        if (val === null) {
		            return 'Null';
		        } else if (val === UNDEF) {
		            return 'Undefined';
		        } else {
		            return _rKind.exec( _toString.call(val) )[1];
		        }
		    }
		    module.exports = kindOf;
		
	
	
	/***/ },
	/* 41 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
		
		var _utils = __webpack_require__(2);
		
		var _utils2 = _interopRequireDefault(_utils);
		
		var _errors = __webpack_require__(3);
		
		var _errors2 = _interopRequireDefault(_errors);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		var NER = _errors2.default.NER;
		var IA = _errors2.default.IA;
		var R = _errors2.default.R;
		
		var fakeId = 'DS_' + new Date().getTime();
		
		function diffIsEmpty(diff) {
		  return !(_utils2.default.isEmpty(diff.added) && _utils2.default.isEmpty(diff.removed) && _utils2.default.isEmpty(diff.changed));
		}
		
		function check(fnName, resourceName, id, options) {
		  var _this = this;
		  var definition = _this.definitions[resourceName];
		  options = options || {};
		
		  id = _utils2.default.resolveId(definition, id);
		  if (!definition) {
		    throw new NER(resourceName);
		  } else if (!_utils2.default._sn(id)) {
		    throw _utils2.default._snErr('id');
		  }
		  id = id === fakeId ? undefined : id;
		
		  options = _utils2.default._(definition, options);
		
		  options.logFn(fnName, id, options);
		
		  return { _this: _this, definition: definition, _resourceName: resourceName, _id: id, _options: options };
		}
		
		exports.default = {
		  // Return the changes for the given item, if any.
		  //
		  // @param resourceName The name of the type of resource of the item whose changes are to be returned.
		  // @param id The primary key of the item whose changes are to be returned.
		  // @param options Optional configuration.
		  // @param options.ignoredChanges Array of strings or regular expressions of fields, the changes of which are to be ignored.
		  // @returns The changes of the given item, if any.
		
		  changes: function changes(resourceName, id, options) {
		    var _check$call = check.call(this, 'changes', resourceName, id, options);
		
		    var _this = _check$call._this;
		    var definition = _check$call.definition;
		    var _resourceName = _check$call._resourceName;
		    var _id = _check$call._id;
		    var _options = _check$call._options;
		
		
		    var item = definition.get(_id);
		    if (item) {
		      var _ret = function () {
		        var observer = _this.store[_resourceName].observers[_id];
		        if (observer && typeof observer === 'function') {
		          // force observation handler to be fired for item if there are changes and `Object.observe` is not available
		          observer.deliver();
		        }
		
		        var ignoredChanges = _options.ignoredChanges || [];
		        // add linked relations to list of ignored changes
		        _utils2.default.forEach(definition.relationFields, function (field) {
		          if (!_utils2.default.contains(ignoredChanges, field)) {
		            ignoredChanges.push(field);
		          }
		        });
		        // calculate changes
		        var diff = _utils2.default.diffObjectFromOldObject(item, _this.store[_resourceName].previousAttributes[_id], _utils2.default.equals, ignoredChanges);
		        // remove functions from diff
		        _utils2.default.forOwn(diff, function (changeset, name) {
		          var toKeep = [];
		          _utils2.default.forOwn(changeset, function (value, field) {
		            if (!_utils2.default.isFunction(value)) {
		              toKeep.push(field);
		            }
		          });
		          diff[name] = _utils2.default.pick(diff[name], toKeep);
		        });
		        // definitely ignore changes to linked relations
		        _utils2.default.forEach(definition.relationFields, function (field) {
		          delete diff.added[field];
		          delete diff.removed[field];
		          delete diff.changed[field];
		        });
		        return {
		          v: diff
		        };
		      }();
		
		      if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
		    }
		  },
		
		
		  // Return the change history of the given item, if any.
		  //
		  // @param resourceName The name of the type of resource of the item whose change history is to be returned.
		  // @param id The primary key of the item whose change history is to be returned.
		  // @returns The change history of the given item, if any.
		  changeHistory: function changeHistory(resourceName, id) {
		    var _check$call2 = check.call(this, 'changeHistory', resourceName, id || fakeId);
		
		    var _this = _check$call2._this;
		    var definition = _check$call2.definition;
		    var _resourceName = _check$call2._resourceName;
		    var _id = _check$call2._id;
		
		    var resource = _this.store[_resourceName];
		
		    if (!definition.keepChangeHistory) {
		      definition.errorFn('changeHistory is disabled for this resource!');
		    } else {
		      if (_resourceName) {
		        var item = definition.get(_id);
		        if (item) {
		          return resource.changeHistories[_id];
		        }
		      } else {
		        return resource.changeHistory;
		      }
		    }
		  },
		  commit: function commit(resourceName, id) {
		    var _check$call3 = check.call(this, 'commit', resourceName, id);
		
		    var _this = _check$call3._this;
		    var definition = _check$call3.definition;
		    var _resourceName = _check$call3._resourceName;
		    var _id = _check$call3._id;
		
		    var resource = _this.store[_resourceName];
		    var item = _this.store[_resourceName].index[_id];
		    if (item) {
		      resource.previousAttributes[_id] = _utils2.default.copy(item, null, null, null, definition.relationFields);
		    }
		
		    if (resource.changeHistories[_id].length) {
		      _utils2.default.forEach(resource.changeHistories[_id], function (changeRecord) {
		        _utils2.default.remove(resource.changeHistory, changeRecord);
		      });
		      resource.changeHistories[_id].splice(0, resource.changeHistories[_id].length);
		    }
		    return item;
		  },
		
		
		  // Re-compute the computed properties of the given item.
		  //
		  // @param resourceName The name of the type of resource of the item whose computed properties are to be re-computed.
		  // @param instance The instance whose computed properties are to be re-computed.
		  // @returns The item whose computed properties were re-computed.
		  compute: function compute(resourceName, instance) {
		    var _this = this;
		    var definition = _this.definitions[resourceName];
		
		    instance = _utils2.default.resolveItem(_this.store[resourceName], instance);
		    if (!definition) {
		      throw new NER(resourceName);
		    } else if (!instance) {
		      throw new R('Item not in the store!');
		    } else if (!_utils2.default._o(instance) && !_utils2.default._sn(instance)) {
		      throw new IA('"instance" must be an object, string or number!');
		    }
		
		    definition.logFn('compute', instance);
		
		    // re-compute all computed properties
		    _utils2.default.forOwn(definition.computed, function (fn, field) {
		      _utils2.default.compute.call(instance, fn, field);
		    });
		    return instance;
		  },
		
		
		  // Factory function to create an instance of the specified Resource.
		  //
		  // @param resourceName The name of the type of resource of which to create an instance.
		  // @param attrs Hash of properties with which to initialize the instance.
		  // @param options Optional configuration.
		  // @param options.defaults Default values with which to initialize the instance.
		  // @returns The new instance.
		  createInstance: function createInstance(resourceName, attrs, options) {
		    var definition = this.definitions[resourceName];
		    var item = undefined;
		
		    attrs = attrs || {};
		
		    if (!definition) {
		      throw new NER(resourceName);
		    } else if (attrs && !_utils2.default.isObject(attrs)) {
		      throw new IA('"attrs" must be an object!');
		    }
		
		    options = _utils2.default._(definition, options);
		
		    var relationList = definition.relationList || [];
		    if (relationList.length) {
		      _utils2.default.forEach(relationList, function (def) {
		        var relationData = _utils2.default.get(attrs, def.localField);
		        if (relationData) {
		          if (_utils2.default.isArray(relationData)) {
		            (function () {
		              var array = [];
		              var Resource = definition.getResource(def.relation);
		              var _options = options.orig();
		              _utils2.default.forEach(relationData, function (relationDataItem) {
		                array.push(Resource.createInstance(relationDataItem, _options));
		              });
		              _utils2.default.set(attrs, def.localField, array);
		            })();
		          } else if (_utils2.default.isObject(relationData)) {
		            _utils2.default.set(attrs, def.localField, definition.getResource(def.relation).createInstance(relationData, options.orig()));
		          }
		        }
		      });
		    }
		
		    options.logFn('createInstance', attrs, options);
		
		    // lifecycle
		    options.beforeCreateInstance(options, attrs);
		
		    // grab instance constructor function from Resource definition
		    var Constructor = definition[definition.class];
		
		    // create instance
		    item = new Constructor();
		
		    if (definition.instanceEvents) {
		      _utils2.default.Events(item);
		    }
		
		    // add default values
		    if (options.defaultValues) {
		      _utils2.default.deepMixIn(item, _utils2.default.copy(options.defaultValues));
		    }
		    _utils2.default.deepMixIn(item, attrs);
		
		    // compute computed properties
		    if (definition.computed) {
		      definition.compute(item);
		    }
		    // lifecycle
		    options.afterCreateInstance(options, item);
		    return item;
		  },
		
		
		  // Create a new collection of the specified Resource.
		  //
		  // @param resourceName The name of the type of resource of which to create a collection
		  // @param arr Possibly empty array of data from which to create the collection.
		  // @param params The criteria by which to filter items. Will be passed to `DS#findAll` if `fetch` is called. See http://www.js-data.io/docs/query-syntax
		  // @param options Optional configuration.
		  // @param options.notify Whether to call the beforeCreateCollection and afterCreateCollection lifecycle hooks..
		  // @returns The new collection.
		  createCollection: function createCollection(resourceName, arr, params, options) {
		    var _this = this;
		    var definition = _this.definitions[resourceName];
		
		    arr = arr || [];
		    params = params || {};
		
		    if (!definition) {
		      throw new NER(resourceName);
		    } else if (arr && !_utils2.default.isArray(arr)) {
		      throw new IA('"arr" must be an array!');
		    }
		
		    options = _utils2.default._(definition, options);
		
		    options.logFn('createCollection', arr, options);
		
		    // lifecycle
		    options.beforeCreateCollection(options, arr);
		
		    // define the API for this collection
		    Object.defineProperties(arr, {
		      //  Call DS#findAll with the params of this collection, filling the collection with the results.
		      fetch: {
		        value: function value(params, options) {
		          var __this = this;
		          __this.params = params || __this.params;
		          return definition.findAll(__this.params, options).then(function (data) {
		            if (data === __this) {
		              return __this;
		            }
		            data.unshift(__this.length);
		            data.unshift(0);
		            __this.splice.apply(__this, data);
		            data.shift();
		            data.shift();
		            if (data.$$injected) {
		              _this.store[resourceName].queryData[_utils2.default.toJson(__this.params)] = __this;
		              __this.$$injected = true;
		            }
		            return __this;
		          });
		        }
		      },
		      // params for this collection. See http://www.js-data.io/docs/query-syntax
		      params: {
		        value: params,
		        writable: true
		      },
		      // name of the resource type of this collection
		      resourceName: {
		        value: resourceName
		      }
		    });
		
		    // lifecycle
		    options.afterCreateCollection(options, arr);
		    return arr;
		  },
		
		  defineResource: __webpack_require__(42),
		  digest: function digest() {
		    this.observe.Platform.performMicrotaskCheckpoint();
		  },
		
		  eject: __webpack_require__(43),
		  ejectAll: __webpack_require__(44),
		  filter: __webpack_require__(45),
		
		  // Return the item with the given primary key if its in the store.
		  //
		  // @param resourceName The name of the type of resource of the item to retrieve.
		  // @param id The primary key of the item to retrieve.
		  // @returns The item with the given primary key if it's in the store.
		  // /
		  get: function get(resourceName, id) {
		    var _check$call4 = check.call(this, 'get', resourceName, id);
		
		    var _this = _check$call4._this;
		    var _resourceName = _check$call4._resourceName;
		    var _id = _check$call4._id;
		
		    // return the item if it exists
		
		    return _this.store[_resourceName].index[_id];
		  },
		
		
		  // Return the items in the store that have the given primary keys.
		  //
		  // @param resourceName The name of the type of resource of the items to retrieve.
		  // @param ids The primary keys of the items to retrieve.
		  // @returns The items with the given primary keys if they're in the store.
		  getAll: function getAll(resourceName, ids) {
		    var _this = this;
		    var definition = _this.definitions[resourceName];
		    var resource = _this.store[resourceName];
		    var collection = [];
		
		    if (!definition) {
		      throw new NER(resourceName);
		    } else if (ids && !_utils2.default._a(ids)) {
		      throw _utils2.default._aErr('ids');
		    }
		
		    definition.logFn('getAll', ids);
		
		    if (_utils2.default._a(ids)) {
		      // return just the items with the given primary keys
		      var length = ids.length;
		      for (var i = 0; i < length; i++) {
		        if (resource.index[ids[i]]) {
		          collection.push(resource.index[ids[i]]);
		        }
		      }
		    } else {
		      // most efficient of retrieving ALL items from the store
		      collection = resource.collection.slice();
		    }
		
		    return collection;
		  },
		
		
		  // Return the whether the item with the given primary key has any changes.
		  //
		  // @param resourceName The name of the type of resource of the item.
		  // @param id The primary key of the item.
		  // @returns Whether the item with the given primary key has any changes.
		  hasChanges: function hasChanges(resourceName, id) {
		    var _check$call5 = check.call(this, 'hasChanges', resourceName, id);
		
		    var definition = _check$call5.definition;
		    var _id = _check$call5._id;
		
		
		    return definition.get(_id) ? diffIsEmpty(definition.changes(_id)) : false;
		  },
		
		  inject: __webpack_require__(46),
		
		  // Return whether the item with the given primary key is a temporary item.
		  //
		  // @param resourceName The name of the type of resource of the item.
		  // @param id The primary key of the item.
		  // @returns Whether the item with the given primary key is a temporary item.
		  isNew: function isNew(resourceName, id) {
		    var _check$call6 = check.call(this, 'isNew', resourceName, id || fakeId);
		
		    var _this = _check$call6._this;
		    var _resourceName = _check$call6._resourceName;
		    var _id = _check$call6._id;
		
		    var resource = _this.store[_resourceName];
		
		    return !!resource.temporaryItems[_id];
		  },
		
		
		  // Return the timestamp from the last time the item with the given primary key was changed.
		  //
		  // @param resourceName The name of the type of resource of the item.
		  // @param id The primary key of the item.
		  // @returns Timestamp from the last time the item was changed.
		  lastModified: function lastModified(resourceName, id) {
		    var _check$call7 = check.call(this, 'lastModified', resourceName, id || fakeId);
		
		    var _this = _check$call7._this;
		    var _resourceName = _check$call7._resourceName;
		    var _id = _check$call7._id;
		
		    var resource = _this.store[_resourceName];
		
		    if (_id) {
		      if (!(_id in resource.modified)) {
		        resource.modified[_id] = 0;
		      }
		      return resource.modified[_id];
		    }
		    return resource.collectionModified;
		  },
		
		
		  // Return the timestamp from the last time the item with the given primary key was saved via an adapter.
		  //
		  // @param resourceName The name of the type of resource of the item.
		  // @param id The primary key of the item.
		  // @returns Timestamp from the last time the item was saved.
		  lastSaved: function lastSaved(resourceName, id) {
		    var _check$call8 = check.call(this, 'lastSaved', resourceName, id || fakeId);
		
		    var _this = _check$call8._this;
		    var _resourceName = _check$call8._resourceName;
		    var _id = _check$call8._id;
		
		    var resource = _this.store[_resourceName];
		
		    if (!(_id in resource.saved)) {
		      resource.saved[_id] = 0;
		    }
		    return resource.saved[_id];
		  },
		
		
		  // Return the previous attributes of the item with the given primary key before it was changed.
		  //
		  // @param resourceName The name of the type of resource of the item.
		  // @param id The primary key of the item.
		  // @returns The previous attributes of the item
		  previous: function previous(resourceName, id) {
		    var _check$call9 = check.call(this, 'previous', resourceName, id);
		
		    var _this = _check$call9._this;
		    var _resourceName = _check$call9._resourceName;
		    var _id = _check$call9._id;
		
		    var resource = _this.store[_resourceName];
		
		    // return resource from cache
		    return resource.previousAttributes[_id] ? _utils2.default.copy(resource.previousAttributes[_id]) : undefined;
		  },
		
		
		  // Revert all attributes of the item with the given primary key to their previous values.
		  //
		  // @param resourceName The name of the type of resource of the item.
		  // @param id The primary key of the item.
		  // @param options Optional configuration.
		  // @returns The reverted item
		  revert: function revert(resourceName, id, options) {
		    var _check$call10 = check.call(this, 'revert', resourceName, id, options);
		
		    var _this = _check$call10._this;
		    var definition = _check$call10.definition;
		    var _resourceName = _check$call10._resourceName;
		    var _id = _check$call10._id;
		    var _options = _check$call10._options;
		
		
		    var preserve = _options.preserve || [];
		    var injectObj = {};
		
		    if (preserve.length === 0) {
		      injectObj = _this.previous(_resourceName, _id);
		    } else {
		      var _ret3 = function () {
		        var instance = definition.get(id);
		        var previousInstance = _this.previous(_resourceName, _id);
		
		        if (!instance) {
		          return {
		            v: undefined
		          };
		        }
		
		        _utils2.default.forOwn(instance, function (value, key) {
		          if (_utils2.default.contains(preserve, key)) {
		            injectObj[key] = instance[key];
		          } else {
		            injectObj[key] = previousInstance[key];
		          }
		        });
		      }();
		
		      if ((typeof _ret3 === 'undefined' ? 'undefined' : _typeof(_ret3)) === "object") return _ret3.v;
		    }
		
		    return definition.inject(injectObj, {
		      onConflict: 'replace'
		    });
		  }
		};
	
	/***/ },
	/* 42 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; }; /* jshint evil:true, loopfunc:true */
		
		
		var _utils = __webpack_require__(2);
		
		var _utils2 = _interopRequireDefault(_utils);
		
		var _errors = __webpack_require__(3);
		
		var _errors2 = _interopRequireDefault(_errors);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		/**
		 * These are DS methods that will be proxied by instances. e.g.
		 *
		 * var store = new JSData.DS()
		 * var User = store.defineResource('user')
		 * var user = User.createInstance({ id: 1 })
		 *
		 * store.update(resourceName, id, attrs[, options]) // DS method
		 * User.update(id, attrs[, options]) // DS method proxied on a Resource
		 * user.DSUpdate(attrs[, options]) // DS method proxied on an Instance
		 */
		var instanceMethods = ['compute', 'eject', 'refresh', 'save', 'update', 'destroy', 'loadRelations', 'changeHistory', 'changes', 'commit', 'hasChanges', 'isNew', 'lastModified', 'lastSaved', 'previous', 'revert'];
		
		module.exports = function defineResource(definition) {
		  var _this = this;
		  var definitions = _this.definitions;
		
		  /**
		   * This allows the name-only definition shorthand.
		   * store.defineResource('user') is the same as store.defineResource({ name: 'user'})
		   */
		  if (_utils2.default._s(definition)) {
		    definition = {
		      name: definition.replace(/\s/gi, '')
		    };
		  }
		  if (!_utils2.default._o(definition)) {
		    throw _utils2.default._oErr('definition');
		  } else if (!_utils2.default._s(definition.name)) {
		    throw new _errors2.default.IA('"name" must be a string!');
		  } else if (definitions[definition.name]) {
		    throw new _errors2.default.R(definition.name + ' is already registered!');
		  }
		
		  /**
		   * Dynamic Resource constructor function.
		   *
		   * A Resource inherits from the defaults of the data store that created it.
		   */
		  function Resource(options) {
		    this.defaultValues = {};
		    this.methods = {};
		    this.computed = {};
		    this.scopes = {};
		    this.actions = {};
		    _utils2.default.deepMixIn(this, options);
		    var parent = _this.defaults;
		    if (definition.extends && definitions[definition.extends]) {
		      parent = definitions[definition.extends];
		    }
		    _utils2.default.fillIn(this.defaultValues, parent.defaultValues);
		    _utils2.default.fillIn(this.methods, parent.methods);
		    _utils2.default.fillIn(this.computed, parent.computed);
		    _utils2.default.fillIn(this.scopes, parent.scopes);
		    _utils2.default.fillIn(this.actions, parent.actions);
		    this.endpoint = 'endpoint' in options ? options.endpoint : this.name;
		  }
		
		  try {
		    var def;
		
		    var _class;
		
		    var _ret = function () {
		      // Resources can inherit from another resource instead of inheriting directly from the data store defaults.
		      if (definition.extends && definitions[definition.extends]) {
		        // Inherit from another resource
		        Resource.prototype = definitions[definition.extends];
		      } else {
		        // Inherit from global defaults
		        Resource.prototype = _this.defaults;
		      }
		      definitions[definition.name] = new Resource(definition);
		
		      def = definitions[definition.name];
		
		
		      def.getResource = function (resourceName) {
		        return _this.definitions[resourceName];
		      };
		
		      def.logFn('Preparing resource.');
		
		      if (!_utils2.default._s(def.idAttribute)) {
		        throw new _errors2.default.IA('"idAttribute" must be a string!');
		      }
		
		      // Setup nested parent configuration
		      if (def.relations) {
		        def.relationList = [];
		        def.relationFields = [];
		        _utils2.default.forOwn(def.relations, function (relatedModels, type) {
		          _utils2.default.forOwn(relatedModels, function (defs, relationName) {
		            if (!_utils2.default._a(defs)) {
		              relatedModels[relationName] = [defs];
		            }
		            _utils2.default.forEach(relatedModels[relationName], function (d) {
		              d.type = type;
		              d.relation = relationName;
		              d.name = def.name;
		              def.relationList.push(d);
		              if (d.localField) {
		                def.relationFields.push(d.localField);
		              }
		            });
		          });
		        });
		        if (def.relations.belongsTo) {
		          def.parents = {};
		          _utils2.default.forOwn(def.relations.belongsTo, function (relatedModel, modelName) {
		            _utils2.default.forEach(relatedModel, function (relation) {
		              if (relation.parent) {
		                def.parent = modelName;
		                def.parentKey = relation.localKey;
		                def.parentField = relation.localField;
		                def.parents[modelName] = {
		                  key: def.parentKey,
		                  field: def.parentField
		                };
		              }
		            });
		          });
		        }
		        if (typeof Object.freeze === 'function') {
		          Object.freeze(def.relations);
		          Object.freeze(def.relationList);
		        }
		      }
		
		      // Create the wrapper class for the new resource
		      _class = def['class'] = _utils2.default.pascalCase(def.name);
		
		      try {
		        if (typeof def.useClass === 'function') {
		          if (def.csp) {
		            def[_class] = function () {
		              def.useClass.call(this);
		            };
		          } else {
		            def[_class] = new Function('def', 'return function ' + _class + '() { def.useClass.call(this); }')(def); // eslint-disable-line
		          }
		          def[_class].prototype = function (proto) {
		            function Ctor() {}
		
		            Ctor.prototype = proto;
		            return new Ctor();
		          }(def.useClass.prototype);
		        } else if (def.csp) {
		          def[_class] = function () {};
		        } else {
		          def[_class] = new Function('return function ' + _class + '() {}')(); // eslint-disable-line
		        }
		      } catch (e) {
		        def[_class] = function () {};
		      }
		
		      // Apply developer-defined instance methods
		      _utils2.default.forOwn(def.methods, function (fn, m) {
		        def[_class].prototype[m] = fn;
		      });
		
		      /**
		       * var user = User.createInstance({ id: 1 })
		       * user.set('foo', 'bar')
		       */
		      def[_class].prototype.set = function (key, value) {
		        var _this2 = this;
		
		        _utils2.default.set(this, key, value);
		        def.compute(this);
		        if (def.instanceEvents) {
		          setTimeout(function () {
		            _this2.emit('DS.change', def, _this2);
		          }, 0);
		        }
		        def.handleChange(this);
		        return this;
		      };
		
		      /**
		       * var user = User.createInstance({ id: 1 })
		       * user.get('id') // 1
		       */
		      def[_class].prototype.get = function (key) {
		        return _utils2.default.get(this, key);
		      };
		
		      // Setup the relation links
		      _utils2.default.applyRelationGettersToTarget(_this, def, def[_class].prototype);
		
		      var parentOmit = null;
		      if (!def.hasOwnProperty('omit')) {
		        parentOmit = def.omit;
		        def.omit = [];
		      } else {
		        parentOmit = _this.defaults.omit;
		      }
		      def.omit = def.omit.concat(parentOmit || []);
		
		      // Prepare for computed properties
		      _utils2.default.forOwn(def.computed, function (fn, field) {
		        if (_utils2.default.isFunction(fn)) {
		          def.computed[field] = [fn];
		          fn = def.computed[field];
		        }
		        if (def.methods && field in def.methods) {
		          def.errorFn('Computed property "' + field + '" conflicts with previously defined prototype method!');
		        }
		        def.omit.push(field);
		        if (_utils2.default.isArray(fn)) {
		          var deps;
		          if (fn.length === 1) {
		            var match = fn[0].toString().match(/function.*?\(([\s\S]*?)\)/);
		            deps = match[1].split(',');
		            deps = _utils2.default.filter(deps, function (x) {
		              return x;
		            });
		            def.computed[field] = deps.concat(fn);
		            fn = def.computed[field];
		            if (deps.length) {
		              def.errorFn('Use the computed property array syntax for compatibility with minified code!');
		            }
		          }
		          deps = fn.slice(0, fn.length - 1);
		          _utils2.default.forEach(deps, function (val, index) {
		            deps[index] = val.trim();
		          });
		          fn.deps = _utils2.default.filter(deps, function (dep) {
		            return !!dep;
		          });
		        } else if (_utils2.default.isObject(fn)) {
		          Object.defineProperty(def[_class].prototype, field, fn);
		        }
		      });
		
		      // add instance proxies of DS methods
		      _utils2.default.forEach(instanceMethods, function (name) {
		        def[_class].prototype['DS' + _utils2.default.pascalCase(name)] = function () {
		          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
		            args[_key] = arguments[_key];
		          }
		
		          args.unshift(this[def.idAttribute] || this);
		          args.unshift(def.name);
		          return _this[name].apply(_this, args);
		        };
		      });
		
		      // manually add instance proxy for DS#create
		      def[_class].prototype.DSCreate = function () {
		        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
		          args[_key2] = arguments[_key2];
		        }
		
		        args.unshift(this);
		        args.unshift(def.name);
		        return _this.create.apply(_this, args);
		      };
		
		      // Initialize store data for the new resource
		      _this.store[def.name] = {
		        collection: [],
		        expiresHeap: new _utils2.default.BinaryHeap(function (x) {
		          return x.expires;
		        }, function (x, y) {
		          return x.item === y;
		        }),
		        completedQueries: {},
		        queryData: {},
		        pendingQueries: {},
		        index: {},
		        modified: {},
		        saved: {},
		        previousAttributes: {},
		        observers: {},
		        changeHistories: {},
		        changeHistory: [],
		        collectionModified: 0,
		        temporaryItems: {}
		      };
		
		      var resource = _this.store[def.name];
		
		      // start the reaping
		      if (def.reapInterval) {
		        setInterval(function () {
		          return def.reap();
		        }, def.reapInterval);
		      }
		
		      // proxy DS methods with shorthand ones
		      var fns = ['registerAdapter', 'getAdapterName', 'getAdapter', 'is', '!clear'];
		      for (var key in _this) {
		        if (typeof _this[key] === 'function') {
		          fns.push(key);
		        }
		      }
		
		      /**
		       * Create the Resource shorthands that proxy DS methods. e.g.
		       *
		       * var store = new JSData.DS()
		       * var User = store.defineResource('user')
		       *
		       * store.update(resourceName, id, attrs[, options]) // DS method
		       * User.update(id, attrs[, options]) // DS method proxied on a Resource
		       */
		      _utils2.default.forEach(fns, function (key) {
		        var k = key;
		        if (k[0] === '!') {
		          return;
		        }
		        if (_this[k].shorthand !== false) {
		          def[k] = function () {
		            for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
		              args[_key3] = arguments[_key3];
		            }
		
		            args.unshift(def.name);
		            return _this[k].apply(_this, args);
		          };
		          def[k].before = function (fn) {
		            var orig = def[k];
		            def[k] = function () {
		              for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
		                args[_key4] = arguments[_key4];
		              }
		
		              return orig.apply(def, fn.apply(def, args) || args);
		            };
		          };
		        } else {
		          def[k] = function () {
		            for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
		              args[_key5] = arguments[_key5];
		            }
		
		            return _this[k].apply(_this, args);
		          };
		        }
		      });
		
		      def.beforeValidate = _utils2.default.promisify(def.beforeValidate);
		      def.validate = _utils2.default.promisify(def.validate);
		      def.afterValidate = _utils2.default.promisify(def.afterValidate);
		      def.beforeCreate = _utils2.default.promisify(def.beforeCreate);
		      def.afterCreate = _utils2.default.promisify(def.afterCreate);
		      def.afterFind = _utils2.default.promisify(def.afterFind);
		      def.afterFindAll = _utils2.default.promisify(def.afterFindAll);
		      def.afterLoadRelations = _utils2.default.promisify(def.afterLoadRelations);
		      def.beforeUpdate = _utils2.default.promisify(def.beforeUpdate);
		      def.afterUpdate = _utils2.default.promisify(def.afterUpdate);
		      def.beforeDestroy = _utils2.default.promisify(def.beforeDestroy);
		      def.afterDestroy = _utils2.default.promisify(def.afterDestroy);
		
		      var defaultAdapter = undefined;
		      if (def.hasOwnProperty('defaultAdapter')) {
		        defaultAdapter = def.defaultAdapter;
		      }
		
		      // setup "actions"
		      _utils2.default.forOwn(def.actions, function (action, name) {
		        if (def[name] && !def.actions[name]) {
		          throw new Error('Cannot override existing method "' + name + '"!');
		        }
		        action.request = action.request || function (config) {
		          return config;
		        };
		        action.response = action.response || function (response) {
		          return response;
		        };
		        action.responseError = action.responseError || function (err) {
		          return _utils2.default.Promise.reject(err);
		        };
		        def[name] = function (id, options) {
		          if (_utils2.default._o(id)) {
		            options = id;
		          }
		          options = options || {};
		          var adapter = def.getAdapter(action.adapter || defaultAdapter || 'http');
		          var config = _utils2.default.deepMixIn({}, action);
		          if (!options.hasOwnProperty('endpoint') && config.endpoint) {
		            options.endpoint = config.endpoint;
		          }
		          if (typeof options.getEndpoint === 'function') {
		            config.url = options.getEndpoint(def, options);
		          } else {
		            var _args = [options.basePath || def.basePath || adapter.defaults.basePath, adapter.getEndpoint(def, _utils2.default._sn(id) ? id : null, options)];
		            if (_utils2.default._sn(id)) {
		              _args.push(id);
		            }
		            _args.push(action.pathname || name);
		            config.url = _utils2.default.makePath.apply(null, _args);
		          }
		          config.method = config.method || 'GET';
		          config.resourceName = def.name;
		          _utils2.default.deepMixIn(config, options);
		          return new _utils2.default.Promise(function (resolve) {
		            return resolve(config);
		          }).then(options.request || action.request).then(function (config) {
		            return adapter.HTTP(config);
		          }).then(function (data) {
		            if (data && data.config) {
		              data.config.resourceName = def.name;
		            }
		            return data;
		          }).then(options.response || action.response, options.responseError || action.responseError);
		        };
		      });
		
		      // mix in events
		      _utils2.default.Events(def);
		
		      def.handleChange = function (data) {
		        resource.collectionModified = _utils2.default.updateTimestamp(resource.collectionModified);
		        if (def.notify) {
		          setTimeout(function () {
		            def.emit('DS.change', def, data);
		          }, 0);
		        }
		      };
		
		      def.logFn('Done preparing resource.');
		
		      return {
		        v: def
		      };
		    }();
		
		    if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
		  } catch (err) {
		    _this.defaults.errorFn(err);
		    delete definitions[definition.name];
		    delete _this.store[definition.name];
		    throw err;
		  }
		};
	
	/***/ },
	/* 43 */
	/***/ function(module, exports) {
	
		'use strict';
		
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
		
		/* jshint eqeqeq:false */
		/**
		 * Eject an item from the store, if it is currently in the store.
		 *
		 * @param resourceName The name of the resource type of the item eject.
		 * @param id The primary key of the item to eject.
		 * @param options Optional configuration.
		 * @param options.notify Whether to emit the "DS.beforeEject" and "DS.afterEject" events
		 * @param options.clearEmptyQueries Whether to remove cached findAll queries that become empty as a result of this method call.
		 * @returns The ejected item if one was ejected.
		 */
		module.exports = function eject(resourceName, id, options) {
		  var _this = this;
		  var DSUtils = _this.utils;
		  var definition = _this.definitions[resourceName];
		  var resource = _this.store[resourceName];
		  var item = undefined;
		  var found = false;
		
		  id = DSUtils.resolveId(definition, id);
		
		  if (!definition) {
		    throw new _this.errors.NER(resourceName);
		  } else if (!DSUtils._sn(id)) {
		    throw DSUtils._snErr('id');
		  }
		
		  options = DSUtils._(definition, options);
		
		  options.logFn('eject', id, options);
		
		  // find the item to eject
		  for (var i = 0; i < resource.collection.length; i++) {
		    if (resource.collection[i][definition.idAttribute] == id) {
		      // eslint-disable-line
		      item = resource.collection[i];
		      // remove its expiration timestamp
		      resource.expiresHeap.remove(item);
		      found = true;
		      break;
		    }
		  }
		  if (found) {
		    var _ret = function () {
		      // lifecycle
		      definition.beforeEject(options, item);
		      if (options.notify) {
		        definition.emit('DS.beforeEject', definition, item);
		      }
		
		      // find the item in any ($$injected) cached queries
		      var toRemove = [];
		      DSUtils.forOwn(resource.queryData, function (items, queryHash) {
		        if (items.$$injected) {
		          DSUtils.remove(items, item);
		        }
		        // optionally remove any empty queries
		        if (!items.length && options.clearEmptyQueries) {
		          toRemove.push(queryHash);
		        }
		      });
		
		      // clean up
		      DSUtils.forEach(resource.changeHistories[id], function (changeRecord) {
		        DSUtils.remove(resource.changeHistory, changeRecord);
		      });
		      DSUtils.forEach(toRemove, function (queryHash) {
		        delete resource.completedQueries[queryHash];
		        delete resource.queryData[queryHash];
		      });
		      if (resource.observers[id] && typeof resource.observers[id].close === 'function') {
		        // stop observation
		        resource.observers[id].close();
		      }
		      delete resource.observers[id];
		      delete resource.index[id];
		      delete resource.previousAttributes[id];
		      delete resource.completedQueries[id];
		      delete resource.pendingQueries[id];
		      delete resource.changeHistories[id];
		      delete resource.modified[id];
		      delete resource.saved[id];
		      if (definition.instanceEvents && item.off) {
		        item.off();
		      }
		
		      // remove it from the store
		      resource.collection.splice(i, 1);
		      // collection has been modified
		      definition.handleChange(item);
		
		      // lifecycle
		      definition.afterEject(options, item);
		      if (options.notify) {
		        definition.emit('DS.afterEject', definition, item);
		      }
		
		      return {
		        v: item
		      };
		    }();
		
		    if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
		  }
		};
	
	/***/ },
	/* 44 */
	/***/ function(module, exports) {
	
		'use strict';
		
		/**
		 * Eject a collection of items from the store, if any items currently in the store match the given criteria.
		 *
		 * @param resourceName The name of the resource type of the items eject.
		 * @param params The criteria by which to match items to eject. See http://www.js-data.io/docs/query-syntax
		 * @param options Optional configuration.
		 * @returns The collection of items that were ejected, if any.
		 */
		module.exports = function ejectAll(resourceName, params, options) {
		  var _this = this;
		  var DSUtils = _this.utils;
		  var definition = _this.definitions[resourceName];
		  params = params || {};
		
		  if (!definition) {
		    throw new _this.errors.NER(resourceName);
		  } else if (!DSUtils._o(params)) {
		    throw DSUtils._oErr('params');
		  }
		
		  options = DSUtils._(definition, options);
		  definition.logFn('ejectAll', params, options);
		
		  DSUtils.applyScope(definition, params, options);
		
		  var resource = _this.store[resourceName];
		  var queryHash = DSUtils.toJson(params);
		
		  // get items that match the criteria
		  var items = definition.filter(params);
		
		  if (DSUtils.isEmpty(params)) {
		    // remove all completed queries if ejecting all items
		    resource.completedQueries = {};
		  } else {
		    // remove matching completed query, if any
		    delete resource.completedQueries[queryHash];
		  }
		  // prepare to remove matching items
		  DSUtils.forEach(items, function (item) {
		    if (item && item[definition.idAttribute]) {
		      definition.eject(item[definition.idAttribute], options);
		    }
		  });
		  // collection has been modified
		  definition.handleChange(items);
		  return items;
		};
	
	/***/ },
	/* 45 */
	/***/ function(module, exports) {
	
		'use strict';
		
		/**
		 * Return the subset of items currently in the store that match the given criteria.
		 *
		 * The actual filtering is delegated to DS#defaults.defaultFilter, which can be overridden by developers.
		 *
		 * @param resourceName The name of the resource type of the items to filter.
		 * @param params The criteria by which to filter items. See http://www.js-data.io/docs/query-syntax
		 * @param options Optional configuration.
		 * @returns Matching items.
		 */
		module.exports = function filter(resourceName, params, options) {
		  var _this = this;
		  var DSUtils = _this.utils;
		  var definition = _this.definitions[resourceName];
		
		  if (!definition) {
		    throw new _this.errors.NER(resourceName);
		  } else if (params && !DSUtils._o(params)) {
		    throw DSUtils._oErr('params');
		  }
		
		  // Protect against null
		  params = params || {};
		  options = DSUtils._(definition, options);
		  options.logFn('filter', params, options);
		
		  DSUtils.applyScope(definition, params, options);
		
		  // delegate filtering to DS#defaults.defaultFilter, which can be overridden by developers.
		  return definition.defaultFilter.call(_this, _this.store[resourceName].collection, resourceName, params, options);
		};
	
	/***/ },
	/* 46 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		var _utils = __webpack_require__(2);
		
		var _utils2 = _interopRequireDefault(_utils);
		
		var _errors = __webpack_require__(3);
		
		var _errors2 = _interopRequireDefault(_errors);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		/**
		 * This is a beast of a file, but it's where a significant portion of the magic happens.
		 *
		 * DS#inject makes up the core of how data gets into the store.
		 */
		
		/**
		 * This factory function produces an observer handler function tailor-made for the current item being injected.
		 *
		 * The observer handler is what allows computed properties and change tracking to function.
		 *
		 * @param definition Resource definition produced by DS#defineResource
		 * @param resource Resource data as internally stored by the data store
		 * @returns {Function} Observer handler function
		 * @private
		 */
		function makeObserverHandler(definition, resource) {
		  var DS = this;
		
		  // using "var" avoids a JSHint error
		  var name = definition.name;
		
		  /**
		   * This will be called by observe-js when a new change record is available for the observed object
		   *
		   * @param added Change record for added properties
		   * @param removed Change record for removed properties
		   * @param changed Change record for changed properties
		   * @param oldValueFn Function that can be used to get the previous value of a changed property
		   * @param firstTime Whether this is the first time this function is being called for the given item. Will only be true once.
		   */
		  return function _react(added, removed, changed, oldValueFn, firstTime) {
		    var target = this;
		    var item = undefined;
		
		    // Get the previous primary key of the observed item, in-case some knucklehead changed it
		    var innerId = oldValueFn && oldValueFn(definition.idAttribute) ? oldValueFn(definition.idAttribute) : target[definition.idAttribute];
		
		    // Ignore changes to relation links
		    _utils2.default.forEach(definition.relationFields, function (field) {
		      delete added[field];
		      delete removed[field];
		      delete changed[field];
		    });
		
		    // Detect whether there are actually any changes
		    if (!_utils2.default.isEmpty(added) || !_utils2.default.isEmpty(removed) || !_utils2.default.isEmpty(changed) || firstTime) {
		      item = DS.get(name, innerId);
		
		      // update item and collection "modified" timestamps
		      resource.modified[innerId] = _utils2.default.updateTimestamp(resource.modified[innerId]);
		
		      if (item && definition.instanceEvents) {
		        setTimeout(function () {
		          item.emit('DS.change', definition, item);
		        }, 0);
		      }
		
		      definition.handleChange(item);
		
		      // Save a change record for the item
		      if (definition.keepChangeHistory) {
		        var changeRecord = {
		          resourceName: name,
		          target: item,
		          added: added,
		          removed: removed,
		          changed: changed,
		          timestamp: resource.modified[innerId]
		        };
		        resource.changeHistories[innerId].push(changeRecord);
		        resource.changeHistory.push(changeRecord);
		      }
		    }
		
		    // Recompute computed properties if any computed properties depend on changed properties
		    if (definition.computed) {
		      item = item || DS.get(name, innerId);
		      _utils2.default.forOwn(definition.computed, function (fn, field) {
		        if (_utils2.default._o(fn)) {
		          return;
		        }
		        var compute = false;
		        // check if required fields changed
		        _utils2.default.forEach(fn.deps, function (dep) {
		          if (dep in added || dep in removed || dep in changed || !(field in item)) {
		            compute = true;
		          }
		        });
		        compute = compute || !fn.deps.length;
		        if (compute) {
		          _utils2.default.compute.call(item, fn, field);
		        }
		      });
		    }
		
		    if (definition.idAttribute in changed) {
		      definition.errorFn('Doh! You just changed the primary key of an object! Your data for the "' + name + '" resource is now in an undefined (probably broken) state.');
		    }
		  };
		}
		
		/**
		 * A recursive function for injecting data into the store.
		 *
		 * @param definition Resource definition produced by DS#defineResource
		 * @param resource Resource data as internally stored by the data store
		 * @param attrs The data to be injected. Will be an object or an array of objects.
		 * @param options Optional configuration.
		 * @returns The injected data
		 * @private
		 */
		function _inject(definition, resource, attrs, options) {
		  var _this = this;
		  var injected = undefined;
		
		  if (_utils2.default._a(attrs)) {
		    // have an array of objects, go ahead and inject each one individually and return the resulting array
		    injected = [];
		    for (var i = 0; i < attrs.length; i++) {
		      injected.push(_inject.call(_this, definition, resource, attrs[i], options));
		    }
		  } else {
		    // check if "idAttribute" is a computed property
		    var c = definition.computed;
		    var idA = definition.idAttribute;
		    // compute the primary key if necessary
		    if (c && c[idA]) {
		      (function () {
		        var args = [];
		        _utils2.default.forEach(c[idA].deps, function (dep) {
		          args.push(attrs[dep]);
		        });
		        attrs[idA] = c[idA][c[idA].length - 1].apply(attrs, args);
		      })();
		    } else if (options.temporary) {
		      attrs[idA] = _utils2.default.guid();
		    }
		
		    if (!(idA in attrs)) {
		      var error = new _errors2.default.R(definition.name + '.inject: "attrs" must contain the property specified by "idAttribute"!');
		      options.errorFn(error);
		      throw error;
		    } else {
		      try {
		        (function () {
		          // when injecting object that contain their nested relations, this code
		          // will recursively inject them into their proper places in the data store.
		          // Magic!
		          _utils2.default.forEach(definition.relationList, function (def) {
		            var relationName = def.relation;
		            var relationDef = _this.definitions[relationName];
		            var toInject = attrs[def.localField];
		            if (typeof def.inject === 'function') {
		              def.inject(definition, def, attrs);
		            } else if (toInject && def.inject !== false) {
		              if (!relationDef) {
		                throw new _errors2.default.R(definition.name + ' relation is defined but the resource is not!');
		              }
		              // handle injecting hasMany relations
		              if (_utils2.default._a(toInject)) {
		                (function () {
		                  var items = [];
		                  _utils2.default.forEach(toInject, function (toInjectItem) {
		                    if (toInjectItem !== _this.store[relationName].index[toInjectItem[relationDef.idAttribute]]) {
		                      try {
		                        var injectedItem = relationDef.inject(toInjectItem, options.orig());
		                        if (def.foreignKey) {
		                          _utils2.default.set(injectedItem, def.foreignKey, attrs[definition.idAttribute]);
		                        }
		                        items.push(injectedItem);
		                      } catch (err) {
		                        options.errorFn(err, 'Failed to inject ' + def.type + ' relation: "' + relationName + '"!');
		                      }
		                    }
		                  });
		                })();
		              } else {
		                // handle injecting belongsTo and hasOne relations
		                if (toInject !== _this.store[relationName].index[toInject[relationDef.idAttribute]]) {
		                  try {
		                    var _injected = relationDef.inject(attrs[def.localField], options.orig());
		                    if (def.foreignKey) {
		                      _utils2.default.set(_injected, def.foreignKey, attrs[definition.idAttribute]);
		                    }
		                    if (def.localKey) {
		                      _utils2.default.set(attrs, def.localKey, _utils2.default.get(_injected, relationDef.idAttribute));
		                    }
		                  } catch (err) {
		                    options.errorFn(err, 'Failed to inject ' + def.type + ' relation: "' + relationName + '"!');
		                  }
		                }
		              }
		            }
		          });
		
		          // primary key of item being injected
		          var id = attrs[idA];
		          // item being injected
		          var item = definition.get(id);
		          // 0 if the item is new, otherwise the previous last modified timestamp of the item
		          var initialLastModified = item ? resource.modified[id] : 0;
		
		          // item is new
		          if (!item) {
		            if (attrs instanceof definition[definition['class']]) {
		              item = attrs;
		            } else {
		              item = new definition[definition['class']]();
		            }
		
		            if (definition.instanceEvents && typeof item.emit !== 'function') {
		              _utils2.default.Events(item);
		            }
		            // remove relation properties from the item, since those relations have been injected by now
		            _utils2.default.forEach(definition.relationList, function (def) {
		              if (typeof def.link === 'boolean' ? def.link : !!definition.linkRelations) {
		                delete attrs[def.localField];
		              }
		            });
		
		            // copy remaining properties to the injected item
		            _utils2.default.deepMixIn(item, attrs);
		
		            // add item to collection
		            resource.collection.push(item);
		            resource.changeHistories[id] = [];
		
		            // create the observer handler for the data to be injected
		            var _react = makeObserverHandler.call(_this, definition, resource);
		
		            // If we're in the browser, start observation
		            if (definition.watchChanges) {
		              resource.observers[id] = new _this.observe.ObjectObserver(item);
		              resource.observers[id].open(_react, item);
		            }
		
		            // index item
		            resource.index[id] = item;
		            // fire observation handler for the first time
		            _react.call(item, {}, {}, {}, null, true);
		            // save "previous" attributes of the injected item, for change diffs later
		            resource.previousAttributes[id] = _utils2.default.copy(item, null, null, null, definition.relationFields);
		            // mark item as temporary if guid has been generated
		            if (options.temporary) {
		              resource.temporaryItems[id] = true;
		            }
		          } else {
		            // item is being re-injected
		            // new properties take precedence
		            if (options.onConflict === 'merge') {
		              _utils2.default.deepMixIn(item, attrs);
		            } else if (options.onConflict === 'replace') {
		              _utils2.default.forOwn(item, function (v, k) {
		                if (k !== definition.idAttribute) {
		                  if (!attrs.hasOwnProperty(k)) {
		                    delete item[k];
		                  }
		                }
		              });
		              _utils2.default.forOwn(attrs, function (v, k) {
		                if (k !== definition.idAttribute) {
		                  item[k] = v;
		                }
		              });
		            }
		
		            if (definition.resetHistoryOnInject) {
		              // clear change history for item
		              _this.commit(definition.name, id);
		            }
		            if (resource.observers[id] && typeof resource.observers[id] === 'function') {
		              // force observation callback to be fired if there are any changes to the item and `Object.observe` is not available
		              resource.observers[id].deliver();
		            }
		          }
		          // update modified timestamp of item
		          resource.modified[id] = initialLastModified && resource.modified[id] === initialLastModified ? _utils2.default.updateTimestamp(resource.modified[id]) : resource.modified[id];
		
		          // reset expiry tracking for item
		          resource.expiresHeap.remove(item);
		          var timestamp = new Date().getTime();
		          resource.expiresHeap.push({
		            item: item,
		            timestamp: timestamp,
		            expires: definition.maxAge ? timestamp + definition.maxAge : Number.MAX_VALUE
		          });
		
		          // final injected item
		          injected = item;
		        })();
		      } catch (err) {
		        options.errorFn(err, attrs);
		      }
		    }
		  }
		  return injected;
		}
		
		/**
		 * Inject the given object or array of objects into the data store.
		 *
		 * @param resourceName The name of the type of resource of the data to be injected.
		 * @param attrs Object or array of objects. Objects must contain a primary key.
		 * @param options Optional configuration.
		 * @param options.notify Whether to emit the "DS.beforeInject" and "DS.afterInject" events.
		 * @returns The injected data.
		 */
		module.exports = function inject(resourceName, attrs, options) {
		  var _this = this;
		  var definition = _this.definitions[resourceName];
		  var resource = _this.store[resourceName];
		  var injected = undefined;
		
		  if (!definition) {
		    throw new _errors2.default.NER(resourceName);
		  } else if (!_utils2.default._o(attrs) && !_utils2.default._a(attrs)) {
		    throw new _errors2.default.IA(resourceName + '.inject: "attrs" must be an object or an array!');
		  }
		
		  options = _utils2.default._(definition, options);
		  options.logFn('inject', attrs, options);
		
		  // lifecycle
		  options.beforeInject(options, attrs);
		  if (options.notify) {
		    definition.emit('DS.beforeInject', definition, attrs);
		  }
		
		  // start the recursive injection of data
		  injected = _inject.call(_this, definition, resource, attrs, options);
		
		  // collection was modified
		  definition.handleChange(injected);
		
		  // lifecycle
		  options.afterInject(options, injected);
		  if (options.notify) {
		    definition.emit('DS.afterInject', definition, injected);
		  }
		
		  return injected;
		};
	
	/***/ },
	/* 47 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = {
		  create: __webpack_require__(48),
		  destroy: __webpack_require__(49),
		  destroyAll: __webpack_require__(50),
		  find: __webpack_require__(51),
		  findAll: __webpack_require__(52),
		  loadRelations: __webpack_require__(53),
		  reap: __webpack_require__(54),
		  refresh: function refresh(resourceName, id, options) {
		    var _this = this;
		    var DSUtils = _this.utils;
		
		    return new DSUtils.Promise(function (resolve, reject) {
		      var definition = _this.definitions[resourceName];
		      id = DSUtils.resolveId(_this.definitions[resourceName], id);
		      if (!definition) {
		        reject(new _this.errors.NER(resourceName));
		      } else if (!DSUtils._sn(id)) {
		        reject(DSUtils._snErr('id'));
		      } else {
		        options = DSUtils._(definition, options);
		        options.bypassCache = true;
		        options.logFn('refresh', id, options);
		        resolve(_this.get(resourceName, id));
		      }
		    }).then(function (item) {
		      return item ? _this.find(resourceName, id, options) : item;
		    }).catch(_this.errorFn('refresh', resourceName, id, options));
		  },
		  refreshAll: function refreshAll(resourceName, params, options) {
		    var _this = this;
		    var DSUtils = _this.utils;
		    var definition = _this.definitions[resourceName];
		    params = params || {};
		
		    return new DSUtils.Promise(function (resolve, reject) {
		      if (!definition) {
		        reject(new _this.errors.NER(resourceName));
		      } else if (!DSUtils._o(params)) {
		        reject(DSUtils._oErr('params'));
		      } else {
		        options = DSUtils._(definition, options);
		        options.bypassCache = true;
		        options.logFn('refreshAll', params, options);
		        resolve(_this.filter(resourceName, params, options));
		      }
		    }).then(function (existing) {
		      options.bypassCache = true;
		      return _this.findAll(resourceName, params, options).then(function (found) {
		        DSUtils.forEach(existing, function (item) {
		          if (found.indexOf(item) === -1) {
		            definition.eject(item);
		          }
		        });
		        return found;
		      });
		    }).catch(_this.errorFn('refreshAll', resourceName, params, options));
		  },
		
		  save: __webpack_require__(55),
		  update: __webpack_require__(56),
		  updateAll: __webpack_require__(57)
		};
	
	/***/ },
	/* 48 */
	/***/ function(module, exports) {
	
		'use strict';
		
		/**
		 * Using an adapter, create a new item.
		 *
		 * Generally a primary key will NOT be provided in the properties hash,
		 * because the adapter's persistence layer should be generating one.
		 *
		 * @param resourceName The name of the type of resource of the new item.
		 * @param attrs Hash of properties with which to create the new item.
		 * @param options Optional configuration.
		 * @param options.cacheResponse Whether the newly created item as returned by the adapter should be injected into the data store.
		 * @param options.upsert If the properties hash contains a primary key, attempt to call DS#update instead.
		 * @param options.notify Whether to emit the "DS.beforeCreate" and "DS.afterCreate" events.
		 * @param options.beforeValidate Lifecycle hook.
		 * @param options.validate Lifecycle hook.
		 * @param options.afterValidate Lifecycle hook.
		 * @param options.beforeCreate Lifecycle hook.
		 * @param options.afterCreate Lifecycle hook.
		 */
		module.exports = function create(resourceName, attrs, options) {
		  var _this = this;
		  var DSUtils = _this.utils;
		  var definition = _this.definitions[resourceName];
		  var resource = _this.store[resourceName];
		  var adapter = undefined;
		
		  options = options || {};
		  attrs = attrs || {};
		
		  var rejectionError = undefined;
		  if (!definition) {
		    rejectionError = new _this.errors.NER(resourceName);
		  } else if (!DSUtils._o(attrs)) {
		    rejectionError = DSUtils._oErr('attrs');
		  } else {
		    options = DSUtils._(definition, options);
		    if (options.upsert && DSUtils._sn(attrs[definition.idAttribute]) && !resource.temporaryItems[attrs[definition.idAttribute]]) {
		      return _this.update(resourceName, attrs[definition.idAttribute], attrs, options);
		    }
		    options.logFn('create', attrs, options);
		  }
		
		  return new DSUtils.Promise(function (resolve, reject) {
		    if (rejectionError) {
		      reject(rejectionError);
		    } else {
		      resolve(attrs);
		    }
		  })
		  // start lifecycle
		  .then(function (attrs) {
		    return options.beforeValidate.call(attrs, options, attrs);
		  }).then(function (attrs) {
		    return options.validate.call(attrs, options, attrs);
		  }).then(function (attrs) {
		    return options.afterValidate.call(attrs, options, attrs);
		  }).then(function (attrs) {
		    return options.beforeCreate.call(attrs, options, attrs);
		  }).then(function (attrs) {
		    if (options.notify) {
		      definition.emit('DS.beforeCreate', definition, attrs);
		    }
		    adapter = _this.getAdapterName(options);
		    return _this.adapters[adapter].create(definition, DSUtils.omit(attrs, options.omit), options);
		  }).then(function (attrs) {
		    return options.afterCreate.call(attrs, options, attrs);
		  }).then(function (attrs) {
		    if (options.notify) {
		      definition.emit('DS.afterCreate', definition, attrs);
		    }
		    if (options.cacheResponse) {
		      // injected created intem into the store
		      var created = _this.inject(definition.name, attrs, options.orig());
		      var id = created[definition.idAttribute];
		      // mark item's `find` query as completed, so a subsequent `find` call for this item will resolve immediately
		      var _resource = _this.store[resourceName];
		      _resource.completedQueries[id] = new Date().getTime();
		      _resource.saved[id] = DSUtils.updateTimestamp(_resource.saved[id]);
		      return created;
		    } else {
		      // just return an un-injected instance
		      return _this.createInstance(resourceName, attrs, options);
		    }
		  }).then(function (item) {
		    return DSUtils.respond(item, { adapter: adapter }, options);
		  })['catch'](_this.errorFn('create', resourceName, attrs, options));
		};
	
	/***/ },
	/* 49 */
	/***/ function(module, exports) {
	
		'use strict';
		
		/**
		 * Using an adapter, destroy an item.
		 *
		 * @param resourceName The name of the type of resource of the item to destroy.
		 * @param id The primary key of the item to destroy.
		 * @param options Optional configuration.
		 * @param options.eagerEject Whether to eject the item from the store before the adapter operation completes, re-injecting if the adapter operation fails.
		 * @param options.notify Whether to emit the "DS.beforeDestroy" and "DS.afterDestroy" events.
		 * @param options.beforeDestroy Lifecycle hook.
		 * @param options.afterDestroy Lifecycle hook.
		 * @returns The primary key of the destroyed item.
		 */
		module.exports = function destroy(resourceName, id, options) {
		  var _this = this;
		  var DSUtils = _this.utils;
		  var definition = _this.definitions[resourceName];
		  var item = undefined,
		      adapter = undefined;
		
		  return new DSUtils.Promise(function (resolve, reject) {
		    id = DSUtils.resolveId(definition, id);
		    if (!definition) {
		      reject(new _this.errors.NER(resourceName));
		    } else if (!DSUtils._sn(id)) {
		      reject(DSUtils._snErr('id'));
		    } else {
		      // check if the item is in the store
		      item = definition.get(id) || { id: id };
		      options = DSUtils._(definition, options);
		      options.logFn('destroy', id, options);
		      resolve(item);
		    }
		  })
		  // start lifecycle
		  .then(function (attrs) {
		    return options.beforeDestroy.call(attrs, options, attrs);
		  }).then(function (attrs) {
		    if (options.notify) {
		      definition.emit('DS.beforeDestroy', definition, attrs);
		    }
		    // don't wait for the adapter, remove the item from the store
		    if (options.eagerEject) {
		      definition.eject(id);
		    }
		    adapter = definition.getAdapter(options);
		    return adapter.destroy(definition, id, options);
		  }).then(function () {
		    return options.afterDestroy.call(item, options, item);
		  }).then(function (item) {
		    if (options.notify) {
		      definition.emit('DS.afterDestroy', definition, item);
		    }
		    // make sure the item is removed from the store
		    definition.eject(id);
		    return DSUtils.respond(id, { adapter: adapter }, options);
		  })['catch'](function (err) {
		    // rollback by re-injecting the item into the store
		    if (options && options.eagerEject && item) {
		      definition.inject(item, { notify: false });
		    }
		    return _this.errorFn('destroy', resourceName, id, options)(err);
		  });
		};
	
	/***/ },
	/* 50 */
	/***/ function(module, exports) {
	
		'use strict';
		
		/**
		 * Using an adapter, destroy an item.
		 *
		 * @param resourceName The name of the type of resource of the item to destroy.
		 * @param params The criteria by which to filter items to destroy. See http://www.js-data.io/docs/query-syntax
		 * @param options Optional configuration.
		 * @param options.eagerEject Whether to eject the items from the store before the adapter operation completes, re-injecting if the adapter operation fails.
		 * @param options.notify Whether to emit the "DS.beforeDestroy" and "DS.afterDestroy" events.
		 * @param options.beforeDestroy Lifecycle hook.
		 * @param options.afterDestroy Lifecycle hook.
		 * @returns The ejected items, if any.
		 */
		module.exports = function destroyAll(resourceName, params, options) {
		  var _this = this;
		  var DSUtils = _this.utils;
		  var definition = _this.definitions[resourceName];
		  var ejected = undefined,
		      toEject = undefined,
		      adapter = undefined;
		
		  params = params || {};
		
		  return new DSUtils.Promise(function (resolve, reject) {
		    if (!definition) {
		      reject(new _this.errors.NER(resourceName));
		    } else if (!DSUtils._o(params)) {
		      reject(DSUtils._oErr('attrs'));
		    } else {
		      options = DSUtils._(definition, options);
		      options.logFn('destroyAll', params, options);
		      DSUtils.applyScope(definition, params, options);
		      resolve();
		    }
		  }).then(function () {
		    // find items that are to be ejected from the store
		    toEject = definition.defaultFilter.call(_this, resourceName, params);
		    return options.beforeDestroy(options, toEject);
		  }).then(function () {
		    if (options.notify) {
		      definition.emit('DS.beforeDestroy', definition, toEject);
		    }
		    // don't wait for the adapter, remove the items from the store
		    if (options.eagerEject) {
		      ejected = definition.ejectAll(params);
		    }
		    adapter = definition.getAdapterName(options);
		    return _this.adapters[adapter].destroyAll(definition, params, options);
		  }).then(function () {
		    return options.afterDestroy(options, toEject);
		  }).then(function () {
		    if (options.notify) {
		      definition.emit('DS.afterDestroy', definition, toEject);
		    }
		    // make sure items are removed from the store
		    return ejected || definition.ejectAll(params);
		  }).then(function (items) {
		    return DSUtils.respond(items, { adapter: adapter }, options);
		  })['catch'](function (err) {
		    // rollback by re-injecting the items into the store
		    if (options && options.eagerEject && ejected) {
		      definition.inject(ejected, { notify: false });
		    }
		    return _this.errorFn('destroyAll', resourceName, params, options)(err);
		  });
		};
	
	/***/ },
	/* 51 */
	/***/ function(module, exports) {
	
		'use strict';
		
		/* jshint -W082 */
		
		/**
		 * Using an adapter, retrieve a single item.
		 *
		 * @param resourceName The of the type of resource of the item to retrieve.
		 * @param id The primary key of the item to retrieve.
		 * @param options Optional configuration.
		 * @param options.bypassCache Whether to ignore any cached item and force the retrieval through the adapter.
		 * @param options.cacheResponse Whether to inject the found item into the data store.
		 * @param options.strictCache Whether to only consider items to be "cached" if they were injected into the store as the result of `find` or `findAll`.
		 * @param options.strategy The retrieval strategy to use.
		 * @param options.findStrategy The retrieval strategy to use. Overrides "strategy".
		 * @param options.fallbackAdapters Array of names of adapters to use if using "fallback" strategy.
		 * @param options.findFallbackAdapters Array of names of adapters to use if using "fallback" strategy. Overrides "fallbackAdapters".
		 * @returns The item.
		 */
		module.exports = function find(resourceName, id, options) {
		  var _this = this;
		  var DSUtils = _this.utils;
		  var definition = _this.definitions[resourceName];
		  var resource = _this.store[resourceName];
		  var adapter = undefined;
		
		  return new DSUtils.Promise(function (resolve, reject) {
		    if (!definition) {
		      reject(new _this.errors.NER(resourceName));
		    } else if (!DSUtils._sn(id)) {
		      reject(DSUtils._snErr('id'));
		    } else {
		      options = DSUtils._(definition, options);
		      options.logFn('find', id, options);
		
		      if (options.params) {
		        options.params = DSUtils.copy(options.params);
		      }
		
		      if (options.bypassCache || !options.cacheResponse) {
		        delete resource.completedQueries[id];
		      }
		
		      var expired = options.maxAge && id in resource.completedQueries && resource.completedQueries[id] + options.maxAge < new Date().getTime();
		
		      if ((!options.findStrictCache || id in resource.completedQueries) && definition.get(id) && !options.bypassCache && !expired) {
		        // resolve immediately with the cached item
		        resolve(definition.get(id));
		      } else {
		        // we're going to delegate to the adapter next
		        delete resource.completedQueries[id];
		        resolve();
		      }
		    }
		  }).then(function (item) {
		    if (!item) {
		      if (!(id in resource.pendingQueries)) {
		        var promise = undefined;
		        var strategy = options.findStrategy || options.strategy;
		
		        // try subsequent adapters if the preceeding one fails
		        if (strategy === 'fallback') {
		          var makeFallbackCall = function makeFallbackCall(index) {
		            adapter = definition.getAdapterName((options.findFallbackAdapters || options.fallbackAdapters)[index]);
		            return _this.adapters[adapter].find(definition, id, options)['catch'](function (err) {
		              index++;
		              if (index < options.fallbackAdapters.length) {
		                return makeFallbackCall(index);
		              } else {
		                return DSUtils.Promise.reject(err);
		              }
		            });
		          };
		
		          promise = makeFallbackCall(0);
		        } else {
		          adapter = definition.getAdapterName(options);
		          // just make a single attempt
		          promise = _this.adapters[adapter].find(definition, id, options);
		        }
		
		        resource.pendingQueries[id] = promise.then(function (data) {
		          return options.afterFind.call(data, options, data);
		        }).then(function (data) {
		          // Query is no longer pending
		          delete resource.pendingQueries[id];
		          if (options.cacheResponse) {
		            // inject the item into the data store
		            var injected = definition.inject(data, options.orig());
		            // mark the item as "cached"
		            resource.completedQueries[id] = new Date().getTime();
		            resource.saved[id] = DSUtils.updateTimestamp(resource.saved[id]);
		            return injected;
		          } else {
		            // just return an un-injected instance
		            return definition.createInstance(data, options.orig());
		          }
		        });
		      }
		      return resource.pendingQueries[id];
		    } else {
		      // resolve immediately with the item
		      return item;
		    }
		  }).then(function (item) {
		    return DSUtils.respond(item, { adapter: adapter }, options);
		  })['catch'](function (err) {
		    if (resource) {
		      delete resource.pendingQueries[id];
		    }
		    return _this.errorFn('find', resourceName, id, options)(err);
		  });
		};
	
	/***/ },
	/* 52 */
	/***/ function(module, exports) {
	
		'use strict';
		
		/* jshint -W082 */
		function processResults(data, resourceName, queryHash, options) {
		  var _this = this;
		  var DSUtils = _this.utils;
		  var definition = _this.definitions[resourceName];
		  var resource = _this.store[resourceName];
		  var idAttribute = definition.idAttribute;
		  var date = new Date().getTime();
		
		  data = data || [];
		
		  // Query is no longer pending
		  delete resource.pendingQueries[queryHash];
		  resource.completedQueries[queryHash] = date;
		
		  // Merge the new values into the cache
		  var injected = definition.inject(data, options.orig());
		
		  // Make sure each object is added to completedQueries
		  if (DSUtils._a(injected)) {
		    DSUtils.forEach(injected, function (item) {
		      if (item) {
		        var id = item[idAttribute];
		        if (id) {
		          resource.completedQueries[id] = date;
		          resource.saved[id] = DSUtils.updateTimestamp(resource.saved[id]);
		        }
		      }
		    });
		  } else {
		    options.errorFn('response is expected to be an array!');
		    resource.completedQueries[injected[idAttribute]] = date;
		  }
		
		  return injected;
		}
		
		/**
		 * Using an adapter, retrieve a collection of items.
		 *
		 * @param resourceName The name of the type of resource of the items to retrieve.
		 * @param params The criteria by which to filter items to retrieve. See http://www.js-data.io/docs/query-syntax
		 * @param options Optional configuration.
		 * @param options.bypassCache Whether to ignore any cached query for these items and force the retrieval through the adapter.
		 * @param options.cacheResponse Whether to inject the found items into the data store.
		 * @returns The items.
		 */
		module.exports = function findAll(resourceName, params, options) {
		  var _this = this;
		  var DSUtils = _this.utils;
		  var definition = _this.definitions[resourceName];
		  var resource = _this.store[resourceName];
		  var queryHash = undefined,
		      adapter = undefined;
		
		  return new DSUtils.Promise(function (resolve, reject) {
		    params = params || {};
		
		    if (!_this.definitions[resourceName]) {
		      reject(new _this.errors.NER(resourceName));
		    } else if (!DSUtils._o(params)) {
		      reject(DSUtils._oErr('params'));
		    } else {
		      options = DSUtils._(definition, options);
		      queryHash = DSUtils.toJson(params);
		      options.logFn('findAll', params, options);
		
		      if (options.params) {
		        options.params = DSUtils.copy(options.params);
		      }
		
		      DSUtils.applyScope(definition, params, options);
		
		      // force a new request
		      if (options.bypassCache || !options.cacheResponse) {
		        delete resource.completedQueries[queryHash];
		        delete resource.queryData[queryHash];
		      }
		
		      var expired = options.maxAge && queryHash in resource.completedQueries && resource.completedQueries[queryHash] + options.maxAge < new Date().getTime();
		
		      if (queryHash in resource.completedQueries && !expired) {
		        if (options.useFilter) {
		          if (options.localKeys) {
		            resolve(definition.getAll(options.localKeys, options.orig()));
		          } else {
		            // resolve immediately by filtering data from the data store
		            resolve(definition.filter(params, options.orig()));
		          }
		        } else {
		          // resolve immediately by returning the cached array from the previously made query
		          resolve(resource.queryData[queryHash]);
		        }
		      } else {
		        resolve();
		      }
		    }
		  }).then(function (items) {
		    if (!items) {
		      if (!(queryHash in resource.pendingQueries)) {
		        var promise = undefined;
		        var strategy = options.findAllStrategy || options.strategy;
		
		        // try subsequent adapters if the preceeding one fails
		        if (strategy === 'fallback') {
		          var makeFallbackCall = function makeFallbackCall(index) {
		            adapter = definition.getAdapterName((options.findAllFallbackAdapters || options.fallbackAdapters)[index]);
		            return _this.adapters[adapter].findAll(definition, params, options)['catch'](function (err) {
		              index++;
		              if (index < options.fallbackAdapters.length) {
		                return makeFallbackCall(index);
		              } else {
		                return DSUtils.Promise.reject(err);
		              }
		            });
		          };
		
		          promise = makeFallbackCall(0);
		        } else {
		          adapter = definition.getAdapterName(options);
		          // just make a single attempt
		          promise = _this.adapters[adapter].findAll(definition, params, options);
		        }
		
		        resource.pendingQueries[queryHash] = promise.then(function (data) {
		          return options.afterFindAll.call(data, options, data);
		        }).then(function (data) {
		          // Query is no longer pending
		          delete resource.pendingQueries[queryHash];
		          if (options.cacheResponse) {
		            // inject the items into the data store
		            resource.queryData[queryHash] = processResults.call(_this, data, resourceName, queryHash, options);
		            resource.queryData[queryHash].$$injected = true;
		            return resource.queryData[queryHash];
		          } else {
		            DSUtils.forEach(data, function (item, i) {
		              data[i] = definition.createInstance(item, options.orig());
		            });
		            return data;
		          }
		        });
		      }
		
		      return resource.pendingQueries[queryHash];
		    } else {
		      // resolve immediately with the items
		      return items;
		    }
		  }).then(function (items) {
		    return DSUtils.respond(items, { adapter: adapter }, options);
		  })['catch'](function (err) {
		    if (resource) {
		      delete resource.pendingQueries[queryHash];
		    }
		    return _this.errorFn('findAll', resourceName, params, options)(err);
		  });
		};
	
	/***/ },
	/* 53 */
	/***/ function(module, exports) {
	
		'use strict';
		
		function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
		
		/**
		 * Load the specified relations for the given instance.
		 *
		 * @param resourceName The name of the type of resource of the instance for which to load relations.
		 * @param instance The instance or the primary key of the instance.
		 * @param relations An array of the relations to load.
		 * @param options Optional configuration.
		 * @returns The instance, now with its relations loaded.
		 */
		module.exports = function loadRelations(resourceName, instance, relations, options) {
		  var _this = this;
		  var DSUtils = _this.utils;
		  var DSErrors = _this.errors;
		
		  var definition = _this.definitions[resourceName];
		  var _options = undefined;
		
		  return new DSUtils.Promise(function (resolve, reject) {
		    if (DSUtils._sn(instance)) {
		      instance = definition.get(instance);
		    }
		
		    if (DSUtils._s(relations)) {
		      relations = [relations];
		    }
		
		    relations = relations || [];
		
		    if (!definition) {
		      reject(new DSErrors.NER(resourceName));
		    } else if (!DSUtils._o(instance)) {
		      reject(new DSErrors.IA('"instance(id)" must be a string, number or object!'));
		    } else if (!DSUtils._a(relations)) {
		      reject(new DSErrors.IA('"relations" must be a string or an array!'));
		    } else {
		      (function () {
		        _options = DSUtils._(definition, options);
		        _options.logFn('loadRelations', instance, relations, _options);
		
		        var tasks = [];
		
		        DSUtils.forEach(definition.relationList, function (def) {
		          var relationName = def.relation;
		          var relationDef = definition.getResource(relationName);
		          var __options = DSUtils._(relationDef, options);
		
		          // relations can be loaded based on resource name or field name
		          if (!relations.length || DSUtils.contains(relations, relationName) || DSUtils.contains(relations, def.localField)) {
		            var task = undefined;
		            var params = {};
		            if (__options.allowSimpleWhere) {
		              params[def.foreignKey] = instance[definition.idAttribute];
		            } else {
		              params.where = {};
		              params.where[def.foreignKey] = {
		                '==': instance[definition.idAttribute]
		              };
		            }
		
		            var orig = __options.orig();
		            var defKey = def.localKey ? DSUtils.get(instance, def.localKey) : null;
		            var hasDefKey = !!(defKey || defKey === 0);
		
		            if (typeof def.load === 'function') {
		              task = def.load(definition, def, instance, orig);
		            } else {
		              if (def.type === 'hasMany') {
		                if (def.localKeys) {
		                  delete params[def.foreignKey];
		                  var keys = DSUtils.get(instance, def.localKeys) || [];
		                  keys = DSUtils._a(keys) ? keys : DSUtils.keys(keys);
		                  params.where = _defineProperty({}, relationDef.idAttribute, {
		                    'in': keys
		                  });
		                  orig.localKeys = keys;
		                } else if (def.foreignKeys) {
		                  delete params[def.foreignKey];
		                  params.where = _defineProperty({}, def.foreignKeys, {
		                    contains: instance[definition.idAttribute]
		                  });
		                }
		                task = relationDef.findAll(params, orig);
		              } else if (def.type === 'hasOne') {
		                if (def.localKey && hasDefKey) {
		                  task = relationDef.find(defKey, orig);
		                } else if (def.foreignKey) {
		                  task = relationDef.findAll(params, orig).then(function (hasOnes) {
		                    return hasOnes.length ? hasOnes[0] : null;
		                  });
		                }
		              } else if (hasDefKey) {
		                task = relationDef.find(defKey, orig);
		              }
		            }
		
		            if (task) {
		              if (!_options.linkRelations) {
		                task = task.then(function (data) {
		                  instance[def.localField] = data;
		                });
		              }
		              tasks.push(task);
		            }
		          }
		        });
		
		        resolve(tasks);
		      })();
		    }
		  }).then(function (tasks) {
		    return DSUtils.Promise.all(tasks);
		  }).then(function () {
		    return _options.afterLoadRelations.call(instance, _options, instance);
		  }).catch(_this.errorFn('loadRelations', resourceName, instance, relations, options));
		};
	
	/***/ },
	/* 54 */
	/***/ function(module, exports) {
	
		'use strict';
		
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
		
		/**
		 * Find expired items of the specified resource type and perform the configured action.
		 *
		 * @param resourceName The name of the type of resource of the items to reap.
		 * @param options Optional configuration.
		 * @returns The reaped items.
		 */
		module.exports = function reap(resourceName, options) {
		  var _this = this;
		  var DSUtils = _this.utils;
		  var definition = _this.definitions[resourceName];
		  var resource = _this.store[resourceName];
		
		  return new DSUtils.Promise(function (resolve, reject) {
		    if (!definition) {
		      reject(new _this.errors.NER(resourceName));
		    } else {
		      options = DSUtils._(definition, options);
		      if (!options.hasOwnProperty('notify')) {
		        options.notify = false;
		      }
		      options.logFn('reap', options);
		      var items = [];
		      var now = new Date().getTime();
		      var expiredItem = undefined;
		
		      // find the expired items
		      while ((expiredItem = resource.expiresHeap.peek()) && expiredItem.expires < now) {
		        items.push(expiredItem.item);
		        delete expiredItem.item;
		        resource.expiresHeap.pop();
		      }
		      resolve(items);
		    }
		  }).then(function (items) {
		    // only hit lifecycle if there are items
		    if (items.length) {
		      definition.beforeReap(options, items);
		      if (options.notify) {
		        definition.emit('DS.beforeReap', definition, items);
		      }
		    }
		
		    if (options.reapAction === 'inject') {
		      (function () {
		        var timestamp = new Date().getTime();
		        DSUtils.forEach(items, function (item) {
		          resource.expiresHeap.push({
		            item: item,
		            timestamp: timestamp,
		            expires: definition.maxAge ? timestamp + definition.maxAge : Number.MAX_VALUE
		          });
		        });
		      })();
		    } else if (options.reapAction === 'eject') {
		      DSUtils.forEach(items, function (item) {
		        definition.eject(item[definition.idAttribute]);
		      });
		    } else if (options.reapAction === 'refresh') {
		      var _ret2 = function () {
		        var tasks = [];
		        DSUtils.forEach(items, function (item) {
		          tasks.push(definition.refresh(item[definition.idAttribute]));
		        });
		        return {
		          v: DSUtils.Promise.all(tasks)
		        };
		      }();
		
		      if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
		    }
		    return items;
		  }).then(function (items) {
		    // only hit lifecycle if there are items
		    if (items.length) {
		      definition.afterReap(options, items);
		      if (options.notify) {
		        definition.emit('DS.afterReap', definition, items);
		      }
		    }
		    return items;
		  }).catch(_this.errorFn('reap', resourceName, options));
		};
	
	/***/ },
	/* 55 */
	/***/ function(module, exports) {
	
		'use strict';
		
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
		
		/**
		 * Save a single item in its present state.
		 *
		 * @param resourceName The name of the type of resource of the item.
		 * @param id The primary key of the item.
		 * @param options Optional congifuration.
		 * @returns The item, now saved.
		 */
		module.exports = function save(resourceName, id, options) {
		  var _this = this;
		  var DSUtils = _this.utils;
		  var DSErrors = _this.errors;
		
		  var definition = _this.definitions[resourceName];
		  var resource = _this.store[resourceName];
		  var item = undefined,
		      noChanges = undefined,
		      adapter = undefined;
		
		  return new DSUtils.Promise(function (resolve, reject) {
		    id = DSUtils.resolveId(definition, id);
		    if (!definition) {
		      reject(new DSErrors.NER(resourceName));
		    } else if (!DSUtils._sn(id)) {
		      reject(DSUtils._snErr('id'));
		    } else if (!definition.get(id)) {
		      reject(new DSErrors.R('id "' + id + '" not found in cache!'));
		    } else {
		      item = definition.get(id);
		      options = DSUtils._(definition, options);
		      options.logFn('save', id, options);
		      resolve(item);
		    }
		  })
		  // start lifecycle
		  .then(function (attrs) {
		    return options.beforeValidate.call(attrs, options, attrs);
		  }).then(function (attrs) {
		    return options.validate.call(attrs, options, attrs);
		  }).then(function (attrs) {
		    return options.afterValidate.call(attrs, options, attrs);
		  }).then(function (attrs) {
		    return options.beforeUpdate.call(attrs, options, attrs);
		  }).then(function (attrs) {
		    if (options.notify) {
		      definition.emit('DS.beforeUpdate', definition, attrs);
		    }
		    // only send changed properties to the adapter
		    if (options.changesOnly) {
		      var key;
		
		      var _ret = function () {
		        if (resource.observers[id] && typeof resource.observers[id] === 'function') {
		          resource.observers[id].deliver();
		        }
		        var toKeep = [];
		        var changes = definition.changes(id);
		
		        for (key in changes.added) {
		          toKeep.push(key);
		        }
		        for (key in changes.changed) {
		          toKeep.push(key);
		        }
		        DSUtils.forEach(options.always, function (property) {
		          toKeep.push(property);
		        });
		        changes = DSUtils.pick(attrs, toKeep);
		        // no changes? no save
		        if (DSUtils.isEmpty(changes)) {
		          // no changes, return
		          options.logFn('save - no changes', id, options);
		          noChanges = true;
		          return {
		            v: attrs
		          };
		        } else {
		          attrs = changes;
		        }
		      }();
		
		      if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
		    }
		    adapter = definition.getAdapterName(options);
		    return _this.adapters[adapter].update(definition, id, DSUtils.omit(attrs, options.omit), options);
		  }).then(function (data) {
		    return options.afterUpdate.call(data, options, data);
		  }).then(function (attrs) {
		    if (options.notify) {
		      definition.emit('DS.afterUpdate', definition, attrs);
		    }
		    if (noChanges) {
		      // no changes, just return
		      return attrs;
		    } else if (options.cacheResponse) {
		      // inject the reponse into the store, updating the item
		      var injected = definition.inject(attrs, options.orig());
		      // mark the item as "saved"
		      resource.saved[id] = DSUtils.updateTimestamp(resource.saved[id]);
		      if (!definition.resetHistoryOnInject) {
		        resource.previousAttributes[id] = DSUtils.copy(injected, null, null, null, definition.relationFields);
		      }
		      return injected;
		    } else {
		      // just return an instance
		      return definition.createInstance(attrs, options.orig());
		    }
		  }).then(function (item) {
		    return DSUtils.respond(item, { adapter: adapter }, options);
		  }).catch(_this.errorFn('save', resourceName, id, options));
		};
	
	/***/ },
	/* 56 */
	/***/ function(module, exports) {
	
		'use strict';
		
		/**
		 * Update a single item using the supplied properties hash.
		 *
		 * @param resourceName The name of the type of resource of the item to update.
		 * @param id The primary key of the item to update.
		 * @param attrs The attributes with which to update the item.
		 * @param options Optional configuration.
		 * @returns The item, now updated.
		 */
		module.exports = function update(resourceName, id, attrs, options) {
		  var _this = this;
		  var DSUtils = _this.utils;
		  var DSErrors = _this.errors;
		
		  var definition = _this.definitions[resourceName];
		  var adapter = undefined;
		
		  return new DSUtils.Promise(function (resolve, reject) {
		    id = DSUtils.resolveId(definition, id);
		    if (!definition) {
		      reject(new DSErrors.NER(resourceName));
		    } else if (!DSUtils._sn(id)) {
		      reject(DSUtils._snErr('id'));
		    } else {
		      options = DSUtils._(definition, options);
		      options.logFn('update', id, attrs, options);
		      resolve(attrs);
		    }
		  })
		  // start lifecycle
		  .then(function (attrs) {
		    return options.beforeValidate.call(attrs, options, attrs);
		  }).then(function (attrs) {
		    return options.validate.call(attrs, options, attrs);
		  }).then(function (attrs) {
		    return options.afterValidate.call(attrs, options, attrs);
		  }).then(function (attrs) {
		    return options.beforeUpdate.call(attrs, options, attrs);
		  }).then(function (attrs) {
		    if (options.notify) {
		      definition.emit('DS.beforeUpdate', definition, attrs);
		    }
		    adapter = definition.getAdapterName(options);
		    return _this.adapters[adapter].update(definition, id, DSUtils.omit(attrs, options.omit), options);
		  }).then(function (data) {
		    return options.afterUpdate.call(data, options, data);
		  }).then(function (attrs) {
		    if (options.notify) {
		      definition.emit('DS.afterUpdate', definition, attrs);
		    }
		    if (options.cacheResponse) {
		      // inject the updated item into the store
		      var injected = definition.inject(attrs, options.orig());
		      var resource = _this.store[resourceName];
		      var _id = injected[definition.idAttribute];
		      // mark the item as "saved"
		      resource.saved[_id] = DSUtils.updateTimestamp(resource.saved[_id]);
		      if (!definition.resetHistoryOnInject) {
		        resource.previousAttributes[_id] = DSUtils.copy(injected, null, null, null, definition.relationFields);
		      }
		      return injected;
		    } else {
		      // just return an instance
		      return definition.createInstance(attrs, options.orig());
		    }
		  }).then(function (item) {
		    return DSUtils.respond(item, { adapter: adapter }, options);
		  }).catch(_this.errorFn('update', resourceName, id, attrs, options));
		};
	
	/***/ },
	/* 57 */
	/***/ function(module, exports) {
	
		'use strict';
		
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
		
		/**
		 * Update a collection of items using the supplied properties hash.
		 *
		 * @param resourceName The name of the type of resource of the items to update.
		 * @param attrs  The attributes with which to update the item.
		 * @param params The criteria by which to select items to update. See http://www.js-data.io/docs/query-syntax
		 * @param options Optional configuration.
		 * @returns The updated items.
		 */
		module.exports = function updateAll(resourceName, attrs, params, options) {
		  var _this = this;
		  var DSUtils = _this.utils;
		  var DSErrors = _this.errors;
		
		  var definition = _this.definitions[resourceName];
		  var adapter = undefined;
		
		  return new DSUtils.Promise(function (resolve, reject) {
		    if (!definition) {
		      reject(new DSErrors.NER(resourceName));
		    } else {
		      options = DSUtils._(definition, options);
		      options.logFn('updateAll', attrs, params, options);
		      DSUtils.applyScope(definition, params, options);
		      resolve(attrs);
		    }
		  })
		  // start lifecycle
		  .then(function (attrs) {
		    return options.beforeValidate.call(attrs, options, attrs);
		  }).then(function (attrs) {
		    return options.validate.call(attrs, options, attrs);
		  }).then(function (attrs) {
		    return options.afterValidate.call(attrs, options, attrs);
		  }).then(function (attrs) {
		    return options.beforeUpdate.call(attrs, options, attrs);
		  }).then(function (attrs) {
		    if (options.notify) {
		      definition.emit('DS.beforeUpdate', definition, attrs);
		    }
		    adapter = definition.getAdapterName(options);
		    return _this.adapters[adapter].updateAll(definition, DSUtils.omit(attrs, options.omit), params, options);
		  }).then(function (data) {
		    return options.afterUpdate.call(data, options, data);
		  }).then(function (data) {
		    if (options.notify) {
		      definition.emit('DS.afterUpdate', definition, attrs);
		    }
		    var origOptions = options.orig();
		    if (options.cacheResponse) {
		      var _ret = function () {
		        // inject the updated items into the store
		        var injected = definition.inject(data, origOptions);
		        var resource = _this.store[resourceName];
		        // mark the items as "saved"
		        DSUtils.forEach(injected, function (i) {
		          var id = i[definition.idAttribute];
		          resource.saved[id] = DSUtils.updateTimestamp(resource.saved[id]);
		          if (!definition.resetHistoryOnInject) {
		            resource.previousAttributes[id] = DSUtils.copy(i, null, null, null, definition.relationFields);
		          }
		        });
		        return {
		          v: injected
		        };
		      }();
		
		      if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
		    } else {
		      var _ret2 = function () {
		        // just return instances
		        var instances = [];
		        DSUtils.forEach(data, function (item) {
		          instances.push(definition.createInstance(item, origOptions));
		        });
		        return {
		          v: instances
		        };
		      }();
		
		      if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
		    }
		  }).then(function (items) {
		    return DSUtils.respond(items, { adapter: adapter }, options);
		  }).catch(_this.errorFn('updateAll', resourceName, attrs, params, options));
		};
	
	/***/ }
	/******/ ])
	});
	;
	//# sourceMappingURL=js-data-debug.js.map

/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(511);

/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(512);
	var utils = __webpack_require__(513);
	var dispatchRequest = __webpack_require__(515);
	var InterceptorManager = __webpack_require__(525);
	var isAbsoluteURL = __webpack_require__(526);
	var combineURLs = __webpack_require__(527);
	var bind = __webpack_require__(528);
	var transformData = __webpack_require__(520);
	
	function Axios(defaultConfig) {
	  this.defaults = utils.merge({}, defaultConfig);
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = utils.merge({
	      url: arguments[0]
	    }, arguments[1]);
	  }
	
	  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Don't allow overriding defaults.withCredentials
	  config.withCredentials = config.withCredentials || this.defaults.withCredentials;
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	var defaultInstance = new Axios(defaults);
	var axios = module.exports = bind(Axios.prototype.request, defaultInstance);
	axios.request = bind(Axios.prototype.request, defaultInstance);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Expose properties from defaultInstance
	axios.defaults = defaultInstance.defaults;
	axios.interceptors = defaultInstance.interceptors;
	
	// Factory for creating new instances
	axios.create = function create(defaultConfig) {
	  return new Axios(defaultConfig);
	};
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(529);
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	  axios[method] = bind(Axios.prototype[method], defaultInstance);
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	  axios[method] = bind(Axios.prototype[method], defaultInstance);
	});


/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(513);
	var normalizeHeaderName = __webpack_require__(514);
	
	var PROTECTION_PREFIX = /^\)\]\}',?\n/;
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	module.exports = {
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      data = data.replace(PROTECTION_PREFIX, '');
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  headers: {
	    common: {
	      'Accept': 'application/json, text/plain, */*'
	    },
	    patch: utils.merge(DEFAULT_CONTENT_TYPE),
	    post: utils.merge(DEFAULT_CONTENT_TYPE),
	    put: utils.merge(DEFAULT_CONTENT_TYPE)
	  },
	
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};


/***/ },
/* 513 */
/***/ function(module, exports) {

	'use strict';
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  typeof document.createElement -> undefined
	 */
	function isStandardBrowserEnv() {
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined' &&
	    typeof document.createElement === 'function'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object' && !isArray(obj)) {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (obj.hasOwnProperty(key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  trim: trim
	};


/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(513);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	/**
	 * Dispatch a request to the server using whichever adapter
	 * is supported by the current environment.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  return new Promise(function executor(resolve, reject) {
	    try {
	      var adapter;
	
	      if (typeof config.adapter === 'function') {
	        // For custom adapter support
	        adapter = config.adapter;
	      } else if (typeof XMLHttpRequest !== 'undefined') {
	        // For browsers use XHR adapter
	        adapter = __webpack_require__(517);
	      } else if (typeof process !== 'undefined') {
	        // For node use HTTP adapter
	        adapter = __webpack_require__(517);
	      }
	
	      if (typeof adapter === 'function') {
	        adapter(resolve, reject, config);
	      }
	    } catch (e) {
	      reject(e);
	    }
	  });
	};
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(516)))

/***/ },
/* 516 */,
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(513);
	var buildURL = __webpack_require__(518);
	var parseHeaders = __webpack_require__(519);
	var transformData = __webpack_require__(520);
	var isURLSameOrigin = __webpack_require__(521);
	var btoa = (typeof window !== 'undefined' && window.btoa) || __webpack_require__(522);
	var settle = __webpack_require__(523);
	
	module.exports = function xhrAdapter(resolve, reject, config) {
	  var requestData = config.data;
	  var requestHeaders = config.headers;
	
	  if (utils.isFormData(requestData)) {
	    delete requestHeaders['Content-Type']; // Let the browser set it
	  }
	
	  var request = new XMLHttpRequest();
	  var loadEvent = 'onreadystatechange';
	  var xDomain = false;
	
	  // For IE 8/9 CORS support
	  // Only supports POST and GET calls and doesn't returns the response headers.
	  // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
	  if (("production") !== 'test' && typeof window !== 'undefined' && window.XDomainRequest && !('withCredentials' in request) && !isURLSameOrigin(config.url)) {
	    request = new window.XDomainRequest();
	    loadEvent = 'onload';
	    xDomain = true;
	    request.onprogress = function handleProgress() {};
	    request.ontimeout = function handleTimeout() {};
	  }
	
	  // HTTP basic authentication
	  if (config.auth) {
	    var username = config.auth.username || '';
	    var password = config.auth.password || '';
	    requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	  }
	
	  request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	  // Set the request timeout in MS
	  request.timeout = config.timeout;
	
	  // Listen for ready state
	  request[loadEvent] = function handleLoad() {
	    if (!request || (request.readyState !== 4 && !xDomain)) {
	      return;
	    }
	
	    // The request errored out and we didn't get a response, this will be
	    // handled by onerror instead
	    if (request.status === 0) {
	      return;
	    }
	
	    // Prepare the response
	    var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	    var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	    var response = {
	      data: transformData(
	        responseData,
	        responseHeaders,
	        config.transformResponse
	      ),
	      // IE sends 1223 instead of 204 (https://github.com/mzabriskie/axios/issues/201)
	      status: request.status === 1223 ? 204 : request.status,
	      statusText: request.status === 1223 ? 'No Content' : request.statusText,
	      headers: responseHeaders,
	      config: config,
	      request: request
	    };
	
	    settle(resolve, reject, response);
	
	    // Clean up request
	    request = null;
	  };
	
	  // Handle low level network errors
	  request.onerror = function handleError() {
	    // Real errors are hidden from us by the browser
	    // onerror should only fire if it's a network error
	    reject(new Error('Network Error'));
	
	    // Clean up request
	    request = null;
	  };
	
	  // Handle timeout
	  request.ontimeout = function handleTimeout() {
	    var err = new Error('timeout of ' + config.timeout + 'ms exceeded');
	    err.timeout = config.timeout;
	    err.code = 'ECONNABORTED';
	    reject(err);
	
	    // Clean up request
	    request = null;
	  };
	
	  // Add xsrf header
	  // This is only done if running in a standard browser environment.
	  // Specifically not if we're in a web worker, or react-native.
	  if (utils.isStandardBrowserEnv()) {
	    var cookies = __webpack_require__(524);
	
	    // Add xsrf header
	    var xsrfValue = config.withCredentials || isURLSameOrigin(config.url) ?
	        cookies.read(config.xsrfCookieName) :
	        undefined;
	
	    if (xsrfValue) {
	      requestHeaders[config.xsrfHeaderName] = xsrfValue;
	    }
	  }
	
	  // Add headers to the request
	  if ('setRequestHeader' in request) {
	    utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	      if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	        // Remove Content-Type if data is undefined
	        delete requestHeaders[key];
	      } else {
	        // Otherwise add header to the request
	        request.setRequestHeader(key, val);
	      }
	    });
	  }
	
	  // Add withCredentials to request if needed
	  if (config.withCredentials) {
	    request.withCredentials = true;
	  }
	
	  // Add responseType to request if needed
	  if (config.responseType) {
	    try {
	      request.responseType = config.responseType;
	    } catch (e) {
	      if (request.responseType !== 'json') {
	        throw e;
	      }
	    }
	  }
	
	  // Handle progress if needed
	  if (config.progress) {
	    if (config.method === 'post' || config.method === 'put') {
	      request.upload.addEventListener('progress', config.progress);
	    } else if (config.method === 'get') {
	      request.addEventListener('progress', config.progress);
	    }
	  }
	
	  if (requestData === undefined) {
	    requestData = null;
	  }
	
	  // Send the request
	  request.send(requestData);
	};


/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(513);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      }
	
	      if (!utils.isArray(val)) {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(513);
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	    }
	  });
	
	  return parsed;
	};


/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(513);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(513);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	  (function standardBrowserEnv() {
	    var msie = /(msie|trident)/i.test(navigator.userAgent);
	    var urlParsingNode = document.createElement('a');
	    var originURL;
	
	    /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	    function resolveURL(url) {
	      var href = url;
	
	      if (msie) {
	        // IE needs attribute set twice to normalize properties
	        urlParsingNode.setAttribute('href', href);
	        href = urlParsingNode.href;
	      }
	
	      urlParsingNode.setAttribute('href', href);
	
	      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	      return {
	        href: urlParsingNode.href,
	        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	        host: urlParsingNode.host,
	        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	        hostname: urlParsingNode.hostname,
	        port: urlParsingNode.port,
	        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	                  urlParsingNode.pathname :
	                  '/' + urlParsingNode.pathname
	      };
	    }
	
	    originURL = resolveURL(window.location.href);
	
	    /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	    return function isURLSameOrigin(requestURL) {
	      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	      return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	    };
	  })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return function isURLSameOrigin() {
	      return true;
	    };
	  })()
	);


/***/ },
/* 522 */
/***/ function(module, exports) {

	'use strict';
	
	// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	function E() {
	  this.message = 'String contains an invalid character';
	}
	E.prototype = new Error;
	E.prototype.code = 5;
	E.prototype.name = 'InvalidCharacterError';
	
	function btoa(input) {
	  var str = String(input);
	  var output = '';
	  for (
	    // initialize result and counter
	    var block, charCode, idx = 0, map = chars;
	    // if the next str index does not exist:
	    //   change the mapping table to "="
	    //   check if d has no fractional digits
	    str.charAt(idx | 0) || (map = '=', idx % 1);
	    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
	    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
	  ) {
	    charCode = str.charCodeAt(idx += 3 / 4);
	    if (charCode > 0xFF) {
	      throw new E();
	    }
	    block = block << 8 | charCode;
	  }
	  return output;
	}
	
	module.exports = btoa;


/***/ },
/* 523 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  // Note: status is not exposed by XDomainRequest
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(response);
	  }
	};


/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(513);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	  (function standardBrowserEnv() {
	    return {
	      write: function write(name, value, expires, path, domain, secure) {
	        var cookie = [];
	        cookie.push(name + '=' + encodeURIComponent(value));
	
	        if (utils.isNumber(expires)) {
	          cookie.push('expires=' + new Date(expires).toGMTString());
	        }
	
	        if (utils.isString(path)) {
	          cookie.push('path=' + path);
	        }
	
	        if (utils.isString(domain)) {
	          cookie.push('domain=' + domain);
	        }
	
	        if (secure === true) {
	          cookie.push('secure');
	        }
	
	        document.cookie = cookie.join('; ');
	      },
	
	      read: function read(name) {
	        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	        return (match ? decodeURIComponent(match[3]) : null);
	      },
	
	      remove: function remove(name) {
	        this.write(name, '', Date.now() - 86400000);
	      }
	    };
	  })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return {
	      write: function write() {},
	      read: function read() { return null; },
	      remove: function remove() {}
	    };
	  })()
	);


/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(513);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ },
/* 526 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ },
/* 527 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '');
	};


/***/ },
/* 528 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ },
/* 529 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ },
/* 530 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var RadniNalog = function RadniNalog(DS) {
	    return DS.defineResource({
	        name: 'RadniNalog',
	        endpoint: '/radniNalozi'
	    });
	};
	
	RadniNalog.$inject = ['DS'];
	
	var PlanRada = function PlanRada(DS) {
	    return DS.defineResource({
	        name: 'PlanRada',
	        endpoint: '/planRada'
	    });
	};
	
	PlanRada.$inject = ['DS'];
	
	exports.PlanRada = PlanRada;
	exports.RadniNalog = RadniNalog;

/***/ },
/* 531 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var Ordinacija = function Ordinacija(DS) {
	    return DS.defineResource({
	        name: 'Ordinacija',
	        endpoint: '/ordinacije'
	    });
	};
	
	Ordinacija.$inject = ['DS'];
	
	exports.Ordinacija = Ordinacija;

/***/ },
/* 532 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var Tehnicar = function Tehnicar(DS) {
	    return DS.defineResource({
	        name: 'Tehnicar',
	        endpoint: '/tehnicari'
	    });
	};
	
	Tehnicar.$inject = ['DS'];
	
	exports.Tehnicar = Tehnicar;

/***/ },
/* 533 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var Valuta = function Valuta(DS) {
	    return DS.defineResource({
	        name: 'Valuta',
	        endpoint: '/valute'
	    });
	};
	
	Valuta.$inject = ['DS'];
	
	exports.Valuta = Valuta;

/***/ },
/* 534 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var PoreznaStopa = function PoreznaStopa(DS) {
	    return DS.defineResource({
	        name: 'PoreznaStopa',
	        endpoint: '/porezneStope'
	    });
	};
	
	PoreznaStopa.$inject = ['DS'];
	
	exports.PoreznaStopa = PoreznaStopa;

/***/ },
/* 535 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var ProtetskiRad = function ProtetskiRad(DS) {
	    return DS.defineResource({
	        name: 'ProtetskiRad',
	        endpoint: '/protetskiRadovi'
	    });
	};
	
	ProtetskiRad.$inject = ['DS'];
	
	exports.ProtetskiRad = ProtetskiRad;

/***/ },
/* 536 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var Cjenik = function Cjenik(DS) {
	
	    return DS.defineResource({
	        name: 'Cjenik',
	        endpoint: '/cjenici'
	    });
	};
	
	// methods: {
	//     getNazivValute: function() {
	//         let id = this.valuta;
	//         return DS.find('Valuta', id).then((item) => {
	//             return item.valuta;
	//         });
	
	//         // return DS.get('Valuta', id).valuta;
	//     }
	// },
	// relations: {
	//     belongsTo: {
	//         Valuta: {
	//             localField: 'valuta',
	//             localKey: 'valuta_id'
	//         }
	//     }
	// }
	
	Cjenik.$inject = ['DS'];
	
	exports.Cjenik = Cjenik;

/***/ },
/* 537 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var StavkaCjenika = function StavkaCjenika(DS) {
	    return DS.defineResource({
	        name: 'StavkaCjenika',
	        endpoint: '/stavkeCjenika'
	    });
	};
	
	StavkaCjenika.$inject = ['DS'];
	
	exports.StavkaCjenika = StavkaCjenika;

/***/ },
/* 538 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var Boja = function Boja(DS) {
	
	    return DS.defineResource({
	        name: 'Boja',
	        endpoint: '/boje'
	    });
	};
	
	Boja.$inject = ['DS'];
	
	exports.Boja = Boja;

/***/ },
/* 539 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var OznakaBoje = function OznakaBoje(DS) {
	
	    return DS.defineResource({
	        name: 'OznakaBoje',
	        endpoint: '/oznakeBoja'
	    });
	};
	
	OznakaBoje.$inject = ['DS'];
	
	exports.OznakaBoje = OznakaBoje;

/***/ },
/* 540 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var FazaNaloga = function FazaNaloga(DS) {
	    return DS.defineResource({
	        name: 'FazaNaloga',
	        endpoint: '/fazeNaloga'
	    });
	};
	
	FazaNaloga.$inject = ['DS'];
	
	exports.FazaNaloga = FazaNaloga;

/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _lodash = __webpack_require__(165);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var StavkaNaloga = function StavkaNaloga(DS) {
	    return DS.defineResource({
	        name: 'StavkaNaloga',
	        endpoint: '/stavkeNaloga',
	        methods: {
	            group: function group(stavke) {
	                var groupedStavke = [];
	                stavke.map(function (stavka) {
	                    var item = _lodash2['default'].find(groupedStavke, { protetski_rad: stavka.protetski_rad, cjenik: stavka.cjenik });
	                    if (_lodash2['default'].isUndefined(item)) {
	                        item = {
	                            protetski_rad: stavka.protetski_rad,
	                            cjenik: stavka.cjenik,
	                            pozicije: [stavka.pozicija]
	                        };
	                        groupedStavke.push(item);
	                        return;
	                    }
	                    item.pozicije.push(stavka.pozicija);
	                });
	                return groupedStavke;
	            }
	        }
	    });
	};
	
	StavkaNaloga.$inject = ['DS'];
	
	exports.StavkaNaloga = StavkaNaloga;

/***/ },
/* 542 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var KorisnikOrdinacija = function KorisnikOrdinacija(DS) {
	    return DS.defineResource({
	        name: 'KorisnikOrdinacija',
	        endpoint: '/korisnikOrdinacija'
	    });
	};
	
	KorisnikOrdinacija.$inject = ['DS'];
	
	exports.KorisnikOrdinacija = KorisnikOrdinacija;

/***/ },
/* 543 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var Materijal = function Materijal(DS) {
	    return DS.defineResource({
	        name: 'Materijal',
	        endpoint: '/materijali'
	    });
	};
	
	Materijal.$inject = ['DS'];
	
	exports.Materijal = Materijal;

/***/ },
/* 544 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var GrupaRada = function GrupaRada(DS) {
	    return DS.defineResource({
	        name: 'GrupaRada',
	        endpoint: '/grupeRadova'
	    });
	};
	
	GrupaRada.$inject = ['DS'];
	
	exports.GrupaRada = GrupaRada;

/***/ },
/* 545 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var VrstaRada = function VrstaRada(DS) {
	    return DS.defineResource({
	        name: 'VrstaRada',
	        endpoint: '/vrsteRadova'
	    });
	};
	
	VrstaRada.$inject = ['DS'];
	
	exports.VrstaRada = VrstaRada;

/***/ },
/* 546 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var DokumentNaloga = function DokumentNaloga(DS) {
	    return DS.defineResource({
	        name: 'DokumentNaloga',
	        endpoint: '/dokumentNaloga'
	    });
	};
	
	DokumentNaloga.$inject = ['DS'];
	
	exports.DokumentNaloga = DokumentNaloga;

/***/ },
/* 547 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	var Token = function Token(DS) {
	    return DS.defineResource({
	        name: 'Token',
	        endpoint: '/token'
	    });
	};
	
	Token.$inject = ['DS'];
	
	exports.Token = Token;

/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _moment = __webpack_require__(216);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var config = function config($stateProvider, $urlRouterProvider, AppConfigurationProvider) {
	    var acp = AppConfigurationProvider;
	
	    _moment2['default'].locale('hr');
	
	    $urlRouterProvider.otherwise('/dashboard');
	
	    var app = acp.application('DentalLab');
	
	    app.addEntity(acp.entity('dashboard'));
	    app.addEntity(acp.entity('Tehnicar').label('Tehničar'));
	    app.addEntity(acp.entity('Valuta').label('Valuta'));
	    app.addEntity(acp.entity('PoreznaStopa').label('Porezna stopa'));
	    app.addEntity(acp.entity('ProtetskiRad').label('Protetski rad'));
	    app.addEntity(acp.entity('Cjenik').label('Cjenik'));
	    app.addEntity(acp.entity('StavkaCjenika').label('Stavka cjenika'));
	    app.addEntity(acp.entity('Ordinacija').label('Ordinacija'));
	    app.addEntity(acp.entity('RadniNalog').label('Radni nalog'));
	    app.addEntity(acp.entity('StavkaNaloga').label('Stavka naloga'));
	    app.addEntity(acp.entity('Boja').label('Boja'));
	    app.addEntity(acp.entity('OznakaBoje').label('Oznaka boje'));
	    app.addEntity(acp.entity('FazaNaloga').label('Faza naloga'));
	    app.addEntity(acp.entity('KorisnikOrdinacija').label('Korisnici'));
	    app.addEntity(acp.entity('Materijal').label('Materijal'));
	    app.addEntity(acp.entity('VrstaRada').label('Vrsta rada'));
	    app.addEntity(acp.entity('GrupaRada').label('Grupa rada'));
	    app.addEntity(acp.entity('Komentar').label('Komentar'));
	
	    acp.configure(app);
	
	    __webpack_require__(549)(acp, app);
	    __webpack_require__(550)(acp, app);
	    __webpack_require__(551)(acp, app);
	    __webpack_require__(552)(acp, app);
	    __webpack_require__(553)(acp, app);
	    __webpack_require__(554)(acp, app);
	    __webpack_require__(555)(acp, app);
	    __webpack_require__(556)(acp, app);
	    __webpack_require__(557)(acp, app);
	    __webpack_require__(558)(acp, app);
	    __webpack_require__(559)(acp, app);
	    __webpack_require__(560)(acp, app);
	    __webpack_require__(561)(acp, app);
	    __webpack_require__(562)(acp, app);
	    __webpack_require__(563)(acp, app);
	    __webpack_require__(564)(acp, app);
	    __webpack_require__(565)(acp, app);
	
	    __webpack_require__(566)($stateProvider);
	    __webpack_require__(567)($stateProvider);
	    __webpack_require__(568)($stateProvider);
	    __webpack_require__(569)($stateProvider);
	    __webpack_require__(570)($stateProvider);
	    __webpack_require__(571)($stateProvider);
	};
	
	var run = function run($rootScope, $state, djangoAuth, AppConfiguration, $transitions) {
	    djangoAuth.initialize('/rest-auth', true);
	
	    var match = {
	        to: function to(state) {
	            // return state.data != null && state.data.authRequired === true;
	            return state.name !== 'login';
	        }
	    };
	
	    $transitions.onStart(match, function (trans) {
	        djangoAuth.authenticationStatus(true).then(function () {
	            return djangoAuth.profile();
	        }).then(function (response) {
	            $rootScope.user = response;
	        })['catch'](function () {
	            return $state.go('login');
	        });
	        return true;
	    });
	
	    // $rootScope.$state = $state;
	
	    var app = AppConfiguration();
	    app.menu(__webpack_require__(572)(AppConfiguration, $state));
	};
	
	run.$inject = ['$rootScope', '$state', 'djangoAuth', 'AppConfiguration', '$transitions'];
	config.$inject = ['$stateProvider', '$urlRouterProvider', 'AppConfigurationProvider'];
	
	exports.config = config;
	exports.run = run;

/***/ },
/* 549 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	exports['default'] = function (ac, app) {
	    var dashboard = app.getEntity('dashboard');
	    dashboard.listView().fields([ac.field('sifra_naloga').label('Šifra naloga'), ac.field('pacijent'), ac.field('ordinacija', 'reference').targetEntity(app.getEntity('Ordinacija')).targetField(ac.field('naziv'))]).listActions(['edit']);
	
	    return dashboard;
	};
	
	module.exports = exports['default'];

/***/ },
/* 550 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	exports['default'] = function (ac, app) {
	    var tehnicar = app.getEntity('Tehnicar');
	    tehnicar.listView().title('Tehničari').icon('<i class="fa fa-users fa-3x"></i>').fields([ac.field('naziv', 'template').label('Naziv').template(function (entry) {
	        return entry.prezime + ' ' + entry.ime;
	    }).cssClasses(['col-md-11'])]).listActions(['edit', 'delete']);
	
	    tehnicar.editionView().title('Tehničar').fields([{
	        key: 'prezime',
	        type: 'hInput',
	        templateOptions: {
	            label: 'Prezime',
	            required: true,
	            focus: true
	        }
	    }, {
	        key: 'ime',
	        type: 'hInput',
	        templateOptions: {
	            label: 'Ime',
	            required: true
	        }
	    }]);
	
	    return tehnicar;
	};
	
	module.exports = exports['default'];

/***/ },
/* 551 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	exports['default'] = function (ac, app) {
	    var valuta = app.getEntity('Valuta');
	
	    valuta.listView().title('Valute').icon('<i class="fa fa-eur fa-3x"></i>').fields([ac.field('valuta').cssClasses(['col-md-6']), ac.field('sifra').label('Šifra').cssClasses(['col-md-5'])]).listActions(['edit', 'delete']);
	
	    valuta.editionView().title('Valuta').fields([{
	        key: 'valuta',
	        type: 'hInput',
	        templateOptions: {
	            label: 'Valuta',
	            required: true,
	            focus: true
	        }
	    }, {
	        key: 'sifra',
	        type: 'hInput',
	        templateOptions: {
	            label: 'Šifra',
	            required: true
	        }
	    }]);
	
	    return valuta;
	};
	
	module.exports = exports['default'];

/***/ },
/* 552 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	exports['default'] = function (ac, app) {
	    var poreznaStopa = app.getEntity('PoreznaStopa');
	
	    poreznaStopa.listView().title('Porezne stope').icon('<i class="fa fa-bar-chart fa-3x"></i>').fields([ac.field('naziv').label('Naziv stope').cssClasses(['col-md-3']), ac.field('stopa').cssClasses(['col-md-2']), ac.field('vazi_od', 'date').label('Važi od').cssClasses(['col-md-3']), ac.field('vazi_do', 'date').label('Važi do').cssClasses(['col-md-3'])]).listActions(['edit', 'delete']);
	
	    poreznaStopa.editionView().title('Porezna stopa').fields([{
	        key: 'naziv',
	        type: 'hInput',
	        templateOptions: {
	            label: 'Naziv stope',
	            required: true,
	            focus: true
	        }
	    }, {
	        key: 'stopa',
	        type: 'hInput',
	        templateOptions: {
	            label: 'Stopa(%)',
	            required: true
	        }
	    }, {
	        key: 'vazi_od',
	        type: 'hDatepicker',
	        templateOptions: {
	            label: 'Važi od',
	            required: true
	        }
	    }, {
	        key: 'vazi_do',
	        type: 'hDatepicker',
	        templateOptions: {
	            label: 'Važi do'
	        }
	    }]);
	
	    return poreznaStopa;
	};
	
	module.exports = exports['default'];

/***/ },
/* 553 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	exports['default'] = function (ac, app) {
	    var protetskiRad = app.getEntity('ProtetskiRad');
	
	    protetskiRad.listView().title('Protetski radovi').icon('<i class="fa fa-archive fa-3x"></i>').fields([ac.field('naziv').cssClasses(['col-md-4']),
	    // ac.field('tip')
	    //     .cssClasses(['col-md-2']),
	    ac.field('materijal', 'reference').label('Materijal').targetEntity(app.getEntity('Materijal')).targetField(ac.field('naziv')).cssClasses(['col-md-2']), ac.field('vrsta_rada', 'reference').label('Vrsta rada').targetEntity(app.getEntity('VrstaRada')).targetField(ac.field('naziv')).cssClasses(['col-md-2'])]).listActions(['edit', 'delete']);
	
	    protetskiRad.editionView().title('Protetski rad').fields([{
	        key: 'naziv',
	        type: 'hInput',
	        templateOptions: {
	            label: 'Naziv',
	            required: true,
	            focus: true
	        }
	    },
	    // {
	    //     key: "tip",
	    //     type: "hSelect",
	    //     templateOptions: {
	    //         label: "Tip rada",
	    //         options: [
	    //             {
	    //                 name: "Fiksna",
	    //                 value: "F"
	    //             },
	    //             {
	    //                 name: "Mobilna",
	    //                 value: "M"
	    //             }
	    //         ]
	    //     }
	    // },
	
	    {
	        key: 'materijal',
	        type: 'huiSelect',
	        templateOptions: {
	            label: 'Materijal',
	            optionsAttr: 'bs-options',
	            ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
	            valueProp: 'id',
	            labelProp: 'naziv',
	            placeholder: 'Odaberite materijal',
	            options: []
	        },
	        controller: ['$scope', 'DS', function ($scope, DS) {
	            DS.findAll('Materijal').then(function (response) {
	                $scope.to.options = response;
	            });
	        }]
	    }, {
	        key: 'vrsta_rada',
	        type: 'huiSelect',
	        templateOptions: {
	            label: 'Vrsta rada',
	            optionsAttr: 'bs-options',
	            ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
	            valueProp: 'id',
	            labelProp: 'naziv',
	            placeholder: 'Odaberite vrstu rada',
	            options: []
	        },
	        controller: ['$scope', 'DS', function ($scope, DS) {
	            DS.findAll('VrstaRada').then(function (response) {
	                $scope.to.options = response;
	            });
	        }]
	    }]);
	
	    return protetskiRad;
	};
	
	module.exports = exports['default'];

/***/ },
/* 554 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	exports['default'] = function (ac, app) {
	    var cjenik = app.getEntity('Cjenik');
	
	    cjenik.listView().title('Cjenici').icon('<i class="fa fa-money fa-3x"></i>');
	
	    cjenik.editionView().title('Cjenik').fields([{
	        key: 'naziv',
	        type: 'hInput',
	        templateOptions: {
	            label: 'Naziv cjenika',
	            required: true,
	            focus: true
	        }
	    }, {
	        key: 'valuta',
	        type: 'huiSelect',
	        templateOptions: {
	            label: 'Valuta',
	            optionsAttr: 'bs-options',
	            ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
	            valueProp: 'id',
	            labelProp: 'valuta',
	            placeholder: 'Odaberite valutu',
	            options: []
	        },
	        controller: ['$scope', 'DS', function ($scope, DS) {
	            $scope.to.options = DS.getAll('Valuta');
	            DS.findAll('Valuta').then(function (response) {
	                $scope.to.options = response;
	            });
	        }]
	    }]);
	
	    var stavkaCjenika = app.getEntity('StavkaCjenika');
	
	    stavkaCjenika.listView().title(function (entry) {
	        return 'Cjenik ' + entry.naziv;
	    }).description('Registar cjenika').icon('<i class="fa fa-archive fa-3x"></i>').fields([ac.field('protetski_rad', 'reference').label('Naziv protetskog rada / usluge ').targetEntity(app.getEntity('ProtetskiRad')).targetField(ac.field('naziv')), ac.field('porezna_stopa', 'reference').label('Porezna tarifa').targetEntity(app.getEntity('PoreznaStopa')).targetField(ac.field('naziv', 'template').template(function (entry) {
	        return '' + entry.naziv;
	    })), ac.field('iznos')]).listActions(['edit', 'delete']);
	
	    stavkaCjenika.creationView().title('Unos nove stavke cjenika').fields([{
	        key: 'protetski_rad',
	        type: 'huiSelect',
	        templateOptions: {
	            label: 'Protetski rad',
	            optionsAttr: 'bs-options',
	            ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
	            valueProp: 'id',
	            labelProp: 'naziv',
	            placeholder: 'Odaberite uslugu',
	            options: [],
	            required: true
	        },
	        controller: ['$scope', 'DS', function ($scope, DS) {
	            DS.findAll('ProtetskiRad').then(function (response) {
	                $scope.to.options = response;
	            });
	        }]
	    }, {
	        key: 'porezna_stopa',
	        type: 'huiSelect',
	        templateOptions: {
	            label: 'Porezna stopa',
	            optionsAttr: 'bs-options',
	            ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
	            valueProp: 'id',
	            labelProp: 'naziv',
	            placeholder: 'Odaberite stopu',
	            options: [],
	            required: true
	        },
	        controller: ['$scope', 'DS', function ($scope, DS) {
	            DS.findAll('PoreznaStopa').then(function (response) {
	                $scope.to.options = response;
	            });
	        }]
	    }, {
	        key: 'iznos',
	        type: 'hInput',
	        templateOptions: {
	            label: 'Iznos'
	        }
	    }]);
	
	    return cjenik;
	};
	
	module.exports = exports['default'];

/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _commonFormsLayoutJs = __webpack_require__(434);
	
	var _commonConfigurationViewListViewJs = __webpack_require__(335);
	
	var _commonConfigurationViewListViewJs2 = _interopRequireDefault(_commonConfigurationViewListViewJs);
	
	var fields = {
	    naziv: {
	        key: 'naziv',
	        type: 'input',
	        templateOptions: {
	            label: 'Naziv',
	            required: true,
	            focus: true
	        }
	    },
	    oib: {
	        key: 'oib',
	        type: 'input',
	        templateOptions: {
	            label: 'OIB'
	        }
	    },
	    radno_vrijeme: {
	        key: 'radno_vrijeme',
	        type: 'input',
	        templateOptions: {
	            label: 'Radno vrijeme'
	        }
	    },
	    napomena: {
	        key: 'napomena',
	        type: 'textarea',
	        templateOptions: {
	            label: 'Napomena'
	        }
	    },
	    adresa: {
	        key: 'adresa',
	        type: 'input',
	        templateOptions: {
	            label: 'Adresa'
	        }
	    },
	    postanski_broj: {
	        key: 'postanski_broj',
	        type: 'input',
	        templateOptions: {
	            label: 'Poštanski broj'
	        }
	    },
	    mjesto: {
	        key: 'mjesto',
	        type: 'input',
	        templateOptions: {
	            label: 'Mjesto'
	        }
	    },
	    telefon: {
	        key: 'telefon',
	        type: 'input',
	        templateOptions: {
	            label: 'Telefon'
	        }
	    },
	    email: {
	        key: 'email',
	        type: 'input',
	        templateOptions: {
	            label: 'E-mail'
	        }
	    }
	};
	
	exports['default'] = function (ac, app) {
	    var ordinacija = app.getEntity('Ordinacija');
	    var nalozi = app.getEntity('RadniNalog');
	    var view = new _commonConfigurationViewListViewJs2['default']();
	    view.setEntity(nalozi);
	    view.fields([ac.field('datum_naloga', 'date').label('Datum naloga').cssClasses(['col-lg-3']), ac.field('pacijent', 'template').cssClasses(['col-lg-4']).template(function (entry) {
	        return entry.pacijent + '<br><small><i class="fa fa-clock-o"></i> Status: <strong>' + entry.status + '</strong></small>';
	    }), ac.field('broj_naloga', 'template').label('Broj naloga').cssClasses(['col-lg-2', 'text-right']).template(function (entry) {
	        return '<a ui-sref="radniNalog.details({id: entry.id})" class="btn btn-xs btn-success " type="button"><i class="fa fa-search"></i> {{entry.sifra_naloga}}</a>';
	    })]);
	
	    nalozi.views['OrdinacijaViews'] = view;
	
	    // poreznaStopa.listView()
	    //     .title('Porezne stope')
	    //     .icon('<i class="fa fa-bar-chart fa-3x"></i>')
	    //     .fields([
	    //         ac.field('naziv')
	    //             .label('Naziv stope')
	    //             .cssClasses(['col-md-3']),
	    //         ac.field('stopa')
	    //             .cssClasses(['col-md-2']),
	    //         ac.field('vazi_od', 'date')
	    //             .label('Važi od')
	    //             .cssClasses(['col-md-3']),
	    //         ac.field('vazi_do', 'date')
	    //             .label('Važi do')
	    //             .cssClasses(['col-md-3']),
	    //     ])
	    //     .listActions([
	    //         'edit',
	    //         'delete'
	    //     ]);
	
	    ordinacija.creationView().title('Ordinacije').fields([[(0, _commonFormsLayoutJs.Row)([(0, _commonFormsLayoutJs.Column9)([fields.naziv])]), (0, _commonFormsLayoutJs.Row)([(0, _commonFormsLayoutJs.Column3)([fields.oib]), (0, _commonFormsLayoutJs.Column9)([fields.radno_vrijeme])]), (0, _commonFormsLayoutJs.Row)([(0, _commonFormsLayoutJs.Column12)([fields.napomena])])], [(0, _commonFormsLayoutJs.Row)([(0, _commonFormsLayoutJs.Column6)([fields.adresa]), (0, _commonFormsLayoutJs.Column3)([fields.postanski_broj]), (0, _commonFormsLayoutJs.Column3)([fields.mjesto])]), (0, _commonFormsLayoutJs.Row)([(0, _commonFormsLayoutJs.Column4)([fields.telefon]), (0, _commonFormsLayoutJs.Column8)([fields.email])]), { template: '<hr/>' }]]);
	
	    return ordinacija;
	};
	
	module.exports = exports['default'];

/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _commonFormsLayoutJs = __webpack_require__(434);
	
	var fields = {
	    ordinacija: {
	        key: 'ordinacija',
	        type: 'uiSelect',
	        templateOptions: {
	            label: 'Ordinacija',
	            optionsAttr: 'bs-options',
	            ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
	            valueProp: 'id',
	            labelProp: 'naziv',
	            placeholder: 'Odaberite ordinaciju',
	            options: [],
	            required: true
	        },
	        controller: ['$scope', 'DS', function ($scope, DS) {
	            DS.findAll('Ordinacija').then(function (response) {
	                $scope.to.options = response;
	            });
	        }]
	    },
	    datum_naloga: {
	        key: 'datum_naloga',
	        type: 'datepicker',
	        templateOptions: {
	            label: 'Datum naloga'
	        }
	    },
	    pacijent: {
	        key: 'pacijent',
	        type: 'input',
	        templateOptions: {
	            required: true,
	            label: 'Pacijent',
	            focus: true
	        }
	    },
	    spol: {
	        key: 'spol',
	        type: 'uiSelect',
	        templateOptions: {
	            required: true,
	            label: 'Spol',
	            optionsAttr: 'bs-options',
	            ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
	            valueProp: 'id',
	            labelProp: 'naziv',
	            placeholder: 'Odaberite spol',
	            options: [{ id: 'M', naziv: 'M' }, { id: 'Ž', naziv: 'Ž' }]
	        }
	    },
	    godina_rodjenja: {
	        key: 'godina_rodjenja',
	        type: 'input',
	        templateOptions: {
	            label: 'Godina rođenja',
	            type: 'number'
	        }
	    },
	    napomena: {
	        key: 'napomena',
	        type: 'textarea',
	        templateOptions: {
	            label: 'Napomena',
	            rows: 4
	        }
	    },
	    boja: {
	        key: 'boja',
	        type: 'uiSelect',
	        templateOptions: {
	            label: 'Boja',
	            required: true,
	            optionsAttr: 'bs-options',
	            ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
	            valueProp: 'naziv',
	            labelProp: 'naziv',
	            // placeholder: 'Odaberite boju',
	            options: []
	        },
	        controller: ['$scope', 'DS', function ($scope, DS) {
	            DS.findAll('Boja').then(function (response) {
	                $scope.to.options = response;
	            });
	        }]
	    },
	    oznaka_boje: {
	        key: 'oznaka_boje',
	        type: 'uiSelect',
	        templateOptions: {
	            label: 'Oznaka',
	            required: true,
	            optionsAttr: 'bs-options',
	            ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
	            valueProp: 'oznaka',
	            labelProp: 'oznaka',
	            // placeholder: 'Odaberite oznaku',
	            options: []
	        },
	        controller: ['$scope', 'DS', function ($scope, DS) {
	            DS.findAll('OznakaBoje').then(function (response) {
	                $scope.to.options = response;
	            });
	        }]
	    },
	    oblik: {
	        key: 'oblik',
	        type: 'uiSelect',
	        templateOptions: {
	            label: 'Oblik',
	            required: true,
	            optionsAttr: 'bs-options',
	            valueProp: 'naziv',
	            labelProp: 'naziv',
	            // placeholder: 'Odaberite oznaku',
	            options: [{ id: '-', naziv: '-' }, { id: 'Pravokutni', naziv: 'Pravokutni' }, { id: 'Trokutasti', naziv: 'Trokutasti' }, { id: 'Ovalni', naziv: 'Ovalni' }, { id: 'Kockasti', naziv: 'Kockasti' }]
	        }
	    }
	};
	
	exports['default'] = function (ac, app) {
	    var radniNalog = app.getEntity('RadniNalog');
	    radniNalog.listView().title('Pregled radnih naloga').description('Evidencija zaprimljenih radnih naloga').icon('<i class="fa fa-file-text-o fa-3x"></i>').fields([ac.field('sifra_naloga', 'template').label('Šifra naloga').template(function (entry) {
	        return '' + entry.sifra_naloga;
	    }), ac.field('pacijent').cssClasses(function (entry) {
	        return '';
	    }), ac.field('ordinacija', 'reference').targetEntity(app.getEntity('Ordinacija')).targetField(ac.field('naziv'))]).listActions(['edit']);
	
	    radniNalog.creationView().fields([[(0, _commonFormsLayoutJs.Row)([(0, _commonFormsLayoutJs.Column4)([fields.datum_naloga])]), (0, _commonFormsLayoutJs.Row)([(0, _commonFormsLayoutJs.Column4)([fields.pacijent]), (0, _commonFormsLayoutJs.Column4)([fields.ordinacija])]), (0, _commonFormsLayoutJs.Row)([(0, _commonFormsLayoutJs.Column4)([fields.spol]), (0, _commonFormsLayoutJs.Column4)([fields.godina_rodjenja])])], [(0, _commonFormsLayoutJs.Row)([(0, _commonFormsLayoutJs.Column12)([fields.boja]), (0, _commonFormsLayoutJs.Column12)([fields.oznaka_boje]), (0, _commonFormsLayoutJs.Column12)([fields.oblik])])], [(0, _commonFormsLayoutJs.Row)([(0, _commonFormsLayoutJs.Column12)([fields.napomena])])]]);
	
	    radniNalog.editionView().fields([(0, _commonFormsLayoutJs.Row)([(0, _commonFormsLayoutJs.Column4)([fields.datum_naloga])]), (0, _commonFormsLayoutJs.Row)([(0, _commonFormsLayoutJs.Column4)([fields.pacijent]), (0, _commonFormsLayoutJs.Column4)([fields.ordinacija])]), (0, _commonFormsLayoutJs.Row)([(0, _commonFormsLayoutJs.Column4)([fields.spol]), (0, _commonFormsLayoutJs.Column4)([fields.godina_rodjenja])]), (0, _commonFormsLayoutJs.Row)([(0, _commonFormsLayoutJs.Column3)([fields.boja]), (0, _commonFormsLayoutJs.Column3)([fields.oznaka_boje]), (0, _commonFormsLayoutJs.Column3)([fields.oblik])]), (0, _commonFormsLayoutJs.Row)([(0, _commonFormsLayoutJs.Column12)([fields.napomena])])]);
	
	    return radniNalog;
	};
	
	module.exports = exports['default'];

/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	var _lodash = __webpack_require__(165);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _commonFormsLayoutJs = __webpack_require__(434);
	
	var fields = {
	    // vrsta_rada: {
	    //     key: 'vrsta_rada',
	    //     type: 'uiSelect',
	    //     templateOptions: {
	    //         label: 'Vrsta rada',
	    //         optionsAttr: 'bs-options',
	    //         ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
	    //         valueProp: 'id',
	    //         labelProp: 'naziv',
	    //         placeholder: 'Odaberite vrstu rada',
	    //         options: [
	    //             {id: 'M', naziv: 'MOBILNA'},
	    //             {id: 'F', naziv: 'FIKSNA'}
	    //         ]
	    //     }
	    // },
	
	    materijal: {
	        key: 'materijal',
	        type: 'huiSelect',
	        templateOptions: {
	            label: 'Materijal',
	            optionsAttr: 'bs-options',
	            ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
	            valueProp: 'id',
	            labelProp: 'naziv',
	            placeholder: 'Odaberite materijal',
	            options: []
	        },
	        controller: ['$scope', 'DS', function ($scope, DS) {
	            DS.findAll('Materijal').then(function (response) {
	                $scope.to.options = response;
	            });
	        }]
	    },
	
	    vrsta_rada: {
	        key: 'vrsta_rada',
	        type: 'huiSelect',
	        templateOptions: {
	            label: 'Vrsta rada',
	            optionsAttr: 'bs-options',
	            ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
	            valueProp: 'id',
	            labelProp: 'naziv',
	            placeholder: 'Odaberite vrstu rada',
	            options: [],
	            required: true
	        },
	        controller: ['$scope', 'DS', function ($scope, DS) {
	            DS.findAll('VrstaRada').then(function (response) {
	                $scope.to.options = response;
	            });
	        }]
	    },
	    // protetski_rad: {
	    //     key: 'protetski_rad',
	    //     type: 'huiSelect',
	    //     templateOptions: {
	    //         label: 'Protetski rad',
	    //         optionsAttr: 'bs-options',
	    //         ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
	    //         valueProp: 'id',
	    //         labelProp: 'naziv',
	    //         placeholder: 'Odaberite uslugu',
	    //         options: [],
	    //         required: true
	    //     },
	    //     controller: ['$scope', 'DS', function ($scope, DS) {
	    //         $scope.$watch('model.vrsta_rada', function (newValue, oldValue) {
	    //             if(newValue !== oldValue) {
	    //                 if($scope.model[$scope.options.key] && oldValue) {
	    //                     $scope.model[$scope.options.key] = '';
	    //                 }
	    //             }
	    //             DS.findAll('ProtetskiRad').then(function (response) {
	    //                 $scope.to.options = response.filter((i) => i.tip === newValue);
	    //             });
	    //         });
	    //     }]
	    // },
	    protetski_rad: {
	        key: 'protetski_rad',
	        type: 'huiSelect',
	        templateOptions: {
	            label: 'Protetski rad',
	            optionsAttr: 'bs-options',
	            ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
	            valueProp: 'id',
	            labelProp: 'naziv',
	            placeholder: 'Odaberite uslugu',
	            options: [],
	            required: true
	        },
	        controller: ['$scope', 'DS', function ($scope, DS) {
	            // DS.findAll('ProtetskiRad').then(function (response) {
	            //     $scope.to.options = response;
	            // });
	
	            var radovi = undefined;
	
	            function setProtetskiRad() {
	                var vrsta_rada = $scope.model.vrsta_rada;
	                var materijal = $scope.model.materijal;
	                var opcije = [].concat(_toConsumableArray(radovi));
	
	                $scope.model[$scope.options.key] = null;
	
	                if (_lodash2['default'].isFinite(parseInt(vrsta_rada))) {
	                    opcije = opcije.filter(function (o) {
	                        return o.vrsta_rada === vrsta_rada;
	                    });
	                }
	
	                if (_lodash2['default'].isFinite(parseInt(materijal))) {
	                    opcije = opcije.filter(function (o) {
	                        return o.materijal === materijal;
	                    });
	                }
	
	                $scope.to.options = [].concat(_toConsumableArray(opcije));
	
	                if (opcije.length === 1) {
	                    $scope.model[$scope.options.key] = opcije[0].id;
	                }
	            }
	
	            DS.findAll('StavkaCjenika').then(function (stavke) {
	                if (stavke && stavke.length > 0) {
	                    DS.findAll('ProtetskiRad').then(function (protetskiRadovi) {
	                        $scope.to.options = protetskiRadovi.filter(function (i) {
	                            return _lodash2['default'].find(stavke, { protetski_rad: i.id });
	                        });
	                        radovi = [].concat(_toConsumableArray($scope.to.options));
	                    });
	                }
	            });
	
	            $scope.$watch('model.vrsta_rada', function (newValue, oldValue) {
	                if (newValue !== oldValue) {
	                    $scope.model.materijal = null;
	                    setProtetskiRad();
	                }
	            });
	
	            $scope.$watch('model.materijal', function (newValue, oldValue) {
	                if (newValue !== oldValue) {
	                    setProtetskiRad();
	                }
	            });
	        }]
	    },
	    kolicina: {
	        key: 'kolicina',
	        type: 'input',
	        templateOptions: {
	            label: 'Komada',
	            required: true
	        }
	    },
	    napomena: {
	        key: 'napomena',
	        type: 'textarea',
	        templateOptions: {
	            label: 'Napomena',
	            rows: 4
	        }
	    },
	    cjenik: {
	        key: 'cjenik',
	        type: 'huiSelect',
	        templateOptions: {
	            label: 'Cjenik',
	            optionsAttr: 'bs-options',
	            ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
	            valueProp: 'id',
	            labelProp: 'naziv',
	            placeholder: 'Odaberite cjenik',
	            options: [],
	            required: true
	        },
	        controller: ['$scope', 'DS', function ($scope, DS) {
	
	            var cjenici = undefined,
	                stavkeCjenika = undefined;
	
	            function setCjenik() {
	                var protetski_rad = parseInt($scope.model.protetski_rad);
	
	                $scope.model[$scope.options.key] = null;
	
	                if (_lodash2['default'].isFinite(protetski_rad)) {
	                    (function () {
	                        var stavke = stavkeCjenika.filter(function (s) {
	                            return s.protetski_rad === protetski_rad;
	                        });
	                        $scope.to.options = cjenici.filter(function (c) {
	                            return _lodash2['default'].find(stavke, { cjenik: c.id });
	                        });
	
	                        if ($scope.to.options.length === 1) {
	                            $scope.model[$scope.options.key] = $scope.to.options[0].id;
	                        }
	                    })();
	                }
	            }
	
	            DS.findAll('StavkaCjenika').then(function (stavke) {
	                stavkeCjenika = [].concat(_toConsumableArray(stavke));
	                DS.findAll('Cjenik').then(function (sviCjenici) {
	                    cjenici = sviCjenici.filter(function (c) {
	                        return _lodash2['default'].find(stavke, { cjenik: c.id });
	                    });
	                    $scope.to.options = [].concat(_toConsumableArray(cjenici));
	                });
	            });
	
	            $scope.$watch('model.protetski_rad', function (newValue, oldValue) {
	                if (newValue !== oldValue) {
	                    setCjenik();
	                }
	            });
	        }]
	    }
	};
	
	exports['default'] = function (ac, app) {
	    var stavkaNaloga = app.getEntity('StavkaNaloga');
	
	    stavkaNaloga.listView().fields([ac.field('protetski_rad', 'reference').targetEntity(app.getEntity('ProtetskiRad')).targetField(ac.field('naziv')).hidden(true), ac.field('pozicije', 'template').label('Protetski rad<br/><small>Pozicija</small>').template(function (entry) {
	        return '<protetski-pozicije></protetski-pozicije>';
	    }), ac.field('cjenik', 'reference').label('Tip rada').targetEntity(app.getEntity('Cjenik')).targetField(ac.field('naziv')), ac.field('kolicina', 'template').label('Količina').template(function (entry) {
	        return entry.pozicije.length;
	    })])
	    // .references(app.getEntity('ProtetskiRad'))
	    .
	    // ac.field('napomena', 'template')
	    //     .label('Napomena')
	    //     .template((entry) => {
	    //         return `<small>${entry.napomena}</small>`;
	    //     })
	    //     .cssClasses(['col-md-4']),
	    listActions(['delete']);;
	
	    // stavkaNaloga.creationView()
	    //     .title('Odaberite pozicije za rad')
	    //     .fields([
	    //         Row([Column4([fields.cjenik]), Column4([fields.vrsta_rada])]),
	    //         Row([Column8([fields.protetski_rad]), Column3([fields.kolicina])]),
	    //         Row([Column12([fields.napomena])])
	    //     ]);
	
	    stavkaNaloga.creationView().title('Odaberite pozicije za rad').fields([
	    // fields.vrsta_rada,
	    // fields.materijal,
	    fields.protetski_rad, fields.cjenik]);
	
	    return stavkaNaloga;
	};
	
	module.exports = exports['default'];

/***/ },
/* 558 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	exports['default'] = function (ac, app) {
	    var entity = app.getEntity('Boja');
	
	    entity.listView().title('Boje').icon('<i class="fa fa-eur fa-3x"></i>').fields([ac.field('naziv').cssClasses(['col-md-11'])]).listActions(['edit', 'delete']);
	
	    entity.editionView().title('Boja').fields([{
	        key: 'naziv',
	        type: 'hInput',
	        templateOptions: {
	            label: 'Naziv',
	            required: true,
	            focus: true
	        }
	    }]);
	
	    return entity;
	};
	
	module.exports = exports['default'];

/***/ },
/* 559 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	exports['default'] = function (ac, app) {
	    var entity = app.getEntity('OznakaBoje');
	
	    entity.listView().title('Oznake boja').icon('<i class="fa fa-eur fa-3x"></i>').fields([ac.field('boja', 'reference').label('Boja').targetEntity(app.getEntity('Boja')).targetField(ac.field('naziv')).cssClasses(['col-md-9']), ac.field('oznaka').cssClasses(['col-md-2'])]).listActions(['edit', 'delete']);
	
	    entity.editionView().title('Boja').fields([{
	        key: 'boja',
	        type: 'huiSelect',
	        templateOptions: {
	            label: 'Boja',
	            required: true,
	            optionsAttr: 'bs-options',
	            ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
	            valueProp: 'id',
	            labelProp: 'naziv',
	            placeholder: 'Odaberite boju',
	            options: [],
	            focus: true
	        },
	        controller: ['$scope', 'DS', function ($scope, DS) {
	            DS.findAll('Boja').then(function (response) {
	                $scope.to.options = response;
	            });
	        }]
	    }, {
	        key: 'oznaka',
	        type: 'hInput',
	        templateOptions: {
	            label: 'Oznaka',
	            required: true
	        }
	    }]);
	
	    return entity;
	};
	
	module.exports = exports['default'];

/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _commonFormsLayoutJs = __webpack_require__(434);
	
	var fields = {
	    datum_probe: {
	        key: 'datum_probe',
	        type: 'datepicker',
	        templateOptions: {
	            label: 'Datum probe',
	            required: true
	        }
	    },
	    termin_probe: {
	        key: 'termin_probe',
	        type: 'timepicker',
	        templateOptions: {
	            label: 'Termin',
	            required: true
	        }
	    },
	    tehnicar: {
	        key: 'tehnicar',
	        type: 'uiSelect',
	        templateOptions: {
	            label: 'Tehničar',
	            optionsAttr: 'bs-options',
	            ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
	            valueProp: 'id',
	            labelProp: 'naziv',
	            placeholder: 'Odaberite tehničara',
	            options: []
	        },
	        controller: ['$scope', 'DS', function ($scope, DS) {
	            DS.findAll('Tehnicar').then(function (response) {
	                $scope.to.options = response;
	            });
	        }]
	    },
	    napomena: {
	        key: 'napomena',
	        type: 'textarea',
	        templateOptions: {
	            label: 'Napomena',
	            rows: 4
	        }
	    }
	};
	
	exports['default'] = function (ac, app) {
	    var entity = app.getEntity('FazaNaloga');
	    entity.listView().title('Faze naloga').fields([ac.field('datum_probe', 'date').label('Datum probe').cssClasses(['col-md-2']), ac.field('termin_probe').label('Termin').cssClasses(['col-md-1']), ac.field('tehnicar', 'reference').targetEntity(app.getEntity('Tehnicar')).targetField(ac.field('naziv')).label('Tehničar').cssClasses(['col-md-2']), ac.field('napomena').cssClasses(['col-md-5'])]).listActions(['delete']);
	
	    entity.dashboardView().fields([ac.field('ordinacija_naziv', 'template').label('Ordinacija').template(function (entry) {
	        return '<h4 class="font-extra-bold">' + entry.ordinacija_naziv + '</h4>';
	    }), ac.field('pacijent_naziv').label('Pacijent'), ac.field('radni_nalog_broj_naloga', 'template').label('Radni nalog').template(function (entry) {
	        return '<a ui-sref="radniNalog.details({id:' + entry.radni_nalog + '})">' + entry.radni_nalog_sifra_naloga + '</a>';
	    }), ac.field('napomena').label('Napomena'), ac.field('termin_probe', 'template').label('<i class="fa fa-clock-o"></i>Termin').template(function (entry) {
	        return '<h4>' + entry.termin_probe + '</h4>';
	    }).cssClasses(['text-center'])]);
	
	    entity.editionView().title('Izmjena faze naloga').fields([(0, _commonFormsLayoutJs.Row)([(0, _commonFormsLayoutJs.Column4)([fields.datum_probe]), (0, _commonFormsLayoutJs.Column3)([fields.termin_probe])]), (0, _commonFormsLayoutJs.Row)([(0, _commonFormsLayoutJs.Column4)([fields.tehnicar]), (0, _commonFormsLayoutJs.Column8)([fields.napomena])])]);
	
	    return entity;
	};
	
	module.exports = exports['default'];

/***/ },
/* 561 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	exports['default'] = function (ac, app) {
	    var entity = app.getEntity('KorisnikOrdinacija');
	
	    entity.listView().title('Korisnici').icon('<i class="fa fa-user fa-3x"></i>').fields([ac.field('first_name').label('Ime').cssClasses(['col-md-2']), ac.field('last_name').label('Prezime').cssClasses(['col-md-2']), ac.field('email'), ac.field('username')]).listActions(['delete']);
	
	    entity.creationView().title('Unos korisnika').fields([{
	        key: 'username',
	        type: 'hInput',
	        templateOptions: {
	            label: 'Korisničko ime',
	            required: true,
	            focus: true
	        }
	    }, {
	        key: 'first_name',
	        type: 'hInput',
	        templateOptions: {
	            label: 'Ime',
	            required: true
	        }
	    }, {
	        key: 'last_name',
	        type: 'hInput',
	        templateOptions: {
	            label: 'Prezime',
	            required: true
	        }
	    }, {
	        key: 'email',
	        type: 'hInput',
	        templateOptions: {
	            label: 'Email'
	        }
	    }, {
	        key: 'password1',
	        type: 'hInput',
	        templateOptions: {
	            label: 'Zaporka',
	            type: 'password',
	            required: true
	        }
	    }, {
	        key: 'password2',
	        type: 'hInput',
	        templateOptions: {
	            label: 'Potvrdite',
	            type: 'password',
	            required: true
	        }
	    }]);
	
	    return entity;
	};
	
	module.exports = exports['default'];

/***/ },
/* 562 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	exports['default'] = function (ac, app) {
	    var materijal = app.getEntity('Materijal');
	
	    materijal.listView().title('Materijali').icon('<i class="fa fa-archive fa-3x"></i>').fields([ac.field('naziv')]).listActions(['edit', 'delete']);
	
	    materijal.editionView().title('Materijal').fields([{
	        key: 'naziv',
	        type: 'hInput',
	        templateOptions: {
	            label: 'Naziv',
	            required: true,
	            focus: true
	        }
	    }]);
	
	    return materijal;
	};
	
	module.exports = exports['default'];

/***/ },
/* 563 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	exports['default'] = function (ac, app) {
	    var vrstaRada = app.getEntity('VrstaRada');
	
	    vrstaRada.listView().title('Vrsta rada').icon('<i class="fa fa-archive fa-3x"></i>').fields([ac.field('naziv'), ac.field('grupa', 'reference').label('Grupa').targetEntity(app.getEntity('GrupaRada')).targetField(ac.field('naziv'))]).listActions(['edit', 'delete']);
	
	    vrstaRada.editionView().title('Vrsta rada').fields([{
	        key: 'naziv',
	        type: 'hInput',
	        templateOptions: {
	            label: 'Naziv',
	            required: true,
	            focus: true
	        }
	    }, {
	        key: 'grupa',
	        type: 'huiSelect',
	        templateOptions: {
	            label: 'Grupa',
	            optionsAttr: 'bs-options',
	            ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
	            valueProp: 'id',
	            labelProp: 'naziv',
	            placeholder: 'Odaberite grupu',
	            options: [],
	            required: true
	        },
	        controller: ['$scope', 'DS', function ($scope, DS) {
	            DS.findAll('GrupaRada').then(function (response) {
	                $scope.to.options = response;
	            });
	        }]
	    }, {
	        key: 'boja',
	        type: 'hInput',
	        templateOptions: {
	            label: 'Boja'
	
	        }
	    }]);
	
	    return vrstaRada;
	};
	
	module.exports = exports['default'];

/***/ },
/* 564 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	exports['default'] = function (ac, app) {
	    var grupaRada = app.getEntity('GrupaRada');
	
	    grupaRada.listView().title('Grupa rada').icon('<i class="fa fa-archive fa-3x"></i>').fields([ac.field('naziv')]).listActions(['edit', 'delete']);
	
	    grupaRada.editionView().title('Grupa rada').fields([{
	        key: 'naziv',
	        type: 'hInput',
	        templateOptions: {
	            label: 'Naziv',
	            required: true,
	            focus: true
	        }
	    }]);
	
	    return grupaRada;
	};
	
	module.exports = exports['default'];

/***/ },
/* 565 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	exports['default'] = function (ac, app) {
	    var komentar = app.getEntity('Komentar');
	    komentar.listView().title('Vaši komentari').icon('<i class="fa fa-comments fa-3x"></i>').fields([ac.field('sender').label('Pošiljatelj').cssClasses(['col-md-3']), ac.field('poruka').label('Poruka').cssClasses(['col-md-7']), ac.field('radni_nalog', 'template').label('Radni nalog').template(function (entry) {
	        return '<a ui-sref="radniNalog.details({id: entry.radni_nalog})" class="btn"><i class="fa fa-comments"></i> {{entry.sifra_naloga}}</a>';
	    }).cssClasses(['col-md-2'])]);
	
	    return komentar;
	};
	
	module.exports = exports['default'];

/***/ },
/* 566 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	exports['default'] = function ($stateProvider) {
	    $stateProvider.state('login', {
	        url: '/login',
	        template: '<auth></auth>',
	        data: {
	            specialClass: 'blank'
	        }
	    });
	};
	
	module.exports = exports['default'];

/***/ },
/* 567 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	exports['default'] = function ($stateProvider) {
	    $stateProvider.state('dashboard', {
	        url: '/dashboard',
	        component: 'dashboard'
	    });
	};
	
	module.exports = exports['default'];

/***/ },
/* 568 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	exports['default'] = function ($stateProvider) {
	    $stateProvider.state('ordinacija', {
	        url: '/ordinacija',
	        template: '<ordinacija-list></ordinacija-list>',
	        data: {
	            pageTitle: 'Ordinacije dentalne medicine',
	            pageDesc: 'Registar ordinacija dentalne medicine',
	            icon: '<i class="fa fa-building fa-3x"></i>'
	        }
	    }).state('ordinacija.details', {
	        url: '/details/:id',
	        views: {
	            '@': {
	                // template: '<ordinacija-details></ordinacija-details>',
	                component: 'ordinacijaDetails'
	            }
	        },
	        resolve: {
	            item: ['$transition$', 'DS', function ($transition$, DS) {
	                var params = $transition$.params();
	                return DS.find('Ordinacija', params.id);
	            }]
	        },
	        data: {
	            pageTitle: 'Detalji ordinacije'
	        }
	    }).state('ordinacija.create', {
	        url: '/create',
	        views: {
	            '@': {
	                component: 'ordinacijaCreate'
	            }
	        },
	        resolve: {
	            item: function item() {
	                return {};
	            }
	        }
	
	    }).state('ordinacija.details.edit', {
	        url: '/edit',
	        views: {
	            '@': {
	                component: 'ordinacijaEdit'
	            }
	        },
	        resolve: {
	            item: ['DS', '$transition$', function (DS, $transition$) {
	                var params = $transition$.params();
	                return DS.find('Ordinacija', params.id);
	            }]
	        }
	    });
	};
	
	module.exports = exports['default'];

/***/ },
/* 569 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	exports['default'] = function ($stateProvider) {
	    $stateProvider.state('cjenik', {
	        url: '/cjenik',
	        component: 'cjenik'
	    }).state('cjenik.details', {
	        url: '/:id',
	        views: {
	            '@': {
	                component: 'stavkaCjenika'
	            }
	        },
	        resolve: {
	            cjenik: ['$transition$', 'DS', function ($transition$, DS) {
	                var params = $transition$.params();
	                return DS.find('Cjenik', params.id);
	            }]
	        }
	    });
	};
	
	module.exports = exports['default'];

/***/ },
/* 570 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function viewProvider(viewName) {
	    return ['$transition$', 'AppConfiguration', function ($transition$, AppConfiguration) {
	        var view;
	        var params = $transition$.params();
	        try {
	            view = AppConfiguration().getViewByEntityAndType(params.entity, viewName);
	        } catch (e) {
	            var error404 = new Error('Unknown view or entity name');
	            error404.status = 404;
	            throw error404;
	        }
	        return view;
	    }];
	}
	
	exports['default'] = function ($stateProvider) {
	    $stateProvider.state('crud', {
	        abstract: true,
	        url: '/crud/:entity',
	        template: '<ui-view></ui-view>',
	        resolve: {
	            view: viewProvider('ListView'),
	            store: ['$transition$', 'DS', function ($transition$, DS) {
	                var params = $transition$.params();
	                return DS.definitions[params.entity];
	            }]
	        }
	    }).state('crud.list', {
	        url: '/list',
	        component: 'listView'
	    });
	};
	
	module.exports = exports['default'];

/***/ },
/* 571 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	exports['default'] = function ($stateProvider) {
	    $stateProvider.state('radniNalog', {
	        url: '/radniNalog',
	        component: 'radniNalogList',
	        data: {
	            pageTitle: 'Radni nalozi'
	        }
	    }).state('radniNalog.details', {
	        url: '/details/:id',
	        views: {
	            '@': {
	                // template: '<ordinacija-details></ordinacija-details>',
	                component: 'radniNalogDetails'
	            }
	        },
	        resolve: {
	            id: ['$transition$', 'DS', function ($transition$, DS) {
	                var params = $transition$.params();
	                return params.id;
	            }]
	        },
	        data: {
	            pageTitle: 'Pregled naloga'
	        }
	    }).state('radniNalog.details.edit', {
	        url: '/edit',
	        views: {
	            '@': {
	                component: 'radniNalogEdit'
	            }
	        },
	        resolve: {
	            item: ['DS', '$transition$', function (DS, $transition$) {
	                var params = $transition$.params();
	                return DS.find('RadniNalog', params.id);
	            }]
	        }
	    }).state('radniNalog.details.planRada', {
	        url: '/planRada',
	        views: {
	            '@': {
	                component: 'planRada'
	            }
	        },
	        data: {
	            pageTitle: 'Plan rada'
	        }
	    }).state('radniNalog.create', {
	        url: '/create',
	        views: {
	            '@': {
	                component: 'radniNalogCreate'
	            }
	        }
	    });
	};
	
	module.exports = exports['default'];

/***/ },
/* 572 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	exports['default'] = function (acp, $state) {
	    return acp.menu().addChild(acp.menu().title('Početna').icon('<i class="fa fa-home"></i>').link($state.href('dashboard'))).addChild(acp.menu().title('Šifranti').addChild(acp.menu().title('Materijali').link($state.href('crud.list', { entity: 'Materijal' }))).addChild(acp.menu().title('Grupe radova').link($state.href('crud.list', { entity: 'GrupaRada' }))).addChild(acp.menu().title('Vrste radova').link($state.href('crud.list', { entity: 'VrstaRada' }))).addChild(acp.menu().title('Protetski radovi').link($state.href('crud.list', { entity: 'ProtetskiRad' }))).addChild(acp.menu().title('Cjenici').link($state.href('cjenik'))).addChild(acp.menu().title('Firma').link($state.href('crud.list', { entity: 'Firma' }))).addChild(acp.menu().title('Ordinacije').link($state.href('ordinacija'))).addChild(acp.menu().title('Porezne stope').link($state.href('crud.list', { entity: 'PoreznaStopa' }))).addChild(acp.menu().title('Tehničari').link($state.href('crud.list', { entity: 'Tehnicar' }))).addChild(acp.menu().title('Valute').link($state.href('crud.list', { entity: 'Valuta' }))).addChild(acp.menu().title('Boje').link($state.href('crud.list', { entity: 'Boja' }))).addChild(acp.menu().title('Oznake boja').link($state.href('crud.list', { entity: 'OznakaBoje' })))).addChild(acp.menu().title('Radni nalozi').link($state.href('radniNalog'))).addChild(acp.menu().title('Upute za rad').link($state.href('upute')));
	};
	
	module.exports = exports['default'];

/***/ }
]);


// WEBPACK FOOTER //
// app.js